module.exports = {
  Cargo_CreatBy: 'ผู้เสนอราคา',
  Cargo_TrunkLine: 'เส้นทางหลัก',
  Cargo_Inquiry_MissingBusinessCannotSubmit: 'ประเภท {0} ยังไม่ได้เลือกผู้รับผิดชอบทางธุรกิจ จึงไม่สามารถส่งได้',
  Cargo_100Million: 'พันล้าน',
  Cargo_10Cents: 'มุม',
  Cargo_1St: 'ภาพแรก',
  Cargo_1StInvoiceNo: 'หมายเลขใบแจ้งหนี้ครั้งแรก',
  Cargo_1Year: '1 ปี',
  Cargo_2NdDispatch: 'จัดส่งครั้งที่สอง',
  Cargo_2NdDispatchTime: 'เวลาส่งครั้งที่สอง',
  Cargo_2NdReleaseTime: 'เวลาเปิดตัวรอง',
  Cargo_2NdTransitAirportAir: 'รถรับส่งที่ 2 (ว่างเปล่า)',
  Cargo_2StUnit: 'หน่วยที่สอง',
  Cargo_2Years: '2 ปี',
  Cargo_30DaysShpt: '30 วัน (ตั๋ว)',
  Cargo_3RdParty: 'บุคคลที่สาม',
  Cargo_3RdTransitAirportAir: 'รถรับส่ง 3 เที่ยว (ว่างเปล่า)',
  Cargo_3Years: '3 ปี',
  Cargo_60DaysShpt: '60 วัน (ตั๋ว)',
  Cargo_90DaysShpt: '90 วัน (ตั๋ว)',
  Cargo_AAPACRIG: 'เป็นการชำระเงินล่วงหน้าสร้างบันทึกที่สอดคล้องกัน!',
  Cargo_AbandonThisVoucher: 'ยืนยันการสละสิทธิ์บัตรกำนัลนี้?',
  Cargo_Abbreviation: 'ชื่อย่อ',
  Cargo_AbbreviationOfConsignor: 'หน่วยงานหลัก (ย่อ)',
  Cargo_ABCDC: 'กำลังยืนยัน ซึ่ง {0} ได้รับการยืนยันแล้ว',
  Cargo_MessageTip1: 'คุณมี [',
  Cargo_MessageTip2: '] การแจ้งเตือนที่ไม่ได้อ่านแถบ',
  Cargo_Abstract: 'บทสรุป',
  Cargo_AbstractRuleOfJournalEntry: 'กฎสรุปรายการ',
  Cargo_ABYBPSTCI23M: 'AA-ประมูลรายปี ตามสถานการณ์ดูได้,ภายใน 2-3 เดือน',
  Cargo_Accepted: 'ได้รับการยอมรับแล้ว',
  Cargo_AccordingBillExchangeRate: 'อัตราแลกเปลี่ยนตามบิล',
  Cargo_AccordingForStatementFxRate: 'โดยอัตราแลกเปลี่ยนตามใบแจ้งยอด',
  Cargo_AccountClosedSuccessfully: 'เช็คเอาท์เสร็จแล้ว',
  Cargo_AccountInForeignCurrency: 'มีการคำนวณเหรียญกษาปณ์เดิมหรือไม่',
  Cargo_AccountingMethod: 'วิธีการทำบัญชี',
  Cargo_AccountingOrganizationCode: 'การบัญชีรหัสองค์กร',
  Cargo_AccountingQuantity: 'การบัญชีปริมาณ',
  Cargo_AccountingVoucher: 'บัตรกำนัลทางบัญชี',
  Cargo_AccountPeriod: 'ระยะเวลาบัญชี',
  Cargo_AccountPeriodDay: 'ระยะเวลาบัญชี (วัน)',
  Cargo_AccountQuantityOrNot: 'มีการคำนวณตามปริมาณหรือไม่',
  Cargo_AccountsReconciliation: 'การปรองดองนิวเคลียร์',
  Cargo_AccountsReconciliation2: 'บัญชีกระแสรายวัน 2',
  Cargo_AccountStatement: 'ใบแจ้งยอด',
  Cargo_AccountStatementNo: 'หมายเลขใบแจ้งยอดบัญชี',
  Cargo_AccountStatementNoP: 'หมายเลขใบแจ้งยอดบัญชี:',
  Cargo_AccountTitle: 'วิชา',
  Cargo_AccountTitle2: 'วิชา 2',
  Cargo_AccountTitleCanTBeEmpty: 'วิชาไม่สามารถเว้นว่างได้',
  Cargo_AccountTitleCategory: 'ประเภทวิชา',
  Cargo_AccountTitleClassification: 'เกรดวิชา',
  Cargo_AccountTitleClassificationRule: 'กฎเกณฑ์การให้คะแนนวิชา',
  Cargo_AccountTitleCode: 'รหัสวิชา',
  Cargo_AccountTitleCodeCanTBeEmpty: 'รหัสวิชาต้องไม่ว่างเปล่า',
  Cargo_AccountTitleCodeP: 'รหัสวิชา:',
  Cargo_AccountTitleGroupingCondition1: 'เงื่อนไขการจัดกลุ่มวิชาที่หนึ่ง',
  Cargo_AccountTitleGroupingCondition2: 'เงื่อนไขการจัดกลุ่มวิชาที่สอง',
  Cargo_AccountTitleGroupingCondition3: 'เงื่อนไขการจัดกลุ่มวิชา III',
  Cargo_AccountTitleGroupingCondition4: 'เงื่อนไขการจัดกลุ่มวิชา IV',
  Cargo_AccountTitleGroupingCondition5: 'เงื่อนไขการจัดกลุ่มวิชาที่ 5',
  Cargo_AccountTitleGroupingCondition6: 'เงื่อนไขการจัดกลุ่มวิชาที่ 6',
  Cargo_AccountTitleLevel: 'ระดับวิชา',
  Cargo_AccountTitleMapping: 'แผนที่วิชา',
  Cargo_AccountTitleName: 'ชื่อวิชา',
  Cargo_AccountTitleNameCanTBeEmpty: 'ชื่อวิชาต้องไม่ว่างเปล่า',
  Cargo_AccountTitleNameP: 'ชื่อวิชา:',
  Cargo_AccountTitleOfProfitNotAllocated: 'วิชากำไรที่ไม่ได้จัดสรร',
  Cargo_AccountTitleOfProfitNotAllocatedP: 'วิชากำไรที่ไม่ได้จัดสรร:',
  Cargo_AccrualDate: 'วันที่นับ',
  Cargo_JobAccrualDate: 'วันที่นับคะแนนธุรกิจ',
  Cargo_AccrualReview: 'การตรวจสอบบัญชี',
  Cargo_AccrualStatus: 'สถานะการนับคะแนน',
  Cargo_Accrue: 'นับคะแนน',
  Cargo_Accrued: 'นับแล้ว',
  Cargo_UsersAlreadyProvisionedToday: 'มีผู้ใช้ที่ได้รับการตั้งสำรองในวันนี้แล้วโปรดตรวจสอบ',
  Cargo_AccumulatedCommissionProfit: 'กำไรคอมมิชชั่นสะสม',
  Cargo_AConsiderChangeIfOffersCheap: 'A- พิจารณาตราบเท่าที่มันถูก',
  Cargo_ACPCOIM: 'ระบบกำลังชำระเงินโปรดอดทนและลองอีกครั้งในภายหลัง ~',
  Cargo_Acquired: 'ได้รับแล้ว',
  Cargo_AcquireFilteredExpenseList: 'รับรายการค่าธรรมเนียมการกรอง',
  Cargo_Acquirer: 'ผู้รับ',
  Cargo_AcquirerCanTBeEmpty: 'ผู้รับไม่สามารถว่างได้',
  Cargo_AcquireSelectedItems: 'รับวัตถุที่เลือก',
  Cargo_AcquireTotalAROrAPAmount: 'รับยอดรวมของลูกหนี้',
  Cargo_Acquisition: 'ปลอกคอ',
  Cargo_AcquisitionRecord: 'บันทึกการรับ',
  Cargo_AcquisitionTime: 'เวลารับ',
  Cargo_AcquisitionTimeCanTBeEmpty: 'เวลารับต้องไม่ว่างเปล่า',
  Cargo_ACSWASRATBTSWEAC: 'เมื่อยืนยันแล้วระบบจะตั้งยอดเงินกระทบยอดโดยอัตโนมัติเท่ากับยอดค่าธรรมเนียม จะดำเนินการต่อหรือไม่',
  Cargo_ACSWASRATBTSWEANCOWOEWNBPC: 'ยอดเงินที่กระทบยอดทั้งหมดจะถูกกำหนดตามจำนวนค่าธรรมเนียม ซึ่งค่าธรรมเนียมที่ได้รับการยืนยันหรือตัดบัญชีแล้วจะถูกละเลย จะดำเนินการต่อหรือไม่',
  Cargo_ThereAreAlreadyExportedVouchers: 'การแสดงตนของบัตรกำนัลที่ส่งออกไปแล้ว',
  Cargo_ActualChargedWeight: 'น้ำหนักการเรียกเก็บเงินจริง',
  Cargo_ActualGrossWeight: 'น้ำหนักรวมที่แท้จริง',
  Cargo_ActualQuantity: 'จำนวนชิ้นจริง',
  Cargo_ActualReceiptAmount: 'จำนวนเงินที่เรียกชำระแล้ว',
  Cargo_ActualReceiptAndPayment: 'ชำระแล้ว',
  Cargo_ActualVolume: 'ปริมาณจริง',
  Cargo_ActualWeight: 'น้ำหนักจริง',
  Cargo_ActualWriteOffAmountRequired: 'จำนวนเงินที่ต้องตัดบัญชีจริง',
  Cargo_OnlyImportedCurrentBranch: 'เฉพาะค่าธรรมเนียมการนำเข้าสาขาที่ดำเนินการเป็นสาขาปัจจุบันเท่านั้น',
  Cargo_Add: 'เพิ่มใหม่',
  Cargo_AddAdjustBill: 'การปรับเพิ่ม (บิล)',
  Cargo_AddAirBooking: 'เพิ่มการจองห้องโดยสารทางอากาศ',
  Cargo_AddRailwayBooking: 'เพิ่มชั้นโดยสารรถไฟ',
  Cargo_RailwayBooking: 'การจองห้องโดยสารรถไฟ',
  Cargo_AddAirFreightServiceItems: 'เพิ่มโครงการบริการขนส่งสินค้าทางอากาศ',
  Cargo_AddAssetAccountTitle: 'เพิ่มวิชาสินทรัพย์',
  Cargo_AddAssociatedPort: 'เพิ่มพอร์ตที่เกี่ยวข้อง',
  Cargo_AddAwbSurcharge: 'เพิ่มค่าธรรมเนียมเบ็ดเตล็ดสำหรับใบขนส่งทางอากาศ',
  Cargo_AddBasePort: 'เพิ่มพอร์ตพื้นฐาน',
  Cargo_AddBill: 'เพิ่มบิล',
  Cargo_AddBillCharge: 'ค่าธรรมเนียมการเข้าร่วม',
  Cargo_AddBLType: 'เพิ่มประเภท B / L',
  Cargo_AddCashFlowItem: 'โครงการเพิ่มกระแสเงินสด',
  Cargo_AddCharges: 'เพิ่มค่าธรรมเนียม',
  Cargo_AddCostType: 'เพิ่มประเภทค่าใช้จ่าย',
  Cargo_EditFeeType: 'แก้ไขประเภทค่าธรรมเนียม',
  Cargo_DeleteFeeType: 'ลบประเภทค่าธรรมเนียม',
  Cargo_ImportFeeType: 'นำเข้าประเภทค่าธรรมเนียม',
  Cargo_SelectBusinessOperation: 'กรุณาเลือกธุรกิจที่ดำเนินการอย่างถูกต้อง',
  Cargo_SelectSameDelegateUnit: 'กรุณาเลือกธุรกิจที่มีหน่วยมอบหมายเดียวกัน',
  Cargo_SelectSameBusinessType: 'กรุณาเลือกธุรกิจที่มีประเภทธุรกิจเดียวกัน',
  Cargo_SelectSameFbaStatus: 'กรุณาเลือกธุรกิจที่มีสถานะ FBA เดียวกัน',
  Cargo_SelectSameBusinessTypeWithJobNo: 'ประเภทธุรกิจไม่ตรงกัน: {baseJobNo} และ {currentJobNo} โปรดเลือกธุรกิจที่มีประเภทธุรกิจเดียวกัน',
  Cargo_SelectSameFbaStatusWithJobNo: 'สถานะ FBA ไม่ตรงกัน: {baseJobNo} และ {currentJobNo} โปรดเลือกธุรกิจที่มีสถานะ FBA เดียวกัน',
  Cargo_SelectFeeType: 'โปรดเลือกประเภทค่าธรรมเนียม!',
  Cargo_ReceivablePayableLocked: 'ธุรกิจที่เลือกมีการล็อคค่าธรรมเนียมรับและจ่าย ไม่สามารถดำเนินการนี้ได้!',
  Cargo_ReceivableLocked: 'ธุรกิจที่เลือกมีการล็อคค่าธรรมเนียมรับ ไม่สามารถดำเนินการนี้ได้!',
  Cargo_PayableLocked: 'ธุรกิจที่เลือกมีการล็อคค่าธรรมเนียมจ่าย ไม่สามารถดำเนินการนี้ได้!',
  Cargo_PleaseSelectTheManifestYouWishToDelete: 'โปรดเลือกรายการที่คุณต้องการลบ',
  Cargo_TheManifestYouWishToDeleteTips: '* เคล็ดลับที่อบอุ่น: LCL ลบรายการต้องถูกลบออกพร้อมกันในกล่องเพื่อให้รายการไม่สามารถลบแยกต่างหาก!',
  Cargo_ConfirmDelete: 'ยืนยันการลบ',
  Cargo_AddCirculationDocumentType: 'เพิ่มประเภทแฟ้มหมุนเวียน',
  Cargo_AddClientType: 'เพิ่มประเภทลูกค้า',
  Cargo_AddCollectionRecord: 'เพิ่มการลงทะเบียนเรียกเก็บเงิน',
  Cargo_AddCommissionRules: 'เพิ่มกฎค่าคอมมิชชั่น',
  Cargo_AddContinent: 'เพิ่มทวีป',
  Cargo_AddContract: 'สัญญาใหม่',
  Cargo_AddCustomizedServiceType: 'เพิ่มประเภทธุรกิจที่กำหนดเอง',
  Cargo_AddedAlreadyDoNotRepeat: '{0} เพิ่มแล้ว ไม่สามารถเพิ่มซ้ำได้',
  Cargo_AddedSuccessfully: 'เพิ่มความสำเร็จ',
  Cargo_AddFees: 'เพิ่มค่าธรรมเนียม',
  Cargo_AddHeadquartersToTheList: 'เพิ่มสำนักงานใหญ่',
  Cargo_AddJournalEntry: 'เพิ่มรายการ',
  Cargo_AddKeyword: 'เพิ่มคำที่ละเอียดอ่อน',
  Cargo_AddMscService: 'เพิ่มบริการ MSC',
  Cargo_AddNewSoaOrNot: 'ไม่ว่าจะเป็นการเพิ่มใบแจ้งยอดบัญชีใหม่',
  Cargo_AddRailwayStation: 'เพิ่มสถานีรถไฟ',
  Cargo_AddressTelNo: 'ที่อยู่ / โทรศัพท์',
  Cargo_AddressTelNoP: 'ที่อยู่, โทรศัพท์:',
  Cargo_AddRoute: 'เพิ่มเส้นทางบิน',
  Cargo_AddSave: 'เพิ่มบันทึก',
  Cargo_AddSeaBooking: 'เพิ่มการจองห้องโดยสารทางทะเล',
  Cargo_IntelligentDocumentRecognition: 'การรับรู้หนังสืออัจฉริยะ',
  Cargo_AddSoa: 'เพิ่มใบแจ้งยอดบัญชี',
  Cargo_AddToBlackList: 'เข้าร่วมบัญชีดำ',
  Cargo_AdjustBillDate: 'การปรับวันเรียกเก็บเงิน',
  Cargo_AdjustDate: 'วันที่ปรับ',
  Cargo_AdjustedItem: 'การปรับรายการ',
  Cargo_AdjustedOrNot: 'ไม่ว่าจะเป็นการปรับ',
  Cargo_AdjustedSuccessfully: 'ปรับสำเร็จ',
  Cargo_AdjustedValue: 'ปรับค่า',
  Cargo_AdjustExpenseOrNot: 'ไม่ว่าจะเป็นการปรับค่าธรรมเนียม',
  Cargo_AdjustFxRateEndOfPeriod: 'ปรับอัตราแลกเปลี่ยน (สิ้นงวด)',
  Cargo_AdjustmentDateCanTBeEmpty: 'วันที่ปรับไม่สามารถว่างได้',
  Cargo_AdjustmentExpense: 'ค่าธรรมเนียมการปรับ',
  Cargo_AdjustmentExpenseState: 'ปรับสถานะ',
  Cargo_Advance: 'การชำระเงินล่วงหน้า',
  Cargo_AdvanceAP: 'การชำระเงินล่วงหน้า',
  Cargo_AdvanceAPDifferential: 'จ่ายส่วนต่างล่วงหน้า',
  Cargo_AdvanceChargeInfo: 'การชำระเงินดาวน์',
  Cargo_AdvancedSearch: 'การสอบถามขั้นสูง',
  Cargo_AdvanceMoneyForAnotherOrNot: 'ไม่ว่าจะเป็นการเปลี่ยนพรม',
  Cargo_AdvanceOrNot: 'ไม่ว่าจะเป็นเงินดาวน์',
  Cargo_AdvancePayment: 'การชำระเงินล่วงหน้า',
  Cargo_AdvancePaymentAmount: 'จำนวนเงินที่ต้องชำระล่วงหน้า',
  Cargo_AdvancePaymentItem: 'สำรองจ่าย',
  Cargo_AdvanceReceiptOrNot: 'ไม่ว่าจะเป็นการเก็บล่วงหน้า',
  Cargo_AdvanceReceivedAmount: 'จำนวนเงินที่รับล่วงหน้า',
  Cargo_AdvanceReceivedAmountIs: 'จำนวนเงินที่เรียกเก็บล่วงหน้าคือ',
  Cargo_AEBPWTCW1Y: 'AAA - มีความสัมพันธ์ภายในของตัวแทนความร่วมมือคงที่ไม่เปลี่ยนแปลงเป็นเวลาหนึ่งปี',
  Cargo_AEFTSIST: 'การส่งออกทางอากาศของเซี่ยงไฮ้คล้ายกับ',
  Cargo_AEIMBOUF: 'การอัพเดตล้มเหลวและมีการแก้ไขค่าธรรมเนียมโดยผู้อื่น',
  Cargo_AEIMBOUFM: 'การอัพเดตรายการ {0} ล้มเหลวและมีการแก้ไขค่าธรรมเนียมโดยผู้อื่น',
  Cargo_AGEBDAWI: 'ค่าธรรมเนียมที่เกิดจากการปรับส่วนต่างโดยอัตโนมัติเมื่อออกตั๋ว',
  Cargo_AgentBillNo: 'หมายเลขบิลของฝ่ายตรงข้าม',
  Cargo_Aging: 'อายุบัญชี (วัน)',
  Cargo_AgingOfCurrentBill: 'เมื่ออายุบัญชีตั๋ว',
  Cargo_Agree: 'ความยินยอม',
  Cargo_AILCNETOCERCTS: 'จำนวนเงินในสกุลเงินหลักไม่เท่ากับสกุลเงินเดิม * อัตราแลกเปลี่ยน คุณจะยังคงรักษาต่อไปหรือไม่?',
  Cargo_Air: 'การขนส่งทางอากาศ',
  Cargo_AirExport: 'การส่งออกทางอากาศ',
  Cargo_AirImport: 'การนำเข้าทางอากาศ',
  Cargo_AirImportExport: 'การขนส่งทางอากาศเข้าและออก',
  Cargo_Airline: 'เส้นทางบิน',
  Cargo_AirlineCode: 'รหัสเส้นทาง',
  Cargo_AirlineCompany: 'สายการบิน',
  Cargo_ShippingCompanyName: 'บริษัท เรือ ชื่อภาษาจีน / ภาษาอังกฤษ',
  Cargo_ShippingCompanyCode: 'รหัส บริษัท เรือ',
  Cargo_ShippingCompanyScacCode: 'บริษัท เรือ SCAC CODE',
  Cargo_ShippingCompanyChineseName: 'บริษัท เรือ ชื่อภาษาจีน',
  Cargo_ShippingCompanyEnglishName: 'บริษัท เรือ ชื่อภาษาอังกฤษ',
  Cargo_DataDuplication: 'มีข้อมูลอยู่แล้วอย่าเพิ่มซ้ำ',
  Cargo_AdditionFailed: 'ใหม่ล้มเหลว',
  Cargo_DeleteShipCompany: 'ยืนยันที่จะลบข้อมูลที่เลือก? <br> เคล็ดลับที่อบอุ่น: กองเรือที่ถูกลบออกจากผู้เช่าหลังจากการลบล้างค่าเริ่มต้น',
  Cargo_AssociatedPlatformShippingCompany: 'บริษัท เรือแพลตฟอร์มที่เกี่ยวข้อง',
  Cargo_ShipCompanyThirdPartyCode: 'รหัสบุคคลที่สามของบริษัทเดินเรือ',
  Cargo_MblCode: 'รหัส B / L',
  Cargo_AirlinePerson: 'หัวหน้าเส้นทางบิน',
  Cargo_Airport: 'แอร์พอร์ต',
  Cargo_AirportOfDischarge: 'ท่าเรือขนถ่ายสินค้า (ท่าเรือว่างเปล่า)',
  Cargo_AirService: 'โครงการบริการขนส่งสินค้าทางอากาศ',
  Cargo_AlertConfiguration: 'การกำหนดค่าการแจ้งเตือน',
  Cargo_AlertDaysPriorToExpiryDate: '*แจ้งเตือนวันที่เหลือก่อนวันหมดอายุ',
  Cargo_All: 'ทั้งหมด',
  Cargo_AllB: '(ทั้งหมด)',
  Cargo_AllP: '【ทั้งหมด】',
  Cargo_AllAmount: 'ทั้งหมด',
  Cargo_AllAmountP: 'ทั้งหมด:',
  Cargo_AllCurrencies: 'สกุลเงินทั้งหมด',
  Cargo_AllForeignCurrencies: 'สกุลเงินต่างประเทศทั้งหมด',
  Cargo_AllSelectedBillsWrittenOff: 'ใบเรียกเก็บเงินที่เลือกไว้จะถูกยกเลิกทั้งหมด',
  Cargo_AllSelectedRecordsConfirmed: 'บันทึกที่เลือกได้รับการยืนยันทั้งหมด',
  Cargo_AllSelectedSoaWrittenOff: 'ใบแจ้งยอดที่เลือกไว้ถูกยกเลิกทั้งหมด',
  Cargo_WithoutDiscrepancies: 'ไม่มีความแตกต่าง',
  Cargo_AllWithWithoutDiscrepancies: 'ความแตกต่างทั้งหมด / ไม่มีความแตกต่าง',
  Cargo_AllWrittenOff: 'ขายหมดแล้ว',
  Cargo_AlreadyAddedOrNot: 'ไม่ว่าจะเป็นการเพิ่มเติม',
  Cargo_AmendmentFee: 'ค่าธรรมเนียมการเปลี่ยนแปลง',
  Cargo_Amount: 'จำนวนเงิน',
  Cargo_AmountF: 'จำนวนเงิน',
  Cargo_AmountCanTBeEmpty: 'จำนวนเงินไม่สามารถเว้นว่างได้',
  Cargo_AmountCanTBeZero: 'จำนวนเงินต้องไม่เป็นศูนย์',
  Cargo_AmountCNY: 'จำนวนเงิน (CNY)',
  Cargo_AmountCNYP: 'จำนวน CNY:',
  Cargo_AmountEnteredForReconciliation: 'จำนวนการกลั่นกรอง',
  Cargo_AmountIncurredOfCurrentPeriod: 'จำนวนเงินที่เกิดขึ้นในประเด็นนี้',
  Cargo_AmountInOriginalCurrency: 'จำนวนเงินในสกุลเงินเดิม',
  Cargo_AmountNotWrittenOff: 'ยอดคงค้าง',
  Cargo_AmountNumber: 'ปริมาณ',
  Cargo_AmountNumberP: 'ปริมาณ:',
  Cargo_AmountOfActualCollectionPayment: 'จำนวนเงินที่รับชำระแล้ว',
  Cargo_AmountOfCurrentMonth: 'จำนวนเดือน',
  Cargo_AmountOfPaidInOutOfPocket: 'จำนวนเงินที่รับชำระจริง',
  Cargo_AmountOfPaymentApplication: 'จำนวนเงินที่สมัคร',
  Cargo_AmountRange: 'ช่วงจำนวนเงิน',
  Cargo_AmountRemark: 'หมายเหตุค่าธรรมเนียม',
  Cargo_AmountSum: 'ยอดรวม',
  Cargo_AmountTo: 'รวม',
  Cargo_AmountToDetail: 'รายละเอียดรวม',
  Cargo_CurrentMonthAmountTo: 'รวมเดือนนี้',
  Cargo_CurrentYearAmountTo: 'รวมปีนี้',
  Cargo_TotalReportingCurrencyOfThisMonth: 'สกุลเงินท้องถิ่นรวมของเดือน',
  Cargo_TotalReportingCurrencyOfThisYear: 'สกุลเงินหลักรวมในปีนี้',
  Cargo_AmountToCNY: 'รวม (CNY)',
  Cargo_AmountToP: 'รวม:',
  Cargo_AmountToUSD: 'ทั้งหมด (USD)',
  Cargo_AmountUSD: 'จำนวน USD',
  Cargo_AmountUSDP: 'จำนวน USD:',
  Cargo_AmsEnsCyCutOffDate: 'AMS/ENS วันที่ปิดรับสมัคร',
  Cargo_Annual: 'รายปี',
  Cargo_AolAir: 'สนามบินต้นทาง',
  Cargo_AOPLVCTBE: 'สรุป Profit & Loss Voucher ต้องไม่ว่างเปล่า',
  Cargo_APAR: 'ลูกหนี้ที่ต้องจ่าย',
  Cargo_APBill: 'จ่ายบิล',
  Cargo_APEOFINNPPARFV: 'โปรดตรวจสอบว่าค่าใช้จ่ายที่ต้องชำระตามหมายเลขใบแจ้งหนี้ต่อไปนี้ยังไม่ได้รับการอนุมัติการชำระเงิน: \# \n',
  Cargo_APInclusive: 'ไม่ว่าจะรวมค่าใช้จ่ายที่ต้องชำระแล้ว',
  Cargo_APInvoice: 'ใบแจ้งหนี้ที่ชำระแล้ว',
  Cargo_Appendix: 'แนบหน้า',
  Cargo_Applicant: 'ผู้สมัคร',
  Cargo_ApplicationDateApplicationDate: 'วันที่สมัคร วันที่สมัคร',
  Cargo_ApplicationDateBusinessDate: 'วันที่สมัคร วันที่ประกอบธุรกิจ',
  Cargo_ApplicationFormSavedSuccessfully: 'บันทึกใบสมัครสำเร็จ!',
  Cargo_ApplicationNo: 'หมายเลขใบสมัคร',
  Cargo_ApplicationNoBill: 'ไม่มีใบแจ้งหนี้สำหรับค่าธรรมเนียมของใบสมัครหมายเลข {0} และหมายเลขธุรกิจ {1}',
  Cargo_ApplicationPermission: 'สิทธิ์การใช้งาน',
  Cargo_ApplicationStatus: 'สถานะการสมัคร',
  Cargo_AppliedForPaymentOrNot: 'ไม่ว่าจะเป็นการขอรับเงิน',
  Cargo_ApplyForPayment: 'สมัครชำระเงิน',
  Cargo_Approval: 'อนุมัติผ่าน',
  Cargo_ApprovalStatus: 'สถานะการอนุมัติ',
  Cargo_Approved: 'ตรวจสอบแล้ว',
  Cargo_ApprovedBy: 'ตรวจสอบบุคคล',
  Cargo_ApprovedStatue: 'ตรวจสอบสถานะ',
  Cargo_April: 'เมษายน',
  Cargo_APWriteOff: 'บัญชีเจ้าหนี้',
  Cargo_APWriteOffAmount: 'ยอดบัญชีเจ้าหนี้',
  Cargo_APWrittenOff: 'ชำระหนี้',
  Cargo_APWrittenOffP: 'ขาย:',
  Cargo_ARAges: 'อายุบัญชี',
  Cargo_ARAmountCanTExceedAPAmount: 'ค่าใช้จ่ายของลูกหนี้ต้องไม่เกินค่าใช้จ่ายที่ต้องชำระ',
  Cargo_ARAP: 'ลูกหนี้',
  Cargo_ARAPItemsMustBeComplete: 'ค่าธรรมเนียมที่เรียกเก็บจะต้องกรอกให้ครบถ้วน',
  Cargo_ARBill: 'บัญชีลูกหนี้',
  Cargo_ARegularExportVolume20TeuMonthly: 'A. การส่งออกสินค้ามีเสถียรภาพคงที่ 20TEU ทุกเดือน',
  Cargo_ARInvoice: 'ใบแจ้งหนี้ที่ได้รับ',
  Cargo_ARIPFCSC: 'การผลักดันใบแจ้งหนี้ของ Sirui ล้มเหลว:',
  Cargo_ARNotWrittenOff: 'ขายลูกหนี้',
  Cargo_ARNotWrittenOffP: 'ขายค้างชำระ:',
  Cargo_AROrNot: 'ไม่ว่าจะเป็นการรับลูกหนี้',
  Cargo_InvoiceAROrNot: 'ไม่ว่าจะเป็นการรับใบแจ้งหนี้',
  Cargo_ArrivalDate: 'วันที่มาถึงท่าเรือ',
  Cargo_ArrivalTime: 'เวลามาถึงท่าเรือ',
  Cargo_ARWriteOffAmount: 'ยอดบัญชีรับ-จ่าย',
  Cargo_ARWrittenOff: 'ขายลูกหนี้',
  Cargo_ARWrittenOffP: 'ขายลูกหนี้:',
  Cargo_ASRCCTD: 'บันทึกที่เลือกได้รับการยืนยันทั้งหมดและไม่สามารถปฏิเสธได้',
  Cargo_AssessedClientLevel: 'คะแนนการประเมินลูกค้า',
  Cargo_AssignedClientsSuccessfully: 'จัดสรรสำเร็จ {0} ลูกค้า',
  Cargo_AssignmentDate: 'วันที่กำหนด',
  Cargo_AssignToMe: 'มอบหมายให้ฉัน',
  Cargo_AssociatedPort: 'พอร์ตที่เกี่ยวข้อง',
  Cargo_ATCIJECTBE: 'การเข้ารหัสวิชาถอดรหัสไม่สามารถว่างได้',
  Cargo_AttachedDocuments: 'เอกสารแนบ',
  Cargo_Attachment: 'อุปกรณ์เสริม',
  Cargo_AttachmentP: 'อุปกรณ์เสริม:',
  Cargo_AttachmentInvoice: 'เอกสารแนบใบแจ้งหนี้',
  Cargo_AttachmentStorage: 'อุปกรณ์จัดเก็บข้อมูล',
  Cargo_Audit: 'รีวิว',
  Cargo_AuditDate: 'วันที่ตรวจสอบ',
  Cargo_Auditor: 'รีวิวโดย',
  Cargo_AuditorP: 'รีวิวโดย:',
  Cargo_AuditStatus: 'สถานะการตรวจสอบ',
  Cargo_AuditSuccessfully: 'การตรวจสอบสำเร็จ',
  Cargo_AuditSuccessfullyF: 'การตรวจสอบสำเร็จ',
  Cargo_Guarantee: 'หนังสือค้ำประกัน',
  Cargo_GuaranteeName: 'ชื่อของหนังสือค้ำประกัน',
  Cargo_GuaranteeType: 'ประเภทของหนังสือค้ำประกัน',
  Cargo_August: 'สิงหาคม',
  Cargo_AuthorizedClient: 'หน่วยงานหลัก',
  Cargo_AvailableBranch: 'สาขาที่มีอยู่',
  Cargo_AuthorizedCubage: 'ปริมาณค่าคอมมิชชั่น',
  Cargo_AuthorizedQuantity: 'จำนวนชิ้นที่ได้รับมอบหมาย',
  Cargo_AutomaticallyEnterInvoiceNumber: 'ป้อนหมายเลขใบแจ้งหนี้อัตโนมัติ',
  Cargo_AutomaticGenerated: 'สร้างโดยอัตโนมัติ',
  Cargo_AvailableOrNot: 'ใช้ได้หรือไม่',
  Cargo_AverageMonthlyCargoVolume: 'การจัดส่งเฉลี่ยต่อเดือน',
  Cargo_AwaitBusinessApproval: 'รอการอนุมัติธุรกิจ',
  Cargo_AwaitFinancialApproval: 'รอการอนุมัติทางการเงิน',
  Cargo_Back: 'กลับ',
  Cargo_BackgroundParameter: 'พารามิเตอร์พื้นหลัง',
  Cargo_BackgroundProcessing: 'ในการประมวลผลพื้นหลัง',
  Cargo_BackgroundReturnedErrorStatus: 'Back Office กลับสู่สถานะที่ไม่ถูกต้อง',
  Cargo_BackToCancel: 'กลับไป ยกเลิก',
  Cargo_BackToInvoicingStatus: 'กลับสู่สถานะใบแจ้งหนี้',
  Cargo_BackToProcessingMethod: 'กลับไปที่วิธีการประมวลผล',
  Cargo_BackToSearchResults: 'กลับไปที่ผลการสอบถาม',
  Cargo_BaiwangInvoiceExport: 'InvoiceExport(Baiwang).xml',
  Cargo_Balance: 'ยอดคงเหลือ',
  Cargo_BalanceCalculation: 'การคำนวณยอดคงเหลือ',
  Cargo_BalanceCNY: 'ยอดคงเหลือ (CNY)',
  Cargo_BalanceDirection: 'ทิศทางยอดคงเหลือ',
  Cargo_BalanceOfActualCollectionPayment: 'ยอดเงินที่ชำระแล้ว',
  Cargo_BalanceSheet: 'งบดุล',
  Cargo_BalanceSheet2: 'งบดุล 2',
  Cargo_BalancesOfAccountTitle: 'รายการยอดคงเหลือของวิชา',
  Cargo_BalancesOfAccountTitle2: 'ตารางยอดคงเหลือของวิชา 2',
  Cargo_BalanceUSD: 'ยอดคงเหลือ (USD)',
  Cargo_BangPic: 'รูปภาพการเข้าคลัง',
  Cargo_Bank: 'ธนาคาร',
  Cargo_BankAccount: 'หมายเลขบัญชีธนาคาร',
  Cargo_BankAccountBalance: 'ยอดคงเหลือของธนาคาร',
  Cargo_BankAccountNo: 'หมายเลขบัญชีธนาคาร',
  Cargo_BankOfPayment: 'การชำระเงิน ธนาคาร',
  Cargo_BankReceiptDetails: 'รายละเอียดบิลน้ำ',
  Cargo_BankReceiptNo: 'หมายเลขสลิปน้ำของธนาคาร',
  Cargo_ReceiptNo: 'หมายเลขน้ำ',
  Cargo_BankReceiptRecord: 'ลงทะเบียนใบกำกับน้ำ',
  Cargo_BankReceiptStatus: 'สถานะน้ำ',
  Cargo_BaseCurrency: 'สกุลเงินอ้างอิง',
  Cargo_BasePort: 'ท่าเรือหลัก',
  Cargo_Basic: 'พื้นฐาน',
  Cargo_ExternalInterface: 'อินเตอร์เฟซภายนอก',
  Cargo_Blacklisted: 'ถูกเพิ่มในรายการดำ!',
  Cargo_BasicInfo: 'ข้อมูลพื้นฐาน',
  Cargo_BasicInformation: 'ข้อมูลพื้นฐาน',
  Cargo_BasisForGrouping: 'เงื่อนไขการจัดกลุ่ม',
  Cargo_BatchAudit: 'การตรวจสอบแบทช์',
  Cargo_BatchCancelAudit: 'การยกเลิกการตรวจสอบจำนวนมาก',
  Cargo_BatchCancelConfirmation: 'ยืนยันการยกเลิกจำนวนมาก',
  Cargo_BatchConfirm: 'ยืนยันเป็นกลุ่ม',
  Cargo_BatchDelete: 'ลบแบทช์',
  Cargo_BatchDownload: 'ดาวน์โหลดจำนวนมาก',
  Cargo_BatchEnterModifyBusinessOrderNo: 'ป้อนข้อมูลเป็นกลุ่ม แก้ไขหมายเลขธุรกิจ',
  Cargo_BatchNo: 'หมายเลขล็อต',
  Cargo_BatchNoOfCollection: 'หมายเลขชุดเรียกเก็บ',
  Cargo_BatchNoP: 'หมายเลขล็อต:',
  Cargo_BatchPrint: 'พิมพ์จำนวนมาก',
  Cargo_BatchProcessing: 'การดำเนินการแบทช์',
  Cargo_BatchRetrieval: 'ถอนแบทช์',
  Cargo_BatchRetrievalButtonTrigger: 'ปุ่มเรียกคืนเป็นกลุ่ม',
  Cargo_BatchRevokeRetrieval: 'การถอนเงินเป็นกลุ่ม',
  Cargo_BatchTransfer: 'จัดส่งเป็นกลุ่ม',
  Cargo_BelowBillingAmountsIncorrect: 'ยอดการเรียกเก็บเงินต่อไปนี้ไม่ถูกต้อง:',
  Cargo_Bill: 'การเรียกเก็บเงิน',
  Cargo_BillCanTBeEmpty: 'ร่างกฎหมายจะเว้นวรรคไม่ได้',
  Cargo_BillConfirmed: 'ยืนยันร่างกฎหมายดังกล่าวแล้ว',
  Cargo_BillConfirmedM: '[{0}] บิลได้รับการยืนยันแล้ว',
  Cargo_BillDate: 'วันที่เรียกเก็บเงิน',
  Cargo_DueDate: 'วันหมดอายุของใบเรียกเก็บเงิน',
  Cargo_BillDeleteAdjustment: 'การเรียกเก็บเงิน - ลบการปรับแต่ง',
  Cargo_BillDeletedSuccessfully: 'ลบบิล {0} เรียบร้อยแล้ว',
  Cargo_BilledOrNot: 'ไม่ว่าจะเป็นการเรียกเก็บเงิน',
  Cargo_BillingAmount: 'จำนวนการเรียกเก็บเงิน',
  Cargo_BillingCurrency: 'สกุลเงินบิล',
  Cargo_BillingData: 'ข้อมูลการเรียกเก็บเงิน',
  Cargo_BillingDetails: 'รายละเอียดการเรียกเก็บเงิน',
  Cargo_BillingExpenditure: 'การใช้จ่ายบิล',
  Cargo_BillingExpenditureDetails: 'รายละเอียดค่าใช้จ่ายสำหรับการเรียกเก็บเงิน',
  Cargo_BillingExpense: 'ค่าธรรมเนียมการเรียกเก็บเงิน',
  Cargo_BillingMethod: 'วิธีการชำระเงิน',
  Cargo_BillingRevenue: 'รายได้จากการเรียกเก็บเงิน',
  Cargo_BillingRevenueExpenseDetails: 'รายละเอียดค่าใช้จ่ายของรายได้จากการเรียกเก็บเงิน',
  Cargo_BillInvoiced: '[{0}] ใบเรียกเก็บเงิน',
  Cargo_BillIssued: 'ใบเรียกเก็บเงิน',
  Cargo_BillList: 'รายการบิล',
  Cargo_BillNo: 'หมายเลขบิล',
  Cargo_BillNoP: 'หมายเลขบิล:',
  Cargo_BillNotSelected: 'ไม่มีการเลือกร่างกฎหมาย',
  Cargo_BillPaidInFullCanTRepeatWriteOff: 'มีการเบิกจ่ายบิลหมดแล้วไม่สามารถตัดบัญชีได้อีก',
  Cargo_BillStatus: 'สถานะการเรียกเก็บเงิน',
  Cargo_BillTo: 'วัตถุการเรียกเก็บเงิน',
  Cargo_BillType: 'ประเภทการเรียกเก็บเงิน',
  Cargo_BillWrittenOff: '[{0}] บิลถูกยกเลิก',
  Cargo_Blacklist: 'บัญชีดำ',
  Cargo_BLControl: 'การจัดการ BL',
  Cargo_BLMAEONRS: 'วิธีการ B / L มีอยู่แล้วหรือไม่ได้เลือกบันทึก',
  Cargo_BLMethodMaintenance: 'วิธี B / L การบำรุงรักษา',
  Cargo_BLMode: 'วิธี B / L',
  Cargo_BLNo: 'หมายเลขใบตราส่งสินค้า',
  Cargo_BLReleaseManagement: 'การจัดการการวางแผ่น',
  Cargo_MBLReleaseManagement: 'การจัดการใบตราส่งสินค้าหลัก',
  Cargo_HBLReleaseManagement: 'การจัดการใบตราส่งสินค้า',
  Cargo_BLReleaseReview: 'ใส่แผ่นตรวจสอบ',
  Cargo_MBLReleaseReview: 'การตรวจสอบ Masterplace',
  Cargo_HBLReleaseReview: 'การตรวจสอบแผ่นดิสเพลย์',
  Cargo_BLReleaseReviewStatus: 'ใส่สถานะการตรวจสอบแผ่น',
  Cargo_BlReleasingNo: 'ใส่หมายเลขเดียว',
  Cargo_BlReleasingNoP: 'ใส่หมายเลขแผ่น:',
  Cargo_BLRemoteReleaseFee: 'ค่าธรรมเนียมการเรียกเก็บเงินนอกสถานที่',
  Cargo_BLRetrieved: 'ไม่ว่าจะเป็นการเรียกคืนใบตราส่งสินค้า',
  Cargo_BLType: 'ประเภท B / L',
  Cargo_HBLType: 'HBL ประเภท B / L',
  Cargo_QuickSearchCustomPage: 'ค้นหาด่วน: ชื่อฟอร์ม',
  Cargo_ApplicationScene: 'สถานการณ์การใช้งาน',
  Cargo_CreateForm: 'สร้างฟอร์มใหม่',
  Cargo_ConfigForm: 'กำหนดค่าฟอร์ม',
  Cargo_Branch: 'บริษัทแอปพลิเคชัน',
  Cargo_CopyOne: 'กรุณาเลือกข้อมูลหนึ่งรายการเพื่อทำการคัดลอก!',
  Cargo_SelectDeleteTip4: 'กรุณาเลือกข้อมูลที่คุณต้องการลบ',
  Cargo_CopyFormConfirm: 'ยืนยันที่จะคัดลอกฟอร์มนี้และข้อมูลการกำหนดค่าอื่น ๆ ทั้งหมดรวมถึงกลุ่มและเค้าโครงองค์ประกอบหรือไม่?',
  Cargo_CannotDeleteEnabledForm: 'ไม่สามารถลบฟอร์มที่เปิดใช้งานอยู่ได้ กรุณาปิดใช้งานฟอร์มนี้ก่อน',
  Cargo_FormInfo: 'ข้อมูลฟอร์ม',
  Cargo_CopySucceed: 'คัดลอกสำเร็จ',
  Cargo_FormId: 'เลขที่ฟอร์ม',
  Cargo_FormType: 'ประเภทฟอร์ม',
  Cargo_AddSelectedElements: 'เพิ่มฟิลด์ที่เลือก',
  Cargo_ElementsAddedSuccessfully: 'เพิ่มองค์ประกอบสำเร็จ',
  Cargo_SelectPagePart: 'เลือกพื้นที่ข้อมูล',
  Cargo_AddPagePart: 'เพิ่มพื้นที่ข้อมูล',
  Cargo_ChatUser: 'ผู้ใช้',
  Cargo_ChatAI: 'ผู้ช่วย AI',
  Cargo_ChatInputPlaceholder: 'ส่งข้อความ... (Enter ขึ้นบรรทัดใหม่, Ctrl+Enter ส่ง)',
  Cargo_ChatThinking: 'กำลังคิด...',
  Cargo_ChatCopySuccess: 'คัดลอกไปยังคลิปบอร์ดแล้ว',
  Cargo_ChatConfirmTitle: 'คำเตือน',
  Cargo_ChatDeleteConfirm: 'ยืนยันที่จะลบข้อความนี้?',
  Cargo_ChatCopyFailed: 'คัดลอกล้มเหลว',
  Cargo_ChatDeleteSuccess: 'ลบเรียบร้อยแล้ว',
  Cargo_ChatNoResponse: 'ไม่ได้รับคำตอบ',
  Cargo_ChatConnectionError: 'ขออภัย การเชื่อมต่อมีปัญหา โปรดลองอีกครั้ง',
  Cargo_Debug: 'ดีบัก',
  Cargo_DebugAndConfig: 'ดีบักและการตั้งค่า',
  Cargo_EnterValue: 'กรุณากรอกค่า',
  Cargo_FormNamePlaceholder: 'กรุณากรอกชื่อฟอร์ม',
  Cargo_BranchPlaceholder: 'กรุณาเลือกบริษัทแอปพลิเคชัน',
  Cargo_ApplicationScenePlaceholder: 'กรุณาเลือกสถานการณ์การใช้งาน',
  Cargo_BusinessTypePlaceholder: 'กรุณาเลือกประเภทธุรกิจ',
  Cargo_RemarksPlaceholder: 'กรุณากรอกข้อมูลหมายเหตุ',
  Cargo_APIApplication: 'แอปพลิเคชัน API',
  Cargo_ConfirmMessageNotEditableAfterCreate: 'ไม่สามารถแก้ไขหลังจากสร้าง ยืนยันเข้าสู่ขั้นตอนถัดไป?',
  Cargo_Tip2: 'คำเตือน',
  Cargo_SelectDeleteTip5: 'ยืนยันที่จะลบข้อมูลที่เลือก? การดำเนินการนี้ไม่สามารถยกเลิกได้',
  Cargo_FormDisableWarning: 'ฟอร์มที่ถูกปิดใช้งานจะไม่สามารถใช้ได้ โปรดปรับเปลี่ยนโมดูลที่ใช้ฟอร์มนี้ทันที',
  Cargo_ElementSettings: 'การตั้งค่าฟิลด์',
  Cargo_ElementRules: 'กฎฟิลด์',
  Cargo_IsReadOnly: 'อ่านอย่างเดียวหรือไม่',
  Cargo_IsRequired: 'จำเป็นต้องกรอกหรือไม่',
  Cargo_MaxPagePartsReached: 'ถึงจำนวนสูงสุดของพื้นที่ข้อมูลแล้ว {0}',
  Cargo_InputOutputConfig: 'การตั้งค่าข้อมูลเข้า-ออก',
  Cargo_FormInputConfigDescription: 'โหลดฟอร์ม (Request Params): เมื่อโหลดฟอร์ม จะร้องขออินเทอร์เฟซตามลำดับ และประมวลผลฟิลด์ฟอร์ม',
  Cargo_FormInputAPI: 'อินเทอร์เฟซอินพุต',
  Cargo_FormInputAPIPlaceholder: 'กรุณากรอกรายการอินเทอร์เฟซอินพุต',
  Cargo_FormOutputConfigDescription: 'ส่งฟอร์ม (Function Call): เมื่อส่งฟอร์ม จะร้องขออินเทอร์เฟซแอปพลิเคชันตามลำดับ',
  Cargo_FormOutputAPI: 'อินเทอร์เฟซเอาต์พุต',
  Cargo_FormOutputAPIPlaceholder: 'กรุณากรอกรายการอินเทอร์เฟซเอาต์พุต',
  Cargo_PublishForm: 'เผยแพร่ฟอร์ม',
  Cargo_LastOperateTime: 'เวลาดำเนินการล่าสุด',
  Cargo_Draft: 'ร่าง',
  Cargo_Published: 'เผยแพร่แล้ว',
  Cargo_ConfigPagePart: 'กำหนดค่าพื้นที่',
  Cargo_ConfigName: 'ชื่อการกำหนดค่า',
  Cargo_PagePartFunction: 'ฟังก์ชันพื้นที่',
  Cargo_PleaseSelectFunction: 'กรุณาเลือกฟังก์ชัน',
  Cargo_BusinessElements: 'ฟิลด์ธุรกิจ',
  Cargo_ConsigneeShipperAndNotifyInfo: 'ข้อมูลผู้รับ-ผู้ส่ง-ผู้แจ้ง',
  Cargo_AccountsReceivable: 'ค่าธรรมเนียมการรับ',
  Cargo_AccountsPayable: 'ค่าธรรมเนียมที่ต้องชำระ',
  Cargo_UploadFile: 'อัปโหลดไฟล์',
  Cargo_UploadInstruction: 'คำสั่งอัปโหลด',
  Cargo_InstructionParameter: 'พารามิเตอร์คำสั่ง',
  Cargo_FormPreviewInListViewIsReadOnly: 'หากต้องการแก้ไขข้อมูลดีบัก กรุณาคลิก "แก้ไข" เพื่อเข้าสู่หน้าด้านละเอียด',
  Cargo_BPM: 'BPM',
  Cargo_OCR: 'OCR',
  Cargo_PublishSuccess: 'เผยแพร่สำเร็จ',
  Cargo_PublishFailed: 'เผยแพร่ล้มเหลว',
  Cargo_ValueRequired: 'ค่านี้ไม่สามารถว่างได้',
  Cargo_FixFormErrors: 'โปรดตรวจสอบว่าการกรอกแบบฟอร์มถูกต้อง',
  Cargo_ValidationFailed: 'ตรวจสอบผลลัพธ์ผิดพลาดโปรดตรวจสอบว่ากรอกข้อมูลถูกต้องหรือไม่',
  Cargo_ToggleStatusFailed: 'เปลี่ยนสถานะการเปิดใช้งานฟอร์มล้มเหลว',
  Cargo_CopyFailed: 'คัดลอกล้มเหลว',
  Cargo_GetFormConfigFailed: 'รับการกำหนดค่าฟอร์มล้มเหลว',
  Cargo_ConfirmChangeBlockType: 'เปลี่ยนฟังก์ชันพื้นที่ ยืนยันล้างเนื้อหาการกำหนดค่าของพื้นที่เดิม?',
  Cargo_ConfirmDeleteBlock: 'ยืนยันที่จะลบพื้นที่นี้ และยกเลิกฟิลด์ที่เลือก?',
  Carog_ConfirmSaveBeforeGoBack: 'ต้องการบันทึกเนื้อหาการกำหนดค่าปัจจุบันหรือไม่?',
  Cargo_FormValidation: 'การตรวจสอบฟอร์ม',
  Cargo_Problem: 'ปัญหา',
  Cargo_Description: 'คำอธิบาย',
  Cargo_ValidationSucceed: 'ตรวจสอบสำเร็จ',
  Cargo_NoChanges: 'ไม่มีการแก้ไขข้อมูล',
  Cargo_JobUuidRequired: 'ฟอร์มธุรกิจ uuid ไม่สามารถว่างได้',
  Cargo_LoadFormDataFailed: 'โหลดข้อมูลฟอร์มล้มเหลว',
  Cargo_SyncRuleExecutionFailed: 'การดำเนินการตามกฎการแก้ไขความสัมพันธ์ข้อมูลล้มเหลว',
  Cargo_PreviewRevision: 'ดูตัวอย่างผลลัพธ์ของเวอร์ชันนี้',
  Cargo_Current: 'ปัจจุบัน',
  Cargo_FormPreviewInRevisionViewIsReadOnly: 'แสดงตัวอย่างปัจจุบันเป็นรุ่นประวัติศาสตร์และรองรับโหมดอ่านอย่างเดียวเท่านั้น',
  Cargo_VisualizationView: 'การจัดวางภาพ',
  Cargo_CodeView: 'มุมมองโค้ด',
  Cargo_ChatView: 'ผู้ช่วย AI',
  Cargo_RestoreRevision: 'กู้คืนเป็นเวอร์ชันนี้',
  Cargo_RestoreSucceed: 'กู้คืนสำเร็จ',
  Cargo_RestoreFailed: 'กู้คืนล้มเหลว',
  Cargo_ConfirmRestoreRevision: 'ยืนยันที่จะกู้คืนเวอร์ชันนี้?',
  Cargo_NeedAtLeastOnePagePart: 'ไม่สามารถลบพื้นที่ข้อมูลทั้งหมดได้',
  Cargo_DataFill: 'กรอกข้อมูล',
  Cargo_CSNInfo_BASIC: 'ข้อมูลผู้รับ-ผู้ส่ง-ผู้แจ้ง (แท็บพื้นฐาน)',
  Cargo_CSNInfo_MBL: 'ข้อมูลผู้รับ-ผู้ส่ง-ผู้แจ้ง (MBL)',
  Cargo_CSNInfo_HBL: 'ข้อมูลผู้รับ-ผู้ส่ง-ผู้แจ้ง (HBL)',
  Cargo_CSNInfo_HBL2: 'ขการรับ-ส่งข้อมูล (แบบฟอร์มย่อย)',
  Cargo_ReadOnly: 'อ่านอย่างเดียว',
  Cargo_Notify: 'ผู้แจ้ง',
  Cargo_AlsoNotify: 'ผู้แจ้งคนที่สอง',
  Cargo_AgentParty: 'ข้อมูลตัวแทน',
  Cargo_DataLoadingPleaseWait: 'Đang tải dữ liệu, vui lòng chờ',
  Cargo_RuleID: 'ID quy tắc',
  Cargo_ValidationRule: 'Quy tắc kiểm tra',
  Cargo_TriggerElement: 'Trường kích hoạt',
  Cargo_RelatedElements: 'Trường liên quan',
  Cargo_TriggerCondition: 'Điều kiện kích hoạt',
  Cargo_FunctionCode: 'Mã hàm',
  Cargo_AddedValidationRules: 'Đã thêm các quy tắc kiểm tra sau',
  Cargo_AddedSyncRules: 'Đã thêm các quy tắc đồng bộ sau',
  Cargo_AddedVisibilityRules: 'Đã thêm các quy tắc hiển thị sau',
  Cargo_NoRuleDetected: 'Xin lỗi, không phát hiện được hàm kiểm tra dữ liệu hoặc hàm chỉnh sử Liên kết dữ liệu hiệu quả, bạn có thể thử điều chỉnh truy vấn và thử lại',
  Cargo_ConnectionError: 'Xin lỗi, kết nối có vấn đề, vui lòng thử lại',
  Cargo_OperationArea: 'Khu vực thao tác',
  Cargo_BlDataNotFound: 'Không tìm thấy dữ liệu vận đơn Tương ứng',
  Cargo_SelectBlDocument: 'Vui lòng chọn tài liệu vận đơn',
  Cargo_SelectHblDocument: 'Vui lòng chọn tài liệu vận đơn HBL',
  Cargo_SelectHawb2Document: 'Vui lòng chọn tài liệuHình thức đặt hàng',
  Cargo_BNASPCTBBE: 'หมายเลขธุรกิจและวัตถุของการตั้งถิ่นฐานไม่สามารถว่างเปล่าได้ทั้งหมด',
  Cargo_BNTTPRS: 'หมายเลขล็อต {0} โอนเข้าบัญชีแบบเติมเงินเรียบร้อยแล้ว',
  Cargo_BOECTBCIWBII: 'โปรดเลือกค่าธรรมเนียมภายในประเทศ / ต่างประเทศเพื่อสร้างการเรียกเก็บเงิน',
  Cargo_Booking: 'การจองห้องพัก',
  Cargo_BookingAgent: 'ตัวแทนการจองห้องพัก',
  Cargo_BookingAgentAbbreviation: 'ตัวแทนการจองห้องพัก (สั้นๆ)',
  Cargo_BookingAgentCode: 'ตัวแทนการจองห้องพัก (รหัส)',
  Cargo_BookingNo: 'หมายเลขการจอง',
  Cargo_BookingOrderNotExistCanTBeAdded: 'การเพิ่มใหม่ล้มเหลว ไม่มีรายการจอง',
  Cargo_BookingWindow: 'สั่งซื้อ / เปลี่ยนหน้าต่าง',
  Cargo_BookKeeper: 'พนักงานบัญชี',
  Cargo_BookKeepingDate: 'วันที่ทำบัญชี',
  Cargo_BookKeepingMethod: 'วิธีการทำบัญชี',
  Cargo_BookKeepingVoucher: 'หนังสือรับรองการทำบัญชี',
  Cargo_BOPIOOPCTBLT: 'ยอดการรับชำระจริงต้องไม่น้อยกว่า {0}',
  Cargo_BOPIOOPCTBLTCWOA: 'ยอดการรับชำระจริงต้องไม่น้อยกว่ายอดชำระหนี้ครั้งนี้',
  Cargo_BPHCCTBWO: 'การเรียกเก็บเงิน {0} กำลังรอการตรวจสอบจากสำนักงานใหญ่และไม่สามารถตัดบัญชีได้ในขณะนี้',
  Cargo_BranchBill: 'บิลสาขา',
  Cargo_BranchCMP: 'สำนักงานสาขา',
  Cargo_BranchCMPP: 'สาขา:',
  Cargo_BranchCompany: 'สาขาในเครือ',
  Cargo_BranchConfirmation: 'ยืนยันสาขา',
  Cargo_BranchConfirmed: 'สาขาได้รับการยืนยัน',
  Cargo_BranchFilter: 'กรองสาขา',
  Cargo_BREVB20TM: 'B. การส่งออกมีเสถียรภาพมากขึ้นภายใต้ 20TEU',
  Cargo_BRNPNACW: 'หมายเลขอ้างอิงธุรกิจ / หมายเลขสินค้า / น้ำหนักการเรียกเก็บเงินจริง',
  Cargo_BrokenDesc: 'การสูญเสียสินค้า Description',
  Cargo_BrokenNumberDetection: 'ตรวจสอบหมายเลขหัก',
  Cargo_Browse: 'เรียกดู...',
  Cargo_BRTSIOC: 'B - Cheap พิจารณาคำแนะนำสำหรับเจ้านาย',
  Cargo_BSNMIR: 'สถานะธุรกิจไม่เป็นไปตามใบแจ้งหนี้',
  Cargo_BSNMPCR: 'สถานะธุรกิจไม่เป็นไปตามคำขอเบิกจ่าย',
  Cargo_BSNMWOR: 'สถานะธุรกิจไม่ตรงตามข้อกำหนดการตัดบัญชี',
  Cargo_BulkCargo: 'ร้านขายของชำ',
  Cargo_BURCNBE: 'ธุรกิจที่จะตรวจสอบไม่สามารถแก้ไขได้',
  Cargo_Business: 'ธุรกิจ',
  Cargo_BusinessAdjustment: 'การปรับธุรกิจ',
  Cargo_BusinessAdjustmentLog: 'บันทึกการปรับธุรกิจ',
  Cargo_BusinessApproval: 'การอนุมัติทางธุรกิจ',
  Cargo_BusinessApprovalDate: 'วันที่อนุมัติธุรกิจ',
  Cargo_BusinessApproved: 'อนุมัติธุรกิจแล้ว',
  Cargo_OfficeApproved: 'ได้รับการอนุมัติทางธุรกิจ',
  Cargo_BusinessCategory: 'ประเภทของธุรกิจ',
  Cargo_BusinessCharacteristic: 'ลักษณะธุรกิจ',
  Cargo_BusinessCommission: 'ค่าคอมมิชชั่นธุรกิจ',
  Cargo_BusinessCreateDate: 'วันที่สร้างธุรกิจ',
  Cargo_BusinessCreator: 'ผู้สร้างธุรกิจ',
  Cargo_BusinessDate: 'วันที่ประกอบธุรกิจ',
  Cargo_BusinessDateBusinessDate: 'วันที่ประกอบธุรกิจ วันที่ประกอบธุรกิจ',
  Cargo_BusinessDateP: 'วันที่ประกอบธุรกิจ:',
  Cargo_BusinessDocNo: 'หมายเลขธุรกิจ',
  Cargo_BusinessDocNo2: 'หมายเลขธุรกิจ 2',
  Cargo_BusinessDocNoP: 'หมายเลขธุรกิจ:',
  Cargo_BusinessHappenDate: 'วันที่เกิดธุรกิจ',
  Cargo_BusinessHappenDateP: 'วันที่เกิดธุรกิจ:',
  Cargo_BusinessInformation: 'ข้อมูลธุรกิจ',
  Cargo_BusinessModel: 'รูปแบบธุรกิจ',
  Cargo_BusinessNo: 'หมายเลขธุรกิจ',
  Cargo_BusinessNoInBill: '(บิล) หมายเลขธุรกิจ',
  Cargo_BusinessNotSelected: 'ธุรกิจไม่ได้เลือก',
  Cargo_BusinessReferenceNo: 'หมายเลขอ้างอิงธุรกิจ',
  Cargo_GenerateNumberOfBusiness: 'สร้างจำนวนหุ้นธุรกิจ',
  Cargo_UpdateBusinessAgain: 'ปรับเปลี่ยนธุรกิจสร้างอีกครั้ง',
  Cargo_Business_CustomerRefNo: 'หมายเลขอ้างอิงธุรกิจ / ลูกค้า',
  Cargo_BusinessStatus: 'สถานะธุรกิจ',
  Cargo_BusinessStatusChangeLog: 'บันทึกการเปลี่ยนแปลงสถานะธุรกิจ',
  Cargo_DataPushResultRecords: 'การบันทึกผลการผลักดันข้อมูล',
  Cargo_SendType: 'ประเภทการส่ง',
  Cargo_ReissueFees: 'ค่าธรรมเนียมการออกซ้ำ',
  Cargo_ReissueFeesTips: 'การคลิกที่ปุ่มนี้จะส่งค่าธรรมเนียมทั้งหมดที่ล้มเหลวในการส่งอีกครั้ง',
  Cargo_BusinessType: 'ประเภทธุรกิจ',
  Cargo_BusinessTypeP: 'ประเภทธุรกิจ:',
  Cargo_BusinessTypeCanTBeEmpty: 'ประเภทของธุรกิจต้องไม่ว่างเปล่า',
  Cargo_BusinessTypeInconsistent: 'ประเภทธุรกิจไม่สอดคล้องกัน',
  Cargo_ButtonPermissionControl: 'ปุ่มควบคุมสิทธิ์',
  Cargo_BuyingPrice: 'ราคาซื้อ',
  Cargo_BWNBCAED: 'จะไม่สามารถสร้างธุรกิจได้หลังจากหมดสัญญา',
  Cargo_ByBill: 'ตามบิล',
  Cargo_ByDetail: 'ตามรายละเอียด',
  Cargo_ByInvoice: 'ตามใบแจ้งหนี้',
  Cargo_ByInvoiceFxRate: 'โดยอัตราแลกเปลี่ยนตามใบแจ้งหนี้',
  Cargo_ByJob: 'ตามธุรกิจ',
  Cargo_ByJobNo: 'โดยหมายเลขธุรกิจ',
  Cargo_ByPaymentRequestFxRate: 'สมัครอัตราแลกเปลี่ยนตามการชำระเงิน',
  Cargo_BySettlementAgent: 'ผ่านตัวแทนการตั้งถิ่นฐาน',
  Cargo_CAEONRS: 'สกุลเงินที่มีอยู่แล้วหรือไม่ได้เลือกบันทึก',
  Cargo_CAIFCINFCAUU: 'เลือกบัญชีสกุลเงินต่างประเทศ หากไม่มีเงินตราต่างประเทศจะถูกตัดสินเป็นดอลลาร์สหรัฐ',
  Cargo_CAIOCPCRY: 'เครดิตที่เกิดขึ้นในงวดนี้ (CNY)',
  Cargo_CAIOCPUSD: 'เครดิตที่เกิดขึ้นสำหรับงวดนี้ (USD)',
  Cargo_CalculateBalance: 'คำนวณยอดคงเหลือ',
  Cargo_CalculateBalanceTotalToWriteOff: 'คำนวณมูลค่ารวมของยอดคงเหลือที่ขายได้',
  Cargo_CalculateBillingAmount: 'การคำนวณยอดบิล',
  Cargo_CalculatedInOriginalCurrency: 'การคำนวณโดยใช้สกุลเงินเดิม',
  Cargo_CalculateTaxRate: 'คำนวณอัตราภาษี',
  Cargo_CallbackFunction: 'ฟังก์ชั่นการโทรกลับ',
  Cargo_CanBeConfirmedOrNot: 'ไม่ว่าจะเป็นการยืนยัน',
  Cargo_CanBeDeletedOrNot: 'ไม่ว่าจะเป็นการลบ',
  Cargo_CanBePrintedOrNot: 'สามารถพิมพ์ได้หรือไม่',
  Cargo_CanBeVoidedOrNot: 'ไม่ว่าจะเป็นโมฆะ',
  Cargo_CANCA: 'เงินทดรองจ่าย เงินทดรองจ่าย',
  Cargo_Cancel: 'การยกเลิก',
  Cargo_CancelAccrue: 'ยกเลิกการนับคะแนน',
  Cargo_CancelAudit: 'ยกเลิกการตรวจสอบ',
  Cargo_NewCustomerApplication: 'คำขอเพิ่มลูกค้าใหม่',
  Cargo_NewSupplierApplication: 'คำขอเพิ่มซัพพลายเออร์ใหม่',
  Cargo_RequiredFields: 'กรุณากรอกข้อมูลในช่องที่จำเป็นของแบบฟอร์ม',
  Cargo_SelectTradeType: 'กรุณาเลือกรูปแบบการค้า',
  Cargo_CancelCheckOfSelectedRecord: 'ยืนยันประวัติการยกเลิกการเลือกหรือไม่',
  Cargo_CancelClosure: 'ยกเลิกการปิด',
  Cargo_CancelConfirm: 'ยืนยันการยกเลิก',
  Cargo_CancelCurrentModification: 'ยกเลิกการแก้ไขข้อมูลในปัจจุบัน',
  Cargo_CancelDefaultsInBatch: 'ยกเลิกเป็นกลุ่ม ค่าเริ่มต้น',
  Cargo_CancelEditing: 'ยกเลิกการแก้ไข',
  Cargo_CancelGetBack: 'ถอนการรับคืน',
  Cargo_CancelIgnore: 'ยกเลิกการเพิกเฉย',
  Cargo_CancelMark: 'ยกเลิกการทำเครื่องหมาย',
  Cargo_CancelMerging: 'ยกเลิกการควบรวมกิจการ',
  Cargo_CancelModification: 'ยกเลิกการแก้ไขปัจจุบันหรือไม่',
  Cargo_CancelPublishment: 'ยกเลิกการเผยแพร่',
  Cargo_DownloadImportTemplate: 'ดาวน์โหลด Stencil นำเข้า',
  Cargo_CancelReconciliation: 'ยกเลิกการสร้างความปรองดอง',
  Cargo_CancelReturn: 'ยกเลิกการส่งคืน',
  Cargo_CancelSuccessfully: 'ยกเลิกสำเร็จ',
  Cargo_CancelTheChargesAudit: 'การตรวจสอบค่าธรรมเนียมการยกเลิก',
  Cargo_CancelWriteOff: 'ยกเลิกการตัดบัญชี',
  Cargo_CanNotProcessUnsavedNewExpense: 'ค่าใช้จ่ายใหม่ที่ยังไม่ได้บันทึกไม่สามารถดำเนินการได้',
  Cargo_CanNotRedoCancellation: 'ไม่สามารถออกจากระบบซ้ำได้',
  Cargo_CanNotRemoveAllBills: 'ไม่สามารถถอดถอนร่างกฎหมายได้ทั้งหมด',
  Cargo_CanOnlyRetrieveAfterDelivered: 'ถูกส่งออกไปเพื่อรับคืน!',
  Cargo_CanTDeleteItemsWithInvoiceNo: 'ป้อนหมายเลขใบแจ้งหนี้แล้ว ไม่สามารถลบได้',
  Cargo_CanTDeleteWrittenOffItem: 'ตรวจสอบแล้ว ไม่สามารถลบได้',
  Cargo_CanTEditClosedItem: 'เช็คเอาท์อยู่แล้วไม่สามารถแก้ไขได้',
  Cargo_CanTRepeatVoiding: '【{0}】 เป็นโมฆะและไม่สามารถเป็นโมฆะได้อีกต่อไป',
  Cargo_CanTSelectInvoiceNoForEInvoice: 'ใบแจ้งหนี้อิเล็กทรอนิกส์ไม่สามารถเลือกหมายเลขใบแจ้งหนี้ได้',
  Cargo_CanTSplitInvoicedItem: 'ออกตั๋วแล้วและไม่สามารถแยกได้!',
  Cargo_CanTVoidInvoiceWithoutInvoiceNo: 'ไม่มีหมายเลขใบแจ้งหนี้ ใบแจ้งหนี้ไม่สามารถเป็นโมฆะได้!',
  Cargo_CanTVoidWrittenOffItem: '【{0}】 ได้รับการยกเลิกและไม่สามารถเป็นโมฆะได้',
  Cargo_CAOPWWT: 'คำนวณราคาภาษี ไม่รวมภาษีมูลค่าเพิ่ม',
  Cargo_Cargo: 'สินค้า',
  Cargo_Remark: 'หมายเหตุสินค้า',
  Cargo_Remark_Check: 'หมายเหตุสินค้าสามารถป้อนได้เพียง 3999 ตัวอักษร (ตัวพิมพ์ใหญ่/เล็ก ตัวเลข และอักขระพิเศษ: !"#%&\'()*+,-./:;<=>?@_0-9a-zA-Z\n\s)',
  Cargo_CargoDetention: 'สินค้าหัวเข็มขัด',
  Cargo_CargoInfo: 'ข้อมูลสินค้า',
  Cargo_CargoName: 'ชื่อสินค้า',
  Cargo_CargoNature: 'คุณสมบัติของสินค้า',
  Cargo_CargoType: 'ประเภทสินค้า',
  Cargo_CAROJE: 'การกำหนดค่ากฎสรุปรายการ',
  Cargo_CarriedOver: 'Carryover แล้ว',
  Cargo_Carrier: 'ผู้ให้บริการ',
  Cargo_Carrier_Ship: 'ผู้ให้บริการ (บริษัทเรือ)',
  Cargo_Carrier_Air: 'ผู้ให้บริการ (สายการบิน)',
  Cargo_Carrier_Railway: 'ผู้ให้บริการ (ตัวแทนท่าเรือ)',
  Cargo_CarrierAgent: 'เรือนำเที่ยว',
  Cargo_CarrierShip: 'บริษัท เรือ',
  Cargo_CarryOverForeignExchange: 'อัตราแลกเปลี่ยน Carryover',
  Cargo_CarryOverInitialized: 'เริ่มการทำงาน Carryover',
  Cargo_CarryOverProfitLoss: 'กำไรและขาดทุน Carryover',
  Cargo_CarryOverProfitLoss2: 'กำไรและขาดทุน Carryover 2',
  Cargo_CarryOverToNextPeriod: 'ปมไปยังงวดถัดไป',
  Cargo_CartonQuantity: 'ประเภทกล่อง ปริมาณกล่อง',
  Cargo_TicketCount: 'จำนวนใบ',
  Cargo_Cash: 'เงินสด',
  Cargo_CasualClientNonCasualClient: 'ลูกค้ารายย่อย / ลูกค้ารายย่อย',
  Cargo_NonCasualClient: 'ลูกค้ารายย่อย',
  Cargo_CasualClientOrNot: 'ไม่ว่าจะเป็นลูกค้ารายย่อย',
  Cargo_Category: 'หมวดหมู่',
  Cargo_CategoryOfPartner: 'ประเภทพันธมิตร',
  Cargo_CATISExport: 'การส่งออกภาษีทองคำ',
  Cargo_CATISInvalid: 'ภาษีทองคำเป็นโมฆะ',
  Cargo_CATISPrint: 'การพิมพ์ภาษีทอง',
  Cargo_CBEIPCPTSINACSRANMPC: 'สาขาปัจจุบัน e-Invoice: รหัสแพลตฟอร์ม / รหัสผ่าน / หมายเลขประจำตัวผู้เสียภาษี / รหัสอนุญาต / ที่อยู่คำขอบริการไม่ได้รับการบำรุงรักษาโปรดตรวจสอบ',
  Cargo_CBEIPCTSINACSRANMPC: 'สาขาปัจจุบัน e-Invoice: รหัสแพลตฟอร์ม / หมายเลขประจำตัวผู้เสียภาษี / รหัสการอนุญาต / ที่อยู่คำขอบริการไม่ได้รับการบำรุงรักษาโปรดตรวจสอบ',
  Cargo_CBFCEBD: 'สร้างบิลค่าธรรมเนียมที่ได้รับการยืนยันโดยปริยาย',
  Cargo_CBISAWTSNM: 'สาขาปัจจุบันที่อยู่บริการอินเทอร์เฟซระบบภาษีไม่ได้รับการบำรุงรักษา',
  Cargo_CBTSINNM: 'หมายเลขประจำตัวผู้เสียภาษีของสาขาปัจจุบันไม่ได้รับการบำรุงรักษา',
  Cargo_CCOCM: 'กำหนดยกเลิกการแก้ไขปัจจุบันหรือไม่',
  Cargo_CCOPLV: 'การสร้าง Carryover Profit & Loss Voucher สำเร็จ:',
  Cargo_CCRAIOC: 'C-Cheap พิจารณาการเตรียมตัวสำหรับการเปลี่ยนตัวแทน',
  Cargo_CCS: 'ยกเลิกยืนยันความสำเร็จ',
  Cargo_CDOPRI: 'ระบุข้อมูลคำขอปฏิเสธการชำระเงิน',
  Cargo_Cent: 'คะแนน',
  Cargo_AndTo: 'และ {0} ถึง {1}',
  Cargo_AlreadyHere: 'มาถึงแล้ว',
  Cargo_IsOver: '{0} ผ่านไปแล้ว {1}',
  Cargo_CERNM: 'อัตราแลกเปลี่ยนสกุลเงิน ({0}) ไม่มีการบำรุงรักษา',
  Cargo_CFCNAPM: 'รายวิชาจะไม่นับสกุลเงินต่างประเทศในปัจจุบัน: {0} โปรดแก้ไข',
  Cargo_CGS1RV: 'ยอดขายปล้นความสำเร็จของลูกค้า! ตรวจสอบรายการ {0} เรียบร้อยแล้ว',
  Cargo_ChangeContent: 'เปลี่ยนเนื้อหา',
  Cargo_ChangeInvoiceTitle: 'เปลี่ยนหัวใบแจ้งหนี้',
  Cargo_ChangeInvoiceTitleP: 'เปลี่ยนหัวใบแจ้งหนี้:',
  Cargo_ChangeSob: 'เปลี่ยนชุดบัญชี',
  Cargo_ChangeTo: 'เปลี่ยนเป็น',
  Cargo_ChangeToP: 'เปลี่ยนเป็น:',
  Cargo_Charge: 'การเก็บรวบรวม',
  Cargo_Chargeback: 'การคืนเงิน',
  Cargo_ChargebackFile: 'เอกสารการคืนเงิน',
  Cargo_ChargeDetails: 'รายละเอียดค่าใช้จ่าย',
  Cargo_ChargedWeight: 'น้ำหนักการเรียกเก็บเงิน',
  Cargo_ChargeName: 'ชื่อค่าธรรมเนียม',
  Cargo_ChargeOriginalAmount: 'จำนวนเงินเดิมของค่าธรรมเนียม',
  Cargo_ChargeOriginalCurrency: 'ค่าธรรมเนียมสกุลเงินเดิม',
  Cargo_ChargeOriginalExchangeRate: 'อัตราค่าธรรมเนียมเดิม',
  Cargo_ChargesAudit: 'การตรวจสอบค่าใช้จ่าย',
  Cargo_ChargesContactPerson: 'ติดต่อค่าใช้จ่าย',
  Cargo_ChargesReject: 'ค่าธรรมเนียมการยกเลิก',
  Cargo_ChargeStatus: 'สถานะค่าใช้จ่าย',
  Cargo_ChargesTotalAmount: 'ยอดรวมค่าธรรมเนียม',
  Cargo_ChargeType: 'ประเภทของค่าธรรมเนียม',
  Cargo_ChargeTypeP: 'ประเภทค่าธรรมเนียม:',
  Cargo_CHBRNFOA: 'มีการต่อสัญญาห้ามดำเนินการ',
  Cargo_CheckAccountInForeignCurrency: 'เลือกบัญชีสกุลเงินต่างประเทศ',
  Cargo_CheckChargeDetailBranch: 'สำนักงานสาขาที่ข้อมูลกำลังดำเนินการอยู่นั้นไม่ได้เป็นของสาขาปัจจุบันหรือสาขาระดับก่อนหน้า',
  Cargo_CheckCreateBillWay: 'วัตถุของการตั้งถิ่นฐานหรือตัวแทนการตั้งถิ่นฐานต้องเป็นไปตามรายการเดียวกัน',
  Cargo_CheckInvoiceQueryBranch: 'ขณะนี้ดำเนินการสาขาไม่สอดคล้องกับสาขาที่เป็นข้อมูล กรุณาตรวจสอบข้อมูลอีกครั้งเพื่อประมวลผลใหม่',
  Cargo_CheckClientToExtendValidPeriod: 'โปรดเลือกลูกค้าที่ต้องการขยายระยะเวลาก่อน',
  Cargo_CheckIfSoaFullyWrittenOff: 'ตรวจสอบใบแจ้งยอดบัญชีว่ามีการเบิกจ่ายครบถ้วนหรือไม่',
  Cargo_CheckingStatus: 'ยืนยันสถานะ B / L',
  Cargo_HblCheckingStatus: 'HBL ยืนยันสถานะ B / L',
  Cargo_CheckingURLStatus: 'สถานะคู่',
  Cargo_CheckInvoice: 'การรับตั๋วและออกตั๋ว',
  Cargo_CheckWriteOffDetails: 'สอบถามรายละเอียดบัญชีการขาย',
  Cargo_ChineseCargoName: 'ชื่อภาษาจีน',
  Cargo_StatusUpdateTime: 'เวลาเปลี่ยนสถานะ B / L',
  Cargo_StatusUpdateUser: 'เปลี่ยนแปลงสถานะ B / L',
  Cargo_ChineseFirstVesselName: 'ชื่อเรือ',
  Cargo_ChineseName: 'ชื่อภาษาจีน',
  Cargo_ChineseNameCanTBeEmpty: 'ชื่อภาษาจีนไม่สามารถเว้นว่างได้',
  Cargo_ChineseNameOfSettlingParty: 'ชื่อภาษาจีนของวัตถุการตั้งถิ่นฐาน',
  Cargo_Choose0P: 'เลือก 0:',
  Cargo_ChooseByText: 'เลือกจากข้อความ',
  Cargo_ChooseFee: 'เลือกค่าธรรมเนียม',
  Cargo_ChooseFeeCNY: 'เลือกค่าธรรมเนียม RMB',
  Cargo_ChooseFeeUSD: 'ตรวจสอบค่าธรรมเนียม USD',
  Cargo_ChooseInvoicedFee: 'เลือกค่าธรรมเนียมใบแจ้งหนี้',
  Cargo_ChooseP: 'เลือก {0}:',
  Cargo_TicketCount: 'จำนวน: ',
  Cargo_CIIRSBATTB: 'ยืนยันว่าควรเพิ่มการเรียกเก็บเงินในร่างกฎหมายหรือไม่',
  Cargo_CIMJ: 'ข้อมูลด่วน การตัดสินที่ต้องบันทึก',
  Cargo_CIMS: 'แก้ไขข้อมูลการเรียกเก็บเงินสำเร็จ',
  Cargo_City: 'เมืองที่เกี่ยวข้อง',
  Cargo_CityCode: 'รหัสเมือง',
  Cargo_CityMaintenance: 'การบำรุงรักษาเมือง',
  Cargo_CityName: 'ชื่อเมือง',
  Cargo_CityNotSelected: 'เมือง ไม่มีตัวเลือก',
  Cargo_CityP: 'เมือง',
  Cargo_Claim: 'การอ้างสิทธิ์',
  Cargo_ClaimAdvanceReceipt: 'การเรียกร้องล่วงหน้า',
  Cargo_ClaimAR: 'การอ้างสิทธิ์ของลูกหนี้',
  Cargo_ClaimBankReceipt: 'การเรียกร้องค่าน้ำ',
  Cargo_ClaimDate: 'วันที่อ้างสิทธิ์',
  Cargo_ClaimedBy: 'ผู้รับสิทธิ์',
  Cargo_ClaimInformation: 'ข้อมูลการเรียกร้อง',
  Cargo_ClaimOrNot: 'ไม่ว่าจะเป็นการเรียกร้อง',
  Cargo_ClaimState: 'สถานะการเรียกร้อง',
  Cargo_ClaimStatusOfAdvanceReceipt: 'สถานะการเรียกร้องสิทธิ (ยอมรับล่วงหน้า)',
  Cargo_ClaimStatusOfAR: 'สถานะการเรียกร้อง (ลูกหนี้)',
  Cargo_Clear: 'ล้าง',
  Cargo_ClearData: 'ล้างข้อมูล',
  Cargo_ClearFilter: 'ล้างการกรอง',
  Cargo_ClickToFilter: 'คลิกกรอง',
  Cargo_ClickToLoadParameter: 'คลิกปุ่มเพื่อโหลดพารามิเตอร์แบบสอบถาม',
  Cargo_ClickToQuery: 'คลิกปุ่มเพื่อดำเนินการสอบถาม',
  Cargo_ClientAllocationStatus: 'สถานะการจัดสรรลูกค้า',
  Cargo_CLientCantBeEmpty: 'ลูกค้าไม่สามารถว่างได้',
  Cargo_ClientContract: 'สัญญาลูกค้า',
  Cargo_ClientEventNotSelected: 'กิจกรรมของลูกค้า ไม่มีตัวเลือก',
  Cargo_ClientList: 'รายชื่อลูกค้า',
  Cargo_ClientMovedToRecycleBin: 'ลูกค้ารายนี้ถูกย้ายไปยังถังรีไซเคิลของลูกค้า',
  Cargo_ClientNo: 'หมายเลขลูกค้า',
  Cargo_ClientOverseasAgent: 'ลูกค้า / ตัวแทนในต่างประเทศ',
  Cargo_ClientStatus: 'สถานะลูกค้า',
  Cargo_ClientSVisit: 'ลูกค้าเยี่ยมชม',
  Cargo_ClientVendor: 'ลูกค้า / ผู้จำหน่าย',
  Cargo_Close: 'ปิด',
  Cargo_Close2: 'วางลง',
  Cargo_CloseAccount: 'เช็คเอาท์',
  Cargo_CloseAccount2: 'เช็คเอาท์ 2',
  Cargo_CloseAccountOrNot: 'ไม่ว่าจะเป็นการเช็คเอาท์',
  Cargo_CloseDateOfContainerReturn: 'วันสิ้นสุดการคืนตู้',
  Cargo_CloseDetailWindow: 'ปิดหน้าต่างรายละเอียด',
  Cargo_CloseWindow: 'ปิดหน้าต่าง',
  Cargo_ClosureNo: 'หมายเลขสิ้นสุด',
  Cargo_ClosureTimeSelection: 'เลือกเวลาสิ้นสุด',
  Cargo_ClosureTitleOfAccount: 'จบวิชา',
  Cargo_CNY: 'หยวนจีน',
  Cargo_CNYHKD: 'CNY / ดอลลาร์ฮ่องกง',
  Cargo_CNYInvoiceNo: 'หมายเลขใบแจ้งหนี้ RMB',
  Cargo_CNYP: 'หยวนจีน:',
  Cargo_COACP: 'สกุลเงินที่รับชำระจริง',
  Cargo_Code: 'รหัส',
  Cargo_CodeCanTBeEmpty: 'รหัสต้องไม่ว่างเปล่า',
  Cargo_DuplicateCode: 'รหัสซ้ำโปรดป้อนอีกครั้ง',
  Cargo_CodeNotMaintained: 'ไม่มีการบำรุงรักษาสำหรับการเข้ารหัส',
  Cargo_CodeOfExpenseDescription: 'ค่าธรรมเนียม ชื่อ รหัส',
  Cargo_CodeSearching: 'การดึงรหัส',
  Cargo_CodeType: 'ประเภทการเข้ารหัส',
  Cargo_CodeTypeP: 'ประเภทการเข้ารหัส:',
  Cargo_Coding: 'การเข้ารหัส',
  Cargo_ApCoding: 'การรับมือกับการเข้ารหัส',
  Cargo_ArCoding: 'รหัสการรับ',
  Cargo_CodingMapping: 'แผนที่การเข้ารหัส',
  Cargo_CodingP: 'การเข้ารหัส:',
  Cargo_Collect: 'รับ',
  Cargo_CollectAndPrepaidOrNot: 'ไม่ว่าจะเป็นการรับเงินดาวน์แทน',
  Cargo_CollectedExpenseDetails: 'รายละเอียดค่าธรรมเนียมที่เรียกเก็บ',
  Cargo_CollectedExpenseDetailsP: 'รายละเอียดค่าธรรมเนียมที่เรียกเก็บ:',
  Cargo_CollectedInFull: 'รวบรวมแล้ว',
  Cargo_CollectedNotCollectedInFull: 'เก็บ/ไม่เก็บ',
  Cargo_CollectFormation: 'ข้อมูลการรับเงิน',
  Cargo_CollectInvoice: 'การรับตั๋ว',
  Cargo_Collection: 'การเก็บรวบรวม',
  Cargo_CollectionCNY: 'การเก็บรวบรวม CNY',
  Cargo_CollectionDetails: 'รายละเอียดการเรียกเก็บค่าธรรมเนียม',
  Cargo_CollectionDifference: 'ความแตกต่างในการเรียกเก็บเงิน',
  Cargo_CollectionInformation: 'ข้อมูลการเรียกเก็บเงิน',
  Cargo_CollectionPayment: 'การรับชำระเงิน',
  Cargo_CollectionPaymentCleared: 'ชำระค่าสินค้าเรียบร้อยแล้ว',
  Cargo_CollectionPaymentDate: 'วันที่รับเงินและชำระเงิน',
  Cargo_CollectionPaymentInformation: 'ข้อมูลการรับชำระเงิน',
  Cargo_CollectionPaymentMethod: 'วิธีการรับชำระเงิน',
  Cargo_CollectionPaymentTypeFilter: 'การกรองประเภทการรับชำระเงิน',
  Cargo_CollectionRecordByCarrier: 'บันทึกการเก็บเงินของ บริษัท เรือ',
  Cargo_CollectionSituation: 'สถานการณ์การรับเงิน',
  Cargo_CollectionStatus: 'สถานะการเรียกเก็บเงิน',
  Cargo_CollectionUSD: 'การเรียกเก็บเงิน USD',
  Cargo_CoLoadConsol: 'LCL ที่ได้รับมอบหมาย',
  Cargo_ColorOfControllingRow: 'สีบรรทัดควบคุม',
  Cargo_CombinedInvoicing: 'รวมใบแจ้งหนี้',
  Cargo_CombinedListNo: 'และหมายเลขรายการตั๋ว',
  Cargo_Commission: 'คอมมิชชั่น',
  Cargo_CommissionAmount: 'จำนวนค่าคอมมิชชั่น',
  Cargo_CommissionedGrossWeight: 'น้ำหนักรวมที่ได้รับมอบหมาย',
  Cargo_CommissionItems: 'รายการคอมมิชชั่น',
  Cargo_CommissionOrNot: 'ไม่ว่าจะเป็นค่าคอมมิชชั่น',
  Cargo_CommissionPercentage: 'อัตราส่วนค่าคอมมิชชั่น',
  Cargo_CommissionRules: 'กฎค่าคอมมิชชั่น',
  Cargo_CommodityCode: 'รหัสสินค้า',
  Cargo_CommodityInspection: 'การตรวจสอบสินค้า',
  Cargo_CommonlyUsedTradeTerms: 'เงื่อนไขการค้าทั่วไป',
  Cargo_Company: 'บริษัท',
  Cargo_CompanySelfRelease: 'ใบสั่งซื้อจากบริษัท',
  Cargo_CompanySReceivingAccountNumber: 'หมายเลขบัญชีบริษัท',
  Cargo_CompanySReceivingBank: 'ธนาคารผู้รับเงิน',
  Cargo_Competitor: 'บริษัท คู่แข่ง',
  Cargo_Completed: 'เสร็จสิ้น',
  Cargo_CompleteDate: 'วันที่สิ้นสุด',
  Cargo_CompletedOrNot: 'ไม่ว่าจะเสร็จเรียบร้อยแล้ว',
  Cargo_CompleteWriteOff: 'ชำระเต็มจำนวน',
  Cargo_CompletionTime: 'เวลาเสร็จสิ้น',
  Cargo_ConditionOfSearch: 'เงื่อนไขการค้นหา',
  Cargo_ConditionType: 'ประเภทเงื่อนไข',
  Cargo_ConfiCNYill: 'ยืนยันการเรียกเก็บเงิน',
  Cargo_ConfigureAccountTitle: 'การตั้งค่าวิชา',
  Cargo_Confirm: 'ระบุ',
  Cargo_AMSEnsChannel: 'ต่อต้านการก่อการร้าย Manifold ENS ระบุซัพพลายเออร์',
  Cargo_SkipAll: 'ข้ามทั้งหมด',
  Cargo_SecondFlightSchedule: 'ช่วงเวลาเที่ยวบินที่สอง',
  Cargo_TwoWayFreighter: 'เครื่องบินขนส่งสินค้าสองทาง',
  Cargo_EmailFormatError: 'รูปแบบกล่องจดหมายผิดพลาด',
  Cargo_CountryOfShipment: 'ประเทศจัดส่ง',
  Cargo_AirFreightRateDetails: 'รายละเอียดค่าจัดส่งทางอากาศ',
  Cargo_ConfirmAndCheckSelectedRecord: 'ยืนยันบันทึกการเลือกตรวจสอบหรือไม่?',
  Cargo_ConfirmAP: 'ยืนยันค่าใช้จ่ายที่ต้องชำระ',
  Cargo_ConfirmCancellationOfRecord: 'แน่ใจที่จะลบประวัติ?',
  Cargo_ConfirmCombinedInvoice: 'การกำหนดใบแจ้งหนี้รวม',
  Cargo_ConfirmDate: 'วันที่ยืนยัน',
  Cargo_Confirmed: 'ได้รับการยืนยันแล้ว',
  Cargo_ConfirmedSuccessfully: 'ยืนยันความสำเร็จ',
  Cargo_ConfirmExpenses: 'การยืนยันค่าใช้จ่าย',
  Cargo_ConfirmNotification: 'ยืนยันการแจ้งเตือน',
  Cargo_ConfirmOffset: 'ยืนยันหมุดคู่',
  Cargo_ConfirmOrNot: 'ไม่ว่าจะเป็นการยืนยัน',
  Cargo_ConfirmPartial: 'ไม่ว่าจะเป็นการยืนยันบางส่วน',
  Cargo_ConfirmR: 'ยืนยัน',
  Cargo_ConfirmRQ: 'ยืนยัน?',
  Cargo_ConfirmRemarks: 'ยืนยันหมายเหตุ',
  Cargo_ConfirmSelectedItem: 'ยืนยันการเลือก',
  Cargo_ConfirmStatus: 'ยืนยันสถานะ',
  Cargo_ConfirmSubmissionOfPaymentOrder: 'แน่ใจในการยื่นหนังสือแจ้งการชำระเงิน?',
  Cargo_ConfirmWriteOff: 'การกำหนดบัญชีการขาย',
  Cargo_ConfirmWriteOffQ: 'ยืนยันการตัดบัญชี?',
  Cargo_ConfirmWrittenOffExpense: 'ยืนยันค่าธรรมเนียมการขายบัญชี',
  Cargo_ConflictExpenseDetails: 'รายละเอียดค่าใช้จ่ายความขัดแย้ง',
  Cargo_Consignation: 'การมอบหมาย',
  Cargo_ConsignationCompanyCannotBeNull: 'หน่วยที่ได้รับมอบหมายไม่สามารถว่างได้',
  Cargo_Consignee: 'ผู้รับสินค้า',
  Cargo_ConsigneeId: 'รหัสผู้รับ',
  Cargo_ConsigneeInfo: 'ข้อมูลผู้รับ',
  Cargo_ConsigneeSName: 'ชื่อผู้รับ',
  Cargo_ConsignorSCode: 'หน่วยงานหลัก (รหัส)',
  Cargo_ConsolidatedCNY: 'รวม (CNY)',
  Cargo_ConsolidatedCurrency: 'รวมสกุลเงิน',
  Cargo_ConsolidatedLocalCurrency: 'เหรียญมาตรฐานที่ครอบคลุม',
  Cargo_ConsolidatedLocalCurrencyCNY: 'สกุลเงินมาตรฐานที่ครอบคลุม (CNY)',
  Cargo_ConsolidatedProfitLossIs: 'กำไรและขาดทุนจากอัตราแลกเปลี่ยนคือ:',
  Cargo_ConsolidateOrNot: 'ไม่ว่าจะเป็นการควบรวมกิจการ',
  Cargo_Contact: 'ติดต่อ',
  Cargo_ContactNumber: 'เบอร์ติดต่อ',
  Cargo_ContainerAmount: 'ปริมาณกล่อง',
  Cargo_ContainerDescription: 'ปริมาณกล่อง ลักษณะ',
  Cargo_ContainerInfo: 'ข้อมูลการบรรจุ',
  Cargo_ContainerNo: 'หมายเลขกล่อง',
  Cargo_ContainerSize: 'ประเภทกล่อง',
  Cargo_ContainerType: 'ชนิดของกล่อง',
  Cargo_ContainerRule: 'ไม้บรรทัดกล่อง',
  Cargo_ContainerTypeCanTBeEmpty: 'ประเภทกล่องไม่สามารถว่างเปล่าได้',
  Cargo_ContainerTypeMaintenance: 'การบำรุงรักษาชนิดกล่อง',
  Cargo_ContainerTypeSea: 'ประเภทการสะกดทั้งหมด (ทางทะเล)',
  Cargo_ContentDescription: 'คำอธิบายเนื้อหา',
  Cargo_ContentFailedToLoad: 'การโหลดเนื้อหาล้มเหลว',
  Cargo_ContentFailedToLoadP: 'การโหลดเนื้อหาล้มเหลว:',
  Cargo_ContentOfAmount: 'จำนวนเงิน เนื้อหา',
  Cargo_ContentOfExpenseDescription: 'ชื่อค่าธรรมเนียม เนื้อหา',
  Cargo_ContentPreviewOfPaymentNotice: 'การแสดงตัวอย่างเนื้อหาการแจ้งเตือนการรับเข้า',
  Cargo_Continent: 'ทวีป',
  Cargo_ContinueToAddData: 'เพิ่มข้อมูลต่อไป',
  Cargo_ContinueToSave: 'เก็บต่อไป',
  Cargo_ContinuousFilter: 'การกรองอย่างต่อเนื่อง',
  Cargo_Contra: 'พินคู่',
  Cargo_ContraAmount: 'จำนวนพิน',
  Cargo_ContraAmountP: 'จำนวนพิน:',
  Cargo_ContraBalance: 'ยอดคงเหลือ PIN',
  Cargo_ContractAdministrator: 'ผู้ดูแลสัญญา',
  Cargo_ContractConfiguration: 'การกำหนดค่าสัญญา',
  Cargo_Contracted: 'ลงนามแล้ว',
  Cargo_ContractedClientInformation: 'ข้อมูลลูกค้า',
  Cargo_ContractExpired: 'สัญญาเป็นโมฆะ',
  Cargo_ContractNumber: 'หมายเลขสัญญา',
  Cargo_ContractNumberCanTBeEmpty: 'หมายเลขสัญญาไม่สามารถเว้นว่างได้',
  Cargo_ContractRateProperty: 'คุณสมบัติของราคาโดยประมาณ',
  Cargo_ContractSignedSuccessfully: 'ลายเซ็นสำเร็จ',
  Cargo_ContractStatus: 'สถานะสัญญา',
  Cargo_RiskReason: 'เหตุผลควบคุมความเสี่ยง',
  Cargo_ContractValidStatus: 'ไม่ว่าจะเป็นสัญญาที่ถูกต้อง',
  Cargo_ContractTerms: 'เงื่อนไขของสัญญา',
  Cargo_CurrentCredit: 'ปัจจุบัน Credit Control',
  Cargo_ContractCredit: 'การควบคุมเครดิตสัญญา',
  Cargo_ContractType: 'ประเภทของสัญญา',
  Cargo_ConversionAmountContent: 'เนื้อหาจำนวนเงิน',
  Cargo_ConversionAmountInCNY: 'คำนวณ CNY ทั้งหมด',
  Cargo_ConversionRMB: 'รวม RMB',
  Cargo_ConversionAP: 'เทียบเท่ากับการจ่าย',
  Cargo_ConversionAPCNY: 'จ่าย CNY',
  Cargo_ConversionPaidCNY: 'จ่าย CNY',
  Cargo_ConversionAPCurrency: 'เทียบเท่า {0} จ่าย',
  Cargo_ConversionAR: 'พับเก็บได้',
  Cargo_ConversionARCNY: 'พับ CNY ลูกหนี้',
  Cargo_ConversionReceivedCNY: 'พับ CNY ได้รับ',
  Cargo_ConversionARCurrency: 'ยอดคงเหลือ {0}',
  Cargo_ConversionCurrencyAmount: 'จำนวนสกุลเงิน',
  Cargo_ConversionOutstandingAR: 'พับเก็บไม่ได้',
  Cargo_ConversionOutstandingARCNY: 'พับ CNY ไม่ได้รับ',
  Cargo_ConversionOutstandingARCurrency: 'ยอด {0} ยังไม่ได้รับ',
  Cargo_ConversionOutstandingReceivedCurrency: 'พับ {0} ได้รับ',
  Cargo_ConversionProfit: 'กำไรที่เทียบเท่า',
  Cargo_ConversionProfitCNY: 'กำไร CNY',
  Cargo_ConversionProfitCNYP: 'กำไรเท่ากับ CNY:',
  Cargo_ConversionWriteOffAmountInCNY: 'ตัดบัญชี Rebate จำนวน CNY',
  Cargo_COPLOCP: 'Carryover กำไรและขาดทุนสำหรับงวดนี้',
  Cargo_Copy: 'คัดลอก',
  Cargo_CopyAndAddPoItems: 'คัดลอกใหม่',
  Cargo_CopyExchangeRate: 'คัดลอกอัตราแลกเปลี่ยน',
  Cargo_CopyFromExisting: 'สร้างใหม่ตามซองบัญชีที่มีอยู่',
  Cargo_InitializeLevelOneSubject: 'หลักสูตรเตรียมความพร้อมระดับหนึ่ง',
  Cargo_InitializeReport: 'รายการเริ่มต้น',
  Cargo_Cost: 'ค่าธรรมเนียม',
  Cargo_CostInvoiceNo: 'หมายเลขใบแจ้งหนี้ค่าใช้จ่าย',
  Cargo_CounterpartySBankAccount: 'หมายเลขบัญชีของอีกฝ่าย',
  Cargo_CounterpartySBillingNo: 'หมายเลขบิลของฝ่ายตรงข้าม',
  Cargo_Country: 'ประเทศ',
  Cargo_CountryMaintenance: 'การบำรุงรักษาแห่งชาติ',
  Cargo_CountryRegion: 'ประเทศ (ภูมิภาค)',
  Cargo_CountryRegionCode: 'รหัสประเทศ (ภูมิภาค)',
  Cargo_CourierOrderNo: 'หมายเลขเอกสารด่วน',
  Cargo_CPIOOPRCCTBV: 'ประวัติการชำระเงินที่ชำระแล้วในปัจจุบันได้รับการตรวจสอบแล้วและไม่สามารถเป็นโมฆะได้',
  Cargo_CPIOOPRVCTBM: 'ประวัติการชำระเงินที่ชำระแล้วในปัจจุบันเป็นโมฆะและไม่สามารถแก้ไขได้!',
  Cargo_CPIOOPRWOCTBV: 'ปัจจุบันบันทึกการชำระเงินที่เรียกชำระแล้วมีบันทึกการชำระหนี้แล้วและไม่สามารถเป็นโมฆะได้',
  Cargo_Create: 'สร้าง',
  Cargo_uploadErr: 'อัปโหลดล้มเหลว',
  Cargo_CreateAndExportDirectly: 'ส่งออกโดยตรงหลังจากสร้าง',
  Cargo_CreateBill: 'สร้างบิล',
  Cargo_BatchCreateBill: 'การสร้างบิลจำนวนมาก',
  Cargo_BatchCreateBillTitle: 'โปรดเลือกช่วงข้อมูล',
  Cargo_BatchCreateBillBySame: 'ค่าธรรมเนียมสำหรับวัตถุที่ชำระราคาเดียวกันจะสร้างใบเรียกเก็บเงิน',
  Cargo_BatchCreateBillByAll: 'บันทึกทั้งหมดที่พบ',
  Cargo_BatchCreateBillBySelected: 'บันทึกที่เลือก',
  Cargo_BatchCreateBillSuccess: 'ความสำเร็จในการดำเนินงาน: การสร้างบิลร่วม {0}',
  Cargo_CreateBillQ: 'ไม่ว่าจะเป็นการสร้างบิล',
  Cargo_CreateCombination: 'ผสานการสร้าง',
  Cargo_CreateCostInvoice: 'ไม่ว่าจะเป็นการสร้างใบแจ้งหนี้ค่าใช้จ่าย',
  Cargo_CreatedBy: 'ป้อนคน',
  Cargo_CreatedDate: 'วันที่สร้าง',
  Cargo_CreatedSuccessfully: 'สร้างเสร็จแล้ว!',
  Cargo_CreateInvoice: 'สร้างใบแจ้งหนี้',
  Cargo_CreateListOfCombinedInvoices: 'สร้างและรายการตั๋ว',
  Cargo_CreateOffsetExpense: 'สร้างค่าธรรมเนียมการป้องกันความเสี่ยง',
  Cargo_CreatePaymentRequest: 'สร้างใบคำขอชำระเงิน',
  Cargo_CreatePaymentRequestChooseFees: 'สร้างใบสมัครการชำระเงิน - เลือกค่าธรรมเนียม',
  Cargo_CreatePaymentRequestDetails: 'สร้างใบสมัครการชำระเงิน - รายละเอียด',
  Cargo_BasicPaymentRequest: 'คำขอชำระเงิน (แบบพื้นฐาน)',
  Cargo_PendingSupervisorApproval: 'รอการอนุมัติจาก主管',
  Cargo_PaymentRequestSettings: 'การตั้งค่าคำขอชำระเงิน',
  Cargo_EnableUICustomization: 'เปิดการแสดงผล UI แบบกำหนดเอง',
  Cargo_AdditionalApprovalNode: 'โหนดการอนุมัติเพิ่มเติม',
  Cargo_DepartmentApprovalTab: 'การอนุมัติ部門（แสดงแท็บรอการอนุมัติ部門）',
  Cargo_SupervisorApprovalTab: 'การอนุมัติ主管（แสดงแท็บรอการอนุมัติ主管）',
  Cargo_Settings: 'การตั้งค่า',
  Cargo_PendingDepartmentApproval: 'รอการอนุมัติจาก部門',
  Cargo_PreApproval: 'การตรวจสอบล่วงหน้า',
  Cargo_FinanceApproval: 'การตรวจสอบการเงิน',
  Cargo_OperationReview: 'การทบทวนการดำเนินงาน',
  Cargo_DepartmentReview: 'การทบทวนแผนก',
  Cargo_SupervisorReview: 'การตรวจสอบ主管',
  Cargo_RuleBasedApproval: 'เฉพาะเอกสารที่ตรงตามกฎจะเข้าสู่แท็บนี้เพื่อการอนุมัติเพิ่มเติม',
  Cargo_NonRuleBypass: 'อนุญาตให้เอกสารที่ไม่ตรงตามกฎเฉพาะข้ามการอนุมัติ主管ได้',
  Cargo_AllPaymentRequests: 'คำขอชำระเงิน (ทั้งหมด)',
  Cargo_SupervisorReviewer: 'ผู้ตรวจสอบ主管',
  Cargo_SupervisorReviewDate: 'วันที่ตรวจสอบ主管',
  Cargo_SettlementUnitContractStatus: 'สถานะสัญญาหน่วยชำระเงิน',
  Cargo_ReturnToPreviousApprovalNode: 'ส่งกลับโหนด ที่มีการอนุมัติสูงสุด หรือไม่',
  Cargo_CreateSoa: 'สร้างใบแจ้งยอด',
  Cargo_CreateVoucher: 'สร้างคูปอง',
  Cargo_Creator: 'สร้างโดย',
  Cargo_Credit: 'สินเชื่อ',
  Cargo_CreditAmount: 'ทั้งหมด credit',
  Cargo_CreditAmount2: 'จำนวนเงินกู้',
  Cargo_CreditAmountCNY: 'เครดิต (CNY)',
  Cargo_CreditAmountOccurred: 'ยอดเครดิตที่เกิดขึ้น',
  Cargo_CreditAmountOccurredCNY: 'การเกิดขึ้นของเงินกู้ (CNY)',
  Cargo_CreditAmountOccurredP: 'เครดิตที่เกิดขึ้น:',
  Cargo_CreditAmountOccurredUSD: 'ยอดเครดิตที่เกิดขึ้น (USD)',
  Cargo_CreditAmountTo: 'เครดิตรวม',
  Cargo_CreditAmountToP: 'เครดิตรวม:',
  Cargo_CreditAmountUSD: 'เครดิต (USD)',
  Cargo_CreditControlDetails: 'รายละเอียดการควบคุมเครดิต',
  Cargo_CreditControlSettings: 'การตั้งค่า Credit',
  Cargo_CreditLimitExceeded: 'วงเงินที่เกิน',
  Cargo_CreditLimitRange: 'ช่วงวงเงิน',
  Cargo_CreditLocalCurrency: 'สกุลเงินท้องถิ่นเครดิต',
  Cargo_CreditNotWrittenOff: 'เครดิต Unpin',
  Cargo_CreditOriginalAmount: 'เครดิต จำนวนเงินเดิม',
  Cargo_CreditSide: 'เครดิต',
  Cargo_CreditUsed: 'วงเงินที่ใช้แล้ว',
  Cargo_CreditWriteOffAmount: 'ยอดชำระหนี้เครดิต',
  Cargo_CREVB5TM: 'C. การส่งออกมีเสถียรภาพภายใน 5TEU ต่อเดือน',
  Cargo_CRPI: 'แน่ใจนะว่าต้องการจะลงทะเบียนล่วงหน้า',
  Cargo_CSNPM: 'บริการรับ-ส่งข้อมูลการบำรุงรักษา',
  Cargo_CSR: 'ผู้ประกอบการ',
  Cargo_CSRGTIDDDI: 'ผลลัพธ์ของการสืบค้นในปัจจุบันมีมากกว่าจำนวนแถบแสดงผลและข้อมูลที่แสดงไม่สมบูรณ์',
  Cargo_CSWTCSTR: 'ลูกค้ารายนี้ได้ทำสัญญาและเลือกลูกค้ารายนี้เพื่อต่ออายุ',
  Cargo_CTMCWOPCCF: 'ตัดบัญชีที่ตรวจสอบแล้วไม่สามารถแก้ไขได้ ขอให้ยกเลิกการตรวจสอบก่อน',
  Cargo_CTOPR: 'แน่ใจในการโอนเข้าลงทะเบียนแบบเติมเงิน?',
  Cargo_CTORI: 'กำหนดโอนกลับไปสู่การปรองดองหรือไม่',
  Cargo_CTRCWOPCCF: 'ตัดบัญชีที่ตรวจสอบแล้วไม่สามารถเพิกถอนได้ขอให้ยกเลิกการตรวจสอบก่อน',
  Cargo_CTRLSPFCC: 'ไม่ว่าจะเป็นการยืนยันการปลดล็อกการขายที่ลูกค้าผูกไว้',
  Cargo_Cubage: 'ปริมาณ',
  Cargo_Currency: 'สกุลเงิน',
  Cargo_CurrencyCanTBeEmpty: 'สกุลเงินไม่สามารถว่างได้',
  Cargo_CurrencyFXRateNoMaintained: 'อัตราแลกเปลี่ยนของสกุลเงิน 【{0}】 ไม่มีการบำรุงรักษา!',
  Cargo_CurrencyInconsistent: 'ค่าเงินไม่สอดคล้องกัน',
  Cargo_CurrencyMaintenance: 'การบำรุงรักษาสกุลเงิน',
  Cargo_CurrencyOfPayment: 'สกุลเงินการชำระเงิน',
  Cargo_CurrencyOfTotal: 'สกุลเงินรวม',
  Cargo_CurrencyP: 'สกุลเงิน:',
  Cargo_CurrentClientIsContracted: 'ลูกค้าปัจจุบันได้ลงนามแล้ว',
  Cargo_CurrentExchangeRate: 'อัตราแลกเปลี่ยนปัจจุบัน',
  Cargo_CurrentLoginUser: 'เข้าสู่ระบบปัจจุบัน',
  Cargo_CurrentMonth: 'เดือนปัจจุบัน',
  Cargo_CurrentSelected: 'เลือกปัจจุบัน',
  Cargo_Reefer: 'Reefer',
  Cargo_ShowCharacteristics: 'แสดงลักษณะของสินค้า',
  Cargo_ShowCharacteristicsTip: 'เมื่อเลือกประเภทสินค้าปัจจุบัน ให้แสดงช่องทำเครื่องหมาย "Live" "With Magnetic" "Liquid" "Powder" เพิ่มเติมที่หน้าหลัก',
  Electric: 'ไฟฟ้า',
  Magnetic: 'ด้วยแม่เหล็ก',
  Powder: 'ผง',
  Liquid: 'ของเหลว',
  Cargo_CurrentSelectedExpense: 'ค่าธรรมเนียมที่เลือกในปัจจุบัน {0}',
  Cargo_CurrentSelectedSobIs: 'Socket Currently selected คือ: {0}',
  Cargo_CurrentSettlingParty: 'วัตถุการตั้งถิ่นฐานปัจจุบัน',
  Cargo_CurrentWriteOffSerialNoCompleted: 'หมายเลขกระแสรายวันของบัญชีที่ถูกตัดออกนี้คือ {0}',
  Cargo_CurrentYearAccumulatedAmount: 'ยอดสะสมตลอดปี',
  Cargo_CurrentYearProfitAccount: 'รายวิชากำไรสำหรับปี',
  Cargo_CurrentYearProfitAccountP: 'วิชากำไรสำหรับปี:',
  Cargo_CurrentYearTotal: 'สะสมตลอดทั้งปี',
  Cargo_CurrentYearTotalAmout: 'ยอดสะสมที่เกิดขึ้นในปีนี้',
  Cargo_CurrentYearTotalAmoutCreditCNY: 'เครดิตสะสมที่เกิดขึ้นในปีนี้ (CNY)',
  Cargo_CurrentYearTotalAmoutCreditUSD: 'เครดิตสะสมที่เกิดขึ้นระหว่างปี (USD)',
  Cargo_CurrentYearTotalAmoutDebitCNY: 'ยอดเดบิตสะสมในรอบปี (CNY)',
  Cargo_CurrentYearTotalAmoutDebitUSD: 'ยอดเดบิตสะสมในรอบปี (ดอลลาร์สหรัฐ)',
  Cargo_CursorPointedInvoiceNo: 'เคอร์เซอร์ค้นหาหมายเลขใบแจ้งหนี้',
  Cargo_Customer: 'ลูกค้า',
  Cargo_CustomerAddress: 'ที่อยู่ของลูกค้า',
  Cargo_CustomerHasConfirm: 'หมายเลข {0} ลูกค้ายืนยันแล้ว',
  Cargo_CustomerLevel: 'ระดับลูกค้า',
  Cargo_CustomerName: 'ชื่อลูกค้า',
  Cargo_CustomerP: 'ลูกค้า:',
  Cargo_CustomerProperty: 'คุณสมบัติของลูกค้า',
  Cargo_CustomerReferenceNumber: 'หมายเลขอ้างอิงของลูกค้า',
  Cargo_CustomerSelfRelease: 'ใบสั่งซื้อจากลูกค้าเอง',
  Cargo_CustomerService: 'ฝ่ายบริการลูกค้า',
  Cargo_CustomerSpace2: 'สินค้าระบุ',
  Cargo_CustomerSpace3: 'แพคเกจด้วยตนเอง',
  Cargo_CustomerType: 'ประเภทลูกค้า',
  Cargo_Customized: 'การปรับแต่ง',
  Cargo_CustomizedField1: 'ฟิลด์ที่กำหนดเอง 1',
  Cargo_CustomizedField2: 'ฟิลด์ที่กำหนดเอง 2',
  Cargo_CustomizedField3: 'ฟิลด์ที่กำหนดเอง 3',
  Cargo_CustomizedField4: 'ฟิลด์ที่กำหนดเอง 4',
  Cargo_CustomJobType: 'ประเภทธุรกิจที่กำหนดเอง',
  Cargo_CustomJobTypeP: 'ประเภทธุรกิจที่กำหนดเอง',
  Cargo_CustomsApproval: 'การอนุมัติศุลกากร',
  Cargo_CustomsBroker: 'ตัวแทนออกของ',
  Cargo_CustomsBrokerFilter: 'กรองบรรทัดประกาศศุลกากร',
  Cargo_CustomsDeclaration: 'ประกาศศุลกากร',
  Cargo_CustomsDeclarationSearchFailed: 'การสอบถามข้อมูลการประกาศศุลกากรล้มเหลว:',
  Cargo_CustomsNo: 'หมายเลขศุลกากร',
  Cargo_CWOIFCTTTEPRCOEA: 'การเรียกเก็บเงินจะถูกตัดออกหมดแล้วและไม่สามารถโอนเป็นค่าธรรมเนียมได้อีกโปรดทำเอกสารการเรียกเก็บเงินหรือค่าธรรมเนียมเพิ่มเติม',
  Cargo_CYCutOffDate: 'วันที่ปิดรับสมัคร',
  Cargo_CYSPATIPLVCTBE: 'ใบกำกับกำไรขาดทุน รายวิชากำไรสำหรับปีนี้ไม่สามารถเว้นว่างได้',
  Cargo_CYWRYTTPPATDWBMTRS: 'คลิก ใช่ จะข้ามไปยังหน้าพิมพ์และแก้ไขสถานะเอกสารเป็น "คืนแล้ว"',
  Cargo_CYWRYTTPPATRDWBCTRS: 'คลิก "ใช่" เพื่อข้ามไปยังหน้าพิมพ์และเอกสารที่ได้รับคืนจะเปลี่ยนเป็นสถานะ "คืนเงิน"',
  Cargo_DAIIUCTBD: '【การปรับส่วนต่าง】 ถูกใช้ในเชิงพาณิชย์และไม่สามารถลบออกได้',
  Cargo_DAIOCPCNY: 'เดบิตที่เกิดขึ้นในงวดนี้ (CNY)',
  Cargo_DAIOCPUSD: 'เดบิตที่เกิดขึ้นในงวดนี้ (ดอลลาร์สหรัฐ)',
  Cargo_DataExport: 'ส่งออก',
  Cargo_DataExportPDF: 'ส่งออกไฟล์ PDF',
  Cargo_DataSent: 'ข้อมูลที่ส่งแล้ว',
  Cargo_DataTransmissionStatus: 'สถานะการส่งข้อมูล',
  Cargo_DataType: 'ประเภทข้อมูล',
  Cargo_DataTypeP: 'ประเภทข้อมูล:',
  Cargo_Date: 'วันที่',
  Cargo_DateCanTBeEmpty: 'วันที่ไม่สามารถว่างได้',
  Cargo_DateFrom: 'วันที่เริ่มต้น',
  Cargo_DateFunction: 'ฟังก์ชันวันที่',
  Cargo_DateNotInPeriod: 'วันที่ไม่อยู่ในช่วงเวลา',
  Cargo_DateOfApplication: 'วันที่สมัคร',
  Cargo_DateOfCollectionCanTBeEmpty: 'วันที่รับเงินไม่สามารถว่างได้',
  Cargo_DateOfDeclaration: 'วันที่ประกาศ',
  Cargo_DateOfDepartureCannotBeNull: 'วันที่ออกเดินทางไม่สามารถว่างได้',
  Cargo_DateOfDocument: 'วันที่สั่งซื้อ',
  Cargo_DateOfInvoicingList: 'วันที่ออกใบแจ้งหนี้',
  Cargo_DateP: 'วันที่:',
  Cargo_DateType: 'ประเภทวันที่',
  Cargo_DateType2: 'ประเภทวันที่ 2',
  Cargo_Days: 'วัน',
  Cargo_DaysFromContractSigned: 'วันที่เซ็น',
  Cargo_DaysOfSleep: 'จำนวนวันที่หลับใหล',
  Cargo_DaysOverdue: 'วันที่ค้างชำระ',
  Cargo_DaysToContractExpiry: 'วันที่กำลังจะหมดอายุ',
  Cargo_DBASBEICS: 'หมายเลขบัญชีธนาคารจะต้องว่างเป็นค่าเริ่มต้นเมื่อเลือกเงินสด',
  Cargo_Deadline: 'วันปิดสมุดทะเบียน',
  Cargo_TempCredit: 'การควบคุมจดหมายชั่วคราว',
  Cargo_EtdDays: 'จำนวนวันEstimated Time of Departure (ETD)',
  Cargo_EtdExceedsDays: 'ETD เกิน {0} วัน ไม่สามารถปล่อยเลขที่ได้',
  Cargo_EtdExceedsDaysOrder: 'ETD เกิน {0} วัน ไม่สามารถปล่อยเอกสาร (ใบตราส่งสินค้า) ได้',
  Cargo_ShippingDocumentsNotBeReleased: 'เอกสารการจัดส่งจะไม่ถูกปล่อย จนกว่าค่าใช้จ่ายด้านการขนส่งที่ค้างชำระทั้งหมดจะได้รับการชำระ',
  Cargo_SpecialFeePaymentLimit: 'ข้อจำกัดในการขอชำระเงินค่าใช้จ่ายเฉพาะด้าน',
  Cargo_PaymentOnlySpecificCosts: 'การขอชำระเงินค่าใช้จ่ายเฉพาะด้าน ต้องขอชำระเฉพาะค่าใช้จ่ายนั้นเท่านั้น ห้ามมีค่าใช้จ่ายอื่นปน',
  Cargo_ThePaymentNotSettled: 'การชำระเงินสำหรับเดือน {0} ยังไม่ได้ชำระให้เสร็จสิ้น',
  Cargo_UnconfirmedSum: '{0}+{1}+{2}+{3} ยังไม่ได้รับการยืนยัน กรุณายืนยันก่อน!',
  Cargo_SpecialApproval2: 'การอนุมัติพิเศษ',
  Application_Item: 'เรื่องที่ขอ申請',
  Application_Content: 'เนื้อหาการขอ申請',
  Application_Reason: 'เหตุผลในการขอ申請',
  Cargo_DomesticOverseas: 'ในประเทศ/ต่างประเทศ',
  Cargo_IncludeOverseasWarehouse: 'รวมคลังสินค้าต่างประเทศ',
  Cargo_SignContract2: 'ลงนามสัญญา',
  Cargo_LatestContractDate: 'วันที่ลงนามสัญญาล่าสุด',
  Cargo_CreditControlSelfAssessment: 'แบบฟอร์มประเมินตนเองวงเงินสินเชื่อ',
  Cargo_CustomerFile: 'แฟ้มลูกค้า',
  Cargo_CustomerConsignmentNote: 'ใบฝากส่งลูกค้า',
  Cargo_HasContract: 'มีสัญญา',
  Cargo_NoContract: 'ไม่มีสัญญา',
  Cargo_ContractStatus2: 'มีหรือไม่มีสัญญา',
  Cargo_SupplierFile: 'แฟ้มซัพพลายเออร์',
  Cargo_ApprovalSummary: 'สรุปเนื้อหาการอนุมัติ',
  Cargo_AlreadyExistsCannotSubmit: '{0} มีอยู่แล้ว ไม่สามารถส่งคำขอได้!',
  Action_AddAttachment: 'เพิ่มไฟล์แนบ',
  Validation_ApplicationContentRequired: 'กรุณากรอกเนื้อหาการขอ申請',
  Validation_ApplicationReasonRequired: 'กรุณาระบุเหตุผลในการขอ申請',
  Cargo_AutoReceivablesWriteOff: 'ตัดชำระหนี้สินค้างรับอัตโนมัติ',
  Cargo_WhetherIgnore: 'ไม่ว่าจะเป็นการละเลย',
  Cargo_TempCreditNotBeCross: 'วันหมดอายุเครดิตชั่วคราวไม่สามารถมีอินเตอร์เซกได้',
  Cargo_TempCreditNotice: 'หมายเหตุ: วงเงิน / หน่วยของรอบระยะเวลาบัญชี (Temporary Credit Control) ของสัญญาเดียวกัน (มีผลวันถัดไป)',
  Cargo_CurrentCreditNotice: 'หมายเหตุ: ระยะเวลาบัญชี / วงเงินที่ปฏิบัติตามเงื่อนไขภายใต้เวลาปัจจุบันและ CTC ที่ได้รับการบำรุงรักษาในวันเดียวกันจะถูกซิงค์กับคู่ค้าในวันถัดไป',
  Cargo_CurrentAvailableNotEntered: 'ไม่ได้ป้อนจำนวนที่ใช้ได้ในปัจจุบัน',
  Cargo_Debit: 'ยืม',
  Cargo_DebitAmount: 'ทั้งหมด debit',
  Cargo_DebitAmount2: 'ยอดเดบิต',
  Cargo_DebitAmountCNY: 'จำนวนเดบิต (CNY)',
  Cargo_DebitAmountOccurred: 'ยอดเดบิต',
  Cargo_DebitAmountOccurredCNY: 'ยอดเดบิต (CNY)',
  Cargo_DebitAmountOccurredP: 'เดบิตที่เกิดขึ้น:',
  Cargo_DebitAmountOccurredUSD: 'ยอดเดบิต (USD)',
  Cargo_DebitAmountTo: 'รวม Debit',
  Cargo_DebitAmountToP: 'รวม Debit:',
  Cargo_DebitAmountUSD: 'จำนวนเดบิต (USD)',
  Cargo_DebitLocalCurrency: 'เดบิตคอยน์',
  Cargo_DebitNotWrittenOff: 'debit ไม่มีขาย',
  Cargo_DebitOriginalAmount: 'จำนวนเงินเดิม Debit',
  Cargo_DebitSide: 'เดบิต',
  Cargo_DebitSideCNY: 'เดบิต (CNY)',
  Cargo_DebitSideCreditSide: 'เดบิต / เครดิต',
  Cargo_DebitSideCreditSideP: 'เดบิต / เครดิต:',
  Cargo_DebitSideUSD: 'เดบิต (USD)',
  Cargo_DebitWriteOffAmount: 'ยอดชำระหนี้ Debit',
  Cargo_December: 'ธันวาคม',
  Cargo_DeclareWarehouseLoadingContainer: 'ไม่ว่าจะเป็นคลังสินค้าที่บรรจุในกล่องประกาศศุลกากร',
  Cargo_DeemedPrinted: 'พิมพ์ View',
  Cargo_VGMLog: 'บันทึก VGM',
  Cargo_SendVGM: 'ส่ง VGM',
  Cargo_VGMChannel: 'ช่อง VGM',
  Cargo_VGMBasicInfo: 'ข้อมูลพื้นฐานของ VGM',
  Cargo_FriendlyReminder: 'เคล็ดลับที่อบอุ่น: สะกดเพิ่มเติมโปรดกรอกหมายเลขหลัก',
  Cargo_VGMCutOffDate: 'ส่วนวันที่ VGM',
  Cargo_ContainerHolder: 'ผู้ถือกล่อง',
  Cargo_NotFilledIn: 'ยังไม่ได้กรอกข้อมูลให้ส่งเมื่อกรอกข้อมูลเสร็จสมบูรณ์',
  Cargo_NotSelected: 'ยังไม่มีการเลือก กรุณาส่งเมื่อกรอกข้อมูลเรียบร้อยแล้ว',
  Cargo_PleaseMaintainCargoInfo: 'กรุณารักษาข้อมูลการจัดส่งกล่อง',
  Cargo_IfYouHaveSentPreStowageManifest: 'หากคุณได้ส่งรายการล่วงหน้าผ่านช่องทาง Sea Butler ข้อมูลจะถูกซิงค์จากหน้าข้อมูลล่วงหน้า',
  Cargo_IfYouHaveNotSentPreStowageManifest: 'หากไม่ได้ส่งรายการล่วงหน้าผ่านช่องทางแม่บ้านทะเล ข้อมูลจะถูกซิงโครไนซ์จากพื้นฐาน หน้าจองห้องโดยสาร',
  Cargo_FriendlyReminderWithPort: 'เคล็ดลับที่อบอุ่น: ท่าเรือเซี่ยงไฮ้ขอแนะนำให้คุณส่งข้อความ VGM หลังจากเสร็จสิ้นการป้อนข้อมูลล่วงหน้าเรือต่อเรือขนาดใหญ่ขึ้นอยู่กับเวลาเรือ',
  Cargo_TerminalInfoForReferenceOnly: 'ข้อมูลท่าเทียบเรือเป็นเพียงข้อมูลอ้างอิงเท่านั้นโปรดระบุพอร์ตการจอง!',
  Cargo_TerminalInfoForReferenceWse: 'หากข้อมูลท่าเรือฟักสั่งซื้อไม่ตรงกับข้อมูลท่าเรืออ้างอิงของเราโปรดติดต่อฝ่ายบริการลูกค้าขอบคุณ!',
  Cargo_IfBookingPortTerminalInfoDoesNotMatchPleaseContactCustomerService: 'หากข้อมูลการจองท่าเรือฟักไม่ตรงกับข้อมูลท่าเรืออ้างอิงของเราโปรดติดต่อฝ่ายบริการลูกค้า',
  Cargo_FriendlyReminderWithCutOffTime: 'เคล็ดลับที่อบอุ่น: โปรดกรอกเวลาที่ตัดตอนถูกต้องเราจะส่งหลายครั้งตามวันที่นี้หากค่าโหลดล่าช้าเนื่องจากข้อผิดพลาดของข้อมูลแพลตฟอร์มจะไม่รับผิดชอบ',
  Cargo_TheShipperDeclares: 'Bento Shipping ประกาศ: กรมข้อมูลน้ำหนักของภาชนะบรรจุที่มีอยู่ในเอกสารนี้ได้รับตามวิธีการที่อธิบายไว้ในอนุสัญญาระหว่างประเทศว่าด้วยความปลอดภัยของชีวิตทางทะเล 1974 ระบุว่าตัวชี้วัดของความสำคัญได้รับใบรับรองการตรวจสอบมาตรวิทยาที่ออกโดยสถาบันเทคโนโลยีมาตรวิทยาและวันที่ได้รับน้ำหนักอยู่ในขอบเขตที่ถูกต้องของใบรับรอง',
  Cargo_RepeatedlySendingVGMWithTheSameContainerTips: 'หมายเลขกล่องเดียวกัน ส่งซ้ำ VGM จะถูกเรียกเก็บเงินหลายครั้งสำหรับการส่งอีกครั้งโปรด {0}S โพสต์ส่ง',
  Cargo_Send_VGM_Reminder: 'แต่ละหมายเลขกล่องส่ง VGM จะหักค่าธรรมเนียมหนึ่งครั้งหมายเลขกล่องเดียวกันส่งหลายครั้งจะหักค่าธรรมเนียมซ้ำ เช่นการแก้ไขข้อมูล VGM เพียงส่งข้อมูล VGM ของกล่องที่แก้ไข </ br > กรุณายืนยันว่าจะส่งต่อหรือไม่',
  Cargo_ContinueSending: 'ส่งต่อไป',
  Cargo_ResendAfterS: 'ส่งอีกครั้งหลังจาก s',
  Cargo_ExternalAssociationCode: 'รหัสพันธมิตรภายนอก',
  Cargo_ExternalAssociationCodeValidMessage: 'รหัสพันธมิตรภายนอกสามารถเป็นตัวอักษรหรือตัวเลขเท่านั้น',
  Cargo_ShippingCompanyReceiptStatus: 'สถานะการตอบกลับของ บริษัท เรือ',
  Cargo_DeparturePortFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: 'ฟิลด์พอร์ตการจัดส่งไม่พบข้อมูลที่ตรงกับ Sea Butler โปรดตรวจสอบ',
  Cargo_ShippingCompanyFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: 'ไม่พบข้อมูลที่ตรงกับ Sea Butler ในฟิลด์ บริษัท เรือโปรดทำเครื่องหมาย',
  Cargo_CharLengthWithRange: 'ความยาวใน {0} ถึง {1} ตัวอักษร',
  Cargo_TheBoxNumberMustBe: 'หมายเลขกล่องต้องเป็นตัวอักษร 4 หลัก + ตัวเลข 7 หลัก',
  Cargo_LoadWharfTips: 'ข้อมูลท่าเทียบเรือเป็นเพียงข้อมูลอ้างอิงเท่านั้นโปรดระบุพอร์ตการจอง! หากข้อมูลท่าเรือฟักสั่งซื้อไม่ตรงกับข้อมูลท่าเรืออ้างอิงของเราโปรดติดต่อฝ่ายบริการลูกค้าขอบคุณ!',
  Cargo_WhetherToContinueSendingVGM: 'จะส่ง VGM ต่อไปหรือไม่',
  Cargo_Default: 'ปริยาย',
  Cargo_DefaultAPUnitPrice: 'ราคาต่อหน่วยจ่ายตามค่าเริ่มต้น',
  Cargo_DefaultARCurrency: 'สกุลเงินที่รับค่าเริ่มต้น',
  Cargo_DefaultAPCurrency: 'สกุลเงินเจ้ามือปริยาย',
  Cargo_DefaultARUnitPrice: 'ราคาต่อหน่วยปริยาย',
  Cargo_DefaultDecimalPlaces: 'ทศนิยมปริยาย',
  Cargo_DefaultLine: 'บรรทัดปริยาย',
  Cargo_DefaultMenuItems: 'รายการเมนูปริยาย',
  Cargo_DefaultOrNot: 'ปริยายหรือไม่',
  Cargo_DefaultPayee: 'วัตถุเจ้ามือปริยาย',
  Cargo_DefaultPayer: 'วัตถุที่รับโดยปริยาย',
  Cargo_DefaultSearchCondition: 'เงื่อนไขการค้นหาปริยาย',
  Cargo_DefaultValue: 'ค่าปริยาย',
  Cargo_SeDefaultValue: 'SeaOut ค่าเริ่มต้น',
  Cargo_SiDefaultValue: 'Haijin ปริยาย',
  Cargo_AeDfaultValue: 'ว่างเปล่าปริยาย',
  Cargo_AiDfaultValue: 'ว่างเปล่า ค่าปริยาย',
  Cargo_ReDfaultValue: 'เหล็กออกจากค่าเริ่มต้น',
  Cargo_RiDfaultValue: 'ค่าปริยายของเหล็ก',
  Cargo_EditDefaultValue: 'แก้ไขค่าปริยาย',
  Cargo_EditJobDefaultValueTip: `หากค่าเริ่มต้นของแต่ละประเภทธุรกิจแตกต่างกันโปรดรักษาไว้ในกล่องข้อความประเภทธุรกิจที่สอดคล้องกัน
เช่นกล่องข้อความประเภทธุรกิจและค่าเริ่มต้นทั้งสองรักษาค่าให้ความสำคัญตามประเภทธุรกิจเพื่อใช้ค่ากล่องข้อความประเภทธุรกิจที่สอดคล้องกัน；`,
  Cargo_DefaultWriteOffCurrency: 'สกุลเงินตัดบัญชีปริยาย',
  Cargo_DelayedTaxRefund: 'เป็นการคืนภาษีล่าช้า',
  Cargo_DelegationTypeRailway: 'ประเภทค่าคอมมิชชั่น (รถไฟ)',
  Cargo_Delete: 'ลบ',
  Cargo_DeleteConfirmation: 'คุณแน่ใจว่าต้องการลบระเบียนที่เลือกหรือไม่?',
  Cargo_DeleteBill: 'ลบบิล',
  Cargo_DisplayRules: 'แสดงกฎ',
  Cargo_ViewAttachments: 'ดูอุปกรณ์เสริม',
  Cargo_DeleteCollectionRecord: 'ลบการลงทะเบียนการเรียกเก็บเงิน',
  Cargo_DeletedBillList: 'รายการบิลที่ถูกลบ',
  Cargo_DeletedSuccessfully: 'ลบสำเร็จ',
  Cargo_WithdrawSuccessfully: 'การถอนเงินสำเร็จ',
  Cargo_DeletedNotHavePermission: 'คุณไม่มีสิทธิ์ลบใบเสนอราคานี้',
  Cargo_DeletedNotIntoBusiness: 'ใบเสนอราคาถูกนำเข้ามาในค่าใช้จ่ายของธุรกิจและไม่สามารถลบได้!',
  Cargo_DeleteEntry: 'ลบรายการ',
  Cargo_DeleteFailed: 'การลบล้มเหลว',
  Cargo_DeleteFee: 'ค่าธรรมเนียมการลบ',
  Cargo_DeleteFeeConfirmedListSync: 'ลบใบยืนยันการเรียกเก็บเงินพร้อมกัน',
  Cargo_DeleteInvoice: 'ลบใบแจ้งหนี้',
  Cargo_DeleteNotification: 'เคล็ดลับการลบ',
  Cargo_DeleteOrNot: 'ลบ?',
  Cargo_DeleteVoucher: 'ลบบัตรกำนัล',
  Cargo_Delivered: 'ส่งแล้ว',
  Cargo_DeliveredButNotRetrieved: 'ส่งแล้ว (ไม่รับคืน)',
  Cargo_DeliveredSuccessfully: 'ส่งประสบความสำเร็จ',
  Cargo_DeliveredToBranch: 'ไม่ว่าจะเป็นการส่งบริษัทมากเกินไป',
  Cargo_DeliverPartial: 'ไม่ว่าจะเป็นการส่งบางส่วน',
  Cargo_DeliverySigned: 'ลงชื่อแล้ว',
  Cargo_DenialReason: 'เหตุผลในการปฏิเสธ',
  Cargo_DenialReasonP: 'เหตุผลในการปฏิเสธ:',
  Cargo_Denied: 'ถูกปฏิเสธ',
  Cargo_DeniedSuccessfully: 'ปฏิเสธความสำเร็จ',
  Cargo_DenyApplication: 'ปฏิเสธการสมัคร',
  Cargo_DenyPaymentApplication: 'คำขอปฏิเสธการชำระเงิน',
  Cargo_Department: 'แผนก',
  Cargo_DepartmentApproval: 'การอนุมัติหน่วยงาน',
  Cargo_DepartmentP: 'แผนก:',
  Cargo_DepartureTime: 'เวลาออกเรือ',
  Cargo_DepositBank: 'เปิดบัญชีธนาคาร',
  Cargo_DepositBankAccountNo: 'เปิดบัญชี เลขที่บัญชีธนาคาร',
  Cargo_DepositBankAndAccountNo: 'เปิดบัญชี LINE และเลขที่บัญชี',
  Cargo_DepositBankAndAccountNoP: 'หมายเลขบัญชี:',
  Cargo_DesCharge: 'ค่าธรรมเนียมปลายทาง',
  Cargo_DescriptionCanTBeEmpty: 'คำอธิบายเนื้อหาต้องไม่ว่างเปล่า',
  Cargo_DescriptionOfCharge: 'เนื้อหาค่าธรรมเนียม',
  Cargo_DescriptionOfExpenseItem: 'ชื่อรายการค่าธรรมเนียม',
  Cargo_DescriptionOfExpenseItemCNY: 'ชื่อรายการ ค่าธรรมเนียม CNY',
  Cargo_DescriptionOfExpenseItemUSD: 'ค่าธรรมเนียม USD ชื่อรายการ',
  Cargo_DescriptionOfExpenseItemJPY: 'ค่าธรรมเนียม JPY ชื่อรายการ',
  Cargo_DescriptionOfExpenseItemEUR: 'EUR ค่าธรรมเนียม ชื่อรายการ',
  Cargo_DescriptionOfPlan: 'คำอธิบายโครงการ',
  Cargo_DescriptionOfQuantity: 'เนื้อหาปริมาณ',
  Cargo_DescriptionOfVoucherType: 'ประเภทของบัตรกำนัล คำอธิบาย',
  Cargo_DesignatedDepartment: 'แผนกที่กำหนด',
  Cargo_DesignSubTitlesOfAccount: 'การออกแบบวิชาย่อย',
  Cargo_Destination: 'จุดหมายปลายทาง',
  Cargo_ChargeItemMaintenance: 'ค่าบำรุงรักษาโครงการ',
  Cargo_ZeroTaxRate: 'ไม่ว่าจะเป็นการเก็บภาษีเป็นศูนย์',
  Cargo_DestinationAgent: 'ตัวแทนท่าเรือปลายทาง',
  Cargo_DestinationAgent1: 'ตัวแทนในต่างประเทศ',
  Cargo_DestinationChargeOrNot: 'ไม่ว่าจะเป็นค่าใช้จ่ายปลายทาง',
  Cargo_DestinationPort: 'ท่าเรือปลายทาง',
  Cargo_DestinationPortSea: 'ท่าเรือปลายทาง (ทางทะเล)',
  Cargo_DestinationPortAir: 'พอร์ตปลายทาง (ทางอากาศ)',
  Cargo_OverseaWarehouse: 'คลังสินค้าต่างประเทศ',
  Cargo_NoRestriction: 'ไม่จำกัด',
  Cargo_Details: 'รายละเอียดและรายละเอียด',
  Cargo_DetailsOfOutOfPocketRecord: 'รายละเอียดการลงทะเบียนจ่ายจริง',
  Cargo_DetailsOfSingleWriteOff: 'รายละเอียดบัญชีแยกรายการเดียว',
  Cargo_DetailsOfSingleWriteOffPDF: 'รายละเอียดบัญชีแยกรายการเดียว.pdf',
  Cargo_DetailsOfSingleWriteOffXLS: 'รายละเอียดบัญชีแยกรายการเดียว .xls',
  Cargo_DevelopedAtExhibitions: 'การพัฒนานิทรรศการ',
  Cargo_Difference: 'ความแตกต่าง',
  Cargo_DifferenceAdjustment: 'การปรับส่วนต่าง',
  Cargo_DifferenceCNYCNY: 'ความแตกต่าง CNY',
  Cargo_DifferenceUSD: 'ความแตกต่าง USD',
  Cargo_DifferentialAdjustedSuccessfully: 'การปรับส่วนต่างประสบความสำเร็จ',
  Cargo_DifferentialIs: 'ความแตกต่างคือ: {0}',
  Cargo_DifferentialProcessing: 'การจัดการความแตกต่าง',
  Cargo_DifficultyIndex: 'ดัชนีความยากในการพิชิต',
  Cargo_DIITRLNLTSIT: 'การแสดงรายการด้านขวาไม่เกี่ยวข้องกับประเภทใบแจ้งหนี้ที่เลือก',
  Cargo_DirectAssign: 'จัดสรรโดยตรง',
  Cargo_DirectBusiness: 'เดี่ยวตรง',
  Cargo_DirectConsol: 'LCL ด้วยตนเอง',
  Cargo_DirectConsolContainerNo: 'จำนวน LCL ด้วยตนเอง',
  Cargo_Direction: 'ทิศทาง',
  Cargo_DirectServiceOrNot: 'ไม่ว่าจะเป็นทางตรง',
  Cargo_DiscrepancyExist: 'มีความแตกต่าง',
  Cargo_DiscrepancyFound: 'มีความแตกต่างกัน',
  Cargo_DisplayAmountOfDifferential: 'ไม่ว่าจะเป็นการแสดงจำนวนเงินส่วนต่าง',
  Cargo_DisplayAmountOfReconciliation: 'ไม่ว่าจะเป็นการแสดงยอดเงินปรองดอง',
  Cargo_DisplayBatchOperation: 'ไม่ว่าจะเป็นการแสดงการดำเนินการเป็นกลุ่ม',
  Cargo_DisplayCashFlowItems: 'ไม่ว่าจะเป็นโครงการกระแสเงินสด',
  Cargo_DisplayExpenseDetails: 'ไม่ว่าจะเป็นการแสดงรายละเอียดค่าใช้จ่าย',
  Cargo_DisplayMonthSelector: 'จะให้แสดงตัวเลือกเดือน',
  Cargo_DisplayOrder: 'แสดงลำดับ',
  Cargo_DisplayTotalCost: 'ไม่ว่าจะเป็นการแสดงต้นทุนทั้งหมด',
  Cargo_DisplayTotalIncome: 'ไม่ว่าจะเป็นการแสดงรายได้ทั้งหมด',
  Cargo_DisplayUnCodedRecordsOnly: 'ดูเฉพาะการเข้ารหัสที่ว่างเปล่า',
  Cargo_DisplayUnInvoicedAmount: 'ไม่ว่าจะเป็นการแสดงยอดบัตรที่ยังไม่ออก',
  Cargo_DistributedReconciliationAmount: 'แบ่งยอดการปรองดอง',
  Cargo_DistributionCostOrNot: 'ไม่ว่าจะเป็นการแบ่งค่าใช้จ่ายต่างๆ',
  Cargo_District: 'อำเภอ',
  Cargo_DLCCLCCTBE: 'สกุลเงินเดบิต / สกุลเงินเดบิตไม่สามารถเว้นว่างได้',
  Cargo_DMROITE: 'ประเภทใบแจ้งหนี้ {0} มีการบันทึกการบำรุงรักษาซ้ำ',
  Cargo_DNBTCBOHC: 'สาขาที่ข้อมูลกำลังดำเนินการอยู่นั้นไม่ได้เป็นของสาขาปัจจุบันหรือระดับก่อนหน้า คุณแน่ใจหรือไม่ว่าคุณต้องการดำเนินการต่อ?',
  Cargo_DORMBGTTDOR: 'วันที่ส่งคืนต้องมากกว่าวันที่รับคืน',
  Cargo_InvoiceNature: 'การระบุอัตราภาษี',
  Cargo_InvoiceNatureTip: 'อัตราภาษีที่ปรับได้เมื่อระบุอัตราปกติ',
  Cargo_DOCOTS: 'ชื่อสินค้าหรือแรงงานที่ต้องเสียภาษี',
  Cargo_DocReleaseAgainstPayment: 'ไม่ว่าจะเป็นการจ่ายเงิน',
  Cargo_DocumentationType: 'ประเภทเดี่ยวออก',
  Cargo_DocumentCirculation: 'การไหลเวียนของเอกสารเดียว',
  Cargo_Documents: 'เอกสารประกอบ',
  Cargo_DOEICTBE: 'ชื่อรายการค่าธรรมเนียมไม่สามารถว่างได้',
  Cargo_Domestic: 'ในประเทศ',
  Cargo_DomesticBill: 'บิลในประเทศ',
  Cargo_DomesticChargeInformation: 'สถานการณ์ค่าใช้จ่ายในประเทศ',
  Cargo_DomesticCollection: 'การรับเงินในประเทศ',
  Cargo_DomesticDirectClient: 'ลูกค้าภายในประเทศ',
  Cargo_DomesticDirectClientOrNot: 'ไม่ว่าจะเป็นลูกค้าภายในประเทศโดยตรง',
  Cargo_DomesticOrInternational: 'ในประเทศ / ต่างประเทศ',
  Cargo_DomesticPayment: 'การชำระเงินภายในประเทศ',
  Cargo_DomesticTrade: 'การค้าภายใน',
  Cargo_DoNotSelectMultipleItems: 'อย่าเลือกหลายรายการ',
  Cargo_Door: 'จุดประตู',
  Cargo_DoorAddress: 'ที่อยู่ Doorpoint',
  Cargo_DoorLoadingDelivery: 'Door Dot Cartoning / รถกระบะ',
  Cargo_DoorPickup: 'จุดรับสินค้า',
  Cargo_DOPNCTBLTAC: 'ส่วนต่างบวกต้องไม่น้อยกว่า 1 สตางค์',
  Cargo_DoubleClickToView: 'คลิกสองครั้งเพื่อดู',
  Cargo_DownloadCompleted: 'ดาวน์โหลดสำเร็จ!',
  Cargo_DownloadFailed: 'การดาวน์โหลดล้มเหลว!',
  Cargo_DrawABillOrNot: 'ไม่ว่าจะเป็นการออกใบเรียกเก็บเงินทั้งหมด',
  Cargo_DRIRORIOCA: 'เงินปันผลลูกหนี้ ดอกเบี้ยลูกหนี้อื่น สินค้าคงคลัง สินทรัพย์หมุนเวียนอื่น',
  Cargo_DSAIM: 'ไม่ว่าจะเป็นการแสดงวิธีการตั้งถิ่นฐานและวิธีการออกใบแจ้งหนี้',
  Cargo_DSCSDSCS: 'เดบิต เดบิต',
  Cargo_Dues: 'การรับมือ',
  Cargo_DuesB: '(จ่าย)',
  Cargo_DuesToCNY: 'เทียบเท่ากับ CNY จ่าย:',
  Cargo_EquivalentCNY: 'หัก CNY จำนวน:',
  Cargo_DuesCNY: 'CNY รับมือ',
  Cargo_DuesEUR: 'EUR เพื่อรับมือ',
  Cargo_DuesGBP: 'GBP รับมือ',
  Cargo_DuesHKD: 'HKD รับมือ',
  Cargo_DuesJPY: 'JPY รับมือ',
  Cargo_DuesNGN: 'การจัดการ NGN',
  Cargo_DuesP: 'การรับมือ:',
  Cargo_DuesUSD: 'การชำระเงิน USD',
  Cargo_DuplicateCodePleaseTryItAgain: 'รหัสซ้ำโปรดป้อนอีกครั้ง',
  Cargo_DuplicateContent: 'คัดลอกเนื้อหา',
  Cargo_DutyFree: 'ยกเว้นภาษี',
  Cargo_DynamicCurrencyDisplayColumn: 'แสดงคอลัมน์สกุลเงินแบบไดนามิก',
  Cargo_ECDICA: 'ล้างเนื้อหาที่แสดงในพื้นที่กลาง',
  Cargo_ECNETSFS: 'โปรดป้อนชื่อรหัส ฯลฯ กลับไปที่คำถามเบลอ',
  Cargo_ECSNMIR: 'ค่าธรรมเนียมยืนยันสถานะไม่เป็นไปตามใบแจ้งหนี้',
  Cargo_ECSNMPAR: 'สถานะการยืนยันค่าธรรมเนียมไม่เป็นไปตามข้อกำหนดในการชำระค่าสมัคร',
  Cargo_ECSNMWOR: 'ค่าธรรมเนียมยืนยันสถานะไม่ตรงกับการตัดบัญชี',
  Cargo_EdiCode: 'การเข้ารหัส EDI',
  Cargo_EdiInterfaceTypeOfEInvocing: 'ประเภทอินเทอร์เฟซการออกตั๋วอิเล็กทรอนิกส์ภายนอก',
  Cargo_EdiInterfaceTypeOfInvoicing: 'ประเภทอินเทอร์เฟซการออกตั๋วภายนอก',
  Cargo_Edit: 'บรรณาธิการ',
  Cargo_EditAdjustment: 'การปรับเปลี่ยน',
  Cargo_EditAirFreightServiceItems: 'แก้ไขรายการบริการขนส่งสินค้าทางอากาศ',
  Cargo_EditAssociatedPort: 'แก้ไขพอร์ตที่เกี่ยวข้อง',
  Cargo_EditAwbSurcharge: 'แก้ไขใบนำส่งสินค้าทางอากาศ ค่าธรรมเนียมเบ็ดเตล็ด',
  Cargo_EditBill: 'แก้ไขบิล',
  Cargo_EditBLType: 'แก้ไขประเภท B / L',
  Cargo_EditChargeFinancialDate: 'แก้ไขวันที่ทางการเงินของค่าธรรมเนียม',
  Cargo_EditCirculationDocumentType: 'แก้ไขประเภทแฟ้มหมุนเวียน',
  Cargo_CirculationDocumentType: 'ประเภทไฟล์ Flow',
  Cargo_EditClientType: 'แก้ไขประเภทลูกค้า',
  Cargo_EditCommissionRules: 'แก้ไขกฎค่าคอมมิชชั่น',
  Cargo_EditContract: 'แก้ไขสัญญา',
  Cargo_EditCustomizedServiceType: 'แก้ไขประเภทธุรกิจที่กำหนดเอง',
  Cargo_EditedSuccessfully: 'แก้ไขสำเร็จ',
  Cargo_EditField: 'แก้ไขฟิลด์',
  Cargo_EditFinancialDate: 'แก้ไขวันที่ทางการเงิน',
  Cargo_EditFormula: 'แก้ไขสูตร -',
  Cargo_EditKeyWord: 'แก้ไขคำที่ละเอียดอ่อน',
  Cargo_EditMscService: 'แก้ไขบริการ MSC',
  Cargo_EditOppositeVoucherNo: 'แก้ไขหมายเลขคูปองของผู้อื่น',
  Cargo_EditOrNot: 'ไม่ว่าจะเป็นการแก้ไข',
  Cargo_EditRemarks: 'แก้ไขหมายเหตุ',
  Cargo_EditRoute: 'แก้ไขเส้นทางบิน',
  Cargo_EDTTTC: 'รายละเอียดค่าธรรมเนียมการเรียกเก็บเงินโอนเข้า',
  Cargo_EDTTTCP: 'รายละเอียดของค่าธรรมเนียมการเรียกเก็บเงินโอนเข้า:',
  Cargo_EffectiveDate: 'วันที่มีผลบังคับใช้',
  Cargo_EffectiveMonth: 'เดือนที่ถูกต้อง',
  Cargo_EICCMBU: '\'คอลัมน์Column \'ค่าป้อนข้อมูลของ CURRENCY CURRENCY ละเมิดข้อ จำกัด ทางเพศที่ไม่ซ้ำกัน',
  Cargo_EINDWI: 'ไม่ว่าใบแจ้งหนี้จะใส่หมายเลขใบแจ้งหนี้โดยตรง',
  Cargo_EInvoiceCanTBePrinted: 'ไม่สามารถพิมพ์ใบแจ้งหนี้อิเล็กทรอนิกส์ได้',
  Cargo_EInvoiceCanTBeVoided: 'ใบแจ้งหนี้อิเล็กทรอนิกส์ไม่สามารถเป็นโมฆะได้',
  Cargo_EInvoicePaperInvoice: 'ใบแจ้งหนี้อิเล็กทรอนิกส์ ใบแจ้งหนี้กระดาษ',
  Cargo_EmailAddress: 'อีเมล์',
  Cargo_EMailAlertForTestOnly: 'จดหมายเตือน (ทดสอบเฉพาะ)',
  Cargo_EmailSent: 'จดหมายถูกส่งแล้ว',
  Cargo_Empty: 'ล้าง',
  Cargo_EmptyData: 'ล้างข้อมูล',
  Cargo_EmptyEntries: 'ล้างอินพุต',
  Cargo_EmptyOriginalCurrency: 'ล้างเหรียญต้นฉบับ',
  Cargo_EMSSCM: 'การส่งจดหมายสำเร็จโปรดใส่ใจกับการตรวจสอบ',
  Cargo_EndDate: 'กำหนดเวลา',
  Cargo_EnglishCargoName: 'ชื่อภาษาอังกฤษ',
  Cargo_EnglishCommodityNameMsc: 'ชื่อภาษาอังกฤษ (MSC)',
  Cargo_EnglishName: 'ชื่อภาษาอังกฤษ',
  Cargo_EnglishNameCanTBeEmpty: 'ชื่อภาษาอังกฤษไม่สามารถว่างได้',
  Cargo_Enter: 'ป้อนเข้า',
  Cargo_CannotDeleteUsedCustomerType: 'ไม่อนุญาตให้ลบประเภทลูกค้าที่ใช้แล้ว',
  Cargo_CannotDeleteUsedCustomerContactChannel: 'ไม่อนุญาตให้ลบช่องทางการติดต่อลูกค้าที่ใช้แล้ว',
  Cargo_CannotDeleteUsedCustomerRating: 'ไม่อนุญาตให้ลบเกรดการประเมินลูกค้าที่ใช้แล้ว',
  Cargo_EnterBusinessTypeToStartSearch: 'กรุณากรอกข้อมูลประเภทธุรกิจ',
  Cargo_EnterExpenseName: 'ป้อนชื่อค่าธรรมเนียม',
  Cargo_EnterInvoiceNo: 'ป้อนหมายเลขใบแจ้งหนี้',
  Cargo_EnterInvoiceNoDirectly: 'ไม่ว่าจะเป็นการป้อนหมายเลขใบแจ้งหนี้โดยตรง',
  Cargo_EnterKeyWordsToStartFuzzySearch: 'โปรดป้อนคำที่ละเอียดอ่อนสำหรับคำถามที่คลุมเครือ',
  Cargo_EnterManually: 'ป้อนข้อมูลด้วยตนเอง',
  Cargo_EnterSpecialInvoiceNo: 'ป้อนหมายเลขใบแจ้งหนี้พิเศษ',
  Cargo_EnterVoucherInformation: 'ป้อนข้อมูลบัตรกำนัล',
  Cargo_Entity: 'นิติบุคคล',
  Cargo_EntryDate: 'วันที่เข้า',
  Cargo_EntryOfNumber: 'ป้อนหมายเลข',
  Cargo_EqualTo: 'เท่ากับ',
  Cargo_Error: 'ผิดพลาด',
  Cargo_ErrorNoDataFound: 'ผิดพลาด ไม่มีข้อมูล',
  Cargo_ESNMIR: 'สถานะค่าธรรมเนียมไม่เป็นไปตามใบแจ้งหนี้',
  Cargo_ESNMPAR: 'สถานะค่าธรรมเนียมไม่เป็นไปตามข้อกำหนดในการชำระค่าสมัคร',
  Cargo_ESNMWOR: 'สถานะค่าธรรมเนียมไม่เป็นไปตามข้อกำหนดการตัดบัญชี',
  Cargo_EstTimeOfWarehouseIn: 'เวลาโดยประมาณในการเข้าสู่ตำแหน่ง',
  Cargo_EventOfSettlingParty: 'เหตุการณ์ Settlement Object',
  Cargo_EventRecord: 'บันทึกเหตุการณ์',
  Cargo_EventTime: 'เวลาเกิดเหตุ',
  Cargo_EverCancelledWriteOff: 'ไม่ว่าจะเป็นการดำเนินการยกเลิกการเพิกถอน',
  Cargo_ExcelExport: 'ส่งออก Excel',
  Cargo_ExcessiveOrNot: 'ไม่ว่าจะเป็นส่วนเกิน',
  Cargo_ExchangeCode: 'แลกเปลี่ยนรหัส',
  Cargo_ExchangeCodeCanTBeEmpty: 'การแลกเปลี่ยนรหัสต้องไม่ว่างเปล่า',
  Cargo_ExchangeCurrency: 'แลกเปลี่ยนสกุลเงิน',
  Cargo_ExchangeGainsAndLosses: 'กำไรและขาดทุนจากอัตราแลกเปลี่ยน',
  Cargo_ExchangeRate: 'อัตราการแลกเปลี่ยน',
  Cargo_ExchangeRateAdjustmentTable: 'ตารางปรับอัตราแลกเปลี่ยน',
  Cargo_ExchangeRateAdjustmentTableP: 'ตารางปรับอัตราแลกเปลี่ยน:',
  Cargo_ExchangeRateCanTBeEmpty: 'อัตราแลกเปลี่ยนไม่สามารถว่างได้',
  Cargo_ExchangeRateDifference: 'ความแตกต่างของอัตราแลกเปลี่ยน',
  Cargo_ExchangeRateHKD: 'อัตราแลกเปลี่ยน HKD',
  Cargo_ExchangeRateList: 'รายการอัตราแลกเปลี่ยน',
  Cargo_ExchangeRateOfHKD: 'อัตราแลกเปลี่ยน HKD',
  Cargo_ExchangeRateP: 'อัตราแลกเปลี่ยน:',
  Cargo_ExchangeRateUSD: 'อัตราแลกเปลี่ยน USD',
  Cargo_ExclusionFilter: 'ขับไล่การกรอง',
  Cargo_ExecutionMethodOfWindowClosure: 'ปิดวิธีการประมวลผลหน้าต่าง',
  Cargo_Existed: 'มีอยู่แล้ว',
  Cargo_ExpectedReviewDate: 'วันที่คาดว่าจะพิจารณา',
  Cargo_Expenditure: 'การใช้จ่าย',
  Cargo_ExpenseAdjustment: 'การปรับค่าธรรมเนียม',
  Cargo_ExpenseAdjustmentOfCollection: 'ค่าธรรมเนียมการปรับการเรียกเก็บเงิน',
  Cargo_ExpenseApprovalProcedure: 'ขั้นตอนการอนุมัติค่าใช้จ่าย',
  Cargo_ExpenseDescriptionCanTBeEmpty: 'ชื่อค่าธรรมเนียมไม่สามารถเว้นว่างได้',
  Cargo_ExpenseItemsCanTBeEmpty: 'ค่าใช้จ่ายในใบเรียกเก็บเงินไม่สามารถว่างเปล่าได้',
  Cargo_ExpenseListNonEntity: 'รายการค่าธรรมเนียมที่ไม่ใช่นิติบุคคล',
  Cargo_ExpenseNotSelected: 'ไม่มีการเลือกค่าธรรมเนียม',
  Cargo_ExpenseRejectedSuccessfully: 'การยกเลิกค่าธรรมเนียมสำเร็จ',
  Cargo_ExpenseRelated: 'สอดคล้องกับค่าใช้จ่าย',
  Cargo_ExpenseReviewedBy: 'ผู้ตรวจสอบค่าใช้จ่าย',
  Cargo_ExpenseSearch: 'สอบถามค่าใช้จ่าย',
  Cargo_ExpenseSelection: 'ตัวเลือกค่าธรรมเนียม',
  Cargo_ExpenseSettlingParty: 'วัตถุแห่งการชำระค่าธรรมเนียม',
  Cargo_ExpenseWriteOffCanTBeEmpty: 'ค่าใช้จ่ายในการตัดบัญชีต้องไม่ว่างเปล่า',
  Cargo_ExpenseWrittenOffCanTBeSplit: 'ค่าใช้จ่ายถูกตัดออกและไม่สามารถแบ่งได้!',
  Cargo_ExpiryDateCanTBeEmpty: 'วันหมดอายุไม่สามารถว่างได้',
  Cargo_Export: 'ทางออก',
  Cargo_ExportBaiwangInvoice: 'การส่งออกใบแจ้งหนี้ Baiwang',
  Cargo_ExportClientSuccessfully: 'ส่งออกความสำเร็จของลูกค้า',
  Cargo_ExportedSuccessfully: 'ส่งออกสำเร็จ',
  Cargo_ExportExcel: 'EXCLE ส่งออก',
  Cargo_ExportExpenses: 'ค่าธรรมเนียมการส่งออก',
  Cargo_ExportFailed: 'การส่งออกล้มเหลว',
  Cargo_ExportOrNot: 'ไม่ว่าจะเป็นการส่งออก',
  Cargo_ExportRecordsSuccessfully: 'บันทึกการส่งออกสำเร็จ',
  Cargo_ExportRequired: 'ต้องการส่งออก',
  Cargo_ExportResult: 'ส่งออกผลลัพธ์',
  Cargo_ExportSuccessfully: 'การส่งออกเสร็จสมบูรณ์ประสบความสำเร็จ',
  Cargo_ExportVatInvoice: 'การส่งออกใบกำกับภาษีมูลค่าเพิ่ม',
  Cargo_ExportVatInvoiceXLS: 'ส่งออกใบกำกับภาษีมูลค่าเพิ่ม .xls',
  Cargo_ExportVoucher: 'ส่งออกคูปอง',
  Cargo_ExportWriteOffDetails: 'ส่งออกรายละเอียดบัญชีการขาย',
  Cargo_ExpressAddress: 'ที่อยู่จัดส่ง',
  Cargo_ExpressInfo: 'ข้อมูลด่วน',
  Cargo_Extend: 'ไม่ว่าจะเป็นชุนยัน',
  Cargo_ExtendPeriod: 'ขยายระยะเวลา',
  Cargo_ExtensionAfterExpiration: 'Shunyan หลังจากหมดอายุ',
  Cargo_ExtensionCycle: 'รอบ Shunyen',
  Cargo_External: 'ภายนอก',
  Cargo_Fax: 'แฟกซ์',
  Cargo_FCAEFAIIVWBIWBCCTV: 'มีใบแจ้งหนี้ {0} ที่ส่งออกใบแจ้งหนี้ทางการเงินแล้วหากระบบ Disruption จะสร้างใบแจ้งหนี้ Hongchong ยืนยันการเป็นโมฆะหรือไม่',
  Cargo_FCAOCAE: 'มีการทำบัญชีเงินตราต่างประเทศเพื่อคำนวณจำนวนเงินสกุลเดิม',
  Cargo_FCASPSCT: 'เลือกบัญชีสกุลเงินต่างประเทศแล้ว กรุณาเลือกสกุลเงินที่ต้องการบัญชี',
  Cargo_FCL: 'กล่อง FCL',
  Cargo_SpecialSize: 'ขนาดพิเศษ',
  Cargo_SpecialSizeTip: 'หลังจากติ๊กรายการข้อมูลการบรรจุสามารถแสดงฟิลด์ "ข้อมูลจำเพาะขนาด (L * W * H Unit M)" เพิ่มเติม',
  Cargo_FclLclTypeSeaExport: 'ประเภทการสะกดทั้งหมด (ทะเลออก)',
  Cargo_FclLclTypeSeaImport: 'ประเภทการสะกดทั้งหมด (Haijin)',
  Cargo_EstimatedArrivalTimeSeaExport: 'เวลาท่าเรือออกที่คาดการณ์ (ส่งออกทางทะเล)',
  Cargo_EstimatedArrivalTimeSeaImport: 'เวลาท่าเรือถึงที่คาดการณ์ (นำเข้าทางทะเล)',
  Cargo_EstimatedArrivalTimeAirExport: 'เวลาถึงที่คาดการณ์ (ส่งออกทางอากาศ)',
  Cargo_FDMOPPE0: 'กำหนดวัน/เดือน หรือระยะเวลาบัญชีมากกว่า 0',
  Cargo_February: 'กุมภาพันธ์',
  Cargo_FeederOrNot: 'ไม่ว่าจะเป็นเรือ',
  Cargo_FIAICTR: 'ใบคำขอออกใบแจ้งหนี้ต่อไปนี้ได้ออกใบแจ้งหนี้แล้วและไม่สามารถเพิกถอนได้!',
  Cargo_FIDSEC: 'คุณเลือกค่าธรรมเนียมสำหรับหน่วยการตั้งถิ่นฐานที่แตกต่างกัน คุณแน่ใจหรือไม่ว่าจะรวมยอดตัดบัญชีต่อไป?',
  Cargo_FileApplication: 'ส่งใบสมัคร',
  Cargo_FileDocumentation: 'เอกสารข้อมูล',
  Cargo_FileFormat: 'รูปแบบไฟล์',
  Cargo_FileHistory: 'ประวัติไฟล์',
  Cargo_FileLoadingFailed: 'การโหลดแฟ้มล้มเหลว',
  Cargo_FileName: 'ชื่อแฟ้ม',
  Cargo_FileNo: 'หมายเลขไฟล์',
  Cargo_FileNotFoundInCloud: 'การจัดเก็บเมฆไม่พบแฟ้ม',
  Cargo_FileRetrievedSuccessfully: 'เรียกคืนไฟล์สำเร็จ',
  Cargo_FileSize: 'ขนาดไฟล์',
  Cargo_FileStatus: 'สถานะไฟล์',
  Cargo_FileType: 'ประเภทไฟล์',
  Cargo_FileTypeDescription: 'ชื่อประเภทไฟล์',
  Cargo_Filter: 'การกรอง',
  Cargo_FilterP: 'การกรอง:',
  Cargo_FinalDestination: 'ปลายทางสุดท้าย',
  Cargo_FinancialApprovalDate: 'วันที่อนุมัติทางการเงิน',
  Cargo_FinancialApproved: 'ได้รับการอนุมัติทางการเงิน',
  Cargo_FinancialAudit: 'การตรวจสอบทางการเงิน',
  Cargo_FinancialAuditDetail: 'การตรวจสอบทางการเงิน - รายละเอียด',
  Cargo_FinancialChangeReview: 'การตรวจสอบการเปลี่ยนแปลงทางการเงิน',
  Cargo_FinancialCharges: 'ค่าใช้จ่ายทางการเงิน',
  Cargo_FinancialCode: 'รหัสทางการเงิน',
  Cargo_FinancialDate: 'วันที่ทางการเงิน',
  Cargo_FinancialExpenseIs: 'ค่าใช้จ่ายทางการเงินคือ',
  Cargo_FinancialPeriod: 'ช่วงเวลาทางการเงิน',
  Cargo_FinancialReceived: 'การยอมรับ',
  Cargo_FinancialRemarks: 'หมายเหตุทางการเงิน',
  Cargo_FinancialSoftware: 'ซอฟต์แวร์ทางการเงิน',
  Cargo_FinasialCheck: 'การอนุมัติทางการเงิน',
  Cargo_FindExistingCurrencies: 'ค้นหาสกุลเงินที่มีอยู่แล้ว',
  Cargo_FirstAccruedProfit: 'กำไรขั้นต้น',
  Cargo_FirstAccruedTime: 'การนับเวลาครั้งแรก',
  Cargo_FirstContactDate: 'วันที่ติดต่อครั้งแรก',
  Cargo_FiscalPeriod: 'รอบระยะเวลาบัญชี',
  Cargo_Fit: 'ลูกค้ารายบุคคล',
  Cargo_FixedAccountingCode: 'การเข้ารหัสบัญชีคงที่',
  Cargo_FixedDateMonthly: 'วันที่ระบุในแต่ละเดือน',
  Cargo_FJTLCTW: 'ใบงานต่อไปนี้ถูกล็อคและไม่สามารถคืนเงินได้:',
  Cargo_FLCLType: 'ประเภทการสะกดทั้งหมด',
  Cargo_FlightVoyage: 'เที่ยวบิน',
  Cargo_FollowingBillsInTheTextNotFound: 'ไม่พบบิลดังต่อไปนี้ในข้อความ:',
  Cargo_ForAirBusiness: 'ใช้ทางอากาศ',
  Cargo_ForAirExportBusiness: 'การใช้การส่งออกทางอากาศ',
  Cargo_ForAirImportBusiness: 'การนำเข้าทางอากาศใช้',
  Cargo_ForRailwayBusiness: 'การใช้กิจการรถไฟ',
  Cargo_ForIntegratedJob: 'การใช้โลจิสติกส์อย่างครอบคลุม',
  Cargo_ForFbaSeaBusiness: 'FBA Sea Freight ใช้',
  Cargo_ForFbaAirBusiness: 'FBA ทางอากาศใช้',
  Cargo_ForFbaRailwayBusiness: 'การใช้รถไฟ FBA',
  Cargo_ForceDelete: 'บังคับให้ลบ',
  Cargo_ForeignCurrency: 'สกุลเงินต่างประเทศ',
  Cargo_ForeignCurrencyAccounting: 'บัญชีสกุลเงินต่างประเทศ',
  Cargo_ForeignCurrencyAccountingExist: 'มีบัญชีเงินตราต่างประเทศ',
  Cargo_ForeignTrade: 'การค้าต่างประเทศ',
  Cargo_Format: 'การจัดรูปแบบ',
  Cargo_FormLayout: 'รูปแบบฟอร์ม',
  Cargo_FormVerification: 'การตรวจสอบแบบฟอร์ม',
  Cargo_ForOceanBusiness: 'การใช้ทางทะเล',
  Cargo_ForOtherBusiness: 'การใช้ธุรกิจอื่น ๆ',
  Cargo_ForRailwayExportBusiness: 'ใช้ทางออกทางรถไฟ',
  Cargo_ForSeaExportBusiness: 'ส่งออกทางทะเลใช้',
  Cargo_ForSeaImportBusiness: 'การนำเข้าทางทะเลใช้',
  Cargo_FreeDetension: 'ระยะเวลาการเช่าตู้ฟรี',
  Cargo_FreightForwardingFee: 'ค่าธรรมเนียมการขนส่ง',
  Cargo_FristApprovalDate: 'ระยะเวลาการสมัคร',
  Cargo_From: 'เริ่มต้นจาก',
  Cargo_Frozen: 'ถูกแช่แข็ง',
  Cargo_FrozenSuccessfully: 'แช่แข็งสำเร็จ',
  Cargo_FullPayment: 'ชำระเงินทั้งหมด',
  Cargo_FullScreenDisplay: 'ไม่ว่าจะเป็นการแสดงผลเต็มหน้าจอ',
  Cargo_Fumigation: 'การรมควัน',
  Cargo_FunctionOfSuccessfulAcquisition: 'รับฟังก์ชันที่ประสบความสำเร็จ',
  Cargo_FVOCPIOOPRECTBV: 'ประวัติการชำระเงินที่ชำระแล้วในปัจจุบัน มีการส่งออกหนังสือรับรองทางการเงินและไม่สามารถเป็นโมฆะได้',
  Cargo_FVOVNP: 'Voucher 【{0}】 การตรวจสอบต่อไปนี้ไม่ผ่าน:',
  Cargo_GeneralInvoice: 'ใบแจ้งหนี้ทั่วไป',
  Cargo_GeneralLedger: 'บัญชีแยกประเภท',
  Cargo_GeneralLedger2: 'บัญชีแยกประเภททั่วไป 2',
  Cargo_GeneralRate: 'ราคาปกติ',
  Cargo_GeneratedAccountStatement: 'ไม่ว่าจะเป็นการสร้างใบแจ้งยอด',
  Cargo_GeneratedBillsOrNot: 'ไม่ว่าจะเป็นการสร้างบิล',
  Cargo_GetBack: 'การรับคืน',
  Cargo_GoldenTaxationExportPrint: 'การพิมพ์ส่งออกภาษีทอง',
  Cargo_GoOn: 'ดำเนินการต่อไป',
  Cargo_ARAP_Locked: 'งานที่เลือกมีการล็อกทั้งลูกหนี้และเจ้าหนี้ ไม่สามารถเพิ่มค่าใช้จ่ายได้',
  Cargo_AR_Locked: 'งานที่เลือกมีการล็อกลูกหนี้ ไม่สามารถเพิ่มค่าใช้จ่ายลูกหนี้ได้',
  Cargo_AP_Locked: 'งานที่เลือกมีการล็อกเจ้าหนี้ ไม่สามารถเพิ่มค่าใช้จ่ายเจ้าหนี้ได้',
  Cargo_Only_AR: 'ผู้ใช้ปัจจุบันสามารถเพิ่มค่าใช้จ่ายลูกหนี้เท่านั้น',
  Cargo_Only_AP: 'ผู้ใช้ปัจจุบันสามารถเพิ่มค่าใช้จ่ายเจ้าหนี้เท่านั้น',
  Cargo_Cannot_Add_Charge: 'ผู้ใช้ปัจจุบันไม่สามารถเพิ่มค่าใช้จ่ายได้',
  Cargo_ChargeLockStatusChanged: 'สถานะล็อกลูกหนี้/เจ้าหนี้ของงานได้รับการอัปเดตแล้ว กรุณาค้นหาใหม่และส่งค่าใช้จ่ายใหม่อีกครั้ง',
  Cargo_GrandTotal: 'ทั้งหมด',
  Cargo_GrandTotalP: 'รวม:',
  Cargo_GreaterThan: 'มากกว่า',
  Cargo_GroupCompany: 'กลุ่มบริษัท',
  Cargo_GroupExchangeRate: 'อัตราแลกเปลี่ยนกลุ่ม',
  Cargo_GroupingConditions: 'เงื่อนไขการจัดกลุ่ม',
  Cargo_GroupingConditions1: 'เงื่อนไขการจัดกลุ่ม 1',
  Cargo_GroupingConditions2: 'เงื่อนไขการจัดกลุ่ม 2',
  Cargo_GroupingConditions3: 'เงื่อนไขการจัดกลุ่ม 3',
  Cargo_GroupingConditions4: 'เงื่อนไขการจัดกลุ่ม 4',
  Cargo_GroupingConditions5: 'เงื่อนไขการจัดกลุ่ม 5',
  Cargo_GroupingConditions6: 'เงื่อนไขการจัดกลุ่ม 6',
  Cargo_GroupingMethod: 'วิธีการจัดกลุ่ม',
  Cargo_GroupingRulesOfJournalEntries: 'กฎการจัดกลุ่มรายการ',
  Cargo_GroupingType: 'ประเภทกลุ่ม',
  Cargo_GroupingTypesOfJournalEntries: 'ประเภทการแบ่งกลุ่ม',
  Cargo_GroupingTypesOfJournalEntriesP: 'ประเภทการแบ่งกลุ่ม:',
  Cargo_HalfMonthly: 'ปมพระจันทร์ครึ่งเสี้ยว',
  Cargo_Harbour: 'ท่าเรือ',
  Cargo_HaulageCompany: 'บริษัท ขนส่ง',
  Cargo_HaveHas: 'มี',
  Cargo_HaveOrNot: 'มี',
  Cargo_HazmatContained: 'ไม่ว่าจะเป็นสารเคมีอันตราย',
  Cargo_HBLFreightTerm: 'เงื่อนไขการจัดส่งสินค้าแบบแยกส่วน',
  Cargo_HBLMode: 'วิธี B / L ของ B / L',
  Cargo_MBLMode: 'วิธี B / L B / L',
  Cargo_HBLTransitTerm: 'เงื่อนไขการจัดส่งสินค้าแบบแยกส่วน',
  Cargo_HedgingInvoice: 'ใบเรียกเก็บเงินป้องกันความเสี่ยง',
  Cargo_HideQuantity: 'จำนวนที่ซ่อนอยู่',
  Cargo_HoldCargoOrNot: 'ไม่ว่าจะเป็นการหักสินค้า',
  Cargo_HoldDoc: 'หัวเข็มขัด',
  Cargo_SpecialApprovalOrder: 'แผ่นวางชุดพิเศษ',
  Cargo_HoldSubmission: 'งดส่งหนังสือชั่วคราว',
  Cargo_HqSWriteOffPendingConfirmation: 'การตรวจสอบการขายของสำนักงานใหญ่เพื่อยืนยัน',
  Cargo_HsCode: 'หมายเลข HS',
  Cargo_IADBD: 'วันที่ขอใบแจ้งหนี้ วันที่ประกอบธุรกิจ',
  Cargo_IARS: 'การขอถอนใบแจ้งหนี้สำเร็จ',
  Cargo_IBOCR: 'ยอดคงเหลือในบันทึกการเก็บเงินไม่เพียงพอ:',
  Cargo_ICDOOAABBD: 'เริ่มต้นใช้งานข้อมูลสรุปการขนส่งทางทะเลและทางอากาศโดยปริยาย',
  Cargo_IDVOCVDCCIATTC: 'อินเทอร์เฟซบัตรกำนัลที่กำหนดเอง อินเทอร์เฟซของรุ่นที่แสดงจะแสดงอินเทอร์เฟซที่กำหนดเองตามการกำหนดค่า',
  Cargo_Ignore: 'ไม่สนใจ',
  Cargo_IgnoreP: 'ไม่ว่าจะเป็นการละเลย',
  Cargo_IICS: 'ข้อมูลใบแจ้งหนี้สำเร็จ',
  Cargo_IINMCTBE: 'การบำรุงรักษาชื่อรายการใบแจ้งหนี้ไม่สามารถเว้นว่างได้',
  Cargo_Import: 'นำเข้า',
  Cargo_ImportBankSlip: 'รายการน้ำนำเข้า',
  Cargo_ImportExcel: 'การนำเข้า Excel',
  Cargo_INABNCTBBE: 'หมายเลขใบแจ้งหนี้หรือหมายเลขธุรกิจไม่สามารถเว้นว่างได้ทั้งหมด',
  Cargo_INCBMDON: 'ไม่ว่าจะเป็นการแก้ไขหมายเลขใบแจ้งหนี้โดยตรง',
  Cargo_IncludedToBusinessNo: 'นับหมายเลขธุรกิจ',
  Cargo_IncludedToBusinessNoP: 'หมายเลขธุรกิจ:',
  Cargo_InclusiveExpense: 'รวมค่าธรรมเนียม',
  Cargo_InclusiveExpenseP: 'รวมค่าธรรมเนียม:',
  Cargo_InclusiveOfAR: 'ไม่ว่าจะรวมค่าธรรมเนียมลูกหนี้แล้ว',
  Cargo_Income: 'การเก็บรวบรวม',
  Cargo_IncorrectWriteOffRecord: 'บันทึกการขายบัญชีไม่ถูกต้อง',
  Cargo_IncoTerm: 'เงื่อนไขการค้า',
  Cargo_IncreaseAdjustment: 'เพิ่มการปรับ',
  Cargo_IncrementValueDuty: 'ภาษีมูลค่าเพิ่ม',
  Cargo_ProductNameEn: 'ชื่อผลิตภัณฑ์ (อังกฤษ)',
  Cargo_ContainerNumber: 'หมายเลขตู้คอนเทนเนอร์',
  Cargo_TotalDataCount: 'รวมทั้งหมด {0} รายการข้อมูล',
  Cargo_PalletDetails: 'รายละเอียดพาเลท',
  Cargo_PalletDimensions: 'ขนาดพาเลท',
  Cargo_ShippingCompanyWebsite: 'เว็บไซต์บริษัทเรือ',
  Cargo_OverseasWarehouseAddress: 'ที่อยู่คลังสินค้าต่างประเทศ',
  Cargo_Index: 'ดัชนี',
  Cargo_IndexCanTBeEmpty: 'สรุปไม่สามา  รถว่างได้',
  Cargo_IndexName: 'ชื่อสรุป',
  Cargo_IndustrialTradingCompany: 'การรวมอุตสาหกรรมและการค้า Inc',
  Cargo_INEPREIN: 'มีหมายเลขใบแจ้งหนี้อยู่แล้ว กรุณากรอกหมายเลขใบแจ้งหนี้อีกครั้ง',
  Cargo_Infomation: 'ข้อมูล',
  Cargo_InformationSentDate: 'วันที่ส่ง',
  Cargo_InformationSentTime: 'เวลาที่ส่งแล้ว',
  Cargo_InitialBalance: 'ยอดคงเหลือเริ่มต้นของวิชา',
  Cargo_InitialBalanceImport: 'การนำเข้ายอดคงเหลือเริ่มต้น',
  Cargo_InitializePageSwitching: 'วิธีการเตรียมใช้งานหน้าเว็บ toggle',
  Cargo_InitializingPleaseWait: 'เริ่มการทำงาน กรุณาทีหลัง...',
  Cargo_InitialPeriod: 'ระยะเวลาเริ่มต้น',
  Cargo_InitialPeriodCannotBeEmpty: 'ช่วงเวลาเริ่มต้นไม่สามารถว่างได้',
  Cargo_InitialPeriodCanTBeEmpty: 'ปีเริ่มต้นไม่สามารถว่างได้',
  Cargo_InitialPeriodOrNot: 'ไม่ว่าจะเป็นช่วงเริ่มต้น',
  Cargo_InitialPeriodP: 'ระยะเวลาเริ่มต้น:',
  Cargo_InitiateContainerPickupRequest: 'เริ่มต้นคำขอธุรกิจยกกระเป๋า',
  Cargo_INNECTCW: 'ไม่มีการป้อนหมายเลขใบแจ้งหนี้ ยืนยันการปิดหน้าต่าง?',
  Cargo_INNECTP: 'ไม่มีการป้อนหมายเลขใบแจ้งหนี้ คุณต้องการพิมพ์ต่อหรือไม่?',
  Cargo_INNECTS: 'ไม่มีการป้อนหมายเลขใบแจ้งหนี้ คุณต้องการบันทึกต่อไปหรือไม่?',
  Cargo_InputBusinessNumber: 'กรุณากรอกหมายเลขธุรกิจ',
  Cargo_InputTime: 'เวลาเข้า',
  Cargo_InsertJournalEntry: 'แทรกรายการ',
  Cargo_InsidePacking: 'แพคเกจชิ้นเล็ก',
  Cargo_InsideQuantity: 'จำนวนชิ้นเล็ก ๆ',
  Cargo_InstantMessengerQqWechatEtc: 'ข้อความโต้ตอบแบบทันที (QQ WeChat เป็นต้น)',
  Cargo_InsufficientRecordBalance: 'บันทึกยอดคงเหลือไม่เพียงพอ:',
  Cargo_IntentionStage: 'เวทีแสดงเจตจำนง',
  Cargo_InterfaceScheme: 'รูปแบบอินเทอร์เฟซ',
  Cargo_Internal: 'ภายใน',
  Cargo_InternalCode: 'การเข้ารหัสภายใน',
  Cargo_InternalInvoice: 'ใบแจ้งหนี้ภายใน',
  Cargo_International: 'ต่างประเทศ',
  Cargo_InternationalBill: 'บิลต่างประเทศ',
  Cargo_IntLFreight: 'ค่าจัดส่งตัวแทนระหว่างประเทศ',
  Cargo_IntLFreightForwardingServiceFee: 'ค่าบริการขนส่งสินค้าระหว่างประเทศ',
  Cargo_IntLOceanFreight: 'ค่าขนส่งทางทะเลสำหรับตัวแทนระหว่างประเทศ',
  Cargo_InUseByBusinessCanTBeDeleted: 'ใช้ในเชิงพาณิชย์และไม่สามารถลบออกได้',
  Cargo_Invalid: 'โมฆะ',
  Cargo_InvalidDate: 'วันหมดอายุ',
  Cargo_InvalidNavigation: 'การนำทางไม่ถูกต้อง',
  Cargo_InvalidOrNot: 'ไม่ว่าจะเป็นโมฆะ',
  Cargo_InvalidParameter: 'พารามิเตอร์ที่ไม่ถูกต้อง',
  Cargo_InverseSelect: 'ต่อต้านการเลือกตั้ง',
  Cargo_Invoice: 'ใบแจ้งหนี้',
  Cargo_Invoiceable: 'สามารถออกใบแจ้งหนี้ได้',
  Cargo_InvoiceAcquisition: 'การรับใบแจ้งหนี้',
  Cargo_InvoiceAfterARAPOffset: 'ใบแจ้งหนี้การป้องกันความเสี่ยงของลูกหนี้',
  Cargo_InvoiceAmount: 'จำนวนใบแจ้งหนี้',
  Cargo_InvoiceAmountP: 'จำนวนใบแจ้งหนี้:',
  Cargo_InvoiceConfirmation: 'การกำหนดใบแจ้งหนี้',
  Cargo_InvoiceContent: 'เนื้อหาของใบแจ้งหนี้',
  Cargo_InvoiceCurrency: 'สกุลเงินใบแจ้งหนี้',
  Cargo_InvoiceCurrencyP: 'สกุลเงินใบแจ้งหนี้:',
  Cargo_Invoiced: 'ใบแจ้งหนี้',
  Cargo_InvoiceDate: 'วันที่ออกตั๋ว',
  Cargo_InvoiceDateP: 'วันที่ออกตั๋ว:',
  Cargo_InvoicedBy: 'ผู้ออกตั๋ว',
  Cargo_InvoicedByP: 'ผู้เรียกเก็บเงิน:',
  Cargo_InvoiceDeleted: 'ลบใบแจ้งหนี้แล้ว',
  Cargo_InvoicedOrNot: 'ไม่ว่าจะเป็นการออกใบแจ้งหนี้',
  Cargo_InvoiceHasBeenWrittenOff: 'ใบแจ้งหนี้ขาดบัญชี',
  Cargo_InvoiceHeader: 'เพิ่มใบแจ้งหนี้',
  Cargo_InvoiceInformation: 'ข้อมูลใบแจ้งหนี้',
  Cargo_InvoiceIssued: 'ออกใบแจ้งหนี้แล้ว',
  Cargo_InvoiceItemName: 'ชื่อรายการใบแจ้งหนี้',
  Cargo_InvoiceItemNameSetup: 'การตั้งค่าชื่อรายการใบแจ้งหนี้',
  Cargo_InvoiceNo: 'หมายเลขใบแจ้งหนี้',
  Cargo_InvoiceNoCanTBeEmpty: 'หมายเลขใบแจ้งหนี้ไม่สามารถเว้นว่างได้',
  Cargo_InvoiceNoEntry: 'ป้อนหมายเลขใบแจ้งหนี้',
  Cargo_InvoiceNoExist: 'มีหมายเลขใบแจ้งหนี้',
  Cargo_InvoiceNoExistedContinue: 'มีหมายเลขใบแจ้งหนี้อยู่แล้ว จะดำเนินการต่อหรือไม่',
  Cargo_InvoiceNoExistedContinueToSave: 'หมายเลขใบแจ้งหนี้มีอยู่แล้ว คุณจะบันทึกไว้หรือไม่?',
  Cargo_InvoiceNoExistedRewrite: 'หมายเลขใบแจ้งหนี้ [{0}] มีอยู่แล้วโปรดกรอกหมายเลขใบแจ้งหนี้อีกครั้ง',
  Cargo_InvoiceNoIsEmpty: 'หมายเลขใบแจ้งหนี้ว่างเปล่า',
  Cargo_InvoiceNoIsEmptyContinue: 'หมายเลขใบแจ้งหนี้ว่างเปล่า จะดำเนินการต่อหรือไม่',
  Cargo_InvoiceNoMandatory: 'จำเป็นต้องกรอกหมายเลขใบแจ้งหนี้หรือไม่',
  Cargo_InvoiceNoNotEntered: 'ไม่ได้ใส่หมายเลขใบแจ้งหนี้',
  Cargo_InvoiceNoP: 'หมายเลขใบแจ้งหนี้:',
  Cargo_InvoiceNoSegment: 'ส่วนของหมายเลขใบแจ้งหนี้',
  Cargo_InvoiceNoStatus: 'สถานะหมายเลขใบแจ้งหนี้',
  Cargo_InvoicePrintedCanTBeDeleted: 'พิมพ์ใบแจ้งหนี้แล้วไม่สามารถลบได้',
  Cargo_InvoicePrinting: 'การพิมพ์ใบแจ้งหนี้',
  Cargo_InvoiceRecord: 'บันทึกใบแจ้งหนี้',
  Cargo_InvoiceReIssued: 'ออกใบแจ้งหนี้อีกครั้ง',
  Cargo_InvoiceRemark: 'หมายเหตุการออกตั๋ว',
  Cargo_InvoiceSavedSuccessfully: 'บันทึกใบแจ้งหนี้สำเร็จ',
  Cargo_InvoiceSaveFailed: 'การบันทึกใบแจ้งหนี้ล้มเหลว',
  Cargo_InvoiceStatus: 'สถานะใบแจ้งหนี้',
  Cargo_InvoiceTitle: 'การเรียกเก็บเงินเพิ่มขึ้น',
  Cargo_ChargeInvoiceTitle: 'การเรียกเก็บเงินเพิ่มขึ้น',
  Cargo_InvoiceTitleInvoiceNo: 'หมายเลขใบแจ้งหนี้',
  Cargo_InvoiceTitleNotMatched: 'ใบแจ้งหนี้เพิ่มขึ้นไม่เป็นเอกภาพ',
  Cargo_InvoiceTitleP: 'การเรียกเก็บเงินเพิ่มขึ้น:',
  Cargo_InvoiceType: 'ประเภทใบแจ้งหนี้',
  Cargo_InvoiceTypeIncompatible: 'ประเภทของใบแจ้งหนี้ไม่เหมือนกัน',
  Cargo_InvoiceTypeP: 'ประเภทใบแจ้งหนี้:',
  Cargo_InvoiceTypeSelection: 'เลือกประเภทใบแจ้งหนี้',
  Cargo_InvoiceUse: 'การใช้ใบแจ้งหนี้',
  Cargo_InvoiceVoided: 'ใบแจ้งหนี้เป็นโมฆะ',
  Cargo_InvoiceVoidedCanTBeDeleted: 'ใบแจ้งหนี้เป็นโมฆะและไม่สามารถลบได้',
  Cargo_InvoiceVoucherAfterARAPOffset: 'บัตรกำนัล Hedging Invoice',
  Cargo_InvoiceWrittenOffCanTBeDeleted: 'ใบแจ้งหนี้ขาดบัญชีไม่สามารถลบได้',
  Cargo_InvoiceWrittenOffCanTBeVoided: 'ใบแจ้งหนี้ขาดบัญชีและไม่สามารถเป็นโมฆะได้',
  Cargo_Invoicing: 'ใบแจ้งหนี้',
  Cargo_InvoicingAccordingToCurrency: 'ใบแจ้งหนี้ประเภท Cent',
  Cargo_InvoicingAddress: 'ที่อยู่สำหรับใบแจ้งหนี้',
  Cargo_InvoicingAmount: 'จำนวนใบแจ้งหนี้',
  Cargo_InvoicingApplicationDate: 'วันที่ขอใบแจ้งหนี้',
  Cargo_InvoicingApplicationReview: 'การตรวจสอบคำขอออกใบแจ้งหนี้',
  Cargo_InvoicingCompleted: 'การออกใบเรียกเก็บเงินเสร็จสิ้น',
  Cargo_InvoicingCurrency: 'สกุลเงินใบเรียกเก็บเงิน',
  Cargo_InvoicingDateBusinessDate: 'วันที่ออกใบแจ้งหนี้ วันที่ทำธุรกิจ',
  Cargo_InvoicingHeadCannotBeEmpty: 'ใบแจ้งหนี้ไม่สามารถเว้นว่างได้',
  Cargo_InvoicingInformation: 'ข้อมูลการออกใบแจ้งหนี้',
  Cargo_InvoicingListNo: 'หมายเลขใบแจ้งหนี้',
  Cargo_InvoicingMachineNo: 'หมายเลขตั๋ว',
  Cargo_InvoicingMethod: 'วิธีการออกใบแจ้งหนี้',
  Cargo_InvoicingMethodP: 'วิธีการเรียกเก็บเงิน:',
  Cargo_InvoicingMode: 'โหมดใบแจ้งหนี้',
  Cargo_InvoicingPerBill: 'ใบเรียกเก็บเงินใบเดียว',
  Cargo_InvoicingPerMonth: 'ใบแจ้งยอดรายเดือน',
  Cargo_InvoicingRequirements: 'ข้อกำหนดการออกตั๋ว',
  Cargo_InvoicingSearch: 'สอบถามการออกตั๋ว',
  Cargo_InvoicingStatus: 'สถานะใบแจ้งหนี้',
  Cargo_InvoicingType: 'ประเภทของใบแจ้งหนี้',
  Cargo_InvoicingVerification: 'การตรวจสอบใบแจ้งหนี้',
  Cargo_IOSPIM: 'วัตถุของการตั้งถิ่นฐานจะต้องป้อนข้อมูล',
  Cargo_IPCTFATROJE: 'พารามิเตอร์ที่ไม่ถูกต้องไม่พบกฎของรายการ',
  Cargo_IsBroken: 'สำหรับหมายเลขหัก',
  Cargo_IsExtended: 'ไม่ว่าจะเกินกำหนด',
  Cargo_IsItAR: 'ไม่ว่าจะเป็นการรับน้อง',
  Cargo_IsItCollection: 'ไม่ว่าจะเป็นการรับเงิน',
  Cargo_IsItDefaultExpense: 'ไม่ว่าจะเป็นค่าปริยาย',
  Cargo_IsCharterFlightCosts: 'ไม่ว่าจะเป็นค่าเช่าเหมาลำ',
  Cargo_IsCharterVesselCosts: 'ไม่ว่าจะเป็นการเหมาจ่ายค่าบอร์ด',
  Cargo_IsCharterFlight: 'ไม่ว่าจะเป็นเที่ยวบินเช่าเหมาลำ',
  Cargo_IsCharterVessel: 'ไม่ว่าจะเป็นการหุ้มบอร์ด',
  Cargo_Number_Of_Charter_Containers: 'จำนวนคอนเทนเนอร์เช่าเหมาลำ',
  Cargo_Charter_weight_Restrictions: 'การจำกัดน้ำหนักเครื่องบินเช่าเหมาลำ',
  Cargo_Charter_Volume_Restrictions: 'จำกัด ปริมาณการเช่าเหมาลำ',
  Cargo_Description_of_the_package_Information: 'รายละเอียดข้อมูลแพ็คบอร์ด',
  Cargo_Pallets_can_be_loaded_in_Weight: 'น้ำหนักบรรทุกของแผ่นห่อ',
  Cargo_Packing_Plates_Can_Be_Loaded_In_Volume: 'ปริมาณแผ่นห่อสามารถโหลดได้',
  Cargo_The_Total_Cost_Amount: 'จำนวนค่าใช้จ่ายทั้งหมด',
  Cargo_Unit_Load_Device: 'คอนเทนเนอร์',
  Cargo_MountingInformation: 'ข้อมูลการติดตั้งบอร์ด',
  Cargo_Please_Load_The_Main_Ticket: 'กรุณาดำเนินการโหลดบอร์ดที่ตั๋วหลัก',
  Cargo_Please_Empty_And_Load_The_Main_Ticket_For_The_Operation: 'กรุณาดำเนินการติดตั้งบอร์ดที่เคาน์เตอร์หลัก',
  Cargo_OtherBusinessUse: 'การใช้ธุรกิจอื่น ๆ',
  Cargo_DefaultArSettlementObject: 'วัตถุชำระหนี้คงที่ปริยาย',
  Cargo_DefaultArSettlementObjectNull: 'วัตถุที่รับโดยปริยายว่างอยู่หรือไม่',
  Cargo_DefaultApSettlementObject: 'ค่าเริ่มต้นที่จะจัดการกับวัตถุการตั้งถิ่นฐานคงที่',
  Cargo_DefaultApSettlementObjectNull: 'วัตถุเจ้าหนี้ปริยายว่างเปล่าหรือไม่',
  Cargo_IsItWriteOff: 'ไม่ว่าจะเป็นการป้องกันความเสี่ยง',
  Cargo_IsoCode: 'รหัส ISO',
  Cargo_IsShutOut: 'ไม่ว่าจะเป็นการถอนตัว',
  Cargo_IssuanceReceiptOfInvoice: 'การออกใบแจ้งหนี้และการเก็บตั๋ว',
  Cargo_Issued: 'เผยแพร่แล้ว',
  Cargo_IssueHbl: 'ไม่ว่าจะเป็นการเซ็นสัญญากับ HBL',
  Cargo_IssueInvoiceDirectly: 'สร้างใบแจ้งหนี้โดยตรง',
  Cargo_IssueInvoiceDirectlyOrNot: 'ไม่ว่าจะเป็นการออกตั๋วโดยตรง',
  Cargo_IssueOfTheYear: '{0} ปี {1}',
  Cargo_ISWBDC: 'แน่ใจนะว่าคุณต้องการลบข้อมูล {0} รายการนี้?',
  Cargo_Item: 'โครงการ',
  Cargo_Item1: 'โครงการ I',
  Cargo_Item2: 'โครงการที่สอง',
  Cargo_ItemNo: 'หมายเลขสินค้า',
  Cargo_ItemNo2P: 'หมายเลขสินค้า 2:',
  Cargo_ItemNoP: 'หมายเลขสินค้า:',
  Cargo_ItemsAdded: 'เพิ่มแถบ {0}',
  Cargo_ItemsNBR: 'จำนวนชิ้น',
  Cargo_ReturnContainerAddress: 'ที่อยู่คืนตู้คอนเทนเนอร์',
  Cargo_LoadingAddress: 'ที่อยู่ในการบรรจุตู้',
  Cargo_ITIOCBNMPCBITIITBCPOTS: 'บัตรประจำตัวผู้ออกใบแจ้งหนี้ของสาขาปัจจุบันไม่ได้รับการบำรุงรักษา กรุณากำหนดค่าบัตรประจำตัวผู้ออกใบแจ้งหนี้ของบ้านวังในการกำหนดค่าพื้นฐาน',
  Cargo_ITPIEI: 'ประเภทใบแจ้งหนี้ ใบแจ้งหนี้กระดาษ ใบแจ้งหนี้อิเล็กทรอนิกส์',
  Cargo_IYDTRIAACWTACYIYWTKTAABFFIACNCTCIA: 'หากท่านได้ตัดสินใจยกเลิกการขอใบแจ้งหนี้ร่วมกับผู้สมัครแล้ว กรุณาคลิก "ใช่" หากเก็บใบคำขอออกใบแจ้งหนี้ไว้เป็นพื้นฐานสำหรับการออกใบแจ้งหนี้ในอนาคต กรุณาคลิก "ไม่" เพื่อยืนยันการยกเลิกใบคำขอออกใบแจ้งหนี้หรือไม่?',
  Cargo_January: 'มกราคม',
  Cargo_JEODTD: 'รายการประเภทข้อมูล ({0}) ถูกลบไปแล้ว!',
  Cargo_JEOOSC: 'ไม่ว่าจะเป็นรายการศูนย์พักชำระหนี้ในต่างประเทศ',
  Cargo_JFOCP: 'ฟิลด์แยกคำรับเงิน',
  Cargo_JobListSearched: 'รายการงานที่สอบถามแล้ว',
  Cargo_JobNo: 'หมายเลขงาน',
  Cargo_JobNoP: 'หมายเลขงาน:',
  Cargo_JobTypeImport: 'นำเข้า',
  Cargo_JournalEntryCategory: 'ประเภทการบันทึก',
  Cargo_JournalEntryRule: 'กฎของรายการ',
  Cargo_July: 'กรกฎาคม',
  Cargo_June: 'มิถุนายน',
  Cargo_KeyWord: 'คำที่ละเอียดอ่อน',
  Cargo_KeyWordCanTBeEmpty: 'คำที่ละเอียดอ่อนต้องไม่ว่างเปล่า',
  Cargo_KingdeeCloudApprove: 'JindieCloud รีวิว',
  Cargo_KingdeeCloudReview: 'รีวิว Jindieyun',
  Cargo_LastAccrualTime: 'เวลานับล่าสุด',
  Cargo_LastDate: 'วันที่ล่าสุด',
  Cargo_LastInvoiceNo: 'หมายเลขใบแจ้งหนี้สุดท้าย',
  Cargo_LastModificationTime: 'เวลาแก้ไขล่าสุด:',
  Cargo_LastReceiveDate: 'วันที่รับเงินล่าสุด',
  Cargo_LastReceivingDate: 'วันที่รับเงินล่าสุด',
  Cargo_LastTimeBalance: 'ยอดคงเหลือล่าสุด',
  Cargo_LBNRYSTW: 'ธุรกิจที่เกี่ยวข้องยังไม่ได้รับการตรวจสอบ,ยืนยันจะคืนเงิน?',
  Cargo_LegalUnit: 'หน่วยกฎหมาย',
  Cargo_Lender: 'ผู้ให้กู้',
  Cargo_LessThan: 'น้อยกว่า',
  Cargo_Letter: 'คำศัพท์',
  Cargo_Level: 'ระดับ',
  Cargo_Level1AccountTitle: 'ระดับ 1 วิชา',
  Cargo_Level2AccountTitle: 'วิชาที่สอง',
  Cargo_Level3AccountTitle: 'ระดับ 3 วิชา',
  Cargo_Level4AccountTitle: 'ระดับ 4 วิชา',
  Cargo_Level5AccountTitle: 'ระดับ 5 วิชา',
  Cargo_Level6AccountTitle: 'ระดับ 6 วิชา',
  Cargo_Limit: 'วงเงิน',
  Cargo_LinkBills: 'ไม่ว่าจะเป็นการเรียกเก็บเงินที่เกี่ยวข้อง',
  Cargo_LinkOffsetExpenseDifferentials: 'ไม่ว่าจะเป็นความเกี่ยวข้องความแตกต่างของค่าธรรมเนียมป้องกันความเสี่ยง',
  Cargo_LinkPaymentRequests: 'ไม่ว่าจะเป็นการยื่นคำร้องขอจ่ายเงินที่เกี่ยวโยงกัน',
  Cargo_LinkToInvoice: 'เชื่อมโยงกับใบแจ้งหนี้',
  Cargo_Load: 'กำลังโหลด',
  Cargo_LoadCache: 'กำลังโหลดแคช',
  Cargo_Loaded: 'โหลดเสร็จสมบูรณ์',
  Cargo_LoadedAndSave: 'โหลดเสร็จแล้วแตะบันทึก',
  Cargo_LoadingAtDoor: 'กล่องจุดประตู',
  Cargo_LoadingAtFactory: 'ชุดผลิต',
  Cargo_LoadOrNot: 'กำลังโหลดหรือไม่',
  Cargo_Loan: 'สินเชื่อ',
  Cargo_LoanSwap: 'สินเชื่อแลกเปลี่ยน',
  Cargo_LocalAgent: 'ตัวแทนท้องถิ่น',
  Cargo_LocalCharge: 'ค่าธรรมเนียมท้องถิ่น',
  Cargo_LocalChargeOrNot: 'ไม่ว่าจะเป็นค่าใช้จ่ายในพื้นที่',
  Cargo_LocalCurrency: 'เหรียญท้องถิ่น',
  Cargo_LocalizedName: 'ชื่อแปล',
  Cargo_Location: 'สถานที่ตั้ง',
  Cargo_LocationOfCurrentVoucher: 'สถานที่ตั้งของบัตรกำนัลปัจจุบัน',
  Cargo_LockCancellationDate: 'ล็อควันที่ยกเลิก',
  Cargo_LockTheBill: 'ล็อคแผ่น',
  Cargo_Log: 'บันทึกประจำวัน',
  Cargo_LogisticsCompany: 'บริษัทโลจิสติกส์',
  Cargo_LogRecord: 'เข้าสู่ระบบ',
  Cargo_LOTFINMBGT3D: 'หมายเลขใบแจ้งหนี้ใบแรกต้องมีความยาวมากกว่าสามหลัก',
  Cargo_LowerCase: 'ตัวพิมพ์เล็ก',
  Cargo_MainLineTransport: 'การขนส่งหลัก',
  Cargo_MaintenanceOfShippingTerms: 'การบำรุงรักษาเงื่อนไขการขนส่ง',
  Cargo_ManagementOfWithdrawal: 'การจัดการการคืนเงิน',
  Cargo_ManageParameters: 'การจัดการพารามิเตอร์แบบสอบถาม',
  Cargo_MANMWCSAISCTD: 'ที่อยู่จัดส่งแตกต่างจากที่อยู่ลูกค้าในข้อมูลการบำรุงรักษาระบบแน่ใจหรือไม่ว่าต้องการส่งออก',
  Cargo_March: 'มีนาคม',
  Cargo_Mark: 'เครื่องหมาย',
  Cargo_MarkTime: 'ทำเครื่องหมายเวลา',
  Cargo_Marker: 'แท็กโดย',
  Cargo_MarkStatus: 'สถานะเครื่องหมาย',
  Cargo_MarkCancelledSuccessfully: 'ยกเลิกการทำเครื่องหมายสำเร็จ',
  Cargo_MarkDate: 'วันที่ระบุ',
  Cargo_Marked: 'แท็กความสำเร็จ',
  Cargo_MarkedBy: 'แท็กโดย',
  Cargo_MarkOfConfirmation: 'ยืนยันเครื่องหมาย',
  Cargo_Marks: 'เครื่องหมายการจัดส่งสินค้า',
  Cargo_MarkSymbols: 'เครื่องหมายโลโก้',
  Cargo_MasterBillNotSearched: 'ไม่มีการสอบถามเกี่ยวกับตั๋วหลัก',
  Cargo_May: 'พฤษภาคม',
  Cargo_MBACM: 'แก้ไขวิธีการคำนวณยอดบิล',
  Cargo_MBEIRPSUB: 'มีบิลที่ทำเครื่องหมายไว้ในบันทึก โปรดเลือกบิลที่ไม่ได้ทำเครื่องหมาย',
  Cargo_MBLAudit: 'รีวิว MBL',
  Cargo_MBLCargoDetention: 'สินค้าหัวเข็มขัด MBL',
  Cargo_MBLFreightTerm: 'เงื่อนไขการจัดส่งสินค้าสำหรับคำสั่งซื้อหลัก',
  Cargo_MblNo: 'หมายเลขเดี่ยวหลัก',
  Cargo_MBLPayable: 'การชำระเงิน MBL',
  Cargo_MBLPaymentTime: 'เวลาชำระเงิน MBL',
  Cargo_MBLReviewTime: 'เวลาตรวจสอบ MBL',
  Cargo_MBLTimeOfCargoHolding: 'MBL หักเวลาสินค้า',
  Cargo_MBLTransitTerm: 'เงื่อนไขการจัดส่งสินค้า',
  Cargo_MDEPSBP: 'มีการแก้ไขข้อมูลให้บันทึกแล้วพิมพ์',
  Cargo_MDEPSBPIN: 'มีการแก้ไขข้อมูลโปรดบันทึกก่อนที่จะพิมพ์ [หมายเลขใบแจ้งหนี้: {0}]',
  Cargo_Merge: 'เริ่มต้นการควบรวมกิจการ',
  Cargo_MergeOrNot: 'ไม่ว่าจะเป็นการควบรวมกิจการ',
  Cargo_MethodOfClaim: 'รูปแบบการเรียกร้อง',
  Cargo_MethodOfClaimP: 'รูปแบบการเรียกร้อง:',
  Cargo_Metrics: 'วัดมาตรฐาน',
  Cargo_MfnTaxRate: 'อัตราภาษีประเทศที่ชื่นชอบมากที่สุด',
  Cargo_Mode: 'โหมด',
  Cargo_ModelSpecification: 'สเปค แบบ',
  Cargo_ModificationOfCollection: 'การปรับเปลี่ยนการเรียกเก็บเงิน',
  Cargo_ModificationTime: 'แก้ไขเวลา',
  Cargo_ModifiedDataNotSavedCancel: 'ข้อมูลที่แก้ไขไม่ได้ถูกบันทึก ยืนยันการยกเลิก?',
  Cargo_Modifier: 'แก้ไขโดย',
  Cargo_Modify: 'การปรับเปลี่ยน',
  Cargo_ModifyAccountTitle: 'แก้ไขรายวิชา',
  Cargo_ModifyAccountTitleName: 'แก้ไขชื่อวิชา',
  Cargo_ModifyAdjustBill: 'การเรียกเก็บเงิน - การปรับเปลี่ยน',
  Cargo_ModifyBillingInformation: 'แก้ไขข้อมูลการเรียกเก็บเงิน',
  Cargo_ModifyCollectionInformation: 'การแก้ไขข้อมูลการเรียกเก็บ',
  Cargo_ModifyInvoice: 'แก้ไขใบแจ้งหนี้',
  Cargo_ModifyPort: 'การปรับเปลี่ยนพอร์ต',
  Cargo_ModifyRailwayStation: 'การปรับเปลี่ยนสถานีรถไฟ',
  Cargo_ModifyOverseaWarehouse: 'แก้ไขคลังในต่างประเทศ',
  Cargo_AddOverseaWarehouse: 'เพิ่มคลัง Amazon',
  Cargo_NewOverseaWarehouse: 'เพิ่มคลังในต่างประเทศ',
  Cargo_CannotDeleteWarehouse: '{0} มีการใช้รหัสคลังสินค้าและไม่สามารถลบได้!',
  Cargo_ModifyRateWithTax: 'แก้ไขราคารวมภาษี',
  Cargo_ModifySelectedInvoiceStatus: 'แก้ไขสถานะใบแจ้งหนี้ที่เลือก',
  Cargo_ModifyWriteOffRecord: 'แก้ไขบันทึกการชำระหนี้',
  Cargo_MOMAOB: 'การบำรุงรักษายอดคงเหลือเริ่มต้นงวดช่วยเหลือลูกค้า',
  Cargo_MonetaryEquivalent: 'จำนวนคณ',
  Cargo_MonetaryEquivalentCNY: 'คำนวณ CNY ทั้งหมด',
  Cargo_Month: 'เดือน',
  Cargo_FinanceMonthUnitTip: 'คำนวณตามปฏิทิน: เส้นตัดคือ N เดือนก่อนวันที่ 1 ของเดือนปัจจุบัน ล็อกเฉพาะข้อมูลก่อนเส้นตัด (ไม่รวมวันเส้นตัด) เช่น ตั้งค่า 2 เดือนในเดือนกันยายน จะล็อกข้อมูลก่อนวันที่ 1 กรกฎาคม (ไม่รวม 1 กรกฎาคม)',
  Cargo_Monthly: 'ปมเดือน',
  Cargo_MonthlyReconciliation: 'การปรองดองรายเดือน',
  Cargo_Months: 'เดือน',
  Cargo_MoreConditions: 'เงื่อนไขเพิ่มเติม',
  Cargo_MoreSearch: 'สอบถามเพิ่มเติม',
  Cargo_Motorcade: 'กองเรือ',
  Cargo_MscServiceCode: 'รหัสบริการ',
  Cargo_MultipleChoiceBox: '【หลายช่อง】',
  Cargo_MultipleCurrenciesExit: 'มีหลายสกุลเงิน',
  Cargo_MultipleSettlingPartiesExist: 'มีการตั้งถิ่นฐานหลายรายการ',
  Cargo_MUPIOOPFWO: 'ไม่ว่าจะต้องใช้บัญชีรับและจ่ายจริง',
  Cargo_MustSelectTheSameClient: 'ต้องเลือกลูกค้าเดิม',
  Cargo_MVOACP: 'ไม่ว่าจะเป็นการรักษาบัตรกำนัล Prepaid',
  Cargo_MVOARAPOI: 'ไม่ว่าจะเป็นการรักษาใบรับรองใบแจ้งหนี้การป้องกันความเสี่ยงของลูกหนี้',
  Cargo_Name: 'ชื่อ',
  Cargo_NameCanTBeEmpty: 'ชื่อไม่สามารถเว้นว่างได้',
  Cargo_EnglishNameCheck: 'ชื่อภาษาอังกฤษไม่สามารถเว้นว่างได้',
  Cargo_ExistDoorSite: 'มีข้อมูลจุดเดียวกันอยู่แล้ว',
  Cargo_PleaseSelectCommissioningUnit: 'โปรดเลือกหน่วยงานในหุ้นส่วน',
  Cargo_PleaseInputOneDoorInfoAtLeast: 'กรุณากรอกข้อมูล Door Point อย่างน้อยหนึ่งรายการ',
  Cargo_LandTransportationDetails: 'แก้ไขรายละเอียดการขนส่งทางบก',
  Cargo_NameP: 'ชื่อ:',
  Cargo_NAMISANOSNBCWBRS2DPTED: 'หมายเหตุ: วิธีการแจ้งเตือนคือ "ระบบแจ้งเตือน" ระบบจะแจ้งเตือนอีกครั้งในวันที่ 2 ก่อนวันหมดอายุห้ามสร้าง Business Configuration',
  Cargo_NatureOfSales: 'ขายทรัพย์สิน',
  Cargo_NBCTBGTC: 'ส่วนต่างติดลบต้องไม่เกิน -1 เพนนี',
  Cargo_NECDFTIC: 'ไม่เกิน {0} สกุลเงินที่แตกต่างจากสกุลเงินที่ออกใบแจ้งหนี้',
  Cargo_BillPaymentCurrencyBeyond: 'ไม่เกิน {0} สกุลเงินที่แตกต่างจากการชำระเงิน!',
  Cargo_PayByBillingRate: 'ชำระด้วยอัตราแลกเปลี่ยนตามบิล',
  Cargo_NeedAccountingPeriod: 'ขออภัย ซอฟต์แวร์เวอร์ชั่นของชุดบัญชีที่คุณใช้อยู่ในขณะนี้"ซอฟต์แวร์บัญชีวอเตอร์"ต้องกำหนดระยะเวลาบัญชีเพื่อแก้ไขรายวิชา',
  Cargo_NeedAccrue: 'ไม่ว่าจะเป็นการนับคะแนน',
  Cargo_NeedCustomsDeclare: 'ไม่ว่าจะเป็นการประกาศศุลกากร',
  Cargo_NeedHqToWriteOffOrNot: 'ไม่ว่าจะต้องเช็กเอาต์ผ่านสำนักงานใหญ่',
  Cargo_NeedInvoiceOrNot: 'ไม่ว่าจะเป็นการเรียกเก็บเงินที่จำเป็น',
  Cargo_NeedMandatoryAccrue: 'ไม่ว่าจะเป็นการบังคับคดี',
  Cargo_NeedToBillCNYToCNY: 'จำเป็นต้องเรียกเก็บเงินจาก {0} {1}RMB',
  Cargo_NeedToConfiCNYankAccountOrNot: 'ไม่ว่าจะเป็นการยืนยันเลขบัญชีธนาคาร',
  Cargo_NeedToCreateBillOrNot: 'คุณต้องการสร้างบิลหรือไม่?',
  Cargo_NeedToExportOrNot: 'จำเป็นต้องส่งออกหรือไม่',
  Cargo_NeedToPayTo: 'ต้องจ่ายให้กับ {0} {1}RMB',
  Cargo_NEFEIDE: 'มีการกรองแบบไม่ว่างเปล่าเมื่อส่งออกโดยปริยาย',
  Cargo_NegotiationStage: 'เวทีธุรกิจ',
  Cargo_NEIAFPRPOCA: 'ไม่มีค่าธรรมเนียมในการสมัคร กรุณารีเฟรชหน้าเว็บหรือติดต่อผู้ดูแลระบบ',
  Cargo_NEICTBD: 'ไม่สามารถดาวน์โหลดใบแจ้งหนี้ที่ไม่ใช่อิเล็กทรอนิกส์',
  Cargo_NetWork: 'เครือข่าย',
  Cargo_NetworkName: 'ชื่อเครือข่าย',
  Cargo_NetworkNameCanTBeEmpty: 'ชื่อเครือข่ายต้องไม่ว่างเปล่า',
  Cargo_New: 'สร้างใหม่',
  Cargo_NewAccountStatement: 'ใบแจ้งยอดบัญชีใหม่',
  Cargo_NewAccountTitle: 'หัวข้อใหม่',
  Cargo_NewFiscalPeriod: 'รอบระยะเวลาบัญชีใหม่',
  Cargo_NewInvoiceNo: 'หมายเลขใบแจ้งหนี้ใหม่',
  Cargo_NewInvoiceNoP: 'หมายเลขใบแจ้งหนี้ใหม่:',
  Cargo_NewPaymentRequest: 'สร้างใบสมัครการชำระเงิน',
  Cargo_NewValue: 'ค่าใหม่',
  Cargo_Next: 'ขั้นตอนต่อไป',
  Cargo_NextItem: 'ถัดไป',
  Cargo_NextStep: 'ภารกิจถัดไป',
  Cargo_NextStepToSave: 'บันทึกถัดไป',
  Cargo_NFFICSPRE: 'ไม่พบแฟ้มจัดเก็บข้อมูลบนคลาวด์ โปรดส่งออกใหม่',
  Cargo_NFMKWPEAW: 'หมายเหตุ: คำที่ละเอียดอ่อนหลายคำโปรดป้อนกลับเพื่อเปลี่ยนบรรทัด',
  Cargo_NFPAFTS: 'ไม่มีช่วงเวลาทางการเงินที่พร้อมใช้งานในซองบัญชีนี้',
  Cargo_NFPSCATWBSACYCTS: 'เนื่องจากไม่มีรอบระยะเวลาบัญชี ปีวิชาปัจจุบันจะตั้งปีนี้ยืนยันว่าจะเก็บไว้ต่อไป',
  Cargo_NMT2MCTAIEAWO: 'มากกว่าสองสกุลเงินที่แตกต่างจากสกุลเงินตัดบัญชีไม่สามารถปรากฏในค่าธรรมเนียม',
  Cargo_NNTCVFCOPL: 'ไม่จำเป็นต้องสร้างบัตรกำนัล Carryover กำไรและขาดทุน',
  Cargo_NNTEIBOPLBFSOATBOTY: 'ซองที่เปิดใช้งานตั้งแต่ต้นปี ไม่ต้องใส่ยอดเงินเริ่มต้นของกำไรและขาดทุนนะ',
  Cargo_No: 'ไม่',
  Cargo_NOATGCAAIODMBETTGMO: 'เงื่อนไขการจัดกลุ่มวิชาเรียงหมายเลขตามลำดับข้อมูลต้องเท่ากับการจัดกลุ่มวิชาลบหนึ่ง!',
  Cargo_NoBillToConfirm: 'ยังไม่มีการเรียกเก็บเงินมายืนยัน',
  Cargo_NoBillToCreateSoa: 'ไม่มีการเรียกเก็บเงินเพื่อทำใบแจ้งยอด',
  Cargo_NoBillToWriteOff: 'ไม่มีบิลที่ต้องตัดบัญชี',
  Cargo_NoBusinessNeedFinancialReview: 'ไม่มีธุรกิจให้ตรวจสอบทางการเงิน',
  Cargo_NoBusinessTypeSelected: 'ประเภทธุรกิจ ไม่มีตัวเลือก',
  Cargo_NoCitySelectedToEdit: 'ยังไม่มีการเลือกเมืองที่จะแก้ไข',
  Cargo_NoConfirmedBillToCancel: 'ไม่มีการเรียกเก็บเงินเพื่อยกเลิกการยืนยัน',
  Cargo_NoData: 'ไม่มีข้อมูล',
  Cargo_NoDataModifiedNoNeedToSave: 'ไม่มีการแก้ไขข้อมูลไม่จำเป็นต้องบันทึก',
  Cargo_NoDataSelected: 'ยังไม่มีการเลือกข้อมูล',
  Cargo_NoDataSelectedToDelete: 'ยังไม่มีการเลือกข้อมูลที่จะลบ',
  Cargo_NoDataToExport: 'ไม่มีข้อมูลที่จะส่งออก',
  Cargo_NoDataToModify: 'ไม่มีข้อมูลที่สามารถแก้ไขได้',
  Cargo_NoDataToPreview: 'ไม่มีข้อมูลแสดงตัวอย่าง',
  Cargo_NoDataToTransfer: 'ไม่มีข้อมูลที่สามารถส่งได้',
  Cargo_NoDoNotLink: 'ไม่ ฉันไม่มีความสัมพันธ์',
  Cargo_NOEGT1ICTSTNWBST1C: 'จำนวนค่าธรรมเนียมมากกว่า 1 ถ้าแยกค่าใช้จ่ายต่อไปจะตั้งจำนวนเป็น 1 แน่ใจหรือไม่ว่าต้องการต่อ',
  Cargo_NoElectronicInvoiceNoToCreate: 'ไม่มีการสร้างหมายเลขใบแจ้งหนี้อิเล็กทรอนิกส์',
  Cargo_NoEligibleExpenseToPrint: 'ไม่มีค่าธรรมเนียมในการพิมพ์',
  Cargo_NoEligibleRecord: 'ไม่มีประวัติเข้าข่าย',
  Cargo_NoEligibleRecordsFound: 'ไม่มีการสอบถามไปยังบันทึกที่ตรงกับความต้องการ',
  Cargo_NoExpenseDifferentialsToProcess: 'ไม่มีค่าใช้จ่ายส่วนต่างที่ต้องดูแล',
  Cargo_NoExpenseToBill: 'ไม่มีค่าธรรมเนียมในการทำบิล',
  Cargo_NoExpenseToInvoice: 'ไม่มีค่าธรรมเนียมในการออกใบแจ้งหนี้',
  Cargo_NoExpenseToReject: 'ไม่มีค่าธรรมเนียมการยกเลิก',
  Cargo_NoExpenseToReview: 'ไม่มีค่าธรรมเนียมที่ตรวจสอบได้',
  Cargo_NoExpenseToWriteOff: 'ไม่มีค่าธรรมเนียมการขาย',
  Cargo_NoFileToRetrieve: 'ไม่มีเอกสารมารับคืน',
  Cargo_NoFileToRevoke: 'ไม่มีเอกสารที่จะเพิกถอนได้',
  Cargo_NoForeignCurrencyAccounting: 'ไม่มีการทำบัญชีเงินตราต่างประเทศ',
  Cargo_NoInvoiceNo: 'ไม่มีหมายเลขใบแจ้งหนี้',
  Cargo_NoInvoiceNoForInvoiceAmounted: 'ใบแจ้งหนี้ที่มีจำนวน {0} ไม่มีหมายเลขใบแจ้งหนี้!',
  Cargo_NoInvoiceNoToCheck: 'ไม่มีเลขที่ใบแจ้งหนี้ที่ต้องตรวจสอบ',
  Cargo_NoMaintainedBankForClient: 'ลูกค้าไม่ได้รักษาธนาคาร',
  Cargo_NoMatchedRecordFound: 'ไม่พบประวัติตรงตามข้อกำหนด',
  Cargo_NominatedAgent: 'ตัวแทนจัดส่งสินค้า',
  Cargo_NonAccrual: 'ไม่ได้นับรวม',
  Cargo_None: 'ไม่มี',
  Cargo_NoneAnyBillable: 'ไม่มีค่าธรรมเนียมการออกตั๋ว',
  Cargo_NoNeedToRepeatConfirmation: 'ยืนยันไม่จำเป็นต้องยืนยันอีกครั้ง',
  Cargo_NoNeedToSplitThisKeyWord: 'ไม่จำเป็นต้องแยกคำที่ละเอียดอ่อนนี้',
  Cargo_NonElectronicInvoice: 'ใบแจ้งหนี้ที่ไม่ใช่อิเล็กทรอนิกส์',
  Cargo_NonSplitWriteOffExpense: 'ค่าใช้จ่ายที่ไม่สามารถแบ่งชำระหนี้ได้',
  Cargo_NoNumberBreak: 'ไม่มีเลขหัก',
  Cargo_NoOfPages: 'จำนวนหน้า',
  Cargo_NoParentAccountTitles: 'วิชาที่ไม่มีผู้บังคับบัญชา',
  Cargo_NoPortSelected: 'ท่าเรือ ไม่มีตัวเลือก',
  Cargo_NoRecordChecked: 'ไม่มีการทำเครื่องหมายบันทึก',
  Cargo_NoRecordSelected: 'ยังไม่มีการเลือกระเบียน',
  Cargo_NoRecordToSave: 'ไม่มีประวัติที่บันทึกไว้',
  Cargo_NoRelease: 'ไม่ใส่แผ่น',
  Cargo_NoReviewedExpenseToCancel: 'ไม่มีค่าธรรมเนียมการยกเลิกการตรวจสอบ',
  Cargo_NoServiceTicketToDelete: 'ไม่มีใบยืนยันค่าใช้จ่ายที่สามารถลบได้',
  Cargo_NoSiteSelected: 'เว็บไซต์ไม่ได้เลือก',
  Cargo_NoSobSetUpCurrently: 'ขณะนี้ยังไม่มีการตั้งซองแต่อย่างใด',
  Cargo_NotAcquired: 'ไม่ได้รับ',
  Cargo_NotAdjustedExpense: 'ค่าธรรมเนียมที่ไม่ปรับ',
  Cargo_NotAFinalAccountTitle: '【{0}}】 ไม่ใช่วิชาสุดท้าย',
  Cargo_NotCarriedOver: 'เปิด Carryover',
  Cargo_NotCollectAdvance: 'การชำระเงินดาวน์ที่ไม่ใช่ตัวแทน',
  Cargo_NotCollected: 'ยังไม่ได้รับ',
  Cargo_NotCollectedCNY: 'CNY ยังไม่ได้รับ',
  Cargo_NotCollectedEUR: 'EUR ยังไม่ได้รับ',
  Cargo_NotCollectedGBP: 'GBP ยังไม่ได้รับ',
  Cargo_NotCollectedHKD: 'HKD ยังไม่ได้รับ',
  Cargo_NotCollectedInFull: 'ไม่เก็บ',
  Cargo_NotCollectedJPY: 'JPY ยังไม่ได้รับ',
  Cargo_NotCollectedNGN: 'NGN ยังไม่ได้รับ',
  Cargo_NotCollectedP: 'ยังไม่ได้รับ:',
  Cargo_NotCollectedUSD: 'USD ยังไม่ได้รับ',
  Cargo_Collected: 'ได้รับแล้ว',
  Cargo_NotContracted: 'ไม่ได้เซ็นสัญญา',
  Cargo_NotDisplayedIfMultipleItemsExist: 'ไม่แสดงเมื่อมีหลายแถบ',
  Cargo_NOTDIST: 'แสดงจำนวนเทมเพลตในป้ายหน้าสอบถาม',
  Cargo_NotificationOfPaymentFreeze: 'แจ้งอายัดชำระเงิน',
  Cargo_NotificationOfUnfrozenPayment: 'แจ้งการชำระเงินสำหรับการยกเลิกการแช่แข็ง',
  Cargo_NotifyHq: 'แจ้งสำนักงานใหญ่',
  Cargo_NotifyId: 'รหัสผู้แจ้ง',
  Cargo_NotifyInfo: 'ข้อมูลผู้แจ้ง',
  Cargo_NotifyParty: 'แจ้งโดย',
  Cargo_NotifyPartySName: 'ชื่อผู้แจ้ง',
  Cargo_NotifyUser: 'แจ้งเตือนผู้ใช้',
  Cargo_NotifyMethod: 'วิธีการแจ้งเตือน',
  Cargo_NotInvoicedMoney: 'จำนวนเงินที่ยังไม่เรียกเก็บ',
  Cargo_NoTotal: 'แผ่น {0} ของ {1}',
  Cargo_NotReviewed: 'ยังไม่ได้ตรวจสอบ',
  Cargo_NotSent: 'ยังไม่ได้ส่ง',
  Cargo_NotSet: 'ยังไม่ได้ตั้งค่า',
  Cargo_NotSubmittedCanTWithdraw: 'ไม่สามารถคืนเงินหากไม่ยื่น',
  Cargo_NotTaxFree: 'ไม่ได้ยกเว้นภาษี',
  Cargo_NotWrittenBack: 'ไม่แดง',
  Cargo_NotWrittenOff: 'ยกเลิกการเพิกถอน',
  Cargo_NotWrittenOff2: 'ยอดคงเหลือ RMB',
  Cargo_NotWrittenOffCurrency: 'ไม่มีขาย ({0})',
  Cargo_NotWrittenOffHKD: 'ไม่มีขาย (HKD)',
  Cargo_NotWrittenOffUSD: 'ไม่มีขาย (USD)',
  Cargo_NoUnInvoicedExpense: 'ไม่มีค่าธรรมเนียมการออกตั๋วค้างชำระ',
  Cargo_November: 'พฤศจิกายน',
  Cargo_NPDOSB: 'ไม่มีข้อมูลเบื้องต้นเกี่ยวกับยอดเงินเสริม',
  Cargo_NRFTAL: 'ตนเองดึง self-feed',
  Cargo_NSEFPCA: 'ไม่พบค่าธรรมเนียมแยก, ติดต่อผู้ดูแลระบบ!',
  Cargo_NTWBWRLION: 'คุณต้องการออกใบแจ้งหนี้ตัวอักษรสีแดงหรือไม่?',
  Cargo_Number: 'หมายเลข',
  Cargo_NumberS: 'หมายเลข',
  Cargo_NumberOfAttachedDocuments: 'จำนวนเอกสารแนบ',
  Cargo_NumberOfCopies: 'จำนวนสำเนา',
  Cargo_NumberOfCopiesCanTBe0: 'จำนวนสำเนาต้องไม่เป็น 0',
  Cargo_NumberOfExpenseWriteOffs: 'ค่าธรรมเนียมการขายบัญชี จำนวน',
  Cargo_NumberOfNominatedAgents: 'ระบุจำนวนตัวแทน',
  Cargo_OBCILC: 'ยอดคงเหลือเบื้องต้น (Combined Native Coin)',
  Cargo_OBIMICMAWTCSCCPBR: 'ธนาคารต้องระบุวิธีการรับชำระค่าน้ำเมื่อชำระด้วยเช็ค แคชเชียร์เช็ค',
  Cargo_OceanExport: 'ส่งออกทางทะเล',
  Cargo_OceanFreight: 'การขนส่งทางทะเล',
  Cargo_OceanImport: 'นำเข้าทางทะเล',
  Cargo_OceanImportExport: 'เข้าและออกทางทะเล',
  Cargo_OCLWSPCBS: 'เลือกได้เฉพาะลูกค้าที่เกี่ยวข้องกับการขาย',
  Cargo_October: 'ตุลาคม',
  Cargo_Oddment: 'บัญชีระยะสั้น',
  Cargo_ODWSSCBP: 'สามารถพิมพ์เอกสารสถานะเดียวกันได้เท่านั้น',
  Cargo_OEOSET: 'ส่วนของเจ้าของหรือผู้ถือหุ้นรวม',
  Cargo_OEVCBWB: 'เฉพาะบัตรกำนัลที่ช่องแดงส่งออกไปแล้ว',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC: 'การดำเนินการล้มเหลวและค่าใช้จ่ายทั้งหมดหรือบางส่วนอยู่ในขั้นตอนการอนุมัติการชำระเงินโปรดดำเนินการเมื่อกระบวนการเสร็จสิ้น',
  Cargo_OFCIIFPRNRN: 'รวมค่าธรรมเนียมการออกใบแจ้งหนี้แล้ว โปรดเลือกหมายเลขใบคำขอชำระเงินใหม่:',
  Cargo_OFCTCMT2: 'การดำเนินการล้มเหลวและต้องไม่เกิน 2 สกุลเงิน',
  Cargo_OffsetDataSource: 'แหล่งข้อมูลป้องกันความเสี่ยง',
  Cargo_OffsetEntity: 'หน่วยงานป้องกันความเสี่ยง',
  Cargo_OffsetOrNot: 'ไม่ว่าจะเป็นการป้องกันความเสี่ยง',
  Cargo_MustInvoiceNoAndTitle: 'ต้องกรอกหมายเลขใบแจ้งหนี้และใบแจ้งหนี้เพิ่มขึ้น',
  Cargo_OFGTECOBUFEIIC: 'การดําเนินการล้มเหลว "การส่งออกภาษีทองคํา" สามารถทําได้เฉพาะกับใบแจ้งหนี้อิเล็กทรอนิกส์ที่มีสกุลเงินเป็นเงินหยวนเท่านั้น',
  Cargo_OFNBFSWWF: 'ไม่สามารถออกบัตรโดยสารได้และไม่มีค่าธรรมเนียมการออกบัตรโดยสาร',
  Cargo_OFTAPFSDNMTIR: 'สถานะค่าใช้จ่ายที่ต้องชำระไม่เป็นไปตามใบแจ้งหนี้',
  Cargo_OFTARFSDNMTIR: 'สถานะค่าธรรมเนียมที่เรียกเก็บไม่เป็นไปตามใบแจ้งหนี้',
  Cargo_OFTCBDNMTTINSIIITIEI: 'การดำเนินการล้มเหลวและสาขาปัจจุบันไม่ได้รักษาหมายเลขประจำตัวผู้เสียภาษี จึงไม่สามารถออกใบแจ้งหนี้อิเล็กทรอนิกส์ได้',
  Cargo_OFTFRCWNM: 'การดำเนินการล้มเหลวและไม่ผ่านเงื่อนไขการตรวจสอบทางการเงิน',
  Cargo_OFTFRCWNMCSRT: 'ไม่สามารถตรวจสอบทางการเงินได้โดยตรงและลองใหม่หลังจากเปลี่ยนการกำหนดค่า',
  Cargo_OFTIISCBD: 'ออกใบแจ้งหนี้แล้วไม่สามารถลบได้',
  Cargo_OFTIRCBDTNIAF: 'ใบคำขอออกใบแจ้งหนี้ต่อไปนี้ได้ออกใบแจ้งหนี้แล้วและไม่สามารถลบได้!',
  Cargo_OFTIRCBETNIAF: 'ใบคำขอออกใบแจ้งหนี้ต่อไปนี้มีการออกใบแจ้งหนี้แล้วและไม่สามารถแก้ไขได้!',
  Cargo_OFTRFOTARFCBIITB: 'ค่าธรรมเนียมในใบแจ้งหนี้รวมค่าธรรมเนียมการชงแดงหรือค่าธรรมเนียมการชงแดง',
  Cargo_OFTUFSCBS: 'การดำเนินการล้มเหลวและไม่สามารถแยกค่าใช้จ่ายที่ยังไม่ได้บันทึกไว้',
  Cargo_OFTWOANTBETTSOREGALFE: 'การดำเนินการล้มเหลว และจำนวนเงินที่ชำระหนี้ต้องเท่ากับผลรวมของจำนวนเงินที่เรียกเก็บ + กำไรและขาดทุนจากการแลกเปลี่ยน + ค่าใช้จ่ายทางการเงิน + บัญชีเศษส่วน',
  Cargo_OFWTIARTARMBGTTAP: 'การดำเนินการล้มเหลว เมื่อประเภทของรายรับและรายจ่ายเป็นลูกหนี้ ยอดรวมของลูกหนี้ต้องมากกว่ายอดรวมที่ต้องชำระ',
  Cargo_OIRWPSCBCAC: 'เฉพาะการสมัครใบแจ้งหนี้ที่มีสถานะเป็นใบแจ้งหนี้เท่านั้นที่สามารถสร้างและรายการสลากได้!',
  Cargo_OIWWBCBP: 'สามารถพิมพ์ใบแจ้งหนี้ที่ยังไม่ได้ล้างสีแดงเท่านั้น',
  Cargo_OnAccountHedge: '(การป้องกันความเสี่ยงบัญชีแขวนลอย)',
  Cargo_OneClickRenewal: 'ต่ออายุด้วยคลิกเดียว',
  Cargo_OnlyCheckedRecordsCanBeCancelled: 'ทำได้เพียงยกเลิกบันทึกที่เคยตรวจสอบแล้ว',
  Cargo_OnlyReviewedVouchersCanBeDeleted: 'คูปองที่ยังไม่ได้รับการตรวจสอบจะถูกลบออกเท่านั้น',
  Cargo_OnlyUnCheckedRecordsCanBeChecked: 'สามารถตรวจสอบได้เฉพาะบันทึกที่ไม่ได้รับการตรวจสอบเท่านั้น',
  Cargo_OOAPIICCTTTEPRCOEA: 'การเรียกเก็บเงินเป็นเพียงค่าธรรมเนียมที่ค้างชำระและไม่สามารถโอนเป็นค่าใช้จ่ายได้อีกโปรดทำเอกสารการเรียกเก็บเงินหรือค่าธรรมเนียมเพิ่มเติม!',
  Cargo_OORCBSFASBI: 'ใบแจ้งหนี้ใบเดียวสามารถเลือกบันทึกได้เพียงรายการเดียว',
  Cargo_OpeningAmountOfTheYear: 'จำนวนต้นปี',
  Cargo_OpeningBalance: 'ยอดคงเหลือเริ่มต้นงวด',
  Cargo_OpeningBalanceCreditCNY: 'ยอดคงเหลือเริ่มต้นงวด (CNY)',
  Cargo_OpeningBalanceCreditUSD: 'ยอดเงินคงเหลือเริ่มต้นงวด (ดอลลาร์สหรัฐ)',
  Cargo_OpeningBalanceDebitCNY: 'ยอดคงเหลือเบื้องต้น เดบิต (CNY)',
  Cargo_OpeningBalanceDebitUSD: 'ยอดคงเหลือเริ่มต้นงวด เดบิต (USD)',
  Cargo_OperateBy: 'ดำเนินการโดย',
  Cargo_OperatedSuccessfullyRefreshPage: 'การดำเนินการรีเฟรชหน้าเรียบร้อยแล้ว',
  Cargo_OperatingCompany: 'หน่วยธุรกิจ',
  Cargo_Operation: 'การดำเนินงาน',
  Cargo_OperationCompany: 'บริษัท ปฏิบัติการ',
  Cargo_OperationComplete: 'ความสำเร็จในการดำเนินงาน',
  Cargo_OperationDate: 'วันที่ดำเนินการ',
  Cargo_OperationDepartment: 'ฝ่ายปฏิบัติการ',
  Cargo_OperationOffice: 'สาขาปฏิบัติการ',
  Cargo_OperationFailed: 'การดำเนินการล้มเหลว',
  Cargo_OperationHistory: 'ประวัติการดำเนินงาน',
  Cargo_OperationModeAir: 'โหมดการทำงาน (อากาศ)',
  Cargo_OperationModeAirExport: 'โหมดการทำงาน (ว่างเปล่า)',
  Cargo_OperationModeAirImport: 'โหมดการทำงาน (Air-in)',
  Cargo_OperationRequirementType: 'ประเภทของความต้องการในการใช้งาน',
  Cargo_OperationSuccessfully: 'การดำเนินงานประสบความสำเร็จ',
  Cargo_HblTeleReleaseGuarantee: 'หนังสือค้ำประกันการตรวจสอบการพิมพ์ HBL',
  Cargo_TeleReleaseBillType: 'ประเภทของ B / L ที่วางจำหน่าย',
  Cargo_OperationSymbol: 'สัญลักษณ์การดำเนินงาน',
  Cargo_OperationType: 'ประเภทการดำเนินงาน',
  Cargo_OperationTypeCanTBeEmpty: 'ประเภทข้อกำหนดในการดำเนินงาน ไม่สามารถว่างได้',
  Cargo_Operator: 'ผู้ประกอบการ',
  Cargo_OperatorOfWithdrawal: 'ผู้จัดการคืนเงิน',
  Cargo_OppositeVoucherNo: 'หมายเลขคูปองของคู่กรณี',
  Cargo_OppositeVoucherNoP: 'หมายเลขคูปอง:',
  Cargo_OPVWES: 'สามารถทำได้เฉพาะบัตรกำนัลที่มีสถานะเป็นการทบทวนเท่านั้น',
  Cargo_Order: 'ลำดับขั้น',
  Cargo_OrdinaryTaxRate: 'อัตราภาษีทั่วไป',
  Cargo_ORDM: 'ข้อกำหนดการใช้งาน ลักษณะ การบำรุงรักษาข้อมูล',
  Cargo_Original: 'ต้นฉบับ',
  Cargo_OriginalAmount: 'จำนวนเงินเดิม',
  Cargo_OriginalAmountCNY: 'CNY เดิม จำนวน',
  Cargo_OriginalAmountInBill: 'ยอดบิลเดิม',
  Cargo_OriginalAmountUSD: 'USD จำนวน RAW',
  Cargo_OriginalContent: 'เนื้อหาต้นฉบับ',
  Cargo_OriginalCurrency: 'เหรียญต้นฉบับ',
  Cargo_OriginalCurrencyInBill: 'สกุลเงินต้นฉบับของบิล',
  Cargo_OriginalCurrencyNotWrittenOff: 'สกุลเงินเดิมที่ยังไม่ได้ขาย',
  Cargo_OriginalCurrencyP: 'เหรียญต้นฉบับ:',
  Cargo_OriginalExchangeRateInBill: 'อัตราแลกเปลี่ยนเดิมของบิล',
  Cargo_OriginalExpense: 'ค่าใช้จ่ายเดิม',
  Cargo_OriginalExpenseAmount: 'จำนวนค่าธรรมเนียมเดิม',
  Cargo_OriginalExpenseP: 'ค่าใช้จ่ายเดิม:',
  Cargo_OriginalInvoiceNo: 'หมายเลขใบแจ้งหนี้เดิม',
  Cargo_OriginalInvoiceNoP: 'หมายเลขใบแจ้งหนี้เดิม:',
  Cargo_OriginalInvoiceTitle: 'ใบแจ้งหนี้เดิมเพิ่มขึ้น',
  Cargo_OriginalInvoiceTitleP: 'ใบแจ้งหนี้เดิมเพิ่มขึ้น:',
  Cargo_OriginalValue: 'ค่าเดิม',
  Cargo_ChargeItemView: 'รายการค่าธรรมเนียมดู',
  Cargo_ORORDCBO: 'สามารถดำเนินการได้เฉพาะเอกสารที่ได้รับคืนหรือคืนแล้ว',
  Cargo_ORVCBE: 'ส่งออกได้เฉพาะบัตรกำนัลที่ผ่านการตรวจสอบแล้ว',
  Cargo_OSVBMP: 'ค้นหาเฉพาะบัตรกำนัลกลไก',
  Cargo_Other: 'อื่นๆ',
  Cargo_OtherChargeItem: 'ค่าธรรมเนียมเบ็ดเตล็ดสำหรับใบขนส่งทางอากาศ',
  Cargo_OtherContact: 'สัญญาอื่นๆ',
  Cargo_OtherConversionAP: 'การชำระค่าลดหย่อนอื่นๆ',
  Cargo_OtherConversionAPCNY: 'การคำนวณอื่น ๆ CNY เจ้าหนี้',
  Cargo_OtherConversionAPEUR: 'การคำนวณอื่น ๆ EUR ต้องชำระ',
  Cargo_OtherConversionAPGBP: 'อัตราส่วนอื่น ๆ GBP เจ้าหนี้',
  Cargo_OtherConversionAPHKD: 'ส่วนลดอื่นๆ HKD ชำระ',
  Cargo_OtherConversionAPJPY: 'อัตราส่วนอื่น ๆ JPY ต้องชำระ',
  Cargo_OtherConversionAPNGN: 'ค่าใช้จ่ายอื่น ๆ NGN เจ้าหนี้',
  Cargo_OtherConversionAR: 'ส่วนลดอื่น ๆ',
  Cargo_OtherConversionARCNY: 'การคํานวณอื่น ๆ CNY ลูกหนี้',
  Cargo_OtherConversionAREUR: 'การคํานวณอื่น ๆ EUR ลูกหนี้',
  Cargo_OtherConversionARGBP: 'ค่าธรรมเนียมอื่น ๆ GBP ลูกหนี้',
  Cargo_OtherConversionARHKD: 'ส่วนลดอื่น ๆ HKD ลูกหนี้',
  Cargo_OtherConversionARJPY: 'ส่วนลดอื่น ๆ JPY ลูกหนี้',
  Cargo_OtherConversionARNGN: 'ส่วนลดอื่น ๆ NGN ลูกหนี้',
  Cargo_OtherCurrencies: 'สกุลเงินอื่น ๆ',
  Cargo_OtherCurrencyExchangeRates: 'อัตราแลกเปลี่ยนสกุลเงินอื่น ๆ',
  Cargo_OtherExchangeRates: 'อัตราแลกเปลี่ยนอื่นๆ',
  Cargo_OtherOutstandingConversionAP: 'ส่วนลดอื่นๆ ที่ยังไม่ได้ชำระ',
  Cargo_OtherOutstandingConversionAPCNY: 'ส่วนลดอื่น ๆ CNY ค้างชำระ',
  Cargo_OtherOutstandingConversionAPEUR: 'ส่วนลดอื่น ๆ EUR ค้างชำระ',
  Cargo_OtherOutstandingConversionAPGBP: 'ส่วนลดอื่น ๆ GBP ค้างชำระ',
  Cargo_OtherOutstandingConversionAPHKD: 'ส่วนลดอื่น ๆ HKD ค้างชำระ',
  Cargo_OtherOutstandingConversionAPJPY: 'ส่วนลดอื่น ๆ JPY ค้างชำระ',
  Cargo_OtherOutstandingConversionAPNGN: 'ส่วนลดอื่นๆ NGN ค้างชำระ',
  Cargo_OtherOutstandingConversionAR: 'ส่วนลดอื่น ๆ ยังไม่ได้รับ',
  Cargo_OtherOutstandingConversionARCNY: 'ส่วนลดอื่น ๆ CNY ไม่ได้รับ',
  Cargo_OtherOutstandingConversionAREUR: 'ส่วนลดอื่น ๆ EUR ไม่ได้รับ',
  Cargo_OtherOutstandingConversionARGBP: 'การคํานวณอื่น ๆ GBP ไม่ได้เรียกเก็บ',
  Cargo_OtherOutstandingConversionARHKD: 'ส่วนลดอื่นๆ HKD ไม่เรียกเก็บ',
  Cargo_OtherOutstandingConversionARJPY: 'ส่วนลดอื่นๆ JPY ไม่เรียกเก็บ',
  Cargo_OtherOutstandingConversionARNGN: 'ส่วนลดอื่น ๆ NGN ยังไม่ได้รับ',
  Cargo_OTNSOSICBD: 'ไม่ได้ส่งและส่งแล้วถึงจะลบได้',
  Cargo_OTWOOCCI: 'เพียงแต่พนักงานขายบัญชีเองสามารถเพิกถอนการขายบัญชีได้',
  Cargo_OTWOOCMI: 'เฉพาะคนขายบัญชีเองเท่านั้นที่สามารถแก้ไขการขายบัญชีได้',
  Cargo_OurAccount: 'หมายเลขบัญชีของเรา',
  Cargo_OurBank: 'ธนาคารของเรา',
  Cargo_OurBankIsEmptySaveBankReceipt: 'ธนาคารของเราว่างเปล่าและเก็บค่าน้ำไว้หรือไม่?',
  Cargo_Outcomes: 'ผลลัพธ์',
  Cargo_OutstandingAP: 'ชำระยอดคงค้าง',
  Cargo_OutstandingAPP: 'ค้างชำระ:',
  Cargo_OutstandingConversionAPInCNY: 'ยอดคงเหลือ CNY',
  Cargo_OutstandingConversionAPInCurrency: 'ยอดคงเหลือ {0} ค้างชำระ',
  Cargo_OutstandingConversionPaidInCurrency: 'เทียบเท่า {0} จ่ายแล้ว',
  Cargo_OutstandingPaymentParties: 'หน่วยการชำระบัญชีที่ยังไม่ชัดเจน',
  Cargo_OutstandingWrittenOffItemsExist: 'มีบัญชีที่ยังไม่ได้ขาย',
  Cargo_OVDCBUFPLAT: 'วิชาประเภทกำไรและขาดทุนที่เลือกเฉพาะแผนกเสมือนเท่านั้น',
  Cargo_Virtual: 'เสมือนจริง',
  Cargo_Over90DaysShpt: 'มากกว่า 90 วัน (ตั๋ว)',
  Cargo_OverdueExpenses: 'ค่าธรรมเนียมส่วนเกิน',
  Cargo_Overseas: 'ต่างประเทศ',
  Cargo_OverseasAgencyContract: 'สัญญาตัวแทนในต่างประเทศ',
  Cargo_OverseasAgent: 'ตัวแทนต่างประเทศ',
  Cargo_OverseasAgentOrNot: 'ไม่ว่าจะเป็นตัวแทนจากต่างประเทศ',
  Cargo_OverseasCollection: 'การรับเงินจากต่างประเทศ',
  Cargo_OverseasDirectClient: 'ลูกค้าโดยตรงจากต่างประเทศ',
  Cargo_OverseasDirectClientOrNot: 'ไม่ว่าจะเป็นลูกค้าประจำจากต่างประเทศ',
  Cargo_OverseasDomestic: 'ต่างประเทศ ในประเทศ',
  Cargo_OverseasOrNot: 'ไม่ว่าจะเป็นในต่างประเทศ',
  Cargo_OverseasPayment: 'การชำระเงินต่างประเทศ',
  Cargo_OverseasWriteOff: 'การขายบัญชีในต่างประเทศ',
  Cargo_OverseasWriteOffOrNot: 'ไม่ว่าจะเป็นการขายบัญชีในต่างประเทศ',
  Cargo_OverseasWriteOffSearch: 'สอบถามการขายบัญชีในต่างประเทศ',
  Cargo_OVICBETGTEI: 'ใบกำกับภาษีมูลค่าเพิ่ม (VAT) จึงจะสามารถส่งออกใบกำกับภาษีทองคำทางอิเล็กทรอนิกส์ได้',
  Cargo_OVWCSNCBE: 'ต้องส่งออกบัตรกำนัลที่มีเลขบัตรกำนัลต่อเนื่องเท่านั้น',
  Cargo_OVWUSCBE: 'สามารถตรวจสอบได้เฉพาะบัตรกำนัลที่มีสถานะเป็น Unreview เท่านั้น',
  Cargo_OWCICGTSEEI: 'สกุลเงินใบเรียกเก็บเงินคือ {0} เพื่อให้ภาษีทองคำสามารถส่งออกใบแจ้งหนี้อิเล็กทรอนิกส์ได้',
  Cargo_OwningDept: 'หน่วยงานในสังกัด',
  Cargo_Package: 'การบรรจุ',
  Cargo_PackageExistsOrSelectNull: 'แพ็กเกจมีหรือไม่มีการเลือกบันทึก',
  Cargo_PackageMaintenance: 'การบำรุงรักษาบรรจุภัณฑ์',
  Cargo_PackingInformationNotSelected: 'ข้อมูลกล่องยังไม่ได้ถูกเลือก',
  Cargo_PADS: 'คำร้องขอปฏิเสธการชำระเงินสำเร็จ',
  Cargo_Page: 'จาง',
  Cargo_Paid: 'ชำระเงินแล้ว',
  Cargo_PaidInFull: 'ชำระแล้ว',
  Cargo_PaidInOutOfPocket: 'การรับ-จ่ายจริง',
  Cargo_ReceiptPaymentpVoucher: 'บัตรกำนัลรับชำระเงินจริง',
  Cargo_PANMWEAPCAOCA: 'ใบแจ้งค่าธรรมเนียมไม่ตรงกับจำนวนเงินค่าธรรมเนียม โปรดตรวจสอบยอดเงินหรือติดต่อผู้ดูแลระบบ!',
  Cargo_ParentAccountTitle: 'วิชาขั้นสูง',
  Cargo_PARGMSA: 'ใบคำขอชำระเงินต้องได้รับการอนุมัติจากกรรมการผู้จัดการ',
  Cargo_Parter: 'พาร์ทเนอร์',
  Cargo_CreditAccountingPeriod: 'ระยะเวลาบัญชีเครดิต',
  Cargo_CreditLine: 'วงเงินสินเชื่อ',
  Cargo_ExceededAmount: 'เกินแล้ว, {0} หยวน',
  Cargo_Exceeded: 'เกิน',
  Cargo_PartialConfirmation: 'ยืนยันบางส่วน',
  Cargo_PartialExpense: 'ค่าธรรมเนียมบางส่วน',
  Cargo_PartialPayment: 'การชำระเงินบางส่วน',
  Cargo_PartialReversalCompleted: 'บางส่วนโอนกลับไปสู่ความสำเร็จ',
  Cargo_PartialWriteOff: 'การชำระบัญชีบางส่วน',
  Cargo_Participant: 'ผู้เข้าร่วมโครงการ',
  Cargo_PartnerCanTBeEmpty: 'พันธมิตรไม่สามารถเว้นว่างได้',
  Cargo_PartnerSCreditLimitExceeded: 'ระยะเวลาบัญชีวงเงินหุ้นส่วนเกินกำหนด',
  Cargo_Password: 'รหัสผ่าน',
  Cargo_PasswordField: 'พื้นที่รหัสผ่าน',
  Cargo_PAWOCTBD: 'ใบคำขอชำระเงินถูกยกเลิกและไม่สามารถลบได้',
  Cargo_Pay: 'การชำระเงิน',
  Cargo_Payable: 'ชำระเงินได้',
  Cargo_PayableNeedPay: 'จ่ายได้ (ชำระแล้ว)',
  Cargo_PayableOrNot: 'ไม่ว่าจะเป็นการจ่ายเงิน',
  Cargo_PayablesWriteOfStatus: 'สถานะการชำระหนี้',
  Cargo_Payee: 'ผู้รับเงิน',
  Cargo_PayeeP: 'ผู้รับ:',
  Cargo_Payment: 'การชำระเงิน',
  Cargo_PaymentAccount: 'หมายเลขบัญชีการชำระเงิน',
  Cargo_PaymentAgainstMonthlySoa: 'ปมเดือน / ปมตั๋ว',
  Cargo_PaymentAmount: 'จำนวนเงินที่จ่าย',
  Cargo_PaymentApplicationDirectlySent: 'การชำระเงิน ใบสมัคร โดยตรง',
  Cargo_PaymentApplicationInformation: 'ข้อมูลการสมัครชำระเงิน',
  Cargo_PaymentApplicationNo: 'หมายเลขคำขอชำระเงิน',
  Cargo_PaymentAppliedSuccessfully: 'สมัครชำระเงินสำเร็จ',
  Cargo_PaymentApprovalSlipDetails: 'รายละเอียดการอนุมัติการชำระเงิน',
  Cargo_PaymentApprovalSlipNo: 'หมายเลขใบอนุมัติการชำระเงิน',
  Cargo_PaymentCompany: 'หน่วยลงทุน',
  Cargo_PaymentCompanyName: 'ชื่อบริษัทที่มา',
  Cargo_PaymentCycle: 'รอบระยะเวลาบัญชี',
  Cargo_PaymentDate: 'วันที่ชำระเงิน',
  Cargo_PaymentDateCanTBeEmpty: 'วันที่ชำระเงินไม่สามารถว่างได้',
  Cargo_PaymentMethod: 'วิธีการชำระเงิน',
  Cargo_PaymentNotApplied: 'ยังไม่ได้รับการชำระเงิน',
  Cargo_PaymentNotificationNo: 'หมายเลขแจ้งการชำระเงิน',
  Cargo_PaymentPeriod: 'เงื่อนไขการชำระเงิน',
  Cargo_PaymentPeriodExceeded: 'เกินระยะเวลาบัญชี',
  Cargo_PaymentPeriodRange: 'ช่วงระยะเวลาบัญชี',
  Cargo_PaymentReceiveMethod: 'วิธีการรับและจ่ายเงิน',
  Cargo_PaymentReceiveMethodP: 'วิธีการรับและจ่ายเงิน:',
  Cargo_PaymentReceiveType: 'ประเภทการรับชำระเงิน',
  Cargo_PaymentReceiveTypeP: 'ประเภทการรับชำระเงิน:',
  Cargo_PaymentRequest: 'สมัครชำระเงิน',
  Cargo_PaymentRequestBusiness: 'สมัครชำระเงิน - ธุรกิจ',
  Cargo_PaymentRequestDetail: 'คำขอชำระเงิน - รายละเอียด',
  Cargo_PaymentRequested: 'ชำระเงินแล้ว',
  Cargo_PaymentRequestedNotRequested: 'แจ้งชำระเงิน / แจ้งชำระเงิน',
  Cargo_PaymentRequestsCreatedOrNot: 'ไม่ว่าจะเป็นใบคำขอเบิกจ่ายเงิน',
  Cargo_PaymentTime: 'ระยะเวลาการชำระเงิน',
  Cargo_PaymentToBeChecked: 'เงินรอการตรวจสอบ',
  Cargo_CarryForwardList: 'รายการ Carryover',
  Cargo_PaymentType: 'ประเภทการชำระเงิน',
  Cargo_PaymentVerification: 'การตรวจสอบการชำระเงิน',
  Cargo_PayReceive: 'การรับชำระเงิน',
  Cargo_PayReceiveDate: 'วันที่รับเงิน',
  Cargo_PayUnit: 'หน่วยการชำระเงิน',
  Cargo_PCAOCO: 'โปรดยืนยันว่าจำนวนเงิน {0} ในครั้งนี้คือ:',
  Cargo_PCHIUV: 'ทะเลสากลของลูกค้าที่จะตรวจสอบ',
  Cargo_PCITIHBI: 'โปรดตรวจสอบว่ามีการออกตั๋วหรือไม่',
  Cargo_INVOICE_NO_FILE: 'ไม่พบเอกสารใบแจ้งหนี้อิเล็กทรอนิกส์ที่ตรงกันภายใต้ใบแจ้งหนี้',
  Cargo_Pcs: 'หนึ่ง',
  Cargo_PCSALOA: 'กรุณาคลิกที่ใบสมัครมากกว่าหนึ่งใบ',
  Cargo_PCSALOI: 'โปรดเลือกใบแจ้งหนี้มากกว่าหนึ่งใบ',
  Cargo_Pcst: 'แถบ',
  Cargo_PCTAOTCPI: 'กรุณายืนยัน: \# \#n ยอดรับชำระตามจริงคือ',
  Cargo_PCTOOPAIWOADSA: 'กรุณายืนยัน: \# \\n จำนวนเงินที่ชำระจริงคือ: {0}, \\n ยอดตัดบัญชีคือ: {1}, \\n ส่วนต่างคือ: {2} เป็นบัญชีสั้นศูนย์!',
  Cargo_PDDPAF: 'แสดงเฉพาะข้อมูลบางส่วนโปรดเพิ่มการกรองเงื่อนไขการดึงข้อมูล',
  Cargo_PeakSeason: 'ช่วงไฮซีซั่นของธุรกิจ',
  Cargo_PEALTVJE: 'โปรดป้อนรายการที่ถูกต้องอย่างน้อย 2 รายการ',
  Cargo_PEATGR: 'โปรดป้อนกฎการจัดกลุ่มวิชา',
  Cargo_PECCI: 'กรุณากรอกข้อมูลด่วนให้ครบถ้วน',
  Cargo_PECINSWACONIO: 'กรุณากรอกหมายเลขใบแจ้งหนี้ที่ถูกต้อง ระบบจะป้อนหมายเลขอื่นโดยอัตโนมัติตามลำดับ!',
  Cargo_PEERAVC: 'มีการสร้างหลักฐานการโอนเงินปลายทาง:',
  Cargo_PEFEA: 'การโอนเงินปลายทาง',
  Cargo_PEFEA2: 'การโอนเงินปลายงวด 2',
  Cargo_PEFEAS: 'การโอนเงินปลายทางสำเร็จแล้ว',
  Cargo_PendingBusinessApplication: 'ธุรกิจที่จะสมัคร',
  Cargo_PendingPrice: 'เพื่อตรวจสอบ',
  Cargo_People: 'คน',
  Cargo_PerformLetterFiltering: 'ทำการกรองอักขระ',
  Cargo_PERFROIRF: 'กรุณาระบุเหตุผลในการเปิดใหม่ลงในหมายเหตุ',
  Cargo_Period: 'ระยะเวลา',
  Cargo_PeriodEndAmount: 'จำนวนงวดสิ้นสุด',
  Cargo_PeriodEndBalance: 'ยอดคงเหลือ ณ สิ้นงวด',
  Cargo_PeriodEndBalanceCreditCNY: 'ยอดคงเหลือ ณ สิ้นงวด (CNY)',
  Cargo_PeriodEndBalanceCreditUSD: 'ยอดเงินคงเหลือ ณ สิ้นงวด (USD)',
  Cargo_PeriodEndBalanceDebitCNY: 'ยอดคงเหลือ ณ สิ้นงวด เดบิต (CNY)',
  Cargo_PeriodEndBalanceDebitUSD: 'ยอดคงเหลือ ณ สิ้นงวด เดบิต (USD)',
  Cargo_PeriodEndExchangeRateAdjustment: 'ไม่ว่าจะเป็นการโอนเงินปลายงวด',
  Cargo_PeriodRange: 'ช่วงระยะเวลา',
  Cargo_Periods: 'ช่วงเวลา',
  Cargo_PermissionCheck: 'การตรวจสอบสิทธิ์',
  Cargo_PermissionControl: 'การควบคุมสิทธิ์',
  Cargo_PermissionToSubmitExpense: 'การยื่นค่าธรรมเนียม',
  Cargo_PESAI: 'โปรดป้อนข้อมูล {1} ของบัญชีเสริมสำหรับ 【{0}】',
  Cargo_PESAIN: 'กรุณากรอกข้อมูล 【{0}】',
  Cargo_PESCSBA: 'โปรดป้อนหมายเลขบัญชีธนาคารของหน่วยขาย',
  Cargo_PETSAINO: 'กรุณากรอกข้อมูล 【{0}】',
  Cargo_PETSFIIB: 'กรุณากรอกข้อมูลค่าธรรมเนียมแยกไว้ด้านล่าง',
  Cargo_PEWOIPETS: 'กรุณากรอกข้อมูลการตัดบัญชี กลับไปยังสอบถาม',
  Cargo_PFAEFTS: 'การชำระเงินทางอากาศในเซี่ยงไฮ้',
  Cargo_PICNENCTSFS: 'กรุณาใส่ชื่อภาษาจีน, ชื่อภาษาอังกฤษ, รหัส, แบบสอบถามสั้น ๆ',
  Cargo_PlaceOfDelivery: 'สถานที่จัดส่ง',
  Cargo_PlaceOfMblPayment: 'สถานที่ชำระเงินหลัก',
  Cargo_PlaceOfReceipt: 'สถานที่รับสินค้า',
  Cargo_PlanDescription: 'คำอธิบายโครงการ',
  Cargo_PlatformCode: 'การเข้ารหัสแพลตฟอร์ม',
  Cargo_PlatformCustomerService: 'ฝ่ายบริการลูกค้าแพลตฟอร์ม',
  Cargo_CustomerServiceOverSea: 'ฝ่ายบริการลูกค้าต่างประเทศ',
  Cargo_PLCOS: 'ความสำเร็จของ Carryover กำไรและขาดทุน',
  Cargo_PleaseAddAtLeastOneContactPerson: 'กรอกข้อมูลติดต่อลูกค้าอย่างน้อยหนึ่งรายการ',
  Cargo_PleaseAddContactPerson: 'กรุณากรอกข้อมูลติดต่อ',
  Cargo_PleaseAddExpense: 'โปรดเพิ่มค่าธรรมเนียม',
  Cargo_PleaseAddNominationCargoAgent: 'กรุณากรอกข้อมูลตัวแทนจัดส่งสินค้า',
  Cargo_PleaseAddNominationCargoAgentP: 'โปรดกรอกตัวแทนจัดส่งที่ระบุ:',
  Cargo_PleaseAddTelNumbers: 'กรุณากรอกเบอร์โทรศัพท์',
  Cargo_PleaseBatchSelectInvoiceNo: 'โปรดเลือก {0} หมายเลขใบแจ้งหนี้เป็นจำนวนมาก',
  Cargo_PleaseCheckClient: 'กรุณาเลือกลูกค้า',
  Cargo_PleaseCheckInvoice: 'โปรดติ๊กใบแจ้งหนี้',
  Cargo_PleaseChooseData: 'โปรดเลือกข้อมูล',
  Cargo_PleaseChooseFeeName: 'โปรดเลือกชื่อค่าธรรมเนียม',
  Cargo_PleaseChooseSettlementEntity: 'โปรดเลือกหน่วยการชำระเงิน',
  Cargo_PleaseClickSelectAnInvoice: 'โปรดเลือกใบแจ้งหนี้',
  Cargo_PleaseClickSelectARecord: 'กรุณาเลือกบันทึก',
  Cargo_PleaseConfirmPaymentMade: 'โปรดยืนยันว่า {1} {2} ได้จ่ายเงินให้กับ {0} แล้ว!',
  Cargo_PleaseConfirmReviewDate: 'โปรดยืนยันวันที่ตรวจสอบ:',
  Cargo_PleaseConfirmTheDueAmount: 'กรุณายืนยัน: \# \#n เวลานี้ควร {0} จำนวน:',
  Cargo_PleaseConfirmThePaidInAmountIs: 'ขอยืนยันว่าจำนวนเงินที่เรียกเก็บในครั้งนี้',
  Cargo_PleaseConfirmThisTime: 'โปรดยืนยันว่าจำนวนเงิน {0} ในครั้งนี้คือ:',
  Cargo_PleaseDeleteAfterVoid: 'ขอให้เป็นโมฆะก่อนแล้วค่อยลบ',
  Cargo_PleaseEnterAccountTitle: 'กรุณากรอกชื่อวิชา',
  Cargo_PleaseEnterAmount: 'กรุณาใส่จำนวนเงิน',
  Cargo_PleaseEnterClientName: 'กรุณากรอกชื่อลูกค้า',
  Cargo_PleaseEnterCode: 'กรุณาใส่รหัส',
  Cargo_PleaseEnterCorrectAmount: 'กรุณากรอกจำนวนเงินให้ถูกต้อง',
  Cargo_PleaseEnterCorrectBillingParty: 'โปรดป้อนวัตถุที่ถูกต้องสำหรับการตั้งถิ่นฐาน',
  Cargo_PleaseEnterCorrectExchangeRate: 'กรุณาใส่อัตราแลกเปลี่ยนที่ถูกต้อง',
  Cargo_PleaseEnterCorrectNumber: 'กรุณากรอกตัวเลขให้ถูกต้อง',
  Cargo_PleaseEnterCurrencyExchangeRate: 'กรุณาใส่อัตราแลกเปลี่ยนของสกุลเงิน 【{0}】',
  Cargo_PleaseEnterDate: 'กรุณาใส่วันที่',
  Cargo_PleaseEnterDateOfReceipt: 'กรุณากรอกวันที่รับเงิน',
  Cargo_PleaseEnterDifferential: 'กรุณาใส่ส่วนต่าง',
  Cargo_PleaseEnterExpenseDescription: 'กรุณากรอกชื่อค่าธรรมเนียม',
  Cargo_PleaseEnterExpenseDetails: 'กรุณากรอกรายละเอียดค่าใช้จ่าย',
  Cargo_PleaseEnterFinancialCode: 'กรุณาใส่รหัสทางการเงิน',
  Cargo_ApAndArCodeIsEmpty: 'ปัจจุบัน 【รหัสการรับ】 / 【การรับมือกับการเข้ารหัส】 ว่างเปล่าโปรดลองอีกครั้งหลังจากปรับปรุงข้อมูล',
  Cargo_PleaseEnterFinancialDate: 'กรุณากรอกวันที่ทำการเงิน',
  Cargo_PleaseEnterHsCode: 'กรุณากรอก HSCode',
  Cargo_PleaseEnterInformationOf: 'โปรดป้อนข้อมูล {1} ของบัญชีเสริมสำหรับ 【{0}】',
  Cargo_PleaseEnterInvoiceInformation: 'กรุณากรอกข้อมูลใบแจ้งหนี้',
  Cargo_PleaseEnterInvoiceNo: 'กรุณากรอกหมายเลขใบแจ้งหนี้',
  Cargo_PleaseEnterInvoiceNoP: 'กรุณาใส่หมายเลขใบแจ้งหนี้:',
  Cargo_PleaseEnterMailingAddress: 'กรุณากรอกที่อยู่จัดส่ง',
  Cargo_PleaseEnterName: 'กรุณากรอกชื่อ',
  Cargo_PleaseEnterNewInvoiceNo: 'กรุณากรอกหมายเลขใบแจ้งหนี้ใหม่',
  Cargo_PleaseEnterNewInvoiceTitle: 'โปรดป้อนใบแจ้งหนี้ใหม่ที่เพิ่มขึ้น',
  Cargo_PleaseEnterOperationCode: 'โปรดป้อนตัวดำเนินการ',
  Cargo_PleaseEnterOurBankAccountNo: 'กรุณากรอกหมายเลขบัญชีธนาคารของเรา',
  Cargo_PleaseEnterPaidInAmount: 'กรุณากรอกจำนวนเงินที่ชำระแล้ว',
  Cargo_PleaseEnterPaidInDate: 'กรุณากรอกวันที่ชำระแล้ว',
  Cargo_PleaseEnterPaymentParty: 'กรุณาใส่หน่วยการชำระเงิน',
  Cargo_PleaseEnterPaymentTerm: 'กรุณากรอกระยะเวลาการชำระเงิน',
  Cargo_PleaseEnterPlanName: 'โปรดป้อนชื่อของโครงการ',
  Cargo_PleaseEnterGuarantrrName: 'กรุณาระบุชื่อของหนังสือค้ำประกัน',
  Cargo_PleaseEnterRecipientSName: 'กรุณากรอกชื่อผู้รับ',
  Cargo_PleaseEnterReturnedCourierNo: 'กรุณากรอกหมายเลขพัสดุคืน',
  Cargo_PleaseEnterSalesCompanySBank: 'กรุณากรอกหมายเลขบัญชีหน่วยขาย',
  Cargo_PleaseEnterScarletLetterNumber: 'กรุณากรอกหมายเลขใบแจ้งเตือนด้วยตัวอักษรสีแดง',
  Cargo_PleaseEnterSearchInformation: 'กรุณากรอกข้อมูลการสอบถาม',
  Cargo_PleaseEnterSettlingParty: 'กรุณากรอก Settlement Object',
  Cargo_PleaseEnterSobCode: 'กรุณาใส่รหัสชุดบัญชี',
  Cargo_PleaseEnterSobName: 'กรุณาใส่ชื่อซอง',
  Cargo_PleaseEnterSplitAmount: 'กรุณาใส่จำนวนที่แยก',
  Cargo_PleaseEnterTableName: 'กรุณากรอกชื่อตาราง',
  Cargo_PleaseEnterTelNo: 'กรุณากรอกเบอร์ติดต่อ',
  Cargo_PleaseEnterUserName: 'โปรดป้อนผู้ใช้',
  Cargo_PleaseEnterValueOfCondition: 'กรุณาใส่ค่าตามเงื่อนไข',
  Cargo_PleaseEnterVoucherLetter: 'กรุณากรอก voucher word',
  Cargo_PleaseEnterVoucherNo: 'กรุณากรอกหมายเลขคูปอง',
  Cargo_PleaseEnterVoucherType: 'กรุณากรอกประเภทบัตรกำนัล',
  Cargo_PleaseInputJobNo: 'กรุณากรอกหมายเลขงาน',
  Cargo_PleaseReselectTheVoucherToExport: 'โปรดเลือกคูปองที่คุณต้องการส่งออกอีกครั้ง',
  Cargo_PleaseSelect: 'กรุณาเลือก',
  Cargo_PleaseSelectP: '- กรุณาเลือก -',
  Cargo_PleaseSelect2OrMoreApplications: 'กรุณาคลิกใบสมัครมากกว่า 2 ใบ',
  Cargo_PleaseSelectAccountTitle: 'กรุณาเลือกวิชา',
  Cargo_PleaseSelectAnAdvanceReceipt: 'โปรดเลือกรายการรับเงินล่วงหน้า',
  Cargo_PleaseSelectAnExpenseItem: 'โปรดเลือกค่าธรรมเนียม',
  Cargo_PleaseSelectAnInvoice: 'โปรดเลือกใบแจ้งหนี้',
  Cargo_PleaseSelectAPAndARExpense: 'โปรดเลือกค่าธรรมเนียมที่เรียกเก็บและชำระ',
  Cargo_PleaseSelectApplication: 'กรุณาเลือกใบสมัคร',
  Cargo_PleaseSelectARecord: 'กรุณาเลือกบันทึก',
  Cargo_PleaseSelectBill: 'โปรดเลือกบิล',
  Cargo_PleaseSelectBillToMark: 'โปรดเลือกบิลที่คุณต้องการทำเครื่องหมาย',
  Cargo_PleaseSelectBillToPrint: 'โปรดเลือกบิลเพื่อพิมพ์',
  Cargo_PleaseSelectBillToRemove: 'โปรดเลือกบิลที่คุณต้องการลบ',
  noRowsToShow: 'ไม่มีผลการสอบถาม',
  Cargo_PleaseSelectBranch: 'กรุณาเลือกสาขา',
  Cargo_SelectBranch: 'เลือกสาขา',
  Cargo_ApplicationBranch: 'สาขาปฏิบัติการประยุกต์',
  Cargo_ApplicationDepartment: 'ฝ่ายปฏิบัติการประยุกต์',
  Cargo_MoreBusinessConditions: 'เงื่อนไขทางธุรกิจเพิ่มเติม',
  Cargo_MoreConditionsOptions: 'ตัวเลือกเงื่อนไขเพิ่มเติม',
  Cargo_BusinessConditionsOptions: 'ตัวเลือกเงื่อนไขทางธุรกิจ',
  Cargo_PleaseSelectBusiness: 'โปรดเลือกธุรกิจ',
  Cargo_PleaseSelectBusinessDate: 'โปรดเลือกวันที่ทำธุรกิจ',
  Cargo_PleaseSelectBusinessOrderRecord: 'โปรดเลือกบันทึกสลิปธุรกิจ',
  Cargo_PleaseSelectBusinessType: 'กรุณาเลือกประเภทธุรกิจ',
  Cargo_PleaseSelectGuaranteeType: 'กรุณาเลือกประเภทของหนังสือค้ำประกัน',
  Cargo_PleaseSelectClosureTime: 'โปรดเลือกเวลาสิ้นสุด',
  Cargo_PleaseSelectContentToModify: 'โปรดเลือกสิ่งที่จำเป็นต้องแก้ไข',
  Cargo_PleaseSelectCurrency: 'กรุณาเลือกสกุลเงิน',
  Cargo_PleaseSelectData: 'กรุณาเลือกข้อมูล',
  Cargo_PleaseSelectContainerGroup: 'กรุณาเลือกกลุ่มคอนเทนเนอร์เพื่อดำเนินการเพิ่ม',
  Cargo_AutomaticReleaseTips: 'ใบตราส่งสินค้าที่มีอยู่ในสถานะที่สามารถวางได้โดยไม่ต้องมีใบตราส่งสินค้าพิเศษ',
  Cargo_PleaseSelectDataToDelete: 'โปรดเลือกข้อมูลที่คุณต้องการลบ',
  Cargo_PleaseSelectDataToRevoke: 'โปรดเลือกข้อมูลที่คุณต้องการเป็นโมฆะ',
  Cargo_SuredRevokeJob: 'กำหนดธุรกิจที่เป็นโมฆะหรือไม่',
  Cargo_PleaseSelectDataToExport: 'โปรดเลือกข้อมูลที่ต้องการส่งออก',
  Cargo_PleaseSelectDataType: 'โปรดเลือกประเภทข้อมูล',
  Cargo_PleaseSelectDataTypeToCreate: 'โปรดเลือกประเภทข้อมูลที่คุณต้องการสร้าง',
  Cargo_PleaseSelectDate: 'กรุณาเลือกวันที่',
  Cargo_PleaseSelectExpense: 'โปรดเลือกค่าธรรมเนียม',
  Cargo_PleaseSelectExpenseToConfirm: 'โปรดเลือกค่าธรรมเนียมเพื่อยืนยัน',
  Cargo_PleaseSelectExpenseToSplit: 'โปรดเลือกค่าธรรมเนียมที่คุณต้องการแยก',
  Cargo_PleaseSelectExpenseToWriteOff: 'โปรดเลือกค่าธรรมเนียมที่ต้องการตัดบัญชี',
  Cargo_PleaseSelectFile: 'กรุณาเลือกไฟล์',
  Cargo_OwnFileDelete: 'สิทธิ์ไม่เพียงพอ: ไม่สามารถลบไฟล์ที่อัปโหลดโดยผู้ใช้รายอื่นได้',
  Cargo_PleaseSelectFileType: 'โปรดเลือกประเภทไฟล์',
  Cargo_PleaseSelectGroupingCondition: 'โปรดเลือกเงื่อนไขการจัดกลุ่ม',
  Cargo_PleaseSelectGroupingCondition2: 'โปรดเลือกเงื่อนไขการจัดกลุ่ม1.',
  Cargo_PleaseSelectIncludedBizNo: 'กรุณาเลือกหมายเลขธุรกิจ',
  Cargo_PleaseSelectInvoice: 'โปรดเลือกใบแจ้งหนี้',
  Cargo_PleaseSelectInvoiceNo: 'โปรดเลือกหมายเลขใบแจ้งหนี้',
  Cargo_PleaseSelectOurBank: 'กรุณาเลือกธนาคารของเรา',
  Cargo_PleaseSelectPaymentApplication: 'โปรดเลือกการชำระเงิน',
  Cargo_PleaseSelectTheRecord: 'โปรดเลือกระเบียนที่ต้องการแก้ไข',
  Cargo_batchChangePaymentSuccess: 'คำขอแก้ไขการชำระเงินสำเร็จแล้ว',
  Cargo_batchChangePaymentFailed: 'คำขอแก้ไขการชำระเงินจำนวนมากล้มเหลว',
  Cargo_NotEmptyChangePaymentTime: 'เวลาชำระค่าสมัครไม่สามารถว่างได้',
  Cargo_ApprovedSuccess: 'การอนุมัติสำเร็จ',
  Cargo_ApprovedFaild: 'การอนุมัติล้มเหลว',
  Cargo_ReturnedSuccess: 'ส่งคืนสำเร็จ',
  Cargo_ReturnedFaild: 'การคืนสินค้าล้มเหลว',
  Cargo_NoBusinessApproval: 'ไม่มีข้อมูลที่ต้องอนุมัติธุรกิจ',
  Cargo_NoDeptApproval: 'ไม่มีข้อมูลที่ต้องได้รับการอนุมัติจากกรม',
  Cargo_NoFinanceApprovalData: 'ไม่มีข้อมูลที่ต้องการการอนุมัติทางการเงิน',
  Cargo_NoSupervisorApprovalData: 'ไม่มีข้อมูลที่ต้องการการอนุมัติจาก主管',
  Cargo_PleaseSelectPeriodRange: 'กรุณาเลือกช่วงระยะเวลา',
  Cargo_PleaseSelectRecord: 'โปรดเลือกบันทึก',
  Cargo_PleaseSelectRecordToInvoice: 'โปรดเลือกบันทึกที่คุณต้องการออกใบสั่ง',
  Cargo_PleaseSelectRecordToReview: 'โปรดเลือกระเบียนที่คุณต้องการตรวจสอบ',
  Cargo_PleaseSelectRecordToCancelReview: 'โปรดเลือกบันทึกที่คุณต้องการยกเลิกการตรวจสอบ',
  Cargo_PleaseSelectRecordToWriteOff: 'โปรดเลือกบันทึกที่คุณต้องการตัดบัญชี',
  Cargo_PleaseSelectReviewDate: 'โปรดเลือกวันที่ตรวจสอบ',
  Cargo_PleaseSelectSameInvoiceType: 'โปรดเลือกประเภทใบแจ้งหนี้เดียวกัน',
  Cargo_PleaseSelectServiceTicket: 'โปรดเลือกแบบฟอร์มยืนยันการชำระเงิน',
  Cargo_PleaseSelectSettlingParty: 'โปรดเลือกวัตถุที่ชำระราคา',
  Cargo_AddTag: 'ป้ายกํากับใหม่',
  Cargo_NotFoundNeedSaveCharges: 'ไม่มีค่าใช้จ่ายเพิ่มเติมในรายการ',
  Cargo_SureSaveBilling: 'แน ่ ใจหรือไม ่ ว ่ าจะบันทึกและสร ้ างการเรียกเก็บเงิน ?',
  Cargo_SureSaveChargeOnly: 'แน ่ ใจหรือไม ่ ว ่ าจะบันทึกเฉพาะค่าธรรมเนียม ?',
  Cargo_SureCancelEdit: 'แน ่ ใจหรือไม ่ ว ่ าจะยกเลิกการแก ้ ไข ?',
  Cargo_JobBillingChargeNotEqual: '[{1}] [{2}] ของธุรกิจ [{0}] ไม่สอดคล้องกับการเรียกเก็บเงินโปรดลบค่าใช้จ่ายที่ไม่สอดคล้องกันเท่านั้นที่สามารถแก้ไขได้!',
  Cargo_SaveGenerateBills: 'บันทึกและสร้างการเรียกเก็บเงิน',
  Cargo_GenerateExpensesOnly: 'สร้างค่าใช้จ่ายเท่านั้น',
  Cargo_PleaseSelectSoa: 'โปรดเลือก Statement',
  Cargo_PleaseSelectSob: 'กรุณาเลือกซอง',
  Cargo_PleaseSelectStartTime: 'โปรดเลือกเวลาเริ่มต้น',
  Cargo_PleaseSelectThePurchaser: 'โปรดเลือกผู้ซื้อ',
  Cargo_PleaseSelectTypeOfJournalEntries: 'โปรดเลือกประเภทของรายการ.',
  Cargo_PleaseSelectVatInvoice: 'กรุณาเลือกใบกำกับภาษีมูลค่าเพิ่ม',
  Cargo_PleaseSelectVatEiInvoice: 'กรุณาเลือกตั๋วภาษีมูลค่าเพิ่ม',
  Cargo_PleaseSelectVoucher: 'กรุณาเลือกคูปอง',
  Cargo_PleaseSelectVoucherGroupingRule: 'โปรดเลือกกฎการจัดกลุ่มบัตรกำนัล',
  Cargo_PleaseSelectVoucherToCancel: 'กรุณาเลือกคูปองที่ต้องการยกเลิก',
  Cargo_PleaseSelectVoucherToReview: 'กรุณาเลือกคูปองที่ต้องการตรวจสอบ',
  Cargo_PleaseSelectWriteOffDetails: 'โปรดเลือกรายละเอียดการขายบัญชี',
  Cargo_PleaseSelectWriteOffRecord: 'โปรดเลือกประวัติการขายบัญชี',
  Cargo_PleaseSpecifyPaymentPeriodRange: 'โปรดระบุช่วงระยะเวลาบัญชี',
  Cargo_PleaseUseComponent: 'กรุณาใช้ส่วนประกอบ',
  Cargo_PlsInput: 'กรุณากรอก',
  Cargo_PLVDCTBE: 'วันที่ Profit & Loss Voucher ไม่สามารถว่างได้',
  Cargo_PLVDNITP: 'วันที่บัตรกำนัลกำไรและขาดทุนไม่อยู่ในช่วงระยะเวลา',
  Cargo_PLVFCTBE: 'คำรับรองกำไรและขาดทุนต้องไม่ว่างเปล่า',
  Cargo_PLVNAPATCTBE: 'กำไรและขาดทุนที่ไม่ได้รับการจัดสรรวิชากำไรไม่สามารถเว้นว่างได้',
  Cargo_PoaCustomsDeclaration: 'พศม.',
  Cargo_PODcode: 'รหัสพอร์ต',
  Cargo_FileFromQuotation: 'ไฟล์ที่นำเข้าจากการจัดการใบเสนอราคาไม่สามารถลบได้',
  Cargo_FileFromInquiry: 'ไฟล์ที่นำเข้าจากการจัดการคำถามไม่สามารถลบได้',
  Cargo_PodSea: 'ท่าเรือขนถ่ายสินค้า (ท่าเรือ)',
  Cargo_Unloading: 'ขนถ่ายสินค้า',
  Cargo_ArrivalNotice: 'ประกาศการมาถึง',
  Cargo_PickUp: 'รับสินค้า',
  Cargo_AircraftGISPositioning: 'ตำแหน่งเครื่องบิน GIS',
  Cargo_PointOfPermission: 'จุดอนุญาต',
  Cargo_PointsToNote: 'มีหรือไม่มีเฉพาะเจาะจง',
  Cargo_Pol: 'ท่าเรือโหลด',
  Cargo_PolAgent: 'ตัวแทนพอร์ตการจัดส่งสินค้า',
  Cargo_POLCannotBeNull: 'พอร์ตการจัดส่งสินค้าไม่สามารถว่างเปล่าได้',
  Cargo_PolSea: 'ท่าเรือต้นทาง (ท่าเรือ)',
  Cargo_Port: 'ท่าเรือ',
  Cargo_PortCodeCanTBeEmpty: 'รหัสพอร์ตต้องไม่ว่างเปล่า',
  Cargo_PortGroup: 'กลุ่มท่าเรือ',
  Cargo_PortGroupCanTBeEmpty: 'กลุ่มท่าเรือไม่สามารถว่างเปล่าได้',
  Cargo_PortOfDestinationCode: 'รหัสท่าเรือปลายทาง',
  Cargo_PortOfDischarge: 'ท่าเรือขนถ่ายสินค้า',
  Cargo_PortOfDischargeCannotBeNull: 'ท่าเรือขนถ่ายสินค้าต้องไม่ว่างเปล่า',
  Cargo_PortOfLoading: 'ท่าเรือขนส่งสินค้า',
  Cargo_PortOfLoadingSea: 'พอร์ตการจัดส่งสินค้า (ทางทะเล)',
  Cargo_PortOfLoadingAir: 'พอร์ตการจัดส่งสินค้า (ทางอากาศ)',
  Cargo_PortPrompt: 'โปรดป้อนพอร์ต',
  Cargo_PortRequirement: 'ความต้องการพอร์ต',
  Cargo_PositiveOperation: 'การทำงานในเชิงบวก',
  Cargo_Post: 'โพสต์',
  Cargo_PotentialStage: 'ขั้นตอนที่มีศักยภาพ',
  Cargo_PPNCASA: 'เป็นบัญชีสั้นเศษเสี้ยวไม่มีการชำระเงินล่วงหน้า',
  Cargo_PRCTBCFWOE: 'ค่าธรรมเนียม / ธุรกิจที่ได้รับการยกเลิกไม่สามารถสร้างคำขอชำระเงินได้',
  Cargo_PreCollection: 'การเก็บเงินล่วงหน้า',
  Cargo_PreferredAgentAtDestination: 'การตั้งค่าตัวแทนปลายทาง',
  Cargo_PreferredAirline: 'สายการบินที่ต้องการ',
  Cargo_PreferredAirport: 'การตั้งค่า Airport',
  Cargo_PreferredAirportAir: 'ท่าเรือที่ต้องการ (ว่างเปล่า)',
  Cargo_PreferredCustomsBroker: 'การตั้งค่าบริการประกาศศุลกากร',
  Cargo_PreferredOceanCarrier: 'บริษัท เรือที่ต้องการ',
  Cargo_PreferredPort: 'การตั้งค่าท่าเรือ',
  Cargo_PreferredPortSea: 'ท่าเรือที่ต้องการ (ท่าเรือ)',
  Cargo_PreferredShippingMethod: 'ประเภทของการเดิน',
  Cargo_PreferredShippingRoute: 'เส้นทางที่ต้องการ',
  Cargo_PreferredShippingTerms: 'เงื่อนไขการจัดส่งที่ต้องการ',
  Cargo_PreferredTrucker: 'การตั้งค่าแถวรถพ่วง',
  Cargo_PreferredTruckingService: 'การตั้งค่าบริการรถพ่วง',
  Cargo_PrepaidOrNot: 'ไม่ว่าจะเป็นการจ่ายล่วงหน้า',
  Cargo_PreparedBy: 'ทำเดี่ยว',
  Cargo_PreparedByP: 'ทำเดี่ยว:',
  Cargo_PrepareServiceTicket: 'แบบฟอร์มยืนยันค่าใช้จ่ายในการผลิต',
  Cargo_PrePayment: 'ไม่ว่าจะเป็นการเก็บเงินล่วงหน้า',
  Cargo_PrepaymentRecordedSuccessfully: 'ลงทะเบียนเติมเงินสำเร็จ',
  Cargo_PreReviewStatus: 'สถานะก่อนการพิจารณาคดี',
  Cargo_PreReviewAllStatus: 'สถานะก่อนการตรวจสอบ (ตรวจสอบแล้ว)',
  Cargo_PreSubmission: 'ส่งล่วงหน้า',
  Cargo_PreviewEmailContent: 'แสดงตัวอย่างเนื้อหาของจดหมาย',
  Cargo_Previous: 'ก่อนหน้า',
  Cargo_PrimeCost: 'ต้นทุน',
  Cargo_Print: 'การพิมพ์',
  Cargo_PrintAll: 'พิมพ์ทั้งหมด',
  Cargo_PrintBill: 'พิมพ์บิล',
  Cargo_PrintedSuccessfully: 'พิมพ์สำเร็จ',
  Cargo_PrintInvoice: 'การพิมพ์ใบแจ้งหนี้',
  Cargo_PrintList: 'พิมพ์รายการ',
  Cargo_PrintOrNot: 'ไม่ว่าจะเป็นการพิมพ์',
  Cargo_LACKINVOICE: 'ขาดใบแจ้งหนี้หรือไม่',
  Cargo_Printout: 'ผลการพิมพ์',
  Cargo_PrintPaymentList: 'พิมพ์รายการชำระเงิน',
  Cargo_PrintSoa: 'พิมพ์ใบแจ้งยอด',
  Cargo_PrintStatusSaved: 'บันทึกสถานะการพิมพ์สำเร็จ',
  Cargo_PrintTheProfit: 'พิมพ์กำไร',
  Cargo_PrintVerification: 'การตรวจสอบการพิมพ์',
  Cargo_PrintWithdrawalList: 'พิมพ์ (รายการคืนเงิน)',
  Cargo_ProcessedAsShortAccount: 'ประมวลผลเป็นบัญชีสั้นศูนย์',
  Cargo_ProcessedBy: 'ประมวลผลคน',
  Cargo_ProcessingChangeRemarks: 'การประมวลผลการปรับหมายเหตุ',
  Cargo_ProcessingPleaseWait: 'กรุณารอสักครู่ กำลังดำเนินการอยู่',
  Cargo_ProcessingRemarks: 'หมายเหตุการประมวลผล',
  Cargo_ProcessingTime: 'เวลาดำเนินการ',
  Cargo_ProductName: 'ชื่อโครงการ',
  Cargo_Profit: 'กำไร',
  Cargo_ProfitLossAccount: 'วิชากำไรและขาดทุน',
  Cargo_ProfitLoss: 'ตารางกำไร',
  Cargo_ProfitLoss2: 'ตารางกำไร 2',
  Cargo_ProfitLossVoucherNoCanTBeEmpty: 'หมายเลขบัตรกำนัลกำไรและขาดทุนต้องไม่ว่างเปล่า',
  Cargo_ProfitLossVoucherNotInThePeriod: 'บัตรกำนัลกำไรและขาดทุนไม่อยู่ในช่วงระยะเวลา',
  Cargo_Prompt: 'เตือนความจำ',
  Cargo_Proof: 'คูปอง',
  Cargo_ProofDate: 'วันที่บัตรกำนัล',
  Cargo_ProofDateP: 'วันที่บัตรกำนัล:',
  Cargo_ProofOrNot: 'ไม่ว่าจะเป็นการสร้างคูปอง',
  Cargo_Property: 'คุณสมบัติ',
  Cargo_Province: 'จังหวัด',
  Cargo_PRSCSCRICP: 'บันทึกการเก็บเงินของบริษัทเรือ โปรดไปที่หน้าเรียกเก็บเงินเพื่อเซ็นเพิกถอน',
  Cargo_PSALOAPAARE: 'โปรดเลือกอย่างน้อยหนึ่งรายการที่ต้องชำระและค่าธรรมเนียมที่เรียกเก็บ',
  Cargo_PSALOER: 'โปรดเลือกบันทึกค่าใช้จ่ายอย่างน้อยหนึ่งรายการ',
  Cargo_PSALOGODC: 'โปรดเลือกเงื่อนไขวันที่อย่างน้อย 1 ชุด',
  Cargo_PSALOGODC2: 'โปรดเลือกเงื่อนไขการกรองอย่างน้อยหนึ่งข้อ',
  Cargo_SelectLockOrderCondition: 'เลือกเงื่อนไขการล็อกงาน',
  Cargo_PSBOTSSP: 'โปรดเลือกการเรียกเก็บเงินจากหน่วยการชำระเงินเดียวกัน',
  Cargo_PSCI: 'โปรดเลือกข้อมูลการเรียกเก็บเงิน',
  Cargo_PSDTOVG: 'กรุณาเลือกประเภทข้อมูลกลุ่มบัตรกำนัล',
  Cargo_PSEDTRWO: 'โปรดตรวจสอบรายละเอียดค่าธรรมเนียมที่คุณต้องการยกเลิกการตัดบัญชี',
  Cargo_PSFDD: 'แบบสอบถามในหน้าเอกสารประกาศศุลกากร',
  Cargo_PSFPOTSY: 'รอบระยะเวลาบัญชี กรุณาเลือกปีเดียวกัน',
  Cargo_PleaseSelectVoucherRange: 'กรุณาเลือกช่วงคูปอง',
  Cargo_PSGROJE: 'โปรดเลือกกฎการจัดกลุ่มรายการ',
  Cargo_PSOR: 'โปรดเลือกข้อกำหนดการใช้งาน',
  Cargo_PSPAF: 'โปรดเลือกแบบฟอร์มการชำระเงิน',
  Cargo_PSPATD: 'โปรดเลือกคำขอชำระเงินที่คุณต้องการลบ',
  Cargo_PSPATW: 'โปรดเลือกคำขอชำระเงินที่คุณต้องการถอน',
  Cargo_PSPATR: 'โปรดเลือกคำขอชำระเงินที่คุณต้องการคืน',
  Cargo_PSPATS: 'โปรดเลือกคำขอชำระเงินที่คุณต้องการส่ง',
  Cargo_PSROACP: 'กรุณาเลือกประวัติการรับชำระเงินจริง',
  Cargo_PSRTCPA: 'กรุณาเลือกประวัติที่ต้องการทำรายการชำระเงิน',
  Cargo_PSRTCV: 'โปรดเลือกระเบียนของบัตรกำนัลที่คุณต้องการสร้าง',
  Cargo_PSSDOCD: 'โปรดเลือกวันที่เริ่มต้นหรือวันสิ้นสุด',
  Cargo_PSUSPAF: 'โปรดเลือกใบคำขอชำระเงินที่ยังไม่ได้ยื่น',
  Cargo_PSSPAF: 'สามารถเบิกถอนคำขอเบิกจ่ายเงินที่ยังไม่ได้รับการอนุมัติเท่านั้น',
  Cargo_PSVOFS: 'โปรดเลือกเวอร์ชั่นซอฟต์แวร์การเงิน',
  Cargo_CurrencyMismatch: 'สกุลเงินของ {0} ไม่ตรงกับหมายเลขบัญชีธนาคารโปรดแก้ไขบัญชีการขาย',
  Cargo_PublicClientHub: 'ทะเลหลวงของลูกค้า',
  Cargo_Publish: 'เผยแพร่',
  Cargo_PublishStatus: 'สถานะโพสต์',
  Cargo_PurchasedBy: 'ผู้ซื้อ',
  Cargo_PurchaseRecord: 'บันทึกการซื้อ',
  Cargo_PurchaseRegisteredSuccessfully: 'ลงทะเบียนซื้อสำเร็จ',
  Cargo_PurchaseRegistration: 'ลงทะเบียนซื้อ',
  Cargo_PurchasingParty: 'ฝ่ายซื้อ',
  Cargo_PurchasingUnit: 'หน่วยซื้อ',
  Cargo_PUSBAANMRIDSS: 'ธนาคารที่เปิดบัญชีและหมายเลขบัญชีไม่ใช่บัญชีธนาคารที่ {0} เป็นเจ้าของ คุณต้องการบันทึกหรือไม่?',
  Cargo_PutARItemsOnTop: 'เด็กรับใส่มัน',
  Cargo_PYPALAA: 'รายวิชาปรับกำไรและขาดทุนประจำปีที่ผ่านมา',
  Cargo_PYPALAAP: 'รายวิชาปรับกำไรและขาดทุนประจำปีก่อนหน้า:',
  Cargo_Query: 'สอบถาม',
  Cargo_QueryFailed: 'การสอบถามล้มเหลว',
  Cargo_QueryInvoice: 'สอบถามใบแจ้งหนี้',
  Cargo_QuickSearch: 'สอบถามง่าย',
  Cargo_QuotaCurrency: 'สกุลเงิน',
  Cargo_QuotaRange: 'ช่วงวงเงิน',
  Cargo_RAIAV: 'ยอดปรองดองหลังจากถอนค่าสัมบูรณ์',
  Cargo_Railway: 'รถไฟ',
  Cargo_RailwayExport: 'ทางออกรถไฟ',
  Cargo_RailwayImport: 'การนำเข้าทางรถไฟ',
  Cargo_RailwayBusiness: 'ธุรกิจรถไฟ',
  Cargo_IntegratedJob: 'โลจิสติกส์ครบวงจร',
  Cargo_FbaOrder: 'FBA สั่งซื้อ',
  Cargo_FbaSea: 'การขนส่งทางทะเล FBA',
  Cargo_FbaAir: 'FBA ทางอากาศ',
  Cargo_FbaRailway: 'FBA รถไฟ',
  Cargo_RailwayRoute: 'เส้นทางรถไฟ',
  Cargo_RCAFTPOY: 'เคาน์เตอร์เช็คเอาท์ {0} ปี {1}',
  Cargo_RCBDIDL: 'รีเฟรชข้อมูล บริษัท สาขาแบบเลื่อนลงปัจจุบัน',
  Cargo_RealPaid: 'จ่ายจริง',
  Cargo_RealPaidP: 'จ่ายจริง:',
  Cargo_ReasonNotEntered: 'เหตุผลที่ยังไม่ได้กรอก',
  Cargo_ReasonOfCargoDetention: 'เหตุผลของการหักเงิน',
  Cargo_ReasonOfCargoDetentionP: 'เหตุผลของการหัก:',
  Cargo_ReCalculateBillingAmount: 'คำนวณยอดบิลใหม่',
  Cargo_Receipt: 'การรับเงิน',
  Cargo_ReceiptAmount: 'จำนวนเงินที่ได้รับ',
  Cargo_Receivable: 'การรับสมัคร',
  Cargo_ReceivableToCNY: 'พับเก็บลูกหนี้ CNY:',
  Cargo_ReceivableB: '(ลูกหนี้)',
  Cargo_ReceivedCNY: 'CNY ได้รับ',
  Cargo_PayPaidCNY: 'CNY จ่าย',
  Cargo_ReceivedUSD: 'USD ปิด',
  Cargo_ReceivedEUR: 'EUR ปิด',
  Cargo_ReceivedGBP: 'GBP ได้รับ',
  Cargo_ReceivedHKD: 'HKD ได้รับ',
  Cargo_ReceivedJPY: 'JPY ได้รับ',
  Cargo_ReceivedNGN: 'รับ NGN',
  Cargo_PayPaidUSD: 'USD ชำระแล้ว',
  Cargo_PayPaidEUR: 'EUR จ่ายแล้ว',
  Cargo_PayPaidGBP: 'GBP ชำระแล้ว',
  Cargo_PayPaidHKD: 'HKD จ่ายแล้ว',
  Cargo_PayPaidJPY: 'JPY จ่าย',
  Cargo_PayPaidNGN: 'NGN จ่ายแล้ว',
  Cargo_OtherConversionReceivedUSD: 'ส่วนลด USD อื่น ๆ',
  Cargo_OtherConversionReceivedEUR: 'ส่วนลดอื่น ๆ EUR ได้รับ',
  Cargo_OtherConversionReceivedGBP: 'ส่วนลด GBP อื่น ๆ',
  Cargo_OtherConversionReceivedHKD: 'ส่วนลดอื่น ๆ HKD ได้รับ',
  Cargo_OtherConversionReceivedJPY: 'ส่วนลดอื่น ๆ JPY ได้รับ',
  Cargo_OtherConversionReceivedNGN: 'ส่วนลดอื่น ๆ NGN ได้รับ',
  Cargo_OtherConversionPayPaidUSD: 'ส่วนลดอื่น ๆ USD จ่ายแล้ว',
  Cargo_OtherConversionPayPaidEUR: 'ส่วนลดอื่น ๆ EUR จ่ายแล้ว',
  Cargo_OtherConversionPayPaidGBP: 'ค่าใช้จ่ายอื่น ๆ GBP จ่ายแล้ว',
  Cargo_OtherConversionPayPaidHKD: 'ส่วนลดอื่น ๆ HKD จ่ายแล้ว',
  Cargo_OtherConversionPayPaidJPY: 'ส่วนลดอื่น ๆ JPY จ่ายแล้ว',
  Cargo_OtherConversionPayPaidNGN: 'ค่าใช้จ่ายอื่น ๆ NGN ชำระแล้ว',
  Cargo_OtherConversionReceivedCNY: 'ส่วนลดอื่น ๆ CNY ได้รับ',
  Cargo_OtherConversionPayPaidCNY: 'ส่วนลดอื่น ๆ CNY จ่ายแล้ว',
  Cargo_ReceivableCNY: 'CNY ลูกหนี้',
  Cargo_ReceivableEUR: 'EUR ลูกหนี้',
  Cargo_ReceivableGBP: 'GBP ลูกหนี้',
  Cargo_ReceivableHKD: 'ลูกหนี้ HKD',
  Cargo_ReceivableJPY: 'JPY ลูกหนี้',
  Cargo_ReceivableNGN: 'เอ็นจีเอ็น',
  Cargo_ReceivableP: 'การยอมรับ:',
  Cargo_ReceivablesInvoicingDate: 'วันที่ออกใบแจ้งหนี้',
  Cargo_ReceivablesInvoicingStatus: 'สถานะของใบเรียกเก็บเงิน',
  Cargo_ReceivablesWriteOfStatus: 'สถานะการชำระหนี้',
  Cargo_ReceivableUSD: 'รับ USD',
  Cargo_Receive: 'รับ',
  Cargo_RevocationOfReceipt: 'ยกเลิกการรับ',
  Cargo_Received: 'ได้รับแล้ว',
  Cargo_ReceivedDate: 'วันที่รับเงิน',
  Cargo_ReceiveMethod: 'วิธีการรับเงิน',
  Cargo_Receiver: 'รับคืน',
  Cargo_Receiver2: 'ผู้รับ',
  Cargo_ReceiverCompanyName: 'หน่วยรับ',
  Cargo_ReceivingBank: 'ธนาคารผู้รับเงิน',
  Cargo_ReceivingBankAccount: 'หมายเลขบัญชีผู้รับเงิน',
  Cargo_ReceivingDate: 'วันที่รับคืน',
  Cargo_Recheck: 'ตรวจสอบซ้ำ',
  Cargo_RecheckDate: 'วันที่ตรวจสอบ',
  Cargo_ReCheckedSuccessfully: 'ทบทวนสำเร็จ',
  Cargo_ReCheckedFailed: 'การตรวจสอบล้มเหลว',
  Cargo_CancelReCheckedSuccessfully: 'ยกเลิกการทบทวนสำเร็จ',
  Cargo_RecheckOrNot: 'ไม่ว่าจะเป็นการตรวจสอบ',
  Cargo_RecheckP: 'การตรวจสอบ:',
  Cargo_ReCheckPermission: 'ตรวจสอบสิทธิ์',
  Cargo_RecipientOfWithdrawal: 'ผู้รับเงินคืน',
  Cargo_RecipientSCompanyOfWithdrawal: 'หน่วยรับเงินคืน',
  Cargo_ReconcileOrNot: 'ไม่ว่าจะเป็นการสร้างความปรองดอง',
  Cargo_Reconciliation: 'การสร้างความปรองดอง',
  Cargo_ReconciliationAmount: 'ยอดการปรองดอง',
  Cargo_ReconciliationConfirmation: 'ยืนยันปรองดองสมานฉันท์',
  Cargo_ReconciliationDate: 'วันที่ปรองดอง',
  Cargo_ReconciliationOfAR: 'การสร้างความปรองดองของลูกหนี้',
  Cargo_ReconciliationStatus: 'สถานะการปรองดอง',
  Cargo_ReconciliationStatusControl: 'การควบคุมสถานะการปรองดอง',
  Cargo_ReconciliationType: 'ประเภทการสร้างความปรองดอง',
  Cargo_SendEmailByReconciliationDiff: 'ไม่ว่าจะเป็นการซิงค์ข้อความเมื่อมีการบันทึก การแจ้งเตือนค่าใช้จ่าย การสร้างบุคลากร ยอดกระทบยอดไม่สอดคล้องกัน',
  Cargo_ReconciliationDiffConfirm: 'การจัดการความแตกต่างของการปรองดอง',
  Cargo_ReconciliationDiffReason: 'สาเหตุของความแตกต่าง',
  Cargo_ReconciliationDiffConfirmTip: 'ไม่ว่าจะเป็นการส่งจดหมายแจ้งยอดเงินปรองดองที่ไม่สอดคล้องกันเมื่อบันทึก',
  Cargo_Record: 'บันทึกการลงทะเบียน',
  Cargo_RecordCount: 'จำนวนระเบียน',
  Cargo_Recorder: 'บันทึกโดย',
  Cargo_RecordLabel: 'ป้ายบันทึก',
  Cargo_RecordNoOfPaidIn: 'หมายเลขทะเบียนเรียกชำระแล้ว',
  Cargo_RecordOrNot: 'ไม่ว่าจะเป็นการลงทะเบียน',
  Cargo_RecordOutOfPocket: 'ลงทะเบียนชำระเงินจริง',
  Cargo_RecordPrepayment: 'ลงทะเบียนล่วงหน้า',
  Cargo_RecordsFound: 'สอบถามไปยัง {0} บันทึก',
  Cargo_RecordsWithEmptyInvoiceTypeExist: 'มีการบันทึกประเภทใบแจ้งหนี้ว่างเปล่า',
  Cargo_RecordTime: 'เวลาบันทึก',
  Cargo_RedChargesOrNot: 'ไม่ว่า Hongchong มีค่าใช้จ่ายในต่างประเทศไม่มีเลขบิลที่ถูกต้อง',
  Cargo_ReDeliveryOrNot: 'ส่วนจะส่งเป็นรองหรือไม่',
  Cargo_ReferralFromExistingClient: 'แนะนำลูกค้าประจำ',
  Cargo_Reflush: 'อัพเดท',
  Cargo_RefNbr: 'หมายเลขใบปิด',
  Cargo_Refresh: 'รีเฟรช',
  Cargo_RefreshCompleteStatus: 'อัปเดตเสร็จสมบูรณ์',
  Cargo_RefreshSearch: 'สอบถาม รีเฟรช',
  Cargo_RefundAdvanceReceipt: 'การคืนเงินก่อนการเรียกเก็บเงิน',
  Cargo_RefundOfLclBusiness: 'มีการคืนเงิน LCL หรือไม่?',
  Cargo_Refuse: 'ปฏิเสธ',
  Cargo_Region: 'ภูมิภาค',
  Cargo_RegisteredCapital: 'ทุนจดทะเบียนบริษัท',
  Cargo_RegisteredCapitalIn10Thousand: 'ทุนจดทะเบียนบริษัท / วัน',
  Cargo_RegistrationNumber: 'เลขประจำตัวผู้เสียภาษี',
  Cargo_RegistrationNumberP: 'เลขประจำตัวผู้เสียภาษี:',
  Cargo_ReIssuedInvoiceNo: 'เปิดหมายเลขใบแจ้งหนี้ใหม่อีกครั้ง',
  Cargo_ReIssuedInvoiceNoP: 'เปิดหมายเลขใบแจ้งหนี้ใหม่:',
  Cargo_ReIssueInvoice: 'ออกใบแจ้งหนี้อีกครั้ง',
  Cargo_ReIssueVoidedInvoice: 'การออกตั๋วใหม่หลังจากเป็นโมฆะ',
  Cargo_RelatedBLNo: 'หมายเลขใบตราส่งสินค้าที่เกี่ยวข้อง',
  Cargo_Release: 'ปล่อย',
  Cargo_ReleaseHbl: 'แยกและวางแผ่น',
  Cargo_Releasing: 'ใส่แผ่น',
  Cargo_ReleasingStatus: 'สถานะการวางแผ่น',
  Cargo_RemainingAmount: 'จำนวนเงินที่เหลือ',
  Cargo_RemainingPledgedAmount: 'จำนวนเงินที่เรียกร้องคงเหลือ',
  Cargo_Remarks: 'หมายเหตุ',
  Cargo_SupervisorComments: 'พื้นที่แสดงความคิดเห็นของผู้บังคับบัญชา',
  Cargo_RemarksCannotBeEmptyWhenWipeOut: 'หมายเหตุไม่สามารถเว้นว่างได้เมื่อไม่สนใจเศษส่วน',
  Cargo_RemarksOnAROrAPItems: 'หมายเหตุ รายวิชา ค่าธรรมเนียมการรับชำระเงิน',
  Cargo_RemarksOnPayment: 'หมายเหตุการชำระเงิน',
  Cargo_RemarksP: 'หมายเหตุ:',
  Cargo_ArOriginalCurrency: 'ลูกหนี้ (สกุลเงินเดิม)',
  Cargo_ApOriginalCurrency: 'ชำระ (สกุลเงินเดิม)',
  Cargo_RemarkTheLengthCannotExceedP: 'หมายเหตุ ความยาวไม่เกิน',
  Cargo_RemarkTheLengthCannotExceedP256: 'หมายเหตุ ความยาวไม่เกิน 256',
  Cargo_RemittanceFee: 'ค่าธรรมเนียมการโอนเงิน',
  Cargo_Remove: 'ลบ',
  Cargo_RemoveConfig: 'ลบการกำหนดค่า',
  Cargo_AddConfig: 'เพิ่มการกำหนดค่า',
  Cargo_RemoveBillCharge: 'ค่าธรรมเนียมการกำจัด',
  Cargo_RemoveDetails: 'ลบรายละเอียด',
  Cargo_RemoveExpenseRemoveAll: 'ค่าธรรมเนียมการลบ / ลบทั้งหมด',
  Cargo_RemoveParameterFunction: 'ฟังก์ชั่นการลบพารามิเตอร์',
  Cargo_RemovePartial: 'ลบส่วน',
  Cargo_OrderType: 'ประเภทการสั่งซื้อ',
  Cargo_TruckTrailer: 'รถบรรทุกพ่วง',
  Cargo_WholeVehicleAndLessThanCarload: 'รถทั้งคัน / ศูนย์แขน',
  Cargo_RemovePermissionToSubmitExpense: 'ยกเลิกสิทธิ์ในการยื่นค่าธรรมเนียม',
  Cargo_RemoveSelectedData: 'ลบข้อมูลที่ถูกเลือก',
  Cargo_RemoveSelectedExpense: 'ลบค่าธรรมเนียมที่เลือก',
  Cargo_RenderStyle: 'การแสดงผลสไตล์',
  Cargo_Renew: 'ต่ออายุ',
  Cargo_RenewContract: 'การต่อสัญญาใหม่',
  Cargo_ReOpen: 'เปิดอีกครั้ง',
  Cargo_ReOpenedSuccessfully: 'กลับมาประสบความสำเร็จอีกครั้ง',
  Cargo_RepeatedMaintenance: 'การบำรุงรักษาซ้ำ',
  Cargo_ReplaceBill: 'เปลี่ยนบิล',
  Cargo_ReportTo: 'การซักถามวัตถุ',
  Cargo_Reset: 'รีเซ็ต',
  Cargo_ResetFilter: 'รีเซ็ตเงื่อนไข',
  Cargo_Restore: 'การกู้คืน',
  Cargo_RestoreSelectedClient: 'ไม่ว่าจะเป็นการยืนยันลูกค้าที่กลับมาเลือกอีกครั้ง',
  Cargo_RetreatASingle: 'รายการคืนเงิน',
  Cargo_RetrievalFailureReturnFunction: 'เรียกคืนฟังก์ชันส่งคืนล้มเหลว',
  Cargo_RetrievalFunction: 'ดึงฟังก์ชัน',
  Cargo_RetrievalType: 'ประเภทการดึงข้อมูล',
  Cargo_RetrievalTypeP: 'ประเภทการดึงข้อมูล:',
  Cargo_Retrieved: 'เรียกคืนแล้ว',
  Cargo_RetrievedButNotReturned: 'รับคืนแล้ว (ไม่คืนเงิน)',
  Cargo_RetrieveMark: 'แท็กดึงกลับ',
  Cargo_Return: 'ส่งคืน',
  Cargo_ReturnDate: 'วันที่คืนเงิน',
  Cargo_Returned: 'คืนเงินแล้ว',
  Cargo_ReturnedSuccessfully: 'คืนเงินสำเร็จ',
  Cargo_ReturnExpressNumber: 'การคืนหมายเลขด่วน',
  Cargo_ReturnOrderExpressNumber: 'หมายเลขการจัดส่งสินค้าด่วน',
  Cargo_ReturnQuery: 'กลับไปที่คำถาม',
  Cargo_ReturnToSearch: 'จะกลับไปสอบถามหรือไม่',
  Cargo_Revenue: 'รายได้',
  Cargo_RevenueAndExpenditureType: 'ประเภทรายรับและรายจ่าย',
  Cargo_RevenueOrExpenditure: 'รายรับและรายจ่าย',
  Cargo_Reverse: 'ยืนยันว่า เรดชอง',
  Cargo_ReversedCloseAccountSuccessfully: 'ป้องกันการชำระเงินที่ประสบความสำเร็จ',
  Cargo_CloseAccountSuccessfully: 'เช็คเอาท์สำเร็จ',
  Cargo_ReverseReview: 'การตรวจสอบย้อนกลับ',
  Cargo_ReverseReviewedSuccessfully: 'ตรวจสอบย้อนกลับสำเร็จ',
  Cargo_ReviewCancelledSuccessfully: 'ยกเลิกการตรวจสอบสำเร็จ',
  Cargo_ReviewedOrNot: 'ไม่ว่าจะเป็นการตรวจสอบ',
  Cargo_ReviewOverallSearch: 'ตรวจสอบแบบสอบถามทั่วโลก',
  Cargo_ReviewTime: 'เวลาตรวจสอบ',
  Cargo_ReviewVoucher: 'รีวิวคูปอง',
  Cargo_Revoke: 'เพิกถอน',
  Cargo_RevokeClaim: 'เพิกถอนการอ้างสิทธิ์',
  Cargo_RevokedSuccessfully: 'ยกเลิกสำเร็จ',
  Cargo_RevokeInvoicingApplication: 'ขอเพิกถอนการออกใบแจ้งหนี้',
  Cargo_RevokeOrNot: 'ไม่ว่าจะเป็นการเพิกถอน',
  Cargo_PushFailByCBMS: 'การผลักดันล้มเหลวให้ติดต่อเจ้าหน้าที่เพื่อตรวจสอบ',
  Cargo_PushSuccessByCBMS: 'ผลักดันให้ธุรกิจประสบความสำเร็จ',
  Cargo_RevokeReview: 'ยกเลิกการตรวจสอบ',
  Cargo_RevokeSelection: 'ยกเลิกการเลือก',
  Cargo_RevokeWithdrawal: 'การถอนเงินคืน',
  Cargo_RevokeWithdrawalList: 'ถอนรายการคืนเงิน',
  Cargo_RevokingRetrievalFailed: 'การถอนเงินคืนล้มเหลว',
  Cargo_RFPNMIS: 'ไม่มีระยะเวลาทางการเงินที่สอดคล้องกันในชุดบัญชี',
  Cargo_RITSS: 'บันทึกการนำเข้าระบบเรียบร้อยแล้ว',
  Cargo_RTGTEOMCACC: 'การดำเนินการส่งออกภาษีทองคำที่ซ้ำซ้อนอาจมีค่าใช้จ่ายเพิ่มเติม,มั่นใจหรือไม่ว่าต้องการส่งออกภาษีทองคำอีก?',
  Cargo_RTIAFRODI: 'หากไม่เลือก "ลบใบยืนยันค่าใช้จ่ายพร้อมกัน" ให้ส่งใบแจ้งหนี้กลับไปที่การตรวจสอบคำขอออกใบแจ้งหนี้ มิฉะนั้นใบแจ้งหนี้และใบยืนยันค่าใช้จ่ายจะถูกลบออก',
  Cargo_RTPIRS: 'ถูกรีเซ็ตในการตรวจสอบคำร้องขอใบแจ้งหนี้',
  Cargo_Rule: 'กฎ',
  Cargo_SABID: 'ไม่ว่าจะข้ามไปกรอกข้อมูลพื้นฐานโดยตรง',
  Cargo_SADNSUICAT: 'วิชาปัจจุบันไม่มีการตั้งบัญชีรอง',
  Cargo_SailingDate: 'วันที่ออกเดินทาง',
  Cargo_SailingDay: 'วันออกเรือ',
  Cargo_ETD: 'ETD',
  Cargo_ETA: 'ETA',
  Cargo_ATD: 'ATD',
  Cargo_ATA: 'ATA',
  Cargo_LookDetail: 'ดูรายละเอียด',
  Cargo_Sales: 'ฝ่ายขาย',
  Cargo_SalesP: 'ฝ่ายขาย:',
  Cargo_SalesBranchCompany: 'สาขาขาย',
  Cargo_SalesCommission: 'ค่าคอมมิชชั่นการขาย',
  Cargo_SalesCompany: 'บริษัท ขาย',
  Cargo_SalesDepartment: 'ฝ่ายขาย',
  Cargo_SalesFreeHand: 'ขายตนเอง',
  Cargo_Salesman: 'พนักงานธุรกิจ',
  Cargo_SalesmanP: 'พนักงาน:',
  Cargo_SalesParty: 'ฝ่ายขาย',
  Cargo_SalesPerson: 'พนักงานขาย',
  Cargo_SALOGROEI: 'อย่างน้อยต้องเลือกเงื่อนไขการจัดกลุ่ม หรือป้อนชื่อสรุป',
  Cargo_SameYear: 'ปีเดียวกัน',
  Cargo_SAPPMBI: 'หน่วยชำระหนี้ที่เรียกชำระแล้ว/ชำระหนี้ที่เลือกต้องเป็นหน่วยเดียวกัน',
  Cargo_Save: 'บันทึก',
  Cargo_SaveAll: 'บันทึกทั้งหมด',
  Cargo_SaveAndAdd: 'บันทึกและใหม่',
  Cargo_SaveAndCalculateTotalAmount: 'บันทึกและคำนวณจำนวนเงินทั้งหมด',
  Cargo_SaveBill: 'บันทึกบิล',
  Cargo_SaveCurrentSelection: 'บันทึกการเลือกปัจจุบัน',
  Cargo_CurrentSelection: 'ตัวเลือกปัจจุบัน',
  Cargo_Saved: 'การเก็บรักษาเสร็จสมบูรณ์',
  Cargo_SaveEditing: 'บันทึกการแก้ไข',
  Cargo_SaveEntity: 'บันทึกหน่วยงาน',
  Cargo_SaveExchangeRateToCache: 'บันทึกอัตราแลกเปลี่ยนเพื่อแคช',
  Cargo_SaveFailed: 'การบันทึกล้มเหลว',
  Cargo_SaveGroupInfo: 'บันทึกข้อมูลการจัดกลุ่ม',
  Cargo_SaveInvoice: 'บันทึกใบแจ้งหนี้',
  Cargo_SaveInvoiceNo: 'บันทึกหมายเลขใบแจ้งหนี้',
  Cargo_SaveOrNot: 'ไม่ว่าจะเป็นเจียไต๋อนุรักษ์ไว้',
  Cargo_SaveQueryP: 'บันทึกพารามิเตอร์แบบสอบถาม',
  Cargo_SaveReconciliation: 'บันทึกความปรองดอง',
  Cargo_SaveSucceed: 'บันทึกความสำเร็จ',
  Cargo_Saving: 'บันทึกไว้',
  Cargo_SBRASPATFRD: 'คำขอชำระเงินไม่ต้องมีการตรวจสอบทางธุรกิจและส่งตรงไปยังการตรวจสอบทางการเงิน',
  Cargo_SBSPISB: 'สาขาเดียวกันสรุปตามวัตถุของการตั้งถิ่นฐาน',
  Cargo_ScaleOfCompany: 'ขนาดของบริษัท',
  Cargo_ScaleOfCompanyEmployees: 'ขนาด บริษัท / คน',
  Cargo_SCNEIPMSL: 'โมดูลพันธมิตรที่มีอยู่แล้วธุรกิจที่มีชื่อคล้ายกันต้องการความสัมพันธ์หรือไม่',
  Cargo_SCOCCSC: 'ค่าคอมมิชชั่นการขาย ค่าคอมมิชชั่น การบริการลูกค้า',
  Cargo_SDNCCNTFL: 'มีข้อมูลใบแจ้งยอดที่ยังไม่โหลดเสร็จสมบูรณ์ กรุณาคลิกถัดไปเพื่อโหลด',
  Cargo_SDNMBR: 'สถานะการเรียกเก็บเงินไม่เป็นไปตามใบแจ้งหนี้',
  Cargo_SDNMWOR: 'สถานะการเรียกเก็บเงินไม่เป็นไปตามข้อกำหนดการตัดบัญชี',
  Cargo_SeaportOfDischarge: 'ท่าเรือขนถ่ายสินค้า (ท่าเรือ)',
  Cargo_Search: 'ดึงข้อมูล',
  Cargo_SearchAlreadyExisted: 'การสอบถามมีอยู่แล้ว',
  Cargo_SearchAPWriteOffs: 'สอบถามบัญชีเจ้าหนี้',
  Cargo_SearchARWriteOff: 'สอบถามบัญชีลูกหนี้การขาย',
  Cargo_SearchCompleted: 'สอบถามสำเร็จ',
  Cargo_SearchConditions: 'เงื่อนไขการสอบถาม',
  Cargo_SearchCreated: 'สร้างแบบสอบถาม',
  Cargo_SearchDisplayColumn: 'คอลัมน์แสดงแบบสอบถาม',
  Cargo_SearchError: 'การสอบถามผิดพลาด',
  Cargo_SearchForBill: 'สอบถามเกี่ยวกับการเรียกเก็บเงิน',
  Cargo_SearchForBusinessDeptApproved: 'สอบถามเกี่ยวกับการอนุมัติธุรกิจและการอนุมัติของหน่วยงาน',
  Cargo_SearchForBusinessOfSameGroup: 'สอบถามธุรกิจกลุ่มเดียวกัน',
  Cargo_SearchForData: 'สอบถามข้อมูล',
  Cargo_SearchForDataAsPerPermission: 'ไม่ว่าจะเป็นการสอบถามข้อมูลตามอำนาจหน้าที่',
  Cargo_SearchForExpenses: 'ค่าธรรมเนียมการสอบถาม',
  Cargo_SearchForMore: 'ไม่ว่าจะเป็นการสอบถามเพิ่มเติม',
  Cargo_SearchForOverseasExpense: 'ไม่ว่าจะเป็นการสอบถามเรื่องค่าใช้จ่ายในต่างประเทศ',
  Cargo_SearchForParameterTemplateList: 'รายการเทมเพลตพารามิเตอร์แบบสอบถาม',
  Cargo_SearchInformation: 'สอบถามข้อมูล',
  Cargo_SearchMark: 'เครื่องหมายสอบถาม',
  Cargo_SearchOperation: 'การดำเนินการสอบถาม',
  Cargo_SecondNotifyParty: 'ประกาศฉบับที่ 2',
  Cargo_SecondVoyage: 'เรือเที่ยว',
  Cargo_SecureBusiness: 'ธุรกิจล็อค',
  Cargo_SEFInput: 'รายการประกาศศุลกากร',
  Cargo_Select: 'เลือก',
  Cargo_SelectAddPlatfoCNYLMethod: 'แพลตฟอร์ม B / L วิธีการเลือกเพิ่ม',
  Cargo_SelectAddPlatformContainerType: 'ตัวเลือกกล่องแพลตฟอร์ม เพิ่ม',
  Cargo_SelectAddPlatformCurrency: 'ตัวเลือกสกุลเงินของแพลตฟอร์ม เพิ่ม',
  Cargo_ShippingAddress: 'ที่อยู่จัดส่ง',
  Cargo_AddModel: 'การบำรุงรักษารุ่น',
  Cargo_maintenance: 'การบำรุงรักษาตู้คอนเทนเนอร์',
  cargo_container_type: 'ประเภทคอนเทนเนอร์',
  cargo_container_code: 'รหัสคอนเทนเนอร์',
  cargo_container_number: 'หมายเลขของคอนเทนเนอร์',
  cargo_pallet: 'คณะกรรมการห่อ',
  cargo_container_max_weight: 'คอนเทนเนอร์สามารถโหลดน้ำหนักสินค้า',
  cargo_container_max_capacity: 'ความจุสินค้าบรรจุภาชนะ',
  cargo_loading_rate: 'อัตราการโหลด',
  Cargo_Container_Type_Not_Configured: 'คุณไม่ได้บำรุงรักษาคอนเทนเนอร์และสามารถไปที่ 【ข้อมูลพื้นฐาน - คอนเทนเนอร์】 เพื่อรักษาข้อมูลที่สอดคล้องกัน',
  cargo_please_enter_the_container: 'กรุณาใส่คอนเทนเนอร์',
  cargo_please_enter_the_container_code: 'โปรดป้อนรหัสคอนเทนเนอร์',
  cargo_Please_select_a_container: 'โปรดเลือกคอนเทนเนอร์',
  cargo_Charter_package_board_statistics: 'กฎบัตรแพคเกจสถิติคณะกรรมการ',
  cargo_please_enter_the_cost: 'โปรดป้อนค่าธรรมเนียม',
  Cargo_please_enter_flight_costs: 'เที่ยวบินเช่าเหมาลำ/เช่าเหมาลำ กรุณาระบุค่าใช้จ่ายของเที่ยวบิน',
  Cargo_Please_enter_charter_details_or_flight_costs: 'เที่ยวบินแบบเช่าเหมาลำ กรุณากรอกข้อมูลเช่าเหมาลำหรือค่าใช้จ่ายของเที่ยวบิน',
  cargo_can_only_be_dragged_under_a_container: 'สามารถลากได้ใต้ตู้คอนเทนเนอร์เท่านั้น',
  cargo_requires_dragging_across_containers: 'ต้องการลากข้ามคอนเทนเนอร์',
  cargo_not_allowed_reconfiguration: 'กิจการอื่นที่อยู่นอกสถานประกอบการที่เป็นบวกไม่อนุญาตให้เปลี่ยนสภาพกิจการ',
  Cargo_cross_flight_tips: 'เที่ยวบินข้ามจะเชื่อมต่อตู้คอนเทนเนอร์ใหม่และลบข้อมูลตู้คอนเทนเนอร์ทั้งหมดที่เกี่ยวข้องกับธุรกิจเดิมโปรดยืนยันว่าจะดำเนินการต่อหรือไม่',
  Cargo_CheckUldWeightOrCubage: 'รหัสคอนเทนเนอร์: {0} สินค้า {1} เกินสินค้าที่โหลดได้ {2} โปรดยืนยันว่าจะบันทึกหรือไม่?',
  Cargo_master_reconfiguration_tips: 'หลังจากการเปลี่ยนแปลงตั๋วขนาดเล็กทั้งหมดภายใต้ตั๋วหลักจะเชื่อมโยงกับคอนเทนเนอร์นี้ จะดำเนินการต่อหรือไม่?',
  cargo_no_flight_information: 'ธุรกิจปัจจุบันไม่มีเที่ยวบินและไม่มีข้อมูลเที่ยวบินสำหรับสถานที่เป้าหมายโดยไม่ต้องดำเนินการ',
  cargo_unloaded_container_business: 'ธุรกิจคอนเทนเนอร์ที่ไม่ได้ติดตั้ง',
  Cargo_SelectAddPlatformPackages: 'แพคเกจแพลตฟอร์มเลือกเพิ่ม',
  Cargo_SelectAddPlatformShippingTerms: 'เงื่อนไขการจัดส่งของแพลตฟอร์ม เลือกเพิ่ม',
  Cargo_SelectAddPlatformTradeMethod: 'รูปแบบการค้าแพลตฟอร์ม เลือกเพิ่ม',
  Cargo_SelectAddPlatformTradeTerms: 'เงื่อนไขการค้าแพลตฟอร์ม เลือกเพิ่ม',
  Cargo_SelectAll: 'เลือกทั้งหมด',
  Cargo_SelectBusinessDateRange: 'เลือกช่วงวันที่ทำธุรกิจ',
  Cargo_SelectCopyContent: 'เลือกเนื้อหาที่คัดลอก',
  Cargo_SelectCurrency: 'เลือกสกุลเงิน',
  Cargo_Selected: 'เลือก',
  Cargo_SelectedByDefault: 'เลือกปริยาย',
  Cargo_SelectedData: 'ข้อมูลที่ถูกเลือก',
  Cargo_SelectedEntity: 'นิติบุคคลที่เลือกไว้แล้ว',
  Cargo_SelectedExpenseConfirmedExpense: 'ค่าธรรมเนียมที่เลือก ยืนยันค่าธรรมเนียม',
  Cargo_SelectedInvoice: 'ใบแจ้งหนี้ที่เลือก',
  Cargo_SelectedItems: 'เลือก: {0}',
  Cargo_SelectedP: 'เลือก:',
  Cargo_SelectedVoucher: 'บัตรกำนัลที่เลือก',
  Cargo_SelectedVoucherCantOver100: 'บัตรกำนัลที่เลือก {0} รายการต้องไม่เกิน 100 รายการ',
  Cargo_SelectEventStatus: 'กรุณาเลือกสถานะกิจกรรม',
  Cargo_SelectEventToApprove: 'โปรดเลือกเรื่องอนุมัติ',
  Cargo_SelectFilesToDownload: 'โปรดเลือกไฟล์ที่ต้องการดาวน์โหลด',
  Cargo_SelectInvoiceNo: 'เลือกหมายเลขใบแจ้งหนี้',
  Cargo_SelectNewInvoiceNo: 'เลือกหมายเลขใบแจ้งหนี้ใหม่',
  Cargo_SelectOrAddInvoiceNo: 'เลือกหรือกรอกหมายเลขใบแจ้งหนี้',
  Cargo_SelectPaperInvoiceByDefault: 'เลือกใบแจ้งหนี้กระดาษโดยปริยาย',
  CargoMsg_Information_Supplement: 'ข้อมูลเสริม',
  Cargo_SelectRecordsToExport: 'โปรดเลือกระเบียนที่คุณต้องการส่งออก',
  Cargo_SelectSalesPerson: 'กรุณาเลือกฝ่ายขาย',
  Cargo_SelectSalesPersonDep: 'กรุณาเลือกฝ่ายขาย',
  Cargo_SelectCsr: 'กรุณาเลือกฝ่ายบริการลูกค้า',
  Cargo_SelectCsrDep: 'กรุณาเลือกแผนกบริการลูกค้า',
  Cargo_SelectDoc: 'กรุณาเลือกเอกสาร',
  Cargo_SelectDocDep: 'กรุณาเลือกแผนกเอกสาร',
  Cargo_SelectOverseaOp: 'กรุณาเลือกฝ่ายบริการลูกค้าต่างประเทศ',
  Cargo_SelectOverseaOpDep: 'กรุณาเลือกแผนกบริการลูกค้าต่างประเทศ',
  Cargo_SelectCargoSales: 'กรุณาเลือก Range Sales',
  Cargo_SelectPlanner: 'โปรดเลือกผู้รับผิดชอบเส้นทางบิน',
  Cargo_SelectPlannerDep: 'โปรดเลือกแผนกผู้รับผิดชอบเส้นทางบิน',
  Cargo_invalidBatchModifyBusiness: 'ไม่พบสาขาที่ดำเนินการ และสาขาขาย ธุรกิจเดียวกัน กรุณาเลือกอีกครั้ง',
  Cargo_SelectSob: 'เลือกชุดบัญชี',
  Cargo_SelectSubject: 'กรุณาเลือกหัวข้อ',
  Cargo_SelectToCopyInFutureDoNotAsk: 'คัดลอกโดยการเลือกนี้ในภายหลัง ไม่ต้องถามอีก',
  Cargo_SelectVoucherDate: 'เลือกวันที่บัตรกำนัล',
  Cargo_SelfDeclaration: 'พศด.',
  Cargo_SelfDeclareToCustoms: 'ไม่ว่าจะประกาศศุลกากรด้วยตนเอง',
  Cargo_SelfDelivery: 'จัดส่งด้วยตนเอง',
  Cargo_SpecialApprovalIssuance: 'การอนุมัติพิเศษสำหรับการออกหมายเลข',
  Cargo_CurrentAvailableQuantity: 'จำนวนที่มีให้ใช้งานปัจจุบัน',
  Cargo_OccupiedBusinessNumber: 'หมายเลขธุรกิจที่ถูกครอบครอง',
  Cargo_RemainingAvailableQuantity: 'จำนวนที่เหลือที่สามารถใช้ได้',
  Cargo_SpecialApprovalCreateBusiness: 'เมื่อวัตถุการชำระเงินเกินการควบคุมเครดิตและตั้งค่าด้วย [ไม่สามารถบันทึกได้] เมื่อสร้างธุรกิจ สามารถใช้การอนุมัติพิเศษในการออกหมายเลขเพื่อสร้างธุรกิจพิเศษ',
  Cargo_CopyResult: 'คัดลอกสำเร็จ {0} รายการ, คัดลอกล้มเหลว {1} รายการ',
  Cargo_SellingPrice: 'ราคาขาย',
  Cargo_SellTitle: 'หน่วยขาย',
  Cargo_Send2: 'ส่งออก',
  Cargo_SendAll: 'ส่งมาทั้งหมด',
  Cargo_SendAllP: 'ไม่ว่าจะเป็นการส่งทั้งหมด',
  Cargo_SendBack: 'การคืนเงิน',
  Cargo_SendConfirmationStatus: 'ส่งยืนยันสถานะ',
  Cargo_SendFailed: 'การส่งล้มเหลว',
  Cargo_SendingDate: 'วันที่จัดส่ง',
  Cargo_SendMessage: 'ส่งข้อความ',
  Cargo_SendPartial: 'ส่งบางส่วน',
  Cargo_SendToBranchCompany: 'ส่งสาขา',
  Cargo_Sent: 'ส่งแล้ว',
  Cargo_SentDate: 'วันที่ส่ง',
  Cargo_SeparateNumber: 'หมายเลขย่อย',
  Cargo_September: 'กันยายน',
  Cargo_SequenceNumber: 'หมายเลขซีเรียล',
  Cargo_UNNumber: 'หมายเลขสหประชาชาติ',
  Cargo_ChargeUnit: 'หน่วยเรียกเก็บเงิน / หน่วย',
  Cargo_DangerousGoods: 'สินค้าอันตราย',
  Cargo_IndicatesRequired: '*หมายเลขระบุจำเป็น',
  Cargo_NewTo: 'เพิ่มใหม่',
  Cargo_EditTo: 'บรรณาธิการ',
  Cargo_AccountingPeriodRange: 'โปรดระบุช่วงระยะเวลาบัญชี',
  Cargo_SerialNoOfBankReceipt: 'น้ำเดี่ยวไหล',
  Cargo_AutoUpdateNote: 'ต้องการอัปเดตหมายเหตุโดยอัตโนมัติหรือไม่?',
  Cargo_ConfirmBeforeEnable: 'โปรดยืนยันกับทีมเทคนิคก่อนเปิดใช้งาน อย่าเปิดใช้งานโดยไม่จำเป็น',
  Cargo_MultiHeaderBankMode: 'โหมดธนาคารหลายชื่อ',
  Cargo_ServiceCodeCannotBeNull: 'รหัสบริการไม่สามารถเว้นว่างได้',
  Cargo_ServiceItems: 'โครงการบริการ',
  Cargo_ServiceName: 'ชื่อบริการ',
  Cargo_AutoGenerateFeeName: 'สร้างชื่อค่าบริการอัตโนมัติ',
  Cargo_AutoGenerateTaxRate: 'สร้างอัตราภาษีอัตโนมัติ',
  Cargo_TaxNameRateConsistency: 'ชื่ออัตราภาษี/ค่าบริการ และอัตราภาษี ต้องกรอกทั้งคู่หรือไม่กรอกทั้งคู่',
  Cargo_AutoGenerateOrDefaultTaxExclusive: 'ไม่สามารถเปิดใช้งานทั้งการสร้างอัตราภาษีอัตโนมัติและอัตราภาษี默认ได้พร้อมกัน ต้องเลือกใช้อันใดอันหนึ่งเท่านั้น',
  Cargo_ServiceNameCanTBeEmpty: 'ชื่อบริการต้องไม่ว่างเปล่า',
  Cargo_ServiceRequestAddressForEInvoice: 'E-Invoice Services ที่อยู่คำขอ',
  Cargo_ServiceTicket: 'แบบฟอร์มยืนยันค่าใช้จ่าย',
  Cargo_ServiceTicketState: 'ยืนยันสถานะโสด',
  Cargo_ServiceTicketCreatedOrNot: 'ไม่ว่าจะเป็นใบยืนยันการเรียกเก็บเงิน',
  Cargo_ServiceTicketIssued: 'แบบฟอร์มยืนยันการเปิด',
  Cargo_SetAging: 'กำหนดอายุบัญชี',
  Cargo_SetDefault: 'ตั้งค่าปริยาย',
  Cargo_SetDefaultItemDescription: 'ตั้งค่าชื่อรายการปริยาย',
  Cargo_SetDefaultItemName: 'ไม่ว่าจะเป็นชื่อรายการปริยาย',
  Cargo_SetFocusToFileNoTextTable: 'ตั้งค่าโฟกัสไปยังกล่องข้อความหมายเลขแฟ้ม',
  Cargo_SetName: 'ตั้งค่าชื่อ',
  Cargo_SetsOfBooks: 'ชุดบัญชี',
  Cargo_SetsOfBooksP: 'แขนบัญชี:',
  Cargo_SetText: 'ตั้งค่าข้อความ',
  Cargo_SettleAccountsTo: 'วัตถุของการตั้งถิ่นฐาน',
  Cargo_SettleByMonthly: 'การชำระเงินรายเดือน',
  Cargo_SettleByWeekly: 'การชำระเงินรายสัปดาห์',
  Cargo_SettlementAgent: 'ตัวแทนการตั้งถิ่นฐาน',
  Cargo_SettlementAgentError: 'ข้อผิดพลาดของตัวแทนการตั้งถิ่นฐานโปรดเลือกใหม่!',
  Cargo_SettlementByBill: 'ปมตั๋ว',
  Cargo_SettlementCompany: 'หน่วยการชำระเงิน',
  Cargo_SettlementMethod: 'วิธีการชำระราคา',
  Cargo_SettlementMethodP: 'วิธีการชำระราคา',
  Cargo_SettlementNotByBill: 'ปมที่ไม่ใช่ตั๋ว',
  Cargo_SettlementNotice: 'แจ้งการชำระเงินปม',
  Cargo_SettlementPartyDoesNotExist: 'ไม่มีวัตถุแห่งการชำระราคา',
  Cargo_SettlementStatus: 'สถานะ Knot Pay',
  Cargo_SettlementType: 'ประเภทการชำระราคา',
  Cargo_DoNotSpecify: 'ไม่ระบุ',
  Cargo_DomesticAndForeign: 'ในประเทศ / ต่างประเทศ',
  Cargo_CurrencyRequirements: 'ข้อกำหนดสกุลเงิน',
  Cargo_NotSpecified: 'ไม่ระบุ',
  Cargo_Appoint: 'ระบุ',
  Cargo_PaymentInOriginalCurrency: 'การชำระเงินด้วยสกุลเงินเดิม',
  Cargo_SettlingAgentInconsistent: 'ตัวแทนการตั้งถิ่นฐานไม่สอดคล้องกัน',
  Cargo_SettlingCompanyMustBeIdentical: 'หน่วยการชำระหนี้ต้องเป็นหน่วยเดียวกัน',
  Cargo_SettlingCompanySAbbreviation: 'หน่วยการชำระเงิน (ย่อ)',
  Cargo_SettlingCompanySCode: 'หน่วยการชำระเงิน (รหัส)',
  Cargo_SettlingPartyCanTBeEmpty: 'วัตถุที่ชำระหนี้ไม่สามารถว่างเปล่าได้',
  Cargo_SettlingPartyIncompatible: 'การตั้งถิ่นฐานไม่เป็นเอกภาพ',
  Cargo_SettlingPartyInconsistent: 'เรื่องของการตั้งถิ่นฐานไม่สอดคล้องกัน',
  Cargo_SettlingPartyOrSettlementAgentInconsistent: 'ความไม่สอดคล้องกันของวัตถุการตั้งถิ่นฐานหรือตัวแทนการตั้งถิ่นฐาน',
  Cargo_SettlingPartyIsMandatory: 'วัตถุของการตั้งถิ่นฐานจะต้องป้อน',
  Cargo_SettlingPartyMustBeConsistent: 'การตั้งถิ่นฐานต้องสอดคล้องกัน',
  Cargo_ProjectNumberNotNull: 'หมายเลขธุรกิจไม่สามารถเว้นว่างได้',
  Cargo_SettlingPartyOfPayables: 'หน่วยการชำระเงิน',
  Cargo_SetToCurrentSob: 'ตั้งเป็นชุดบัญชีปัจจุบัน',
  Cargo_SetUpDefaultsInBatch: 'การตั้งค่าแบทช์ ค่าเริ่มต้น',
  Cargo_SetUpServiceTypesInBatch: 'ประเภทบริการการตั้งค่าแบทช์',
  Cargo_SFEDOCSP: 'สอบถามรายละเอียดค่าธรรมเนียม ณ ปัจจุบัน',
  Cargo_CollectFeeType: 'ประเภทค่าธรรมเนียม',
  Cargo_Shipper: 'จัดส่งโดย',
  Cargo_ShipperId: 'รหัสผู้ส่ง',
  Cargo_ShipperInfo: 'ข้อมูลผู้ส่งสินค้า',
  Cargo_ShipperSName: 'ชื่อผู้จัดส่ง',
  Cargo_ShippingCompanyContractNo: 'เกี่ยวกับ บริษัท เรือ',
  Cargo_ShippingCompanySAbbreviation: 'บริษัท เรือ (ย่อ)',
  Cargo_ShippingCompanySCode: 'บริษัท เรือ (รหัส)',
  Cargo_ShippingInformation: 'ข้อมูลการจัดส่ง',
  Cargo_ShippingRouteArea: 'เส้นทาง/ภูมิภาค',
  Cargo_ShortAccountIs: 'บัญชีระยะสั้นเป็นศูนย์คือ:',
  Cargo_ShowDetailedTitles: 'แสดงรายละเอียดวิชา',
  Cargo_ShowAdjustRateEntry: 'มีรายการโอนเงินปลายงวด',
  Cargo_ShowDetails: 'แสดงรายละเอียด',
  Cargo_ShowedByVessel: 'แสดงตามชื่อเรือ',
  Cargo_ShowFromTo2: 'ถึง',
  Cargo_ShowInvoiceDetails: 'แสดงรายละเอียดใบแจ้งหนี้',
  Cargo_ShowOpeningBalance: 'แสดงยอดคงเหลือเริ่มต้นงวด',
  Cargo_ShowRows: 'แสดงจำนวนแถบ',
  Cargo_ShowStatementInformation: 'แสดงข้อมูลใบแจ้งยอด',
  Cargo_ShutOut: 'ยกเลิกศุลกากร',
  Cargo_SIATEPIISOTT: 'ส่วนเริ่มต้นของแม่แบบจัดสรรพื้นที่สำหรับแต่ละคน',
  Cargo_SignContract: 'ลายเซ็น',
  Cargo_SingleBillPrinting: 'การพิมพ์ตั๋วใบเดียว',
  Cargo_SITCINCOSDHBFLBS: 'รวม: {0} Statements ปัจจุบันคือ: {1} Statements (ตรวจสอบให้แน่ใจว่าข้อมูลใบแจ้งยอดอื่น ๆ โหลดเสร็จสมบูรณ์เมื่อบันทึก)',
  Cargo_SiteVisit: 'เยี่ยมชมเว็บไซต์',
  Cargo_Size: 'ขนาด',
  Cargo_SkipPreviousStep: 'ไม่ว่าจะผ่านขั้นตอนก่อนหน้า',
  Cargo_SLNECTS: 'หมายเลขใบแจ้งเตือนตัวอักษรสีแดงไม่ได้ป้อน คุณต้องการบันทึกต่อไปหรือไม่?',
  Cargo_SoaConfirmed: '[{0}] ใบแจ้งยอดได้รับการยืนยันแล้ว',
  Cargo_SoaCreated: 'ใบแจ้งยอด',
  Cargo_SoaCreatedM: '[{0}] ใบแจ้งยอด',
  Cargo_SoaCreatedAlready: 'ร่างกฎหมายได้ทำสำนวนเรียบร้อยแล้ว',
  Cargo_SoaNoAlreadyCreated: 'มีการสร้างหมายเลขใบแจ้งยอดบัญชีไว้แล้ว',
  Cargo_SobCode: 'รหัสชุดบัญชี',
  Cargo_SobCodeAlreadyExists: 'รหัสชุดบัญชีมีอยู่แล้ว',
  Cargo_SobDataLoadingFailed: 'การโหลดข้อมูลชุดบัญชีล้มเหลว',
  Cargo_SobList: 'รายการชุดบัญชี',
  Cargo_SobName: 'ชื่อบัญชี',
  Cargo_SobNameP: 'ชื่อบัญชี:',
  Cargo_SobSetup: 'การตั้งค่าชุดบัญชี',
  Cargo_Soc: 'กล่องเจ้าของสินค้า',
  Cargo_IsSoc: 'ไม่ว่าจะเป็นกล่องเจ้าของสินค้า',
  Cargo_SoftwareVersion: 'รุ่นซอฟต์แวร์',
  Cargo_SolicitationType: 'ประเภทของแพ็คเกจ',
  Cargo_SOSINTU: 'อัปเดตสถานะการเลือกหมายเลขใบแจ้งหนี้',
  Cargo_SOSINTUIU: 'อัปเดตสถานะหมายเลขใบแจ้งหนี้ที่เลือกไว้ว่าใช้แล้ว',
  Cargo_SourceOfClient: 'แหล่งที่มาของลูกค้า',
  Cargo_SOWLC: 'คลังสินค้า Cartoning ภายใน',
  Cargo_Sp1: 'สหภาพใบแจ้งหนี้',
  Cargo_Sp17: 'ขยายรายละเอียด',
  Cargo_Sp18: 'รายละเอียดรวม',
  Cargo_Sp24: 'ข้อมูลทางการเงิน',
  Cargo_Sp27: 'ลายเซ็นองค์กร',
  Cargo_Sp31: 'แยกค่าใช้จ่าย',
  Cargo_SPABNCTBBE: 'วัตถุการตั้งถิ่นฐานและหมายเลขธุรกิจไม่สามารถว่างเปล่าได้ทั้งหมด',
  Cargo_Space2: 'วันที่ออกใบแจ้งหนี้',
  Cargo_SPBNMNAL1SCR: 'วัตถุที่ชำระบัญชี หมายเลขธุรกิจ หมายเลขหลัก วันที่สอบถามเงื่อนไขต้องกรอกข้อมูล',
  Cargo_SpecialApproval: 'ชุดพิเศษ',
  Cargo_SpecialApprovalValidUntil: 'สิทธิพิเศษใช้ได้จนถึง',
  Cargo_BusinessExpirationDate: 'วันหมดอายุของธุรกิจ',
  Cargo_SpecialApprovalTip: 'หมายเหตุ: ชุดพิเศษมีผลในระยะยาวเมื่อวันหมดอายุว่างเปล่า',
  Cargo_SpecialGoods: 'ผลิตภัณฑ์มีความพิเศษหรือไม่',
  Cargo_SpecialInvoice: 'ใบแจ้งหนี้เฉพาะ',
  Cargo_SpecialInvoiceGeneralInvoice: 'ใบแจ้งหนี้เฉพาะ / ใบแจ้งหนี้ทั่วไป',
  Cargo_SpecialInvoiceInternalInvoice: 'ใบแจ้งหนี้เฉพาะ / ใบแจ้งหนี้ภายใน',
  Cargo_SpecialPrice: 'ราคาพิเศษ',
  Cargo_SpecialPriceInstructions: 'หมายเหตุพิเศษ',
  Cargo_SpecifyCollectionPayment: 'การรับชำระเงินที่แตกต่างกัน',
  Cargo_SPIANA: 'วัตถุของการตั้งถิ่นฐานไม่สอดคล้องกันและไม่มีความสัมพันธ์ที่กลับมา',
  Cargo_SPIANA_DiffSettlementAgent: 'วัตถุของการตั้งถิ่นฐานไม่สอดคล้องกันและไม่มีความสัมพันธ์เชิงสมานฉันท์และตัวแทนการตั้งถิ่นฐานไม่สอดคล้องกัน',
  Cargo_Split: 'แยก',
  Cargo_SplitBillingFees: 'แยกค่าธรรมเนียมการเรียกเก็บเงิน',
  Cargo_SplitBL: 'ถอดแผ่น',
  Cargo_SplitExpense: 'แยกค่าธรรมเนียม',
  Cargo_SplitExpenseP: 'ค่าธรรมเนียมการแยก:',
  Cargo_SplitHBL: 'การถอดแผ่น HBL',
  Cargo_SplitMBL: 'MBL ถอดแผ่น',
  Cargo_SplitOldDataToNew: 'แยก (ข้อมูลเก่าเปลี่ยนข้อมูลใหม่)',
  Cargo_SplitSuccessfully: 'แยกสำเร็จ',
  Cargo_SPNETRSC: 'วัตถุการตั้งถิ่นฐานไม่มีอยู่โปรดรีเซ็ตแคชลอง',
  Cargo_SPWPWO: 'วัตถุของการตั้งถิ่นฐานบัญชีที่จะขาย',
  Cargo_SSNMIR: 'สถานะใบแจ้งยอดไม่ตรงตามข้อกำหนดใบแจ้งหนี้',
  Cargo_SSNMWOR: 'สถานะใบแจ้งยอดไม่ตรงตามข้อกำหนดการตัดบัญชี',
  Cargo_SSSFPR: 'บันทึกความสำเร็จ ไม่ว่าจะเป็นการส่งสถานะก่อนการพิจารณาคดี',
  Cargo_STAEONRS: 'เงื่อนไขการขนส่ง มีอยู่แล้วหรือไม่ได้เลือกบันทึก',
  Cargo_Staff: 'พนักงาน',
  Cargo_StaffP: 'พนักงาน:',
  Cargo_StampOfSalesUnit: 'หน่วยขาย: (บท)',
  Cargo_StartDateOfContainerReturn: 'คืนตู้ วันที่เริ่มต้น',
  Cargo_StartDateOfFinancialPeriod: 'วันเริ่มต้นงวดการเงิน',
  Cargo_StartingAccountTitle: 'วิชาเริ่มต้น',
  Cargo_StartNo: 'หมายเลขเริ่มต้น',
  Cargo_StartReconciliation: 'การปรองดองด้วยมือ',
  Cargo_StatementOfBalance: 'แบบฟอร์มยอดคงเหลือ',
  Cargo_StatementOfBalance2: 'งบดุลกระแสรายวัน 2',
  Cargo_Statistics: 'สถิติ',
  Cargo_StatisticsWithoutMblExpenses: 'ไม่นับค่าตั๋วหลัก',
  Cargo_Status: 'สถานะ',
  Cargo_StatusChanged: 'การเปลี่ยนแปลงสถานะ',
  Cargo_StatusOfAdvanceReceipt: 'สถานะการรับเงินล่วงหน้า',
  Cargo_STCCOTB: 'แน่ใจหรือไม่ว่าคุณต้องการยกเลิกการยืนยันการเรียกเก็บเงิน {0} นี้?',
  Cargo_STDTATM: 'ยืนยันว่าต้องการลบแผนที่รายวิชานี้หรือไม่',
  Cargo_STDTATNRAD: 'แน่ใจนะว่าอยากจะถอดวิชาออก ไม่สามารถกู้คืนได้หลังจากลบ!',
  Cargo_STDTPA: 'ยืนยันจะลบคำขอชำระเงินเหล่านี้หรือไม่',
  Cargo_STWTPA: 'ยืนยันจะถอนคำขอรับเงินเหล่านี้หรือไม่',
  Cargo_STDTSPT: 'คุณแน่ใจหรือไม่ว่าคุณต้องการลบแม่แบบพารามิเตอร์แบบสอบถามนี้',
  Cargo_STDTSRRAVWBDT: 'แน่ใจนะว่าคุณต้องการลบซอง? กฎและบัตรกํานัลที่เกี่ยวข้องกับซองบัญชีจะถูกลบออกด้วย',
  Cargo_STDTSVRJEWBDT: 'แน่ใจนะว่าคุณต้องการลบบัตรกำนัลที่เลือกไว้? รายการบัตรกํานัลที่เกี่ยวข้องจะถูกลบด้วย',
  Cargo_STDTSVRJEWBDTM: 'แน่ใจหรือว่าคุณต้องการลบบัตรกำนัล {0} ที่เลือกไว้? รายการบัตรกํานัลที่เกี่ยวข้องจะถูกลบด้วย',
  Cargo_STDTVGR: 'ยืนยันที่จะลบกฎการจัดกลุ่มบัตรกำนัลนี้?',
  Cargo_STOAOWO: 'แสดงยอดคงค้างทั้งหมด',
  Cargo_Storage: 'คลังสินค้า',
  Cargo_SendToEachRecipientSeparately: 'แยกส่งไปยังผู้รับแต่ละราย',
  Cargo_SyncSendCCAddress: 'การส่งที่อยู่ CC แบบซิงโครนัส',
  Cargo_SearchForTheDataYouWantToInsert: 'ค้นหาข้อมูลที่คุณต้องการแทรก',
  Cargo_StorageRequired: 'ไม่ว่าจะเป็นคลังสินค้า',
  Cargo_STRAEAAWORWBRC: 'แน่ใจเหรอว่าต้องการเพิกถอน ค่าปรับและบันทึกการตัดบัญชีทั้งหมดจะถูกรีเซ็ต',
  Cargo_StreetAddress: 'รายละเอียดถนน',
  Cargo_StreetAddressCanTBeEmpty: 'รายละเอียดที่อยู่ถนนไม่สามารถว่างได้',
  Cargo_STRTWOREAIIWBR: 'แน่ใจนะว่าต้องการเพิกถอนการดำเนินการตัดบัญชีนี้ ข้อมูลค่าธรรมเนียมและใบแจ้งหนี้ที่สอดคล้องกันจะถูกรีเซ็ต',
  Cargo_Stuff: 'เติม',
  Cargo_STWBTSV: 'แน่ใจนะว่าคูปอง {0} ที่คุณต้องการเลือกจาก Red Chong?',
  Cargo_SubCategoryOfAccountTitle: 'วิชาย่อย',
  Cargo_Submit: 'ส่ง',
  Cargo_SubmitExpenseForReviewDirectly: 'ไม่ว่าจะเป็นการยื่นค่าธรรมเนียมการตรวจสอบโดยตรง',
  Cargo_SubmitPaymentNotice: 'แจ้งชำระเงิน',
  Cargo_SubmitStatusSelection: 'เลือกสถานะการส่ง',
  Cargo_Submitted: 'ส่งแล้ว',
  Cargo_SubmittedForPreReviewStatus: 'ไม่ว่าจะเป็นการยื่นสถานะก่อนการไต่สวน',
  Cargo_SubmittedSuccessfully: 'ส่งเรียบร้อยแล้ว',
  Cargo_SpecialFeeLimitReleaseApply: 'คำขอปลดล็อกข้อจำกัดค่าใช้จ่ายพิเศษ',
  Cargo_SpecialFeeLimitReleaseApplyContent: 'ขอปลดล็อกข้อจำกัดค่าใช้จ่ายพิเศษสำหรับ {0}',
  Cargo_SpecialFeeLimitReleaseApplyContentPlain: 'ขอปลดล็อกข้อจำกัดค่าใช้จ่ายพิเศษ',
  Cargo_ReleaseDocumentNumberApplication: 'คำขอปล่อยเอกสาร/หมายเลข',
  Cargo_ReleaseNumberDocument: 'ปล่อยหมายเลข/เอกสาร',
  Cargo_IsPaymentReceived: 'ได้รับเงินหรือไม่',
  Cargo_PaymentTime2: 'เวลารับเงิน',
  Cargo_ReleaseNumberQuantity: 'จำนวนหมายเลขที่ปล่อย',
  Cargo_RelatedAttachments: 'ไฟล์แนบที่เกี่ยวข้อง',
  Cargo_ReleaseNumber: 'ปล่อยหมายเลข',
  Cargo_ReleaseDocument: 'ปล่อยเอกสาร',
  Cargo_RemainingTemporaryReleaseQuantity: 'จำนวนการปล่อยชั่วคราวที่เหลือ',
  Cargo_TemporaryDocumentReleaseApplication: 'คำขอปล่อยเอกสารชั่วคราว',
  Cargo_TemporaryNumberReleaseApplication: 'คำขอปล่อยหมายเลขชั่วคราว',
  Cargo_SubscribePOL: 'สถานที่จัดส่ง',
  Cargo_SubsidiaryAccounting: 'การบัญชีเสริม',
  Cargo_SubsidiaryAccountingClient: 'ช่วยลูกค้าบัญชี',
  Cargo_SubsidiaryAccountingCondition1: 'เงื่อนไขการทำบัญชีเสริม I',
  Cargo_SubsidiaryAccountingCondition2: 'เงื่อนไขการทำบัญชีเสริม II',
  Cargo_SubsidiaryAccountingCondition3: 'เงื่อนไขการบัญชีเสริม III',
  Cargo_SubsidiaryAccountingCondition4: 'เงื่อนไขการบัญชีเสริม IV',
  Cargo_SubsidiaryAccountingCondition5: 'เงื่อนไขการทำบัญชีเสริม V',
  Cargo_SubsidiaryAccountingCondition6: 'เงื่อนไขการบัญชีเสริม VI',
  Cargo_SubsidiaryAccountingItems: 'โครงการบัญชีเสริม',
  Cargo_SubsidiaryAccountingStaff: 'เจ้าหน้าที่บัญชีเสริม',
  Cargo_SubsidiaryLedger: 'รายละเอียดบัญชี',
  Cargo_SubsidiaryLedger2: 'รายละเอียดบัญชี 2',
  Cargo_SubtitlesOfAccount: 'วิชาย่อย',
  Cargo_SubTotal: 'ยอดรวม',
  Cargo_SubTotalOfOpeningBalance: 'ยอดคงเหลือเริ่มต้นงวด ยอดรวมย่อย',
  Cargo_Success: 'ความสำเร็จ',
  Cargo_SummarizeDistributionExpense: 'ไม่ว่าจะเป็นการนับค่าใช้จ่ายส่วนแบ่ง',
  Cargo_SummarizeMblExpense: 'ไม่ว่าจะเป็นการนับค่าตั๋วหลัก',
  Cargo_SupervisionMethod: 'วิธีการควบคุม',
  Cargo_SupplierContract: 'สัญญาผู้ขาย',
  Cargo_Surcharge: 'ค่าธรรมเนียมเพิ่มเติม',
  Cargo_Controlled: 'รายการควบคุม',
  Cargo_NeedInvoice: 'รายการใบแจ้งหนี้ที่จำเป็น',
  Cargo_SurchargeOrNot: 'ไม่ว่าจะเป็นค่าบริการเพิ่มเติม',
  Cargo_SureToAddToBlackList: 'มั่นใจอยากขึ้นบัญชีดำ',
  Cargo_SureToBatchConfirmTheBill: 'แน่ใจหรือไม่ว่าต้องการยืนยันการเรียกเก็บเงิน {0} นี้เป็นจำนวนมาก?',
  Cargo_SureToBatchReviewTheExpense: 'แน่ใจหรือไม่ว่าคุณต้องการตรวจสอบค่าธรรมเนียมแถบ {0} นี้เป็นจำนวนมาก?',
  Cargo_SureToCancel: 'แน่ใจนะว่าต้องการยกเลิก?',
  Cargo_SureToCancelConfirmation: 'แน่ใจนะว่าต้องการยกเลิกการยืนยัน?',
  Cargo_SureToCancelConfirmationYes: 'แน่ใจ ต้องการยกเลิกการยืนยัน ยืนยัน',
  Cargo_SureToCancelReviewOfTheExpense: 'แน่ใจหรือไม่ว่าคุณต้องการยกเลิกการตรวจสอบค่าธรรมเนียมแถบ {0} นี้?',
  Cargo_SureToCancelReviewOfTheVoucher: 'ยืนยันเพื่อยกเลิกการตรวจสอบบัตรกำนัล {0} นี้',
  Cargo_SureToCancelReviewOfTheExpenseCheck: 'มีค่าธรรมเนียมที่เลือก {0} <br/>',
  Cargo_Billinged: 'สร้างบิลแล้ว',
  Cargo_WriteOffed: 'ตรวจสอบแล้ว',
  Cargo_SureToCancelVerification: 'แน่ใจหรือไม่ว่าจะยกเลิกการตรวจสอบ',
  Cargo_SureToCarryOver: 'คุณยืนยันการดำเนินการ Carryover หรือไม่?',
  Cargo_SureToConfirmWriteOffRecord: 'แน่ใจนะว่าคุณต้องการยืนยันบันทึกการชำระหนี้',
  Cargo_SureToCreateInvoice: 'แน่ใจเกี่ยวกับการสร้างใบแจ้งหนี้?',
  Cargo_SureToCreateListOfCombinedBills: 'ตรวจสอบการสร้างและรายการตั๋ว?',
  Cargo_SureToDelete: 'คุณยืนยันที่จะลบ?',
  Cargo_SureToDeleteWarehouse: 'ข้อมูลโพซิชั่นที่เข้ามาทั้งหมดจะถูกล้างออกหลังจากการลบ คุณจะดำเนินการต่อหรือไม่?',
  Cargo_SureToDeleteInvoice: 'แน่ใจหรือว่าจะลบใบแจ้งหนี้?',
  Cargo_SureToDeleteSelectedRecord: 'แน่ใจที่จะลบรายการที่เลือก',
  Cargo_SureToDeleteTheAbstractRule: 'แน่ใจนะว่าคุณต้องการลบกฎสรุปนี้?',
  Cargo_SureToDeleteTheAdvanceReceipt: 'แน่ใจนะว่าคุณต้องการลบการเรียกเก็บเงินล่วงหน้านี้?',
  Cargo_SureToDeleteTheBill: 'แน่ใจนะว่าจะลบบิล {0} นี้?',
  Cargo_SureToDeleteTheExchangeRate: 'ยืนยันที่จะลบรายการอัตราแลกเปลี่ยนนี้?',
  Cargo_SureToDeleteTheInvoice: 'แน่ใจว่าคุณต้องการลบใบแจ้งหนี้ {0} นี้',
  Cargo_SureToDeleteTheMapping: 'ยืนยันจะเอาแผนที่นี้ออก?',
  Cargo_SureToDeleteTheRecord: 'แน่ใจนะว่าคุณต้องการลบบันทึกนี้?',
  Cargo_SureToDeleteTheRule: 'ยืนยันจะลบกติกานี้หรือไม่',
  Cargo_SureToDeleteThisSoaItem: 'แน่ใจนะว่าจะลบใบแจ้งยอด {0} นี้?',
  Cargo_SureToDeliverToBranch: 'ยืนยันต้องการส่งสาขาหรือไม่',
  Cargo_SureToDeny: 'แน่ใจนะว่าต้องการปฏิเสธ?',
  Cargo_SureToFreezeApplication: 'แน่ใจเหรอว่าต้องการระงับคำร้อง',
  Cargo_SureToHoldSubmission: 'กำหนดจะไม่ยื่นหนังสือชั่วคราว',
  Cargo_SureToIssueCombinedInvoice: 'การกำหนดการออกตั๋วรวมหรือไม่',
  Cargo_SureToModifyBillingDate: 'กำหนดวันเรียกเก็บเงินที่ต้องการแก้ไขหรือไม่',
  Cargo_SureToPrint: 'แน่ใจนะว่าอยากพิมพ์?',
  Cargo_SureToPrintDetailList: 'แน่ใจในรายละเอียดการพิมพ์?',
  Cargo_SureToReIssueInvoice: 'แน่ใจเหรอว่าต้องการออกตั๋วใหม่',
  Cargo_SureToRejectIt: 'แน่ใจนะว่าจะปฏิเสธ?',
  Cargo_SureToRejectTheExpenseItem: 'แน่ใจหรือไม่ว่าคุณต้องการยกเลิกค่าธรรมเนียม {0} รายการนี้?',
  Cargo_SureToRemoveTheBill: 'ยืนยันที่จะลบใบเรียกเก็บเงิน {0} นี้?',
  Cargo_SureToRemoveTheExpenseItem: 'ยืนยันการลบค่าธรรมเนียมแถบ {0} นี้หรือไม่?',
  Cargo_SureToReturnApplication: 'แน่ใจเหรอว่าต้องการคืนใบสมัคร',
  Cargo_SureToReviewTheBills: 'แน่ใจเหรอว่าจะตรวจสอบรายการเหล่านี้',
  Cargo_SureToReviewTheVoucher: 'ยืนยันที่จะตรวจสอบบัตรกำนัล {0} นี้?',
  Cargo_SureToRevokeContractWith: 'ไม่ว่าจะเป็นการยืนยันการเพิกถอนสัญญากับ ****',
  Cargo_SureToRevokeRetrieval: 'กำหนดถอนถอนคืนหรือไม่',
  Cargo_SureToRevokeWithdrawal: 'แน่ใจหรือไม่ว่าจะถอนการคืนเงิน?',
  Cargo_SureToVoid: 'แน่ใจนะว่าอยากเป็นโมฆะ',
  Cargo_SureToVoidInvoice: 'แน่ใจนะว่าต้องการให้ใบแจ้งหนี้เป็นโมฆะ',
  Cargo_SureToVoidTheInvoice: 'แน่ใจนะว่าต้องการให้ใบแจ้งหนี้เป็นโมฆะ',
  Cargo_SureToVoidTheInvoiceM: 'แน่ใจหรือว่าคุณต้องการยกเลิกใบแจ้งหนี้ {0} นี้?',
  Cargo_SUSBODNMWBACTS: 'ธนาคารเปิดบัญชีหน่วยขายไม่ตรงกับเลขบัญชีธนาคาร,ยืนยันจะเก็บไว้หรือไม่',
  Cargo_SUSBODNMWRISCTS: 'เลขบัญชีธนาคารของหน่วยเซลส์ไม่ตรงกับที่เก็บไว้ในระบบ,ยืนยันอยากบันทึกหรือไม่',
  Cargo_SUTCPALVIBC: 'ตั้งค่า Carryover Profit & Loss Voucher ก่อนเช็คเอาท์',
  Cargo_SVSFPHBC: 'วันที่บัตรกำนัลที่เลือกอยู่ในปัจจุบัน ช่วงเวลาทางการเงินได้ถูกยกเลิกแล้ว',
  Cargo_SVSMHBC: 'Voucher Currently selected เดือนที่เลือกได้ถูกยกเลิกแล้ว',
  Cargo_SWDE: 'ไม่นับค่าใช้จ่ายส่วนแบ่ง',
  Cargo_Switch: 'การสลับ',
  Cargo_SwitchBasisToAcquireDocument: 'สลับตามการได้รับเอกสาร',
  Cargo_SwitchCurrency: 'สลับสกุลเงิน',
  Cargo_SwitchFile: 'สลับไฟล์',
  Cargo_SwitchInvoice: 'เปลี่ยนใบแจ้งหนี้',
  Cargo_SwitchMethodOfClaim: 'เปลี่ยนโหมดการเรียกร้อง',
  Cargo_SwitchSob: 'เปลี่ยนชุดบัญชี',
  Cargo_Symbol: 'สัญลักษณ์',
  Cargo_SynchronousCodingPartners: 'ซิงค์รหัสลูกค้า',
  Cargo_SystemAlertForPayment: 'ระบบเร่งรัดบัญชี',
  Cargo_SystemBusy: 'ระบบไม่ว่าง',
  Cargo_SystemBusyPRL: 'ระบบไม่ว่าง กรุณาลองใหม่อีกครั้งในภายหลัง',
  Cargo_TableFilter: 'การกรองตาราง',
  Cargo_TakeByCustomsBroker: 'นายหน้าศุลกากรรับเอง',
  Cargo_TAOPLFESAMBETCWOA: 'จำนวนเงิน + กำไรและขาดทุนรวม + ค่าใช้จ่ายทางการเงิน + บัญชีเศษเสี้ยว ต้องเท่ากับจำนวนเงินที่มีการตัดบัญชีนี้',
  Cargo_TAOPLFESAMBETCWOANoFinance: 'จำนวนเงิน + กำไร / ขาดทุนรวม + บัญชีสั้นเศษส่วนต้องเท่ากับจำนวนเงินที่ตัดหักค่าใช้จ่ายนี้',
  Cargo_TAOPLFESAMBETCWOAPC: 'จำนวนเงิน + สรุปกำไรขาดทุน + ค่าใช้จ่ายทางการเงิน + บัญชีเศษเสี้ยว ต้องเท่ากับยอดชำระหนี้ครั้งนี้ โปรดตรวจสอบ',
  Cargo_TAPBACTBLTARAWIETIAP: 'เมื่อรายรับและรายจ่ายเป็นเจ้าหนี้ ยอดรวมของบัญชีเจ้าหนี้ต้องไม่น้อยกว่ายอดรวมของบัญชีลูกหนี้',
  Cargo_Tax: 'ภาษีอากร',
  Cargo_TaxAmount: 'จำนวนภาษี',
  Cargo_TaxAmountP: 'จำนวนภาษี:',
  Cargo_TaxationNbr: 'เลขทะเบียนผู้เสียภาษี',
  Cargo_TaxExcludedPrice: 'ราคายังไม่รวมภาษี',
  Cargo_TaxExcludedPriceP: 'ราคายังไม่รวมภาษี:',
  Cargo_TaxFreeAmount: 'ไม่รวมภาษี',
  Cargo_TaxIncludedPrice: 'ราคารวมภาษี',
  Cargo_TaxIncludedPriceP: 'ราคารวมภาษี:',
  Cargo_TaxpayerAuthorizationCode: 'รหัสประจำตัวผู้เสียภาษี',
  Cargo_TaxRate: 'อัตราภาษี',
  Cargo_TaxRateNotNull: 'กรุณากรอกอัตราภาษี',
  Cargo_TaxRateP: 'อัตราภาษี:',
  Cargo_TaxRatePct: 'อัตราภาษี (%)',
  Cargo_TBTRS: 'โอนกลับมาสร้างความปรองดองสำเร็จ',
  Cargo_TDCBODNBTTCBOTULBC: 'สำนักงานสาขาที่ข้อมูลกำลังดำเนินการอยู่นั้นไม่ได้เป็นของสาขาปัจจุบันหรือสาขาระดับก่อนหน้า คุณแน่ใจนะว่าคุณต้องการดำเนินการต่อ',
  Cargo_TeamLeader: 'หัวหน้าทีม',
  Cargo_TeamLeaderAssignment: 'การกำหนดหัวหน้าทีม',
  Cargo_Tel: 'โทรศัพท์',
  Cargo_TelexReleaseApplicant: 'ผู้สมัครปล่อยไฟฟ้า',
  Cargo_TelexReleaseApplicationDate: 'เวลาในการสมัคร',
  Cargo_TelexReleaseFee: 'ค่าธรรมเนียมการปล่อยไฟฟ้า',
  Cargo_TelexReleaseMaterial: 'ข้อมูลการปล่อยไฟฟ้า',
  Cargo_TelexReleaseNo: 'หมายเลขสถานะ',
  Cargo_ExpenseBoxNo: 'หมายเลขกล่องค่าธรรมเนียม',
  Cargo_TemplateDownload: 'ดาวน์โหลดแม่แบบ',
  Cargo_TemplateDownloadFailed: 'การโหลดโมดูลล้มเหลว',
  Cargo_TenDigitCode: 'รหัสสิบหลัก',
  Cargo_TenThousandYuan: 'Wan หยวน',
  Cargo_TEYAPHBMBSEC: 'ค่าใช้จ่ายที่คุณดำเนินการได้ถูกแก้ไขโดยผู้อื่นแล้ว คุณต้องการที่จะดำเนินการต่อหรือไม่?',
  Cargo_TFCFDTECNIPSDOACS: 'ส่วนที่เหลือของลูกค้าที่ลงนามสำเร็จเนื่องจากการลงนามไม่สำเร็จของลูกค้าที่มีหมายเลขต่อไปนี้อยู่แล้วในพันธมิตร',
  Cargo_TFOTPCTBCWOP: 'กรอบเวลาของช่วงเวลาไม่สามารถข้ามกับช่วงเวลาอื่นได้',
  Cargo_TFSIIUDNA: 'เว็บไซต์ต่อไปนี้ถูกใช้ในเชิงพาณิชย์และไม่อนุญาตให้ลบ',
  Cargo_The1StInvoiceNoCanTBeEmpty: 'หมายเลขใบแจ้งหนี้ใบแรกไม่สามารถเว้นว่างได้',
  Cargo_TheAmountOfWrittenOff: 'จำนวนเงินที่จำหน่าย',
  Cargo_TheExpenseNotBoundToInvoice: 'ค่าธรรมเนียมนี้ไม่ผูกพันกับใบแจ้งหนี้',
  Cargo_TheLast: 'ภาพสุดท้าย',
  Cargo_TheLastPage: 'รูปก่อนหน้า',
  Cargo_TheNextPage: 'แผ่นถัดไป',
  Cargo_TheOppositeSideAccount: 'หมายเลขบัญชีของอีกฝ่าย',
  Cargo_TheOppositeSideBank: 'ธนาคารอื่น',
  Cargo_TheOppositeSideCompany: 'หน่วยฝ่ายตรงข้าม',
  Cargo_TheOppositeSideInvoiceNo: 'หมายเลขใบแจ้งหนี้ของฝ่ายตรงข้าม',
  Cargo_ThisFeeHasBeenInvoiced: 'ค่าธรรมเนียมนี้ไม่สามารถแยกได้!',
  Cargo_ThisFeeHasBeenWrittenOff: 'ค่าธรรมเนียมนี้ได้รับการยกเลิกแล้วและไม่สามารถแยกได้!',
  Cargo_ThisTimeBalance: 'ยอดคงเหลือนี้',
  Cargo_ThisTimeWriteOff: 'การชำระหนี้ครั้งนี้',
  Cargo_ThisTimeWriteOffEq: 'การตัดบัญชีครั้งนี้ = จำนวนเงินที่รับ + กำไรและขาดทุนรวม + ค่าใช้จ่ายทางการเงิน + บัญชีเศษเสี้ยว',
  Cargo_ThisWriteOffNoIs: 'หมายเลขกระแสรายวันของบัญชีขายนี้คือ',
  Cargo_TIBYEIB: 'ยอดคงเหลือเริ่มต้นที่คุณป้อน',
  Cargo_TIBYEIUPDCTBSAIS: 'ยอดเงินคงเหลือเริ่มต้นที่คุณป้อนไม่สมดุลโปรดตรวจสอบ "งบดุล" และ "งบกำไร" อย่างรอบคอบ',
  Cargo_Time: 'เวลา',
  Cargo_TimeFrame: 'ช่วงเวลา',
  Cargo_TimeOfCargoHolding: 'เวลาหักสินค้า',
  Cargo_TimeOfDocHolding: 'เวลาหักครั้งเดียว',
  Cargo_TimeOfPurchase: 'เวลาซื้อ',
  Cargo_TimeOfPurchaseCanTBeEmpty: 'เวลาซื้อไม่สามารถว่างได้',
  Cargo_TimeOfUse: 'เวลาที่ใช้',
  Cargo_TimeOfUseCanTBeEmpty: 'เวลาใช้งานต้องไม่ว่างเว้น',
  Cargo_Tips: 'เคล็ดลับ',
  Cargo_PleaseSelectTheSailingScheduleBelow: 'กรุณาเลือกระยะเวลาเรือดังต่อไปนี้',
  Cargo_ChooseShippingSchedulesTips1: '1. โปรดเลือกข้อมูลตารางเวลาที่สอดคล้องกัน หากไม่ได้เลือกจะมีกรณีที่ไม่สามารถรับเวลาเทียบท่าตามแผนที่กำหนดเวลาไว้ได้เวลาเปิดและจอดเรือเวลาออกจากท่าจริง',
  Cargo_ChooseShippingSchedulesTips2: '2. ในกรณีที่ท่านยังไม่สามารถยืนยันกำหนดการเดินเรือได้ ให้กดปุ่ม [ไม่เลือกชั่วคราว] รอจนกว่าท่านจะยืนยันกำหนดการเดินเรือ ให้กดปุ่ม "เลือกกำหนดการเดินเรือ" เพื่อเลือกกำหนดการเดินเรือ',
  Cargo_MoreShippingSchedulesTips: 'บริเวณท่าเรือกลับไปที่ตารางเวลาของท่าเรือหลายท่าเรือจะมีผลต่อการแสดงข้อมูลตารางเวลาเช่นเดียวกับการผลักดันโปรดเลือกข้อมูลตารางเวลาที่คุณต้องการ',
  Cargo_ChooseShippingSchedules: 'เลือกเวลาเรือ',
  Cargo_NoSelectYet: 'ไม่เลือกชั่วคราว',
  Cargo_ChangePayment: 'แก้ไขคำขอชำระเงิน',
  Cargo_PaymentTimeLimit: 'เงื่อนไขการชำระเงิน',
  Cargo_Title: 'ชื่อเรื่อง',
  Cargo_TitleOfAccount: 'วิชาบัญชี',
  Cargo_TLOOSE: 'หนี้สินและส่วนของเจ้าของหรือส่วนของผู้ถือหุ้นทั้งหมด',
  Cargo_TMAEONRS: 'รูปแบบการค้า มีอยู่แล้วหรือไม่ได้เลือกบันทึก',
  Cargo_To: 'ถึง',
  Cargo_FROM: 'จาก',
  Cargo_ToDetermineIfEditableWhenViewing: 'เพื่อตัดสินว่าสามารถแก้ไขได้หรือไม่เมื่อดู',
  Cargo_TOEIAADFIA: 'ยอดรวมของรายการค่าธรรมเนียมจะไม่เท่ากับยอดในใบแจ้งหนี้',
  Cargo_ChargeAmountCannotExceedInvoiceAmount: 'ยอดรายการค่าใช้จ่ายต้องไม่มากกว่ายอดใบแจ้งหนี้',
  Cargo_ChargeAlreadyAssociatedInvoice: 'ค่าใช้จ่าย {0} เชื่อมโยงกับใบแจ้งหนี้แล้ว',
  Cargo_TORFRS: 'แบบสอบถามทั้งหมดถึง {0} ระเบียน เลือก {1} ระเบียน',
  Cargo_Total0: 'จำนวน: {0}',
  Cargo_TotalAmount: 'ยอดรวม',
  Cargo_TotalAmountNotWrittenOff: 'ยอดคงค้างรวม',
  Cargo_TotalAmountOfCurrentPeriod: 'รวมประเด็นนี้',
  Cargo_TotalAmountPJ: 'ยอดรวม -',
  Cargo_TotalAmountP: 'ยอดรวม:',
  Cargo_TotalAmountToWriteOff: 'จำนวนเงินที่สามารถขายได้ ทั้งหมด',
  Cargo_TotalAPAmount: 'รวมค่าใช้จ่ายที่ต้องชำระ',
  Cargo_TotalARAmount: 'ค่าธรรมเนียมที่เรียกเก็บรวม',
  Cargo_TotalBalance: 'ยอดคงเหลือทั้งหมด',
  Cargo_TotalCommissionAmount: 'ค่าคอมมิชชั่น รวม',
  Cargo_TotalCommissionAmountP: 'จำนวนค่าคอมมิชชั่นรวม:',
  Cargo_TotalCost: 'ค่าใช้จ่ายทั้งหมด',
  Cargo_TotalCurrency: 'สกุลเงินทั้งหมด',
  Cargo_TotalCurrentLiabilities: 'หนี้สินหมุนเวียนรวม',
  Cargo_TotalIncome: 'รายได้รวม',
  Cargo_TotalLiabilities: 'หนี้สินรวม',
  Cargo_TotalNonCurrentAssets: 'สินทรัพย์ไม่หมุนเวียนรวม',
  Cargo_TotalNonCurrentLiabilities: 'หนี้สินไม่หมุนเวียนรวม',
  Cargo_TotalOfVouchersEntered: 'บัตรกำนัลเข้า {0} ใบ',
  Cargo_TotalOutstandingAmountByCurrency: 'ยอดคงเหลือ ทั้งหมด',
  Cargo_TotalPriceWithTaxInWords: 'ราคารวมภาษี (ตัวพิมพ์ใหญ่)',
  Cargo_TotalProfit: 'กำไรรวม',
  Cargo_TotalRevenue: 'รายได้รวม',
  Cargo_TotalWriteOffAmount: 'ยอดชำระหนี้ทั้งหมด',
  Cargo_Choose: 'ตรวจสอบแล้ว',
  Cargo_TotalWriteOffs: 'ยอดคงเหลือ',
  Cargo_TotalWriteOffsP: 'เครดิตรวม:',
  Cargo_TPOPNOINOE: 'กำไรรวม กำไรจากการดำเนินงาน รายได้จากการดำเนินงาน รายได้จากการดำเนินงาน รายได้จากการดำเนินงาน',
  Cargo_TPTODIDDYCTMAGV: 'ประเภทการชำระเงินหรือวิธีการรับชำระเงินแตกต่างกัน คุณต้องการรวมบัตรกำนัลเพื่อสร้างบัตรกำนัลหรือไม่?',
  Cargo_TradeTerm: 'รูปแบบการค้า',
  Cargo_TradeTerms: 'เงื่อนไขการซื้อขาย',
  Cargo_TradeTermsMaintenance: 'การบำรุงรักษาข้อตกลงการค้า',
  Cargo_TradeType: 'ประเภทการค้า',
  Cargo_TradingCompany: 'บริษัท การค้า',
  Cargo_Transfer: 'หมุนรอบ',
  Cargo_TransferAllToReconciliation: 'ทั้งหมดโอนกลับไปสู่การปรองดอง',
  Cargo_TransferBackAmount: 'จำนวนเงินที่โอนคืน',
  Cargo_TransferBackGrandTotal: 'โอนคืนยอดรวม',
  Cargo_TransferBackToReconciliation: 'โอนกลับไปสร้างความปรองดอง',
  Cargo_TransferCash: 'โอนเงินสด',
  Cargo_TransferExpense: 'ค่าธรรมเนียมการโอน',
  Cargo_TransferIntoCollection: 'โอนเข้าเพื่อเรียกเก็บเงิน',
  Cargo_TransferOutToCollection: 'การโอนเงินเพื่อเรียกเก็บเงิน',
  Cargo_TransferPort: 'พอร์ตการขนส่ง',
  Cargo_TransferToCNY: 'ไปยัง CNY',
  Cargo_TransitPortSea: 'ท่าเรือขนส่ง (ท่าเรือ)',
  Cargo_TransitTerm: 'เงื่อนไขการจัดส่ง',
  Cargo_Transportation: 'การขนส่ง',
  Cargo_TRAYEINR: 'จำนวนเงินที่คุณป้อนการปรองดองไม่สมเหตุสมผล!',
  Cargo_TRFRBLFDAF: 'ค่าธรรมเนียมการปลดปล่อย ค่าธรรมเนียมการปลดปล่อยนอกสถานที่ ค่าธรรมเนียมการเปลี่ยนแปลงค่าธรรมเนียมการปลดปล่อย',
  Cargo_TrialBalance: 'สมดุลของการคำนวณการทดลอง',
  Cargo_TrialBalanceCheck: 'การตรวจสอบความสมดุลของการคำนวณการทดลอง',
  Cargo_TRNAPUCWOFISI: 'ไม่สามารถเพิกถอนได้ทั้งหมดโปรดใช้คุณลักษณะการยกเลิกบัญชีในอินเทอร์เฟซแบบสอบถาม',
  Cargo_TruckCompany: 'บริษัท รถบรรทุก',
  Cargo_TSASOBMBTS: 'ตัวแทนการตั้งถิ่นฐานของการเรียกเก็บเงินจะต้องเหมือนกัน!',
  Cargo_TSBADNCTCC: 'หมายเลขบัญชีธนาคารที่เลือกไม่มีสกุลเงินนี้ ดำเนินการต่อ?',
  Cargo_TTAEONRS: 'ข้อตกลงการค้ามีอยู่แล้วหรือไม่ได้เลือกบันทึก',
  Cargo_TTOAFNTCCPM: 'รายวิชาจะถูกนับเฉพาะ: {0} และไม่นับสกุลเงินปัจจุบัน: {1} โปรดแก้ไข',
  Cargo_TUPAOTPALVCBE: 'กำไรและขาดทุนที่ไม่ได้รับการจัดสรรวิชากำไรไม่สามารถเว้นว่างได้',
  Cargo_TWORHBRCC: 'บันทึกการขายบัญชีนี้แดงแล้ว ไม่อนุญาตให้เพิกถอน',
  Cargo_Type: 'ประเภท',
  Cargo_MaximumTakeOffWeight: 'น้ำหนักบินขึ้นสูงสุด',
  Cargo_Charter_Flights_Tips: 'กรณีเที่ยวบินเช่าเหมาลำ / เช่าเหมาลำ "กรณีเที่ยวบินเช่าเหมาลำค่าใช้จ่ายเที่ยวบินสามารถดูแลได้ที่นี่"',
  Cargo_Charter_package_board: 'เช่าเหมาลำ / แพ็กเกจบอร์ด',
  Cargo_Board_Tips: 'ธุรกิจแพคเกจสำหรับการวิเคราะห์กำลังการผลิตและผลกำไรในภายหลัง',
  Cargo_Flight_costs: 'ค่าใช้จ่ายเที่ยวบิน',
  Cargo_NumberOfCartridges: 'จำนวนคอนเทนเนอร์',
  Cargo_Please_Select_The_Model_You_Want_To_Edit: 'โปรดตรวจสอบรุ่นที่ต้องการแก้ไข',
  Cargo_Please_Select_The_Model_To_Be_Deleted: 'กรุณาเลือกรุ่นที่ต้องการลบ',
  Cargo_Please_Select_The_Uld_You_Want_To_Edit: 'โปรดเลือกคอนเทนเนอร์ที่คุณต้องการแก้ไข',
  Cargo_Please_Select_The_Uld_To_Be_Deleted: 'โปรดเลือกคอนเทนเนอร์ที่คุณต้องการลบ',
  Cargo_WeightRestrictions: 'ขีด จำกัด น้ำหนัก',
  Cargo_VolumeLimit: 'จำกัด ปริมาณ',
  Cargo_LoadableCapacity: 'กำลังโหลด',
  Cargo_LoadableWeight: 'โหลดน้ำหนัก',
  Cargo_DeadWeight: 'น้ำหนักตัวเอง',
  Cargo_LSize: 'ขนาด (L)',
  Cargo_WSize: 'ขนาด (W)',
  Cargo_HSize: 'ขนาด (สูง)',
  Cargo_ApplicableModels: 'รุ่นที่เหมาะสม',
  Cargo_ApplicableContainerType: 'ประเภทคอนเทนเนอร์',
  Cargo_ApplicableContainerCode: 'รหัสคอนเทนเนอร์',
  Cargo_ApplicableContainerNumber: 'หมายเลขของคอนเทนเนอร์',
  Cargo_CharterPack: 'เช่าเหมาลำ / แพ็กเกจบอร์ด',
  Cargo_TypeOfBill: 'ประเภทตั๋ว',
  Cargo_TypeOfGoods: 'ประเภทของสินค้า',
  Cargo_TypeOfPort: 'ประเภทพอร์ต',
  Cargo_UBEIRPSMB: 'การเรียกเก็บเงินที่ไม่ได้ทำเครื่องหมายไว้ในบันทึกโปรดเลือกการเรียกเก็บเงินที่ทำเครื่องหมายไว้',
  Cargo_UCOVEIIDPCTD: 'ข้อมูลที่นำเข้ามาในปัจจุบันมีลูกค้าหรือซัพพลายเออร์ที่ไม่ได้ดูแลรักษาในระบบ คลิกดาวน์โหลด',
  Cargo_Unbilled: 'ยังไม่ได้เรียกเก็บเงิน',
  Cargo_Uncommitted: 'ยังไม่ได้ส่ง',
  Cargo_Unconfirmed: 'ยังไม่ได้รับการยืนยัน',
  Cargo_UnderConfirmation: 'ในการยืนยัน',
  Cargo_UnfrozenSuccessfully: 'การละลายน้ำแข็งสำเร็จ',
  Cargo_UnInvoiced: 'ยังไม่ได้ออกใบแจ้งหนี้',
  Cargo_Unissued: 'ยังไม่ได้เผยแพร่',
  Cargo_UnissuedServiceTicket: 'แบบฟอร์มยืนยันไม่ได้เปิด',
  Cargo_Unit: 'หน่วย',
  Cargo_UnitOfMeasurement: 'หน่วยวัด',
  Cargo_UnitOfPaymentPeriod: 'หน่วยงวดบัญชี',
  Cargo_UnitPrice: 'ราคาต่อหน่วย',
  Cargo_UnitPriceP: 'ราคาต่อหน่วย:',
  Cargo_Unknown: 'ไม่ทราบ',
  Cargo_UnKnownStatus: 'ไม่ทราบสถานะ',
  Cargo_Unlimited: 'ไม่จำกัด',
  Cargo_Unpaid: 'ยังไม่ได้ชำระเงิน',
  Cargo_UnpaidClear: 'ยังไม่ได้ชำระ',
  Cargo_UnpaidCNY: 'CNY ค้างชำระ',
  Cargo_UnpaidEUR: 'EUR ค้างชำระ',
  Cargo_UnpaidGBP: 'GBP ค้างชำระ',
  Cargo_UnpaidHKD: 'HKD ค้างชำระ',
  Cargo_UnpaidJPY: 'JPY ค้างชำระ',
  Cargo_UnpaidNGN: 'NGN ค้างชำระ',
  Cargo_UnpaidP: 'ยังไม่ได้ชำระเงิน:',
  Cargo_SimpleUnpaidP: 'ยังไม่ได้ชำระเงิน',
  Cargo_UnpaidUSD: 'USD ค้างชำระ',
  Cargo_ReceivedP: 'ได้รับแล้ว',
  Cargo_PaidP: 'จ่ายแล้ว',
  Cargo_EmptyValue: 'ว่างเปล่า',
  Cargo_UnsavedNewExpenseCanTBeSplit: 'ไม่สามารถแยกค่าธรรมเนียมใหม่ที่ยังไม่ได้บันทึกได้!',
  Cargo_UpdateBar: 'ปรับปรุงแถบ',
  Cargo_UpdateBusinessDate: 'แก้ไขวันประกอบธุรกิจ',
  Cargo_UpdatedSuccessfully: 'อัพเดทสำเร็จ',
  Cargo_UpdateFailed: 'การอัพเดตล้มเหลว',
  Cargo_UpdatePageDisplay: 'แสดงหน้าการปรับปรุง',
  Cargo_UpdatePrintButtonStatus: 'อัปเดตสถานะปุ่มพิมพ์',
  Cargo_Upload: 'อัพโหลด',
  Cargo_UploadAttachment: 'อัปโหลดสิ่งที่แนบมา',
  Cargo_DeleteAttachment: 'ลบไฟล์แนบ',
  Cargo_UploadContract: 'อัปโหลดสัญญา',
  Cargo_UploadContractAttachments: 'อัปโหลดเอกสารแนบของสัญญา',
  Cargo_UploadData: 'การอัพโหลดข้อมูล',
  Cargo_URVUTSWBRIKC: 'บัตรกํานัลที่ยังไม่ได้ตรวจสอบภายใต้บัญชีนี้จะผ่านการตรวจสอบของ JindieCloud แน่ใจหรือไม่ว่าจะดําเนินการต่อ',
  Cargo_USD: 'ดอลลาร์จิน',
  Cargo_USDAmount: 'ดอลลาร์สหรัฐ',
  Cargo_USDExchangeRate: 'อัตราแลกเปลี่ยน USD',
  Cargo_USDInvoiceNo: 'หมายเลขใบแจ้งหนี้ USD',
  Cargo_USDP: 'ดอลลาร์:',
  Cargo_Use: 'การใช้',
  Cargo_Used: 'ใช้แล้ว',
  Cargo_UseGroupExchangeRate: 'ใช้อัตราแลกเปลี่ยนแบบกลุ่ม',
  Cargo_UseOriginalTemporarily: 'ใช้เดิมชั่วคราว',
  Cargo_User: 'ผู้ใช้',
  Cargo_UserCanTBeEmpty: 'การใช้คนไม่สามารถว่างเปล่าได้',
  Cargo_UseShouldBeTemporarily: 'ใช้ที่นี่ชั่วคราวควรจะ',
  Cargo_ValidityOfInvoice: 'ไม่ว่าใบแจ้งหนี้จะถูกต้องหรือไม่',
  Cargo_Value: 'ค่า',
  Cargo_VatGeneralInvoice: 'ใบกำกับภาษีมูลค่าเพิ่ม',
  Cargo_VatInvoice: 'ใบกำกับภาษีมูลค่าเพิ่ม',
  Cargo_VatInvoiceIssuingMachineNo: 'หมายเลขเครื่องใบกำกับภาษีมูลค่าเพิ่ม',
  Cargo_VatSpecialInvoice: 'ใบกำกับภาษีมูลค่าเพิ่มพิเศษ',
  Cargo_Vendor: 'ผู้ให้บริการ',
  Cargo_VendorCantBeEmpty: 'ผู้ให้บริการไม่สามารถว่างได้',
  Cargo_VendorClient: 'ลูกค้าผู้ขาย',
  Cargo_VendorModification: 'การปรับเปลี่ยนผู้ขาย',
  Cargo_VendorP: 'ผู้ให้บริการ:',
  Cargo_VendorSInvoiceNo: 'หมายเลขใบแจ้งหนี้ของผู้ขาย',
  Cargo_VerificationCancelled: 'ยกเลิกการตรวจสอบ',
  Cargo_VerificationPassed: 'ไม่ว่าจะผ่านการตรวจสอบ',
  Cargo_VerificationRejected: 'การปฏิเสธการตรวจสอบ',
  Cargo_VerifiedSuccessfullyClickToSave: 'ยืนยันความสำเร็จคลิกบันทึก',
  Cargo_VerifiedSuccessfullyClickToExport: 'ตรวจสอบความสำเร็จ แตะ ส่งออก',
  Cargo_Verify: 'การตรวจสอบ',
  Cargo_VerifyARAPExpense: 'การตรวจสอบค่าใช้จ่ายของลูกหนี้',
  Cargo_VerifyInvoiceNo: 'ตรวจสอบหมายเลขใบแจ้งหนี้',
  Cargo_VerifyJournalEntry: 'ตรวจสอบรายการ',
  Cargo_VesselAndVoyage: 'ชื่อเรือ / เที่ยวบิน',
  Cargo_VesselVoyageFlight: 'ชื่อเรือ เที่ยวบิน',
  Cargo_VGIVSI: 'ใบกำกับภาษีมูลค่าเพิ่ม ใบกำกับภาษีมูลค่าเพิ่ม',
  Cargo_VHBCFSACCTBC: 'การบัญชีเสริม 【ลูกค้า】 สร้างบัตรกำนัลและไม่สามารถยกเลิกได้',
  Cargo_VHBCFSADCTBC: 'การบัญชีเสริม 【แผนก】 สร้างบัตรกำนัลและไม่สามารถยกเลิกได้',
  Cargo_VHBCFSAICTBC: 'การบัญชีเสริม 【โครงการ】 สร้างบัตรกำนัลและไม่สามารถยกเลิกได้',
  Cargo_VHBCFSASCTBC: 'การบัญชีเสริม 【พนักงาน】 สร้างบัตรกำนัลและไม่สามารถยกเลิกได้',
  Cargo_VHBCFSAVCTBC: 'การบัญชีเสริม 【ผู้ให้บริการ】 สร้างบัตรกำนัลและไม่สามารถยกเลิกได้',
  Cargo_ASCCCTBC: 'ยืนยันจากบริษัทผู้ออกแล้วไม่สามารถยกเลิกได้',
  Cargo_VHBEFCWOWBRWBCITWORSTWB: 'บันทึกการเพิกถอนรายการนี้เคยส่งออกหลักฐานการเงินมาแล้ว,ถ้าเพิกถอนระบบการเพิกถอนรายการจะสร้าง Red Chong Record,ยืนยัน Red Chong ไหม',
  Cargo_View: 'ดู',
  Cargo_ViewAllBusiness: 'ดูธุรกิจทั้งหมด',
  Cargo_ViewAllExpenses: 'ดูค่าธรรมเนียมทั้งหมด',
  Cargo_ViewBill: 'ดูบิล',
  Cargo_ViewBusinessOfSameGroup: 'ดูธุรกิจกลุ่มเดียวกัน',
  Cargo_ViewDetail: 'ดูรายละเอียด',
  Cargo_ViewDetails: 'ดูรายละเอียด',
  Cargo_ViewDetailsOfRemovals: 'ดูรายละเอียดการกำจัด',
  Cargo_ViewedByFee: 'ดูตามค่าธรรมเนียม',
  Cargo_ViewedByJob: 'ดูตามธุรกิจ',
  Cargo_ViewExpensesOfSameGroup: 'ดูค่าใช้จ่ายในกลุ่มเดียวกัน',
  Cargo_ViewFile: 'ดูแฟ้ม',
  Cargo_ViewInvoice: 'ดูใบแจ้งหนี้',
  Cargo_ViewSelfBusiness: 'ดูธุรกิจของคุณเอง',
  Cargo_ViewSoa: 'ดูรายการบัญชี',
  Cargo_ViewUploadedDeclarationDocInfo: 'ดูข้อมูลการอัปโหลดเอกสารประกาศศุลกากร',
  Cargo_ViewVoucher: 'ดูบัตรกำนัล',
  Cargo_ViolationOfUniquenessConstraint: 'การละเมิดความยับยั้งชั่งใจทางเพศเพียงอย่างเดียว',
  Cargo_VOCMEICSR: 'บันทึกที่เลือกในปัจจุบันประกอบด้วยบัตรกำนัลสำหรับเดือนที่ชำระเงิน',
  Cargo_VoidCompleted: 'เสร็จสิ้นการเป็นโมฆะ',
  Cargo_Voided: 'เป็นโมฆะ',
  Cargo_VoidedBy: 'โมฆะ',
  Cargo_VoidedInvoice: 'ใบแจ้งหนี้เป็นโมฆะ',
  Cargo_VoidedInvoiceNo: 'หมายเลขใบแจ้งหนี้เป็นโมฆะ',
  Cargo_VoidedInvoiceNoP: 'หมายเลขใบแจ้งหนี้เป็นโมฆะ:',
  Cargo_VoidedSuccessfully: 'โมฆะสำเร็จ',
  Cargo_VoidStatus: 'สถานะเป็นโมฆะ',
  Cargo_VoidTime: 'เวลาโมฆะ',
  Cargo_AssociatedExpenseID: 'รหัสค่าธรรมเนียมพันธมิตร',
  Cargo_ChargeID: 'ค่าธรรมเนียม ID',
  Cargo_VOPLCOCTBD: 'ไม่สามารถลบบัตรกำนัลกำไรขาดทุนจากการยกยอดได้',
  Cargo_StateDeleteError: 'นำเข้าระบบ Voucher เรียบร้อยแล้ว ไม่สามารถลบได้',
  Cargo_VoucherAbstract: 'สรุปคูปอง',
  Cargo_VoucherCannotBeEmpty: 'บัตรกำนัลไม่ว่างเปล่า!',
  Cargo_VoucherCreatedOrNot: 'มีการสร้างบัตรกำนัลหรือไม่',
  Cargo_VoucherCreatedSuccessfully: 'สร้างบัตรกำนัล {0} เรียบร้อยแล้ว',
  Cargo_VoucherDateCanTBeEmpty: 'วันที่บัตรกำนัลไม่สามารถว่างได้',
  Cargo_VoucherEntryCanTBeEmpty: 'บัตรกำนัลไม่สามารถว่างได้',
  Cargo_VoucherGroupingRule: 'กฎการจัดกลุ่มบัตรกำนัล',
  Cargo_VoucherGroupingType: 'ประเภทของบัตรกำนัล',
  Cargo_VoucherGroupingTypeP: 'ประเภทบัตรกำนัล:',
  Cargo_VoucherLetter: 'คำคูปอง',
  Cargo_VoucherLetterCanTBeEmpty: 'คำรับรองไม่สามารถเว้นว่างได้',
  Cargo_VoucherLetterNo: 'หมายเลขบัตรกำนัล',
  Cargo_VoucherLetterP: 'คำรับรอง:',
  Cargo_VoucherList: 'รายการคูปอง',
  Cargo_VoucherMonth: 'เดือนคูปอง',
  Cargo_VoucherNo: 'หมายเลขคูปอง',
  Cargo_VoucherNoCanTBeEmpty: 'หมายเลขบัตรกำนัลไม่สามารถว่างได้',
  Cargo_VoucherNoP: 'หมายเลขคูปอง:',
  Cargo_VoucherNotCreatedCreateItNow: 'ไม่มีการสร้างบัตรกำนัล จะมีการสร้างบัตรกำนัลหรือไม่?',
  Cargo_VoucherOfAdvance: 'บัตรกำนัลรับเงินล่วงหน้า',
  Cargo_VoucherPeriod: 'ระยะเวลาของบัตรกำนัล',
  Cargo_VoucherPeriodCanTBeEmpty: 'ไม่สามารถว่างระหว่างบัตรกำนัล',
  Cargo_VoucherRule: 'กฎบัตรกำนัล',
  Cargo_VoucherSearch: 'สอบถามคูปอง',
  Cargo_VoucherStatus: 'สถานะบัตรกำนัล',
  Cargo_VoucherType: 'ประเภทของคูปอง',
  Cargo_VoyageFlight: 'เที่ยวบิน / เที่ยวบิน',
  Cargo_VoyageNo: 'เที่ยวบิน',
  Cargo_VRDBR: 'ดูรายละเอียดการถอดถอนการปรองดอง',
  Cargo_VSRAOGTEPAEIADPERAPIT: 'ภาษีทองคำส่งออกใบกำกับสินค้ากระดาษใบแจ้งหนี้อิเล็กทรอนิกส์การตรวจสอบที่อยู่คำขอบริการแตกต่างกันโปรดส่งออกแยกตามประเภทของใบแจ้งหนี้',
  Cargo_Warehouse: 'คลังสินค้า',
  Cargo_WarehouseDoor: 'คลังสินค้า / Door Point',
  Cargo_WarehouseLoading: 'โหลดภายในคลังสินค้า',
  Cargo_WarehouseLoadingStorage: 'กล่องภายใน / คลังสินค้า',
  Cargo_WarehouseNo: 'หมายเลขขาเข้า',
  Cargo_WBOWBVCTBD: 'บัตรกำนัล Hongchong หรือโดนบัตรกำนัล Hongchong ไม่สามารถลบออกได้',
  Cargo_WBOWBVCTBWB: 'บัตรกำนัลแดงชง หรือโดนใบแดงชงไม่ได้',
  Cargo_REVERSE: 'บัตรกำนัลหงษ์ชงสำเร็จ',
  Cargo_WCDCOVCWBDBOSRCCWBIDDRWNOPC: 'หลังจากติ๊กแบบสอบถามนี้จะแสดงคอลัมน์รายละเอียดของสกุลเงินที่แตกต่างกันตามผลการตรวจสอบโดยไม่สนใจการตั้งค่าที่กำหนดเอง ผลลัพธ์ของการแสดงผลแบบไดนามิกจะไม่เขียนทับการกำหนดค่าเดิม',
  Cargo_WDPCCS: 'ข้อมูลผิดพลาดโปรดติดต่อฝ่ายบริการลูกค้า',
  Cargo_Wechat: 'วีแชท',
  Cargo_Week: 'สัปดาห์',
  Cargo_Weight: 'น้ำหนัก',
  Cargo_WHCode: 'หมายเลขห้องโดยสารขาเข้า',
  Cargo_WhetherOrNotBroken: 'ไม่ว่าจะเป็นการแตกหัก',
  Cargo_WipeOut: 'ไม่สนใจเศษส่วน',
  Cargo_WithdrawalAddress: 'ที่อยู่การคืนเงิน',
  Cargo_WithdrawalListOfLinkedConsignors: 'รายการคืนหน่วยลงทุนที่เกี่ยวข้อง',
  Cargo_WithdrawExpense: 'ค่าธรรมเนียมการสกัด',
  Cargo_WONCPPC: 'เลขที่บัญชี ยืนยันการชำระเงิน',
  Cargo_WORIPCPARO: 'บันทึกการขายบัญชีไม่ถูกต้องปิดหน้าเพื่อเปิดใหม่',
  Cargo_WorkSetAfterSearch: 'ชุดทำงานหลังการสอบถาม',
  Cargo_WriteBack: 'ช่องแดง',
  Cargo_WriteBackVoucher: 'บัตรกำนัล Hongchong',
  Cargo_WriteOff: 'ตัดบัญชี',
  Cargo_WriteOffAll: 'ชำระหนี้ทั้งหมด',
  Cargo_WriteOffAllP: 'ไม่ว่าจะเป็นการเบิกจ่ายทั้งหมด',
  Cargo_WriteOffAmount: 'ยอดเงินที่ตัดบัญชี',
  Cargo_WriteOffAmountCNY: 'CNY ยอดตัดบัญชี',
  Cargo_WriteOffAmountIs: 'ยอดตัดบัญชีคือ',
  Cargo_WriteOffAmountUSD: 'USD จำนวนการขายบัญชี',
  Cargo_WriteOffAR: 'บัญชีลูกหนี้',
  Cargo_WriteOffBalance: 'ยอดคงเหลือในบัญชี',
  Cargo_WriteOffBalanceIs: 'ยอดคงเหลือของการตัดบัญชีคือ:',
  Cargo_WriteOffCurrency: 'สกุลเงิน Nuclear Outlet',
  Cargo_WriteOffDate: 'วันที่ตัดบัญชี',
  Cargo_WriteOffDetails: 'รายละเอียดบัญชีการขาย',
  Cargo_WriteOffEntry: 'รายการตัดบัญชี',
  Cargo_WriteOffFailed: 'ตัดบัญชีล้มเหลว',
  Cargo_WriteOffInputError: 'ค่าธรรมเนียมที่ค้างชำระจะรวมอยู่ในค่าธรรมเนียมใบคำขอเข้าร่วมชำระเงิน โปรดตรวจสอบหลังจากขั้นตอนการตรวจสอบใบคำขอชำระเงินเสร็จสิ้น',
  Cargo_WriteOffList: 'รายละเอียดบัญชีการขาย',
  Cargo_WriteOffListPDF: 'รายละเอียดบัญชีการขาย. pdf',
  Cargo_WriteOffListXLS: 'รายละเอียดบัญชีการขาย .xls',
  Cargo_WriteOffNo: 'หมายเลขบัญชี',
  Cargo_WriteOffOfAdvance: 'การชำระเงินล่วงหน้า',
  Cargo_WriteOffOrNot: 'ไม่ว่าจะเป็นการตัดบัญชี',
  Cargo_WriteOffP: 'ตัดบัญชี -',
  Cargo_WriteOffPerson: 'พนักงานขายบัญชี',
  Cargo_WriteOffRate: 'อัตราการชำระหนี้',
  Cargo_WriteOffRecordsNotSelected: 'ไม่มีการเลือกบันทึกการตัดบัญชี',
  Cargo_WriteOffRemarks: 'หมายเหตุการตัดบัญชี',
  Cargo_WriteOffReverseWriteOff: 'หมุดนิวเคลียร์ / Counter-Counter Pin',
  Cargo_WriteOffRevokedSuccessfully: 'ยกเลิกบัญชีสำเร็จ',
  Cargo_WriteOffSerialNumber: 'หมายเลขบัญชีกระแสรายวัน',
  Cargo_WriteOffStartingPeriod: 'จุดเริ่มต้นของระยะเวลาการจำหน่ายนิวเคลียร์',
  Cargo_WriteOffStartingPeriodP: 'จุดเริ่มต้นของระยะเวลาการขาย:',
  Cargo_WriteOffStatus: 'สถานะการตัดบัญชี',
  Cargo_WriteOffType: 'พิน',
  Cargo_WriteOffTypeP: 'ประเภทการขายบัญชี:',
  Cargo_WrittenOff: 'บัญชีหักบัญชี',
  Cargo_WrittenOff2: 'ยอดคงเหลือ RMB',
  Cargo_WrittenOffItemsCanTBeModified: 'มีการเพิกถอนแล้วไม่สามารถแก้ไขได้',
  Cargo_WrittenOffItemsExist: 'มีบัญชีที่ยกเลิกแล้ว',
  Cargo_WrittenOffNotWrittenOff: 'ยอดคงเหลือ ยอดคงเหลือ',
  Cargo_WrittenOffSuccessfully: 'ประสบความสำเร็จในการขายบัญชี',
  Cargo_WrongInvoicingMachineNoEntered: 'มีการใส่หมายเลขตั๋วผิดพลาด',
  Cargo_WroteOff: 'ไม่ว่าจะเป็นการชำระหนี้',
  Cargo_WroteOffOrNot: 'ไม่ว่าจะเป็นการเพิกถอน',
  Cargo_X10: 'สิบคน',
  Cargo_X100: 'หนึ่งร้อย',
  Cargo_X1000: 'พันคน',
  Cargo_X10000: 'วัน',
  Cargo_YadongKingdee: 'Yadong จินผีเสื้อ',
  Cargo_Year: 'ปี',
  Cargo_Years: 'วินเทจ',
  Cargo_Yes: 'ใช่',
  Cargo_YesControlled: 'การควบคุม',
  Cargo_NotControlled: 'ไม่มีการควบคุม',
  Cargo_YesLink: 'เป็นฉันที่จะเกี่ยวข้อง',
  Cargo_YesNo: 'ใช่ ไม่',
  Cargo_Yuan: 'หยวน',
  Cargo_ContentIsEmpty: 'เนื้อหาว่างเปล่า',
  Cargo_PleaseSelectExpenseToProcess: 'โปรดเลือกค่าใช้จ่ายที่จะดำเนินการ',
  Cargo_EditSoa: 'แก้ไขใบแจ้งยอด',
  Cargo_InvalidParameterCFR: 'พารามิเตอร์ที่ไม่ถูกต้อง, ไม่พบกฎของรายวิชา',
  Cargo_SuccessItemsFailedItems: 'สำเร็จ {0} บทความ {1} ล้มเหลว',
  Cargo_BADNMOPRTB: 'ตัวแทนการตั้งถิ่นฐานของใบเรียกเก็บเงิน {0} ไม่สอดคล้องกับวัตถุของการตั้งถิ่นฐานของใบแจ้งยอด โปรดลบใบแจ้งหนี้ออกและบันทึกอีกครั้ง',
  Cargo_IVCNBVPDTORTI: 'มีใบแจ้งหนี้ {0} ที่สร้างบัตรกำนัลไม่เป็นโมฆะโปรดลบบัตรกำนัลหรือ Hongchong',
  Cargo_Temp: '- ว่างเปล่า -',
  Cargo_OperationCommission: 'ค่าคอมมิชชั่นในการดำเนินงาน',
  Cargo_CSCommission: 'ค่าคอมมิชชั่นฝ่ายบริการลูกค้า',
  Cargo_ViewPaymentRequest: 'ดูใบสมัครชำระเงิน',
  Cargo_WantToAddThemToTheBill: 'ค่าธรรมเนียมที่เลือกจะรวมค่าธรรมเนียมที่ได้รับการยกเลิกแล้ว คุณต้องการเข้าร่วมบิลต่อไปหรือไม่?',
  Cargo_AddAllToTheBill: 'เข้าร่วมบิลทั้งหมด',
  Cargo_OnlyTheUnwrittenOffExpenses: 'เข้าร่วมเฉพาะค่าธรรมเนียมที่ยังไม่ได้รับการอนุมัติ',
  Cargo_ImportAndQueryOfBillNumber: 'หมายเลขบิลนำเข้าสอบถาม',
  Cargo_DebitAmountCN: 'ยอดเดบิต',
  Cargo_CreditAmountCN: 'จำนวนเงินกู้',
  Cargo_PushMiddleTable: 'ผลักดันตารางกลาง',
  Cargo_IfError: 'ไม่ว่าจะเป็นการแจ้งความผิด',
  Cargo_ErrorInfo: 'แจ้งข้อมูลผิดพลาด',

  Cargo_AIOCER: 'อัตราแลกเปลี่ยน สกุลเงินเดิม จำนวน',
  Cargo_BalanceInRmb: 'ยอดคงเหลือ CNY',
  Cargo_BalanceInUsd: 'ยอดคงเหลือ USD',
  Cargo_CanTDeleteInvoicedItems: 'ไม่สามารถลบใบแจ้งหนี้ได้แล้ว',
  Cargo_CanTDeleteIssuedInvoice: 'ใบแจ้งหนี้ที่ออกแล้วไม่สามารถลบได้!',
  Cargo_CardAccessControl: 'การควบคุมสิทธิ์บัตร',
  Cargo_CCTBEVCTBE: 'ลูกค้าไม่สามารถว่างเปล่าซัพพลายเออร์ไม่สามารถว่างเปล่า',
  Cargo_ConfirmAPP: 'ไม่ว่าจะเป็นการยืนยันค่าใช้จ่ายที่ต้องชำระ',
  Cargo_ConfirmBill: 'ยืนยันการเรียกเก็บเงิน',
  Cargo_CreditSideRmb: 'เครดิต (CNY)',
  Cargo_CreditSideUsd: 'เครดิต (USD)',
  Cargo_CurrencyIncompatible: 'สกุลเงินไม่สม่ำเสมอ',
  Cargo_CustomizedField: 'ฟิลด์ที่กำหนดเอง',
  Cargo_IssuedUnissued: 'โพสต์แล้ว ยังไม่ได้โพสต์',
  Cargo_NoExpensesToBeInvoiced: 'ไม่สามารถออกบัตรโดยสารได้ ไม่มีค่าธรรมเนียมการออกบัตรโดยสาร',
  Cargo_OVICBETGTEI_2: 'ใบกำกับภาษีมูลค่าเพิ่มเพื่อยกเลิกภาษีทองคำใบแจ้งหนี้อิเล็กทรอนิกส์',
  Cargo_OWCICGTSEEI_2: 'สกุลเงินใบเรียกเก็บเงินคือ RMB เพื่อให้ภาษีทองเป็นโมฆะใบแจ้งหนี้อิเล็กทรอนิกส์',
  Cargo_PleaseSelectAnBillPayment: 'กรุณาเลือกรายการชำระเงิน ใบสมัคร',
  Cargo_PleaseSelectPurchaser: 'โปรดเลือกผู้ซื้อ',
  Cargo_SelectAddPlatformBLMethod: 'แพลตฟอร์ม B / L วิธีการเลือกเพิ่ม',
  Cargo_SettlingPartyMustBeIdentical: 'วัตถุของการตั้งถิ่นฐานจะต้องเหมือนกัน',
  Cargo_Space5: 'ปมพระจันทร์ครึ่งเสี้ยว',
  Cargo_TARBACTBLTAPAWIETIAR: 'ประเภทรายรับและรายจ่าย ณ เวลาที่ลูกหนี้ ยอดรวมของบัญชีลูกหนี้ต้องไม่น้อยกว่ายอดรวมของบัญชีเจ้าหนี้',
  Cargo_CanNotRemovedAllCharge: 'ค่าธรรมเนียมทั้งหมดไม่สามารถลบออกได้!',
  Cargo_BillNotAllowEditEtowerOne: 'การเรียกเก็บเงินจาก EtowerOne มาไม่ได้รับอนุญาตให้ดำเนินการ!',
  Cargo_NoSubmit_SR: 'ยังไม่ได้ส่ง',
  Cargo_AwaitApproval_SR: 'อยู่ระหว่างการอนุมัติ',
  Cargo_Approved_SR: 'การอนุมัติเสร็จสิ้น',
  Cargo_ModifyFilter: 'เงื่อนไขการเพิ่มหรือลบ',
  Cargo_SaveChanges: 'บันทึกการแก้ไข',
  Cargo_SaveAsScheme: 'บันทึกเป็นแผน',
  Cargo_QueryScheme: 'แผนการสอบถาม',
  Cargo_QuerySchemeManagement: 'การจัดการแบบสอบถาม',
  Cargo_SelectQueryCriteria: 'เลือกเงื่อนไขการสอบถาม',
  Cargo_ApplicationForm: 'แบบฟอร์มการสมัคร',
  Cargo_ApprovalHistory: 'ประวัติการอนุมัติ',
  Cargo_AllQueryCriteria: 'เงื่อนไขการสอบถามทั้งหมด',
  Cargo_MyQueryCriteria: 'เงื่อนไขการสอบถามของฉัน',
  Cargo_DisplayName: 'แสดงชื่อ',
  Cargo_ConditionalExpression: 'การแสดงออกเงื่อนไข',
  Cargo_ProcessingDifference: 'การจัดการกับความแตกต่าง',
  Cargo_NotFoundTemplate: 'ไม่พบแม่แบบการพิมพ์ที่ตรงกัน!',
  Cargo_NoPaymentMethodPermissionOfReconciliation: 'สิทธิ์ไม่เพียงพอโปรดติดต่อผู้ดูแลระบบเพื่อกำหนดค่าหน้าสร้างความปรองดองเซ็นรับสิทธิ์วิธีการชำระเงิน!',
  Cargo_NoFeeTypePermissionOfReconciliation: 'สิทธิ์ไม่เพียงพอโปรดติดต่อผู้ดูแลระบบเพื่อกำหนดค่าการอนุญาตประเภทค่าธรรมเนียมการลงนามในหน้าการปรองดอง!',
  Cargo_SearchDataForReconciliation: 'กรุณาตรวจสอบข้อมูลก่อนแล้วจึงเริ่มการปรองดอง!',
  Cargo_ChargeUpdateFailed: 'มี {0} ค่าธรรมเนียมที่ถูกแก้ไขโดยผู้อื่นและไม่มีการอัปเดตสำเร็จ!',
  Cargo_SaveReconciliationSuccess: 'บันทึกความสำเร็จของการปรองดอง!',
  Cargo_RemoveAll: 'ลบทั้งหมด',
  Cargo_ViewDeleteChargeDetail: 'ดู/ลบรายละเอียด',
  Cargo_DeleteAdjustment: 'ลบการปรับแต่ง',
  Cargo_PleaseSelectedCancelConfirmCharge: 'โปรดเลือกค่าธรรมเนียมในการยกเลิก',
  Cargo_PleaseSelectedConfirmCharge: 'โปรดเลือกค่าธรรมเนียมที่ต้องการการยืนยัน',
  Cargo_PleaseSelectedBillingDate: 'กรุณาเลือกวันที่เรียกเก็บเงิน!',
  PleaseSelectSplitCharge: 'โปรดเลือกค่าธรรมเนียมที่คุณต้องการแยก!',
  OnlySelectOneChargeToSplit: 'สามารถเลือกค่าธรรมเนียมได้เพียงรายการเดียวเพื่อแยก!',
  ChargeHasInvoicedOrWriteOff: 'ค่าธรรมเนียมนี้ถูกออกใบแจ้งหนี้หรือถูกยกเลิกโปรดเลือกใหม่!',
  NoChargeForSplit: 'ไม่มีค่าธรรมเนียมที่สามารถแยกได้จริงโปรดเลือกใหม่!',
  Cargo_exportExcelAll: 'ส่งออกทั้งหมด',
  Cargo_PleaseInputKeyWordsForQuery: 'กรุณากรอกคำค้นหา',
  Cargo_AccountNumber: 'หมายเลขบัญชี',
  Cargo_OwnerBankOfDeposit: 'ธนาคารของเรา',
  Cargo_JoinBill: 'เข้าร่วมบิล',
  Cargo_SelectedUnConfirmedCharge: 'โปรดเลือกค่าธรรมเนียมในการยกเลิกการยืนยัน!',
  Cargo_NoChargeForSplit: 'ไม่มีค่าธรรมเนียมแยกตัวจริง โปรดเลือกใหม่!',
  Cargo_InputTaxAmount: 'กรุณากรอกราคารวมภาษี!',
  Cargo_ReconciliationTypeP: 'ประเภทการปรองดอง:',
  Cargo_ByFee: 'โดยค่าธรรมเนียม',
  Cargo_SelectBill: 'เลือกบิล',
  Cargo_BillOfType: 'ประเภทการเรียกเก็บเงิน:',
  Cargo_BillDateP: 'วันที่เรียกเก็บเงิน:',
  Cargo_StatementDateP: 'วันที่เรียกเก็บเงิน:',
  Cargo_RegistrationAddress: 'ที่อยู่ผู้เสียภาษี',
  Cargo_OriginalCurrency2: 'สกุลเงินเดิม',
  Cargo_ExchangeRate2: 'อัตราแลกเปลี่ยน',
  Cargo_BillRateEmpty: 'อัตราแลกเปลี่ยนสกุลเงินต้นฉบับของบิลไม่สามารถว่างเปล่า!',
  Cargo_BillCurrencyMore: 'ค่าธรรมเนียมการเรียกเก็บเงินไม่เกินสามสกุลเงิน!',
  Cargo_BillCurrencyEmpty: 'สกุลเงินเรียกเก็บเงินไม่สามารถว่างเปล่า!',
  Cargo_SettlementAgentEmpty: 'ตัวแทนการตั้งถิ่นฐานไม่สามารถว่าง!',
  Cargo_IncludingTaxAmountZero: 'ราคารวมภาษีไม่สามารถเป็นศูนย์!',
  RequiredAccrueDate: 'โปรดป้อนวันที่นับ',
  RequiredCancelDate: 'กรุณาระบุวันที่ยกเลิก',
  Cargo_NoChargeForBillPayment: 'ไม่มีค่าธรรมเนียมสำหรับการสร้างใบสมัครการชำระเงิน!',
  Cargo_CancelSpecialApproval: 'ยกเลิกชุดพิเศษ',
  Cargo_LockTheBillTime: 'ล็อคเวลาเดียว',
  Cargo_CreditControlObject: 'วัตถุควบคุม',
  Cargo_SpecialApprovalTime: 'เวลาล็อตพิเศษ',
  Cargo_SpecialApprovalUser: 'บุคคลพิเศษ',
  Cargo_AmountExceeded: 'ส่วนเกิน',
  Cargo_DateExceeded: 'เกินกำหนด',
  Cargo_CreditControlInfo: 'สถานการณ์ Credit',
  Cargo_OperateTime: 'เวลาทำงาน',
  Cargo_DownloadLog: 'ดาวน์โหลดบันทึก',
  Cargo_Times: 'เวลา',
  Cargo_LockTheBillDate: 'วันที่ล็อคแผ่น',
  Cargo_SpecialApprovalDate: 'วันที่ล็อตพิเศษ',
  Cargo_OperateDate: 'วันที่ดำเนินการ',
  Cargo_LockTheBillUser: 'ล็อคเดี่ยว',
  Cargo_sono: 'SoNo',
  Cargo_pono: 'PO.No.',
  Cargo_PolAir: 'ท่าเรือขนส่งสินค้า (ว่างเปล่า)',
  Cargo_keyWordsTip: 'กรุณาใส่คำหลัก',
  Cargo_sopDoubleClickTip: 'คลิกสองครั้งที่กล่องข้อความเพื่อเลือกแบบสอบถามสถานะโหนด',
  Cargo_SchemeName: 'ชื่อโครงการ',
  Cargo_NewQueryScheme: 'เพิ่มรูปแบบการสอบถาม',
  Cargo_TheQueryItemSelected: 'แบบสอบถามนี้ 【{0}】 ถูกเลือกแล้ว',
  Cargo_SchemeSaveSuccess: 'ความสำเร็จในการบันทึกโปรแกรม',
  Cargo_BillLogManagement: 'การจัดการบันทึก B / L',
  Cargo_ModifyContent: 'แก้ไขเนื้อหา',
  Cargo_CheckPermission: 'คุณไม่มีสิทธิ์ตรวจสอบธุรกิจ!',
  Cargo_CheckBusinessType: 'กรุณาเลือกประเภทธุรกิจเดียวกัน!',
  Cargo_MasterChargeWhetherShareOrNot: 'ไม่ว่าจะเป็นการแบ่งค่าตั๋วหลัก',
  Cargo_DepartmentPrefixNotSelected: 'ไม่มีการเลือก Settlement Department',
  Cargo_SalesIsEmpty: 'ปัจจุบันลูกค้ามียอดขายว่างเปล่าและไม่สามารถลงนามได้!',
  Cargo_Distribution: 'การจัดสรร',
  Cargo_SalesNotSelected: 'ไม่มีการเลือกขาย!',
  Cargo_ReviewedByLeader: 'ได้รับมอบหมายลูกค้ารายนี้ได้รับการตรวจสอบโดยหัวหน้าทีมเดิม:',
  Cargo_AllocationSucceeded: 'จัดสรรสำเร็จ!',
  Cargo_FormerGroupLeader: 'หัวหน้ากลุ่มเดิม',
  Cargo_ChineseNameIsEmpty: 'ชื่อภาษาจีนของลูกค้าว่างเปล่า!',
  Cargo_OriginalTeamLeaderIsEmpty: 'ชื่อหัวหน้ากลุ่มเดิมว่างเปล่า!',
  Cargo_DoNotOperate: 'ห้ามดำเนินการกับลูกค้าปัจจุบันโปรดติดต่อผู้จัดการฝ่ายขายเพื่อแก้ไข!',
  Cargo_RestoreCurrentCustomer: 'ยืนยันต้องการคืนลูกค้าปัจจุบันหรือไม่',
  Cargo_CustomerInformationIsEmpty: 'ข้อมูลลูกค้าว่างเปล่า!',
  Cargo_CannotBeDeleted: 'ลูกค้ารายนี้ถูกใช้ในธุรกิจและไม่สามารถลบได้!',
  Cargo_DeleteSuccessfully: 'การลบสำเร็จลูกค้ารายนี้ถูกย้ายไปยังถังรีไซเคิลของลูกค้า!',
  Cargo_AreYouSureDelete: 'คุณแน่ใจนะว่าต้องการลบ?',
  Cargo_PleaseSelectForDelete: 'โปรดเลือกลูกค้าที่คุณต้องการลบ!',
  Cargo_ChineseNameAlreadyExists: 'มีชื่อภาษาจีนอยู่แล้ว',
  Cargo_EnglishNameAlreadyExists: 'มีชื่อภาษาอังกฤษอยู่แล้ว',
  Cargo_ChineseOrEnglishAlreadyExists: 'มีชื่อภาษาจีนหรือชื่อภาษาอังกฤษอยู่แล้ว',
  Cargo_ContactPersonToFillInA: 'ผู้ติดต่อของลูกค้ากรอกอย่างน้อยหนึ่ง!',
  Cargo_PleaseInvoicingRequirementsTab: 'กรุณากรอกข้อมูลความต้องการสกุลเงินที่ลงนามในหน้าข้อกำหนดการออกใบแจ้งหนี้!',
  Cargo_SignOrNot: 'ไม่ว่าจะเป็นการลงลายมือชื่อ',
  Cargo_DangerousChemicals: 'ไม่ว่าจะเป็นสารเคมีอันตราย',
  Cargo_DaysNotFollowedUp: 'จำนวนวันที่ไม่ได้ติดตาม',
  Cargo_CustomerNotSelected: 'ลูกค้าไม่ได้เลือก!',
  Cargo_AssignedClientsSuccessfully2: 'กำหนดลูกค้า {0} ราย',
  Cargo_examine: 'ลูกค้าแต่ละรายจะได้รับการตรวจสอบโดยหัวหน้าทีมเดิม',
  Cargo_DistributionSales: 'ลูกค้าแต่ละรายประสบความสำเร็จในการกระจายการขาย',
  Cargo_MoreThan1Year: 'มากกว่า 1 ปี',
  Cargo_list: 'รายการ',
  Cargo_MyClients: 'ลูกค้าของฉัน',
  Cargo_CustomersInThisGroup: 'ลูกค้ากลุ่มนี้',
  Cargo_CustomerRecycleBin: 'ถังรีไซเคิลของลูกค้า',
  Cargo_PleaseSelectTheCustomerToExport: 'โปรดเลือกลูกค้าที่ต้องการส่งออก!',
  Cargo_city: 'เมือง',
  Cargo_email: 'กล่องจดหมาย',
  Cargo_add: 'เพิ่ม',
  Cargo_Append: 'เพิ่มเติม',
  Cargo_PSCF: 'โปรดเลือกผู้ติดต่อก่อน!',
  Cargo_NCS: 'ยังไม่มีการเลือกผู้ติดต่อ!',
  Cargo_CNATCBE: 'ชื่อผู้ติดต่อและโทรศัพท์ไม่สามารถว่าง!',
  Cargo_ERF: 'เกิดข้อผิดพลาดในการลบไฟล์!',
  Cargo_FDS: 'การลบไฟล์สำเร็จ!',
  Cargo_AYSDF: 'แน่ใจนะว่าคุณต้องการลบไฟล์?',
  Cargo_PSAEF: 'โปรดเลือกกิจกรรมก่อน',
  Cargo_theme: 'หัวข้อ',
  Cargo_FTMFT: 'การแก้ไขประเภทแฟ้มล้มเหลว',
  Cargo_EventStatus: 'สถานะเหตุการณ์',
  Cargo_TaskTime: 'เวลาภารกิจ',
  Cargo_CustomerChineseName: 'ชื่อภาษาจีนของลูกค้า',
  Cargo_CustomerEnglishName: 'ชื่อภาษาอังกฤษของลูกค้า',
  Cargo_NextTask: 'ภารกิจถัดไป',
  Cargo_RWSR: 'ปฏิเสธระเบียน {0} สำเร็จ',
  Cargo_isActive: 'ใช้ได้หรือไม่',
  Cargo_OverdueLimit: 'วงเงินเกินกำหนด',
  Cargo_OverdueDays: 'วันที่หมดอายุ',
  Cargo_Enable: 'เปิดใช้',
  Cargo_Disable: 'ปิดการใช้งาน',
  Cargo_EnableStatus: 'เปิดใช้งานสถานะ',
  Cargo_Enabled: 'เปิดใช้งานแล้ว',
  Cargo_Disabled: 'ปิดการใช้งาน',
  Cargo_amount: 'จำนวนบาร์',
  Cargo_HasChosen: 'เลือกแล้ว',
  Cargo_RemoveToBlackList: 'ย้ายออกจากบัญชีดำ',
  Cargo_SureToRemoveToBlackList: 'มั่นใจจะย้ายออกจากแบล็กลิสต์หรือไม่',
  Cargo_Flight: 'เที่ยวบิน',
  Cargo_OutstandingAmount: 'ยอดคงค้าง (ค่าธรรมเนียม)',
  Cargo_WriteOffAmountCharge: 'จำนวนเงินชำระหนี้ (ค่าธรรมเนียม)',
  Cargo_ReceivableExcludingTax: 'ลูกหนี้ไม่รวมภาษี (ใบแจ้งหนี้)',
  Cargo_TaxIncludedReceivable: 'รวมภาษีมูลค่าเพิ่ม (ใบแจ้งหนี้)',
  Cargo_PayableExcludingTax: 'ไม่ต้องเสียภาษี (ใบแจ้งหนี้)',
  Cargo_TaxPayable: 'รวมภาษีที่ต้องชำระ (ใบแจ้งหนี้)',
  Cargo_TotalExcludingTax: 'รวมภาษี (ใบแจ้งหนี้)',
  Cargo_TotalTaxIncluded: 'รวมภาษี (ใบแจ้งหนี้)',
  Cargo_PleaseEnterBoxTypeOrBoxType: 'กรุณาใส่ประเภทกล่องหรือชนิดกล่อง!',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate: 'วันที่มีผลบังคับใช้ต้องน้อยกว่าวันที่หมดอายุ',
  Cargo_MaintenanceOfExpenseDetails: 'การบำรุงรักษารายละเอียดค่าใช้จ่าย',
  Cargo_CustomerQuickSearch: 'ดึงข้อมูลด่วน: ชื่อภาษาจีน / ชื่อภาษาอังกฤษของลูกค้า',
  Cargo_WechatAccount: 'ไมโครโฟน',
  Cargo_Download: 'ดาวน์โหลด',
  Cargo_ChineseNamed: 'ชื่อภาษาจีน',
  Cargo_EnglishNamed: 'ชื่อภาษาอังกฤษ',
  Cargo_SignContractTip: 'Partner Module มีธุรกิจที่มีชื่อคล้ายกันอยู่แล้ว จำเป็นต้องเกี่ยวข้องหรือไม่',
  Cargo_SignContractTipYes: 'ใช่ ฉันต้องการความสัมพันธ์',
  Cargo_SignContractTipNo: 'ไม่ ฉันไม่ยุ่งเกี่ยว',
  Cargo_CooperationStage: 'เวทีความร่วมมือ',
  Cargo_Financial_Year: 'ปีการเงิน',
  Cargo_ConfirmCloseWindow: 'ยืนยันการปิดหน้าต่าง?',
  Cargo_NoteUpdatedSuccessfully: 'หมายเหตุ อัพเดทสำเร็จ',
  Cargo_PleaseSelectAPieceOfData: 'โปรดตรวจสอบข้อมูล',
  Cargo_SelectDataIsNotAuditState: 'รองรับเฉพาะธุรกิจที่มีสถานะก่อนการพิจารณาคดีที่อยู่ระหว่างการตรวจสอบชั่วคราวเท่านั้น กรุณาทำเครื่องหมายอีกครั้ง',
  Cargo_SelectDataIsNotSubmittedTemporarilyOrRejectState: 'รองรับเฉพาะธุรกิจที่มีสถานะการยื่นคำร้องขอกลับไม่ส่งชั่วคราวหรือถูกปฏิเสธ กรุณาทำเครื่องหมายอีกครั้ง',
  Cargo_SelectAtLeastOneRecord: 'โปรดเลือกอย่างน้อยหนึ่งระเบียน',
  Cargo_FieldDisplay: 'แสดงฟิลด์',
  Cargo_ControlSelection: 'เลือกตัวควบคุม',
  Cargo_EnumValue: 'ค่าของเอนัม',
  Cargo_StatusIsNotPending: 'สถานะไม่ใช่รอการตรวจสอบ',
  Cargo_NotSubmittedAndRejectedStatusTips: 'สามารถเลือกสถานะที่ไม่ยื่นชั่วคราวและถูกปฏิเสธได้เท่านั้น',
  Cargo_subimitPreStatusTips: 'ยืนยันสถานะการยื่นฟ้องคดีล่วงหน้าหรือไม่',
  Cargo_TransitCannotBeNull: 'พอร์ตการขนส่งไม่สามารถว่างเปล่าได้',
  Cargo_TheClientDoesNotBelongToYourCustomerTips: 'หน่วยงานหลักนี้ไม่ใช่ของลูกค้า กรุณาเลือกจากใหม่',
  Cargo_ThereAreBargesTips: 'เรือบรรทุกสินค้า กรุณาระบุวันกำหนดส่งสินค้า',
  Cargo_ClosingDateCannotBeGreaterThanTheSailingDate: 'กำหนดเส้นตายไม่เกินวันออกเดินทาง',
  Cargo_ClosingDateOfBargeTips: 'กำหนดเวลาเดินเรือต้องไม่เกินกำหนดเวลา',
  Cargo_CurrentAccount: 'หัวข้อการติดต่อกลับ',
  Cargo_BusinessNoAndChargeName: 'หมายเลขธุรกิจ / ชื่อค่าธรรมเนียม',
  Cargo_BusinessNum: 'จำนวนแถบธุรกิจ',
  Cargo_VoucherLineNumberSetting: 'การตั้งค่าจำนวนบรรทัดของบัตรกำนัล',
  Cargo_VoucherLine: 'จำนวนแถวของบัตรกำนัล',
  Cargo_UseRmbEntrytypeByInvoice: 'ใบแจ้งหนี้บัตรกำนัลใบสำคัญแสดงสิทธิ ใช่ ไม่ [จำนวนเงินสกุลเดิม] ถอนโดยตรง [จำนวนเงินสกุลหลัก] อัตราแลกเปลี่ยน 1',
  Cargo_UseRmbEntrytypeByInvoiceTip: '(คั่นด้วย ",": 1 = ลูกหนี้ 3 = เจ้าหนี้ 5 = รายได้จากการดำเนินงาน 7 = ต้นทุนการดำเนินงาน)',
  Cargo_UseRmbEntrytypeByFact: 'รายการบัตรกำนัลรับชำระเงิน ใช่ ไม่ [จำนวนเงินสกุลเดิม] ถอนโดยตรง [จำนวนเงินสกุลหลัก] อัตราแลกเปลี่ยน 1',
  Cargo_UseRmbEntrytypeByFactTip: '(คั่นด้วย ",": 1 = ลูกหนี้ 3 = เจ้าหนี้ 73 = เจ้าหนี้ (บุคคลธรรมดา) 40 = ลูกหนี้ (รวม) 41 = เจ้าหนี้ (รวม) 42 = รายได้จากการดำเนินงาน (รวม) 43 = ต้นทุนการดำเนินงาน (รวม))',
  Cargo_UseRmbEntrytypeByPre: 'รายการบัตรกำนัลที่ได้รับล่วงหน้า ใช่ ไม่ [จำนวนเหรียญดั้งเดิม] ถอนโดยตรง [จำนวนเหรียญท้องถิ่น] อัตราแลกเปลี่ยน 1',
  Cargo_UseRmbEntrytypeByPreTip: '(คั่นด้วย ",": 1 = ลูกหนี้ 3 = เจ้าหนี้ 26 = Pre-Account 44 = Pre-Account)',
  Cargo_UploadTime: 'เวลาอัพโหลด',
  Cargo_Finished: 'ไม่ว่าจะเสร็จสมบูรณ์',
  Cargo_OperationRequirement: 'ข้อกำหนดการดำเนินงาน',
  Cargo_measurements: 'ขนาด CM (L * W * H * จำนวนชิ้น)',
  Cargo_Note: 'คำแนะนำ',
  Cargo_ChooseEdiTemplate: 'เลือกเทมเพลต EDI',
  Cargo_OperatedFailed: 'การดำเนินการล้มเหลว',
  Cargo_SelectPurchaseRecord: 'กรุณาเลือกประวัติการซื้อ',
  Cargo_SelectAcquiredRecord: 'โปรดเลือกประวัติการใช้งาน',
  Cargo_CheckInvoiceInvalidState: 'ตัวเลือกปัจจุบันประกอบด้วยหมายเลขใบแจ้งหนี้ที่เป็นโมฆะหรือใช้แล้ว',
  Cargo_CheckInvoiceUsedState: 'ไม่มีการเลือกใบแจ้งหนี้หรือไม่เลือกสถานะการใช้งาน',
  Cargo_InvoiceRestoreSuccessfully: 'การเรียกคืนใบแจ้งหนี้ประสบความสำเร็จ',
  Cargo_CheckInvoiceRestoreState: 'ตัวเลือกปัจจุบันประกอบด้วยหมายเลขใบแจ้งหนี้ที่ไม่ใช่โมฆะ',
  Cargo_ConfirmRestoreInvoice: 'แน่ใจหรือไม่ว่าต้องการเรียกคืนใบแจ้งหนี้ที่เป็นโมฆะ',
  Cargo_InvoiceInvalidSuccessfully: 'ใบแจ้งหนี้เป็นโมฆะสำเร็จ',
  Cargo_CheckInvoiceType: 'ประเภทใบแจ้งหนี้ไม่สอดคล้องกัน',
  Cargo_CheckInvoiceRecipientState: 'ตัวเลือกปัจจุบันได้รวมบันทึกการใช้งานแล้ว',
  Cargo_LocalAmount: 'เหรียญท้องถิ่น',
  Cargo_SourceAmount: 'เหรียญต้นฉบับ',
  Cargo_DebitAmountOccurredLocal: 'ยอดเดบิต (เดบิต)',
  Cargo_DebitAmountOccurredSource: 'ยอดเดบิต (เหรียญเดิม)',
  Cargo_CreditAmountOccurredLocal: 'ยอดเครดิตที่เกิดขึ้น (สกุลเงินท้องถิ่น)',
  Cargo_CreditAmountOccurredSource: 'ยอดเครดิตที่เกิดขึ้น (เหรียญต้นฉบับ)',
  Cargo_dispPop: 'คลิกเพื่อขยายสถิติ',
  Cargo_hidePop: 'คลิกเพื่อเก็บสถิติ',
  Cargo_SchemeUserTips: 'หมายเหตุ: แผนค่าใช้จ่ายของผู้ใช้ได้รับการบำรุงรักษาให้ใช้ได้เฉพาะกับผู้ใช้ในรายการต่อไปนี้',
  Cargo_NoDataCanBeModified: 'ไม่มีข้อมูลมาแก้ไข',
  Cargo_BalanceLocal: 'ยอดเงินคงเหลือ (เหรียญหลัก)',
  Cargo_BalanceSource: 'ยอดคงเหลือ (เหรียญต้นฉบับ)',
  Cargo_DebitAmountLocal: 'จำนวนเงินเดบิต (สกุลเงินท้องถิ่น)',
  Cargo_DebitAmountSource: 'ยอดเดบิต (เหรียญต้นฉบับ)',
  Cargo_DebitSideLocal: 'เดบิต (สกุลเงินท้องถิ่น)',
  Cargo_DebitSideSource: 'เดบิต (เหรียญต้นฉบับ)',
  Cargo_CreditAmountLocal: 'เครดิต (สกุลเงินท้องถิ่น)',
  Cargo_CreditAmountSource: 'เครดิต (เหรียญต้นฉบับ)',
  Cargo_BatchUpload: 'อัปโหลดเป็นกลุ่ม',
  Cargo_PleaseSelectBusinessData: 'โปรดเลือกชื่อไฟล์ ข้อมูลทางธุรกิจที่ต้องการจับคู่',
  Cargo_DocumentsBack: 'การรับเอกสารคืน',
  Cargo_CanNotWriteOffForDifferentExpenseTypes: 'ค่าธรรมเนียมในประเทศและต่างประเทศไม่อนุญาตให้ตัดพร้อมกัน!',
  Cargo_VehicleRequestForm: 'แบบฟอร์มขอใช้รถ',
  Cargo_VehicleOrder: 'ใบสั่งรถ',
  Cargo_BatchGenerateVehicleOrder: 'สร้างใบสั่งรถแบบกลุ่ม',
  Cargo_VehicleRequestFormNo: 'เลขที่แบบฟอร์มขอใช้รถ',
  Cargo_PickUpDelivery: 'รับ/ส่งสินค้า',
  Cargo_EstimatedPickUpDate: 'วันที่รับสินค้าโดยประมาณ',
  Cargo_Port2: 'ท่าเรือ',
  Cargo_VehicleOrderNo: 'เลขที่ใบสั่งรถ',
  Cargo_VehicleTime: 'เวลาออกรถ',
  Cargo_CancelVehicleOrder: 'ยกเลิกใบสั่งรถ',
  Cargo_VehicleDispatched: 'รถออกแล้ว',
  Cargo_CancelVehicleStatus: 'ยกเลิกสถานะการออกรถ',
  Cargo_CancelCompletedStatus: 'ยกเลิกสถานะเสร็จสิ้น',
  Cargo_StatusUpdateRecord: 'บันทึกการอัปเดตสถานะ',
  Cargo_UpdateVehicleOrderStatus: 'อัปเดตสถานะใบสั่งรถ',
  Cargo_CancelCondition: 'ยกเลิกได้เฉพาะเมื่อสถานะเป็น "ยังไม่ออกรถ"',
  Cargo_ConfirmCancelVehicleOrder: 'ยืนยันยกเลิกการออกรถ?',
  Cargo_SelectNotDispatched: 'กรุณาเลือกใบสั่งรถที่มีสถานะ "ยังไม่ออกรถ"',
  Cargo_SelectDispatched: 'กรุณาเลือกใบสั่งรถที่มีสถานะ "รถออกแล้ว"',
  Cargo_SelectStatusConsistent: 'สถานะของใบสั่งรถที่เลือกต้องเหมือนกัน',
  Cargo_VehicleOrderCompleted: 'ใบสั่งรถเสร็จสิ้นแล้ว',
  Cargo_SelectCompleted: 'กรุณาเลือกใบสั่งรถที่มีสถานะ "เสร็จสิ้น"',
  Cargo_CompletionTimeNotEarlierThanDispatchTime: '"เวลาสิ้นสุด" ต้องไม่เร็วกว่า "เวลาออกรถ"',
  Cargo_ActualPickupDate: 'วันที่รับสินค้าจริง',
  Cargo_DispatchTaskLinkedToVehicle: 'ใบงานส่งรถเชื่อมโยงกับใบสั่งรถแล้ว ไม่สามารถลบได้ ต้องยกเลิกการเชื่อมโยงก่อน',
  Cargo_DispatchTaskLinkedToVehicle_ArrivalMethod: 'ใบงานส่งรถเชื่อมโยงกับใบสั่งรถแล้ว ไม่สามารถแก้ไข "วิธีการรับสินค้า" ได้ ต้องยกเลิกการเชื่อมโยงก่อน',
  Cargo_DispatchTaskLinkedToVehicle_DestinationPort: 'ใบงานส่งรถเชื่อมโยงกับใบสั่งรถแล้ว ไม่สามารถยกเลิก "การส่งรถไปท่าเรือปลายทาง" ได้ ต้องยกเลิกการเชื่อมโยงก่อน',
  Cargo_Port_Airport: 'ท่าเรือ (สนามบิน)',
  Cargo_VehicleRequestDifferentPorts: 'แบบฟอร์มขอใช้รถอยู่ในท่าเรือคนละแห่ง ต้องการรวมกันหรือไม่?',
  Cargo_VehicleOrderGeneratedSuccess: 'สร้างใบสั่งรถสำเร็จ',
  Cargo_VehicleOrderSerialNumber: 'หมายเลขใบสั่งรถคือ',
  Cargo_BusinessCreationTime: 'เวลาสร้างงาน',
  Cargo_CurrencyMustBeTheSame: 'สกุลเงินจะต้องเหมือนกัน!',
  Cargo_AccountContacts: 'ติดต่อหน่วยการชำระเงิน',
  Cargo_AccountAddr: 'ที่อยู่ของหน่วยการชำระเงิน',
  Cargo_AccountContactsTel: 'เบอร์ติดต่อ',
  Cargo_CustomsDeclarationInformationOujian: 'ข้อมูลการประกาศศุลกากร (รูปแบบการผ่านพิธีการศุลกากรในพื้นที่ควบคุมพิเศษไม่รองรับในปัจจุบัน)',
  Cargo_ChargeSubmit: 'ไม่ว่าจะเป็นการส่งค่าธรรมเนียม',
  Cargo_ContractRatePropertySE: 'ลักษณะราคาโดยประมาณ (ทะเลออก)',
  Cargo_ContractRatePropertySI: 'ราคาโดยประมาณ (Haijin)',
  Cargo_TaxRevenueShortName: 'การเข้ารหัส',
  Cargo_TaxRevenueName: 'ชื่อรหัสภาษี',
  Cargo_TaxRevenueToolTip: 'หมายเหตุ: การเข้ารหัสเป็นรหัสภาษีแห่งชาติแบบครบวงจรตัวอย่างเช่น: 304,080,201,0200,000,000; ชื่อรหัสภาษีคือรหัสการจำแนกประเภทภาษีโดยย่อตัวอย่าง: บริการตัวแทนนายหน้า',
  Cargo_CargoSourceTip: 'เปลี่ยนประเภทแพ็คเกจเป็น [{0}] หรือไม่?',
  Cargo_AccountingMonthMaintain: 'การบำรุงรักษาทางการเงินรายเดือน',
  Cargo_FclApproximatePrice: 'FCL ประมาณ NO ราคา',
  Cargo_LclApproximatePrice: 'LCL ประมาณ NO ราคา',
  Cargo_AddContractNo: 'เพิ่มหมายเลขโดยประมาณ',
  Cargo_Income20: '20\'การปรับแต่ง',
  Cargo_Income40: '40\'การปรับแต่ง',
  Cargo_Income40HC: '40HC\'การปรับแต่ง',
  Cargo_Income45: '45\'การปรับแต่ง',
  Cargo_WeightPriceAdjust: 'การปรับราคาน้ำหนัก',
  Cargo_CubagePriceAdjust: 'การปรับราคาปริมาตร',
  Cargo_MinimumPriceAdjust: 'การปรับราคาต่ำสุด',
  Cargo_GrossMargin: 'อัตรากำไรขั้นต้น',
  Cargo_IncorrectExpenseStatus: 'สถานะค่าใช้จ่ายไม่ถูกต้อง!',
  Cargo_ExpenseStatusModifiedSuccessfully: 'แก้ไขสถานะค่าธรรมเนียมสำเร็จ!',
  Cargo_DestinationSelection: 'เลือกจุดหมายปลายทาง',
  Cargo_AciPortCode: 'รหัสพอร์ต aci',
  Cargo_InlandLocation: 'สถานที่ตั้งต่างจังหวัด',
  Cargo_SubLocationCode: 'รหัสตำแหน่งย่อย',
  Cargo_DeleteBillTips: 'สามารถลบใบแจ้งหนี้ที่ไม่ได้สร้างหมายเลขใบแจ้งหนี้และสถานะใบแจ้งหนี้ที่ยังไม่ได้รับการยืนยันเท่านั้น!',
  Cargo_ForceDeleteBillTips: 'สามารถลบใบเรียกเก็บเงินที่มีสถานะการเรียกเก็บเงินที่ไม่ได้รับการยืนยันยืนยันพิมพ์เป็นโมฆะได้เท่านั้น!',
  Cargo_ConfirmDeleteCategoryAndType: 'ระบุประเภทและประเภทที่คุณต้องการลบการเลือก?',
  Cargo_RangeAndGE: 'ขีด จำกัด ล่างของค่าตัวเลข (รวม)',
  Cargo_RangeAndLT: 'ค่าตัวเลขสูงสุด (ไม่รวม)',
  Cargo_FinancialDateCheckNull: 'วันที่ทางการเงินไม่สามารถว่าง!',
  Cargo_CurrencyCheckNull: 'สกุลเงินไม่ได้รับอนุญาตให้ว่างเปล่า!',
  Cargo_FinancialDateCheckBefore: 'เลือกวันที่ต้องไม่ช้ากว่าปัจจุบัน',
  Cargo_OperatingCompanyCannotBeEmpty: 'บริษัทที่ดำเนินการไม่สามารถว่างได้',
  Cargo_DeliveryCannotBeNull: 'สถานที่จัดส่งต้องไม่ว่างเปล่า',
  Cargo_DesignatedCannotBeNull: 'ตัวแทนจัดส่งที่ระบุไม่สามารถว่างเปล่า!',
  Cargo_SalesCannotBeEmpty: 'ยอดขายต้องไม่ว่างเปล่า',
  Cargo_ItemNumberCannotBeEmpty: 'หมายเลขสินค้าต้องไม่ว่างเปล่า!',
  Cargo_PleaseSelectLoadingPort: 'โปรดเลือกพอร์ตของการโหลด!',
  Cargo_PleaseChooseTheDestinationPort: 'โปรดเลือกพอร์ตปลายทาง!',

  Cargo_UserManagement: 'การจัดการผู้ใช้',
  Cargo_Search2: 'ค้นหา',
  Cargo_RecordAmount: 'จำนวนระเบียน',
  Cargo_RoleUserSettings: 'บทบาทการตั้งค่าผู้ใช้',
  Cargo_SystemAdministrator: 'ผู้ดูแลระบบ',
  Cargo_UserCode: 'รหัสผู้ใช้',
  Cargo_UserDepartment: 'แผนกที่ผู้ใช้สังกัด',
  Cargo_UserCompany: 'บริษัทที่ผู้ใช้บริการเป็นสมาชิก',
  Cargo_IncludingElectricitySupplierAccount: 'มีบัญชีอีคอมเมิร์ซ',
  Cargo_ValidOrNot: 'ใช้ได้หรือไม่',
  Cargo_Valid: 'มีประสิทธิภาพ',
  Cargo_Invalid2: 'ความล้มเหลว',
  Cargo_LoginName: 'เข้าสู่ระบบ',
  Cargo_MobilePhoneNo: 'โทรศัพท์มือถือ',
  Cargo_PasswordExpirationDate: 'วันที่รหัสผ่านหมดอายุ',
  Cargo_NetworkManagementCode: 'รหัสท่อตาข่าย',
  Cargo_Superior: 'ผู้บังคับบัญชาระดับสูง',
  Cargo_OfficeAndDep: 'สาขา/แผนก',
  Cargo_ConfirmBatchModifyUser: 'ข้อมูลติ๊กแทนแบทช์ที่สอดคล้องกัน 【{0}】',
  Cargo_BatchModifyUserSucceed: 'แก้ไขข้อมูลแถบ {0} เรียบร้อยแล้ว 【{1}】 เป็น 【{2}】',
  Cargo_Activation: 'การเปิดใช้งาน',
  Cargo_ElectricitySupplierAccountOrNot: 'ไม่ว่าจะเป็นบัญชีอีคอมเมิร์ซ',
  Cargo_SystemAdministratorOrNot: 'ไม่ว่าจะเป็นผู้ดูแลระบบ',
  Cargo_BatchModify: 'การปรับเปลี่ยนแบทช์',
  Cargo_TheCompanyToWhichTheAccountBelongs: 'บัญชีที่เป็นของ บริษัท',
  Cargo_EditPermission: 'แก้ไขสิทธิ์',
  Cargo_AddUser: 'เพิ่มผู้ใช้',
  Cargo_DeleteUser: 'ลบผู้ใช้',
  Cargo_RemoveUser: 'ลบผู้ใช้',
  Cargo_Filter2: 'เงื่อนไขการกรอง',
  Cargo_Import2: 'นำเข้าจำนวนมาก',
  GOODS_INFO_IMPORT: 'การนำเข้าข้อมูลสินค้า',
  Cargo_ContinueToCreate: 'พันธมิตรนี้ได้รับการดูแลภายใต้ {0} คุณต้องการสร้างต่อไปหรือไม่?',
  Cargo_AssignRolesToUsers: 'ผู้ใช้บทบาทที่จะได้รับมอบหมาย',
  Cargo_SelectARangeOfUsers: 'เลือกขอบเขตผู้ใช้',
  Cargo_NotSubmittedOrRejectedTips: 'อนุญาตให้ลบเฉพาะธุรกิจที่ไม่ได้ส่งหรือปฏิเสธชั่วคราวโปรดเลือกใหม่',
  Cargo_SelectedMoreThenNPieces: 'ข้อมูลที่คุณเลือกเกินจำนวนแถบที่จำกัด {0} กรุณาเลือกอีกครั้ง',
  Cargo_SmallTicketCannotBeRemoved: 'ตั๋วใบเล็กมีค่าใช้จ่ายส่วนแบ่งและไม่สามารถถอดออกได้',
  Cargo_invoiceNotInconsistent: 'ประเภทใบแจ้งหนี้ ประเภทใบแจ้งหนี้ไม่สอดคล้องกัน จะดำเนินการต่อหรือไม่',
  Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted: 'สามารถยื่นบิลที่มีเลขใบเรียกเก็บเงินเท่านั้น',
  Cargo_SureDoThis: 'แน่ใจเหรอว่าจะทำแบบนี้',
  Cargo_BillHasBeenSubmitted: 'ส่งบิล[{0}]',
  Cargo_BillWasNotSubmitted: 'การเรียกเก็บเงิน [{0}] ไม่ใช่สถานะที่ส่ง',
  Cargo_OnlyBillsWithBillingNumbersCanBeWriteOff: 'สามารถตัดบัญชีเฉพาะบิลที่มีหมายเลขใบเรียกเก็บเงิน',
  Cargo_BillsHasBeenPaidInFull: 'การเรียกเก็บเงิน {0} ได้รับการชำระเงินทั้งหมดและไม่สามารถตัดบัญชีได้อีก',
  Cargo_NotAllowWriteOffFee: 'ในค่าธรรมเนียมรอการตัดสิน มีค่าใช้จ่ายที่ต้องชำระที่ยังไม่ได้ดำเนินการคำขอชำระเงิน หรือกระบวนการขอชำระเงินยังไม่เสร็จสมบูรณ์ ไม่อนุญาตให้มีการตัดบัญชี',
  Cargo_BillsAlreadyWriteOffFee: 'การเรียกเก็บเงิน {0} ได้ทำการตัดบัญชีและไม่สามารถส่งคืนได้',
  Cargo_RevokeAll: 'ยกเลิกทั้งหมด',
  Cargo_ConfirmAndNotityHQ: 'แน่ใจจะแจ้งสำนักงานใหญ่?',
  Cargo_AllBillingHasBeenSentToBranches: 'เลือกหัวข้อการตั้งถิ่นฐานปัจจุบันทั้งหมด ส่งบริษัทมากเกินไป',
  Cargo_Sender: 'ส่งโดย',
  Cargo_SendDate: 'เวลา EDI',
  Cargo_VersionNo: 'หมายเลขรุ่น',
  Cargo_BookingLog: 'บันทึกการจอง',
  Cargo_BookingSubscribe: 'สมัครรับข้อมูล',
  Cargo_BookingSubscribeSync: 'ซิงค์ข้อมูล',
  Cargo_BookingSubscriptionStatus: 'รายละเอียดการสมัคร',
  Cargo_SubscribeDataType: 'ประเภทข้อมูล',
  Cargo_SubscribeStatus: 'สถานะการสมัคร',
  Cargo_BatchUpdateExchangeRate: 'อัตราแลกเปลี่ยน Batch Update',
  Cargo_UpdateExchangeRate: 'อัพเดทอัตราแลกเปลี่ยน',
  Cargo_SelectAccountAndCurrency: 'โปรดเลือกวัตถุที่ชำระราคาและแก้ไขอัตราแลกเปลี่ยน:',
  Cargo_InputRate: 'ป้อนอัตราแลกเปลี่ยน:',
  Cargo_ConfirmUpdateExchangeRate: 'ยืนยันการต่ออายุอัตราแลกเปลี่ยนหรือไม่?',
  Cargo_PleaseInputRate: 'กรุณาใส่อัตราแลกเปลี่ยนที่ต้องการเปลี่ยนแปลง!',
  Cargo_PleaseSelectAccountAndCurrency: 'โปรดเลือกวัตถุ / สกุลเงินที่ต้องการเปลี่ยนอัตราแลกเปลี่ยน!',
  Cargo_ValidateUpdateRateTips: 'การดำเนินการล้มเหลวหน่วยการชำระราคา / สกุลเงินที่อัปเดตอัตราแลกเปลี่ยนนี้ไม่ได้อยู่ในธุรกิจติ๊กนี้!',
  Cargo_UpdateRateConfirmTipsHead: 'การอัปเดตจำนวนมากของอัตราแลกเปลี่ยนรวมถึงการสร้าง',
  Cargo_UpdateRateConfirmTipsTail: 'ค่าธรรมเนียม การอัพเดทครั้งนี้เฉพาะอัตราแลกเปลี่ยนค่าธรรมเนียมเดิมเท่านั้น การแก้ไขข้อมูลไม่สามารถกู้คืนได้ จะดำเนินการต่อหรือไม่',
  Cargo_BillVoidTipForState: 'การเรียกเก็บเงินสามารถยกเลิกได้เฉพาะในสถานะ "ไม่ได้รับการยืนยัน" เท่านั้น!',
  Cargo_BillVoidTipForReview: 'การเรียกเก็บเงินสามารถยกเลิกได้เฉพาะในสถานะ "ไม่ได้รับการตรวจสอบ" เท่านั้น!',
  Cargo_DuplicatedCode: 'รหัสนี้ซ้ำกันโปรดป้อนอีกครั้ง',
  Cargo_PlatformCertifiedPartner: 'เลือกพันธมิตรที่ได้รับการรับรองแพลตฟอร์ม',
  Cargo_Examine: 'ไม่ว่าจะเป็นการตรวจสอบ',
  Cargo_NameOfApplicant: 'สมัครชื่อธุรกิจ',
  Cargo_CreateSource: 'แหล่งที่มา',
  Cargo_Tenant: 'ผู้เช่า',
  Cargo_Platform: 'แพลตฟอร์ม',
  Cargo_AdvertisingManagement: 'การจัดการโฆษณา',
  Cargo_AdvertisingNo: 'หมายเลขโฆษณา',
  Cargo_AdvertisingContent: 'เนื้อหาโฆษณา',
  Cargo_System: 'ระบบที่สังกัด',
  Cargo_Module: 'โมดูลที่เป็นของ',
  Cargo_PageIndex: 'หน้าเว็บที่เป็นสมาชิก',
  Cargo_AdvertisingSpace: 'พื้นที่โฆษณา',
  Cargo_AdvertisingSubject: 'เนื้อหาโฆษณา',
  Cargo_PromotionCycle: 'รอบโปรโมชั่น',
  Cargo_DataTime: 'วันที่ข้อมูล',
  Cargo_AdvertisingSpaceNo: 'หมายเลขบิตโฆษณา',
  Cargo_billPaymentNo: 'หมายเลขใบคำขอชำระเงิน',
  Cargo_RangeSmaller: 'แนะนำช่วงขนาดเล็ก',
  Cargo_SyncFinanceCode: 'การย้ายครั้งนี้จะเขียนรหัสพันธมิตรลงในรหัสลูกค้า จะดําเนินการต่อหรือไม่',
  Cargo_SyncFinanceCodeSuccess: 'การประสานข้อมูลรหัสลูกค้าประสบความสำเร็จ',
  Carge_ConfirmDate: 'ยืนยันเวลา',
  Carge_ConfirmUser: 'ยืนยันโดย',
  Carge_BillingConfirmDate: 'เวลายืนยันบิล',
  Carge_BillingConfirmUser: 'ยืนยันบิล',
  Carge_BillingGroupConfirmDate: 'เวลายืนยันใบแจ้งยอด',
  Carge_BillingGroupConfirmUser: 'การยืนยันใบแจ้งยอด',
  Carge_ChinessNameExist: 'มีชื่อภาษาจีนแล้ว กรุณาแก้ไข',
  Carge_EnglishNameExist: 'มีชื่อภาษาอังกฤษแล้ว กรุณาแก้ไข',
  Cargo_Dep: 'แผนกป้อนข้อมูล',
  Cargo_contactInformationCopy: 'ข้อมูลการติดต่อ - สำเนาเดี่ยว',
  Cargo_contactInformationCode: 'ข้อมูลการติดต่อ - การดึงรหัส',
  Cargo_auditResult: 'ผลการตรวจสอบ',
  Cargo_number: 'หมายเลข',
  Cargo_PlatformCode2: 'รหัสแพลตฟอร์ม',
  Cargo_InterchaneeCode: 'แลกเปลี่ยนรหัส',
  Cargo_abbreviation: 'ชื่อย่อ',
  Cargo_TemplateDescribe: 'คำอธิบายแม่แบบ',
  Cargo_Describe: 'คำอธิบาย',
  Cargo_BillingHeaderName: 'ชื่อใบแจ้งหนี้ขึ้น',
  Cargo_EnglishNameOfBank: 'ชื่อภาษาอังกฤษของธนาคาร',
  Cargo_ContactName: 'ชื่อผู้ติดต่อ',
  Cargo_TenantID: 'รหัสผู้เช่า',
  Cargo_AppendQuery: 'สอบถามเพิ่มเติม',
  Cargo_CollapseList: 'รับรายการ',
  Cargo_SetAsDefault: 'ตั้งค่าเป็นค่าเริ่มต้น',
  Cargo_MultipleWorkNoEnter: 'โปรดใช้ Enter เพื่อป้อนหมายเลขงานหลายหมายเลข',
  Cargo_DeleteConfirm: 'ข้อมูลจะไม่สามารถกู้คืนได้หลังจากลบ คุณต้องการดำเนินการต่อหรือไม่?',
  Cargo_EachPage: 'แต่ละหน้า',
  Cargo_DataBar: 'ข้อมูลแถบ',
  Cargo_ClientNumberMaintenance: 'การบำรุงรักษาหมายเลขควบคุมภาษี',
  Cargo_BillingPointCode: 'รหัสจุดชำระเงิน',
  Cargo_UseDepartment: 'แผนกการใช้งาน',
  Cargo_CanNotEmpty: 'ว่างเปล่าไม่ได้!',
  Cargo_CanNotRepeat: 'ทำซ้ำไม่ได้!',
  Cargo_BeforeCurrentDisplay: 'ก่อนแสดงปัจจุบัน',
  Cargo_ReceivableChargeInput: 'ค่าธรรมเนียมการรับเข้า',
  Cargo_CostChargeInput: 'ค่าธรรมเนียมที่ต้องชำระ ไม่ว่าจะเป็นรายการ',
  Cargo_ConvertToCnyAr: 'รายได้: RMB',
  Cargo_ConvertToCnyAp: 'การชำระเงิน: RMB',
  Cargo_FeeModifier: 'แก้ไขค่าธรรมเนียม',
  Cargo_FeeModifyDate: 'เวลาแก้ไขค่าธรรมเนียม',
  Cargo_SoNoChangeTips: 'จำนวนใบปิดมีการเปลี่ยนแปลง จะมีการรีเฟรชค่าธรรมเนียมเดิมตามหมายเลขใบปิด?',
  Cargo_EditSaleInfo: 'การปรับข้อมูลการขาย',
  Cargo_PleaseSelectChargeApplyData: 'โปรดเลือกข้อมูลการตรวจสอบค่าธรรมเนียม',
  Cargo_PleaseSelectExportChargeDetailData: 'โปรดลองใหม่อีกครั้งหลังจากเลือกบันทึกการสมัคร',
  Cargo_BeyondMaxExportChargeDetailData: 'บันทึกการสมัครส่งออกต้องไม่เกิน 5,000 รายการโปรดเลือกใหม่',
  Cargo_ExportChargeDetailDataSucceed: 'รายละเอียดการส่งออกประสบความสำเร็จ',
  Cargo_NotSameEtd: 'วันที่ออกเดินทางของธุรกิจติ๊กเดือนไม่สอดคล้องกัน!',
  Cargo_BatchModifyJobNoMore: 'การแก้ไขหมายเลขธุรกิจชุดเดียวต้องไม่เกิน 100 ชิ้น',
  Cargo_BatchModifyJobNoSuccess: 'แก้ไขแบทช์สำเร็จ: {0}',
  Cargo_VolumeIsChanged: 'ปริมาณจริงมีการเปลี่ยนแปลง จะรีเฟรชค่าธรรมเนียมเดิมตามราคาของปริมาตรหรือไม่?',
  Cargo_DealingsCustomer: 'ไม่ว่าจะเป็นยอดเงินหมุนเวียนตามหมายเลขธุรกิจ',
  Cargo_AllowsExceptionProofExport: 'อนุญาตให้ข้ามการส่งออกบัตรกำนัลที่ผิดปกติ',
  Cargo_ChargeChanger: 'เปลี่ยนค่าธรรมเนียม',
  Cargo_ChargeCreadBy: 'สร้างค่าใช้จ่าย',
  Cargo_DeleteData: 'ข้อมูลถูกลบไปแล้วโปรดติดต่อผู้ดูแลระบบ',
  Cargo_MasterTicketShareCharge: 'ค่าใช้จ่ายของบัตรหลักถูกแบ่งออกแล้ว และบัตรใหม่ขนาดเล็กกรุณาแบ่งค่าใช้จ่ายใหม่',
  Cargo_CreateBillNo: 'ไม่ว่าจะเป็นการสร้างหมายเลขบิล',
  Cargo_CalcShareAmount: 'คำนวณจำนวนเงินที่แบ่ง',
  Cargo_CalcShareAmountTip: 'โปรดยืนยันหลังจากกดปุ่มคำนวณจำนวนเงินที่แบ่งในการคำนวณใหม่',
  Cargo_CancelOrder: 'ยกเลิกคำสั่งซื้อ {0} เรียบร้อยแล้วและไม่สามารถยกเลิกคำสั่งซื้อ {1} ได้ รองรับการยกเลิกคำสั่งในสถานะการทำงานเป็นบวกเท่านั้น',
  Cargo_CancelOrderTip1: 'คำสั่งซื้อต่อไปนี้ไม่สามารถยกเลิกได้ คุณต้องการดำเนินการต่อไปหรือไม่?',
  Cargo_CancelOrderTip2: 'คำสั่งซื้อนี้ออกจากท่าเรือและมีหมายเลขธุรกิจหลักอยู่แล้วไม่สามารถยกเลิกได้',
  Cargo_CancelOrderTip3: 'คำสั่งซื้อนี้ออกจากท่าเรือและไม่สามารถยกเลิกได้',
  Cargo_CancelOrderTip4: 'คำสั่งซื้อนี้มีหมายเลขธุรกิจหลักอยู่แล้วและไม่สามารถยกเลิกได้',
  Cargo_CancelOrderTip5: 'คุณต้องการยกเลิกคำสั่งปากกา {0} นี้เป็นจำนวนมากหรือไม่?',
  Cargo_CancelOrderTip6: 'การยกเลิกคำสั่งซื้อ',
  Cargo_CancelOrderTip7: 'สำหรับการส่งคำสั่งปากกา {0} ในครั้งนี้ คำสั่งซื้อต่อไปนี้ไม่สามารถยกเลิกได้ คุณต้องการที่จะดำเนินการต่อหรือไม่?',
  Cargo_CancelOrderTip8: 'สถานะการสั่งซื้อคือ {0} และไม่สามารถยกเลิกได้',
  Cargo_Reason: 'เหตุผล',
  Cargo_PushResultLog: 'การบันทึกผลการผลักดันข้อมูล',
  Cargo_SendContent: 'ส่งเนื้อหา',
  Cargo_ResultSuccess: 'สถานะการส่ง',
  Cargo_ResultMessage: 'สาเหตุของความล้มเหลว',
  Cargo_DesignatedCargoWarehouseNo: 'หมายเลขสถานะขาเข้าเท่ากับหมายเลขอ้างอิงธุรกิจเมื่อระบุสินค้า',
  Cargo_SelfCargoWarehouseNo: 'หมายเลขสถานะขาเข้าเท่ากับหมายเลขอ้างอิงธุรกิจเมื่อทำการสั่งซื้อด้วยตนเอง',
  Cargo_BusinessMark: 'เครื่องหมายธุรกิจ',
  Cargo_ModifyBusiness: 'แก้ไขสร้างธุรกิจอีกครั้ง',
  Cargo_SelectJobNo: 'กรุณาเลือกหมายเลขธุรกิจ',
  Cargo_ClosingRecord: 'บันทึกการปิดบัญชี',
  Cargo_ClosingAudit: 'การตรวจสอบบัญชีปิด',
  Cargo_AccountKeeper: 'ปิดบัญชี',
  Cargo_ClosingMonth: 'เดือนที่ปิดบัญชี',
  Cargo_ClosingBranch: 'สาขาปิดบัญชี',
  Cargo_AccountClosingType: 'ประเภทการปิดบัญชี',
  Cargo_ClosingDate: 'วันที่ปิดบัญชี',
  Cargo_FinancialClosing: 'การปิดบัญชีการเงิน',
  Cargo_BusinessClosing: 'การปิดบัญชีธุรกิจ',
  Cargo_SelectClosingDate: 'เลือกวันที่ปิดบัญชี',
  Cargo_SelectDeleteTip: 'โปรดเลือกข้อมูลลายฉลุที่คุณต้องการลบ',
  Cargo_SelectDeleteTip2: '{0} ถูกใช้และไม่สามารถลบได้',
  Cargo_SelectDeleteTip3: 'แน่ใจหรือว่าคุณต้องการลบการกำหนดค่าที่เลือกไว้? เรียกอินเทอร์เฟซจะไม่ส่งข้อมูลกลับมาหลังจากการลบ',
  Cargo_SameCurrencyForMultipleRecord: 'กรุณาเลือกบันทึกการรับชำระเงินจริงของสกุลเงินเดียวกันสำหรับการตัดบัญชี!',
  Cargo_SamePayReceiveDateForMultipleRecord: 'โปรดเลือกบันทึกการรับชำระจริงที่มีวันที่รับชำระจริงเดียวกันสำหรับการตัดบัญชี!',
  Cargo_DefaultTaxRete: 'อัตราภาษีเริ่มต้น',
  Cargo_TaxRateRange: 'ช่วงอัตราภาษีที่มีอยู่',
  Cargo_TaxRateRangeLimit: '{0}, อัตราภาษีปัจจุบันไม่สามารถใช้ได้, โปรดตรวจสอบ, หากจำเป็นโปรดติดต่อหัวหน้างานเพื่อดูแลรักษา 【อัตราภาษีที่มีอยู่】 ของค่าใช้จ่ายนี้',
  Cargo_BargeETD: 'เรือบรรทุกสินค้า ETD',
  Cargo_DataModifyDate: 'เวลาเปลี่ยนแปลงข้อมูล',
  Cargo_sendOcOrder: 'การส่งข้อมูลการสั่งซื้อซ้ำ',
  Cargo_sendOcTracking: 'ส่งข้อมูลการติดตามอีกครั้ง',
  Cargo_sendOcFile: 'ส่งไฟล์อีกครั้ง',
  Cargo_sendOcBilling: 'การส่งข้อมูลการเรียกเก็บเงินอีกครั้ง',
  Cargo_chargeUpdater: 'อัพเดทค่าธรรมเนียม',
  Cargo_WriteOffForMultipleRemainTipAr: 'จำนวนเงินที่เรียกชำระแล้วในการเลือกนี้ไม่เพียงพอ ขอแนะนำให้แก้ไขจำนวนเงินที่ตัดบัญชีนี้!',
  Cargo_SharedChargeRecord: 'บันทึกการแบ่งค่าใช้จ่าย',
  Cargo_ExcludingTaxAmount: 'จำนวนเงินที่ยังไม่เสียภาษี',
  Cargo_IncludedTaxAmount: 'รวมภาษีแล้ว',
  Cargo_ShareScheme: 'วิธีการแบ่ง',
  Cargo_ChargeSyncStatus: 'สถานะการซิงค์ค่าใช้จ่าย',
  Cargo_ChargeSyncConfirmStatus: 'ยืนยันสถานะแบบซิงโครนัส',
  Cargo_WriteOffForMultipleRemainTipAp: 'จำนวนเงินที่จ่ายจริงสำหรับตัวเลือกนี้ไม่เพียงพอขอแนะนำให้แก้ไขจำนวนเงินที่จ่ายจริง!',
  Cargo_ConsolidatedProfitLossIs2: 'กำไรและขาดทุนจากอัตราแลกเปลี่ยนคือ:',
  Cargo_GroupScene: 'ฉากกลุ่ม',
  Cargo_GroupName: 'ชื่อกลุ่ม',
  Cargo_GroupType: 'ประเภทกลุ่ม',
  Cargo_CcPerson: 'ซีซี คน',
  Cargo_UpdatePerson: 'อัพเดทโดย',
  Cargo_Common: 'สาธารณะ',
  Cargo_Personal: 'ส่วนตัว',
  Cargo_ReleasePerson: 'วางเดี่ยว',
  Cargo_MailGroupType: 'โปรดเลือกอย่างน้อยหนึ่งประเภท',
  Cargo_MailGroupName: 'โปรดป้อนชื่อกลุ่ม',
  Cargo_MailGroupEmail: 'โปรดป้อนที่อยู่อีเมลอย่างน้อย 1',
  Cargo_MailGroupCheckEmail: 'โปรดตรวจสอบรูปแบบข้อความที่ป้อน',
  Cargo_MailGroupDelete: 'การลบไม่สามารถกู้คืนได้ โปรดยืนยันว่าจะลบข้อมูลหรือไม่',
  Cargo_ChargeRate: 'อัตราแลกเปลี่ยนค่าธรรมเนียม',
  Cargo_BillingRate: 'อัตราแลกเปลี่ยนบิล',
  Cargo_GroupChargeRate: 'อัตราแลกเปลี่ยนค่าธรรมเนียมกลุ่ม',
  Cargo_BranchRate: 'อัตราแลกเปลี่ยนของสาขา',
  Cargo_EnabledChildOffice: 'อัตราแลกเปลี่ยนปัจจุบันมีผลบังคับใช้กับบริษัทย่อยระดับล่าง',
  Cargo_ShowParentRateOffice: 'ใบสมัคร: {0} อัตราแลกเปลี่ยน',
  Cargo_SetEnabledChild: 'การจัดตั้งบริษัทย่อยมีผลบังคับใช้',
  Cargo_SetEnabledChildDialog: 'การตั้งค่ามีผลใช้บังคับกับบริษัทย่อยระดับล่าง',
  Cargo_SetEnabledChildCheckbox: 'มีผลใช้บังคับกับบริษัทย่อยระดับล่าง',
  Cargo_CopyOfficeRate: 'คัดลอกอัตราแลกเปลี่ยนของสาขา',
  Cargo_CopyHqRate: 'คัดลอกอัตราแลกเปลี่ยนกลุ่ม',
  Cargo_ConfirmCopyBillingRateTip: 'เขียนทับข้อมูลที่มีอยู่หรือไม่',
  Cargo_Cover: 'ครอบคลุม',
  Cargo_NotCover: 'ไม่เขียนทับ',
  Cargo_PleaseSelectExportData: 'โปรดเลือกข้อมูลที่คุณต้องการส่งออก!',
  Cargo_UploadRateTip: 'ไฟล์ที่อัปโหลดสามารถเป็นรูปแบบ xls, xlsx เท่านั้น!',
  Cargo_UploadDataSizeMore: 'ขนาดไฟล์ต้องไม่เกิน 2MB!',
  Cargo_UploadDataFailed: 'นำเข้าล้มเหลว, ติดต่อผู้ดูแลระบบ!',
  Cargo_UploadFailedCheckExcel: 'การนำเข้าล้มเหลว โปรดตรวจสอบเนื้อหาของเทมเพลต!',
  Cargo_ValidateUploadRateTip1: 'ค่าสกุลเงินเดิมคือ {0} และค่าสกุลเงินอ้างอิงคือ {1} ซ้ำกับข้อมูลอื่น ๆ ใน Excel!',
  Cargo_ValidateUploadRateTip2: 'ค่าสกุลเงินเดิมคือ {0} และค่าสกุลเงินอ้างอิงคือ {1} ซ้ำกับข้อมูลที่มีอยู่ในตาราง!',
  Cargo_ValidateUploadRateTip3: 'ข้อมูลซ้ำกับข้อมูลที่มีอยู่ในตาราง!',
  Cargo_DefaultReceivableMode: 'โหมดรับนักเรียนปริยาย',
  Cargo_DefaultReceivableRate: 'อัตราเริ่มต้น',
  Cargo_SecondReceivableRate: 'อัตราที่สองของลูกหนี้',
  Cargo_ChargeableAmountInterval: 'ช่วงยอดที่ต้องเรียกเก็บ',
  Cargo_ReceivableIntervalType: 'ประเภทช่วงลูกหนี้',
  Cargo_DefaultUnitPrice: 'ราคาต่อหน่วยเริ่มต้น',
  Cargo_DefaultRate: 'อัตราเริ่มต้น',
  Cargo_Suit: 'ใช้ได้',
  Cargo_DefaultPayableMode: 'โหมดจัดการปริยาย',
  Cargo_DefaultPayableRate: 'จ่ายตามอัตราเริ่มต้น',
  Cargo_SecondRatePayable: 'จ่ายในอัตราที่สอง',
  Cargo_PayableAmountInterval: 'ช่วงค่าธรรมเนียมที่ต้องชำระ',
  Cargo_PayableIntervalType: 'ประเภทของช่วงที่ต้องรับมือ',
  Cargo_EDIFileType: 'ประเภทไฟล์EDIเมื่อส่ง(UploadFileSuffix)',
  Cargo_MarkOrCargoEnglishNameChangeTip: 'ลายเซ็นหน้าพื้นฐาน {0} มีการเปลี่ยนแปลงข้อมูลลายเซ็นหน้า B / L รีเฟรชหรือไม่?',
  Cargo_ShareChargeCheckCurrency: 'สกุลเงินของการแบ่งค่าธรรมเนียมและทิศทางการรับชำระเงินควรสอดคล้องกัน',
  Cargo_ShareChargeCheck: 'ผลรวมของค่าธรรมเนียมส่วนแบ่งบัตรโดยสารขนาดเล็กจะไม่เท่ากับค่าธรรมเนียมเดิม!',
  Cargo_PleaseSelectedSalesForCustomer: 'โปรดรักษายอดขายที่สอดคล้องกับลูกค้า!',
  Cargo_PleaseSelectedLevelForCustomer: 'กรุณารักษาระดับลูกค้าที่สอดคล้องกัน!',
  AutomaticReconciliation: 'การสร้างความปรองดองอัตโนมัติ',
  AutomaticReconciliationHistory: 'ประวัติการปรองดองอัตโนมัติ',
  CheckHistory: 'ประวัติความปรองดอง',
  ReconciliationResult: 'ผลการสร้างความปรองดอง',
  ImportReconciliationExcel: 'นำเข้าตาราง Excel เพื่อการปรองดอง',
  Cargo_BatchUpdateChargeConfirmSerialNumber: 'ชุดแก้ไขแบทช์',
  Cargo_BatchUpdateChargeConfirmSerialNumberTip: 'ค่าธรรมเนียมที่เลือกไว้จะถูกแก้ไขเป็นหมายเลขล็อตต่อไปนี้',
  Cargo_InputChargeConfirmSerialNumber: 'กรุณาใส่หมายเลขล็อต',
  Cargo_ChargeConfirmSerialNumber: 'หมายเลขล็อตยืนยันค่าธรรมเนียม',
  Cargo_ChargeConfirmSerialNumberLengthMore: 'หมายเลขล็อตต้องไม่เกิน 20 หลัก!',
  Cargo_PleaseSelectSolicitationType: 'กรุณาเลือกประเภทของแพ็คเกจ!',
  Cargo_WriteoffSeqNo: 'หมายเลขล็อตการขายบัญชี',
  Cargo_CustomerContactChannel: 'ช่องทางการติดต่อลูกค้า',
  Cargo_AgentBilling: 'ตัวแทนแบ่งการเรียกเก็บเงิน',
  Cargo_AgentBillingCanNotEdit: 'การเรียกเก็บเงิน Agent Split ไม่สามารถแก้ไขได้!',
  Cargo_RecheckBillingCanNotEdit: 'การเรียกเก็บเงินที่ตรวจสอบแล้วไม่สามารถแก้ไขได้!',
  Cargo_ContainsAgentBilling: 'มีตัวแทนแบ่งการเรียกเก็บเงินโปรดเลือกใบแจ้งยอดอื่น ๆ เพื่อดำเนินการ!',
  Cargo_HasAgentBilling: 'มีตัวแทนแบ่งการเรียกเก็บเงินโปรดเลือกการเรียกเก็บเงินอื่น ๆ เพื่อดำเนินการ!',
  Cargo_ForeignBillStatusError: 'สถานะบิลต่างประเทศไม่ตรงตามข้อกำหนดการพิมพ์',
  Cargo_ExportBillVoucherStatus: 'ส่งออกสถานะใบสำคัญการบิล',
  Cargo_BillGeneratedNoCancel: 'สร้างหมายเลขบิลแล้ว ไม่สามารถยกเลิกการทบทวนได้',
  Cargo_OverseasBillReverseRule1: 'บิลต่างประเทศต้องมีหมายเลขบิลความสามารถพิเศษทำ reversing',
  Cargo_WriteOffStatusReverseRule: 'สถานะชำระแล้วไม่สามารถ reversing ได้',
  Cargo_VoidStatusReverseRule: 'บิลที่มีสถานะยกเลิกแล้วไม่สามารถ reversing ได้',
  Cargo_AlreadyReversedRule: 'บิลที่ reversing แล้วไม่สามารถ reversing ซ้ำได้',
  Cargo_NoBillToReverse: 'ไม่มีบิลที่สามารถทำการ reversing ได้',
  Cargo_ConfirmReverseBills: 'แน่ใจหรือไม่ที่จะ reversing บิลเหล่านี้จำนวน {0} รายการ?',
  Cargo_ReversedBillNoInvoice: 'บิลที่ reversing แล้วไม่สามารถออกใบแจ้งหนี้ซ้ำได้',
  Cargo_BillInvoicedNoReverse: 'ใบแจ้งหนี้ออกใบกำกับภาษีแล้ว ไม่สามารถทำ reversing ได้',
  Cargo_BillPaymentAppliedNoReverse: 'ใบแจ้งหนี้ถูกใช้ในการขอชำระเงินแล้ว ไม่สามารถทำ reversing ได้',
  Cargo_BillStatementMadeNoReverse: 'ใบแจ้งหนี้ถูกใช้ทำใบแจ้งยอดแล้ว ไม่สามารถทำ reversing ได้',
  Cargo_BillWrittenOffNoReverse: 'ใบแจ้งหนี้ถูกตัดบัญชีแล้ว ไม่สามารถทำ reversing ได้',
  Cargo_Config: 'การกำหนดค่า',
  Cargo_OrderTemplateName: 'นำเข้าชื่อเทมเพลตคำสั่งซื้อ',
  Cargo_TemplateTips: 'เคล็ดลับ:',
  Cargo_Blue: 'สีน้ำเงิน',
  Cargo_MusetSelectd: 'รายการที่จำเป็นไม่สามารถลบได้ต้องกำหนดค่าชื่อหัวตารางของเทมเพลตหากแม่แบบไม่มีค่าโปรดกำหนดค่าเริ่มต้นการสั่งซื้อ',
  Cargo_StartLine: 'นำเข้าแถวเริ่มต้น (พร้อมส่วนหัว)',
  Cargo_TemplateDefault: 'เช่น ไม่มีฟิลด์ที่จำเป็นในเทมเพลต ค่าปริยายสำหรับคำสั่งซื้อที่สร้างขึ้นจากการนำเข้าจะถูกเก็บรักษาไว้ที่นี่',
  Cargo_TemplateDefaultValue: 'ค่าแม่แบบ',
  CargoFieldDescription: 'คำอธิบายฟิลด์',
  Cargo_FieldDropdownValue: 'ฟิลด์ ค่ากล่องแบบเลื่อนลง',
  Cargo_ActualFieldName: 'ชื่อฟิลด์ธุรกิจจริง',
  Cargo_TemplateHeaderName: 'ชื่อหัวตารางแม่แบบ',
  Cargo_TemplateImportValue: 'ค่านำเข้าแม่แบบ',
  Cargo_OrderDefaultValue: 'คำสั่งปริยาย',
  Cargo_OrderOperation: 'การดำเนินงาน',
  Cargo_OrderDelete: 'ลบ',
  Cargo_CloseAccountTips1: 'วันที่ปรับปรุงปัจจุบันถูกปิดบัญชีโปรดเลือกอีกครั้ง',
  Cargo_CloseAccountTips2: 'วันที่ทางการเงินปัจจุบันถูกปิด โปรดเลือกอีกครั้ง',
  Cargo_PayableOrderCreationDate: 'วันที่สร้างใบสั่งซื้อเจ้าหนี้',
  Cargo_InvoiceHistoryEmail: 'จดหมายประวัติใบแจ้งหนี้',
  Cargo_SendCc: 'การส่งที่อยู่ CC แบบซิงโครนัส',
  Cargo_DoInvoiceTip: 'สิทธิ์เฉพาะ {0} ไม่สามารถดำเนินการรับตั๋วได้',
  Cargo_DoInvoiceTip2: 'สิทธิ์เฉพาะ {0} ไม่สามารถดำเนินการได้',
  Cargo_CallBackTip: 'ประวัติการทำประกันภัยของ 【ส่งแบบฟอร์มแล้ว】 ไม่สามารถกลับไปยังขั้นตอนก่อนหน้าได้',
  Cargo_CabinSpaceSerialNo: 'เรือเดินสมุทร',
  Cargo_CabinSpaceStatus: 'สถานะห้องโดยสาร',
  Cargo_CabinSpaceNote: 'หมายเหตุห้องโดยสาร',
  Cargo_AllocationStatus: 'สถานะการจัดสรร',
  Cargo_QuantityInconsistency: 'จำนวน S / O หรือ MBL ไม่สอดคล้องกับจำนวนห้องโดยสาร',
  Cargo_VesselCallSign: 'หมายเลขโทรเรือ',
  Cargo_SORecognitionNewAdd: 'ระบุ SO เพิ่ม',
  Cargo_ShutOut2: 'การกู้คืนศุลกากร',
  Cargo_CabinSpaceBackFill: 'ห้องโดยสาร Backfill',
  Cargo_RevokeAllocation: 'ยกเลิกการจัดสรร',
  Cargo_CancelCabinReservation: 'กลับห้องโดยสาร',
  Cargo_AllocateCabinSpace: 'การจัดสรรห้องโดยสาร',
  Cargo_Allocate1: 'การจัดสรร - ธุรกิจที่เกี่ยวข้อง',
  Cargo_Allocate2: 'การจัดสรร - การสร้างธุรกิจ',
  Cargo_SelectBusinessTip: 'โปรดเลือกธุรกิจที่ปรับเปลี่ยนการคัดลอก',
  Cargo_GuidedSellingPrice: 'แนะนำราคาขาย',
  Cargo_CabinCancellationNote: 'หมายเหตุการคืนห้องโดยสาร',
  Cargo_CutOffDate: 'วันที่ตัดตอน',
  Cargo_DeclarationCutOffDate: 'วันที่สิ้นสุดการประกาศ',
  Cargo_CutOffDate2: 'วันที่ปิดรับลูกค้า',
  Cargo_ReturnDateForCustoms: 'วันที่ยกเลิกศุลกากร',
  Cargo_CutOffTime: 'เวลาตัดคำสั่งของลูกค้า',
  Cargo_FreeStorageDays: 'จำนวนวันที่กองฟรี',
  Cargo_TotalPiecesMismatchContinue: 'จำนวนชิ้นรวมไม่ตรงกัน ต้องการดำเนินการต่อหรือไม่?',
  Cargo_BasicData: 'ข้อมูลพื้นฐาน',
  Cargo_CustomerVendorRating: 'การให้คะแนนลูกค้า/ผู้ขาย',
  Cargo_DeliveryOperator: 'ผู้ดำเนินการส่งมอบ',
  Cargo_DeliveryOperationTime: 'เวลาดำเนินการส่งมอบ',
  Cargo_DeliveryOperationMethod: 'วิธีดำเนินการส่งมอบ',
  Cargo_PartnerApprovalRequired: 'พันธมิตรที่เลือกต้องเข้าสู่กระบวนการอนุมัติก่อนจึงจะมีผล และไม่สามารถใช้งานได้ระหว่างรอการอนุมัติ คุณต้องการเริ่มอนุมัติเลยหรือไม่?',
  Cargo_ContractApprovalRequired: 'สัญญาฉบับนี้ต้องเข้าสู่กระบวนการอนุมัติก่อนจึงจะมีผล และไม่อนุญาตให้แก้ไข/ต่ออายุ/จัดการเอกสารระหว่างรออนุมัติ คุณต้องการเริ่มอนุมัติเลยหรือไม่?',
  Cargo_ViewPartnerDetails: 'ดูรายละเอียดพันธมิตร',
  Cargo_PartnerApplicationForm: 'แบบฟอร์มขอเป็นพันธมิตร',
  Cargo_ContractApplicationForm: 'แบบฟอร์มขอทำสัญญา',
  Cargo_PartnerApplicationApprovalProcess: 'กระบวนการสมัครและอนุมัติพันธมิตร',
  Cargo_ContractApplicationApprovalProcess: 'กระบวนการขอและอนุมัติสัญญา',
  Cargo_UnderReview: 'อยู่ระหว่างการตรวจสอบ',
  Cargo_CanSubmitOnlyUnreviewedPartner: 'สามารถส่งได้เฉพาะพันธมิตรที่อยู่ในสถานะ “รอตรวจสอบ” เท่านั้น กรุณาเลือกใหม่แล้วลองอีกครั้ง',
  Cargo_DataUnderReviewCheckRetry: 'มีข้อมูลที่อยู่ระหว่างการพิจารณา กรุณาตรวจสอบแล้วลองใหม่',
  Cargo_ViewContractDetails: 'ดูรายละเอียดสัญญา',
  Cargo_WeightOutOperator: 'ผู้ดำเนินการชั่งออก',
  Cargo_WeightOutOperationTime: 'เวลาดำเนินการชั่งออก',
  Cargo_WeightOutOperationMethod: 'วิธีดำเนินการชั่งออก',
  Cargo_ConfirmBatchOperation: 'ยืนยันการดำเนินการเป็นชุดหรือไม่?',
  Cargo_AutomationConfig: 'การตั้งค่าอัตโนมัติ',
  Cargo_TaskScenario: 'สถานการณ์งาน',
  Cargo_TimingMethod: 'วิธีตั้งเวลา',
  Cargo_LastExecutionTime: 'เวลาดำเนินการล่าสุด',
  Cargo_ExecutionFrequency: 'ความถี่การดำเนินการ',
  Cargo_PerHour: 'ทุกชั่วโมง',
  Cargo_Daily: 'ทุกวัน',
  Cargo_Weekly: 'ทุกสัปดาห์',
  Cargo_Monthly2: 'ทุกเดือน',
  Cargo_VesselEnglishName: 'ชื่อเรือภาษาอังกฤษ',
  Cargo_ActualSailingTime: 'เวลาเรือออกจริง',
  Cargo_EstimatedSailingTime: 'เวลาเรือออกโดยประมาณ',
  Cargo_ShippingCompanyName2: 'ชื่อบริษัทเรือ',
  Cargo_ActualAmount: 'จำนวนเงินจริง (จำนวนเงินสุดท้ายของค่าใช้จ่าย)',
  Cargo_FeeCreationTime: 'เวลาสร้างค่าใช้จ่าย',
  Cargo_StartExecutionTime: 'เวลาเริ่มดำเนินการ',
  Cargo_Every: 'ทุก',
  Cargo_Hour: 'ชั่วโมง',
  Cargo_EffectiveTime: 'เวลามีผลบังคับใช้',
  Cargo_TaskResult: 'ผลลัพธ์ของงาน',
  Cargo_TaskResultReminder: 'แจ้งผลงาน (อีเมลพร้อมไฟล์ Excel)',
  Cargo_ScenarioName: 'ชื่อสถานการณ์',
  Cargo_AutomationTask: 'งานอัตโนมัติ',
  Cargo_SpecifiedWeekday: 'วันที่กำหนด',
  Cargo_SpecifiedDay: 'วันที่ระบุ',
  Cargo_LastDayOfMonth: 'วันสุดท้ายของเดือน',
  Cargo_Day29to31Fallback: 'หากเลือกวันที่ 29, 30 หรือ 31 แล้วเดือนนั้นไม่มีวันดังกล่าว ระบบจะดำเนินการในวันสุดท้ายของเดือนอัตโนมัติ',
  Cargo_ExecuteCommand: 'ดำเนินการคำสั่ง',
  Cargo_AutoInvoicing: 'ออกใบกำกับภาษีอัตโนมัติ',
  Cargo_TaskName: 'ชื่องาน',
  Cargo_MultiLegVoyageManagement: 'การจัดการเดินเรือหลายเส้นทาง',
  Cargo_ScheduleSelection: 'เลือกรอบเรือ',
  Cargo_Leg1: 'ช่วงที่ 1',
  Cargo_Leg2: 'ช่วงที่ 2',
  Cargo_Leg3: 'ช่วงที่ 3',
  Cargo_Leg4: 'ช่วงที่ 4',
  Cargo_Leg5: 'ช่วงที่ 5',
  Cargo_OnlyOneVoucherForCopy: 'เลือกได้เพียงหนึ่งใบสำคัญเพื่อคัดลอกเท่านั้น!',
  Cargo_VoyageInfoCannotBeEmpty: 'ข้อมูลการเดินเรือ {0} ต้องไม่ว่างเปล่า',
  Cargo_AutoExecute: 'ดำเนินการอัตโนมัติ',
  Cargo_TaskNameCannotBeEmpty: 'ชื่องานต้องไม่ว่างเปล่า!',
  Cargo_TaskNameAlreadyExists: 'ชื่องาน "{0}" มีอยู่แล้ว ไม่อนุญาตให้ซ้ำ!',
  Cargo_TaskScenarioAutoExecuteCannotDelete: 'สถานการณ์งานนี้ถูกตั้งค่าให้ดำเนินการอัตโนมัติ ไม่สามารถลบได้!',
  Cargo_EnabledStatusCannotDelete: '{0} สถานะเปิดใช้งานอยู่ กรุณาปิดใช้งานก่อนทำการลบ',
  Cargo_ConfirmDeleteTaskScenario: 'คุณแน่ใจหรือไม่ว่าต้องการลบสถานการณ์งานนี้?',
  Cargo_ScenarioSettings: 'การตั้งค่าสถานการณ์',
  Cargo_TransmissionRule: 'Transmission Rule',
  Cargo_Script: 'Script',
  Cargo_AccountPassword: 'Account & Password',
  Cargo_GetTokenUrl: 'Token Acquisition URL',
  Cargo_InterfaceUrl: 'Interface URL',
  Cargo_TransmissionSample: 'Transmission Format Sample',
  Cargo_RuleSettings: 'การตั้งค่ากฎ',
  Cargo_CommandSettings: 'การตั้งค่าคำสั่ง',
  Cargo_DataScript: 'สคริปต์ข้อมูล',
  Cargo_DataDisplay: 'การแสดงผลข้อมูล',
  Cargo_DeleteFromLastLeg: 'กรุณาลบจากช่วงสุดท้าย',
  Cargo_PreviewData: 'ดูตัวอย่างข้อมูล',
  Cargo_NotificationPersonnel: 'ผู้รับการแจ้งเตือน',
  Cargo_DebugExecute: 'ดีบักการดำเนินการ',
  Cargo_ConditionName: 'ชื่อเงื่อนไข',
  Cargo_SendToExchangeTime: 'เวลาส่งไปยัง Shipping Exchange',
  Cargo_EnterYourRequirement: 'กรุณาระบุความต้องการของคุณ',
  Cargo_ConfigExecuteCommands: 'กำหนดค่าคำสั่งการดำเนินการ (ดำเนินการตามลำดับหมายเลข)',
  Cargo_CommandName: 'ชื่อคำสั่ง',
  Cargo_SelectCommand: 'เลือกคำสั่ง',
  Cargo_ConfirmRuleSettings: 'โปรดยืนยันการตั้งค่ากฎ',
  Cargo_ScenarioDescription: 'คำอธิบายสถานการณ์',
  Cargo_Command: 'คำสั่ง',
  Cargo_ExecutionTime: 'เวลาในการดำเนินการ',
  Cargo_HistoryDetails: 'รายละเอียดประวัติ',
  Cargo_ExecutionScenario: 'สถานการณ์การดำเนินการ',
  Cargo_DataID: 'รหัสข้อมูล',
  Cargo_ExecuteCommandName: 'ชื่อคำสั่งดำเนินการ',
  Cargo_ManualRun: 'ดำเนินการด้วยตนเอง',
  Cargo_AsyncExecutingCheckLogLater: 'กำลังดำเนินการแบบอะซิงโครนัส โปรดตรวจสอบบันทึกการดำเนินการภายหลัง',
  Cargo_ExecutionLog: 'บันทึกการดำเนินการ',
  Cargo_Execute: 'ดำเนินการ',
  Cargo_NoOutboundCommandConfirmPickList: '{0},ยังไม่มีคำสั่งเบิกของออก ยืนยันการสร้างใบหยิบสินค้าหรือไม่?',
  Cargo_CabinSpaceAllocationDate: 'วันที่กำหนดห้องโดยสาร',
  Cargo_AssociatedBusinessNo: 'หมายเลขธุรกิจที่เกี่ยวข้อง',
  Cargo_AssociatedBusinessStatus: 'สถานะธุรกิจที่เกี่ยวข้อง',
  Cargo_FirstTimeSalesAllocation: 'จำหน่ายครั้งแรก',
  Cargo_FirstTimeAllocationEntrustingUnit: 'การจัดสรรหน่วยต้นสังกัดครั้งแรก',
  Cargo_CabinCancellationExplanation: 'กลับห้องโดยสาร Description',
  Cargo_CabinSpaceRecord: 'บันทึกห้องโดยสาร',
  Cargo_VoyageInformation: 'ข้อมูลการเดินทาง',
  Cargo_AssociatedBusinessStatus2: 'ธุรกิจที่เกี่ยวโยงกัน สถานะธุรกิจ',
  Cargo_UploadFileOver50: 'ความเร็วในการอัปโหลดอาจช้าลงเนื่องจากข้อมูลมีขนาดใหญ่เกินไปโปรดตรวจสอบในภายหลัง',
  Cargo_UserSecurityPolicy: 'นโยบายความปลอดภัยผู้ใช้',
  Cargo_RoleGroupManagement: 'การจัดการกลุ่มบทบาท',
  Cargo_RoleGroupName: 'ชื่อกลุ่มบทบาท',
  Cargo_UnmaintainedRoleGroupPermissions: 'สิทธิ์ของกลุ่มบทบาทที่เกี่ยวข้องยังไม่ได้บำรุงรักษา',
  Cargo_RoleGroup: 'กลุ่มบทบาท',
  Cargo_RoleGroupCountLessThanTwo: 'จำนวนกลุ่มบทบาท < 2',
  Cargo_PolicySettings: 'การตั้งค่านโยบาย:',
  Cargo_EnableUserSecurityPolicy: 'เปิดใช้นโยบายความปลอดภัยผู้ใช้',
  Cargo_PasswordLengthRange: 'ช่วงความยาวรหัสผ่าน:',
  Cargo_MaxLengthRange8to20: 'ความยาวสูงสุด 8-20 ตัวอักษร',
  Cargo_CompositionRule: 'กฎการประกอบ:',
  Cargo_RequireNumUpperLower: 'ต้องมีตัวเลข ตัวพิมพ์ใหญ่และพิมพ์เล็ก',
  Cargo_MustIncludeSpecialChars: 'ต้องมีอักขระพิเศษ: !,$,%,&,_,|,-,@,#,*,=',
  Cargo_PasswordHistoryCheck: 'การตรวจซ้ำรหัสผ่าน:',
  Cargo_HistoryLength0to10: 'ตั้งค่า 0-10; 0 ไม่ตรวจ, 3 ห้ามซ้ำ 3 ครั้งล่าสุด',
  Cargo_PasswordErrorLock: 'การล็อกจากรหัสผิด:',
  Cargo_LockLength0to10: 'ตั้งค่า 0-10; 0 ไม่ล็อก, นอกนั้นปิดใช้บัญชี',
  Cargo_AdminApplication: 'การใช้กับผู้ดูแล:',
  Cargo_AdminPwdFollowPolicy: 'รหัสผู้ดูแลต้องเป็นไปตามนโยบายเดียวกัน',
  Cargo_NoRepeatLastNPasswords: 'ห้ามซ้ำกับ {0} รหัสผ่านล่าสุด',
  Cargo_PasswordRulePrompt: 'กรุณาตั้งตามกฎ: ความยาว {0}-{1} ต้องมีตัวเลข ตัวพิมพ์ใหญ่และพิมพ์เล็ก',
  Cargo_Allocated: 'ได้รับมอบหมาย',
  Cargo_NotAllocated: 'ยังไม่ได้รับมอบหมาย',
  Cargo_PriceAuditEventFclTitle: 'การแจ้งเตือนการปรับปรุงการตรวจสอบค่าจัดส่ง',
  Cargo_FillSO: 'เติม S / O',
  Cargo_FillMBL: 'เติม MBL',
  Cargo_FillALL: 'เติมทั้ง MBL และ S / O',
  Cargo_CustomsReturnAndRecovery: 'การกู้คืนห้องโดยสารจากธุรกิจการขนถ่ายศุลกากร',
  Cargo_CheckDTip: 'MBL NO. หรือ SO NO. มีอยู่แล้ว,ยืนยันต้องการสร้างต่อ?',
  Cargo_BatchUpdateTitle1: 'การปรับเปลี่ยนแบทช์ - การเติมห้องโดยสาร',
  Cargo_WindowTip1: '* อัปเดตข้อมูลหมายเลขใบนำส่งสินค้าเป็นชุด',
  Cargo_WindowTip2: '** ในกรณีที่มีความแตกต่างของปริมาณกล่องประเภทกล่องในการสั่งซื้อแบบ Lot Tick โปรดกรอกข้อมูลในช่องเก็บของ',
  Cargo_CheckDTip2: 'ไม่สามารถดำเนินการได้ในสถานะ "ยกเลิกเที่ยวบิน" หรือ "มอบหมาย"',
  Cargo_CheckDTip3: 'โปรดเลือกห้องโดยสารประเภทกล่องที่มีปริมาณกล่องสม่ำเสมอสำหรับการดำเนินการ',
  Cargo_NoItems_NoAudit: 'ไม่มี{0} ไม่จำเป็นต้องตรวจสอบ',
  Cargo_Audited_NoNeedAudit: 'ตรวจสอบแล้ว ไม่ต้องตรวจสอบซ้ำ',
  Cargo_AvailableCabinSpace: 'หปป.',
  Cargo_QueryTip: 'ดึงข้อมูลอย่างรวดเร็ว: Cabin Flow',
  Cargo_PriceUpdateUser: 'แก้ไขอัตราค่าจัดส่ง',
  Cargo_BookingPreAudit: 'จองที่นั่งล่วงหน้า',
  Cargo_UniversalIntelligentRecognition: 'การระบุอัจฉริยะทั่วไป',
  Cargo_PromptWords: 'คำใบ้',
  Cargo_PleaseUploadFile: 'กรุณาอัพโหลดไฟล์',
  Cargo_BatchImportAr1: 'การนำเข้าแบทช์การเก็บรวบรวมการขาย',
  Cargo_BatchImportAp1: 'นำเข้าจำนวนมาก การชำระเงิน บัญชีการขาย',
  Cargo_BatchImportAr2: 'ดาวน์โหลดเทมเพลตนำเข้าเก็บเงิน',
  Cargo_BatchImportAp2: 'ดาวน์โหลดแม่แบบนำเข้าการชำระเงิน',
  Cargo_ImportingDataSuccess1: 'เพศสัมพันธ์นี้เป็นการดำเนินการแบบอะซิงโครนัสคุณสามารถทำได้ที่',
  Cargo_ImportingDataSuccess2: 'การจัดเก็บไฟล์ -> อัปโหลดบันทึก',
  Cargo_ImportingDataSuccess3: 'ดูผลการนำเข้า',
  Cargo_RecordsWrittenOff: 'ได้ทำการตัดชำระ记录แล้ว {0} รายการ',
  Cargo_lockLabel1: 'ล็อคราคาซื้อ',
  Cargo_lockLabel2: 'ล็อคราคาขาย',
  Cargo_lockLabel3: 'ปลดล็อกราคาซื้อ',
  Cargo_lockLabel4: 'ปลดล็อกราคาขาย',
  Cargo_UnLockLabel: 'ปลดล็อค',
  Cargo_LockLabel: 'ล็อค',
  Cargo_LockSuccess: '{0} {1} สำเร็จ',
  Cargo_DisplayByBillOfLading: 'แสดงตาม B / L',
  Cargo_DisplayByDateAndVoyageNo: 'แสดงตามวันที่เดินทาง',
  Cargo_ShowSeaExportJob: 'รวมดูข้อมูลการจองห้องพักนอกชายฝั่ง',
  Cargo_OperatingSpaceOnly: 'ห้องโดยสารที่ใช้งานได้เท่านั้นคำสั่งที่ไม่สามารถใช้งานได้',
  Cargo_IsCabinSpace: 'ใช้ห้องโดยสารที่มีอยู่หรือไม่',
  Cargo_CheckBoxTip: 'ประเภทกล่อง ปริมาณกล่องไม่สอดคล้องกับห้องโดยสารโปรดตรวจสอบ',
  Cargo_CheckBoxTip2: 'ชื่อเรือ, เส้นทาง, บริษัท เรือ, ETD สำหรับการสั่งซื้อไม่สอดคล้องกับห้องโดยสารโปรดยืนยันว่าจะดำเนินการต่อไปหรือไม่?',
  Cargo_CheckBoxTip3: 'ธุรกิจที่เกี่ยวโยงกันอยู่แล้ว MBL NO หรือ SO NO ไม่สามารถเกี่ยวโยงกันได้',
  Cargo_AllocationSuccess: 'จัดสรรสำเร็จ!',
  Cargo_AllocationCancel: 'ยืนยันจะถอนการจัดสรรหรือไม่',
  Cargo_CabinReturn: 'ออกจากห้องโดยสารพร้อมกัน',
  Cargo_CabinReturnTip: 'กรุณากรอกข้อมูลการเดินทางกลับ',
  Cargo_CancelCabinTip1: 'เพิกถอนเสร็จสมบูรณ์',
  Cargo_CancelCabinTip2: 'การคืนยานเสร็จสิ้น',
  Cargo_CancelCabinTip3: 'ธุรกิจที่เกี่ยวข้องในชั้นโดยสารโปรดยกเลิกก่อน',
  Cargo_CancelCabinTip4: 'ธุรกิจที่เกี่ยวข้องกับห้องโดยสารยังอยู่ในระหว่างการจองล่วงหน้าสำหรับการยกเลิกการจัดสรรโปรดปฏิเสธในระหว่างการจองล่วงหน้า',
  Cargo_CancelCabinTip5: 'ธุรกิจที่เกี่ยวข้องกับห้องโดยสารยังไม่ได้รับการยกเลิกโปรดยกเลิกก่อน',
  Cargo_CancelCabinTip6: 'มีห้องโดยสารที่ไม่ได้รับการจัดสรรโปรดตรวจสอบ',
  Cargo_BusinessProcessStage: 'ขั้นตอนการหมุนเวียนธุรกิจ',
  Cargo_PleaseSelectDataAndUpload: 'กรุณาอัพโหลดไฟล์เป็นกลุ่มหลังจากติ๊กข้อมูล',
  Cargo_PleaseSelectDataAndUpload2: 'กรุณาอัปโหลดไฟล์เป็นกลุ่มหลังจากเลือกประเภทธุรกิจเดียวกัน',
  Cargo_BatchUploadFile: 'อัปโหลดไฟล์เป็นกลุ่ม',
  Cargo_BatchUploadFile2: 'การอัพโหลดล้มเหลว ไม่รองรับรูปแบบนี้',
  Cargo_Allocate3: 'การจัดสรร - การสร้างธุรกิจ',
  Cargo_CabinCreate1: 'สร้างไปยัง Booking Cabin Pre-Trial',
  Cargo_CabinCreate2: 'สร้างไปยังการจัดส่งสินค้าทางทะเล',
  Cargo_CabinCreate3: 'สร้างหมายเลขธุรกิจ:',
  Cargo_CloseAndCopyNumber: 'ปิดและคัดลอกหมายเลขเดี่ยว',
  Cargo_AllocateCheck1: 'มีข้อมูลที่ได้รับมอบหมายให้ตรวจสอบ',
  Cargo_AllocateCheck2: 'มีข้อมูลที่ไม่วางจำหน่ายโปรดตรวจสอบ',
  Cargo_OnlyReturnTheCabin: 'สามารถลบข้อมูลสถานะการคืนยานได้เท่านั้น',
  Cargo_CabinManagement: 'การจัดการห้องโดยสาร',
  Cargo_TheRedFontFieldWillOverwriteTheSeaExportWithTheValueOfTheSpaceManagement: 'เขตข้อมูลแบบอักษรสีแดงจะครอบคลุมการส่งออกทางทะเลที่มีค่าของการจัดการห้องโดยสาร',
  Cargo_OriginalValueOfTheSeaExportAndWillNotBeOverwritten: 'ฟิลด์แบบอักษรสีฟ้าจะยังคงมูลค่าการส่งออกทางทะเลเดิมและจะไม่ถูกเขียนทับ',
  Cargo_ImportedMultipleBusiness: 'มีการนำเข้าธุรกิจจับคู่ตั๋วหลายใบ',
  Cargo_UploadedRepeatedly: 'อัปโหลดซ้ำ',
  Cargo_BoxType2: 'ประเภทกล่องที่สอดคล้องกัน ประเภทกล่อง',
  Cargo_BoxTypeAndCategory: 'ประเภทกล่อง ประเภทกล่อง',
  Cargo_CheckBoxSize: 'กรุณากรอกแบบฟอร์มกล่อง',
  Cargo_UsedQuota: 'วงเงินที่ใช้แล้ว (ป้องกันความเสี่ยง)',
  Cargo_PleaseSelectTheConsignee: 'กรุณาเลือกผู้รับ',
  Cargo_ViewingMessage: 'ดูกระดาษต้นฉบับ',
  Cargo_ChangeSettlement: 'แก้ไขวัตถุของการตั้งถิ่นฐาน',
  Cargo_CanNotEditTips: 'รวมค่าธรรมเนียมที่ไม่สามารถแก้ไขได้โปรดตรวจสอบ!',
  Cargo_PleaseSelectExpenseToModify: 'โปรดเลือกค่าใช้จ่ายที่ต้องการแก้ไข',
  Cargo_ArChargeSettlementCannotModify: 'ไม่สามารถแก้ไขวัตถุชำระเงินของค่าใช้จ่ายลูกหนี้ได้',
  Cargo_ChargeSettledCannotModify: 'ค่าใช้จ่ายได้สร้างใบแจ้งหนี้/ออกใบแจ้งหนี้/ขอชำระ/ตัดบัญชีแล้ว ไม่สามารถแก้ไขได้',
  Cargo_ArChargeSettlementCannotModifyDetail: 'ค่าใช้จ่าย {0} เป็นค่าใช้จ่ายลูกหนี้ ไม่สามารถแก้ไขวัตถุชำระเงินได้',
  Cargo_ChargeSettledCannotModifyDetail: 'ค่าใช้จ่าย {0} ได้สร้างใบแจ้งหนี้/ออกใบแจ้งหนี้/ขอชำระ/ตัดบัญชีแล้ว ไม่สามารถแก้ไขได้',
  Cargo_CanNotEditChargeDetail: 'ค่าใช้จ่าย {0} ไม่มีสิทธิ์แก้ไข ไม่สามารถแก้ไขได้',
  Cargo_CheckChargeDetailBranchDetail: 'ค่าใช้จ่าย {0} อยู่ในสาขาที่ไม่สามารถดำเนินการได้',
  Cargo_BeforeAdjustment: 'ก่อนปรับ',
  Cargo_AfterAdjustment: 'หลังปรับ',
  Cargo_EstimateListQuery: 'แบบฟอร์มสอบถาม',
  Cargo_MappingConfiguration: 'การกำหนดค่าแผนที่',
  Cargo_CreateEstimate: 'สร้างใบประเมินค่าชั่วคราว',
  Cargo_SendSharingCenter: 'ส่งศูนย์แบ่งปัน',
  Cargo_GenerateExpenseAmount: 'สร้างยอดค่าธรรมเนียม',
  Cargo_GenerateExpenseMode: 'สร้างรูปแบบค่าธรรมเนียม',
  Cargo_GenerateInReceivables: 'สร้างในลูกหนี้',
  Cargo_GenerateInPay: 'สร้างในการรับมือ',
  Cargo_GenerateAll: 'สร้างในลูกหนี้ตามลำดับ',
  Cargo_ChargeAmount: 'กรุณากรอกจำนวนเงินที่สร้างค่าธรรมเนียม',
  Cargo_PushDate: 'วันที่ผลักดัน',
  Cargo_GetSendResult: 'รับผลลัพธ์ที่ส่ง',
  Cargo_ALittleSend: 'ผลักดันเป็นลูกค้าประปราย',
  Cargo_MappingEditor: 'แก้ไขแผนที่',
  Cargo_NewMapping: 'แผนที่ใหม่',
  Cargo_Recipient: 'ส่งวัตถุ',
  Cargo_DataRepetition: 'มีข้อมูลที่ซ้ำกัน',
  Cargo_checkTip2: '{0} หรือ {1}',
  Cargo_ErrorExcel: 'แม่แบบผิดพลาด',
  Cargo_ImportException: 'ข้อยกเว้นในการนำเข้า',
  Cargo_SelectiveFinanceMonth: 'เลือกเดือนทางการเงิน',
  Cargo_FinancialMonth: 'เดือนทางการเงิน',
  Cargo_PushLog: 'บันทึกการผลักดัน',
  Cargo_ConfirmImport: 'นำเข้าหรือไม่',
  Cargo_SETitle: 'กำหนดเวลาเดินเรือ / เวลาโดยประมาณ',
  Cargo_CurentSETitle: 'กำหนดเวลาปัจจุบันของท่าเรือ (Current ETD) / กำหนดเวลาปัจจุบันของท่าเรือ (Current ETD)',
  Cargo_OriginalSETitle: 'ตารางเวลาเดิมออกเดินทาง (Original ETD) / ตารางเวลาเดิมถึงท่าเรือ (Original ETD)',
  Cargo_AETitle: 'เวลาออกเดินทางโดยประมาณ / เวลามาถึงโดยประมาณ',
  Cargo_SEAtdAtaTitle: 'เวลาออกเรือจริง (ATD) / เวลามาถึงจริง (ATA)',
  Cargo_AEAtdAtaTitle: 'เวลาออกเดินทางจริง (ATD) / เวลามาถึงจริง (ATA)',
  Cargo_UpdateAtdAtaDateTip: 'กรุณาระบุเวลาออกเรือจริง, เวลามาถึงจริงที่ต้องแก้ไข',
  Cargo_UpdateAtdAtaDateTip2: 'กรุณาระบุเวลาออกเดินทางจริง, เวลามาถึงจริงที่ต้องแก้ไข',
  Cargo_UpdateDateTip: 'กรุณาระบุเวลาออกเดินทางตามกำหนดการ เวลาโดยประมาณที่จะมาถึง',
  Cargo_UpdateDateTip2: 'กรุณาระบุเวลาออกเดินทางโดยประมาณ, เวลามาถึงโดยประมาณที่ต้องแก้ไข',
  Cargo_BusinessNotPositiveOperation: '{0} ไม่ใช่สถานะการทำงานเชิงบวกและไม่สามารถแก้ไขเวลาได้',
  Cargo_SuccessTip: 'สำเร็จ {0} รายการ, ล้มเหลว 0 รายการ',
  Cargo_SuccessTip1: 'สำเร็จ {0} รายการ, ล้มเหลว {1} รายการ, < br /> บันทึกความล้มเหลว: < br /> {2} ไม่ใช่สถานะการทำงานเชิงบวกและไม่สามารถแก้ไขเวลาได้',
  Cargo_SuccessTip2: 'สำเร็จ {0} รายการ, ล้มเหลว {1} รายการ.<br/>คำอธิบายความล้มเหลว: <br/> {2} ไม่อยู่ในสถานะที่สามารถดำเนินการได้ ไม่สามารถแก้ไขได้ <br/> {3} เลือกเพียงใบตราส่งย่อยโดยไม่ได้เลือกข้อมูลใบตราส่งหลัก ไม่สามารถแก้ไขได้',
  Cargo_ErrorCause: 'สาเหตุของความผิดปกติ',
  Cargo_PushMessage: 'กดข้อความ',
  Cargo_PushMessageRsp: 'รับข้อความ',
  Cargo_ViewMessage: 'ดูกระดาษ',
  Cargo_Message: 'เอกสารเผยแพร่',
  Cargo_BusinessApplicationContext: 'การประยุกต์ใช้สถานการณ์ทางธุรกิจ',
  Cargo_ConfigureEmailTemplate: 'ปรับแต่งแม่แบบจดหมาย',
  Cargo_SendingPosition: 'ส่งโพสต์',
  Cargo_DeleteEmailTip: 'คุณยืนยันการลบเทมเพลตจดหมายที่ถูกเลือกหรือไม่?',
  Cargo_UpdateEmailTip: 'ชื่อลายฉลุจดหมายต้องไม่ว่างเปล่า!',
  Cargo_UpdateEmailTip2: 'การเชื่อมโยงการผลักดัน: {0} วัตถุที่ส่ง: {1} มีการตั้งค่าที่เกี่ยวข้องแล้วอย่าทำซ้ำ!',
  Cargo_UpdateEmailTip3: 'ชื่อแม่แบบ 【{0}】 มีอยู่แล้วและชื่อแม่แบบจดหมายไม่สามารถทำซ้ำได้!',
  Cargo_EmailTemplate: 'จดหมายลายฉลุ',
  Cargo_OrganizeClearing: 'องค์กรการตั้งถิ่นฐาน',
  Cargo_DocumentCode: 'หมายเลขเอกสาร',
  Cargo_BillDate2: 'วันที่เอกสาร',
  Cargo_EndDate2: 'วันหมดอายุ',
  Cargo_doTip: 'การประมวลผลแบบอะซิงโครนัสอยู่ในพื้นหลัง โปรดสอบถามอีกครั้งในภายหลัง!',
  Cargo_TypeOfExchange: 'ประเภทการไปมาหาสู่',
  Cargo_CurrentAccountCode: 'การเข้าถึงรหัสบ้าน',
  Cargo_PE: 'ประมาณการชั่วคราว / ประมาณการ',
  Cargo_ENo: 'หมายเลขโดยประมาณ',
  Cargo_OrderChannel: 'ช่องทางการสั่งซื้อที่เกี่ยวข้อง',
  Cargo_MonthlyFinancial: 'เดือนทางการเงิน',
  Cargo_DocumentId: 'รหัสเอกสารระบบธุรกิจ',
  Cargo_SourceSystemCoding: 'การเข้ารหัสระบบแหล่งที่มา',
  Cargo_businessShipAgency: 'ประเภทธุรกิจ (จัดส่ง)',
  Cargo_CoinsReceivable: 'รับเหรียญ',
  Cargo_ArApAmount: 'จำนวนลูกหนี้/เจ้าหนี้',
  Cargo_CostItem: 'รายการค่าใช้จ่าย การเข้ารหัส',
  Cargo_TaxNumber: 'หมายเลขภาษี',
  Cargo_IsDefaultTitle: 'เป็นชื่อเริ่มต้นหรือไม่',
  Cargo_SingleTitleMode: 'โหมดชื่อเดียว',
  Cargo_MultipleTitleMode: 'โหมดหลายชื่อ',
  Cargo_UnitPrice2: 'ราคาต่อหน่วยรวมภาษี',
  Cargo_TaxRateCode: 'อัตราภาษี การเข้ารหัส',
  Cargo_Discount: 'วิธีส่วนลด',
  Cargo_CanNotChargeTips: 'มีค่าธรรมเนียมที่ไม่สามารถแก้ไขได้แล้วโปรดดำเนินการในเวลา!',
  Cargo_RefreshChargeTips: 'มีค่าใช้จ่ายอยู่แล้ว จะรีเฟรชค่าธรรมเนียมหรือไม่',
  Cargo_ArAmount: 'จำนวนลูกหนี้',
  Cargo_MonthCode: 'การเข้ารหัสเดือน',
  Cargo_BeforeChange1: 'กำไรโดยประมาณก่อนการเปลี่ยนแปลงตั๋วทั้งหมด',
  Cargo_BeforeChange2: 'กำไรโดยประมาณของตั๋วทั้งหมดหลังจากการเปลี่ยนแปลง',
  Cargo_TaxPolicyCoding: 'รหัสนโยบายภาษี',
  Cargo_SendingSharingCenter: 'ส่งศูนย์แบ่งปัน',
  Cargo_SendingResult: 'ผลักดันสำเร็จ: {0} แถบล้มเหลว: {1} แถบ',
  Cargo_System2: 'ระบบ',
  Cargo_FileDelete: 'การลบไฟล์: ลบ',
  Cargo_BillsPayable: 'แบบฟอร์มการชำระเงิน',
  Cargo_PaymentSlipDataNo: 'หมายเลขสลิปการชำระเงิน',
  Cargo_Payer: 'วัตถุการชำระเงิน',
  Cargo_Prepaid: 'ชำระเงินล่วงหน้า',
  Cargo_TypeOfInvoice: 'ประเภทของใบแจ้งหนี้',
  Cargo_UploadInvoiceCloudStatus: 'อัพโหลดสถานะคลาวด์ใบแจ้งหนี้',
  Cargo_AccountToBeCredited: 'บัญชีรับเงิน',
  Cargo_BankConnectionNo: 'รหัสธนาคาร / SWIFT CODE',
  Cargo_BankConnectionNo2: 'หมายเลขติดต่อ / SWIFT',
  Cargo_OriginalPaymentSlipNo: 'หมายเลขสลิปการชำระเงินเดิม',
  Cargo_ProcessNumber: 'หมายเลขกระบวนการ',
  Cargo_FinancialPayStatus: 'สถานะเจ้าหนี้ทางการเงิน',
  Cargo_PaymentRequisitionStatus: 'สถานะใบคำขอชำระเงิน',
  Cargo_DefaultDetailItems: 'รายละเอียด รายการเริ่มต้น',
  Cargo_GeneratePay: 'สร้างใบสั่งจ่าย',
  Cargo_MergeGeneratePay: 'รวมบัญชีเจ้าหนี้',
  Cargo_PrintChannel: 'ช่องทางการพิมพ์',
  Cargo_BookingConfirmed: 'จองแล้ว',
  Cargo_OrderRecorded: 'บันทึกรายการ',
  Cargo_CreateBillsPayable: 'สร้างใบสั่งจ่าย',
  Cargo_FinancialPayAreSent: 'ส่งเจ้าหนี้ทางการเงิน',
  Cargo_PaymentRequestSent: 'ส่งใบสมัครการชำระเงิน',
  Cargo_DetailEntryID: 'รหัสรายการรายละเอียด',
  Cargo_PayableSingleAttribute: 'รายการทรัพย์สิน',
  Cargo_SelectAp2: 'กรุณาเลือก ใบแจ้งหนี้ขึ้น ใบคำขอชำระเงิน',
  Cargo_SelectAp: 'กรุณาเลือกแบบฟอร์มการชำระเงิน',
  Cargo_LookAp: 'ดูสลิปการจ่ายเงิน',
  Cargo_IdentifyTheCustomsTips: 'มีแฟ้มที่อยู่ระหว่างการวิเคราะห์หรือได้รับการวิเคราะห์แล้ว',
  Cargo_IdentifyTheCustomsDeclaration: 'ระบุประกาศศุลกากร',
  Cargo_RefreshCustomsDeclaration: 'รีเฟรชประกาศศุลกากร',
  Cargo_ContactMultiple: 'สัญญาเดียวมีข้อตกลงสัญญาที่หลากหลาย',
  Cargo_CustomsActivatedTip: 'ไม่ได้เปิดฟังก์ชั่นบริการประกาศศุลกากรระบุ',
  Cargo_CustomsActivatedTip2: 'ยอดคงเหลือไม่เพียงพอโปรดติดต่อฝ่ายบริการลูกค้าเพื่อเติมเงิน',
  Cargo_CustomsDeclarationNo: 'หมายเลขใบประกาศศุลกากร',
  Cargo_AnalysisStatus: 'สถานะการวิเคราะห์',
  Cargo_SystemFee: 'ค่าธรรมเนียมระบบ',
  Cargo_InsurancePremium: 'ค่าธรรมเนียมการรักษาความปลอดภัย',
  Cargo_ProcessingFee: 'ค่าดำเนินการ',
  Cargo_FOBValue: 'มูลค่าสินค้า FOB',
  Cargo_ExportCustomsDeclaration: 'ส่งออกใบศุลกากร',
  Cargo_Nonstop: 'ดูเฉพาะเที่ยวบินตรง',
  Cargo_InternationalRoute: 'ดูเฉพาะสายต่างประเทศ',
  Cargo_SelectNoDeleteAp: '【แบบฟอร์มการชำระเงิน】 ผลักดัน, ไม่สามารถลบได้',
  Cargo_SelectInvoiceAR: 'โปรดเลือกใบแจ้งหนี้ที่ได้รับ',
  Cargo_SelectInvoiceAR2: 'โปรดเลือกข้อมูลที่ได้รับการผลักดันเพื่อดำเนินการขอรับสถานะ',
  Cargo_SelectNoPushData: 'โปรดเลือกข้อมูลที่ไม่ได้ผลักดัน',
  Cargo_SelectNoDelete: '【แบบฟอร์มการประเมินค่าชั่วคราว】 ผลักดัน, ไม่สามารถลบได้',
  Cargo_SendSharedCenter: 'ส่งสถานะศูนย์แบ่งปัน',
  Cargo_SelectInvoiceType: 'กรุณาเลือกประเภทใบแจ้งหนี้',
  Cargo_EditAp: 'แก้ไขสลิปเจ้าหนี้',
  Cargo_NotPushAP: 'กรณีการเรียกเก็บเงินโดยไม่ต้องกด 【บัญชีเจ้าหนี้ทางการเงิน】',
  Cargo_NotPushAP2: 'หมายเลขติดต่อ / SWIFT ว่างเปล่าและไม่สามารถส่งได้',
  Cargo_AttachmentName: 'ชื่ออุปกรณ์เสริม',
  Cargo_AccessoriesAddress: 'ที่อยู่แนบ',
  Cargo_canNotEdit: 'ได้รับการผลักดันและไม่สามารถแก้ไขได้',
  Cargo_GetTheWriteOffResult: 'รับผลการตัดบัญชี',
  Cargo_RemarkTip1: 'หมายเหตุ ใบแจ้งหนี้ จำนวนคำรวมมากกว่า 230 ตัวอักษร',
  Cargo_RemarkTip2: 'สถานการณ์การเปิดตั๋ว "การออกใบแจ้งหนี้ที่ไม่ใช่รายละเอียด" จะต้องเพิ่มใบแจ้งหนี้กรอกชื่อรายการ',
  Cargo_PortOfTransferCheck: 'โปรดเลือก "ท่าเรือขนส่ง"',
  Cargo_BatchServiceLocking: 'ล็อคธุรกิจจำนวนมาก',
  Cargo_UnlockServicesInBatches: 'กลุ่มธุรกิจ Unlocked',
  Cargo_SetAMarginAlert2: 'ตั้งค่าการแจ้งเตือน',
  Cargo_SetAMarginAlert: 'ตั้งค่าการแจ้งเตือนค่าเผื่อ',
  Cargo_ApplicableBranch: 'สาขาที่เกี่ยวข้อง',
  Cargo_AdditionalRemark: 'คำแนะนำเพิ่มเติม',
  Cargo_FixedLastNumber: 'หมายเลขหาง คงที่ 00',
  Cargo_GenerativeRule: 'สร้างกฎ',
  Cargo_StartNumber: 'หมายเลขเริ่มต้น',
  Cargo_EndNumber: 'สิ้นสุดหมายเลขเดียว',
  Cargo_MarginTip1: 'การแจ้งเตือนค่าเผื่อหมายเลข บริษัท ไม่เพียงพอ',
  Cargo_MarginTip2: 'เตือนผู้รับเบี้ยเลี้ยงไม่เพียงพอ',
  Cargo_MarginTip3: 'สำหรับการเตือนโปรดป้อนค่าเผื่อหมายเลขเดียวไม่เพียงพอในแถบที่สอดคล้องกัน',
  Cargo_useTip: 'หมายเลขเดี่ยวจะต้องยังไม่ได้ใช้งาน',
  Cargo_useTip2: 'หมายเลขเดียวที่เป็นโมฆะไม่สามารถกำหนดได้',
  Cargo_DeleteTip: 'ลบเฉพาะหมายเลขเดียวที่เป็นโมฆะ',
  Cargo_PrefixTip: 'คำนำหน้าหมายเลขหลักเดี่ยวไม่ถูกต้อง',
  Cargo_StarTip: 'เริ่มต้นหมายเลขเดียวสิ้นสุดหมายเลขเดียวไม่เป็นไปตามกฎ',
  Cargo_StarNoTip: 'หมายเลขเริ่มต้นผิดปกติ',
  Cargo_MarginTip4: 'กรุณากรอกชื่อผู้ขอรับสิทธิ์',
  Cargo_NumberErrTip: '* ตัวเลขหลักเดียวไม่เพียงพอ',
  Cargo_NumberErrTip2: 'หมายเลขเดียวไม่สอดคล้องกับกฎการสร้าง',
  Cargo_AlreadyExistTip: 'การนำเข้าล้มเหลวและหมายเลขเดียวที่นำเข้ามีอยู่แล้ว << br/>{0}',
  Cargo_ImportStarTip: 'การนำเข้าล้มเหลวและคำนำหน้าหมายเลขเดียวที่นำเข้าไม่ถูกต้อง << br/>{0}',
  Cargo_ImportNoTip: 'การนำเข้าล้มเหลว, การนำเข้าผิดปกติหมายเลขเดียว << br/>{0}',
  Cargo_EmptyNoTip: 'ไฟล์ Excel นำเข้าไม่มีหมายเลข MBL',
  Cargo_CarrierCheck: 'กรุณากรอกข้อมูลบริษัทเรือก่อน',
  Cargo_NumberMarginUse: 'ค่าเผื่อหมายเลขผู้ใช้ปัจจุบันน้อยกว่า {0}',
  Cargo_NumberMarginCompany: 'ค่าเผื่อหมายเลข บริษัท ปัจจุบันน้อยกว่า {0}',
  Cargo_receiveTip: 'หมายเลขเดี่ยวที่คุณป้อนได้ถูกนำมาใช้แล้วโปรดยืนยันว่าจะดำเนินการต่อหรือไม่',
  Cargo_receiveTip2: 'หมายเลขหลักไม่สอดคล้องกับข้อมูลที่ดูแลรักษาโดย "การจัดการหมายเลขหลัก" คุณแน่ใจหรือไม่ว่าคุณต้องการใช้หมายเลขนี้ต่อไป?',
  Cargo_EstimatedDeliveryDate: 'เวลาการจัดส่งโดยประมาณ',
  Cargo_CheckWarehouseInConfig: 'กรุณาเลือกคลังสินค้า',
  Cargo_SelectScales: 'กรุณาเลือก Weighbridge',
  Cargo_PleaseEnterPieceCount: 'โปรดป้อนจำนวนชิ้น',
  Cargo_PleaseConfirm: 'กรุณายืนยันหมายเลขการไหลเข้าของไซโล / หมายเลขหมายเลขการส่งของไซโล',
  Cargo_WarehouseInState: 'สถานะคลังสินค้าธุรกิจ',
  Cargo_LocationConfigurationError: 'พาเลทไม่สามารถทำซ้ำได้หรือถูกครอบครองอยู่แล้วโปรดตรวจสอบ',
  Cargo_KeyNull: 'appKey ไม่ได้กำหนดค่า',
  Cargo_TokenNull: 'โทเคน Get Empty',
  Cargo_CameraNull: 'การกำหนดค่ากล้องผิดพลาด',
  Cargo_Reading: 'การอ่าน',
  Cargo_ReadingTip: 'หลายขนาดใช้เครื่องหมายจุลภาค \',\'หรือ อัฒภาค \';\'แบ่งรูปแบบ \n: L * W * H / PCS; L × W × H / ชิ้นจำนวน \n ตัวอย่างเช่น: 35 * 40 * 30 / 3; 35×40×30/3;',
  Cargo_ReadingTip2: 'โปรดระบุการกำหนดค่าเครื่องชั่งน้ำหนักในคลังสินค้า',
  Cargo_CargoTerminalGrossWeight: 'น้ำหนักสุทธิของสถานีขนส่ง (กก.)',
  Cargo_FileUpload: 'อัปโหลดไฟล์',
  Cargo_inputMblTip: 'กรุณาสแกน / ป้อนหมายเลขเดี่ยว',
  Cargo_OutboundWeight2: 'การทำงานหนักออก',
  Cargo_FileInfo: 'ข้อมูลอุปกรณ์เสริม',
  Cargo_DeliveryOperation: 'การดำเนินการจัดส่ง',
  Cargo_MasterAirwayBill: 'หมายเลขใบนำส่งหลัก',
  Cargo_DeliveryCargoStation: 'สถานีขนส่งสินค้า',
  Cargo_SplitOrderNumber: 'เอกพจน์ย่อย',
  Cargo_TotalPieces: 'จำนวนชิ้นทั้งหมด',
  Cargo_TotalGrossWeight: 'น้ำหนักรวม',
  Cargo_TotalChargeableWeight: 'น้ำหนักรวม',
  Cargo_TotalVolume: 'ปริมาณรวม',
  Cargo_PrintCheck1: 'ช่วงการพิมพ์หรือจำนวนสำเนาไม่ถูกต้องโปรดตรวจสอบ',
  Cargo_PrintRange: 'ช่วงการพิมพ์',
  Cargo_PrintNumber: 'จำนวนสำเนาที่พิมพ์',
  Cargo_GrossWeight3: 'น้ำหนักตัวนับ',
  Cargo_DimensionsEntry: 'ขนาดรายการ',
  Cargo_WarehouseTip3: 'ยกเลิกคำสั่งออกจากตำแหน่งเสร็จสมบูรณ์',
  Cargo_WarehouseTip2: 'คำสั่งออกจากตำแหน่งเสร็จสมบูรณ์',
  Cargo_WarehouseTip1: 'จัดส่งไม่เสร็จโปรดตรวจสอบ',
  Cargo_CancelOutboundOrder: 'ยกเลิกคำสั่งออกจากตำแหน่ง',
  Cargo_OutboundOrder: 'คำสั่งออกจากตำแหน่ง',
  Cargo_GoodsArrived: 'สินค้ามาถึงแล้ว',
  Cargo_Pallet3: 'โท',
  Cargo_WeightedInfo: 'ข้อมูลปอนด์อยู่แล้ว',
  Cargo_ScaleReading: 'การอ่าน Weighbridge',
  Cargo_ScalePhoto: 'Weighbridge สำหรับการถ่ายภาพ',
  Cargo_Tip: 'เคล็ดลับ: สนับสนุนหมายเลขการไหลของไซโล / หมายเลขป้อนไซโล',
  Cargo_ReadScale: 'อ่านปอนด์',
  Cargo_TakePhoto: 'ถ่ายภาพ',
  Cargo_Weighing: 'ปอนด์น้ำหนัก',
  Cargo_WeightRecord: 'ปอนด์สถิติน้ำหนัก',
  Cargo_WeightHandling: 'ปอนด์ น้ำหนัก การรักษา',
  Cargo_SaveDone: 'บันทึกสถานะการรวมเสร็จสมบูรณ์',
  Cargo_DeliverySecurityCheck: 'การจัดส่ง',
  Cargo_OutboundWeight: 'น้ำหนักออก',
  Cargo_NetGrossWeight: 'น้ำหนักสุทธิ',
  Cargo_VolumeWeight: 'น้ำหนักปริมาณ',
  Cargo_BatchEnterDimensions: 'ขนาดรายการแบทช์',
  Cargo_CoveringSizeAndQuantity: 'หมายเหตุ: จะเขียนทับข้อมูลขนาดและจำนวนที่มีอยู่ทั้งหมด',
  Cargo_Recognition: 'บัตรประจำตัว',
  Cargo_EstimatedDeliveryDateError: 'ระบุข้อผิดพลาด',
  Cargo_ScaleWeight: 'น้ำหนัก Weighbridge',
  Cargo_OurPallet: 'เราใส่ถาด',
  Cargo_TareWeight: 'น้ำหนัก Tare',
  Cargo_GrossWeight2: 'น้ำหนักตัวนับ',
  Cargo_Location2: 'ตำแหน่งห้องสมุด',
  Cargo_FrontEndWarehouseOperation: 'การดำเนินการตำแหน่งล่วงหน้า',
  Cargo_CargoTerminalOperation: 'การดำเนินงานสถานีขนส่งสินค้า',
  Cargo_FileSizeCannotExceed20m2: 'ขนาดไฟล์ไม่เกิน 20M รองรับรูปแบบ .xls และ .xlsx',
  Cargo_StateUpdate: 'อัพเดทสถานะ',
  Cargo_CheckInventory: 'ตรวจสอบสต็อก',
  Cargo_ReleaseLocation: 'ปล่อยไลบรารี',
  Cargo_LocationCode: 'การเข้ารหัสไลบรารี',
  Cargo_Warehouse2: 'คลังสินค้าในเครือ',
  Cargo_LocationType: 'ประเภทห้องสมุด',
  Cargo_LocationStatus: 'สถานะไลบรารี',
  Cargo_LocationDeleteTip: 'ไลบรารีถูกครอบครองและไม่สามารถลบได้',
  Cargo_ReadFailure: 'ล้มเหลวในการอ่าน',
  Cargo_PalletDeleteTip: 'ถาดปัจจุบันถูกครอบครองและไม่สามารถลบออกได้',
  Cargo_NoLocationSelected: 'ไม่มีการเลือกไลบรารี',
  Cargo_PackingCondition: 'สถานการณ์การบรรจุ',
  Cargo_SpecialHandling: 'การรักษาพิเศษ',
  Cargo_PalletNumber: 'หมายเลขกระดาษบอร์ด',
  Cargo_InventoryCheck: 'ดูสต็อก',
  Cargo_ApplyRuleToAllScenarios: 'นำการตั้งค่ากฎไปใช้กับทุกสถานการณ์',
  Cargo_DocumentsWithCargo: 'เอกสารพร้อมสินค้า',
  Cargo_CurrentBusinessAlreadyWeighedOut: 'ธุรกิจนี้ได้ทำการชั่งออกแล้ว ห้ามดำเนินการซ้ำ',
  Cargo_CurrentBusinessAlreadyDelivered: 'ธุรกิจนี้ได้ทำการส่งมอบแล้ว ห้ามดำเนินการซ้ำ',
  Cargo_PalletConfiguration: 'การจัดการพาเลท',
  Cargo_Pallet2: 'ถาด',
  Cargo_PalletID: 'หมายเลขถาด',
  Cargo_PalletStatus: 'สถานะพาเลท',
  Cargo_PalletMaterial: 'วัสดุพาเลท',
  Cargo_RecyclingType: 'ประเภทการรีไซเคิล',
  Cargo_PalletTareWeight: 'พาเลท Tare',
  Cargo_AirCargoTerminal: 'สถานีขนส่งสินค้าคลองท่าเรือ',
  Cargo_WarehouseType: 'ประเภทคลังสินค้า',
  Cargo_WarehouseCode2: 'รหัสคลังสินค้า',
  Cargo_WarehouseName: 'ชื่อคลังสินค้า',
  Cargo_WarehouseAddress: 'ที่อยู่คลังสินค้า',
  Cargo_Terminal: 'สถานีขนส่งสินค้า',
  Cargo_TerminalCode: 'รหัสสถานีขนส่ง',
  Cargo_TerminalName: 'ชื่อสถานีขนส่งสินค้า',
  Cargo_AirportCode: 'รหัสสนามบิน',
  Cargo_TerminalAddress: 'ที่อยู่สถานีขนส่งสินค้า',
  Cargo_DeliveryMap: 'แผนที่การจัดส่ง',
  Cargo_RecipientContact: 'ติดต่อรับของ',
  Cargo_RecipientContactPhone: 'เบอร์ติดต่อรับสินค้า',
  Cargo_SecurityCheckMachineWidthLimit: 'ขีด จำกัด ความกว้างของเครื่องตรวจสอบความปลอดภัย',
  Cargo_SecurityCheckMachineHeightLimit: 'ขีด จำกัด ความสูงของเครื่องตรวจสอบความปลอดภัย',
  Cargo_CustomsCode: 'รหัสศุลกากร',
  Cargo_WeighbridgeNumber: 'เครื่องชั่งน้ำหนัก',
  Cargo_WeighbridgeBaudRate: 'อัตราการส่งข้อมูลของ Weighbridge',
  Cargo_Checksum: 'ตรวจสอบบิต',
  Cargo_AutoFinanceAuditLockOrder: 'ล็อกคำสั่งตรวจสอบทางการเงินอัตโนมัติ',
  Cargo_UnSubmittedBusinessLockOrder: 'ธุรกิจที่ยังไม่ได้ส่งจะถูกล็อกคำสั่งโดยอัตโนมัติ (สถานะธุรกิจ: กำลังดำเนินการ -> ตรวจสอบแล้ว)',
  Cargo_PollingFrequency: 'ความถี่ในกาการสำรวจความคิดเห็น',
  Cargo_SpecificDateMonthly: 'วันที่เฉพาะในแต่ละเดือน',
  Cargo_DailyOnce: 'ทุกวัน',
  Cargo_PhotoTaken: 'ไม่ว่าจะเป็นการถ่ายภาพ',
  Cargo_CameraConfiguration: 'การกำหนดค่ากล้อง',
  Cargo_WeighbridgeTest: 'การทดสอบ Weighbridge',
  Cargo_Test: 'การทดสอบ',
  Cargo_MonitoringInterface: 'อินเตอร์เฟซการตรวจสอบ',
  Cargo_DeviceNumber: 'หมายเลขอุปกรณ์',
  Cargo_MonitoringChannel: 'ช่องทางการตรวจสอบ',
  Cargo_MonitoringInterface1: 'เมฆฟลูโอไลท์',
  Cargo_DeleteTip1: 'คุณจะลบ 【{0}】 ข้อมูล {1} โปรดดำเนินการด้วยความระมัดระวัง',
  Cargo_GeneralCargoWarehouse: 'คลังสินค้าทั่วไป',
  Cargo_WarehouseStorageLocation: 'พื้นที่คลังสินค้า',
  Cargo_WoodenPackagingType: 'ประเภทบรรจุภัณฑ์ไม้',
  Cargo_ClearSave: 'ล้างและบันทึก',
  Cargo_OrderModificationTimes: 'เปลี่ยนจำนวนครั้ง',
  Cargo_ServiceStatisticalArea: 'พื้นที่สถิติธุรกิจ',
  Cargo_DangerousGoodPackage: 'บรรจุภัณฑ์สินค้าอันตราย',
  Cargo_DangerousGoodPackageCode: 'รหัสบรรจุภัณฑ์สินค้าอันตราย',
  Cargo_OOGTEU: 'OOG TEU ทั้งหมด',
  Cargo_SeaRailTransport: 'การขนส่งทางทะเล',
  Cargo_BoxOneWay: 'กรณีการใช้งาน (เที่ยวเดียว / รอบ)',
  Cargo_OOGTEUTip: 'กรุณากรอก OOG TEU quantity',
  Cargo_OneWay: 'เที่ยวเดียว',
  Cargo_Circulation: 'ลูป',
  Cargo_Grade: 'Tier 2 ประเภทธุรกิจที่กำหนดเอง',
  Cargo_Grade2: 'ประเภทธุรกิจที่กำหนดเองโดยผู้บังคับบัญชา',
  Cargo_LotteryDraw: 'การเปิดตั๋ว',
  Cargo_SchoolMonth: 'เปิดเดือน',
  Cargo_WithdrawTheEntrustment: 'เพิกถอนการมอบหมาย',
  Cargo_checkData1: 'ไม่พบข้อมูลการมอบอำนาจ หรือได้รับการตรวจสอบแล้ว',
  Cargo_ContractTip: 'หากจำเป็นต้องปรับสัญญาให้ถอนสัญญาก่อน',
  Cargo_DetailMakeInvoice: 'รายละเอียดใบแจ้งหนี้',
  Cargo_SplitMakeInvoice: 'แยกการเรียกเก็บเงิน',
  Cargo_RemarkAddContent: 'หมายเหตุการออกตั๋ว เพิ่มเติมเนื้อหา',
  Cargo_CustomerAssociatedFactory: 'โรงงานที่เกี่ยวข้องกับลูกค้า',
  Cargo_FactoryName: 'ชื่อโรงงาน',
  Cargo_AddAssociatedFactory: 'เพิ่มโรงงานที่เกี่ยวข้อง',
  Cargo_BatchOperationSameEntrustedUnit: 'การดำเนินการแบบกลุ่มนี้ใช้ได้เฉพาะกับธุรกิจของหน่วยงานที่มีการมอบหมายเหมือนกันเท่านั้น กรุณาเลือกใหม่อีกครั้ง',
  Cargo_ImportFailMessage: 'การนำเข้าไม่สำเร็จ: ค่าใช้จ่ายในการนำเข้าแบบขนาดล็อต ไม่ตรงก ับเงื่อนไขของวัตถุประสงค์การชำระเงิน = หน ่วยงานท ี่ได ร บการมอบหมาย หร ือโรงงานที่เก ่ยวข ้อง โปรดปร บปร งและลองใหม่อ กคร ้ง',
  Cargo_RemarkAddContent3: 'หมายเหตุการออกตั๋ว อัตราแลกเปลี่ยน เนื้อหา',
  Cargo_SaveAndConfirm: 'บันทึกและยืนยัน',
  Cargo_ExportUndoHistory: 'ส่งออกประวัติการเพิกถอน',
  Cargo_RevocationBy: 'ผู้เพิกถอน',
  Cargo_RevocationByDate: 'เวลาเพิกถอน',
  Cargo_billingTip: 'การเรียกเก็บเงินตามความต้องการการเรียกเก็บเงิน',
  Cargo_remarkAddContent2: 'หมายเหตุเพิ่มเติม เนื้อหา',
  Cargo_detailMakeInvoice2: 'ไม่ว่าจะเป็นการออกใบแจ้งหนี้อย่างละเอียด',
  Cargo_splitMakeInvoice2: 'ไม่ว่าจะเป็นการแยกสกุลเงินในการเรียกเก็บเงิน',
  Cargo_rmbGoodsName: 'รายการใบแจ้งหนี้ CNY',
  Cargo_usdGoodsName: 'รายการเรียกเก็บเงิน USD',
  Cargo_CarrierCode: 'รหัส EDI สำหรับเรือ',
  Cargo_identifyTheResult: 'ระบุผลลัพธ์',
  Cargo_identifyTheResult2: 'ระบุข้อมูล BL',
  Cargo_SystemResult: 'ข้อมูล BL ระบบ',
  Cargo_ContrastingSystem: 'ระบบเปรียบเทียบ',
  Cargo_SaveBillData: 'บันทึกข้อมูล BL ของระบบ',
  Cargo_SaveBill2: 'ระบุข้อมูลซ้อนทับและบันทึกใบตราส่ง',
  Cargo_InAnalysis: 'ในการวิเคราะห์โปรดรอสักครู่',
  Cargo_UnopenedService: 'ไม่เปิดให้บริการและไม่สามารถใช้งานได้',
  Cargo_F17Verify: 'การส่ง F17 ต้องให้เลขที่ใจแม่และเลขที่ใจลูกตรงกัน',
  Cargo_Will: 'จะ',
  Cargo_DFI: 'ลากมาที่นี่เพื่อระบุตัวตนหรือ',
  Cargo_seaFile: 'เอกสารรับรองการออกจากทะเล',
  Cargo_siFile: 'เอกสาร BL ของ Haijin',
  Cargo_seBillFile: 'เอกสารใบตราส่งสินค้าทางทะเล',
  Cargo_GenerateSiBusiness: 'สร้างธุรกิจนำเข้าสินค้าทางทะเล',
  Cargo_MaritimeIdentification: 'การระบุการขนส่งทางทะเล',
  Cargo_ApplicationIdentificationType: 'ประเภทการระบุใบสมัคร',
  Cargo_IdentificationType: 'ประเภทการระบุ',
  Cargo_IdentificationChannel: 'ระบุช่องทาง',
  Cargo_OriginalMessage: 'เอกสารต้นฉบับ',
  Cargo_DataSource: 'แหล่งข้อมูล',
  Cargo_InvoiceExport: 'ส่งออกใบแจ้งหนี้',
  Cargo_InvoiceNoImport: 'นำเข้าหมายเลขใบแจ้งหนี้',
  Cargo_profitMargin: 'อัตรากำไร',
  Cargo_Payment1: 'ฝ่ายชำระเงิน',
  Cargo_PaymentCode: 'รหัสฝ่ายชำระเงิน',
  Cargo_PaymentName1: 'ชื่อผู้ติดต่อฝ่ายชำระเงิน',
  Cargo_PaymentName: 'ชื่อฝ่ายชำระเงิน',
  Cargo_SelectPayment: 'เลือกฝ่ายชำระเงิน',
  Cargo_ShowTab: 'แสดงลายเซ็นหน้าเสริม',
  Cargo_MscBookingInfo: 'ข้อมูลเพิ่มเติมเกี่ยวกับการจอง MSC',
  Cargo_PaymentInfo: 'ข้อมูลฝ่ายชำระเงิน',
  Cargo_PaymentInfo1: 'การจัดรูปแบบฝ่ายชำระเงิน',
  Cargo_PaymentEnterpriseCode: 'รหัสธุรกิจของฝ่ายชำระเงิน',
  Cargo_Payment2: 'ชื่อธุรกิจของฝ่ายชำระเงิน',
  Cargo_Payment3: 'ที่อยู่ของผู้ชำระเงิน',
  Cargo_Payment4: 'หมายเลขโทรศัพท์ของฝ่ายชำระเงิน',
  Cargo_Payment5: 'ที่อยู่อีเมลของฝ่ายชำระเงิน',
  Cargo_Payment6: 'หมายเลขโทรสารของฝ่ายชำระเงิน',
  Cargo_Province1: 'จังหวัด / รัฐ',
  Cargo_GeneralFormat: 'รูปแบบทั่วไป',
  Cargo_DetailFormat: 'รูปแบบรายละเอียด',
  Cargo_BringInData: 'นำเข้าข้อมูล',
  Cargo_DefaultInvoiceIssuer: 'ผู้ออกใบกำกับภาษีเริ่มต้น',
  Cargo_checkCabinTip: 'การปรากฏตัวของข้อมูลของการไหลของห้องโดยสารและการไหลของห้องโดยสารไม่มีน้ำไม่สามารถดำเนินการร่วมกัน',
  Cargo_checkCabinTip2: 'คำสั่งที่คุณติ๊กกระบวนการถอนจะดำเนินการ',
  Cargo_RecoverText: 'เรียกคืนห้องโดยสารและลงทะเบียนการคืนห้องโดยสารโดยตรงได้รับการยืนยันหรือไม่?',
  Cargo_RecoverRemark: 'กลับห้องโดยสาร Description',
  Cargo_RecoverTips: 'รีไซเคิล & ส่งคืน',
  Cargo_LinesArAp: 'จำนวนแถวรับ / แถวเจ้าหนี้',
  Cargo_RInPay: 'ลูกหนี้รวมถึงเจ้าหนี้',
  Cargo_market: 'ฝ่ายขาย',
  Cargo_GPExplain: 'คำอธิบาย GP',
  Cargo_ServiceLockSetting1: 'การตั้งค่าล็อคธุรกิจอัตโนมัติ',
  Cargo_ServiceLockSettings: 'การตั้งค่าล็อคธุรกิจ',
  Cargo_LockTheNumberOfDeferredDays: 'ล็อคล่าช้าระหว่าง 3-120 วัน',
  Cargo_checkBillingGroup: '【{0}】 สถานะการเรียกเก็บเงิน ไม่"{1}"',
  Cargo_AutoLock: 'ล็อคอัตโนมัติ',
  Cargo_BusinessDate1: 'หลังจากวันที่ทำธุรกิจ',
  Cargo_Days1: '(วัน)',
  Cargo_SendBookingFail: 'การส่งการจองห้องพักล้มเหลว',
  Cargo_OrderTemplateSaveSuccess: 'การกำหนดค่าเทมเพลตคำสั่งซื้อบันทึกความสำเร็จ',
  Cargo_ContinueSave: 'ชื่อหัวตารางแม่แบบที่ไม่ได้กำหนดค่า จะใช้ชื่อฟิลด์ธุรกิจจริง คุณต้องการดำเนินการต่อหรือไม่?',
  Cargo_OrderTemplateSaveFail: 'การกำหนดค่าเทมเพลตคำสั่งซื้อล้มเหลวในการบันทึก',
  Cargo_DownImportTemplate: 'ดาวน์โหลดแม่แบบการนำเข้า',
  Cargo_DownImportTemplate_Simple: 'ดาวน์โหลด นำเข้าแม่แบบเดียว',
  Cargo_DownImport_Simport: 'นำเข้าเดี่ยว',
  Cargo_ImportingData: 'กำลังนำเข้าข้อมูล...',
  Cargo_ImportingDataSuccess: 'การกระทำนี้เป็นการดำเนินการแบบอะซิงโครนัสคุณสามารถดูผลลัพธ์การนำเข้าที่จัดเก็บไฟล์ -> อัปโหลดบันทึก',
  Cargo_WriteOffHeader: 'หัวเรื่องการตัดบัญชี',
  Cargo_PackageNo: 'หมายเลขบรรจุ:',
  Cargo_DeletePackage: 'ลบบรรจุภัณฑ์',
  Cargo_WareHoused: 'บรรจุภัณฑ์เหล่านี้อยู่ในตำแหน่ง',
  Cargo_NotWareHoused: 'บรรจุภัณฑ์เหล่านี้ไม่ได้เข้าสู่ตำแหน่ง',
  Cargo_CheckPackage: 'คุณแน่ใจหรือไม่ว่าจะลบบรรจุภัณฑ์ที่ตรงกัน? ข้อมูลโพซิชั่นที่เข้ามาจริงจะถูกลบออกหากยืนยัน',
  Cargo_SureDeletePackageIn: 'บรรจุภัณฑ์เหล่านี้อยู่ในตำแหน่งและคุณแน่ใจหรือไม่ว่าจะลบบรรจุภัณฑ์ที่ตรงกัน? ข้อมูลโพซิชั่นที่เข้ามาจริงจะถูกลบออกหากยืนยัน',
  Cargo_SelectPackage: 'โปรดเลือกข้อมูลบรรจุภัณฑ์ที่คุณต้องการลบ',
  Cargo_SureDeleteAbovePackage: 'ยืนยันการลบแพ็กเกจเหล่านี้ข้างต้นหรือไม่?',
  Cargo_BalanceSheetQuarter: 'งบดุล รายงานประจำไตรมาส',
  Cargo_ProfitLossQuarter: 'งบกำไร รายงานประจำไตรมาส',
  Cargo_BalanceSheetYear: 'งบดุล รายงานประจำปี',
  Cargo_ProfitLossYear: 'งบกำไร รายงานประจำปี',
  Cargo_ReasonForJudgment: 'เหตุผลในการตัดสินลงโทษ',
  Cargo_CheckSavePoInfoItem: 'สินค้านี้มีส่วนเกี่ยวข้องกับบรรจุภัณฑ์โปรดยกเลิกการเชื่อมต่อก่อน!',
  Cargo_HasBillingGroup: 'แบบฟอร์มนี้สร้างใบแจ้งยอดและไม่สามารถแก้ไขได้!',
  Cargo_HasInvoice: 'รายการนี้ถูกเรียกเก็บเงินแล้ว และไม่สามารถแก้ไขได้!',
  Cargo_HasWriteOff: 'รายการนี้ถูกยกเลิกและไม่สามารถแก้ไขได้!',
  Cargo_HasConfirm: 'คำสั่งนี้ได้รับการยืนยันและไม่สามารถแก้ไขได้!',
  Cargo_ContinueOperation: 'ดำเนินการอย่างต่อเนื่อง',
  Cargo_CancelOperation: 'ยกเลิกการดำเนินการ',
  Cargo_BackTopPreviousVersion: 'กลับไปที่รุ่นเก่า',
  Cargo_Combine: 'การควบรวมกิจการ',
  Cargo_DataEnableSuccess: 'เปิดใช้งานข้อมูลสำเร็จ!',
  Cargo_DataDisEnableSuccess: 'ปิดการใช้งานข้อมูลสำเร็จ!',
  Cargo_CombineChargeItem: 'รวมรายการค่าธรรมเนียม',
  Cargo_ConsolidatedChargeItem: 'รายการค่าธรรมเนียมที่รวม:',
  Cargo_ChargeItemHasUsedForCombine: '{0} ถูกปิดใช้งานโปรดเลือกรายการค่าธรรมเนียมอื่น ๆ เพื่อรวม!',
  Cargo_CombineChargeItemTips: 'ค่าธรรมเนียมที่เกี่ยวข้องทั้งหมดของ {1} จะถูกรีเฟรชหลังจากการรวมกันเป็น {0} และตั้งค่าให้เป็นสถานะปิดการใช้งาน คุณต้องการจะทำต่อหรือไม่?',
  Cargo_CombineChargeItemTipsOne: 'กำลังควบรวมกิจการ โปรดรอสักครู่',
  Cargo_CombineChargeItemTipsTwo: 'คุณสามารถออกจากอินเทอร์เฟซนี้และคาดว่าจะเสร็จสิ้นการควบรวมกิจการภายใน 10 นาทีโปรดตรวจสอบในภายหลัง',
  Cargo_CombineChargeItemTipsThree: 'โปรดเลือกรายการค่าธรรมเนียมที่แตกต่างกันสำหรับการรวม!',
  Cargo_PayService: 'รายการค่าธรรมเนียม:',
  InvoiceTitleCannotBeBlank: 'ใบแจ้งหนี้ที่เพิ่มขึ้นไม่สามารถว่างเปล่าได้',
  InvoiceTitleCannotBeDuplicate: 'การยกยอดใบแจ้งหนี้ไม่สามารถทำซ้ำได้',
  TaxControlPanelCannotBeDuplicate: 'หนึ่งภาษีควบคุม 【{0}】 ไม่ได้รับอนุญาตให้เชื่อมโยงกับใบแจ้งหนี้ที่เพิ่มขึ้นหลาย',
  CheckTaxControlPanelNo: '【{0}】 หมายเลขควบคุมภาษีหลายตัวยังคงรักษาไว้หรือไม่?',
  TaxControlPanelNoHasInvoiceTitle: 'ข้อมูลการควบคุมภาษีมีการเชื่อมโยงการเรียกเก็บเงินเพิ่มขึ้นและไม่สามารถลบได้โปรดยกเลิกการเชื่อมโยงก่อน!',
  ChinaAdditionalTaxRateIsEmpty: '【อัตราภาษีเพิ่มเติมของจีน】 ฟิลด์ว่างเปล่าและยืนยันว่าจะทำการบันทึกต่อไปหรือไม่?',
  SpecialCharactersExcept: 'การปรากฏตัวของอักขระพิเศษอื่น ๆ นอกเหนือจากภาษาอังกฤษตัวเลขเครื่องหมายวรรคตอน',
  Cargo_ThePreAllocatedManifestHasBeenSentForThisTicketBusiness: 'ธุรกิจตั๋วนี้ได้ส่งรายการสินค้าล่วงหน้าแล้ว การนำเข้าล้มเหลว',
  EstimatedDeliveryDate: 'วันที่จัดส่งโดยประมาณ',
  ActualDeliveryDate: 'วันที่จัดส่งจริง',
  LatestDeliveryDate: 'วันที่จัดส่งล่าสุด',
  DischargingWay: 'วิธีการขนถ่าย',
  Cargo_DownloadSource: 'ดาวน์โหลดข้อมูล',
  Cargo_canOnlyBeUppercaseCharactersAndNumbers: 'ต้องเป็นตัวพิมพ์ใหญ่และตัวเลขเท่านั้น',
  Cargo_numbersNotLetters: 'ตัวเลขต้องไม่มีตัวอักษร',
  Cargo_pleaseSelectShippingTerms: 'โปรดเลือกเงื่อนไขการจัดส่ง',
  Cargo_pleaseSelectTheTypeOfGoods: 'กรุณาเลือกประเภทสินค้า',
  Cargo_pleaseSelectTheBillOfLadingMethod: 'โปรดเลือกวิธี B / L',
  Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters: 'กรุณาใส่ชื่อเต็มภาษาอังกฤษ',
  Cargo_PortOfDischargeTipText: 'Transfer Transfer Port ส่งตรงไปยังท่าเรือปลายทาง',
  Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers: 'ต้องเป็นตัวอักษร, ตัวเลข, ".", "-", "ช่องว่าง" เท่านั้น',
  Cargo_PortPreRateCode: 'รหัสอัตราค่าระวางก่อนท่า',
  Cargo_SideLineType: 'ประเภทเส้นทางรอง',
  Cargo_EndRouteRateCode: 'รหัสอัตราค่าระวางเส้นทางปลายทาง',
  Cargo_DeliveryAddressType: 'ประเภทที่อยู่จัดส่ง',
  Cargo_DirectHaul: 'ขนส่งตรง',
  Cargo_SideLine: 'เส้นทางรอง',
  Cargo_HuzhouSeaRail: 'ทางน้ำ-รถไฟหูโจว',
  Cargo_HaiNingBranch: 'สายการบินไห่หนิง',
  Cargo_ZhapuSideLine: 'เส้นทางรองจ๋าปู',
  Cargo_OriginPortInfo: 'ข้อมูลท่าจอดต้นทาง',
  Cargo_ChargeByContainerType: 'รายการค่าบริการตามประเภทตู้',
  Cargo_ChargeNotByContainerType: 'รายการค่าบริการไม่ตามประเภทตู้',
  Cargo_SpecialRemark: 'หมายเหตุพิเศษ',
  Cargo_AddEntry: 'เพิ่มรายการ',
  Cargo_FreeUseContainer: 'ตู้ฟรีใช้งาน',
  Cargo_FreeStorage: 'เก็บฟรี',
  Cargo_ThirdPartyAddress: 'ที่อยู่ของบุคคลที่สาม',
  Cargo_AmazonWarehouse: 'คลังสินค้าของ Amazon',
  Cargo_WalmartWarehouse: 'คลังสินค้าของ Walmart',
  Cargo_YiCang: 'คลังสินค้า YiCang',
  Cargo_DestinationPortInfo: 'ข้อมูลท่าจอดปลายทาง',
  Cargo_Shelving: 'วางบนชั้น',
  Cargo_PleaseSelectNonNormalRateForShelving: 'กรุณาเลือกอัตราค่าบริการที่ไม่ใช่สถานะ "ปกติ" เพื่อทำการวางบนชั้น',
  Cargo_PleaseSelectValidRateForShelving: 'กรุณาเลือกอัตราค่าบริการที่มีระยะเวลาบังคับใช้อย่างมีผลเพื่อทำการวางบนชั้น',
  Cargo_PleaseSelectNormalRateForUnShelving: 'กรุณาเลือกอัตราค่าบริการที่มีสถานะ "ปกติ" เพื่อทำการนำลงจากชั้น',
  Cargo_SeaFreightFullContainer: 'การขนส่งทางทะเลแบบตู้คอนเทนเนอร์เต็ม',
  Cargo_SeaFreightLessThanContainer: 'การขนส่งทางทะเลแบบตู้คอนเทนเนอร์ไม่เต็ม',
  Cargo_EnquiryNumber: 'หมายเลขการสอบถาม',
  Cargo_EnquirySource: 'แหล่งที่มาของการสอบถาม',
  Cargo_Enquirer: 'ผู้สอบถาม',
  Cargo_EnquiryStatus: 'สถานะการสอบถาม',
  Cargo_FirstLegQuoteStatus: 'สถานะการเสนอราคาก่อนท่าเรือ',
  Cargo_MainlineQuoteStatus: 'สถานะการเสนอราคาส่วนหลัก',
  Cargo_LastLegQuoteStatus: 'สถานะการเสนอราคาส่วนสุดท้าย',
  Cargo_PalletType: 'ประเภทพาเลต',
  Cargo_DirectOrTransshipment: 'ตรง/ขนส่งผ่าน',
  Cargo_Range: 'ช่วง',
  Cargo_Dimensions: 'ความยาว, ความกว้าง, ความสูง',
  Cargo_Terms: 'ข้อกำหนดการบริการ',
  Cargo_DeliveryAddress: 'ที่อยู่การจัดส่ง',
  Cargo_NameHSCode: 'ชื่อสินค้า (HS Code)',
  Cargo_MainlineRate: 'อัตราค่าขนส่งหลัก',
  Cargo_PrePortRate: 'อัตราค่าขนส่งก่อนท่าเรือ',
  Cargo_EndRouteRate: 'อัตราค่าขนส่งปลายทาง',
  Cargo_RateCode: 'รหัสอัตราค่าขนส่ง',
  Cargo_MatchQuote: 'การจับคู่ราคา',
  Cargo_Select_Inquiry_Responsible: 'เลือกผู้รับผิดชอบการสอบถามราคา',
  Cargo_Multiple_Route_Leaders: 'พบข้อมูลผู้รับผิดชอบหลายเส้นทาง กรุณาเลือกผู้ที่ต้องการเริ่มต้นการสอบถาม:',
  Cargo_Pre_Port_Rate_Leader: 'ผู้รับผิดชอบอัตราค่าขนส่งก่อนท่าเรือ',
  Cargo_Mainline_Rate_Leader: 'ผู้รับผิดชอบอัตราค่าขนส่งหลัก',
  Cargo_End_Route_Rate_Leader: 'ผู้รับผิดชอบอัตราค่าขนส่งปลายทาง',
  Cargo_NoMatchFound: 'ไม่พบการจับคู่ [{0}]',
  Cargo_CombinationPlanQuery: 'การค้นหาผลการผสมผสานแผน',
  Cargo_FillQueryConditions: 'กรอกเงื่อนไขการค้นหา',
  Cargo_SelectMatchingRate: 'เลือกอัตราที่ตรงกัน',
  Cargo_GenerateCombinationPlan: 'สร้างแผนการผสมผสาน',
  Cargo_ReturnToPreviousStep: 'กลับไปที่ขั้นตอนก่อนหน้า',
  Cargo_PrePortPrice: 'ราคาก่อนท่าเรือ',
  Cargo_MainlinePrice: 'ราคาทางหลวง',
  Cargo_LastMilePrice: 'ราคาสุดท้าย',
  Cargo_AssociatedPrePortQuoteNumber: 'หมายเลขใบเสนอราคาก่อนท่าเรือที่เกี่ยวข้อง',
  Cargo_AssociatedLastMileQuoteNumber: 'หมายเลขใบเสนอราคาสุดท้ายที่เกี่ยวข้อง',
  Cargo_20GPQuantity: 'จำนวน 20GP',
  Cargo_40GPQuantity: 'จำนวน 40GP',
  Cargo_40HCQuantity: 'จำนวน 40HC',
  Cargo_45HCQuantity: 'จำนวน 45HC',
  Cargo_20NORQuantity: 'จำนวน 20NOR',
  Cargo_40NORQuantity: 'จำนวน 40NOR',
  Cargo_20FootNORQuantity: 'จำนวน 20\'NOR',
  Cargo_40FootNORQuantity: 'จำนวน 40\'NOR',
  Cargo_SubmitQuotation: 'ส่งใบเสนอราคา',
  Cargo_WithdrawQuotation: 'ถอนใบเสนอราคา',
  Cargo_RejectQuotation: 'ปฏิเสธใบเสนอราคา',
  Cargo_InquiryManagement: 'การจัดการการสอบถามราคาสินค้า',
  Cargo_PrePort: 'ก่อนท่าเรือ',
  Cargo_FinalMile: 'ระยะสุดท้าย',
  Cargo_OriginAreaSelection: 'เลือกพื้นที่ต้นทาง',
  Cargo_ShippingAddressSelection: 'Выбор адреса доставки',
  Cargo_AddArea: '+เพิ่มพื้นที่',
  Cargo_AddAddress: '+เพิ่มที่อยู่',
  Cargo_AddressDisabledTip: 'สามารถเพิ่มหลายพื้นที่ได้ เมื่อเลือก 2 พื้นที่หรือมากกว่านั้น ที่อยู่รายละเอียดจะถูกปิดใช้งาน',
  Cargo_PleaseMaintainAtLeastOne: 'กรุณารักษาอย่างน้อยหนึ่งรายการ',
  Cargo_CannotMatchPleaseFill: '{0} ไม่สามารถจับคู่ได้ กรุณากรอก [{1}] ',
  Cargo_Match: 'จับคู่',
  Cargo_QuoteStatusNotAllowedSave: 'ไม่สามารถบันทึกในสถานะการเสนอราคา',
  Cargo_SaveDraft: 'บันทึกเป็นร่าง',
  Cargo_PublishDirectly: 'เผยแพร่ทันที',
  Cargo_SelectPendingQuoteSubmittedCancel: 'กรุณาเลือกใบสอบถามราคาที่ยังรอดำเนินการและได้ส่งแล้วเพื่อยกเลิก',
  Cargo_LastMileDeliveryAddress: 'ที่อยู่การจัดส่งระยะสุดท้าย',
  Cargo_PackingDoorPoint: 'จุดประตูบรรจุภัณฑ์',
  Cargo_BoxTypeNotAllowedDuplicate: 'ไม่อนุญาตให้ใช้ประเภทกล่องซ้ำ',
  Cargo_PrePortBusinessLeader: 'ผู้นำธุรกิจพอร์ตก่อน',
  Cargo_MainlineBusinessLeader: 'ผู้นำธุรกิจเส้นทางหลัก',
  Cargo_LastMileBusinessLeader: 'ผู้นำธุรกิจการจัดส่งระยะสุดท้าย',
  Cargo_OverseaTracker: 'ผู้รับผิดชอบติดตามต่างประเทศ',
  Cargo_EndCommerceSynced: 'ซิงค์แล้ว',
  Cargo_EndCommerceAudited: 'ตรวจสอบแล้ว',
  Cargo_EndCommerceNotSynced: 'ยังไม่ซิงค์',
  Cargo_EndCommercePleaseSelectAtLeastOne: 'กรุณาเลือกอย่างน้อยหนึ่งรายการ',
  Cargo_EndCommerceOnlySelectOne: 'สามารถเลือกได้เพียงหนึ่งรายการสำหรับการดำเนินการนี้',
  Cargo_EndCommerceRecordNotAllowEdit: 'ไม่อนุญาตให้แก้ไขรายการนี้',
  CargoMsg_CurrentIdentityNotice: 'สถานะปัจจุบันจะเชื่อมโยงกับสิทธิ์ที่ตามมา หากคุณต้องการยื่นคำขอในฐานะบทบาทอื่น กรุณาสลับสาขาและแผนกที่มุมขวาบนของหน้าจอก่อน',

  Cargo_enterTheVoyageThereCanBeNoV: 'ไม่สามารถมี V. ได้',
  Cargo_ResubscribeBookingReceipt: 'การสมัครใหม่ใบรับรองการจอง',
  Cargo_BookingReceiptSubscriptionFailed: 'การสมัครใบรับรองการจองล้มเหลว',
  Cargo_inputVoyage: 'กรุณากรอกเที่ยวบิน',
  Cargo_pleaseSelectAShippingGeneration: 'กรุณาเลือก Shipping',
  Cargo_pleaseSelectAShippingCompany: 'กรุณาเลือก บริษัท เรือ',
  Cargo_pleaseEnterAnAddressWithin140Characters: 'กรุณากรอกที่อยู่ภายใน 140 ตัวอักษร',
  Cargo_pleaseEnterTheEnterpriseCode: 'โปรดป้อนรหัสธุรกิจ, ต้องมี "+", + ไม่มีช่องว่างก่อนและหลัง',
  Cargo_pleaseEnterAPhoneNumber: 'กรุณากรอกหมายเลขโทรศัพท์',
  Cargo_pleaseEnterANameWithin140Characters: 'กรุณากรอกชื่อภายใน 140 ตัวอักษร',
  Cargo_pleaseEnterANameWithin140Characters2: 'กรุณากรอกชื่อภายใน 70 ตัวอักษร',
  Cargo_pleaseSelectACountryCode: 'กรุณาเลือกรหัสประเทศ',
  Cargo_pleaseEnterTheActualContactName: 'กรุณากรอกชื่อผู้ติดต่อจริง',
  Cargo_ViewShipGenerations: 'ดู Yaship',
  Cargo_ReferenceShipGenerations: 'เรืออ้างอิง',
  Cargo_CopyShipInformation: 'คัดลอกข้อมูลเรือ',
  Cargo_PleaseInquireWithTheBookingHatchOrCustomerService: 'กรุณาสอบถามเกี่ยวกับการจองห้องโดยสารหรือฝ่ายบริการลูกค้า',
  UnverifiedAmountForCharge: 'ยอดคงค้าง (ค่าธรรมเนียม)',
  VerifiedAmountForCharge: 'จำนวนเงินที่จำหน่าย (ค่าธรรมเนียม)',
  ReceivableForCharge: 'ลูกหนี้ (ค่าธรรมเนียม)',
  PayableForCharge: 'จ่าย (ค่าธรรมเนียม)',
  Cargo_PrePlanBookingCheckSoNo: 'ใบกำกับสินค้าล่วงหน้าที่ส่ง / แก้ไขมีหมายเลขใบกำกับสินค้าที่ยังไม่ได้รับการบำรุงรักษาในธุรกิจแคชเชียร์เช็ค จะดำเนินการต่อหรือไม่',
  Cargo_SwitchToTheOldVersion: 'เปลี่ยนเป็นรุ่นเก่า',
  Cargo_MaintainChargeItem: 'โปรดบำรุงรักษารายการค่าใช้จ่ายก่อน!',
  Cargo_UsePeriodRate: 'ไม่ว่าจะใช้อัตราแลกเปลี่ยนโดยละเอียด',
  Cargo_initRatePeriod: 'เริ่มใช้อัตราแลกเปลี่ยนย้อนหลัง วันที่มีผลบังคับใช้',
  Cargo_MonthRate: 'อัตราแลกเปลี่ยนรายเดือน',
  Cargo_PartialImport: 'นำเข้าบางส่วน',
  Cargo_CopyCustomerShippingInformation: 'การถอดรหัสและส่งผ่าน',
  Cargo_NoPermissionForModule: 'คุณไม่มีสิทธิ์ที่จะเปิดโมดูล!',
  Cargo_OcPayment: 'สอบถามข้อมูลการรับเงินออฟไลน์',
  Cargo_BatchProcess: 'การประมวลผลแบทช์',
  Cargo_BatchCancelProcess: 'การยกเลิกแบทช์',
  Cargo_OcPaymentTime: 'วันที่ชำระเงิน',
  Cargo_ErialNumber: 'ไตรภาคีจ่ายกระแส',
  Cargo_OcErialNumber: 'OC จ่ายกระแส',
  Cargo_BillingAccountId: 'ชื่อลูกค้าชำระบิล',
  Cargo_BillingSettlementAgentId: 'ชื่อตัวแทนการเรียกเก็บเงิน',
  Cargo_Processed: 'ไม่ว่าจะเป็นการประมวลผล',
  Cargo_Project: 'ชื่อโครงการ',
  Cargo_PaymentStatus: 'สถานะการชำระเงิน',
  Cargo_UnlockPaymentTimeQuery: 'หากช่วงวันที่ชำระเงินที่เลือกมากกว่า 2 ปีจะมีผลต่อความเร็วในการโหลดข้อมูลกำหนดข้อมูลนอกสองปีของการสอบถามหรือไม่?',
  Cargo_OnlyUnProcessedRecordsCanBeProcessed: 'สามารถจัดการกับระเบียน 【โอนเงินแบบออฟไลน์】 ที่ยังไม่ถูกประมวลผลเท่านั้น',
  Cargo_ConfirmAndProcessSelectedRecord: 'ยืนยันการประมวลผลระเบียน 【โอนเงินแบบออฟไลน์】 ที่เลือกไว้หรือไม่?',
  Cargo_OnlyProcessedRecordsCanBeCancelled: 'สามารถยกเลิกระเบียน 【โอนเงินแบบออฟไลน์】 ที่ได้ดำเนินการไปแล้วเท่านั้น',
  Cargo_CancelProcessOfSelectedRecord: 'ยืนยันการยกเลิกการประมวลผลระเบียน 【โอนเงินแบบออฟไลน์】 ที่เลือกไว้หรือไม่?',
  Cargo_ProcessedSuccessfully: 'ทำเครื่องหมายว่า ประมวลผลแล้ว',
  Cargo_CancelProcessSuccessfully: 'ทำเครื่องหมายว่าไม่ประมวลผล',
  Cargo_LockedOrNot: 'ไม่ว่าจะเป็นการล็อค',
  Cargo_DeleteOCBillTips: 'ลบเฉพาะบิลที่ไม่ได้ล็อก!',
  Cargo_DeleteRecheckedBillTips: 'ลบเฉพาะบิลที่ไม่ได้ตรวจสอบ!',
  Cargo_OCCanWriteOff: 'สามารถยกเลิกการเรียกเก็บเงิน 【โอนเงินแบบออฟไลน์】 ที่ล็อคไว้เท่านั้น!',
  Cargo_Adjustment: 'การปรับแต่ง',
  Cargo_InChangeExpenseReview: 'ในการตรวจสอบค่าธรรมเนียมการเปลี่ยนแปลง',
  Cargo_Verification: 'พินนิวเคลียร์',
  Cargo_BeWriteBack: 'โดย สีแดง',
  Cargo_InquiryAndQuotation: 'สอบถามและเสนอราคา',
  Cargo_AlertTodoCategoryList: 'รายการหมวดหมู่การแจ้งเตือนและงาน待办',
  Cargo_ItemDescription: 'คำอธิบายรายการ',
  Cargo_Alert: 'การแจ้งเตือน',
  Cargo_Todo: 'งาน待办',
  Cargo_TodoAlert: 'งาน待办/การแจ้งเตือน',
  Cargo_ChangeFeeApplicationProgress: 'ความคืบหน้าการขอเปลี่ยนแปลงค่าธรรมเนียม',
  Cargo_userDefinedRole1: 'โพสต์ที่กำหนดเอง 1',
  Cargo_userDefinedRole2: 'โพสต์ที่กำหนดเอง 2',
  Cargo_userDefinedRole3: 'โพสต์ที่กำหนดเอง 3',
  Cargo_userDefinedRole4: 'โพสต์ที่กำหนดเอง 4',
  Cargo_userDefinedRole5: 'โพสต์ที่กำหนดเอง 5',
  Cargo_userDefinedRole6: 'โพสต์ที่กำหนดเอง 6',
  Cargo_userDefinedRole7: 'โพสต์ที่กำหนดเอง 7',
  Cargo_userDefinedRole8: 'โพสต์ที่กำหนดเอง 8',
  Cargo_DisplaysTheRequestChangeFee: 'แสดงค่าธรรมเนียมการเปลี่ยนแปลงการสมัคร',
  Cargo_UpdateVesselVoyageMsg: 'คุณได้แก้ไขชื่อเรือแล้ว {0} มีค่าอยู่แล้ว คุณต้องการให้เปล่าหรือไม่?',
  Cargo_UpdateMblMsg: 'คุณได้ปรับหมายเลขประจำตัว และได้รับบริการติดตามการส่งออกสินค้าทางอากาศแล้ว {0} ต้องการล้างฟิลด์ที่เกี่ยวข้องหรือไม่',
  Cargo_CheckUnitRate: 'มีค่าใช้จ่ายต่อหน่วยเป็น 0 ดำเนินการต่อ Save จะล้างค่าใช้จ่ายโดยอัตโนมัติต่อหน่วยเป็น 0 ดำเนินการต่อ Save หรือไม่?',
  Cargo_ZeroUnitPrice: 'มีค่าธรรมเนียมที่ราคาต่อหน่วยเป็น 0, จะบันทึกต่อไปหรือลบค่าธรรมเนียมที่ราคาต่อหน่วยเป็น 0?',
  Cargo_ClearZeroFee: 'ลบค่าธรรมเนียมที่เป็น 0',
  Cargo_NoFeesCanBeAdded: 'ไม่มีค่าธรรมเนียมให้เพิ่ม',
  Cargo_ZeroUnitPriceEntry: 'กรอกค่าหน่วยเป็น 0 กรุณายืนยันว่าจะบันทึกต่อหรือไม่',
  Cargo_ZeroAmountWarning: 'ราคาต่อหน่วยหรือจำนวนเงินถูกป้อนเป็น 0 กรุณายืนยันว่าต้องการบันทึกต่อหรือไม่',
  Cargo_Readjust: 'ปรับใหม่',
  Cargo_Validate_Insure: 'ไม่อนุญาตให้ใช้ฟังก์ชั่นประกันภัยภายใต้สำนักงานใหญ่ กรุณาเปลี่ยนไปที่สาขา',
  Cargo_ReceivingOperator: 'รับ Operator',
  Cargo_ReceivingOperationTime: 'รับเวลาทำงาน',
  Cargo_ClaimOperator: 'ผู้ดำเนินการข้อเรียกร้อง',
  Cargo_ClaimOperationTime: 'อ้างเวลาทำงาน',
  Cargo_OrderChangeOperator: 'เปลี่ยนผู้ประกอบการเดี่ยว',
  Cargo_ChangeOrderOperationTime: 'เปลี่ยนเวลาทำงานเดี่ยว',
  Cargo_ContinueToReleaseDocuments: 'ยืนยันจะใส่ใบสั่งต่อหรือไม่',
  Cargo_ExpectedReturnDate: 'วันที่คาดว่าจะส่งคืน',
  Cargo_OcPrePayment: 'เครื่องหมายก่อนรับ',
  Cargo_OcCancelPrePayment: 'ยกเลิกการเรียกเก็บเงินล่วงหน้า',
  Cargo_GetKingdeId: 'รับ ID ผีเสื้อทอง',
  Cargo_RefreshData: 'การดำเนินการล้มเหลวโปรดลองอีกครั้งหลังจากรีเฟรช!',
  Cargo_ContinueExportTip: 'ระเบียนที่เลือกได้ถูกส่งออกไปแล้ว คุณแน่ใจหรือว่าคุณต้องการส่งออกอีกครั้ง?',
  Cargo_WarnRuleConfiguration: 'รายการการกำหนดค่ากฎการเตือนล่วงหน้า',
  Cargo_BPMApprovalProcess: 'กระบวนการอนุมัติ BPM',
  Cargo_DataServiceReminder: 'การแจ้งเตือนการบริการข้อมูล',
  Cargo_ValueAddedServiceReminder: 'การแจ้งเตือนบริการเพิ่มมูลค่า',
  Cargo_DataServiceItems: 'รายการบริการข้อมูล',
  Cargo_SopTemplate: 'เทมเพลต SOP',
  Cargo_SopNode: 'โหนด SOP',
  Cargo_TriggerTypeSelection: 'การเลือกประเภททริกเกอร์',
  Cargo_TriggerType: 'ประเภททริกเกอร์',
  Cargo_WarningConditions: 'เงื่อนไขการเตือนภัย',
  Cargo_NodeUpdate: 'การปรับปรุงโหนด',
  Cargo_EarlyWarning: 'ประเภทของการเตือนภัย',
  Cargo_WarningContent: 'เนื้อหาเตือนภัย',
  Cargo_DataServiceConfig: 'Tên cấu hình dịch vụ dữ liệu',
  Cargo_ConfigureNameNotEmpty: 'Tên cấu hình không được để trống',
  Cargo_ConfigureNameRepeat: '{0} đã tồn tại; tên cấu hình phải là duy nhất',
  Cargo_NotifierRoleRepeat: 'Vị trí {0} đã tồn tại trong cấu hình {1}; vui lòng không cấu hình lại',
  Cargo_NotifierIdRepeat: 'Người dùng {0} đã tồn tại trong cấu hình {1}; vui lòng không cấu hình lại',
  Cargo_RemarksInfo: 'หมายเหตุ ข้อมูล',
  Cargo_DesignatedPost: 'โพสต์ที่กำหนด (การแจ้งเตือนตามการดำเนินงาน, การขาย, การบริการลูกค้า ฯลฯ โพสต์ที่กำหนดในธุรกิจตั๋วแต่ละ)',
  Cargo_SendSettings: 'ส่งการตั้งค่า',
  Cargo_SetTheNotificationRecipients: 'ตั้งค่าวัตถุแจ้งเตือน (Insider)',
  Cargo_ReminderMethod: 'วิธีการเตือน',
  Cargo_DesignatedPersonnel: 'บุคคลที่ได้รับมอบหมาย',
  Cargo_AutoIgnoreMode: 'วิธีการละเว้นอัตโนมัติ',
  Cargo_WarningLevel: 'ระดับการเตือนภัย',
  Cargo_ShipPlanReminderMethod: 'วิธีการเตือนของแผนเรือ',
  Cargo_ShipNameAndVoyage: 'เตือนตามชื่อเรือและรุ่นเดินเรือ',
  Cargo_Job: 'เตือนตามธุรกิจ',
  Cargo_AlertOnStatus: 'สถานะเปิดเตือนภัย',
  Cargo_EarlyWarningMode: 'โหมดเตือนภัยล่วงหน้า',
  Cargo_WarningSwitch: 'สวิตช์เตือนภัยล่วงหน้า',
  Cargo_StartAlert: 'เปิดเตือนภัย',
  Cargo_CloseAlert: 'ปิดเตือนภัย',
  Cargo_EnablePersonalSettings: 'เปิดการตั้งค่าส่วนบุคคล',
  Cargo_ClosePersonalSettings: 'ปิดการตั้งค่าส่วนบุคคล',
  Cargo_DataServiceReminderWarning1: '1.【การผลักตาม "การกำหนดค่าพื้นฐาน"】ถูกผลักที่โหนดซึ่งกำหนดร่วมกันใน【การกำหนดค่าพื้นฐาน】',
  Cargo_DataServiceReminderWarning2: '2. หลังจาก【เปิดการแจ้งเตือน】-【บันทึก】โหนดที่รับจะขึ้นอยู่กับการตั้งค่าส่วนบุคคล',
  Cargo_ConfigurationAlert: 'การผลักตาม "การกำหนดค่าพื้นฐาน"',
  Cargo_PushNodeSettings: 'การตั้งค่าโหนดผลักส่วนบุคคล',
  Cargo_NodPushSettings: 'การตั้งค่าการผลักโหนด',
  Cargo_VesselReminderMethodDifferent: 'วิธีเตือนกำหนดการเรือเดิมที่มีผลคือ {ตามชื่อเรือและเที่ยว} จะถูกแทนที่ทั้งหมดด้วย {ตามธุรกิจ} ล่าสุด',
  Cargo_VesselReminderMethodDifferent2: 'วิธีเตือนกำหนดการเรือเดิมที่มีผลคือ {ตามธุรกิจ} จะถูกแทนที่ทั้งหมดด้วย {ตามชื่อเรือและเที่ยว} ล่าสุด',
  Cargo_UserConfigOpenDifferent: 'การตั้งค่าการผลักโหนดเดิมที่มีผลคือ {ปิดการตั้งค่าส่วนบุคคล} จะถูกแทนที่ทั้งหมดด้วย {เปิดการตั้งค่าส่วนบุคคล} ล่าสุด',
  Cargo_UserConfigOpenDifferent2: 'การตั้งค่าการผลักโหนดเดิมที่มีผลคือ {เปิดการตั้งค่าส่วนบุคคล} จะถูกแทนที่ทั้งหมดด้วย {ปิดการตั้งค่าส่วนบุคคล} ล่าสุด',
  Cargo_BringForward: 'ล่วงหน้า',
  Cargo_Postpone: 'ความล่าช้า',
  Cargo_EarlyWarningReminder: 'จุดเตือนภัยล่วงหน้า',
  Cargo_EarlyTimedIgnore: 'ไม่สนใจเวลา',
  Cargo_TurnOffAutoIgnore: 'ปิด การละเลยอัตโนมัติ',
  Cargo_SetSOPNodeOfAlert: 'โหนด SOP สำหรับการเตือนภัยล่วงหน้า',
  Cargo_SOPNodeOfAlert: 'การแจ้งเตือนโหนด SOP',
  Cargo_ApplicationScope: 'ขอบเขตการใช้งาน',
  Cargo_DocumentNotification: 'การแจ้งเอกสาร',
  Cargo_ApplyToAllTemplates: 'นำไปใช้กับเทมเพลตประเภทธุรกิจเดียวกัน',
  Cargo_UseOnlyTheCurrentTemplate: 'ใช้เทมเพลตปัจจุบันเท่านั้น',
  Cargo_SetAlertNotificationObject: 'ตั้งค่าวัตถุแจ้งเตือนล่วงหน้า',
  Cargo_ReminderModes: 'วิธีการเตือน',
  Cargo_IgnoreTime: 'ไม่สนใจเวลา',
  Cargo_AutomaticallyIgnoreAfterHours: 'ไม่สนใจโดยอัตโนมัติหลังจากชั่วโมง',
  Cargo_EditNodeAlertRules: 'แก้ไขกฎการแจ้งเตือนโหนด',
  Cargo_CloudPlatformFeeStatus: 'สถานะค่าธรรมเนียมแพลตฟอร์มคลาวด์',
  Cargo_CloudPlatformSyncStatus: 'สถานะการซิงโครไนซ์แพลตฟอร์มคลาวด์',
  Cargo_CloudPlatformDocumentNumber: 'หมายเลขเอกสารแพลตฟอร์มคลาวด์',
  Cargo_SynchronousCloudPlatform: 'ซิงค์แพลตฟอร์มคลาวด์',
  Cargo_SendThirdParty: 'ส่งบุคคลที่สาม',
  Cargo_SupplementaryInformation: 'ข้อมูลเพิ่มเติม',
  Cargo_InvoiceTypeOfTheOppositePlatform: 'ประเภทของใบแจ้งหนี้แพลตฟอร์มอื่น ๆ',
  Cargo_PaymentBranch: 'สาขาการชำระเงิน',
  Cargo_SyncInvoiceAttachment: 'ซิงค์ไฟล์แนบใบแจ้งหนี้',
  Cargo_Send: 'ส่ง',
  Cargo_SendSuccess: 'ส่งเรียบร้อยแล้ว',
  Cargo_SendFail: 'ส่งล้มเหลว',
  Cargo_Remarks2: 'หมายเหตุ เนื้อหา',
  Cargo_PaymentInstructions: 'คำชี้แจงการชำระเงิน',
  Cargo_PaymentReason: 'เหตุผลการชำระเงิน',
  Cargo_OurHeader: 'ส่วนหัวของเรา',
  Cargo_DeleteBookingNote: 'แน่ใจนะว่าต้องการลบ {0} นี้?',
  Cargo_ApplicationDetails: 'รายละเอียดการสมัคร',
  Cargo_SubscribeToDataAlerts: 'สมัครรับการแจ้งเตือนข้อมูล',
  Cargo_EnableDataServiceReminder: 'เปิดใช้งานการแจ้งเตือนบริการข้อมูล',
  Cargo_ClickToLearnMore: 'คลิกเพื่อดูข้อมูลเพิ่มเติม',
  Cargo_DataServiceReminderWarningOne: '1. การเตือนความจำที่ผิดปกติจะถูกตัดสินโดยตรรกะและเป็นข้อมูลอ้างอิงเท่านั้นข้อมูลเฉพาะจะขึ้นอยู่กับข้อมูลอย่างเป็นทางการ',
  Cargo_DataServiceReminderWarning: '2. คุณสามารถปิดการแจ้งเตือนได้หากคุณได้รับการแจ้งเตือนกล่องมากเกินไปทุกวันรายการเตือนข้างต้นต้องเปิดโมดูลบริการเสริม',
  Cargo_AskDataServiceReminder: 'หลังจากเปิดให้บริการข้อมูลแล้ว การแจ้งเตือนแบบพุชอัตโนมัติที่มีประสิทธิภาพและแม่นยำจะถูกส่งไปยังเจ้าหน้าที่ภายใน',
  Cargo_AskSopDataService: 'หลังจากเปิดบริการข้อมูลการแจ้งเตือนแบบพุชอัตโนมัติที่มีประสิทธิภาพและถูกต้องแก่พนักงานภายในและลูกค้า (ไม่ได้เปิดใช้งานการสนับสนุนการไหลเวียนของมนุษย์) และสามารถตั้งค่าบริการแจ้งเตือนข้อมูลในการกำหนดค่ากฎการเตือนภัยล่วงหน้าติดต่อผู้ดูแลระบบของ บริษัท ของคุณทันทีสำหรับรายละเอียด:',
  Cargo_ContactDataServiceReminder: 'หรือติดต่อฝ่ายบริการลูกค้าวอลล์เทคออนไลน์ หรือ ฝ่ายปฏิบัติการ 021-65143931',
  Cargo_DataServiceRemind: 'บริการแจ้งเตือนข้อมูล',
  Cargo_WhetherToTurnOffAlerts: 'ไม่ว่าจะเป็นการปิดเตือนภัยล่วงหน้า',
  Cargo_DayWarning: 'เตือนภัยวันนี้',
  Cargo_OnlyDataNodesAreDisplayed: 'แสดงเฉพาะโหนดที่มีการเตือนล่วงหน้า',
  Cargo_ViewProcessedAlerts: 'ดูการเตือนภัยที่ได้รับการประมวลผล',
  Cargo_ViewIgnoredAlerts: 'ดูคำเตือนที่ถูกละเลย',
  Cargo_SelectTheSopTemplateToApplyToTheBusiness: 'เลือกเทมเพลต SOP เพื่อใช้กับธุรกิจนี้',
  Cargo_MakeSureToApplyTheSopTemplate: 'กรุณายืนยันการใช้แม่แบบ SOP 【{0}】',
  Cargo_PleaseSelectAnSOPTemplate: 'โปรดเลือกเทมเพลต SOP',
  Cargo_PleaseSelectSOPTemplateForChange: 'โปรดเลือกลายฉลุ SOP ที่คุณต้องการเปลี่ยน',
  Cargo_PleaseSelectOtherSOPTemplate: 'ธุรกิจที่คุณเลือกมี SOP Stencil ที่คุณต้องการให้เลือกใหม่',
  Cargo_ReplaceTheSOPTemplate: 'เปลี่ยนแม่แบบ SOP',
  Cargo_Apply: 'ใบสมัคร',
  Cargo_MoreFilters: 'คัดกรองเพิ่มเติม',
  Cargo_Handled: 'ประมวลผลแล้ว',
  Cargo_ProcessSelectedData: 'ข้อมูลการเตือนภัยที่เลือกทั้งหมดจะถูกทำเครื่องหมายว่าได้รับการประมวลผลและการดำเนินการนี้จะอัปเดตสถานะข้อความเตือนภัยเท่านั้น?',
  Cargo_IgnoreSelectedData: 'ข้อมูลการเตือนภัยที่เลือกทั้งหมดจะถูกละเลยหรือไม่',
  Cargo_Personnel: 'บุคลากร',
  Cargo_NewSopTemplate: 'เทมเพลต SOP ใหม่',
  Cargo_EditSopTemplate: 'แก้ไขแม่แบบ SOP',
  Cargo_CopySopTemplate: 'คัดลอกแม่แบบ SOP ปัจจุบัน',
  Cargo_SopTemplateName: 'ชื่อแม่แบบ SOP',
  Cargo_LookNode: 'ดูโหนด',
  Cargo_NewNode: 'โหนดใหม่',
  Cargo_EditNode: 'แก้ไขโหนด',
  Cargo_NewNodeStatus: 'สถานะโหนดใหม่',
  Cargo_NodeSettings: 'การตั้งค่าโหนด',
  Cargo_NodeStatusSettings: 'การตั้งค่าสถานะโหนด',
  Cargo_NoticeOfEachBill: 'การแจ้งเอกสารต่อตั๋ว (รวมบัตรเล็ก)',
  Cargo_NoNoticeOfTickets: 'ไม่แจ้งเอกสารตั๋วรายย่อย',
  Cargo_AlertSettings: 'การตั้งค่าการเตือนล่วงหน้า',
  Cargo_ConfigureSopMessagePush: 'กำหนดค่าการผลักข้อความ SOP',
  Cargo_NodeType: 'ประเภทโหนด',
  Cargo_WhetherToDisclose: 'ไม่ว่าจะเป็นสาธารณะ',
  Cargo_EditTheAlertConfiguration: 'แก้ไขการกำหนดค่าการเตือนล่วงหน้า',
  Cargo_AddedAlertConfiguration: 'เพิ่มการตั้งค่าการเตือนล่วงหน้า',
  Cargo_EditTheStatusDetails: 'แก้ไขรายละเอียดสถานะ',
  Cargo_NewStatusDetails: 'เพิ่มรายละเอียดสถานะ',
  Cargo_StatusDetails: 'รายละเอียดสถานะ',
  Cargo_SetUpSopTemplateApplicationBusinessScenarios: 'ตั้งค่าเทมเพลต SOP เพื่อใช้สถานการณ์ทางธุรกิจ',
  Cargo_QuicklySelectBusinessNodes: 'เลือกโหนดธุรกิจได้อย่างรวดเร็ว',
  Cargo_QuicklyConfigureDataServices: 'กำหนดค่าบริการข้อมูลได้อย่างรวดเร็ว',
  Cargo_QuicklyConfigureStatusNotifications: 'กำหนดค่าการแจ้งเตือนสถานะอย่างรวดเร็ว (Insider)',
  Cargo_ShipPlanningAtThePortOfDeparture: 'แผนการเดินเรือที่ท่าเรือ',
  Cargo_ContainerTracking: 'การติดตามสินค้ากล่อง',
  Cargo_ShipDynamicsAtThePortOfDestination: 'ท่าเรือปลายทาง พลวัตของเรือ',
  Cargo_CarryEmpty: 'ยกช่องว่าง',
  Cargo_TheActualDischarging: 'การขนถ่ายสินค้าจริง',
  Cargo_ReturnBox: 'ว่างเปล่า',
  Cargo_TheHomePageIsDisplayed: 'หน้าแรก แสดง',
  Cargo_QuicklyConfigureSettings: 'กำหนดค่าการตั้งค่าอย่างรวดเร็ว',
  Cargo_QuickConfigurationIsCheckedByDefault: 'กำหนดค่าติ๊กเริ่มต้นได้อย่างรวดเร็ว',
  Cargo_PleaseEnterAThemeTemplate: 'โปรดป้อนแม่แบบธีม',
  Cargo_PleaseEnterTheBodyTemplateContent: 'โปรดป้อนเนื้อหาของแม่แบบเนื้อหา',
  Cargo_PleaseEnterTheTemplateContent: 'โปรดป้อนเนื้อหาของแม่แบบ',
  Cargo_PleaseEnterAnExampleTemplate: 'โปรดป้อนตัวอย่างแม่แบบ',
  Cargo_SOPPushObjectChannelRepeats: 'SOP ผลักดันช่องวัตถุซ้ำ',
  Cargo_DataService: 'บริการข้อมูล',
  Cargo_WarningRuleTips: 'หลังจากอัปเดตสถานะโหนด SOP ข้อมูลการเตือนภัยที่สอดคล้องกันจะถูกทำเครื่องหมายว่าได้รับการประมวลผลแล้ว',
  Cargo_SopTemplateChangeTips: 'จับคู่กับเทมเพลต SOP ใหม่ 【{0}】, แม่แบบ SOP เดิมจะถูกเก็บไว้หรือไม่?',
  Cargo_ApplyTheSopTemplateAs: 'ใช้เทมเพลต SOP คือ:',
  Cargo_TheNodeIsShutDown: 'โหนดถูกปิด',
  Cargo_CanNotUploadFileOfNewContract: 'เพิ่มหมายเลขสัญญาที่ยังไม่ได้บันทึกไม่สามารถอัปโหลดไฟล์ได้!',
  Cargo_OrderReceiving: 'เชื่อมต่อเดี่ยว',
  Cargo_PrintTemplate: 'เทมเพลตการพิมพ์',
  Cargo_ControlObject: 'ควบคุมวัตถุ',
  Cargo_ControlMode: 'โหมดควบคุม',
  SetDefaultType: 'ตั้งค่าประเภทปริยาย',
  DefaultFileType: 'ประเภทแฟ้มปริยาย',
  DefaultType: 'ประเภทปริยาย',
  Cargo_ActualPaymentAmount: 'จำนวนเงินที่จ่าย',
  Cargo_ReceivedAmount: 'จำนวนเงินในบัญชี',
  Cargo_OcServiceCharge: 'ค่าธรรมเนียมการดำเนินการ OC',
  Cargo_ChannelServiceCharge: 'ค่าธรรมเนียมการจัดการช่องทางการชำระเงิน',
  Cargo_Abnormal: 'ไม่ว่าจะเป็นความผิดปกติ',
  Cargo_AbnormalState: 'ข้อยกเว้น',
  Cargo_AbnormalRemark: 'หมายเหตุ',
  Cargo_ProcessedDate: 'เวลาดำเนินการ',
  Cargo_UpdateReceivedAmount: 'แก้ไขยอดเงินในบัญชี',
  Cargo_AbnormalComment: 'หมายเหตุแบทช์ที่ผิดปกติ',
  Cargo_MarkAbnormal: 'เครื่องหมายผิดปกติ',
  Cargo_ValueAddedServices: 'บริการเสริม',
  Cargo_CustomsMode: 'วิธีการประกาศศุลกากร',
  Cargo_ServiceType: 'ประเภทของบริการ',
  Cargo_PODServices: 'ท่าเรือปลายทาง',
  Cargo_POD: 'ท่าเรือปลายทาง',
  Cargo_POL: 'ท่าเรือขนส่งสินค้า',
  Cargo_InitData: 'เริ่มต้นข้อมูล',
  Cargo_NotInitData: 'ข้อมูลที่มีอยู่แล้วไม่สามารถเริ่มต้นได้',
  Cargo_GeneratedVoucherInvoice: 'หมายเลขใบแจ้งหนี้ที่มีบัตรกำนัลที่สร้างขึ้น:',
  Cargo_DownLoad_Summary: 'ด/ล แม่แบบสรุป',
  Cargo_DownLoad_Detail: 'ด/ล แม่แบบรายละเอียด',
  Cargo_Import_OnOrder: 'นำเข้าการสั่งซื้อ',
  Cargo_Not_Submit: 'ยืนยันจะไม่ยื่นหนังสือชั่วคราวหรือไม่',
  Cargo_Not_Approved: 'คำสั่งซื้อของ 【เพื่อตรวจสอบ】 ไม่สามารถส่งได้เป็นจำนวนมากเท่านั้น!',
  Cargo_Not_Submit_Please: 'กรุณาเลือกธุรกิจของ 【งดส่งหนังสือชั่วคราว】!',
  Cargo_Not_Submit_Batch_Success: 'ไม่ส่งการปรับปรุงสถานะสำเร็จชั่วคราว',
  Cargo_Submit_Batch: 'กรุณาเลือกธุรกิจที่ต้องการ 【ส่ง】',
  Cargo_Submit_Pre_Qualification: 'ยืนยันสถานะการยื่นฟ้องคดีล่วงหน้าหรือไม่',
  Cargo_Submit_Job: 'ธุรกิจที่สามารถส่งได้เป็นจำนวนมากเท่านั้น 【งดส่งหนังสือชั่วคราว】',
  Cargo_Submit_Success: 'ส่งคำสั่งซื้อแล้ว',
  Cargo_OnlySelectedOneVoucher: 'สามารถเลือกข้อมูลได้เพียงรายการเดียวสำหรับการส่งออก',
  Cargo_BatchSetCategory: 'ประเภทการตั้งค่าแบทช์',
  Cargo_ExportExcelTemplate: 'ส่งออกแม่แบบ Excel?',
  Cargo_Run: 'วิ่ง',
  Cargo_ExcelTemplateExport: 'การส่งออกรายงาน Excel',
  CARGO_OFFICE_EMAIL_ISEMPTY: 'อีเมลสาขาปัจจุบันไม่ได้รับการบำรุงรักษาโปรดตรวจสอบ',
  Cargo_ChangeChargeChanged: 'ค่าธรรมเนียมเดิมของ {0} มีการแก้ไข (การเรียกเก็บเงิน / ใบแจ้งหนี้ / ใบสมัครการชำระเงิน / การตัดบัญชี ฯลฯ ) โปรดตรวจสอบ!',
  Cargo_SecondPolCode: 'ท่าเรือต้นทางที่สอง (รหัส)',
  Cargo_SecondPol: 'ท่าเรือต้นทางที่สอง',
  Cargo_SecondPodCode: 'ท่าเรือปลายทาง (รหัส)',
  Cargo_SecondPod: 'ท่าเรือปลายทางที่สอง',
  Cargo_WaybillDestination: 'ปลายทางของใบนำส่ง',
  Cargo_PolCountry: 'ประเทศ / ภูมิภาคการจัดส่ง',
  Cargo_IC: 'สายการบินบัตรระหว่างประเทศ',
  Cargo_IC_Master: 'ตั๋วสายการบินนานาชาติ',
  Cargo_IC_Basic: 'บัตรโดยสารระหว่างประเทศ',
  Cargo_Settlement: 'การชำระเงิน',
  Cargo_ReconciliationTab: 'แท็บการตรวจสอบ',
  Cargo_BillTab: 'แท็บบิล',
  Cargo_CancelApprovalCheck: 'ข้อมูลที่เลือกมีธุรกิจที่ส่ง BO แล้ว ไม่อนุญาตให้ยกเลิกการตรวจสอบ โปรดตรวจสอบ!',
  Cargo_BusinessPushStatus: 'สถานะการส่งข้อมูลธุรกิจ',
  Cargo_CostPushStatus: 'สถานะการส่งข้อมูลค่าใช้จ่าย',
  Cargo_AutoGenerateEnabled: 'สร้างอัตโนมัติหรือไม่',
  Cargo_BusinessQuotationAmount: 'จำนวนเงินเสนอราคาทางธุรกิจ',
  Cargo_BusinessQuotationConfirmed: 'การเสนอราคาทางธุรกิจได้รับการยืนยัน',
  Cargo_BusinessQuotationConfirmedCancel: 'ยกเลิกการยืนยันข้อเสนอ',
  Cargo_OperationAllowedOnlyForUnconfirmedQuotation: 'การดำเนินการนี้อนุญาตเฉพาะค่าใช้จ่ายที่มีการยืนยันการเสนอราคาเป็น "ไม่" เท่านั้น!',
  Cargo_OperationAllowedOnlyForConfirmedNonZeroQuotation: 'การดำเนินการนี้อนุญาตเฉพาะค่าใช้จ่ายที่มีการเสนอราคาทางธุรกิจไม่เท่ากับ 0 และมีการยืนยันการเสนอราคาเป็น "ใช่" เท่านั้น!',
  Cargo_VehicleModel: 'รุ่นรถ',
  Cargo_TypeKh: 'คาร์แอร์',
  Cargo_waybillInvoice: 'ข้อมูลใบแจ้งหนี้ใบนำส่งสินค้า',
  Cargo_customsMethodPol: 'วิธีการประกาศศุลกากร',
  Cargo_transferAgent: 'ตัวแทนการขนส่ง',
  Cargo_destinationAgent: 'ตัวแทนปลายทาง',
  Cargo_dispatchingPlace: 'สถานที่จัดส่ง',
  Cargo_dispatchingPlace2: 'สถานที่รับ/ส่ง',
  Cargo_dischargingPortCode: 'สถานที่ขนถ่าย (POD)',
  Cargo_transferPortCode: 'แปลงที่ดิน',
  Cargo_loadingPortCode: 'สถานที่จัดส่ง (POL)',
  Cargo_actAta: 'วันที่มาถึงจริง (ATA)',
  Cargo_estEta: 'วันที่คาดว่าจะมาถึง (ETA)',
  Cargo_actAtd: 'วันที่จัดส่งจริง (ATD)',
  Cargo_estEtd: 'วันที่จัดส่งโดยประมาณ (ETD)',
  Cargo_OrderCar: 'การจองห้องพัก',
  Cargo_DestinationDelivery: 'การจัดส่งปลายทาง',
  Cargo_trailerNumber: 'ลงทะเบียนรถ',
  Cargo_polInfo: 'ข้อมูล Port of Shipping Port',
  Cargo_estLandingTime: 'เวลามาถึงโดยประมาณของ CAR',
  Cargo_actLandingTime: 'เวลามาถึงจริงของสายการบิน',
  Cargo_estEntryTime: 'เวลาโดยประมาณขาเข้าของสายการบินคาร์แอร์',
  Cargo_actEntryTime: 'เวลาเข้าประเทศจริงของสายการบินคาร์แอร์',
  Cargo_estExitTime: 'เวลาโดยประมาณขาออกของ CAR',
  Cargo_actExitTime: 'เวลาขาออกจริงของสายการบิน',
  Cargo_estReplacementTime: 'คาดว่า CA AIR จะเปลี่ยนแปลงเวลา',
  Cargo_actReplacementTime: 'เวลาเปลี่ยนถ่ายจริงของสายการบิน',
  Cargo_declareTime: 'เวลาประกาศศุลกากรของสายการบินบัตรแอร์',
  Cargo_transferInfo: 'ข้อมูลการส่งต่อศุลกากร',
  Cargo_declareCompletedTime: 'ประกาศเวลาเสร็จสิ้นการขนส่ง',
  Cargo_estShippingTime: 'เวลาจัดส่งโดยประมาณของสถานที่จัดส่ง',
  Cargo_actShippingTime: 'เวลาจัดส่งจริง',
  Cargo_estArrivePodTime: 'คาดว่าจะถึงจุดหมายปลายทางเวลาชายแดน',
  Cargo_actArrivePodTime: 'เมื่อถึงจุดหมายปลายทางเวลาชายแดนจริง',
  Cargo_estEnterPodTime: 'เวลาปลายทางโดยประมาณ',
  Cargo_actEnterPodTime: 'เวลาปลายทางจริง',
  Cargo_estArriveClearTime: 'คาดว่าจะเดินทางมาถึงสถานที่ประกอบพิธีการศุลกากร',
  Cargo_actArriveClearTime: 'เวลามาถึงสถานที่พิธีการศุลกากรจริง',
  Cargo_estDischargeTime: 'เวลาขนถ่ายสินค้าโดยประมาณของ CAR',
  Cargo_actDischargeTime: 'เวลาขนถ่ายสินค้าจริงของสายการบินคาร์แอร์',
  Cargo_estArriveTime: 'เวลามาถึงโดยประมาณของรถพ่วง',
  Cargo_actArriveTime: 'เวลามาถึงจริงของรถพ่วง',
  Cargo_estTakeTime: 'คาดว่าเวลารับของรถพ่วง',
  Cargo_actTakeTime: 'เวลารับของจริงของรถพ่วง',
  Cargo_estUnloadTime: 'เวลาขนถ่ายโดยประมาณของรถพ่วง',
  Cargo_actUnloadTime: 'เวลาขนถ่ายจริงของรถพ่วง',
  Cargo_podInfo: 'ข้อมูลการจัดส่งไปยังท่าเรือปลายทาง',
  Cargo_estWarehouseDeliveryTime: 'เวลาการจัดส่งโดยประมาณ',
  Cargo_actWarehouseDeliveryTime: 'เวลาจัดส่งสินค้าในคลังสินค้าจริง',
  Cargo_estGoodsDeliveryTime: 'เวลาจัดส่งโดยประมาณ',
  Cargo_actGoodsDeliveryTime: 'เวลาจัดส่งจริง',
  Cargo_estReturnTime: 'คาดว่าจะใช้เวลาคืนพื้นที่',
  Cargo_actReturnTime: 'เวลาคืนพื้นที่จริง',
  Cargo_polPortInfo: 'ข้อมูลท่าเรือของสถานที่ขนส่ง',
  Cargo_khLandingTime: 'Kahang มาถึงฝั่ง',
  Cargo_khEntryTime: 'บัตรแอร์ขาเข้า',
  Cargo_khExitTime: 'KAAIN ขาออก',
  Cargo_khReplacementTime: 'Kahang เปลี่ยน',
  Cargo_khDeclare: 'ประกาศศุลกากรสายการบิน',
  Cargo_transferTransitInfo: 'ข้อมูลการส่งต่อศุลกากร',
  Cargo_transferDeclareCompleted: 'ประกาศแปลงที่ดินเสร็จสมบูรณ์',
  Cargo_transferShipping: 'การจัดส่งสินค้า',
  Cargo_arriveDestinationBorder: 'เดินทางมาถึงชายแดนปลายทาง',
  Cargo_podClearInfo: 'ข้อมูลพิธีการศุลกากรปลายทาง',
  Cargo_arrivePod: 'ถึงจุดหมายปลายทาง',
  Cargo_arriveClear: 'มาถึงสถานที่พิธีการศุลกากร',
  Cargo_khUnloading: 'คาร์แอร์',
  Cargo_polExchangeInfo: 'ข้อมูลการยกขนถ่ายที่ดินขึ้น',
  Cargo_trailerLoad: 'รถพ่วงมารับสินค้า',
  Cargo_trailerArrive: 'รถพ่วงมาถึง',
  Cargo_trailerUnload: 'รถบรรทุกพ่วง',
  Cargo_podDeliveryInfo: 'ข้อมูลการจัดส่งปลายทาง',
  Cargo_warehouseDelivery: 'การจัดส่งสินค้าในคลังสินค้า',
  Cargo_goodsDelivery: 'การจัดส่งสินค้า',
  Cargo_podReturn: 'ว่างเปล่า',
  Cargo_estTime: 'เวลาโดยประมาณ',
  Cargo_actTime: 'เวลาจริง',
  Cargo_secondPlateNumber: 'ป้ายทะเบียน 2',
  Cargo_secondTrailerNumber: 'หมายเลขรถพ่วงที่ 2',
  Cargo_secondVehicleType: 'รุ่นที่สอง',
  Cargo_secondEtd: 'วันที่จัดส่ง',
  Cargo_secondPol: 'สถานที่จัดส่ง',
  Cargo_secondPod: 'จุดหมายปลายทาง',
  Cargo_secondLoadingTime: 'เวลาในการโหลด',
  Cargo_secondShippingTime: 'เวลาจัดส่ง',
  Cargo_secondArriveTime: 'เวลามาถึง',
  Cargo_secondDischargeTime: 'เวลาขนถ่าย',
  Cargo_secondTransportType: 'วิธีการโอน',
  Cargo_bargeInfo: 'ข้อมูลรถบรรทุก',
  Cargo_bargeEtd: 'วันที่จัดส่งรถบรรทุก',
  Cargo_bargeAtd: 'วันที่มาถึงของรถบรรทุก',
  Cargo_bargePlateNumber: 'ป้ายทะเบียนรถ',
  Cargo_bargeTrailerNumber: 'หมายเลขรถพ่วง',
  Cargo_bargePol: 'รถขนส่ง (POL)',
  Cargo_bargePod: 'จุดหมายปลายทางของรถบรรทุก (POD)',
  Cargo_ActualEntryTime: 'เวลาเข้าจริง',
  Cargo_ActualLoadingTime: 'เวลาโหลดจริง',
  Cargo_EstimatedDepartureTime: 'เวลาออกเดินทางโดยประมาณ',
  Cargo_ActualDepartureTime: 'เวลาออกเดินทางจริง',
  Cargo_EstimatedArrivalTime: 'เวลาโดยประมาณ',
  Cargo_ActualArrivalTime: 'เวลาเข้าพักจริง',
  Cargo_ActualBillingTime: 'เวลารับบัตรจริง',
  Cargo_ActualUnloadingTime: 'เวลาขนถ่ายจริง',
  Cargo_ActualArrivalNotificationTime: 'เวลาแจ้งสินค้ามาถึงจริง',
  Cargo_ActualPickupTime: 'เวลารับของจริง',
  Cargo_EstimatedTransitArrivalTime: 'เวลาต่อเครื่องที่คาดว่าจะมาถึง',
  Cargo_TransitArrivalTime: 'เวลาเปลี่ยนเครื่องมาถึง',
  Cargo_EstimatedTransitDepartureTime: 'คาดว่าจะเปลี่ยนเครื่องขึ้นเครื่อง',
  Cargo_TransitDepartureTime: 'เปลี่ยนเครื่อง เวลาออกเดินทาง',
  Cargo_bargeLine: 'รหัสเส้นทางทางหลวง',
  Cargo_bargeCarrierId: 'บริษัท ขนส่ง',
  Cargo_khPlateNumber: 'หมายเลขทะเบียน KAHANG',
  Cargo_khPlateNum: 'ป้ายทะเบียน KAHANG',
  Cargo_PlateNums: 'หมายเลขทะเบียนรถภายในประเทศ',
  Cargo_khTrailerNumber: 'หมายเลขรถพ่วง CA AIR',
  Cargo_TypeTc: 'รถพ่วง',
  Cargo_SyncTargetDocumentNo: 'ซิงค์หมายเลขบัตรกำนัลของกันและกัน',
  Cargo_PleaseChooseTargetDocumentNo: 'โปรดเลือกบันทึกที่มีเลขบัตรกำนัลของกันและกัน',
  Cargo_WriteOffInputFail: 'ในค่าธรรมเนียมที่จะต้องชำระหนี้มีค่าใช้จ่ายที่ต้องชำระที่ยังไม่ได้ดำเนินการคำขอชำระเงินหรือกระบวนการขอชำระเงินยังไม่เสร็จสมบูรณ์ไม่อนุญาตให้มีการชำระหนี้!',
  Cargo_WriteOffInputFail2: 'ในค่าธรรมเนียมที่จะต้องชำระหนี้มีขั้นตอนการสมัครสำหรับการชำระเงินค่าธรรมเนียมที่ยังไม่เสร็จสมบูรณ์ไม่อนุญาตให้มีการชำระหนี้!',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC_Payment: 'การดำเนินการไม่สำเร็จ คำขอรับชำระเงินอยู่ในขั้นตอนการอนุมัติการชำระเงิน โปรดดำเนินการเมื่อกระบวนการเสร็จสิ้น',
  Cargo_estimation: 'ไม่ว่าจะเป็นการประเมินค่าชั่วคราว',
  Cargo_estimationAmount: 'จำนวนเงินโดยประมาณ',
  Cargo_CooperateBranchId: 'สาขาความร่วมมือ',
  Cargo_EntrustBranchId: 'สาขาที่ได้รับมอบหมาย',
  Cargo_CooperateBusinessType: 'ประเภทของธุรกิจร่วมกัน',
  Cargo_BillingWeightActual: 'น้ำหนักการเรียกเก็บเงิน (จริง)',
  Cargo_BillingWeightContract: 'น้ำหนักการเรียกเก็บเงิน (คณะกรรมการ)',
  Cargo_NumberOfItemsActual: 'จำนวนชิ้น (จริง)',
  Cargo_NumberOfItemsContract: 'จำนวนชิ้น (คณะกรรมการ)',
  Cargo_VolumeActual: 'ปริมาณ (ของแข็ง)',
  Cargo_VolumeContract: 'ปริมาณ (คณะกรรมการ)',
  Cargo_GrossWeightContract: 'น้ำหนักรวม (คณะกรรมการ)',
  Cargo_GrossWeightActual: 'น้ำหนักรวม (ของแข็ง)',
  Cargo_CooperateStatus: 'สถานะการทำงานร่วมกัน',
  Cargo_BusinessStatusRemark: 'สถานะธุรกิจ หมายเหตุ',
  Cargo_ChargeStatusRemark: 'สถานะค่าธรรมเนียม หมายเหตุ',
  Cargo_CooperateStatusLog: 'บันทึกการเปลี่ยนแปลงสถานะการทำงานร่วมกัน',
  Cargo_BusinessStatusLog: 'บันทึกการเปลี่ยนแปลงสถานะธุรกิจ',
  Cargo_ChargeStatusLog: 'บันทึกการเปลี่ยนแปลงสถานะค่าธรรมเนียม',
  Cargo_AssociatedWithMasterTicket: 'ไม่ว่าจะเป็นตั๋วหลักที่เกี่ยวข้อง',
  Cargo_SelectCooperateBranch: 'เลือกสาขาที่ร่วมมือกัน',
  Cargo_CooperateBranchCannotBeEmpty: 'สาขาความร่วมมือไม่สามารถว่างได้',
  Cargo_CooperateBusinessTypeCannotBeEmpty: 'ประเภทกิจการร่วมค้าต้องไม่ว่างเว้น',
  Cargo_Cooperation: 'การทำงานร่วมกัน',
  Cargo_CooperationReturn: 'ส่งคืน',
  Cargo_CooperateStatusApprovedCanTBeDeleted: 'สถานะการทำงานร่วมกันได้รับการตรวจสอบและไม่สามารถลบออกได้',
  Cargo_AreYouSureUpdateState: 'แน่ใจนะว่าอยากเปลี่ยนสถานะ?',
  Cargo_CooperateSucceed: 'ความสำเร็จในการทำงานร่วมกัน',
  Cargo_CooperateLogOperation: 'เนื้อหาการดำเนินงาน',
  Cargo_CooperateLogState: 'สถานะหลังการดำเนินการ',
  Cargo_CooperateLogContent: 'รายละเอียด',
  Cargo_AreYouSureReturn: 'แน่ใจนะว่าอยากคืน?',
  Cargo_CooperateCreatedDate: 'เวลาสร้างงานร่วมกัน',
  Cargo_CooperateReviewSeparately: 'ตรวจสอบว่ามีธุรกิจร่วมกันในบันทึกโปรดตรวจสอบแยกต่างหาก',
  Cargo_CooperateNoPretrialReview: 'ไม่มีการดำเนินการตรวจสอบการดำเนินงานร่วมกัน',
  Cargo_ShowCooperateAll: 'ข้อมูลเพิ่มเติมเกี่ยวกับการทำงานร่วมกัน',
  Cargo_SettleBranchId: 'บริษัท Settlement',
  Cargo_ShowInternalCharges: 'แสดงปมภายใน',
  Cargo_InternalCharges: 'ปมภายใน',
  Cargo_IsCooperate: 'เป็นธุรกิจร่วมกันและสามารถดำเนินการได้โดยการรับสาขาเดียว',
  Cargo_BranchCooperate: 'บริษัทช่วยเหลือธุรกิจ',
  Cargo_DownLoad_Template: 'ดาวน์โหลดแม่แบบ',
  Cargo_EstimatedWarehousingTime: 'เวลาโดยประมาณในการเข้าคลังสินค้า',
  Cargo_ActualWarehousingTime: 'เวลาเข้าคลังสินค้าจริง',
  Cargo_EstimatedDeliveryTime: 'เวลาที่คาดว่าจะออกจากคลังสินค้า',
  Cargo_ActualDeliveryTime: 'เวลาออกจากคลังสินค้าจริง',
  Cargo_SyncWarehouseData: 'รับข้อมูลคลังสินค้าแบบซิงโครนัส',
  Cargo_PleaseEnterActualWarehousingTime: 'โปรดป้อนเวลาเข้าคลังสินค้าจริง',
  Cargo_LockOrderTip: 'จะมีการอัพเดตธุรกิจที่ได้รับสิทธิ์ทั้งหมดเป็น 【ตรวจสอบแล้ว】 ว่าจะดำเนินการต่อหรือไม่',
  Cargo_RefreshTcloudToken: 'รีเฟรช openToken',
  Cargo_SeaBooking: 'จองห้องโดยสารทางทะเล',
  Cargo_RailwayOperate: 'การดำเนินงานรถไฟ',
  Cargo_IntegratedOperate: 'การดำเนินงานด้านโลจิสติกส์แบบครบวงจร',
  Cargo_Timezone: 'โซนเวลา',
  Cargo_HiddenPlatform: 'แบบหล่อสำเร็จรูปสำหรับแพลตฟอร์มที่ซ่อนอยู่',
  Cargo_TemplateName: 'ชื่อแผนแม่แบบ',
  Cargo_PleaseEnterPlanRemark: 'กรุณาใส่คำอธิบายโครงการ',
  Cargo_StartLine2: 'แถวเริ่มต้น (พร้อมคำอธิบายภาพ)',
  Cargo_PleaseEnterStartLine: 'โปรดป้อนแถวเริ่มต้น',
  Cargo_ImportTableSet: 'นำเข้าการตั้งค่าตาราง',
  Cargo_PleaseQuery: 'กรุณาค้นหา',
  Cargo_EnableFilterRowRule: 'เปิดใช้งานกฎบรรทัดตัวกรอง',
  Cargo_ImportColumnsFilterOut: 'เมื่อนำเข้าตารางแต่ละแถวของข้อมูลในคอลัมน์ที่ถูกต้องของตารางที่ตรงกับการตั้งค่าที่นี่จะถูกกรองออก',
  Cargo_SpaceGreaterThan: 'จำนวนช่องว่าง มากกว่า',
  Cargo_PleaseEnterHeaderName: 'ชื่อเซลล์ Excel: โปรดป้อนชื่อหัวตารางที่คุณต้องการนำเข้าตาราง Excel',
  Cargo_PleaseEnterHeaderGridNum: 'หมายเลขคอลัมน์เซลล์ Excel: โปรดป้อนหมายเลขคอลัมน์ที่คุณต้องการนำเข้าตาราง Excel เช่น: A、B、AA。',
  Cargo_AddNewTemplate: 'รูปแบบเทมเพลตนำเข้าใหม่',
  Cargo_SerialNo: 'หมายเลขซีเรียล',
  Cargo_InternalTableName: 'ชื่อแบบฟอร์มภายใน',
  Cargo_ExcelCellName: 'ชื่อเซลล์ Excel',
  Cargo_DocumentEntry: 'รายการประกาศศุลกากร',
  Cargo_QueryTags: 'เครื่องหมายสอบถาม',
  Cargo_ChargebackManage: 'การจัดการการคืนเงิน',
  Cargo_ReconciliationRule: 'กติกาการปรองดอง',
  Cargo_ReconciliationRuleName: 'ชื่อหลักเกณฑ์การปรองดอง',
  Cargo_MatchFieldSettings: 'การตั้งค่าฟิลด์ที่ตรงกัน',
  Cargo_PleaseSelectField: 'โปรดเลือกฟิลด์ที่ตรงกันเมื่อเปรียบเทียบ',
  Cargo_Relationship: 'ความสัมพันธ์',
  Cargo_And: 'ด้วย',
  Cargo_Or: 'หรือ',
  Cargo_MatchingOrder: 'ลำดับการจับคู่',
  Cargo_MatchFieldName: 'ชื่อฟิลด์ที่ตรงกัน',
  Cargo_CompareFieldOperations: 'การตั้งค่าฟิลด์เปรียบเทียบ',
  Cargo_SelectFieldToCompare: 'เลือกชื่อฟิลด์ที่ต้องการความคมชัด',
  Cargo_CompareOrder: 'ลำดับความคมชัด',
  Cargo_CompareField: 'ฟิลด์ความคมชัด',
  Cargo_ComparisonOperation: 'การดำเนินการเปรียบเทียบ',
  Cargo_MultiRowSumMethod: 'วิธีการสรุปหลายบรรทัด',
  Cargo_ComparisonSingleLine: 'ความคมชัดรายละเอียดบรรทัดเดียว',
  Cargo_AttachFilePlaneOrNot: 'แนบไฟล์สุ่มหรือไม่',
  Cargo_FlightDate: 'วันเดินทาง',
  Cargo_OtherWarehousingInstructions: 'คำอธิบายการเข้าสู่ตำแหน่งอื่น ๆ',
  Cargo_PhotoShootingAwait: 'รายการเข้าโกดังเพื่อถ่ายรูป',
  Cargo_PhotoShootingAwaitPallets: 'รายการติดตั้งบอร์ดเพื่อถ่ายภาพ',
  Cargo_DeleteSelected: 'ลบการเลือก',
  Cargo_StartUploading: 'เริ่มอัพโหลด',
  Cargo_Register: 'ลงทะเบียน',
  Cargo_Void: 'โมฆะ',
  Cargo_Unbind: 'แก้มัด',
  Cargo_OrderPassingAgent: 'ผ่านตัวแทนเดี่ยว',
  Cargo_BusinessBookiingAgent: 'ตัวแทนรับจองห้องพักธุรกิจ',
  Cargo_RegisteredDate: 'วันที่รับ',
  Cargo_EstimatedBackDate: 'วันที่คาดว่าจะเดินทางกลับ',
  Cargo_ActualBackDate: 'วันที่ส่งคืนจริง',
  Cargo_FreightRateM: 'ค่าจัดส่ง M',
  Cargo_FreightRateN: 'ค่าจัดส่ง N',
  Cargo_FreightRate45: 'ค่าจัดส่ง 45',
  Cargo_FreightRate100: 'ค่าจัดส่ง 100',
  Cargo_FreightRate300: 'ค่าจัดส่ง 300',
  Cargo_FreightRate500: 'ค่าจัดส่ง 500',
  Cargo_FreightRate1000: 'ค่าจัดส่ง 1000',
  Cargo_NewIATAFreightRate: 'อัตราค่าจัดส่ง IATA ใหม่',
  Cargo_EditIATAFreightRate: 'แก้ไขอัตราค่าจัดส่ง IATA',
  Cargo_DeliveryStation: 'สถานีจัดส่ง',
  Cargo_FlightSchedule: 'ตารางเที่ยวบิน',
  Cargo_Schedule: 'ระยะเวลาเรียน',
  Cargo_ArrivaledTime: 'เวลามาถึง',
  Cargo_Voyage: 'ระยะเวลาการเดินทาง',
  Cargo_MustBEntered: 'ต้องป้อน',
  Cargo_NewFlight: 'เที่ยวบินใหม่',
  Cargo_EditFlight: 'แก้ไขเที่ยวบิน',
  Cargo_OneWayPort: 'ท่าเรืออิจิจิง',
  Cargo_SecondPort: 'ท่าเรือสอง',
  Cargo_ThirdPort: 'ท่าเรือสามทาง',
  Cargo_TransshipmentPort: 'พอร์ตโอน',
  Cargo_NewLine: 'สายใหม่',
  Cargo_EditLine: 'แก้ไขบรรทัด',
  Cargo_NewAirTransportationArea: 'สร้างพื้นที่ทางอากาศใหม่',
  Cargo_EditAirTransportationArea: 'แก้ไขพื้นที่ทางอากาศ',
  Cargo_RegionalPorts: 'ท่าเรือภูมิภาค',
  Cargo_OriginRegionCode: 'รหัสพื้นที่จัดส่ง',
  Cargo_TargetRegionCode: 'รหัสพื้นที่ปลายทาง',
  Cargo_NewRoute: 'เส้นทางบินใหม่',
  Cargo_ResponsibilityList: 'รายการความรับผิดชอบ',
  Cargo_ResponsibilityInformation: 'ข้อมูลหน้าที่และความรับผิดชอบ',
  Cargo_ResponsibilityStep1: 'ขั้นตอนที่ 1: ป้อนข้อมูลพื้นฐานของความรับผิดชอบ',
  Cargo_ResponsibilityStep2: 'ขั้นตอนที่ 2: เลือกเส้นทางบิน',
  Cargo_ResponsibilityStep3: 'ขั้นตอนที่ 3: เลือกสายการบิน',
  Cargo_ResponsibilityStep4: 'ขั้นตอนที่ 4: เลือกลักษณะการจอง',
  Cargo_ResponsibilityStep5: 'ขั้นตอนที่ 5: เลือก Airport',
  Cargo_ResponsibilityStep6: 'ขั้นตอนที่ 6: เลือกการขาย',
  Cargo_ResponsibilityStep7: 'ขั้นตอนที่ 7: กำหนดข้อมูลความรับผิดชอบ',
  Cargo_ResponsibilityNew: 'หน้าที่การดำเนินงานใหม่',
  Cargo_ResponsibilityEdit: 'แก้ไขหน้าที่การดำเนินงาน',
  Cargo_QueryType: 'ประเภทของการสอบถาม',
  Cargo_NotClearedToday: 'ยังไม่ได้รายงานตัวดีวันก่อน',
  Cargo_ToBeClearedToday: 'เที่ยวบินในวันที่ประกาศศุลกากร',
  Cargo_DeclarationTheSameDay: 'ประกาศศุลกากรในวันเดียวกัน',
  Cargo_InculdeHistoricalData: 'มีข้อมูลย้อนหลัง',
  Cargo_DeclarationTracking: 'การติดตามประกาศศุลกากร',
  Cargo_FlightTracking: 'การติดตามเที่ยวบิน',
  Cargo_ModifyDeclarationBatches: 'แก้ไขสถานะการประกาศศุลกากรเป็นชุด',
  Cargo_PrintedTag: 'แท็กแล้ว',
  Cargo_PrintTag: 'พิมพ์ฉลาก',
  Cargo_CheckData: 'ตรวจสอบข้อมูล',
  Cargo_AWBQuantity: 'จำนวนชิ้นที่ทำ',
  Cargo_AWBWeight: 'น้ำหนักรวมในการทำแผ่น',
  Cargo_AWBVolume: 'ปริมาณการสั่งซื้อสินค้า',
  Cargo_GoodsSize: 'ขนาดของสินค้า',
  Cargo_ActualFlight: 'เที่ยวบินจริง',
  Cargo_OnwardInformation: 'ข้อมูลการต่ออายุ',
  Cargo_AttachmentDescription: 'คำอธิบายอุปกรณ์เสริม',
  Cargo_CustomsDeclarationStatus: 'สถานะการประกาศศุลกากร',
  Cargo_NumberDeclaration: 'จำนวนประกาศศุลกากร',
  Cargo_DeclarationGrossWeight: 'น้ำหนักรวมของการประกาศศุลกากร',
  Cargo_CustomsDeclarationRemarks: 'หมายเหตุประกาศศุลกากร',
  Cargo_DeleteAccountingEntry: 'ลบรายการ',
  Cargo_Assets: 'สินทรัพย์',
  Cargo_LineNo: 'จำนวนแถว',
  Cargo_LiabilitiesOwner: 'หนี้สินและส่วนของเจ้าของ (หรือผู้ถือหุ้น)',
  Cargo_LineNo2: 'จำนวนแถว',
  Cargo_OpeningAmountOfTheYear2: 'จำนวนต้นปี',
  Cargo_PeriodEndAmount2: 'จำนวนงวดสิ้นสุด',
  Cargo_AmountOfMonth: 'จำนวนเงินที่เกิดขึ้นในเดือน',
  Cargo_AmountOfYear: 'ยอดสะสมตลอดปี',
  Cargo_TrackingTipOne: 'ไอคอนนี้ใช้สำหรับระบบ B2B ในการใช้งาน!',
  Cargo_TrackingTipTwo: 'หมายเหตุ: แนะนำให้อัปโหลดโดยใช้ไอคอน png สีขาวที่มีขนาดไม่เกิน 500 KB',
  Cargo_WarehouseMapTip: 'หมายเหตุ: รูปภาพที่แนะนำให้อัปโหลดแผนที่คลังสินค้าคือ PNG / JPG',
  Cargo_UploadDataSizeMore500KB: 'ขนาดไฟล์ต้องไม่เกิน 500 KB!',
  Cargo_RuleNotesTip: 'หมายเหตุสามารถกรอกข้อมูลเพื่อให้ผู้ใช้สามารถดูคำแนะนำหมายเหตุที่เกี่ยวข้องเมื่อใช้งานได้ง่าย',
  Cargo_MainOrderRegistr: 'ลงทะเบียนรายการหลัก',
  Cargo_MainOrderStart: 'หมายเลขเริ่มต้นเดี่ยวหลัก',
  Cargo_TotalCopies: 'จำนวนเสิร์ฟทั้งหมด',
  Cargo_LastUpdateTime: 'เวลาปรับปรุงล่าสุด',
  Cargo_AddBranch: 'เพิ่มสาขา',
  Cargo_CopyBranch: 'คัดลอกสาขา',
  Cargo_EORIDetail: 'รายละเอียด EORI',
  Cargo_DeleteEORITip: 'EORI ไม่สามารถกู้คืนหลังจากการลบยืนยันการลบ?',
  Cargo_EORINotNull: 'EORI ไม่สามารถว่างได้',
  Cargo_EORINotDuplicate: 'EORI ไม่สามารถทำซ้ำได้',
  Cargo_AddDept: 'เพิ่มแผนก',
  Cargo_BranchCnName: 'ชื่อภาษาจีนของสาขา',
  Cargo_ChineseAddress: 'ที่อยู่ภาษาจีน',
  Cargo_BranchEnName: 'สาขา ชื่อภาษาอังกฤษ',
  Cargo_BranchCode: 'รหัสสาขา',
  Cargo_PostalCode: 'รหัสไปรษณีย์',
  Cargo_Email: 'อีเมล์',
  Cargo_LocalCurrency2: 'สกุลเงินท้องถิ่น',
  Cargo_DefaultAirport: 'ปริยายว่างเปล่า',
  Cargo_DefaultHarbor: 'ท่าเรือปริยาย',
  Cargo_DefaultTimeZone: 'โซนเวลาปริยาย',
  Cargo_RMBAccount: 'บัญชี RMB สำหรับชำระเงิน',
  Cargo_USDAccount: 'บัญชี USD สำหรับชำระเงิน',
  Cargo_ReceiveRMBAccount: 'บัญชี RMB สำหรับรับเงิน',
  Cargo_ReceiveUSDAccount: 'บัญชี USD สำหรับรับเงิน',
  Cargo_DefaultPaymentAccount: 'ค่าเริ่มต้นการชำระ',
  Cargo_DefaultReceiveAccount: 'ค่าเริ่มต้นการรับ',
  Cargo_OverseasBillingAddress: 'ที่อยู่สำหรับการเรียกเก็บเงินในต่างประเทศ',
  Cargo_DomesticBillingAddress: 'ที่อยู่สำหรับการเรียกเก็บเงินภายในประเทศ',
  Cargo_OverseasEDICode: 'รหัส EDI ในต่างประเทศ',
  Cargo_ValueAddedTaxRate: 'อัตราภาษีที่เพิ่มขึ้น',
  Cargo_InvoicingTaxRate: 'อัตราภาษีเรียกเก็บเงิน',
  Cargo_SettleEmail: 'การตั้งถิ่นฐานกล่องจดหมาย',
  Cargo_TaxationSystemAPIAddress: 'ที่อยู่ติดต่อระบบภาษี',
  Cargo_TaxControlMachineNo: 'หมายเลขควบคุมภาษี',
  Cargo_ElectronicInvoicePlatformCode: 'การเข้ารหัสแพลตฟอร์มตั๋วไฟฟ้า',
  Cargo_ElectronicInvoice: 'รหัสตั๋วไฟฟ้า',
  Cargo_ElectronicInvoiceTaxpayer: 'หมายเลขประจำตัวผู้เสียภาษีบัตรโดยสารไฟฟ้า',
  Cargo_ElectronicInvoiceAuthCode: 'รหัสประจำตัวผู้เสียภาษีบัตรโดยสารไฟฟ้า',
  Cargo_ElectronicInvoiceRequestAddress: 'ที่อยู่ขอใช้บริการตั๋วไฟฟ้า',
  Cargo_InvoiceCancellationRequestAddress: 'ที่อยู่คำขอใบแจ้งหนี้เป็นโมฆะ',
  Cargo_EFreighAMSAccount: 'E-Freigh (บัญชี AMS)',
  Cargo_EFreighACIAccount: 'E-Freigh (บัญชี ACI)',
  Cargo_Preview: 'แสดงตัวอย่าง',
  Cargo_NewBranchInformation: 'ข้อมูลสาขาใหม่',
  Cargo_AssociatePartners: 'พันธมิตรพันธมิตร',
  Cargo_AddRole: 'เพิ่มบทบาท',
  Cargo_DepartmentCode: 'รหัสแผนก',
  Cargo_JobNumberCodeField: 'ฟิลด์การเข้ารหัสหมายเลขงาน',
  Cargo_SettlementCompanyIsOrNot: 'ไม่ว่าจะเป็นบริษัทที่ตั้งถิ่นฐาน',
  Cargo_Introduction: 'บทนำ',
  Cargo_EnableOpen: 'เปิด',
  Cargo_DisableOpen: 'ปิด',
  Cargo_GeneralSettings: 'ใช้การตั้งค่าสำนักงานใหญ่',
  Cargo_ControlMode2: 'โหมดควบคุม:',
  Cargo_ReminderMode: 'โหมดเตือนความจำ',
  Cargo_LockMode: 'โหมดล็อคเดี่ยว',
  Cargo_Notification: 'การแจ้งเตือน:',
  Cargo_LockingControl: 'การควบคุมการล็อค:',
  Cargo_Event: 'กิจกรรม',
  Cargo_NotificationMethod: 'วิธีการแจ้งเตือน',
  Cargo_NotificationObject: 'วัตถุแจ้งเตือน',
  Cargo_BLRelease: 'ใบตราส่งสินค้า',
  Cargo_NoLock: 'ไม่หักค่าใช้จ่าย',
  Cargo_NewOrCopyJob: 'เพิ่ม / คัดลอกธุรกิจอย่างเป็นทางการ',
  Cargo_LockAfterSaving: 'ล็อคหลังจากบันทึก',
  Cargo_CannotBeSaved: 'ไม่สามารถบันทึกได้',
  Cargo_JobSheetIsLocked: 'ธุรกิจถูกล็อค',
  Cargo_JobSheetIsUnlocked: 'ธุรกิจถูกปลดล็อก',
  Cargo_CreditLimitExceeded2: 'นอกเหนือการควบคุมเครดิต',
  Cargo_CreditLimitChanged: 'การเปลี่ยนแปลง Credit',
  Cargo_CreditForewarning: 'เตือนภัยล่วงหน้า',
  Cargo_PaymentPeriodForewarning: 'การแจ้งเตือนเวลาบัญชี',
  Cargo_CreditControlManager: 'หัวหน้าฝ่ายควบคุมเครดิต',
  Cargo_TemplateManagement: 'การจัดการเทมเพลต',
  Cargo_TemplateTypeManagement: 'การจัดการประเภทเทมเพลต',
  Cargo_ConfigurationManagement: 'การจัดการการกำหนดค่า',
  Cargo_MappingManagement: 'การจัดการแผนที่',
  Cargo_InitializeTemplateManagement: 'เริ่มต้นการจัดการแม่แบบ',
  Cargo_BusinessStatusManagement: 'การจัดการสถานะธุรกิจ',
  Cargo_TriggerTypeManagement: 'การจัดการประเภททริกเกอร์',
  Cargo_FileTypeManagement: 'การจัดการประเภทไฟล์',
  Cargo_DefaultValueManagement: 'การจัดการค่าปริยาย',
  Cargo_ValidationRuleConfiguration: 'ตรวจสอบการกำหนดค่ากฎ',
  Cargo_EDITemplateSettings: 'การตั้งค่า EDI',
  Cargo_OnlineShippingOrderSettings: 'การตั้งค่า Online-to-Single สำหรับการขนส่งทางทะเล',
  Cargo_RouteAndWarehouseConfiguration: 'การกำหนดค่าเส้นทาง / พอร์ตที่ตั้งไว้ล่วงหน้า',
  Cargo_PushServiceConfiguration: 'การกำหนดค่าบริการ Push',
  Cargo_CustomInvoiceRemarks: 'หมายเหตุการปรับแต่งใบแจ้งหนี้',
  Cargo_EmailTemplateManagement: 'การจัดการแม่แบบกล่องจดหมาย',
  Cargo_BillOfLadingConfiguration: 'ใส่การกำหนดค่าเดียว',
  Cargo_BranchBankAccount: 'เลขที่บัญชีธนาคารของสาขา',
  Cargo_SetRMBAccount: 'ตั้งค่าเป็นหมายเลขบัญชี RMB เริ่มต้น',
  Cargo_SetUSDAccount: 'ตั้งค่าเป็นบัญชี USD เริ่มต้น',
  Cargo_SetReceiveRMBAccount: 'ตั้งค่าเป็นบัญชี RMB สำหรับรับเงินเริ่มต้น',
  Cargo_SetReceiveUSDAccount: 'ตั้งค่าเป็นบัญชี USD สำหรับรับเงินเริ่มต้น',
  Cargo_SetDefaultPaymentAccount: 'ตั้งค่าบัญชีชำระเงินเริ่มต้น',
  Cargo_SetDefaultReceiveAccount: 'ตั้งค่าบัญชีรับเงินเริ่มต้น',
  Cargo_ShortName: 'ชื่อย่อ',
  Cargo_Instructions: 'คำแนะนำ',
  Cargo_BankChineseAddress: 'ธนาคารที่อยู่ภาษาจีน',
  Cargo_BankEnglishAddress: 'ธนาคารที่อยู่ภาษาอังกฤษ',
  Cargo_BankCode: 'หมายเลขบัญชีธนาคาร',
  Cargo_HeaderTitle: 'ชื่อหัวเรื่องที่เกี่ยวข้อง',
  Cargo_ClosingAccountRecord: 'บันทึกการปิดบัญชี',
  Cargo_ClosingAccountReview: 'การตรวจสอบบัญชีปิด',
  Cargo_EditConfigurationItem: 'แก้ไขรายการปรับแต่ง',
  Cargo_SelectClosingAccountDate: 'เลือกวันที่ปิดบัญชี',
  Cargo_EditConfigurationDefinition: 'แก้ไขคำจำกัดความการกำหนดค่า:',
  Cargo_CreditLimitExceededApproval: 'ล็อคแผ่นงานจนกว่าจะปลดล็อคอัตโนมัติหรือชุดพิเศษที่มนุษย์สร้างขึ้นหลังจากการควบคุมเครดิต',
  Cargo_CreditOnlyReminder: 'หลังจากการควบคุมเครดิตเกินจะส่งการแจ้งเตือนเท่านั้นแผ่นงานจะไม่ถูกล็อค',
  Cargo_OperationExecutive: 'หัวหน้าฝ่ายปฏิบัติการ',
  Cargo_SalesExecutive: 'เจ้าหน้าที่ฝ่ายขาย',
  Cargo_CreditControlSupervisor: 'หัวหน้าฝ่ายควบคุมเครดิต',
  Cargo_BusinessCustomerService: 'ฝ่ายบริการลูกค้าธุรกิจ',
  Cargo_EmailsAndReminders: 'จดหมายและการแจ้งเตือน',
  Cargo_Bell2: 'ระฆังภายในสถานี',
  Cargo_Email2: 'จดหมาย',
  Cargo_BatchAddRolePermissions: 'การเพิ่มสิทธิ์บทบาทเป็นกลุ่ม',
  Cargo_RoleName: 'ชื่อตัวละคร',
  Cargo_PermissionName: 'ชื่ออนุญาต',
  Cargo_PermissionCategory: 'คลาสสิทธิ์',
  Cargo_PermissionType: 'ประเภทการอนุญาต',
  Cargo_PermissionPoint: 'จุดอนุญาต',
  Cargo_UpdatePermissionGroups: 'อัปเดตกลุ่มสิทธิ์',
  Cargo_Personal2: 'รายบุคคล',
  Cargo_DepartmentGroups: 'การจัดกลุ่มแผนก',
  Cargo_GreaterRemove: 'ลบ >>',
  Cargo_LessAdd: '<< เพิ่ม',
  Cargo_PleaseEnterNameEtc: 'โปรดป้อนแบบสอบถามที่คลุมเครือเช่นชื่อภาษาจีนชื่อภาษาอังกฤษกล่องจดหมาย ...',
  QuickSearchUser: 'ดึงข้อมูลด่วน: ลงชื่อเข้าใช้, ชื่อภาษาจีน, ชื่อภาษาอังกฤษ, กล่องจดหมาย',
  Cargo_Expired: 'หมดอายุ',
  Cargo_NearExpiration: 'ระยะเวลา',
  Cargo_NotVetDueEytended: 'ยังไม่หมดอายุ/เลื่อน',
  Cargo_History: 'ประวัติความเป็นมา',
  Cargo_QuickSearchContractNumber: 'ดึงข้อมูลได้อย่างรวดเร็ว: หมายเลขสัญญา',
  Cargo_Reminder30Day: 'เคล็ดลับ: ระบบตั้งค่าล่วงหน้าภายใน 30 วัน',
  Cargo_PleaseSelectContractRecord: 'โปรดตรวจสอบบันทึกสัญญา',
  Cargo_ContractAgreement: 'ข้อตกลงสัญญา',
  Cargo_WhetherBookingConfirmation: 'ไม่ว่าจะเป็นการอัพโหลดบทจองห้องโดยสาร',
  Cargo_IsContractAgreementUploaded: 'ไม่ว่าจะเป็นการอัพโหลดสัญญาข้อตกลง',
  Cargo_ContractProhibitedOperated: 'มีการต่อสัญญาห้ามดำเนินการ',
  Cargo_NeedToUpdateOrNot: 'จำเป็นต้องอัพเดตหรือไม่',
  Cargo_ContractCreator: 'ผู้สร้างสัญญา',
  Cargo_ContractCreationTime: 'เวลาสร้างสัญญา',
  Cargo_PartnerCreation: 'ผู้สร้างพันธมิตร',
  Cargo_ContractAuditor: 'ผู้ตรวจสอบสัญญา',
  Cargo_ContractAuditTime: 'เวลาตรวจสอบสัญญา',
  Cargo_TimeLeftUntilExpiry: 'เหลือก่อนวันหมดอายุ',
  Cargo_DayRemind: 'เตือนสวรรค์',
  Cargo_NoteReminderMethod: 'หมายเหตุ: วิธีการเตือนคือ"ระบบแจ้งเตือน",ระบบจะแจ้งเตือนอีกครั้งก่อนวันหมดอายุ 2 วัน',
  Cargo_ProhibitBusinessConfiguration: 'ห้ามสร้างการกำหนดค่าทางธุรกิจ:',
  Cargo_SettlementMethodGreaterThan0: 'เงื่อนไขการชำระราคา กำหนดวัน/เดือน หรือระยะเวลาบัญชีมากกว่า 0',
  Cargo_ViewContract: 'ดูสัญญา',
  Cargo_PaymentTermPeriod: 'ช่วงระยะเวลาบัญชี',
  Cargo_WeekSettlement: 'ปมสัปดาห์',
  Cargo_EveryMonth: 'รายเดือน',
  Cargo_Day: 'วัน',
  Cargo_CAN_NOT_APPROVED: 'ธุรกิจที่มีสถานะ {0} ในข้อมูลที่เลือกไม่สามารถตรวจสอบได้โปรดตรวจสอบ!',
  Cargo_CAN_NOT_CANCEL_APPROVED: 'ข้อมูลที่เลือกมีธุรกิจที่มีสถานะ {0} ธุรกิจที่มีสถานะไม่ได้รับอนุญาตให้ยกเลิกการตรวจสอบโปรดตรวจสอบ!',
  Cargo_HasOneOnly: 'กรุณาเลือกหนึ่งระเบียนเท่านั้น!',
  Cargo_CloseAndCopySerialNumber: 'ปิดและคัดลอกเครื่องหมายน้ำ',
  Cargo_QuickSearchBillPayment: 'ดึงข้อมูลด่วน: หมายเลขคำขอชำระเงิน',
  Cargo_AmsNoTooltip: 'ขอแนะนำให้คุณส่งหนังสือพิมพ์ EDI จำนวนตัวอักษร AMS NO ไม่เกิน 12 หลัก',
  Cargo_AmsNoEFreightTooltip: 'ขอแนะนำให้คุณส่งหนังสือพิมพ์ EDI จำนวนอักขระ AMS NO ไม่เกิน 12 หลักและคำนำหน้าที่เท่ากับ Nvocc Scac จะถูกลบออกเมื่อส่ง',
  Cargo_AmsNoLengthTooltip: 'จำนวนอักขระ AMS NO เกิน 12 หลักแล้ว คุณต้องการที่จะส่งต่อไปหรือไม่?',
  Cargo_AmsShipperLine1tip: 'เคล็ดลับ: เมื่อชื่อ NAME ยาวเป็นพิเศษสามารถเติมลงใน ADDRESS1 ได้',
  Cargo_AmsUnitTypeTip: 'รหัสแผนที่ "รหัสบรรจุภัณฑ์ต่อต้านการก่อการร้าย" สามารถรักษาไว้ในการกำหนดค่าแผนที่',
  Cargo_VoyageFlightLengthTooltip: 'Voyage ไม่เกิน 5 ตัวอักษร',
  Cargo_VoyageFlightSpecialCharactersTooltip: 'มีอักขระพิเศษในแถบ Voyage คุณต้องการที่จะส่งต่อไปหรือไม่? แนะนำให้ส่งหลังจากที่ทำการเปลี่ยนแปลง!',
  Cargo_BargeRemarks: 'หมายเหตุ เรือขนส่งสาขา',
  Cargo_CalcRuleNotes: 'กฎการคำนวณ หมายเหตุ',
  Cargo_NotSupportStartOldApprove: '【สมัครชำระเงิน】 ไม่รองรับการอนุมัติเริ่มอีกต่อไป โปรดไปที่ 【สมัครชำระเงิน】 เพื่อเริ่มการอนุมัติ',
  Cargo_Pending: 'เพื่อดำเนินการ',
  Cargo_Processing: 'ในการประมวลผล',
  Cargo_Completed1: 'เสร็จสมบูรณ์',
  Cargo_Revoked: 'ยกเลิกแล้ว',
  Cargo_StartTime: 'เวลาเริ่มต้น',
  Cargo_StartDate: 'วันที่เริ่มต้น',
  Cargo_ProcessName: 'ชื่อกระบวนการ',
  Cargo_ApprovalSerialNumber: 'อนุมัติการไหล',
  Cargo_ApprovalDate: 'วันที่อนุมัติ',
  Cargo_Approver: 'ผู้อนุมัติ',
  Cargo_ApprovalTemplate: 'การอนุมัติ Stencil',
  Cargo_ProcessingStatus: 'สถานะการประมวลผล',
  Cargo_PleaseFill: 'กรุณากรอก',
  Cargo_PleaseMaintain: 'กรุณาบำรุงรักษา',
  Cargo_MessageNotificationMethod: 'วิธีการแจ้งเตือนข้อความ',
  Cargo_AreYouSureAboutTheModificationProcess: 'กำหนดกระบวนการแก้ไขหรือไม่',
  Cargo_AreYouSureAboutTheModificationProcessTips: 'ยืนยันว่าเมื่อแก้ไขแล้วกระบวนการในการประมวลผลจะดำเนินการต่อไปตามกระบวนการที่ริเริ่มไว้ กระบวนการริเริ่มที่ตามมาจะดําเนินการตามกระบวนการที่แก้ไขแล้ว',
  Cargo_SetUpTheProcessTriggerCondition: 'โปรดตั้งเงื่อนไขทริกเกอร์กระบวนการ',
  Cargo_CurrentApprover: 'ผู้อนุมัติปัจจุบัน',
  Cargo_Initiator: 'ผู้สนับสนุน',
  Cargo_ApprovalRecord: 'บันทึกการอนุมัติ',
  Cargo_SelectTheApprover: 'เลือกผู้อนุมัติ',
  Cargo_RoleSelection: 'การเลือกบทบาท',
  Cargo_ReviewTheProcessRecord: 'ดูบันทึกกระบวนการ',
  Cargo_BatchApproval: 'ความยินยอมเป็นกลุ่ม',
  Cargo_BatchReject: 'การปฏิเสธจำนวนมาก',
  Cargo_TerminateTheProcess: 'กระบวนการยุติ',
  Cargo_ApprovalComments: 'ความเห็นเกี่ยวกับการอนุมัติ',
  Cargo_ApprovalTime: 'เวลาอนุมัติ',
  Cargo_ApprovalCommentsRecord: 'บันทึกความเห็นการอนุมัติ',
  Cargo_IInitiated: 'ฉันเป็นผู้ริเริ่ม',
  Cargo_IDealWithIt: 'ฉันจัดการ',
  Cargo_SubmitAPaymentRequestForApproval: 'ยื่นคำขออนุมัติการชำระเงิน',
  Cargo_Approving: 'การอนุมัติ',
  Cargo_ThereIsDuplicateData: 'มีข้อมูลที่ซ้ำกัน',
  Cargo_SelectTheApprovalPosition: 'เลือกโพสต์อนุมัติ',
  Cargo_FilterDimension: 'พื้นฐานการกรอง',
  Cargo_FilterValue: 'ค่าการกรอง',
  Cargo_ReviewTheApprovalProcess: 'ดูขั้นตอนการอนุมัติ',
  Cargo_Committed: 'ส่งแล้ว',
  Cargo_Agreed: 'ตกลงแล้ว',
  Cargo_Opinion: 'ความเห็น',
  Cargo_ReviewWithdrawal: 'การถอนการตรวจสอบ',
  Cargo_ProcessRevocation: 'กระบวนการยกเลิก',
  Cargo_AlreadyWithdraw: 'ถอนแล้ว',
  Cargo_NoHandlingRequired: 'ไม่จำเป็นต้องได้รับการรักษา',
  Cargo_MyApprovals: 'การอนุมัติของฉัน',
  Cargo_ApprovalsThatIInitiated: 'การอนุมัติที่ฉันเริ่มต้น',
  Cargo_ApprovalsThatIHandle: 'การอนุมัติที่ฉันดำเนินการ',
  Cargo_CreateProcess: 'สร้างกระบวนการ',
  Cargo_EditProcess: 'กระบวนการแก้ไข',
  Cargo_CopyProcess: 'คัดลอกกระบวนการ',
  Cargo_DeleteProcess: 'กระบวนการลบ',
  Cargo_ProcessComment: 'หมายเหตุกระบวนการ',
  Cargo_RevertProcessStatus: 'ยกเลิกสถานะกระบวนการ',
  Cargo_RevertProcess: 'กระบวนการเพิกถอน',
  Cargo_RejectProcess: 'กระบวนการปฏิเสธ',
  Cargo_NotificationEmailCC: 'ข้อความแจ้งเตือน จดหมาย CC',
  Cargo_Irrevocable: 'ไม่สามารถเพิกถอนได้',
  Cargo_BindApprovalTemplate: 'ผูกแม่แบบการอนุมัติ',
  Cargo_ApplicationBusinessDivision: 'สาขาธุรกิจแอปพลิเคชัน',
  Cargo_ProcessTriggerCondition: 'เงื่อนไขทริกเกอร์กระบวนการ',
  Cargo_TriggerConditionConfiguration: 'การกำหนดค่าเงื่อนไขทริกเกอร์',
  Cargo_ApproverSource: 'แหล่งที่มาของผู้อนุมัติ',
  Cargo_ApproverExecutionMode: 'วิธีการดำเนินการของผู้อนุมัติ',
  Cargo_FirstNodeSupervisorNextNodePreviousApproverSupervisor: 'โหนดแรกเป็นผู้บังคับบัญชาระดับสูงสำหรับผู้ริเริ่มโหนดต่อมาเป็นผู้บังคับบัญชาของผู้อนุมัติโหนดก่อนหน้า',
  Cargo_AnyApproverCanHandle: 'ผู้อนุมัติคนใดคนหนึ่งสามารถประมวลผลได้',
  Cargo_AllApproversAtCurrentNodeRequired: 'ต้องมีการประมวลผลโดยผู้อนุมัติทั้งหมดของโหนดปัจจุบัน',
  Cargo_TheNumberOfApprovalsInProgress: 'จำนวนการอนุมัติที่กำลังดำเนินการ',
  Cargo_NotNamed: 'ไม่มีชื่อ',
  Cargo_AdministratorSettings: 'การตั้งค่าผู้ดูแลระบบ',
  Cargo_FormName: 'ชื่อแบบฟอร์ม',
  Cargo_NumberOfConfigurableBranches: 'จำนวนสาขาที่กำหนดค่าได้',
  Cargo_ExistDocumentPlatformConfig: 'สาขานี้มีอยู่แล้วสถานะของแบบฟอร์มนี้เปิดใช้งานโปรดดำเนินการหลังจากยืนยัน',
  Cargo_InitiateApproval: 'เริ่มต้นการอนุมัติ',
  Cargo_InitiateApprovalSuccessfully: 'เริ่มต้นการอนุมัติสำเร็จ',
  Cargo_AreYouSureToInitiateTheApproval: 'ยืนยันจะเริ่มอนุมัติหรือไม่',
  Cargo_AreYouSureToDo: 'ยืนยัน {0}?',
  Cargo_AgreeToTheApproval: 'ยินยอมอนุมัติ',
  Cargo_RejectApproval: 'ปฏิเสธการอนุมัติ',
  Cargo_InitiateBranchCompany: 'เริ่มต้นสาขา',
  Cargo_ApplicationBranch1: 'ใบสมัคร สาขา',
  Cargo_InitiateDepartment: 'ฝ่ายริเริ่ม',
  Cargo_WhetherItIsEnabled: 'ไม่ว่าจะเป็นการเปิดใช้งาน',
  Cargo_Deactivate: 'ปิดการใช้งาน',
  Cargo_PleaseSelectTenantId: 'โปรดเลือก Platform ID',
  Cargo_PleaseSelectOfficeIds: 'กรุณาเลือกสาขาการสมัคร',
  Cargo_PleaseSelectDocumentConfigId: 'โปรดเลือกชื่อแบบฟอร์ม',
  Cargo_PleaseSelectBranchCount: 'โปรดเลือกจำนวนสาขาที่กำหนดค่าได้',
  Cargo_PleaseSelectUserIds: 'โปรดเลือกการตั้งค่าผู้ดูแลระบบ',
  Cargo_DocumentPlatformConfigNote: 'หมายเหตุ: ผู้ดูแลระบบสามารถดูกระแสการอนุมัติทั้งหมดที่เกี่ยวข้องกับแบบฟอร์ม',
  Cargo_AddBranchProcess: '+ เพิ่มกระบวนการสาขา',
  Cargo_Priority: 'ลำดับความสำคัญ',
  Cargo_TriggerConditions: 'เงื่อนไขทริกเกอร์',
  Cargo_PleaseSelectDocumentConfigId2: 'กรุณาเลือกแบบฟอร์ม',
  Cargo_AddBranchProcessCheck: 'จำนวนสาขาของฟอร์มปัจจุบันถึงเพดานแล้ว',
  Cargo_BindForm: 'แบบฟอร์มผูก',
  Cargo_UnknownProcessProcessing: 'การประมวลผลกระบวนการที่ไม่รู้จัก',
  Cargo_AutoWriteOffAfterApproval: 'การอนุมัติแล้วจะถูกหักบัญชีอัตโนมัติหรือไม่',
  Cargo_Bell: 'ระฆัง',
  Cargo_NotifierSource: 'แหล่งที่มาของ CC',
  Cargo_PreconditionsForApproval: 'เงื่อนไขก่อนการอนุมัติ',
  Cargo_RuleConditions: 'เงื่อนไขกติกา',
  Cargo_ConditionalItem: 'รายการเงื่อนไข',
  Cargo_ConditionalRule: 'กฎเงื่อนไข',
  Cargo_ConditionalValue: 'มูลค่าตามเงื่อนไข',
  Cargo_RejectMethod: 'วิธีการปฏิเสธ',
  Cargo_AllowDirectReturnToInitiator: 'อนุญาตให้ส่งคืนผู้สนับสนุนโดยตรง',
  Cargo_ReturnToTheInitiatingNode: 'กลับไปที่โหนดเริ่มต้น',
  Cargo_Returned2: 'ส่งคืนแล้ว',
  Cargo_RefuseAndReturnNode: 'หมายเหตุ: การปฏิเสธ = ส่งคืนโหนดก่อนหน้าส่งคืน = ส่งคืนโหนดเริ่มต้น',
  Cargo_RefuseTitle: 'กลับไปที่โหนดก่อนหน้า',
  Cargo_ReturnTitle: 'กลับไปที่โหนดเริ่มต้น',
  Cargo_BillPaymentUpdateFail: 'การขอต่ออายุการชำระเงินไม่สำเร็จ',
  Cargo_OneClickCopy: 'คัดลอกด้วยคลิกเดียว',
  Cargo_OneClickCopyNote: 'หมายเหตุ: เครื่องหมายการไหลอนุมัติทั้งหมดสามารถคัดลอกได้โดยคลิกที่ปุ่ม "คัดลอกคลิกเดียว" สำหรับการสอบถามจำนวนมากในภายหลัง',
  Cargo_OneClickCopyNoteBillPaymentApply: 'หมายเหตุ: หมายเลขใบสมัครทั้งหมดสามารถคัดลอกได้โดยคลิกที่ปุ่ม "คัดลอกคลิกเดียว" สำหรับการสอบถามจำนวนมากในภายหลัง',
  Cargo_SubmitException: 'ยื่นข้อยกเว้น',
  Cargo_ApprovalException: 'ความผิดปกติในการอนุมัติ',
  Cargo_PriceType: 'กรุณาเลือกราคาก่อนท่าเรือ/ราคาหมายเลขเส้นทางหลัก/ราคาสุดท้าย ขั้นต่ำต้องเลือกประเภทการสอบถามอย่างน้อยหนึ่งรายการ',
  Cargo_AccountPeriodRemainingDays: 'จำนวนวันที่เหลือของงวดบัญชี',
  Cargo_WorkflowsBranchCountNotNull: 'จำนวนสาขาเวิร์กโฟลว์ไม่สามารถว่างได้',
  Cargo_WorkflowsPlatformConfigRepeat: 'สาขานี้มีอยู่แล้วสถานะของแบบฟอร์มนี้เปิดใช้งานโปรดดำเนินการหลังจากยืนยัน',
  Cargo_PleaseSelectUser: 'โปรดเลือกผู้ดูแลระบบของกระบวนการนี้',
  Cargo_Initiate: 'เริ่ม',
  Cargo_InitiateForm: 'แบบฟอร์มการเริ่มต้น',
  Cargo_ApprovalMatters: 'เรื่องอนุมัติ',
  Cargo_SelectApprovalWithSameTemplate: 'กรุณาเลือกเดียวกัน"เทมเพลตการอนุมัติ"เรื่องของการอนุมัติ',
  Cargo_SOPPanelNodeNotDisplayed: 'แผง SOP ไม่แสดงโหนดนี้',
  Cargo_SOPPanelNoDataHide: 'แผง SOP ซ่อนอัตโนมัติเมื่อไม่มีข้อมูล',
  Cargo_TaxInputConfig: 'การตั้งค่าภาษีเข้าข้อมูล',
  Cargo_ReceiptInvoiceTitle: 'หัวข้อใบแจ้งหนี้',
  Cargo_ReceiptInvoiceChannel: 'ช่องทางใบแจ้งหนี้',
  Cargo_InvoiceAssociation: 'การเชื่อมโยงใบแจ้งหนี้',
  Cargo_ManualUpdate: 'อัปเดตด้วยตนเอง',
  Cargo_GetInvoice: 'รับใบกำกับภาษี',
  Cargo_InvoiceTime: 'เวลาการออกใบแจ้งหนี้',
  Cargo_SellerName: 'ชื่อผู้ขาย',
  Cargo_SellerTaxNumber: 'หมายเลขภาษีผู้ขาย',
  Cargo_BuyerName: 'ชื่อผู้ซื้อ',
  Cargo_BuyerTaxNumber: 'หมายเลขภาษีผู้ซื้อ',
  Cargo_InvoicePool: 'สระใบกำกับภาษี',
  Cargo_InvoicePoolReceiving: 'การรับใบแจ้งหนี้ในพูล',
  Cargo_WriteOffBank: 'ธนาคารขายบัญชี',
  Cargo_DepartureStation: 'สถานีต้นทาง',
  Cargo_DestinationStation: 'สถานีปลายทาง',
  Cargo_TransitStation: 'สถานีขนส่ง',
  Cargo_TransferStation: 'สถานีขนส่ง',
  Cargo_QuickApprovalMode: 'วิธีการจัดการผู้อนุมัติเดียวกันในโหนดที่แตกต่างกัน',
  Cargo_AutoAgree: 'ความยินยอมอัตโนมัติ',
  Cargo_PressToDo: 'เร่งดำเนินการ',
  Cargo_CarbonCopy: 'ซีซี',
  Cargo_ApplicationDimension: 'มิติการสมัคร',
  Cargo_ApplicationCode: 'สมัครการเข้ารหัส',
  Cargo_TotalReceivable: 'รวมลูกหนี้',
  Cargo_TotalDues: 'การชำระเงินทั้งหมด',
  Cargo_PackingType: 'ประเภทบรรจุภัณฑ์',
  Cargo_ViewChargeDetails: 'ดูรายละเอียดค่าใช้จ่าย',
  Cargo_StartingPort: 'พอร์ตเริ่มต้น',
  Cargo_SubmitJobChargeForApproval: 'ยื่นคำขออนุมัติค่าธรรมเนียมธุรกิจ',
  Cargo_SubmitJobChargeTip: 'ธุรกิจตั๋วนี้ต้องเริ่มกระบวนการส่งอนุมัติก่อน กระบวนการจะถูกส่งโดยอัตโนมัติหลังจากผ่านและการส่งล้มเหลวจะล้มเหลว \#n คุณต้องการเริ่มการอนุมัติตอนนี้หรือไม่?',
  Cargo_SubmitJobChargeFailTip: 'ไม่มีกระบวนการอนุมัติค่าใช้จ่ายที่ตรงกันในขณะนี้ โปรดติดต่อหัวหน้างานเพื่อเริ่มการส่งอีกครั้งหลังจากปรับปรุงเงื่อนไขทริกเกอร์ในกระบวนการอนุมัติ',
  Cargo_BillHasBeenInitiatedForApproval: 'ใบเรียกเก็บเงินนี้ได้รับการอนุมัติแล้ว สามารถลงนามในหน้ารายการอนุมัติ "ฉันเริ่มต้น" เพื่อตรวจสอบความคืบหน้าและรายละเอียดการอนุมัติ',
  Cargo_SubmitInvoiceFailTip: 'ไม่มีกระบวนการอนุมัติการออกใบแจ้งหนี้ที่สามารถจับคู่ได้ชั่วคราว โปรดติดต่อหัวหน้างานเพื่อเริ่มการส่งอีกครั้งหลังจากปรับปรุงเงื่อนไขทริกเกอร์ในกระบวนการอนุมัติ',
  Cargo_SubmitInvoiceTip: 'เริ่มกระบวนการอนุมัติใบแจ้งหนี้ก่อนใบแจ้งหนี้ คุณต้องการเริ่มการอนุมัติตอนนี้หรือไม่?',
  Cargo_SOURCE_CURRENCY_NOT_NULL: 'สกุลเงินดั้งเดิมไม่สามารถว่างเปล่า!',
  Cargo_SOURCE_AMOUNT_NOT_NULL: 'จำนวนเหรียญเดิมไม่สามารถว่างเปล่า!',
  Cargo_imWarning: 'งานปัจจุบันมีบุคลากรบทบาทไม่เพียงพอที่จะเปิดกลุ่มแชทของ Wo Hung Tong',
  Cargo_ReceiptPaymentOffset: 'การชำระเงินล่วงหน้าล้างกลับ',
  Cargo_InvoicePayableOffset: 'ต้นทุนการดำเนินงานรีบกลับ',
  Cargo_CheckFreightTermOne: 'เมื่อ "{0}" เงื่อนไขการขนส่ง {1} และ {2} จะไม่ว่างเปล่า',
  Cargo_CheckFreightTermTwo: 'เมื่อ "{0}" เงื่อนไขการขนส่ง {1} จะไม่ว่างเปล่า',
  Cargo_ThirdTableCheck: 'ตารางกลางของบุคคลที่สามได้รับการผลักดันและไม่สามารถดำเนินการได้',
  Cargo_CheckMergeExport: 'ใบแจ้งหนี้และการชำระเงินล่วงหน้ารีบกลับไปที่บัตรกำนัลและส่งออกบัตรกำนัล, ติ๊กบันทึกไม่สามารถชนิดของบัตรกำนัลอื่น ๆ. กรุณาตรวจสอบ',
  CargoMsg_QQ: 'QQ',
  CargoMsg_CorporateName: 'ชื่อบริษัทนิติบุคคล',
  Cargo_DeleteUnApprovedBillTips: 'ลบเฉพาะบิลที่ยังไม่ได้อนุมัติ!',
  Cargo_EditUnApprovedBillTips: 'แก้ไขเฉพาะบิลที่ยังไม่ได้อนุมัติ!',
  Cargo_DeleteUnApprovedInvoiceTips: 'ลบใบแจ้งหนี้ที่ยังไม่ได้อนุมัติเท่านั้น!',
  Cargo_InvalidUnApprovedInvoiceTips: 'ยกเลิกใบแจ้งหนี้ที่ยังไม่ได้อนุมัติเท่านั้น!',
  Cargo_InvoiceID: 'หมายเลขใบแจ้งหนี้',
  Cargo_PleaseSelectNeedInvalidBillPaymentTip: 'โปรดเลือกคำขอชำระเงินที่ต้องการเป็นโมฆะ',
  Cargo_Deleted: 'ลบแล้ว',
  Cargo_EnableSopTemplate: 'เปิดใช้เทมเพลต sop ปัจจุบัน',
  Cargo_UnableSopTemplate: 'ปิดใช้งานแม่แบบ sop ปัจจุบัน',
  Cargo_EnableSopTemplateConfirm: 'ยืนยันการเปิดใช้งานแม่แบบ SOP ปัจจุบันหรือไม่?',
  Cargo_UnableSopTemplateConfirm: 'ยืนยันการปิดใช้งานแม่แบบ SOP ปัจจุบันหรือไม่? หลังจากปิดการใช้งานแล้ว ธุรกิจจะไม่สามารถใช้เทมเพลตนี้ได้ แต่จะไม่ส่งผลกระทบต่อธุรกิจที่ใช้เทมเพลตนี้อยู่แล้ว',
  Cargo_Disabled2: '(ปิดการใช้งาน)',
  Cargo_Got_It: 'รู้แล้ว',
  Cargo_Canceled: 'ยกเลิกแล้ว',
  Cargo_RepeatGoldenTaxExport: 'ไม่ดำเนินการส่งออกภาษีทองคำซ้ำซ้อน',
  Cargo_UpdateCustomerInfo: 'อัพเดทข้อมูลลูกค้า',
  Cargo_SyncCustomerData: 'ซิงค์ข้อมูลลูกค้า',
  Cargo_Synchronizing: 'กำลังซิงค์โปรดตรวจสอบในภายหลัง',
  Cargo_Prediction: 'การคาดการณ์',
  Cargo_PlaceOfDeliveryRegion: 'Delivery Land (พื้นที่)',
  Cargo_IsTransfer: 'ไม่ว่าจะเป็นการส่งต่อ',
  Cargo_TotalAmountTax: 'รวมภาษี (ใบแจ้งหนี้)',
  Cargo_CustomerNotOwn: '【หน่วยงานหลัก】 สาขาที่สังกัดไม่สอดคล้องกับบริษัทปัจจุบัน',
  Cargo_SimilarPartners: 'มีธุรกิจที่มีชื่อคล้ายกันอยู่แล้ว 【{0}】 ฯลฯ {1}',
  Cargo_GoBackSuccess: 'ดึงความสำเร็จกลับมา!',
  Cargo_SendBackSuccess: 'การคืนเงินสำเร็จ!',
  Cargo_AddSignature: 'เพิ่มลายเซ็น',
  Cargo_Appoint2: 'การมอบหมาย',
  Cargo_Appointer: 'มอบหมายให้',
  Cargo_ApproverRepeat: 'ผู้อนุมัติไม่อนุญาตให้ทำซ้ำซ้อน',
  Cargo_ApproverAndAppointerRepeat: 'ผู้ใช้ไม่สามารถมีสถานะเป็น "ผู้อนุมัติ" และ "ผู้มอบหมาย" ในเวลาเดียวกัน',
  Cargo_CancelAddSignature: 'ไม่สามารถอยู่กับตัวเองได้"การยกเลิกการเพิ่มลายเซ็น"',
  Cargo_CancelAddSignatureNotSupport: 'ผู้ใช้ "อนุมัติ" หรือ "มอบหมาย" ไม่สนับสนุน "ยกเลิกการเพิ่ม"',
  Cargo_RuleError: 'การเปลี่ยนแปลงประเภทแบบฟอร์มการกำหนดค่ากฎกระบวนการผิดพลาด',
  Cargo_SelectCcTo: 'เลือก CC',
  Cargo_SelectSigner: 'เลือกผู้เซ็น',
  Cargo_SelectTransferor: 'เลือกผู้โอน',
  Cargo_TransferSignature: 'โอนแล้ว',
  Cargo_Appointed: 'ได้รับมอบหมาย',
  Cargo_CancelSignature: 'การยกเลิกการเพิ่มลายเซ็น',
  Cargo_AddSignatureSelf: 'ไม่สามารถอยู่กับตัวเองได้"เพิ่มลายเซ็น"',
  Cargo_OnlySupportedFCL: 'รองรับเฉพาะธุรกิจ FCL ชั่วคราว',
  Cargo_CannotExceedThree: 'มากกว่า 3 ชนิดกล่องที่แตกต่างกันในระบบไม่สามารถส่งข้อมูลที่เกี่ยวข้องได้ในเวลานี้โปรดติดต่อฝ่ายบริการลูกค้าในเวลา',
  Cargo_TransferSignatureSelf: 'ไม่ได้รับอนุญาตให้เลือกตัวเองเป็น "ผู้โอน"',
  Cargo_AddSignatureCurrentNode: 'ไม่อนุญาตให้ผู้ใช้โหนดปัจจุบัน"เพิ่มลายเซ็น"',
  Cargo_ApproverNotEmpty: 'ผู้อนุมัติไม่สามารถเว้นว่างได้',
  Cargo_AppointerNotEmpty: 'การแต่งตั้งไม่สามารถว่างได้',
  Cargo_NewWarehouseFee: 'อนุญาตให้เพิ่มค่าธรรมเนียมคลังสินค้าสำหรับธุรกิจที่มีสถานะการทำงานเป็นบวกเท่านั้น!',
  Cargo_DefaultCurrencyConversion: 'สกุลเงินปริยาย',
  Cargo_ChargeGroupCheck: 'กลุ่มค่าธรรมเนียม 【{0}】 ไม่รองรับการเลือกซ้ำโปรดบันทึกหลังจากปรับใหม่',
  Cargo_RelatedChargeItems: 'รายการค่าธรรมเนียมที่เกี่ยวข้อง',
  Cargo_IncludeSoc: 'ไม่ว่าจะเป็นการบรรจุกล่องเจ้าของสินค้า',
  Cargo_SubsidiaryLedgerDay: 'รายละเอียดบัญชีรายวัน',
  AccountingDate: 'วันที่บัญชี',
  PleaseSelectAccountDate: 'กรุณาเลือกวันบัญชี',
  CurrentDayAmountTo: 'รวมวันนี้',
  TotalReportingCurrencyOfThisDay: 'สกุลเงินท้องถิ่นรวมของวันนี้',
  Cargo_LastOverseasPort: 'เมื่อพอร์ตของการขนถ่ายเป็นพอร์ตของสหรัฐอเมริกาก็สามารถเท่ากับพอร์ตของการโหลดได้โดยตรง \n' +
      'เมื่อท่าเรือขนถ่ายสินค้าไม่ใช่ท่าเรือของสหรัฐอเมริกา ที่นี่ควรเติมท่าเรือที่ไม่ใช่สหรัฐอเมริกาก่อนหน้านี้ก่อนสหรัฐอเมริกา',
  Cargo_FirstPortOfCall: 'เมื่อพอร์ตของการขนถ่ายเป็นพอร์ตของสหรัฐอเมริกาก็สามารถเท่ากับพอร์ตของการขนถ่ายโดยตรง \n' +
      'เมื่อท่าเรือขนถ่ายสินค้าไม่ใช่ท่าเรือของอเมริกา ที่นี่ควรเติมผ่านท่าเรืออเมริกันแห่งแรกของสหรัฐอเมริกา',
  Cargo_PoNoExistTips: 'รายการเลขที่ซ้ำกัน, ยืนยันการบันทึก?',
  Cargo_Assignment: 'การจัดสรร',
  Cargo_SetMarginReminder: 'ตั้งค่าการแจ้งเตือนค่าเผื่อ',
  Cargo_NumberOfCompanyReminders: 'ค่าเผื่อการแจ้งเตือน',
  Cargo_CompanyTrackingNumLower: 'ค่าเผื่อหมายเลข บริษัท ปัจจุบันน้อยกว่า 【{0}】',
  Cargo_BatchAdd: 'เพิ่มจำนวนมาก',
  Cargo_DownloadTemplate: 'ดาวน์โหลดแม่แบบ',
  Cargo_AssignCompany: 'บริษัท จัดสรร',
  Cargo_MawbSource: 'แหล่งที่มาของรายการหลัก',
  CARGO_CAN_NOT_ASSIGNMENT: 'สนับสนุนเฉพาะการจัดสรรรายการหลักสถานะใหม่',
  CARGO_Confirm_Assignment: 'ยืนยันการจัดสรร',
  CARGO_Confirm_Assignment_Success: 'จัดสรรสำเร็จ',
  CARGO_Confirm_Assignment_Error: 'การจัดสรรล้มเหลว',
  CARGO_Only_Invalidated: 'สนับสนุนเฉพาะรายการหลักสำหรับสถานะการเป็นโมฆะและไม่เป็นโมฆะ',
  CARGO_Only_Unbind: 'รองรับเฉพาะรายการหลักที่ผูกไว้เท่านั้น',
  CARGO_Not_Met_New_Conditions: 'รายการหลักต่อไปนี้ไม่เป็นไปตามเงื่อนไขเพิ่มเติม',
  Cargo_Assign_People: 'จัดสรรโดย',
  AERequiredChecksum: 'Master Single Start Number, Bulk เพิ่มจำเป็น',
  Cargo_DeleteCharge: 'ไม่มีการเลือกค่าธรรมเนียม ลบค่าใช้จ่ายทางธุรกิจที่ถูกติ๊กทั้งหมดโดยค่าเริ่มต้น',
  Cargo_BusinessOperationUpdateDynamics: 'อัพเดทความเคลื่อนไหวของการดำเนินธุรกิจ',
  Cargo_UpdateDetails: 'รายละเอียดการอัพเดท',
  Cargo_UpdateContent: 'อัปเดตเนื้อหา',
  Cargo_ChangeLogRecord: 'บันทึกการเปลี่ยนแปลง',
  Cargo_BusinessNoChangeLogRecord: 'บันทึกการเปลี่ยนแปลงหมายเลขธุรกิจ',
  Cargo_ResultsDisplayedInRed: 'ผลการสอบถามจะปรากฏเป็นสีแดง',
  Cargo_ChangeLocation: 'เปลี่ยนตำแหน่ง',
  Cargo_TimeQuery: 'สอบถามเวลา',
  Cargo_BusinessNotExist: 'ธุรกิจไม่ได้อยู่!',
  Cargo_UserNoRole: 'ผู้ใช้คนนี้ไม่ได้มีบทบาทเกี่ยวข้องใด ๆ ยืนยันการบันทึก?',
  Cargo_ResultsDisplayedInYellow: 'ผลการสอบถามจะปรากฏเป็นสีเหลือง',
  Cargo_CreateBillYesOrNo: 'ไม่ว่าจะเป็นการสร้างบิล',
  CurrencyReceivable: '{0} การรับสมัคร',
  CurrencyPayable: '{0} การรับมือ',
  CurrencyNotReceived: '{0} ยังไม่ได้รับ',
  CurrencyUnpaid: '{0} ค้างชำระ',
  CurrencyReceived: '{0} ได้รับ',
  CurrencyPaid: '{0} จ่ายแล้ว',
  Cargo_CheckShippingCompanyCargoTracking: 'คุณได้เปิดบริการติดตามการขนส่งสินค้าของ บริษัท เรือโปรดบันทึกหลังจากเลือก บริษัท เรือเพื่อให้แน่ใจว่าได้รับข้อมูลฟิลด์เรียบร้อยแล้ว',
  Cargo_PodPortInfoPrompt: 'หากคุณเปิดบริการติดตามสินค้าของ บริษัท เรือป้ายหน้าพื้นฐาน - บริษัท เรือเป็นสิ่งจำเป็นโปรดเลือก บริษัท เรืออย่างถูกต้องเพื่อบันทึกธุรกิจให้แน่ใจว่าได้รับข้อมูลฟิลด์เรียบร้อยแล้ว',
  Cargo_StatementReviewStatus: 'สถานะการตรวจสอบงบการเงิน',
  Cargo_StatementReviewer: 'ผู้ตรวจสอบบัญชียอดคงเหลือ',
  Cargo_StatementReviewTime: 'เวลาตรวจสอบบัญชี',
  Cargo_Port_Departure_Sea: 'พอร์ตการจัดส่งสินค้า (ทางทะเล)',
  Cargo_Port_Destination_Sea: 'ท่าเรือปลายทาง (ทางทะเล)',
  Cargo_Port_Departure_Air: 'พอร์ตการจัดส่งสินค้า (ทางอากาศ)',
  Cargo_Port_Destination_Air: 'พอร์ตปลายทาง (ทางอากาศ)',
  Cargo_Port_Departure_Rail: 'ท่าเรือต้นทาง (รถไฟ)',
  Cargo_Port_Destination_Rail: 'ท่าเรือปลายทาง (รถไฟ)',
  Cargo_Lob_NEQ_Port: 'ประเภทของธุรกิจไม่ตรงกับประเภทของท่าเรือ คลิกตกลงเพื่อล้างท่าเรือที่เลือก',
  Cargo_DuplicateLaneCodePleaseTryItAgain: 'เที่ยวบินซ้ำโปรดป้อนอีกครั้ง',
  Need: 'ต้องการ',
  NoNeed: 'ไม่จำเป็น',
  Responsible: 'มีความรับผิดชอบ',
  No_Responsibility: 'ไม่ต้องรับผิดชอบ',
  Cargo_VAT_FEI: 'ใบแจ้งหนี้อิเล็กทรอนิกส์ (VAT Special Invoice)',
  Cargo_NORMAL_FEI: 'ใบแจ้งหนี้อิเล็กทรอนิกส์ (ใบแจ้งหนี้ทั่วไป)',
  Cargo_ViewMoreLogs: 'ดูบันทึกเพิ่มเติม',
  Cargo_ThreeDaysLogs: 'มีพลวัตการทำงานเกือบ 3 วัน',
  Cargo_CarryForward: 'ยอดโอน',
  Cargo_ReconciliationNewVersion: 'การสร้างความปรองดองเวอร์ชั่นใหม่',
  Cargo_NuoNuo: 'โนโนะ',
  Cargo_AISINO_EI: 'จดหมายทางอากาศ',
  Pigeonhole: 'แฟ้มจัดเก็บ',
  Unarchive: 'ยกเลิกการจัดเก็บ',
  Confirm_Archiving_Business: 'ยืนยันจะยื่นธุรกิจที่เลือก',
  Confirm_Unarchiving_Business: 'ยืนยันการยื่นเลิกกิจการที่เลือกไว้',
  Is_Pigeonhole: 'ไม่ว่าจะเป็นการยื่น',
  Financial_Review_Status: 'สถานะการตรวจสอบทางการเงิน',
  Other_Reminders: 'การแจ้งเตือนอื่น ๆ',
  Can_Be_Archived: 'ไม่ว่าจะเป็นการยื่นฟ้อง',
  Not_Accrued: 'ไม่รวม',
  Receivables_Not_Fully_Written_Off: 'ลูกหนี้ได้รับการชำระหนี้ไม่ครบ',
  Payable_Not_Fully_Written_Off: 'ชำระหนี้ไม่ครบ',
  Financial_Archiving_Settings: 'การตั้งค่าคลังข้อมูลทางการเงิน',
  Financial_Filing_Preconditions: 'เงื่อนไขก่อนการยื่นทางการเงิน',
  Financial_Filing_Effective_Effect: 'ผลของการยื่นทางการเงินมีผลบังคับใช้',
  WHETHER_FINANCIAL_AUDIT: 'ไม่ว่าจะเป็นการตรวจสอบทางการเงิน:',
  WHETHER_ACCRUED: 'มีการนับรวมหรือไม่:',
  CARGO_RECOGNITION_SETTING: 'การตั้งค่าการรับรู้ OCR',
  AE_IDENTIFY_VENDORS: 'เพิ่ม / แก้ไขการระบุผู้ขาย',
  TENANT_BUSINESS_NAME: 'ชื่อธุรกิจผู้เช่า',
  OFFSHORE_CONSIGNMENT_IDENTIFICATION_SUPPLIER: 'Seaoutdoor ระบุซัพพลายเออร์',
  OCEAN_BILL_OF_LADING_IDENTIFICATION_SUPPLIER: 'ผู้ให้บริการระบุ BL ทางทะเล',
  DTip: 'แน่ใจหรือไม่ว่าต้องการลบการตั้งค่าของผู้เช่ารายนี้? ระบุซัพพลายเออร์ที่ใช้การตั้งค่าแพลตฟอร์มหลังจากการลบ',
  FormEditTip: 'กรุณาเลือกการตั้งค่าการระบุผู้เช่าที่ต้องการแก้ไข',
  FormDeleteTip: 'กรุณาเลือกการตั้งค่าระบุตัวผู้เช่าที่ต้องการลบ',
  OCRRecognition: 'การระบุ OCR',
  FINANCIAL_RECEIVABLES_VERIFICATION: 'ไม่ว่าจะเป็นการชำระหนี้เต็มจำนวน:',
  FINANCIAL_DUE_VERIFICATION: 'ไม่ว่าจะเป็นการชำระหนี้เต็มจำนวน:',
  FINANCIAL_CHARGE: 'มีการเพิ่ม/เปลี่ยนแปลง/ลบค่าธรรมเนียมที่กำลังดำเนินการ:',
  CANCEL_FINANCIAL_AUDIT: 'การยกเลิกการตรวจสอบทางการเงิน:',
  MODIFY_CHARGE: 'ค่าธรรมเนียมการเปลี่ยนแปลง:',
  MODIFY_JOB: 'แก้ไขข้อมูลธุรกิจ:',
  MODIFY_RATE: 'แก้ไขอัตราแลกเปลี่ยน:',
  MODIFY_FINANCE_JOB_DATE: 'แก้ไขวันทางการเงิน / วันประกอบธุรกิจ',
  GENERATE_RED_INVOICE: 'สร้างใบแจ้งหนี้ Hongchong:',
  RECEIVABLE_GENERATES_INVOICE: 'ใบแจ้งหนี้ที่เรียกเก็บ:',
  COPE_GENERATES_INVOICE: 'ชำระใบแจ้งหนี้ที่สามารถสร้างได้:',
  CANCEL_RECEIVABLE_VERIFICATION: 'การยกเลิกการหักบัญชีลูกหนี้:',
  COPE_RECEIVABLE_VERIFICATION: 'การยกเลิกการชำระหนี้:',
  MODIFY_ACCRUAL: 'แก้ไขรายการ:',
  NON_FILEABLE_BUSINESS: 'มีธุรกิจที่ไม่สามารถยื่นได้',
  NOT_FULLY_COMPLETED: 'มีธุรกิจที่ยังไม่เสร็จสมบูรณ์,ดูเตือน',
  BUSINESS_CAN_ARCHIVED: 'ธุรกิจสามารถยื่นได้',
  ARCHIVE_DATE: 'วันที่ยื่น',
  NOT_OPERATIONAL: 'ไม่สามารถดำเนินการได้,เหตุผล: มีการยื่นเรื่องธุรกิจ',
  CHANGE_CHARGE_IN_PROGRESS: 'มี "การตรวจสอบค่าธรรมเนียมการเปลี่ยนแปลง" ที่กำลังดำเนินการโปรดเสร็จสิ้นก่อน',
  ONLY_NOT_ARCHIVED_TRANSACTIONS: 'กรุณาเลือกธุรกิจที่ยังไม่ได้ยื่น',
  ONLY_ARCHIVED_TRANSACTIONS: 'โปรดกรองการเลือกธุรกิจที่ยื่นแล้ว',
  Cargo_Preplan: 'ประกอบล่วงหน้า',
  Cargo_SeaManagerSendPreplan: 'ซีบัตเลอร์ (ส่งล่วงหน้า)',
  Cargo_SeaManagerUpdatePreplan: 'Sea Butler (แก้ไขเพิ่มเติม)',
  Cargo_SeaManagerDeletePreplan: 'แม่บ้านทะเล (ลบก่อน)',
  Cargo_SeaManagerSendingVGM: 'ซีบัตเลอร์ (ส่ง VGM)',
  Cargo_WseSendMPreplanQd: 'CW (รายการหลักของพอร์ตชิงเต่าส่งรายการ)',
  Cargo_WseSendPreplanQd: 'CW (ชิงเต่าพอร์ตแยกส่งรายการ)',
  Cargo_WseSendUpdatePreplanQd: 'CW (ท่าเรือชิงเต่าแก้ไขรายการ)',
  Cargo_WseDeletePreplanQd: 'CW (ท่าเรือชิงเต่าลบรายการสินค้า)',
  Cargo_WseSendPreplanSh: 'CW (ท่าเรือเซี่ยงไฮ้ส่งรายการ)',
  Cargo_WseSendUpdatePreplanSh: 'CW (ท่าเรือเซี่ยงไฮ้แก้ไขรายการ)',
  Cargo_WseDeletePreplanSh: 'CW (ท่าเรือเซี่ยงไฮ้ลบรายการ)',
  Cargo_WseSendingVGM: 'ส่ง VGM',
  Cargo_Ams: 'AMS ส่ง',
  Cargo_Aci: 'ACI ส่ง',
  Cargo_Afr: 'AFR ส่ง',
  Cargo_EMainfest: 'eMainfest ส่ง',
  Cargo_Ens: 'ENS ส่ง',
  Cargo_Send_error: 'ส่งข้อยกเว้น',
  Cargo_Confirm_Delete: 'ยืนยันที่จะลบข้อมูลที่เลือก?',
  Cargo_ApiCallBack: 'โทรกลับ api',
  Cargo_BWJS: 'Baiwang Jinsui เมฆ',
  Cargo_TaxEasy: 'ยูงจิน',
  Cargo_YGSH: 'ซันนี่ สปีด แล่นเรือ',
  Cargo_BaiHui: 'Baihui โกลเด้น Nonel',
  Cargo_OverseasSettlementCenter: 'ศูนย์ชำระหนี้ในต่างประเทศ',
  Cargo_Receivable2: 'การยอมรับ:',
  Cargo_Payable2: 'การรับมือ:',
  Cargo_From_Import: 'ซิงค์นำเข้า',
  Cargo_From_Export: 'ซิงค์ทางออก',
  Approval_Approved_Time: 'เวลาผ่านการอนุมัติ',
  CheckingExportToImport: 'ธุรกิจไม่สามารถส่งออกไปยังการนำเข้าโปรดลองอีกครั้งหลังจากตรวจสอบ!',
  OnlySupportOneCustomsInfo: 'เมื่อเปิดอินเทอร์เฟซธงสัญญาณรองรับเพียงรายละเอียดการประกาศศุลกากร',
  CustomsDeclareTime: 'กำหนดวันประกาศศุลกากร',
  SendContainer: 'ผลักดันรายการ LCL ไปยังตัวแทนศุลกากร',
  IsTheLCLListSent: 'รายการ LCL จะส่งหรือไม่',
  LCLList: 'รายการ LCL',
  iEPort: 'ออกนอกประเทศ',
  OceanBillOfLadingNumber: 'หมายเลขใบตราส่งสินค้าทางทะเล',
  NoticeBgh: 'ฯลฯ ประกาศศุลกากร',
  SelfDeclaration: 'ลูกค้าประกาศศุลกากรด้วยตนเอง',
  NotSentCustomsFile: 'ยังไม่ได้ส่งข้อมูลประกาศศุลกากร (การแจ้งเตือนนี้สามารถละเว้นได้หากมีการส่งช่องทางอื่นแบบออฟไลน์แล้ว)',
  FilledMustFill: 'กรุณากรอกข้อมูล [{0}] เมื่อส่งประกาศศุลกากร',
  NoContainerInfo: 'ไม่มีข้อมูลการบรรจุใต้กล่องนี้',
  InformationComparison: 'เปรียบเทียบข้อมูล',
  Diff: 'ความแตกต่าง',
  PostLCLTask: 'ผลักดันภารกิจ LCL',
  ForceDeleteCustomsTips: 'ประกาศศุลกากรได้ผลักดันธงสัญญาณ แน่ใจหรือไม่ว่าคุณต้องการบังคับลบ?',
  AddCustomerFileFirst: 'กรุณาเพิ่มข้อมูลพิธีการศุลกากรก่อน',
  Local: 'ท้องถิ่น',
  CustomsDocumentPreparation: 'พิธีการศุลกากร',
  PleaseCreateSplitBillFirst: 'โปรดสร้างแผ่นรื้อถอนก่อน',
  Cargo_DisplaySell: 'แสดงหมายเลขบัญชีธนาคารของฝ่ายขาย',
  Cargo_DisplayBuyer: 'แสดงหมายเลขบัญชีธนาคารของผู้ซื้อ',
  ItIsRecommendedToFillInWhenTheExitPortIsShanghai: '(หมายเหตุ: แนะนำให้กรอกเมื่อท่าเรือขาออกคือเซี่ยงไฮ้)',
  PleaseFillInTheIEPort: 'กรุณากรอกรหัสขาออก',
  CustomsUnFrozen: 'การละลายน้ำแข็งประกาศศุลกากร',
  UnFrozen: 'ละลายน้ำแข็ง',
  LCLTaskSent: 'ส่งงาน LCL แล้ว',
  LCLTaskNotSent: 'ยังไม่ได้ส่งงาน LCL',
  Unfreeze: 'ละลายน้ำแข็ง',
  NotUnfreeze: 'ไม่ละลาย',
  CustomerFileHasBeenSent: 'ส่งข้อมูลประกาศศุลกากรแล้ว',
  NotSendingCustomerFile: 'ไม่มีการส่งข้อมูลประกาศศุลกากร',
  XhqCustomerState: 'สถานะประกาศศุลกากรธงสัญญาณ',
  VGMWeighingAddressCannotBeEmpty: 'ที่อยู่การชั่งน้ำหนัก VGM ไม่สามารถว่างเปล่าได้',
  unfrozenOffline: 'ละลายแล้ว (ละลายออฟไลน์)',
  NotifyCustomsUnfreeze: 'แจ้งการละลายน้ำแข็งของประกาศศุลกากร',
  CargoOwnerSOC: 'SOC สำหรับเจ้าของสินค้า',
  ForwarderSOC: 'ผู้ส่ง SOC',
  SOCType: 'ประเภทกล่องเจ้าของสินค้า',
  InvoiceConfig: 'การกำหนดค่าใบแจ้งหนี้',
  InvoiceChannel: 'ช่องทางการออกบิล',
  FEI_NuoNuo: 'NONONET เต็มใบแจ้งหนี้ไฟฟ้า: NUONUO',
  FEI_Bwjsy: 'เมฆ Baiwang Jinsui: BWJSY',
  FEI_Kpzddm: 'รหัสเทอร์มินัลการออกบิล (kpzddm)',
  FEI_Yhdm: 'รหัสผู้ใช้ (yhdm)',
  FEI_NotUse: 'ไม่ได้เปิดใช้งาน',
  InvoicerConfig: 'การกำหนดค่าผู้เรียกเก็บเงิน',
  Invoicer: 'พนักงานเรียกเก็บเงิน',
  ExtensionNumber: 'หมายเลขต่อ',
  OnlyInvoicer: 'การออกใบสั่งให้สอดคล้องกับผู้เรียกเก็บเงินเท่านั้น',
  AllInvoicer: 'ผู้ใช้ทั้งหมดใช้ร่วมกัน',
  Cargo_ReceiveAmount: 'จำนวนลูกหนี้',
  Cargo_BatchDeleteChargeTips: 'ไม่มีการเลือกค่าธรรมเนียม ลบค่าใช้จ่ายทางธุรกิจที่ถูกติ๊กทั้งหมดโดยค่าเริ่มต้น คุณต้องการดำเนินการต่อหรือไม่?',
  Cargo_Template_Push: 'ผลักดันแม่แบบ',
  Empty: '(ว่างเปล่า)',
  Cargo_UploadTemplateDataSample: 'อัปโหลดตัวอย่างข้อมูลเทมเพลต',
  Cargo_SureDeleteTheFile: 'แน่ใจว่าจะลบไฟล์หรือไม่',
  Cargo_DownloadContent: 'ดาวน์โหลดเนื้อหา',
  Cargo_ImportOrderTemplateFile: ': นำเข้าไฟล์เทมเพลตคำสั่งซื้อ',
  Cargo_ImportOrderTemplateDataSampleFile: ': นำเข้าไฟล์ตัวอย่างข้อมูลเทมเพลตคำสั่งซื้อ',
  Cargo_Sample: 'ตัวอย่างตัวอย่าง',
  Cargo_Sample_Tip: '* เช่น HQ ได้อัปโหลดไฟล์ตัวอย่างข้อมูล เมื่อสาขาอื่นไม่ได้อัปโหลด สาขาอื่น ๆ ใช้ไฟล์ตัวอย่างข้อมูลของ HQ เป็นค่าเริ่มต้น',
  OpenXhqChat: 'เปิดจดหมาย',
  OpenXhqChatTips: 'ธุรกิจนี้ไม่ได้ส่งข้อมูลประกาศศุลกากร กรุณาส่งข้อมูลประกาศศุลกากรก่อน',
  CustomsBrokerNotEntered: 'ตัวแทนออกของไม่เข้า',
  Cargo_CanNotSplitMasterJob: 'ประเภทแพ็กเกจทั้งหมดไม่เท่ากับ LCL หรือ Buyer Console และไม่สามารถแยกได้!',
  RespMsg: 'กลับข้อมูล',
  Cargo_BillPaymentRemarkTip: '* หมายเหตุจะไม่ถูกเขียนทับด้วยข้อมูลเดิมเมื่อว่างเปล่า',
  Cargo_WarehouseCode: 'รหัสหมายเลขขาเข้า',
  Cargo_WarehouseCodeLengthLimit: 'สำหรับการกำหนดค่าการสร้างหมายเลขโพซิชั่นขาเข้าด้วยตัวอักษรโค้ดสูงสุด 10 หลัก',
  Cargo_ValueSetting: 'การตั้งค่าการหาค่า',
  Cargo_SettingValuePriority: 'ตั้งค่าลำดับความสำคัญของการให้ค่า',
  Cargo_PleaseToPartnerWarehouseCode: 'โปรดดูรหัสหมายเลขรายการคู่ค้า',
  Cargo_LineSeaAir: 'เส้นทาง (ทะเล / อากาศ)',
  Cargo_LineRailWay: 'เส้นทาง (รถไฟ)',
  Cargo_BatchDeleteCharge: 'ค่าธรรมเนียมการลบจำนวนมาก',
  Cargo_SetDeleteCondition: 'ตั้งค่าเงื่อนไขการลบ',
  Cargo_ToBeDeletedCharge: 'ข้อมูลค่าธรรมเนียมที่จะลบ',
  Cargo_ToBeDeletedChargeSelected: 'เลือกลบข้อมูลค่าธรรมเนียม:',
  Cargo_MatchCharge: 'ค่าธรรมเนียมการจับคู่',
  Cargo_SureDelete: 'แน่ใจหรือไม่ว่าการลบรายการข้อมูลแถบที่เลือก {0}',
  Cargo_ShowChargeDeleteResult: 'แสดงผลการลบค่าธรรมเนียม',
  Cargo_DeletedTips: 'ลบข้อมูลรายการ {0} แล้ว',
  Cargo_NotSelectDeletedTips: 'ยังไม่มีการเลือกข้อมูลค่าธรรมเนียมที่คุณต้องการลบ!',
  Cargo_PleaseMatchDataFirstTips: 'โปรดยืนยันข้อมูลที่จำเป็นต้องประมวลผลเป็นชุดหลังจากจับคู่ข้อมูลก่อน',
  Cargo_NotSelectDeleteConditionTips: 'ยังไม่มีการเลือกเงื่อนไขการลบค่าธรรมเนียม!',
  Cargo_BatchEditCharge: 'ค่าธรรมเนียมการแก้ไขจำนวนมาก',
  Cargo_SetEditCondition: 'ตั้งเงื่อนไขการปรับ',
  Cargo_ToBeEditCharge: 'ข้อมูลค่าธรรมเนียมที่จะปรับเปลี่ยน',
  Cargo_ToBeEditChargeSelected: 'เลือกปรับข้อมูลค่าธรรมเนียม:',
  Cargo_SureEdit: 'แน่ใจหรือไม่ว่าการปรับแต่งได้เลือกรายการข้อมูลแถบ {0} ไว้?',
  Cargo_ShowChargeEditResult: 'แสดงผลการปรับปรุงค่าธรรมเนียม',
  Cargo_EditTips: 'อัปเดตข้อมูลแถบ {0}',
  Cargo_NotSelectEditTips: 'ยังไม่มีการเลือกข้อมูลค่าธรรมเนียมที่ต้องการปรับเปลี่ยน!',
  Cargo_NotSelectEditConditionTips: 'ไม่มีการเลือกเงื่อนไขการปรับค่าธรรมเนียม!',
  Cargo_EditAmountNoZero: 'การปรับราคาต่อหน่วยต้องไม่เป็น 0!',
  Cargo_EditUnitRate: 'ปรับราคาต่อหน่วย',
  Cargo_EditSettleAccountsTo: 'ปรับวัตถุของการตั้งถิ่นฐาน',
  Cargo_HandleResult: 'ผลการประมวลผล',
  Cargo_LoadMore: 'เลื่อนโหลดเพิ่มเติม',
  Cargo_NoMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
  Cargo_ChargeHasDiffAmount: 'ค่าธรรมเนียมได้ทำแล้ว การประมวลผลส่วนต่างไม่สามารถแก้ไขได้!',
  Cargo_ChargeHasConfirm: 'ค่าธรรมเนียมได้รับการยืนยันแล้วว่าไม่อนุญาตให้แก้ไข!',
  Cargo_ChargeHasVerified: 'ค่าธรรมเนียมถูกยกเลิก ไม่สามารถแก้ไขได้!',
  Cargo_ChargeHasCommit: 'ค่าธรรมเนียมถูกส่งแล้ว ไม่อนุญาตให้แก้ไข!',
  Cargo_ChargeHasCreateBillPayment: 'ค่าธรรมเนียม สร้างใบสมัครการชำระเงิน ไม่อนุญาตให้แก้ไข!',
  Cargo_ChargeHasCreateInvoice: 'ค่าธรรมเนียมที่เรียกเก็บแล้ว ไม่สามารถเปลี่ยนแปลงได้!',
  Cargo_JobStateNotAllowModified: 'ธุรกิจ ส่ง / ตรวจสอบ ไม่อนุญาตให้แก้ไข!',
  Cargo_InvoiceChargeItemSetup: 'การตั้งค่าค่าธรรมเนียม (ใบแจ้งหนี้เวียดนาม)',
  Cargo_InvoiceChargeUnitSetup: 'การตั้งค่าหน่วย (ใบแจ้งหนี้เวียดนาม)',
  Cargo_ChargeItemId: 'รายการค่าธรรมเนียม (Cargoware)',
  Cargo_ChargeItemName: 'ชื่อ (แพลตฟอร์มการออกตั๋ว)',
  Cargo_ChargeUnitCode: 'หน่วย (Cargoware)',
  Cargo_ChargeUnitName: 'คำอธิบาย (แพลตฟอร์มการออกตั๋ว)',
  Cargo_InvoicingByTaxRate: 'การออกใบแจ้งหนี้ตามจุดภาษี',
  Cargo_SureToVoidTheInvoiceVietnam: 'ตามนโยบายควบคุมภาษีของเวียดนาม ขอยืนยันว่าได้รับการติดต่อจากลูกค้าแล้วว่า ใบแจ้งหนี้นี้ยังไม่มีการยื่นภาษี อย่ายกเลิกใบแจ้งหนี้หากทัณฑ์บน < br /> <br /> ยืนยันว่าใบแจ้งหนี้เป็นโมฆะหรือไม่?',
  Cargo_RandomPassword: 'รหัสผ่านแบบสุ่ม',
  ChargeSchemeCopy: 'การคัดลอกแผนค่าธรรมเนียม',
  CompanyCopy: 'คัดลอกพันธมิตร',
  SourceCompany: 'บริษัท ต้นทาง',
  QueryChargeScheme: 'สอบถามแผนค่าธรรมเนียม',
  CopyChargeScheme: 'โปรแกรมค่าธรรมเนียมการคัดลอก',
  QueryCompany: 'สอบถามคู่ค้า',
  CopyCompany: 'คัดลอกพันธมิตร',
  FuzzyQueryOfIdOrName: 'แบบสอบถามเบลอ ID หรือชื่อ',
  CopyToCompany: 'คัดลอกไปยังสาขา',
  CopySuccessCount: 'คัดลอกแถบสำเร็จ {0}',
  PleaseSelectTargetTenant: 'กรุณาเลือกผู้เช่าเป้าหมาย',
  Cargo_TemplateNodeWorkTaskSetting: 'การตั้งค่างานของโหนดสำหรับเทมเพลต',
  Cargo_WorkTaskEnable: 'เปิดการตั้งค่างานทำงานของโหนด',
  Cargo_SetNodeResponsible: 'ตั้งค่าโหนดเพื่อรับผิดชอบ',
  Cargo_DesignatedPosition: 'ระบุโพสต์ (งานที่กำหนดโหนดตามโพสต์มีความรับผิดชอบและสามารถเลือกได้เท่านั้น)',
  Cargo_SetPreNode: 'ตั้งค่า prenode (สถานะ prenode ที่จำเป็นสำหรับการเริ่มต้นของโหนด)',
  Cargo_SetPreNodeTips: 'ตั้งค่า prenodes ของโหนดนี้ (สูงสุด 5 prenodes สำหรับความสัมพันธ์)',
  Cargo_HandlingPriorityMarkers: 'การจัดการแท็กลำดับความสำคัญ',
  Cargo_HandlingPriorityMarkersTips: 'ตั้งค่าลำดับความสำคัญของการประมวลผล (สูงสุด 3 ลำดับความสำคัญต่ำเป็นค่าเริ่มต้นเมื่อไม่ได้ตั้งค่า)',
  Cargo_HandlingPriorityMarkersHigh: 'ตั้งค่าลำดับความสำคัญของการประมวลผลคือ: สูง',
  Cargo_HandlingPriorityMarkersMedium: 'ตั้งค่าลำดับความสำคัญของการประมวลผลคือ: กลาง',
  Cargo_HandlingPriorityMarkersLow: 'ตั้งค่าลำดับความสำคัญของการประมวลผลคือ: ต่ำ',
  Cargo_SOPWorkTaskBoard: 'SOP งาน Kanban',
  Cargo_High: 'สูง:',
  Cargo_Medium: 'กลาง:',
  Cargo_Low: 'ต่ำ:',
  Cargo_SopBusinessFlowDashboard: 'บริษัท SOP Business Stream Kanban',
  Cargo_WarnTodoList: 'รายการเตือนภัยล่วงหน้าสิ่งที่จะทำ',
  Cargo_BpmTodoList: 'รายการอนุมัติ',
  Cargo_BusinessTime: 'เวลาธุรกิจ',
  Cargo_HandleLevel: 'ระดับการประมวลผล',
  Cargo_PreNode: 'โหนดก่อน',
  Cargo_PriorityHigh: 'ความสำคัญสูง',
  Cargo_PriorityMedium: 'ลำดับความสำคัญปานกลาง',
  Cargo_PriorityLow: 'ลำดับความสำคัญต่ำ',
  Cargo_SetDefaultDisplayItem: 'ตั้งเป็นค่าเริ่มต้น',
  Cargo_PreNodeRepeat: 'การกำหนดค่าโหนดก่อนการทำซ้ำ',
  Cargo_PriorityRepeat: 'ในการกำหนดค่าลำดับความสำคัญ 【รายการเงื่อนไข + วิธีการเรียกใช้ + วันที่】 ไม่สามารถทำซ้ำได้',
  Cargo_TrackingIconTip: 'ไอคอนนี้ใช้เป็นระบบ B2B และ SOP Work Task Kanban สำหรับการใช้งาน!',
  Cargo_LoadData: 'รีเฟรชข้อมูล',
  Cargo_TemplateNodeMergeShow: 'โหนดแม่แบบรวมการแสดงผล',
  Cargo_MblTip: 'กรุณาใส่ตัวอักษรและตัวเลข 6-30 ตัว',
  Cargo_VesselTip: 'กรุณาใส่ตัวอักษร, ตัวเลข, ".", "-", "ช่องว่าง"',
  Cargo_VesselTip2: 'ไม่สามารถป้อนภาษาจีนและอักขระแบบเต็มความกว้าง',
  Cargo_VoyageTip: 'โปรดป้อน ไม่มี V. เที่ยวบิน',
  Cargo_ShippingCompanyTip: 'กรุณาเลือกแผนกเรือ',
  Cargo_CarrierAgentTip: 'กรุณาเลือก Shipping',
  Cargo_SailingDateTip: 'กรุณาเลือกวันที่ออกเดินทาง',
  Cargo_PortOfLoadingHgjTip: 'Sea Butler สนับสนุนเฉพาะท่าเรือเซี่ยงไฮ้ในการส่ง',
  Cargo_PortOfLoadingWsTip: 'โปรดเลือกพอร์ตการจัดส่งสินค้าสนับสนุนเซี่ยงไฮ้ชิงเต่า',
  Cargo_PortOfLoadingTip: 'โปรดเลือก Port Capital ชื่อเต็ม ภาษาอังกฤษ',
  Cargo_PortOfDischargeTip: 'โปรดเลือกท่าเรือขนส่งสินค้า',
  Cargo_PortOfDestinationTip: 'กรุณาเลือกท่าเรือปลายทาง',
  Cargo_PortOfDestinationTip2: 'โปรดเลือก Port Capital ชื่อเต็ม ภาษาอังกฤษ',
  Cargo_BlNumberTip: 'โปรดเลือกวิธี B / L',
  Cargo_DispatchingPlaceCodeTip: 'หากหนานจิงได้รับสินค้าและออกจากเซี่ยงไฮ้สถานที่จัดส่งจะเต็มหนานจิง',
  Cargo_DispatchingPlaceCodeTip2: 'กรุณาเลือกสถานที่จัดส่ง',
  Cargo_DispatchingPlaceCodeTip3: 'รองรับเฉพาะสถานที่จัดส่งคือชิงเต่าหรือ Sunzhao',
  Cargo_ShipperEnterpriseNameTip: 'กรุณากรอกตัวอักษรภายใน 140',
  Cargo_ShipperEnterpriseNameTip2: 'กรุณาใส่ตัวอักษรภายใน 70',
  Cargo_ShipperContactsTip: 'กรุณากรอกหมายเลขโทรศัพท์ภายใน 20 ตัวอักษร',
  Cargo_PortPlaceOfDeparture: 'พอร์ตการจัดส่งสินค้า / สถานที่จัดส่ง',
  Cargo_PortPlaceOfDischarge: 'ท่าเรือขนถ่าย / สถานที่ขนถ่าย',
  Cargo_MsgClassifyManager: 'การจัดการการจัดหมวดหมู่ข้อความ',
  Cargo_BellMsg: 'ข้อความระฆัง',
  QuickSearchMsgClassify: 'โปรดป้อนชื่อเรียกคืนแบบเบลอ',
  Cargo_GroupingDimensionForRate: '"เงื่อนไขการจัดกลุ่ม "เท่ากับ "อัตราภาษี" ค่า "ต้องกรอกเป็น "ตัวเลข"!',
  Cargo_CheckAccountSetBranchId: 'สาขาที่ปลอกบัญชีปัจจุบันเป็นเจ้าของไม่ได้เป็นของสาขาปัจจุบันหรือสาขาที่เหนือกว่า จะดำเนินการต่อหรือไม่',
  Cargo_BillPayment: 'ใบคำขอชำระเงิน',
  Cargo_MakeInvoice: 'แบบฟอร์มขอใบแจ้งหนี้',
  Cargo_JobCharge: 'ใบคำขอค่าธรรมเนียมธุรกิจ',
  Cargo_CopyNotifier: 'คัดลอกการแจ้งเตือน',
  Cargo_CopyRecipient: 'คัดลอกผู้รับ',
  Cargo_InputIMO: 'กรุณากรอกหมายเลข IMO',
  Cargo_InputBLFreightTermTootip: 'โปรดเลือกเงื่อนไขการจัดส่ง',
  Cargo_PureNumbers: 'กรุณากรอกตัวเลข',
  Cargo_DefaultShanghai: 'ค่าเริ่มต้น SHANGHAI = CNSHA ไม่สามารถเปลี่ยนแปลงได้',
  Cargo_IMO: 'หมายเลข IMO',
  Cargo_DangerousGoodsCheck: 'คุณกรอกข้อมูล {0} แต่ประเภทของสินค้าเลือก "สินค้าทั่วไป" โปรดส่งใหม่หลังจากตรวจสอบ',
  ChinaPostProductConfiguration: 'การกำหนดค่าผลิตภัณฑ์ China Mail',
  AllowSaleProduct: 'ผลิตภัณฑ์ที่สามารถขายได้',
  AllowSaleProductNotNull: 'สินค้าลดราคา ไม่มีตัวเลือก',
  NewChargeGroup: 'กลุ่มค่าใช้จ่ายคนรุ่นใหม่',
  ChargeMapping: 'แผนที่ค่าใช้จ่ายสำหรับคนรุ่นใหม่',
  ChargeMappingFuzzySearch: 'กรุณากรอกรหัสค่าธรรมเนียมการโอนย้ายหรือสอบถามชื่อเบลอ',
  RailwayUse: 'การใช้รถไฟ',
  BecameInvalid: 'ล้มเหลวแล้ว',
  FullOrInside: 'การเดินทางทั้งหมด / ในประเทศ',
  FullOrInsideNotNull: 'เส้นทางทั้งหมด / ในประเทศ ไม่มีตัวเลือก',
  TransmitChargeName: 'ส่วนค่าธรรมเนียมการโอน',
  TransmitChargeNameNotNull: 'กลุ่มค่าโอนไม่มีตัวเลือก',
  TransmitChargeCode: 'รหัสกลุ่มค่าธรรมเนียมการโอน',
  MaintainerRemarks: 'หมายเหตุพนักงานบำรุงรักษา',
  PushOrNot: 'ไม่ว่าจะเป็นการผลักดันซ้ำ',
  Cargo_BusinessLeaderCompanyPrePort: 'บริษัทหัวหน้าธุรกิจก่อนท่าเรือ',
  Cargo_BusinessLeaderDeptPrePort: 'แผนกหัวหน้าธุรกิจก่อนท่าเรือ',
  Cargo_BusinessLeaderCompanyEndPort: 'บริษัทหัวหน้าธุรกิจช่วงท้ายท่าเรือ',
  Cargo_BusinessLeaderDeptEndPort: 'แผนกหัวหน้าธุรกิจช่วงท้ายท่าเรือ',
  Cargo_CurrentNode: 'โหนดปัจจุบัน',
  Cargo_WorkNode: 'โหนดการทำงาน',
  Cargo_EditStateTip: 'คุณแน่ใจหรือไม่ว่าจะแก้ไขสถานะโหนดของรายการข้อมูลแถบ {0} ที่เลือกไว้?',
  Cargo_BpmSubmitDuplicated: 'เอกสารปัจจุบันมีใบตรวจสอบแล้ว อย่าส่งซ้ำ',
  Cargo_TempCreditApply: 'แบบฟอร์มคำร้องขอเครดิตชั่วคราว',
  Cargo_PartnerName: 'ชื่อพันธมิตร',
  Cargo_ContractAmount: 'วงเงินสัญญา',
  Cargo_ContractAccountingPeriod: 'ระยะเวลาบัญชีสัญญา',
  VerificationSheetRequired: 'ต้องมี checklist',
  Cargo_TransportSource: 'แหล่งกำลังการผลิต',
  Cargo_CustomerExpandMode: 'วิธี TOOKER',
  Cargo_SubmitTempCreditTip: 'การบำรุงรักษา Credit Control ชั่วคราว คุณต้องการเริ่มต้นกระบวนการอนุมัติ Credit ชั่วคราว คุณต้องการเริ่มต้นการอนุมัติในขณะนี้หรือไม่?',
  Cargo_CustomFields: 'ฟิลด์การกำหนดค่า',
  Cargo_CustomerCode: 'ระบบบัตรกำนัล รหัสลูกค้า',
  Cargo_NoHasFinanceCode: 'ไม่มี "รหัสลูกค้าระบบบัตรกำนัล" ของเพื่อนที่สอดคล้องกันสําหรับใบแจ้งหนี้ที่เพิ่มขึ้น',
  Cargo_MultiCurrency: 'ใบแจ้งหนี้ที่ถูกเลือกมีหลายสกุลเงิน',
  Cargo_YongYouDeleteTip: 'ใบแจ้งหนี้ปัจจุบันได้ผลักดันให้เพื่อนผู้ใช้หากต้องการดำเนินการต้องไปที่ระบบบัตรกำนัลลบบันทึกที่สอดคล้องกัน กำหนดปฏิบัติการหรือไม่',
  Cargo_SyncVerifyDoc: 'เอกสารการชำระบัญชีแบบซิงโครนัส',
  Cargo_HasSync: 'ข้อมูลที่ถูกเลือกจะถูกซิงค์',
  Cargo_OverseaActualAmount: 'ข้อมูลการขายบัญชีในต่างประเทศไม่สามารถประสานเพื่อนได้',
  Cargo_MultiInvoiceTitle: 'มีกระแสการขายบัญชีที่มีใบแจ้งหนี้หลายรายการเพิ่มขึ้น ไม่สามารถผลักดันเพื่อนผู้ใช้ได้ ให้ปรับข้อมูล',
  Cargo_InvoiceTitleMustBeIdentical: 'การออกใบแจ้งหนี้ต้องเท่ากัน',
  Cargo_ChargeChangeApply: 'แบบฟอร์มขอเปลี่ยนแปลงค่าธรรมเนียม',
  Cargo_HideUnmodifiedFees: 'ค่าธรรมเนียมคงที่ (ซ่อน)',
  Cargo_ChargeChangeTip: 'หมายเหตุ: มีการเปลี่ยนแปลงในปัจจุบันที่จะได้รับการอนุมัติและสามารถปรับเปลี่ยนค่าธรรมเนียมได้อีกครั้งหลังจากการเปลี่ยนแปลงนี้สิ้นสุดลง',
  Cargo_UniqueIdentification: 'เอกลักษณ์เฉพาะ',
  Cargo_CostNumber: 'หมายเลขค่าธรรมเนียม',
  Cargo_OriginalCostUniqueIdentifier: 'โลโก้เฉพาะของค่าใช้จ่ายเดิม',
  Cargo_OriginalExpenseNumber: 'หมายเลขค่าใช้จ่ายเดิม',
  Cargo_ChargeChange: 'การเปลี่ยนแปลงค่าธรรมเนียม',
  Cargo_ApprovalProcessForChargeChange: 'ค่าธรรมเนียมการเปลี่ยนแปลงกระบวนการอนุมัติคำขอ',
  Cargo_ChargeChangeTip2: 'ขอถามว่าต้องการยืนยันการอนุมัติการเปลี่ยนแปลงค่าธรรมเนียมเริ่มต้นตอนนี้หรือไม่',
  Cargo_ChargeChangeTip3: 'หมายเหตุ: ค่าธรรมเนียมไม่สามารถเปลี่ยนแปลงได้จนกว่าการอนุมัติครั้งนี้จะสิ้นสุดลง',
  Cargo_ViewChangeData: 'ดูข้อมูลการเปลี่ยนแปลง',
  Cargo_GrossProfitMarginBeforeChange: 'อัตรากำไรขั้นต้นก่อนการเปลี่ยนแปลง',
  Cargo_GrossProfitMarginAfterChange: 'อัตรากำไรขั้นต้นหลังการเปลี่ยนแปลง',
  CustomFieldDisplayConfiguration: 'แสดงฟิลด์ที่กำหนดเอง',
  Field: 'เขตข้อมูล',
  ChineseDisplayName: 'ชื่อแสดงภาษาจีน',
  EnglishDisplayName: 'แสดงชื่อภาษาอังกฤษ',
  FieldNotEmpty: 'ฟิลด์ต้องไม่ว่างเปล่า',
  ChineseDisplayNameNotEmpty: 'ไม่กรอกชื่อภาษาจีน',
  EnglishDisplayNameNotEmpty: 'ไม่กรอกชื่อภาษาอังกฤษ',
  Cargo_ContractRule: 'กฏ สัญญา',
  Cargo_ApplicationConditions: 'เงื่อนไขฯ',
  Cargo_ConditionValue: 'ค่าเงื่อนไข',
  Cargo_ContractWarning: 'คำเตือนเกี่ยวกับสัญญา',
  Cargo_ApplicationRules: 'กฎการสมัคร',
  Cargo_ContractRuleChangeTip: 'กฎปัจจุบันได้ถูกนำมาใช้กับบางส่วนของสัญญาแล้ว โปรดดำเนินการเปลี่ยนแปลงกฎใหม่ก่อนโดยสัญญาที่ใช้กฎนี้',
  Cargo_DailySettlement: 'ปมสวรรค์',
  Cargo_ContractNumber2: 'หมายเลขสัญญา',
  CheckArApDisparity: 'กำหนดค่าการตรวจสอบบิลที่โพสต์โปรดเรียกเก็บเงินเจ้าหนี้ดำเนินการแยกกัน',
  VASChannelSetting: 'การกำหนดค่าช่องทางบริการเสริม',
  ManifestChannel: 'Pre-Massed Manifold ส่งซัพพลายเออร์',
  VGMChannel: 'VGM ส่งผู้จัดจำหน่าย',
  VASChannelFormEditTip: 'กรุณาเลือกการตั้งค่าช่องสัญญาณการส่งของผู้เช่าที่ต้องการแก้ไข',
  VASChannelFormDeleteTip: 'กรุณาเลือกการตั้งค่าช่องส่งผู้เช่าที่ต้องการลบ',
  VASChannelSelectOneTip: 'Pre-Massed Manifold ส่งซัพพลายเออร์ / VGM ส่งซัพพลายเออร์เลือกอย่างน้อยหนึ่งราย',
  VASChannelDeleteTip: 'ยืนยันว่าต้องการลบการตั้งค่าของผู้เช่ารายนี้ออก',
  VASChannelDTip: 'ลบการตั้งค่าช่องทางการส่ง',
  Cargo_PushAddCustomer: 'ผลักดันลูกค้ารายใหม่',
  Cargo_ChooseArea: 'กรุณาเลือกภูมิภาค',
  Cargo_AllocationSuccessful: 'จัดสรรสำเร็จ',
  Cargo_CreatedSuccessful: 'สร้างความสำเร็จ',
  Cargo_DuplicateCustomerName: 'ชื่อลูกค้าซ้ำ',
  Cargo_ExistFinanceCode: 'มีรหัสลูกค้าอยู่แล้วไม่จำเป็นต้องผลักดัน',
  Cargo_EntrustedReceiveInfo: 'มอบความไว้วางใจในการรับข้อมูล',
  Cargo_ContainerLoadTypeRailWay: 'ประเภทค่าคอมมิชชั่น (รถไฟ)',
  ExclusionOffice: 'การตั้งค่า บริษัท อินเทอร์เฟซรุ่นใหม่',
  Cargo_TransportationType: 'ประเภทการขนส่ง',
  Cargo_MultiOrderTip: 'สร้างคำสั่งซื้อจำนวนมากหากมีข้อมูลหลายชุด',
  Cargo_IdentifyTemplateName: 'ระบุชื่อแม่แบบ',
  Cargo_IdentifyTemplateName2: 'ระบุชื่อแม่แบบ:',
  Cargo_TemplateId: 'รหัสแม่แบบ',
  Cargo_CodeProcessing: 'การประมวลผลรหัส',
  Cargo_TestFile: 'เอกสารการทดสอบ',
  Cargo_TemplateIdAutomaticallyGenerated: 'รหัสแม่แบบ (สร้างอัตโนมัติ):',
  Cargo_TemplateStatus: 'สถานะแม่แบบ:',
  Cargo_DocumentTypeDescription: 'คำอธิบายประเภทไฟล์',
  Cargo_DocumentTypeDescription2: 'คำอธิบายประเภทไฟล์:',
  Cargo_ReadField: 'อ่านฟิลด์',
  Cargo_FieldName: 'ชื่อฟิลด์',
  Cargo_FieldRuleDescription: 'คำอธิบายกฎฟิลด์',
  Cargo_PreviewPromptWords: 'ตัวอย่างคำใบ้',
  Cargo_Invalid3: 'ไม่ถูกต้อง',
  Cargo_Sequence: 'ลำดับ',
  Cargo_FieldAdd: 'เพิ่มฟิลด์',
  Cargo_FieldEdit: 'แก้ไขฟิลด์',
  Cargo_FieldView: 'มุมมองฟิลด์',
  Cargo_PlatformEnterpriseName: 'แพลตฟอร์มชื่อธุรกิจ',
  Cargo_AccessKey: 'Access Key',
  Cargo_SecretKey: 'Secret Key',
  Cargo_CallBackUrl: 'ที่อยู่โทรกลับ',
  Cargo_PlatformEnterpriseInterfaceConfiguration: 'การกำหนดค่าอินเตอร์เฟซองค์กรแพลตฟอร์ม',
  Cargo_OcrTemplateConfig: 'การตั้งค่าเทมเพลต OCR',
  Cargo_OcrCode: 'การประมวลผลรหัสฝัง (การประมวลผลรหัสรองฝังผลลัพธ์สุดท้ายส่งคืนเป็นค่าเอาต์พุต API)',
  Cargo_originalValue: 'ค่าดั้งเดิม',
  Cargo_DebuggingResults: 'ผลการว่าจ้าง',
  Cargo_UsageStatistics: 'สถิติการใช้งาน',
  Cargo_NumberOfSuccessfulCalls: 'จำนวนการโทรที่ประสบความสำเร็จ',
  Cargo_UsingFlowingWater: 'การใช้น้ำไหล',
  Cargo_CallTemplateId: 'เรียกรหัสแม่แบบ',
  Cargo_CallResult: 'เรียกผลลัพธ์',
  Cargo_Template: 'เทมเพลต',
  Cargo_QueryFlowingWater: 'ดูน้ำไหล',
  Cargo_TemplateId2: 'รหัสแม่แบบ:',
  Cargo_FileName2: 'ชื่อไฟล์:',
  Cargo_IdentifyReturnResult: 'ระบุผลการส่งคืน:',
  Cargo_CustomsChannel: 'ประกาศศุลกากรระบุผู้จัดจำหน่าย',
  Cargo_PleaseSelectSpecificFields: 'โปรดเลือกช่องที่เฉพาะเพื่อแก้ไข',
  Cargo_ConfirmToDeleteThisField: 'แน่ใจนะว่าคุณต้องการลบฟิลด์? อินเทอร์เฟซจะไม่ส่งกลับข้อมูลฟิลด์นี้อีกต่อไปหลังจากการลบ',
  Cargo_ValidThisRecognitionTemplate: 'แน่ใจหรือว่าคุณต้องการเรียกคืนแม่แบบการรับรู้นี้ให้ใช้งานได้?',
  Cargo_InValidThisRecognitionTemplate: 'แน่ใจหรือว่าคุณต้องการยกเลิกการปรับแต่งนี้? อินเทอร์เฟซการเรียกใช้งานจะไม่คืนข้อมูลอีกต่อไปหลังจากล้มเหลว',
  Cargo_ValidThisRecognitionEnterprise: 'กำหนดว่าต้องการฟื้นฟูกิจการให้มีประสิทธิภาพหรือไม่',
  Cargo_InValidThisRecognitionEnterprise: 'แน่ใจนะว่าจะทำให้ธุรกิจเป็นโมฆะ จะไม่สามารถเรียกใช้อินเทอร์เฟซได้หลังจากล้มเหลว',
  Cargo_DateErrorTip: 'วันหมดอายุต้องมากกว่าวันที่มีผลใช้บังคับ',
  Cargo_ModifyCodeHandle: 'การปรับเปลี่ยน"การประมวลผลรหัส"',
  Cargo_ModifyPromptWords: 'การปรับเปลี่ยน"คำใบ้"',
  Cargo_CannotEnable: 'ไม่สามารถคลิก 【เปิดใช้】',
  Cargo_InputTokenCount: 'โมเดลขนาดใหญ่ระบุ input_token quantity',
  Cargo_OutputTokenCount: 'โมเดลขนาดใหญ่ระบุ output_token quantity',
  Cargo_PlsGenerate: 'กรุณาสร้าง',
  Cargo_TemplateUsed: 'ลายฉลุนี้ถูกใช้โดยลูกค้าและไม่สามารถแก้ไขได้ สามารถแก้ไขหรือคัดลอกลายฉลุเพื่อแก้ไขหลังจากถอดได้',
  Cargo_SelectOneData: 'อนุญาตให้ติ๊กข้อมูลเพียงรายการเดียวเพื่อคัดลอก!',
  Cargo_OutputRequirements: 'ความต้องการเอาต์พุต:',
  Cargo_AnalyticMethod: 'วิธีการวิเคราะห์:',
  Cargo_BLNoStatistics: 'สถิติหมายเลข B / L',
  Cargo_RemainingQuantity: 'จำนวนที่เหลือ',
  Cargo_RegistrationDate: 'วันที่ลงทะเบียน',
  AnalyzeChannelSettings: 'การตั้งค่าช่องวิเคราะห์',
  EmailParsingSettings: 'การตั้งค่าการแยกวิเคราะห์จดหมาย',
  EmailPasswordAuthorizationCode: 'รหัสผ่านกล่องจดหมาย / รหัสการอนุญาต',
  SenderServer: 'เซิร์ฟเวอร์ส่ง',
  Port: 'พอร์ต',
  AddOrEditEmail: 'เพิ่ม/แก้ไขกล่องจดหมาย',
  EmailPurpose: 'การใช้กล่องจดหมาย',
  EnterCorrectEmail: 'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
  SelectDeleteEmail: 'โปรดเลือกกล่องจดหมายที่คุณต้องการลบ',
  DeleteEmailConfirm: 'ยืนยันการลบกล่องจดหมายที่เลือกไว้หรือไม่? กล่องจดหมายที่ถูกลบจะไม่ถูกอ่านเพื่อแยกวิเคราะห์อีกต่อไปหลังจากการลบ',
  ImportMblNo: 'นำเข้าหมายเลขหลัก',
  ApplicableDepartment: 'หน่วยงานที่เกี่ยวข้อง',
  Cargo_QuoteMethod_ExistingRate: 'ใบเสนอราคาที่มี "อัตราค่าขนส่งที่มีอยู่" ไม่สามารถยกเลิกได้',
  Cargo_QuoteMethod: 'วิธีการเสนอราคา',
  Cargo_ExistingRate: 'อัตราค่าขนส่งที่มีอยู่',
  Cargo_CommercialQuote: 'ใบเสนอราคาทางการค้า',
  Cargo_PrePortQuoteMethod: 'วิธีการเสนอราคาก่อนท่าเรือ',
  Cargo_MainlineQuoteMethod: 'วิธีการเสนอราคาสายหลัก',
  Cargo_EndlineQuoteMethod: 'วิธีการเสนอราคาช่วงสุดท้าย',
  PleaseSelectApplicableBranch: 'กรุณาเลือกสาขาที่ต้องการ',
  Cargo_CheckSetting: 'การตั้งค่าการตรวจสอบ',
  Cargo_BookNoteFieldName: 'ชื่อช่องใส่หนังสือ',
  Cargo_IfRequired: 'จำเป็นต้องกรอกหรือไม่',
  Cargo_Channel: 'ช่องทาง',
  Cargo_IfSame: 'ความคมชัดไม่สอดคล้องกัน',
  Cargo_DefaultValue2: 'ว่างค่าปริยาย',
  Cargo_BookFieldNameRepeat: 'ชื่อช่องใส่หนังสือซ้ำ',
  Cargo_BookNoteFieldAndSort: 'ฝากหนังสือแสดงฟิลด์และลำดับ',
  Cargo_IfAutoBooking: 'ไม่ว่าจะเป็นการจองห้องโดยสารอัตโนมัติ',
  Cargo_BookRecognitionResults: 'ผลการระบุหนังสือรับรอง',
  Cargo_ConfirmedBusinessData: 'ข้อมูลการบันทึก',
  Cargo_OtherData: 'ข้อมูลอื่น ๆ',
  Cargo_BranchOffice: 'สำนักงานสาขา (สาขา)',
  Cargo_ShippingCompany: 'บริษัท เรือ ( Shipping Company )',
  Cargo_IfAutomaticBooking: 'ไม่ว่าจะเป็นการจองห้องโดยสารอัตโนมัติ (IfAutomaticBooking)',
  Cargo_Book: 'สนับสนุนหนังสือ',
  Cargo_GoodNameContainSensitiveWord: 'คำที่ละเอียดอ่อนรวมอยู่ในชื่อผลิตภัณฑ์ <span style="color: red""> {0}</span> คุณต้องการสำรองที่นั่งต่อหรือไม่?',
  Cargo_OnlyGenerateJob: 'สร้างธุรกิจเท่านั้น',
  Cargo_PleaseReceiveCallback: 'โปรดระวังการตอบกลับ',
  Cargo_JobProcess: 'ความคืบหน้าทางธุรกิจ',
  Cargo_IdentificationMethod: 'วิธีการระบุ',
  Cargo_NoNeedSupplementaryInformationBookNote: 'ไม่มีหนังสือรับรองที่ต้องการข้อมูลเพิ่มเติม',
  Cargo_SupplementaryInformationTip: 'โปรดเลือกระเบียน 【อัพโหลดความคืบหน้า】 เป็น 【การวิเคราะห์เสร็จสมบูรณ์】 และ 【ระบุช่องทาง】 เป็น 【การวิเคราะห์เสร็จสมบูรณ์】 และ 【อัพโหลดความคืบหน้า】 เป็น 【การวิเคราะห์เสร็จสมบูรณ์】',
  CannotBeLongerThan35: 'ข้อมูลยาวมากโปรดแก้ไขใหม่และส่งและรับสูงสุด {0} บรรทัดสูงสุด 35 ตัวอักษรต่อบรรทัด',
  Cargo_OcrSetTip: 'คุณยังไม่ได้ตั้งค่าข้อมูลใด ๆ ฟิลด์ต่อไปนี้รวมถึงการตั้งค่าการตรวจสอบเป็นค่าเริ่มต้นของระบบและในหนังสือรับรองจะแสดงการตั้งค่าเริ่มต้นของแพลตฟอร์ม <br /> <br /> ลำดับความสำคัญของการให้คะแนน: หากเลือก App สำนักงานใหญ่ ลำดับความสำคัญของการประยุกต์ใช้สำนักงานใหญ่ > การตั้งค่าผู้เช่า > การตั้งค่าแพลตฟอร์ม',
  Cargo_AutomaticAllocation: 'ค่าธรรมเนียมการแบ่งปันเสมือนอัตโนมัติ',
  Cargo_ChargeAutomaticAllocationConfig: 'การกำหนดค่าการกระจายค่าธรรมเนียมโดยอัตโนมัติ',
  Cargo_EditAutomaticAllocationConfig: 'แก้ไขการกำหนดค่าการแบ่งค่าธรรมเนียมตั๋วหลักโดยอัตโนมัติ',
  Cargo_AddAutomaticAllocationConfig: 'กำหนดค่าตั๋วหลักใหม่โดยอัตโนมัติ',
  Cargo_MatchingCriteriaSelection: 'การเลือกเงื่อนไขการจับคู่',
  Cargo_AutomaticAllocationRuleConfig: 'การกำหนดค่ากฎการแบ่งปันอัตโนมัติ',
  Cargo_AllocationNature: 'ลักษณะการแบ่ง',
  Cargo_HblSingleAllocation: 'HBL และแบ่งเดี่ยว',
  Cargo_OnlyAllocatedToHblSingle: 'แบ่งให้และบนโต๊ะเท่านั้น',
  Cargo_MasterBill: 'รายการหลัก',
  Cargo_AddEditReceivablePayableFees: 'เพิ่ม/แก้ไขค่าธรรมเนียมรับชำระและชำระหนี้',
  Cargo_AddEditReceivableFees: 'เพิ่ม/แก้ไขค่าธรรมเนียมรับชำระ',
  Cargo_AddEditPayableFees: 'เพิ่ม/แก้ไขค่าธรรมเนียมชำระหนี้',
  Cargo_AddEditReceivableSpecialFees: 'เพิ่ม/แก้ไขค่าธรรมเนียมพิเศษรับชำระ',
  Cargo_AddEditPayableSpecialFees: 'เพิ่ม/แก้ไขค่าธรรมเนียมพิเศษชำระหนี้',
  Cargo_DeleteReceivablePayableFees: 'ลบค่าธรรมเนียมรับชำระและชำระหนี้',
  Cargo_DeleteReceivableFees: 'ลบค่าธรรมเนียมรับชำระ',
  Cargo_DeletePayableFees: 'ลบค่าธรรมเนียมชำระหนี้',
  Cargo_ImportReceivablePayableFees: 'นำเข้าค่าธรรมเนียมรับชำระและชำระหนี้',
  Cargo_ImportReceivableFees: 'นำเข้าค่าธรรมเนียมรับชำระ',
  Cargo_ImportPayableFees: 'นำเข้าค่าธรรมเนียมชำระหนี้',
  Cargo_BusinessTypeError: 'ประเภทธุรกรรมเอกสารที่เลือกไม่ตรงกัน ไม่สามารถแก้ไขได้!',
  Cargo_ReceivableSpecialFee: 'ค่าธรรมเนียมพิเศษที่ต้องรับ',
  Cargo_PayableSpecialFee: 'ค่าธรรมเนียมพิเศษที่ต้องจ่าย',
  Cargo_ReceivablePayableSpecialFee: 'ค่าธรรมเนียมพิเศษที่ต้องรับและต้องจ่าย',
  Cargo_PleaseSetChargeNameAndAllocationType: 'กรุณาตั้งชื่อค่าธรรมเนียมและประเภทการแบ่ง',
  Cargo_PleaseSetChargeName: 'กรุณาตั้งชื่อค่าธรรมเนียม',
  Cargo_PleaseSetAllocationType: 'กรุณาตั้งค่าประเภทการแบ่ง',
  Cargo_HasDuplicateConfigItem: 'มีการกำหนดค่าข้อมูลซ้ำแล้วซ้ำอีก!',
  Cargo_ConfirmDeleteTheConfigItem: 'แน่ใจหรือว่าจะลบรายการปรับแต่งนี้หรือไม่?',
  Cargo_ConfirmSaveModifiedInfo: 'พิจารณาว่าจะบันทึกข้อมูลการแก้ไขหรือไม่',
  Cargo_InvoiceRepeat: 'หมายเลขใบแจ้งหนี้ซ้ำกัน',
  Cargo_TurnOffAutomaticAllocation: 'ค่าธรรมเนียมการแบ่งปันเสมือนจริงของตั๋วหลักนี้จะถูกปิด และเปลี่ยนเป็นการแบ่งด้วยตนเอง!',
  Cargo_RemainingAmountNotEnough: 'ยอดคงเหลือไม่เพียงพอโปรดเติมเงิน',
  Cargo_RemainingAmountNotEnough2: 'ยอดคงเหลือไม่เพียงพอต่อการสร้างธุรกิจอีกครั้ง',
  Cargo_ExpandAll: 'ขยาย >',
  Cargo_PackUp: '< เก็บของ',
  Cargo_OcrTip: 'เคล็ดลับที่อบอุ่น: ข้อมูลบันทึกหมายถึงการเขียนข้อมูลในธุรกิจที่แบบอักษรที่ทำเครื่องหมายด้วยสีแดงหมายถึงข้อผิดพลาดที่ไม่สามารถทำแผนที่กับแพลตฟอร์มได้จำเป็นต้องแก้ไขบันทึกโพสต์',
  Cargo_OcrTip2: 'เคล็ดลับ: ข้อมูลการบันทึกรายการหมายถึงข้อมูลที่เขียนลงในธุรกิจ ตัวอักษรสีแดงหมายถึงข้อผิดพลาดที่ไม่สามารถเชื่อมโยงกับแพลตฟอร์มได้',
  Cargo_ClaimSettlement: 'การเรียกร้องค่าสินไหมทดแทน',
  Cargo_BillStatusDoesNotMeetPaymentRequestRequirements: 'สถานะการเรียกเก็บเงินไม่เป็นไปตามคำขอชำระเงิน',
  Cargo_GetReceiptSettings: 'รับการตั้งค่าการตอบกลับ',
  Cargo_AddEditReadReceiptMethod: 'เพิ่ม / แก้ไขวิธีการอ่านการตอบกลับ',
  Cargo_ReadReceiptMethod: 'อ่านวิธีการโทรกลับ',
  Cargo_DeleteReceiptTip: 'แน่ใจนะว่าต้องการลบการปรับแต่งนี้? จะไม่อ่านการตอบกลับตามกฎนี้อีกต่อไปหลังจากลบ',
  Cargo_PleaseInputTitleOrContentTip: 'โปรดป้อนส่วนหัวหรือเนื้อหา',
  Cargo_BookingState: 'สถานะการจอง',
  Cargo_BookingChannelConfig: 'การกำหนดค่าช่องทางการจอง',
  Cargo_BookingMode: 'โหมดการจอง',
  Cargo_RpaSupplier: 'ผู้ให้บริการ RPA',
  Cargo_BookingChannel: 'ช่องทางการจอง',
  Cargo_ConfirmRejectQuote: 'คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธข้อเสนอ?',
  Cargo_MainlineRejectReason: 'เหตุผลการปฏิเสธสายหลัก',
  Cargo_PortRejectReason: 'เหตุผลการปฏิเสธก่อนท่าเรือ',
  Cargo_EndlineRejectReason: 'เหตุผลการปฏิเสธระยะสุดท้าย',
  Cargo_WebSite: 'ที่อยู่เว็บไซต์',
  Cargo_CompanyCode: 'รหัสบริษัท',
  Cargo_ReceiptConfig: 'การกำหนดค่าการโต้กลับ',
  Cargo_EditBookingChannelConfig: 'แก้ไขการตั้งค่าช่องทางการจอง',
  Cargo_AddBookingChannelConfig: 'เพิ่มช่องทางการจอง',
  Cargo_ReceiptConfigCannotBeEmpty: 'การกำหนดค่าการโต้กลับต้องไม่ว่างเปล่า',
  Cargo_IndiaLineInfo: 'สายอินเดีย',
  Cargo_CargoAmount: 'มูลค่าสินค้า',
  Cargo_CargoCurrency: 'สกุลเงิน',
  Cargo_YdShipCode: 'บริษัท เรือ Yiyuan',
  Cargo_SendThisPageEDI: 'ส่งหน้านี้ EDI',
  Cargo_SendAllEDI: 'ส่ง EDI ทั้งหมด',
  Cargo_SendEDI: 'จะส่ง EDI หรือไม่',
  Cargo_IsSendAllEDI: 'จะส่ง EDI ครบหรือไม่',
  Cargo_SendEDISucceeded: 'ส่ง EDI สำเร็จ',
  Cargo_FailedToSendEDI: 'การส่ง EDI ล้มเหลว',
  Cargo_CheckCanSendEDI: 'จองแล้ว หรือ จองแล้ว ไม่สามารถส่งได้อีก',
  Cargo_OneKeyBooking: 'จองห้องโดยสารด้วยคลิกเดียว',
  Cargo_OneKeyBookingTip1: 'ธุรกิจที่เริ่มต้นการจองห้องโดยสารตามเงื่อนไข: < span style="color: blue"> {0}</span> แถบ 【ยืนยัน】 การจองจะเริ่มต้นโดยตรงหลังจากคลิก สถานะการจองสามารถดูได้ที่ EDI หรือหน้าการจองห้องพักทางทะเล',
  Cargo_OneKeyBookingTip2: 'คำแนะนำที่อบอุ่น: คำสั่งซื้อที่ตรงตามเงื่อนไขต่อไปนี้จะเริ่มต้นการจองห้องพักในคลิกเดียว <br /> 1) วันที่ออกเดินทาง > วัน <br /> 2) สถานะการจองคือ "ใบสั่งซื้อที่ไม่ได้จอง" <br /> 3) ประเภทสินค้า: สินค้าทั่วไป <br /> 4) ประเภทการรวมทั้งหมด: FCL',
  Cargo_CanNotBooking: 'ไม่มีธุรกิจที่สอดคล้องกับ 【เงื่อนไขของห้องโดยสารที่สามารถจองได้】',
  Cargo_CurrentlyBooking: 'เกือบ 2 เดือนที่จอง:',
  Cargo_SendSuccess2: 'ส่งประสบความสำเร็จ:',
  Cargo_CallEdiFail: 'เรียกข้อยกเว้น:',
  Cargo_ValidFail: 'ข้อผิดพลาดในการตรวจสอบ:',
  Cargo_TemplateMatchFail: 'การจับคู่แม่แบบล้มเหลว:',
  Cargo_BookingSendMethod: 'การจองห้องพัก วิธีการส่ง',
  Cargo_BookingSendChannel: 'ช่องทางการจองห้องพัก',
  Cargo_BookingSendDate: 'จองเวลาส่ง',
  Cargo_BookingReceiptDate: 'เวลารับ-ส่งผู้โดยสาร',
  Cargo_OriginBookingState: 'สถานะการจองห้องพักเดิม',
  Cargo_NotBooking: 'ไม่จองห้องพัก',
  Cargo_ContinueBooking: 'ดำเนินการจองคลาส',
  Cargo_ChangeInfo: 'แก้ไขข้อมูล',
  Cargo_BookingTransportMode: 'วิธีการส่งจองห้องโดยสาร',
  Cargo_EdiBookingExportState: 'สถานะการส่งออก',
  Cargo_OneKeyBookingTip3: 'กำลังเริ่มการจองห้องโดยสารเพื่อดูสถานะการจองที่เฉพาะเจาะจงในภายหลัง',
  Cargo_BookingInProgress: 'การจองห้องพัก',
  Cargo_NewSpaceCarrier: 'เพิ่ม Cabin Carrier',
  Cargo_AlreadyExistsCheck: 'มีข้อมูลเดิมอยู่แล้วไม่จำเป็นต้องบันทึก',
  Cargo_portOfLoadingSeaport: 'ข้อมูลห้องโดยสาร ท่าเรือต้นทาง (ท่าเรือ)',
  Cargo_portOfDestinationSeaport: 'ข้อมูลห้องโดยสาร ท่าเรือปลายทาง (ท่าเรือ)',
  Cargo_portOfLoadingAirport: 'ข้อมูลห้องโดยสาร ท่าเรือต้นทาง (ท่าเรือว่างเปล่า)',
  Cargo_portOfDestinationAirport: 'ข้อมูลห้องโดยสาร ท่าเรือปลายทาง (ท่าเรือว่างเปล่า)',
  Cargo_shippingCarrier: 'ผู้ให้บริการห้องโดยสาร',
  Cargo_shippingAirline: 'ข้อมูลชั้นโดยสาร เส้นทางบิน',
  Cargo_newEventRecord: 'เพิ่มบันทึกเหตุการณ์',
  Cargo_SelectInquiryToCopy: 'โปรดเลือกการสอบถามที่ต้องการคัดลอก',
  Cargo_VerifyStateReceivableDomestic: 'สถานะการรับชำระหนี้ในประเทศ',
  Cargo_VerifyStateReceivableOversea: 'สถานะลูกหนี้ต่างประเทศ',
  Cargo_ReturnActualAmountNo: 'หมายเลขน้ำสัมพันธ์',
  Cargo_ReturnAmount: 'จำนวนเงินคืน',
  Cargo_ReturnApplyAmount: 'จำนวนเงินในการคืนเงิน',
  Cargo_ReturnApplyState: 'สถานะการคืนเงิน',
  Cargo_ReturnApply: 'การคืนเงิน',
  Cargo_ReturnApplyCancel: 'ยกเลิกการคืนเงิน',
  Cargo_ReturnApplyAudit: 'ยินยอมคืนเงิน',
  Cargo_ReturnApplyReject: 'การปฏิเสธการคืนเงิน',
  Cargo_RemainingClaimedAmount: 'จำนวนเงินที่เรียกร้องคงเหลือ',
  Cargo_RefundAmount: 'จำนวนเงินคืน',
  Cargo_ReturnApplyCheck: 'มีประวัติการคืนเงินที่รอการอนุมัติและไม่สามารถเริ่มคำขอคืนเงินใหม่ได้ในขณะนี้!',
  Cargo_RemainingClaimedAmountZero: 'ยอดคงเหลือ 0 และไม่สามารถคืนเงินได้!',
  Cargo_ReturnApplyAmountZero: 'จำนวนเงินคืนคือ 0 และไม่สามารถคืนเงินได้!',
  Cargo_ReturnApplyAuditCheck: 'สถานะเป็นบันทึกในการอนุมัติเท่านั้นโปรดติ๊กอีกครั้ง!',
  Cargo_WaterRefundedNoWriteOff: 'บันทึกการคืนเงินค่าน้ำ, การดำเนินการเรียกร้องไม่สนับสนุน!',
  Cargo_WaterRefundingNoWriteOff: 'สถานะการคืนเงินเป็นบันทึกในการอนุมัติและไม่สนับสนุนการดำเนินการอ้างสิทธิ์!',
  Cargo_WaterRefundedNoCancel: 'บันทึกการคืนเงินค่าน้ำ, ถอนการดำเนินการเรียกร้องไม่สนับสนุน!',
  Cargo_khEntryActTime: 'บัตรแอร์ขาเข้า (เวลาจริง)',
  Cargo_transferDeclareCompletedActTime: 'การประกาศแปลงที่ดินเสร็จสิ้น (ตามเวลาจริง)',
  Cargo_khExitActTime: 'CAR ขาออก (เวลาจริง)',
  Cargo_khDeclareActTime: 'บัตรผ่านพิธีการศุลกากร (เวลาจริง)',
  Cargo_khReplacementActTime: 'การเปลี่ยนบรรทุก (เวลาจริง)',
  Cargo_arrivePodActTime: 'ถึงจุดหมายปลายทาง (เวลาจริง)',
  Cargo_arriveClearActTime: 'มาถึงสถานที่พิธีการศุลกากร (เวลาจริง)',
  Cargo_khUnloadingActTime: 'การขนถ่าย (เวลาจริง)',
  Cargo_CustomerReserveVoyage: 'ลูกค้าที่จองเที่ยวบิน',
  Cargo_CustomsDeclarationInformation: 'ข้อมูลรายการปิด',
  Cargo_CustomsDeclarationCommissionNumber: 'หมายเลขใบมอบอำนาจการประกาศศุลกากร',
  Cargo_CustomsDeclarationNotExist: 'กรุณารักษาอย่างน้อยหนึ่งรายการ 【ข้อมูลรายการปิด】',
  Cargo_QuantityWeightCubageChange: 'การเปลี่ยนแปลงข้อมูล trichomes ของชิ้นส่วนจะครอบคลุมหรือไม่?',
  Cargo_ReferenceNoRepeat: 'หมายเลขอ้างอิงใน VGM ไม่สามารถทำซ้ำได้',
  Cargo_CustomerDemandClearanceNumber: 'ความต้องการของลูกค้าปิดเอกพจน์',
  Cargo_Empty2: '(ว่างเปล่า)',
  Cargo_QuantityWeightCubage: 'ชิ้น ร่างกายผม',
  Cargo_CustomsDeclarationDeleteTip: 'หมายเลขใบศุลกากรปัจจุบันเกี่ยวข้องกับประกาศศุลกากรที่ได้รับมอบหมายไม่สามารถลบได้',
  Cargo_CustomsDeclarationValidTip: 'Trichomes ของชิ้นส่วนของข้อมูลศุลกากรไม่สามารถเป็น 0',
  Cargo_CustomsDeclarationSoNoRepeat: '【หมายเลขใบปิด】 ในข้อมูลของใบสั่งศุลกากรในธุรกิจบัตรเดียวกันไม่ได้รับอนุญาตให้ทำซ้ำ',
  Cargo_AuditCancel: 'แน่ใจนะว่าคุณต้องการยกเลิกการตรวจสอบ!',
  Cargo_AuditCancelReason: 'เหตุผลในการยกเลิกการตรวจสอบ',
  Cargo_NuoNuoTipOne: 'เมื่อช่องทางการออกใบแจ้งหนี้ = NONO, รายการการกำหนดค่านี้เติม 1 สำหรับ Red Chong ไม่ได้ออกโดยอัตโนมัติไม่จำเป็นต้องกำหนดค่าเมื่อออกอัตโนมัติ',
  Cargo_DestinationVehicleNumberOne: 'จุดหมายปลายทางอันดับหนึ่ง',
  Cargo_DestinationVehicleRegister: 'ลงทะเบียนรถรับส่งปลายทาง',
  Cargo_ConfirmLockLabelBuyingPrice: 'กำหนดราคารับซื้อล็อกหรือไม่',
  Cargo_ConfirmLockLabelSellingPrice: 'กำหนดล็อกราคาขายหรือไม่',
  Cargo_ConfirmUnlockLabelBuyingPrice: 'กำหนดราคารับซื้อปลดล็อกหรือไม่',
  Cargo_ConfirmUnlockLabelSellingPrice: 'กำหนดปลดล็อกราคาขายหรือไม่',
  Cargo_PurchasePriceLockedStatus: 'สถานะล็อคราคาซื้อ',
  Cargo_SellingPriceLockedStatus: 'สถานะล็อคราคาขาย',
  Cargo_BatchPurchasePriceLock: 'ราคาซื้อล็อคจำนวนมาก',
  Cargo_BatchPurchasePriceUnLock: 'ปลดล็อกราคาซื้อจำนวนมาก',
  Cargo_BatchSellingPriceUnLock: 'ปลดล็อกราคาขายเป็นกลุ่ม',
  Cargo_BatchSellingPriceLock: 'ราคาขายล็อคจำนวนมาก',
  Cargo_NotActiveCompanyCleared: 'พันธมิตรที่ไม่ได้ใช้งานรวมอยู่ในธุรกิจตั๋วนี้: {0} ระบบจะล้างข้อมูลโดยอัตโนมัติ โปรดเลือกรายการใหม่',
  Cargo_FBA_SE: 'การขนส่งทางทะเล FBA',
  Cargo_FBA_AE: 'FBA ทางอากาศ',
  Cargo_FBA_RE: 'FBA รถไฟ',
  Cargo_SyncCreditTip: 'หลังจากคลิกปุ่มนี้ 【ซิงค์】 เครดิตชั่วคราวของหน้าปัจจุบันที่ตรงตามข้อกำหนดจะมีผลทันทีวงเงินระยะเวลาบัญชีจะถูกคำนวณใหม่อาจมีความล่าช้าบางส่วนโปรดอดทน',
  Cargo_SyncTempCreditTip: 'ไม่มีการซิงค์ทันทีเมื่อมีกระแสการอนุมัติเครดิตชั่วคราว',
  Cargo_OperationInstructions: 'คำแนะนำการดำเนินงาน',
  Cargo_InstructionName: 'ชื่อคำสั่ง',
  Cargo_InstructionType: 'ประเภทของคำสั่ง',
  Cargo_RuleCode: 'รหัสกติกา',
  Cargo_CodeParameterValues: 'รหัส พารามิเตอร์ ค่า',
  Cargo_InstructionCode: 'รหัสคำสั่ง',
  Cargo_CommandDisplayName: 'ชื่อแสดงคำสั่ง',
  Cargo_InstructionDescription: 'คำอธิบายคำสั่ง',
  Cargo_InstructionRuleSetting: 'การตั้งค่ากฎคำสั่ง',
  Cargo_IfAllowedSendMultipleTimes: 'ไม่ว่าจะเป็นการอนุญาตให้ส่งหลายครั้ง',
  Cargo_CanOnlyBeSentOnce: 'สามารถส่งได้เพียงครั้งเดียว',
  Cargo_CanBeSentMultipleTimes: 'สามารถส่งได้หลายครั้ง',
  Cargo_TemplateMatching: 'การจับคู่แม่แบบ',
  Cargo_UnifiedBusinessScenario: 'เมื่อเลือกการเชื่อมโยงผลักดันเมื่อสาขาที่แตกต่างกันมีเทมเพลตการบำรุงรักษาที่เป็นอิสระสอดคล้องกับแม่แบบสาขาที่ตรงกัน',
  Cargo_SelectEmailTemplate: 'เลือกเทมเพลตจดหมาย',
  Cargo_SelectOperationInstruction: 'เลือกคำแนะนำการดำเนินงาน',
  Cargo_SelectSpecificBusinessRule: 'เลือกกฎระเบียบทางธุรกิจที่เฉพาะเจาะจง',
  Cargo_SelectThePushLink: 'เลือก Push Link',
  Cargo_OperationButtonSettingsAndTip: 'การตั้งค่าปุ่มการทำงาน (ตั้งค่าคำสั่งการทำงานสูงสุด 5 คำสั่ง)',
  Cargo_SelectInstruction: 'เลือกคำแนะนำ',
  Cargo_SetParameters: 'ตั้งค่าพารามิเตอร์',
  Cargo_SetParameterValues: 'ตั้งค่าพารามิเตอร์',
  Cargo_InstructionChineseName: 'ชื่อภาษาจีนของคำแนะนำ',
  Cargo_InstructionEnglishName: 'ชื่อภาษาอังกฤษของคำสั่ง',
  Cargo_InstructionJapaneseName: 'ชื่อภาษาญี่ปุ่นของคำแนะนำ',
  Cargo_CheckRuleNameExist: 'มีอยู่แล้ว 【{0}】 ชื่อกฎ',
  Cargo_LatestInstructionRecord: 'การดำเนินการตามคำสั่งปฏิบัติการล่าสุด',
  Cargo_InstructionRecords: 'บันทึกคำสั่งการดำเนินงาน',
  Cargo_QueryInstructionRecords: 'ดูบันทึกการดำเนินการคำสั่ง',
  Cargo_ExecuteResult: 'ผลการดำเนินการ',
  Cargo_OperationInstructionsManagement: 'การจัดการคำสั่งการดำเนินงาน',
  Cargo_PlatformInstructionDisabled: 'คำสั่งไม่สามารถใช้งานได้โปรดตรวจสอบว่าการกำหนดค่าถูกต้อง!',
  Cargo_NotMatchInstruction: 'ไม่มีกิจการที่เข้าเงื่อนไขตามคำสั่งนี้',
  Cargo_SelectJobCount: 'จำนวนแถบธุรกิจที่เลือก',
  Cargo_MatchInstructionTip: 'ตรวจสอบแถบ {0} แถบ {1} ที่ตรงกับเงื่อนไขของคำสั่งการดำเนินงาน',
  Cargo_OperationInstructionSetTip: 'ค่า 【เลือกคำแนะนำ】 ไม่สามารถว่างเปล่าเมื่อมีการตั้งค่าคำสั่งปฏิบัติการ!',
  Cargo_OperationInstructionRepeatTip: 'คำสั่งที่เลือกไม่สามารถทำซ้ำเมื่อมีการตั้งค่าคำสั่งการดำเนินงาน!',
  Cargo_OperationInstructionBatchTip: 'อย่าเลือกข้อมูลธุรกิจมากกว่า 30 รายการทุกครั้งที่คุณส่งข้อความเป็นกลุ่ม',
  Cargo_CurrentUserRole: 'บทบาทผู้ใช้ปัจจุบัน',
  Cargo_DisabledUnableToSave: '"{0}" ถูกปิดใช้งานและไม่สามารถบันทึกได้ โปรดลบค่าธรรมเนียมที่เกี่ยวข้องเพื่อบันทึกใหม่',
  Cargo_CompanyDateOfCreation: 'เวลาสร้างหน่วยมอบหมาย',
  Cargo_BringInBusinessInformation: 'ข้อมูลการสั่งซื้อเพิ่มเติม',
  Cargo_LclSendDestinationPortAgentTip: 'สามารถเลือกใช้บริการ Master Ticket ได้เพียง 1 รายการเท่านั้น',
  Cargo_LclSendPackageAgentTip: 'สามารถเลือกทำธุรกิจ Master Ticket ได้เพียง 1 รายการสำหรับการส่ง Set Single Port Agent',
  Cargo_SetUploadFileType: 'ตั้งค่าประเภทไฟล์ที่อัปโหลด',
  Cargo_PillReportData: 'สร้างและแทนที่แหล่งข้อมูลด้วยตนเอง',
  Cargo_CanOnlyPrintOnce: 'สามารถพิมพ์ได้เพียงครั้งเดียว',
  Cargo_CanPrintMultipleTimes: 'สามารถพิมพ์ได้หลายครั้ง',
  Cargo_IfSelectTemplateType: 'เลือกประเภทไฟล์เทมเพลตเมื่อสาขาต่างๆมีเทมเพลตการบำรุงรักษาอิสระที่สอดคล้องกับเทมเพลตสาขา',
  Cargo_PrintMode: 'โหมดการพิมพ์',
  Cargo_SingleJobPrint: 'ธุรกิจพิมพ์ตั๋วใบเดียว',
  Cargo_BatchJobPrint: 'การพิมพ์ธุรกิจจำนวนมาก',
  Cargo_SinglePrintFileType: 'ประเภทไฟล์การพิมพ์ตั๋วใบเดียว',
  Cargo_BatchPrintFileType: 'ประเภทไฟล์พิมพ์แบทช์',
  Cargo_SinglePrintFileTemplate: 'เทมเพลตไฟล์การพิมพ์ตั๋วใบเดียว',
  Cargo_BatchPrintFileTemplate: 'เทมเพลตไฟล์การพิมพ์จำนวนมาก',
  Cargo_SelectPrintFileTemplate: 'เลือกแม่แบบไฟล์พิมพ์',
  Cargo_SelectPrintFileType: 'เลือกประเภทไฟล์ที่พิมพ์',
  Cargo_SelectPrintFileTypeTip: 'แม่แบบการพิมพ์ที่เลือกไม่ได้ตั้งค่าประเภทแฟ้ม! โปรดตั้งค่าประเภทไฟล์ที่สอดคล้องกับแม่แบบการพิมพ์ก่อน',
  Cargo_CabinRetrievalSuccessful: 'ความสำเร็จในการกู้คืนห้องโดยสาร',
  Cargo_CabinFlowExitAndNo: 'การปรากฏตัวของข้อมูลของการไหลของห้องโดยสารและการไหลของห้องโดยสารไม่มีน้ำไม่สามารถดำเนินการร่วมกัน',
  Cargo_CabinRetrievalAndReturnSuccessful: 'การรีไซเคิลและการคืนพื้นที่ประสบความสำเร็จ',
  Cargo_revokeCabinSpace: 'คำสั่งที่คุณติ๊กกระบวนการถอนจะดำเนินการ',
  Cargo_CancelCabinAtTheSameTime: 'ออกจากห้องโดยสารพร้อมกัน',
  Cargo_DeleteConfigTip: 'แน่ใจว่าจะลบหรือไม่ หลังจากลบการตั้งค่าฟังก์ชั่นเดิมจะไม่สามารถใช้งานได้!',
  Cargo_PreviewVoucher: 'ตัวอย่างคูปอง',
  Cargo_InvoiceNotVoucher: 'ใบแจ้งหนี้ไม่มีบัตรกำนัล โปรดเลือกอีกครั้ง',
  Cargo_BankSlipNotVoucher: 'บัตรกำนัลนี้ไม่ได้ถูกสร้างขึ้น โปรดเลือกอีกครั้ง',
  Cargo_PleaseChooseDataThatHasVouchered: 'โปรดเลือกข้อมูลที่สร้างบัตรกำนัล',
  Cargo_ExportVoucherSuccessfully: '{0} ส่งออกบัตรกำนัลเรียบร้อยแล้ว',
  Cargo_ExportVoucherFailedByBankSlip: 'การส่งออกหมายเลขน้ำ {0} ล้มเหลวด้วยเหตุผล {1} โปรดลองอีกครั้ง',
  Cargo_ExportVoucherFailedByInvoice: 'การส่งออกใบแจ้งหนี้ {0} ล้มเหลวด้วยเหตุผล {1} โปรดลองอีกครั้ง',
  Cargo_UpdatePaidOffFlag: 'รีเฟรชไม่ว่าจะถูกเพิกถอนหรือไม่',
  Cargo_CheckMblSame: 'MB/L NO ไม่สอดคล้องกับการเซ็นหน้าพื้นฐาน',
  Cargo_IfExistMblNumberRange: 'ไม่ว่าจะเป็นส่วนที่เป็นหมายเลขเดี่ยวหลัก',
  Cargo_UserName_Password_Maintained: 'ติดต่อผู้ดูแลระบบเพื่อ "การตั้งค่าพื้นฐาน - การตั้งค่าช่องวิเคราะห์" การบำรุงรักษา',
  Cargo_ShipCompany_Maintained: 'กรุณาติดต่อผู้ดูแลระบบเพื่อ "พันธมิตร" การบำรุงรักษา บริษัท เรือที่เกี่ยวข้อง',
  Cargo_ShippingCompanyCode_Maintained: 'บริษัท เรือแผนที่ที่ไม่ได้รับการบำรุงรักษาโปรดติดต่อฝ่ายบริการลูกค้าแพลตฟอร์มการบำรุงรักษา',
  Cargo_ShippingCompanyCode_MaintainedTip: 'กรุณาติดต่อฝ่ายบริการลูกค้าของแพลตฟอร์ม',
  Cargo_BookingChannelConfig_Maintained: 'ไม่ตรงกับการตั้งค่าช่องทางการจอง โปรดติดต่อผู้ดูแลระบบเพื่อบำรุงรักษา "การกำหนดค่าพื้นฐาน - การกำหนดค่าช่องทางการจอง"',
  Cargo_BookingChannelConfig_MaintainedTip: 'ติดต่อผู้ดูแลระบบเพื่อบำรุงรักษา "การกำหนดค่าพื้นฐาน - การกำหนดค่าช่องทางการจอง"',
  Cargo_ErrorMsg: 'สาเหตุของความผิดปกติ',
  Cargo_SelectJumpErrorTip: '【{0}】 ไม่ใช่หน้า Jumpable โปรดเลือกหน้าเช่น: 【{0}】',
  Cargo_SelectJumpPage: 'เลือกหน้าข้าม',
  Cargo_JumpSet: 'การตั้งค่ากระโดด',
  Cargo_ClickJobNoJumpPage: 'คลิกที่หน้าจัมพ์หมายเลขธุรกิจ',
  Cargo_JumpPage: 'หน้าข้าม',
  Cargo_TabNotExistTip: 'ไม่สามารถเข้าถึงเพจได้,ทั้งนี้ ขอยืนยันว่ามีการเข้าถึงหรือเอกสารที่มีเพจดังกล่าว',
  Cargo_CargoValue: 'ค่าระบบ',
  Cargo_YdValue: 'ข้อมูลการตอบกลับ',
  Cargo_ConfirmReplace: 'ยืนยันความคุ้มครอง',
  Cargo_NotReplace: 'ไม่ครอบคลุม',
  Cargo_ReplaceSystemValue: 'ครอบคลุมข้อมูลระบบ',
  Cargo_PleaseSelectDataToReplace: 'โปรดเลือกข้อมูลฟิลด์ที่คุณต้องการเขียนทับ',
  Cargo_YdBookingResultTip: 'ตรวจพบว่ามีการเบี่ยงเบนข้อมูลในการตอบกลับจากข้อมูลที่เข้ามาในระบบ จึงขอยืนยัน',
  Cargo_NoMappingValuesTip: '{0} ไม่ตรงกับค่าของระบบ หากคุณต้องการแก้ไขโปรดเลือกด้วยตนเอง',
  Cargo_NonReplaceDataTip: 'ไม่มีข้อมูลที่ต้องการความคุ้มครอง',
  Cargo_JobNotFound: 'ไม่สอบถามถึงธุรกิจ 【{0}】',
  Cargo_AE_IDENTIFICATION_SUPPLIER: 'ผู้จำหน่ายบัตรประจำตัวหนังสือที่ว่างเปล่า',
  Cargo_AIR_BILL_SUPPLIER: 'ผู้ให้บริการระบุ BL ทางอากาศ',
  Cargo_LoadingDate: 'บริการ Door Point - เวลารับสินค้า',
  Cargo_DoorAddr: 'บริการ Doorpoint - ที่อยู่ Doorpoint',
  Cargo_DoorMan: 'บริการ Doorpoint - ติดต่อ',
  Cargo_DriverTel: 'Doorpoint Service - เบอร์ติดต่อ',
  Cargo_aeFile: 'เอกสารฝากหนังสือว่างเปล่า',
  Cargo_aiFile: 'เอกสารใบตราส่งสินค้าทางอากาศ',
  Cargo_carrierType: 'ประเภทของ Cabin Carrier',
  Cargo_DeclaredValue: 'ประกาศมูลค่า',
  Cargo_DeclaredValueForCustoms: 'มูลค่าของประกาศศุลกากร',
  Cargo_RateLevel: 'ระดับราคา',
  Cargo_PleaseSelectOperateType: 'หน้า 【{0}】 ฝากหนังสือ โปรดเลือกโหมดการทำงาน',
  Cargo_BaoDiCreditInfoNote: 'หมายเหตุ: ระยะเวลาค้ำประกันจะถูกคำนวณเมื่อประเภทวันที่กำหนดค่าในระบบว่างเปล่า (การประมวลผลการตั้งถิ่นฐานเป็นรายเดือนแบบครบวงจร) และวันหมดอายุของค่าธรรมเนียมจะถูกคำนวณใหม่เมื่อประเภทวันที่ในธุรกิจมีมูลค่า',
  Cargo_RpaAccount: 'หมายเลขบัญชีโฮสติ้ง RPA',
  Cargo_WechatGroupName: 'บริษัท ไมโครแชทกลุ่มชื่อ',
  Cargo_TabEnterpriseWechat: 'โฮสติ้งบัญชี Enterprise Micro',
  Cargo_LoginEnterpriseWechat: 'เข้าสู่ระบบ Enterprise Micro',
  Cargo_LoginEnterpriseWechatTip: 'กรุณาใช้ Enterprise WeChat สแกนรหัสเพื่อเข้าสู่ Enterprise Micro',
  Cargo_RpaAccountSummary: 'ข้อมูลบัญชีโฮสติ้ง RPA',
  Cargo_RpaAccountSummaryTip: 'หากต้องการปรับเปลี่ยนคุณสามารถปรับได้ที่ [คู่ค้า - ติดต่อ] หน้า',
  Cargo_RpaAccountColumn: 'บัญชี WeChat ขององค์กร',
  Cargo_RpaAccountEnabled: 'สถานะบัญชี',
  Cargo_BatchEditEnterpriseWechat: 'แก้ไขรายชื่อ บริษัท ไมโครกรุ๊ปแชทเป็นกลุ่ม',
  Cargo_EditEnterpriseWechatButton: 'การปรับเปลี่ยนชุดแชทกลุ่มขนาดเล็กขององค์กร',
  Cargo_RpaAccountColumn2: 'หมายเลขบัญชีโฮสติ้ง RPA',
  Cargo_EditEnterpriseWechatTitle: 'แก้ไขการติดต่อองค์กรไมโครแชทกลุ่ม',
  Cargo_RpaAccountWechatGroupNameCanTBeEmpty: 'โปรดบันทึกหลังจากกรอกหมายเลขบัญชีโฮสติ้ง RPA / ช่องแชทกลุ่ม WeChat ขององค์กร',
  Cargo_EnterpriseWechat: 'บริษัท WeChat',
  Cargo_MessageContent: 'เนื้อหาข้อความ',
  Cargo_PushFiles: 'ผลักดันไฟล์',
  Cargo_PushFilesTip: 'ไฟล์จะถูกบีบอัดเป็นไฟล์ ZIP และส่งไปยังกลุ่ม WeChat ขององค์กรผ่านทางที่อยู่เชื่อมโยงการดาวน์โหลด',
  Cargo_EnterpriseWechat2DataServiceReminder: '(เฉพาะการเปลี่ยนแปลงตารางเรือ)',
  Cargo_EnterpriseWechatSopTip: 'กรุณากรอกชื่อกลุ่มแชทให้ถูกต้อง มิฉะนั้นจะไม่สามารถกดได้ หากมีมากกว่าหนึ่งรายการโปรดกรอกด้วย "," คั่นกัน',
  Cargo_PleaseInputVerificationCode: 'โปรดป้อนรหัสยืนยัน',
  Cargo_InputVerificationCodeTip1: 'อุปกรณ์นี้เป็นการเข้าสู่ระบบครั้งแรกและต้องใส่รหัสยืนยันโปรดป้อนรหัสยืนยันที่ได้รับจากไคลเอนต์โทรศัพท์มือถือ Micro Account ขององค์กร',
  Cargo_InputVerificationCodeTip2: 'การตรวจสอบล้มเหลว, รหัสยืนยันไม่ถูกต้องหรือหมดอายุ, โปรดป้อนอีกครั้ง',
  Cargo_CaptchaUsing: 'ในการตรวจสอบโปรดรีเฟรชสถานะในภายหลัง...',
  Cargo_LoginSuccess: 'หมายเลขบัญชี: {0}, เข้าสู่ระบบเรียบร้อยแล้ว',
  Cargo_PushEnterpriseWechat: 'ไม่ว่าจะเป็นการผลักดันขนาดเล็ก',
  Cargo_PushEnterpriseWechatTip: 'ผู้ติดต่อไม่ได้ตั้งค่าบัญชี Micro ขององค์กรและชื่อแชทกลุ่ม การผลักดันข้อความจะล้มเหลว',
  Cargo_BottomLineCreditControl: 'การควบคุมข้อมูลด้านล่าง',
  Cargo_ProfitShareConfig: 'การกำหนดค่าส่วนแบ่งกำไร',
  Cargo_CreateRule: 'สร้างกฎ',
  Cargo_EditRule: 'แก้ไขกฎ',
  Cargo_CopyRule: 'คัดลอกกฎ',
  Cargo_RuleName: 'ชื่อกฎการแบ่งปัน',
  Cargo_RuleConfig: 'การกำหนดค่ากฎ',
  Cargo_RuleRole: 'บทบาท',
  Cargo_ShareMode: 'โหมดแบ่งงาน',
  Cargo_ShareModeJob: 'แบ่งตามกำไรตั๋วทั้งหมด',
  Cargo_ShareModeCurrency: 'แบ่งกำไรตามสกุลเงิน',
  Cargo_UsdRatio: 'อัตราส่วนการแบ่งปัน',
  Cargo_NonUsdRatio: 'อัตราส่วนที่ไม่ใช่ USD',
  Cargo_ShareModeTip: 'โหมด:',
  Cargo_ShareModeJobTip: 'ตั๋วทั้งหมด',
  Cargo_BankSlipDateCreated: 'วันที่จัดทำบิลน้ำ',
  Cargo_ShareRatio: 'การแบ่งส่วน:',
  Cargo_PleaseSelectSalesBranch: 'กรุณาเลือกสาขาการขาย',
  Cargo_RuleConfigSubCountNotNull: 'จำนวนสาขาที่กำหนดค่ากฎไม่สามารถว่างได้',
  Cargo_SetUpConfigSubTriggerCondition: 'โปรดตั้งเงื่อนไขทริกเกอร์',
  Cargo_ConfigSubRuleError: 'การเปลี่ยนแปลงเงื่อนไขกฎการแบ่งปันการกำหนดค่าเงื่อนไขทริกเกอร์ผิดพลาด',
  Cargo_AddRuleConfigSub: '+ เพิ่มการกำหนดค่าสาขา',
  Cargo_AreYouSureModifyRuleConfigTips: 'ยืนยันการแก้ไขหรือไม่',
  Cargo_ProfitShare: 'มีส่วนเกี่ยวข้องกับการแบ่งหน้าที่กันทำหรือไม่',
  Cargo_ProfitShareColumn: 'ไม่ว่าจะแบ่งหน้าที่กันทำ',
  Cargo_ProfitShareAdjust: 'การปรับค่าความแตกต่าง',
  Cargo_ProfitShareReset: 'แบ่งหน้าที่กันใหม่',
  Cargo_NonProfitShareBranch: 'ไม่มีสาขาเกี่ยวข้องกับการแบ่งหน้าที่กันทำ',
  Cargo_ProfitShareRatioSumExceed: 'ขณะนี้สัดส่วนการแบ่งปันเกิน 100% ขอยืนยันหลังปรับแก้ใหม่',
  Cargo_UsdProfit: 'กำไร USD',
  Cargo_NonUsdProfit: 'กำไรที่ไม่ใช่ USD',
  Cargo_JobProfit: 'กำไรตั๋วทั้งหมด',
  Cargo_ShareBranchId: 'แบ่งพรรคแบ่งพวก',
  Cargo_UsdRatioColumn: 'อัตราส่วน Division',
  Cargo_UsdProfitColumn: 'USDKIN คาดว่าจะทำกำไรได้',
  Cargo_UsdProfitColumn2: 'คาดว่าจะทำกำไรได้',
  Cargo_NonUsdRatioColumn: 'อัตราส่วน Non-Mergin',
  Cargo_NonUsdProfitColumn: 'NON-USD คาดว่าจะทำกำไรได้',
  Cargo_CheckProfitShareResetTip: '{0} แบ่งค่าใช้จ่ายเพื่อดำเนินการทางการเงินที่ตามมา (ใบแจ้งหนี้การชำระเงินการเรียกเก็บเงินการชำระเงิน ... ) ไม่สามารถแบ่งใหม่ได้ชั่วคราวลองอีกครั้งหลังจากยกเลิกการดำเนินการทางการเงินที่สอดคล้องกัน',
  Cargo_AdjustColumn: 'การเปลี่ยนแปลง',
  Cargo_UsdProfitAdjustColumn: 'USDKIN คาดว่าจะทำกำไรเพิ่มเติม',
  Cargo_UsdProfitAdjustColumn2: 'คาดว่าจะมีกำไรเพิ่มขึ้น',
  Cargo_NonUsdProfitAdjustColumn: 'NON USD คาดว่าจะทำกำไรเพิ่มเติม',
  Cargo_JobProfitShare: 'ไม่ว่าจะเป็นการแบ่งหน้าที่กันทำ',
  Cargo_ReceivableFeeLockTime: 'เวลาล็อคค่าธรรมเนียมการรับ',
  Cargo_ReceivableFeeLockTime2: 'เวลาล็อคค่าธรรมเนียมการรับ',
  Cargo_PayableFeeLockTime: 'เวลาล็อคค่าใช้จ่ายที่รับผิดชอบ',
  Cargo_PayableFeeLockTime2: 'เวลาล็อคค่าใช้จ่ายที่รับผิดชอบ',
  Cargo_PayableFeeLockPerson: 'ผู้ล็อคค่าใช้จ่ายเจ้าหนี้',
  Cargo_NotAssemblyQuantity: 'จำนวนชิ้นส่วนที่ประกอบได้',
  Cargo_NotAssemblyGrossWeight: 'น้ำหนักรวมประกอบ',
  Cargo_NotAssemblyVolume: 'ปริมาณประกอบ',
  Cargo_NotAssemblyChargeableWeight: 'น้ำหนักรวม',
  Cargo_Density_Weight: 'ความหนาแน่น / คุณภาพสินค้า',
  Cargo_PreWarehouseStatus: 'สถานะ Preposition',
  Cargo_DeliveryStation2: 'สถานีขนส่งสินค้า',
  Cargo_DeliveryStatus: 'สถานะการจัดส่ง',
  Cargo_PreAssemblyPlanProductionPlan: 'แผนการประกอบล่วงหน้า - แผนการผลิต',
  Cargo_ShipmentOrder: 'คำสั่งออกจากตำแหน่ง',
  Cargo_GenerateAssemblyPlan: 'สร้างแผนการประกอบ',
  Cargo_AssemblyPlanNumber: 'หมายเลขแผนประกอบ',
  Cargo_AssemblyPlanStatus: 'สถานะของแผนการประกอบ',
  Cargo_AssemblyItemCount: 'จำนวนชิ้นประกอบ',
  Cargo_AssemblyGrossWeight: 'น้ำหนักรวมประกอบ',
  Cargo_AssemblyVolume: 'ปริมาณการประกอบ',
  Cargo_AssemblyChargeableWeight: 'น้ำหนักรวม',
  Cargo_ContainerGroup: 'กลุ่มของคอนเทนเนอร์',
  Cargo_LoadingPool: 'พูลโหลด',
  Cargo_MergeGroup: 'รวมกลุ่ม',
  Cargo_DeleteGroup: 'ลบกลุ่ม',
  Cargo_AddToPlan: 'เข้าร่วมโปรแกรม',
  Cargo_AssemblyPlan: 'แผนการประกอบ',
  Cargo_PlanIssued: 'วางแผน',
  Cargo_CancelPlanIssued: 'แผนการยกเลิก',
  Cargo_PlanPrint: 'กำหนดการพิมพ์',
  Cargo_AssemblyCompleted: 'ประกอบเสร็จสมบูรณ์',
  Cargo_CancelAssemblyCompleted: 'ยกเลิกการประกอบเสร็จสมบูรณ์',
  Cargo_ConfirmCompleted: 'ยืนยันเสร็จสิ้น',
  Cargo_CancelConfirmCompleted: 'ยืนยันการยกเลิกเสร็จสิ้น',
  Cargo_ImportAssemblyPlan: 'นำเข้าแผนการประกอบ',
  Cargo_UnifiedError: '【{0}】 ไม่เป็นเอกภาพ คุณต้องการดำเนินการต่อไปหรือไม่?',
  Cargo_JoinExistingAssemblyPlan: 'รวมเข้ากับแผนการประกอบที่มีอยู่แล้วหรือไม่',
  Cargo_ExistingPlanIssued: 'มีแผนการประกอบชิ้นส่วนที่สั่งการและไม่มีการควบรวมกิจการชั่วคราวโปรดยกเลิกการลองใหม่หลังจากสั่งการ',
  Cargo_CostAllocated: 'มีการแบ่งต้นทุนแล้ว ขอให้ผู้ใช้ลบต้นทุนที่แบ่งไว้เอง จะดำเนินการต่อหรือไม่',
  Cargo_MaintainAtLeastOneGroup: 'กรุณารักษากลุ่มคอนเทนเนอร์อย่างน้อยหนึ่งกลุ่ม',
  Cargo_FieldsCannotBeEmpty: '【ชิ้น / ผม / ร่างกาย / เมตร】 ต้องมีมากกว่า 0 โปรดตรวจสอบ',
  Cargo_AssemblyPlanExceedsContainerGroup: '【แผนการประกอบ - การจัดกลุ่มตู้คอนเทนเนอร์】 มากกว่าจำนวน 【แผนการประกอบ - การจัดกลุ่มตู้คอนเทนเนอร์】 คุณต้องการดำเนินการต่อหรือไม่?',
  Cargo_PlanIssuedTip: 'แผนการประกอบชิ้นส่วนได้ถูกวางไว้แล้วและไม่สามารถใช้งานได้โปรดยกเลิกการลองใหม่อีกครั้งหลังจากสั่งซื้อ',
  Cargo_PieceWeightVolumeUnit: 'ชิ้น Trichometer',
  Cargo_PleaseConfirmFinancialDate: 'กรุณายืนยันวันที่ทำการเงิน:',
  Cargo_SoldSlots: 'พื้นที่ขาย',
  Cargo_RemainingSlots: 'ค่าเผื่อห้องโดยสาร',
  Cargo_SoldVolume: 'ปริมาณการขาย',
  Cargo_RemainingVolume: 'ค่าเผื่อปริมาตร',
  Cargo_FlightDateError: 'วันที่ทำการบินไม่อยู่ในช่วงวันหมดอายุของผลิตภัณฑ์เส้นทางบิน หรือเที่ยวบินที่ตรงกับวันที่เที่ยวบินไม่ได้อยู่ในเที่ยวบินที่มีการบำรุงรักษาผลิตภัณฑ์เส้นทางบิน จะดำเนินการต่อหรือไม่',
  Cargo_DimensionsExceedRouteProductLimits: 'ขนาดเกินกว่าขีด จำกัด ของผลิตภัณฑ์เส้นทางการบิน - ในเที่ยวบินต่อไปหรือไม่?',
  Cargo_FlightReassignment: 'การเปลี่ยนแปลงเที่ยวบิน',
  Cargo_InformationMaintenance: 'การบำรุงรักษาข้อมูล',
  Cargo_VehicleInformation: 'ข้อมูลยานพาหนะ',
  Cargo_CountyDistrict: 'อำเภอ/เขต',
  Cargo_TownStreet: 'เมือง/ถนน',
  Cargo_VillageCommunity: 'หมู่บ้าน/ชุมชน',
  Cargo_FleetPhoneNumber: 'หมายเลขโทรศัพท์ขอกองเรือ',
  Cargo_DoorPointName: 'ชื่อจุดประตู',
  Cargo_DeliveryArea: 'พื้นที่ส่งมอบ',
  Cargo_EstimatedLoadingTime: 'เวลาโหลดที่คาดการณ์',
  Cargo_ActualLoadingTime1: 'เวลาโหลดจริง',
  Cargo_DeliverySequenceNumber: 'หมายเลขลำดับการส่งมอบ',
  Cargo_DispatchVehicleNoteFields: 'โปรดทราบในการปฏิบัติการส่งรถให้เสร็จสมบูรณ์ตามฟิลด์ต่อไปนี้:',
  Cargo_TTDEG: 'บริษัทขนส่ง, ค่าลากจูง, ชื่อจุดประตู, เวลาโหลดที่คาดการณ์, น้ำหนักสุทธิ',
  Cargo_RouteMarking: 'เครื่องหมายเส้นทาง',
  Cargo_SecondaryConfirmation: 'การยืนยันครั้งที่สอง',
  Cargo_BookingCompleted: 'จองห้องโดยสารเรียบร้อยแล้ว กรุณาตรวจสอบ:',
  Cargo_DataNotPendingConfirmation: 'มีข้อมูลที่ยังไม่ได้รับการยืนยันโปรดตรวจสอบ:',
  Cargo_PortMismatch: 'ท่าเรือต้นทาง ปลายทาง ไม่สอดคล้องกันทั้งหมด,มั่นใจว่าจะดำเนินการต่อไปหรือไม่',
  Cargo_DataNotConfirmed: 'มีข้อมูลที่ไม่ได้รับการยืนยันโปรดตรวจสอบ:',
  Cargo_RouteNotConfirmedOrDoubleConfirmed: 'มีข้อมูลที่ไม่ได้รับการยืนยันเส้นทางบินหรือได้รับการยืนยันรองโปรดตรวจสอบ:',
  Cargo_SelectOneMasterBill: 'เลือกตั๋วหลักได้สูงสุดหนึ่งใบ',
  Cargo_DataNotRouteDoubleConfirmed: 'มีข้อมูลการยืนยันรองนอกเส้นทางโปรดตรวจสอบ:',
  Cargo_GrossProfitAmount: 'ยอดกำไรขั้นต้น',
  Cargo_SpecialExpenseIndicator: 'ตัวบ่งชี้ค่าใช้จ่ายพิเศษ',
  Cargo_SpecialExpensePayableTotal: 'ยอดรวมค่าใช้จ่ายพิเศษที่ต้องชำระ',
  Cargo_SpecialExpensePayableCurrency: 'สกุลเงินสำหรับค่าใช้จ่ายพิเศษที่ต้องชำระ',
  Cargo_SpecialExpenseReceivableTotal: 'ยอดรวมค่าใช้จ่ายพิเศษที่ต้องรับ',
  Cargo_SpecialExpenseReceivableCurrency: 'สกุลเงินสำหรับค่าใช้จ่ายพิเศษที่ต้องรับ',
  Cargo_BookingCompletion: 'การจองห้องพักเสร็จสมบูรณ์',
  Cargo_RouteConfirmation: 'ยืนยันเส้นทางบิน',
  Cargo_RouteConfirmationStatus: 'ยืนยันสถานะเส้นทางบิน',
  Cargo_FlightDateRange: 'วันเดินทาง',
  Cargo_RouteConfirmationPerson: 'ยืนยันเส้นทางบิน',
  Cargo_RouteConfirmationTimeRange: 'เวลายืนยันเส้นทางบิน',
  Cargo_IsBookingCompleted: 'ไม่ว่าจะเป็นการจองห้องโดยสารเสร็จสมบูรณ์',
  Cargo_OrderNumber: 'หมายเลขการสั่งซื้อ',
  Cargo_FlightNumber: 'หมายเลขเที่ยวบิน',
  Cargo_SecondLegFlight: 'เที่ยวบินที่สอง',
  Cargo_SecondLegAirline: 'เที่ยวบินที่ 2',
  Cargo_SecondLegDocumentNumber: 'หมายเลขเดี่ยวสองทาง',
  Cargo_SecondLegETD: 'ETD สองทาง',
  Cargo_SecondLegETA: 'เส้นทางที่สอง ETA',
  Cargo_ThirdLegFlight: '3 เที่ยวบิน',
  Cargo_ThirdLegAirline: '3 สายการบิน',
  Cargo_ThirdLegDocumentNumber: 'สามทางหมายเลขเดียว',
  Cargo_ThirdLegETD: 'สามทาง ETD',
  Cargo_ThirdLegETA: 'สามทาง ETA',
  Cargo_FreightUnitPrice: 'ราคาต่อหน่วยการขนส่ง',
  Cargo_SignatureWeight: 'การนับน้ำหนักของใบลงนาม',
  Cargo_SignatureDimensions: 'ขนาดลายเซ็น',
  Cargo_SignatureRemarks: 'หมายเหตุการลงลายมือชื่อ',
  Cargo_FoldedWeightRemarks: 'หมายเหตุน้ำหนักพับ',
  Cargo_TotalPrice: 'ราคารวม',
  Cargo_TransshipmentFee: 'ค่าธรรมเนียมการโอน',
  Cargo_HumanResourcePerformance: 'ประสิทธิภาพของบุคลากร',
  Cargo_AIEngine: 'เครื่องยนต์ AI',
  Cargo_ProvisionReport: 'รายงานการตั้งสำรอง',
  Cargo_ScriptName: 'ชื่อสคริปต์',
  Cargo_ScriptDescription: 'คำอธิบายสคริปต์',
  Cargo_GenerateScript: 'สร้างสคริปต์',
  Cargo_RuleDescription: 'คำอธิบายกฎ',
  Cargo_ScriptPreview: 'ตัวอย่างสคริปต์',
  Cargo_CommissionRole: 'บทบาทในการให้ส่วนลด',
  Cargo_CommissionPersonnel: 'บุคลากรในการให้ส่วนลด',
  Cargo_ApplicableScript: 'สคริปต์ที่ใช้ได้',
  Cargo_RuleApplication: 'การใช้กฎ',
  Cargo_ApplicablePersonnel: 'บุคลากรที่ใช้ได้',
  Cargo_BusinessVolume: 'ปริมาณธุรกิจ',
  Cargo_ApplicableRule: 'กฎที่ใช้ได้',
  Cargo_CustomsProvision: 'การตั้งสำรองการศุลกากร',
  Cargo_OperationProvision: 'การตั้งสำรองการดำเนินการ',
  Cargo_CustomerServiceProvision: 'การตั้งสำรองการให้บริการลูกค้า',
  Cargo_BusinessProvision: 'การตั้งสำรองทางธุรกิจ',
  Cargo_SalesProvision: 'การตั้งสำรองการขาย',
  Cargo_OperationTicketProvision: 'การตั้งสำรองตั๋วการดำเนินการ',
  Cargo_SalesSupervisorProvision: 'การตั้งสำรองหัวหน้าฝ่ายขาย',
  Cargo_OperationSupervisorProvision: 'การตั้งสำรองหัวหน้าฝ่ายปฏิบัติการ',
  Cargo_ConfirmCancelProvision: 'ยืนยันการยกเลิกการตั้งสำรองหรือไม่',
  Cargo_LockLimit: 'จำกัดการล็อก',
  Cargo_ReceivableFullWriteOffTime: 'เวลาในการตัดบัญชีรับทั้งหมด',
  Cargo_LockAccountsReceivableAndPayableEntry: 'ล็อกการบันทึกบัญชีลูกหนี้และเจ้าหนี้',
  Cargo_ViewDetailedBusiness: 'ดูธุรกิจอย่างละเอียด',
  Cargo_TestRun: 'ทดสอบการดำเนินการ',
  Cargo_ProvisionLimit: 'จำกัดการตั้งสำรอง',
  Cargo_ViewProvisionDetails: 'ดูรายละเอียดการตั้งสำรอง',
  Cargo_ProvisionBatchNumber: 'หมายเลขกลุ่มการตั้งสำรอง',
  Cargo_ProvisionPerson: 'ผู้ตั้งสำรอง',
  Cargo_ProvisionTime: 'เวลาในการตั้งสำรอง',
  Cargo_ProvisionRole: 'บทบาทในการตั้งสำรอง',
  Cargo_PendingProvision: 'รอการตั้งสำรอง',
  Cargo_ProvisionHistory: 'ประวัติการตั้งสำรอง',
  Cargo_ResponsibleCustomerService: 'ฝ่ายบริการลูกค้าที่รับผิดชอบ',
  Cargo_ResponsibleOperator: 'การปฏิบัติงานที่รับผิดชอบ',
  Cargo_ConfirmAndBookingCompleted: 'ยืนยันและจองห้องพักเรียบร้อยแล้ว',
  Cargo_OrderQuantity: 'ปริมาณการสั่งซื้อ',
  Cargo_FinancialStatus: 'สถานะทางการเงิน',
  Cargo_FinancialColorTip: 'ช่วงการกำหนดการควบคุมสีของตาราง: \nจองเที่ยวบิน - รายการ\nการดำเนินการทางอากาศ - รายการ\nโลจิสติกส์แบบบูรณาการ - รายการ\nการดำเนินการรถไฟ - รายการ\nจองระยะไกล - รายการ\nการสอบถามยอดขาย - รายการ\nการส่งออกทางทะเล - รายการ\nการดำเนินการทางทะเล - รายการ\nการนำเข้าทางทะเล - การพยากรณ์ - รายการ\nการสอบถามยอดขาย - แผนกต่างประเทศ - รายการ\nการสอบถามยอดขาย - แผนกขาย - รายการ\nการส่งออกทางทะเล - ใบขนสินค้าทางทะเล - รายการ\nการส่งออกทางทะเล - EDI - รายการ\nการตรวจสอบทางการเงิน - รายการ\nการตรวจสอบทางการเงิน - การปิดงบ - รายการ\nการส่งออกทางอากาศ - ใบแสดงการขึ้นทะเบียนศุลกากร - รายการ\nการส่งออกทางอากาศ - คลังสินค้าก่อนการส่งออก - รายการ\nส่งออกทางอากาศ - คลังสินค้า - รายการ\nการนำเข้าทางทะเล - การดำเนินการในคลังสินค้า - รายการ',
  Cargo_CurrentInvoiceDifferentRates: 'การออกใบกำกับภาษีปัจจุบันมีค่าใช้จ่ายที่มีอัตราภาษีต่างกัน จะแยกใบกำกับภาษีตามอัตราภาษีและออกใบกำกับภาษีแยกกัน จะใช้รหัสภาษีเริ่มต้นในการบำรุงรักษา ต้องการดำเนินการครั้งนี้ต่อหรือไม่?',
  Cargo_CurrentSelectionContains9TaxPointsAndOthers: 'การเลือกปัจจุบันประกอบด้วยจุดภาษี 9 จุดและจุดภาษีอื่นๆ เนื่องจากใบกำกับภาษีการขนส่งสินค้ามีความพิเศษโปรดขออนุญาตแยกต่างหากไม่สามารถยื่นใบกำกับภาษีพร้อมกันได้',
  Cargo_NumberOfOriginalCopies: 'จำนวนเนื้อหาหลัก',
  Cargo_DisplayDllInformation: 'แสดงข้อมูลทั้งหมด',
  Cargo_DisplayDifferenceInformation: 'แสดงข้อมูลความแตกต่าง',
  Cargo_OverrideSystemBillOfLading: 'ระบบครอบคลุม B / L',
  Cargo_ContainerIdTip: 'ข้อมูลการบรรจุ (เพิ่มลงใน B / L หรือครอบคลุมข้อมูล B / L เมื่อเลือก)',
  Cargo_ContainerInfo2: 'ข้อมูลตู้คอนเทนเนอร์ (หากเลือก จะถูกเพิ่มในใบขนสินค้าทางทะเล หรือเขียนทับข้อมูลในใบขนสินค้าทางทะเล)',
  Cargo_ContainerTypeQuantityMismatch: 'ประเภท/จำนวนตู้คอนเทนเนอร์ไม่ตรงกับข้อมูลตู้คอนเทนเนอร์ที่เลือก โปรดยืนยัน',
  Cargo_SystemData: 'ข้อมูลระบบ',
  Cargo_RecognitionData: 'ระบุข้อมูล',
  Cargo_GrossProfit: 'กำไรขั้นต้น',
  Cargo_MustEnterComplete: 'ต้องป้อนข้อมูลเต็ม',
  Cargo_CostVirtualImplementationToConsolidationPlan: 'ค่าธรรมเนียมการดำเนินการเสมือนจริงในแผนการประกอบ',
  Cargo_ReceivablesWriteoffDate: 'วันที่ชำระหนี้',
  Cargo_PayablesWriteoffDate: 'วันที่ชำระหนี้',
  Cargo_FeeInvoiceTitle: 'เพิ่มใบแจ้งหนี้ค่าธรรมเนียม',
  Cargo_PaymentApplicationTitle: 'สมัครชำระเงิน',
  Cargo_NotData: 'ไม่พบข้อมูล',
  Cargo_LclHasMaster: 'Small Ticket ได้ทำการเชื่อมต่อกับ Master Ticket เรียบร้อยแล้ว',
  Cargo_ParamError: 'พารามิเตอร์ผิดพลาดโปรดตรวจสอบ',
  Cargo_BillResults: 'ช่องระบุ B / L',
  Cargo_BillResults2: 'ระบบ ข้อมูล B / L',
  Cargo_NotUpdate: 'ไม่สามารถเปลี่ยนแปลงได้',
  Cargo_UpdateCheck1: 'โปรดทราบว่าปริมาณกล่องประเภทกล่องไม่สอดคล้องกับข้อมูลการบรรจุที่ติ๊ก',
  Cargo_seaFile2: 'บัตรประจำตัวผู้ออกหนังสือทะเล',
  Cargo_siFile2: 'บัตรประจำตัวของใบตราส่งนำเข้าทางทะเล',
  Cargo_seBillFile2: 'บัตรประจำตัว BL สำหรับการส่งออกทางทะเล',
  Cargo_aeFile2: 'บัตรประจำตัวส่งออกทางอากาศ',
  Cargo_aiFile2: 'บัตรประจำตัวของใบตราส่งนำเข้าทางอากาศ',
  Cargo_OnlyServiceDataLocked: 'ล็อกข้อมูลธุรกิจเท่านั้นและสามารถแก้ไขป้ายหน้าค่าธรรมเนียมได้',
  Cargo_AutomaticallyLocksServiceData: 'ล็อคเอกสารธุรกิจอัตโนมัติ',
  Cargo_AutomaticallySubmitServiceData: 'ส่งเอกสารธุรกิจอัตโนมัติ',
  Cargo_SystemAutomaticExecution: 'ระบบจะดำเนินการโดยอัตโนมัติ',
  Cargo_ServicesNotSubmittedAutomaticallySubmitted: 'ธุรกิจที่ไม่ได้ยื่นจะดำเนินการยื่นโดยอัตโนมัติ (สถานะธุรกิจ: การดำเนินการในเชิงบวก -> ยื่นแล้ว)',
  Cargo_IdentifyTheSupplier: 'ระบุผู้ขาย',
  Cargo_PleaseSet: 'กรุณาตั้งค่า',
  Cargo_OnlyOneSupplier: 'ประเภทหนึ่งสามารถตั้งผู้จำหน่ายได้เพียงรายเดียว',
  Cargo_IdentificationCannotBePerformedTip: 'ไม่มีการตั้งค่าประเภทการระบุตัวตนไม่สามารถระบุได้และมีความต้องการที่จะติดต่อฝ่ายบริการลูกค้า',
  Cargo_TemplateSettings: 'การตั้งค่าลายฉลุ',
  Cargo_IdentificationTip1: 'โปรดตั้งค่าซัพพลายเออร์ที่สอดคล้องกับประเภทการระบุ',
  Cargo_ServiceProductID: 'รหัสผลิตภัณฑ์บริการ',
  Cargo_ServiceProductName: 'บริการ ชื่อผลิตภัณฑ์',
  Cargo_ForceRoutingBooking: 'บังคับให้จองเที่ยวบิน',
  Cargo_UsedAsRoutingProduct: 'ไม่ว่าจะเป็นการใช้เป็นผลิตภัณฑ์เส้นทางบิน',
  Cargo_AirServiceProduct: 'ผลิตภัณฑ์บริการขนส่งทางอากาศ',
  Cargo_BusinessManager: 'หัวหน้าธุรกิจ',
  Cargo_AirlinePersonSetting: 'ตั้งค่าหัวหน้าเส้นทาง',
  Cargo_PrePortFreightRateOfficer: 'หัวหน้าการขนส่งสินค้า ที่ท่าเรือ',
  Cargo_PersonChargeTrunkLineFreightRates: 'หัวหน้าการขนส่งสายโทรศัพท์',
  Cargo_PersonChargeLastMileFreightRates: 'หัวหน้าการขนส่งสินค้าท้าย',
  Cargo_NamePersonResponsible: 'ชื่อผู้รับผิดชอบ',
  Cargo_ResponsiblePortDeparture: 'ดูแลท่าเรือขนส่ง',
  Cargo_OnlyOneFullPerson: 'ท่าเรือว่า งเปล่ามีเพียงหนึ่งเดียวเท่านั้น',
  Cargo_OnlyOneFullPersonSameType: 'มีเพียงคนเดียวเท่านั้น ที่รับผิดชอบในการรวมกลุ่ม',
  Cargo_AdministrativeDivision: 'ขีดเส้นใต้',
  Cargo_StreetTownship: 'ถนนบ้านเมือง',
  Cargo_PostalCodeManagement: 'การจัดการจดหมาย',
  Cargo_UsPostalCode: 'จดหมายอเมริกัน',
  Cargo_preportAudit: 'ก่อนถึงท่าเรือ',
  Cargo_TrunkLineAudit: 'ตรวจสอบสายหลัก',
  Cargo_TailEndAudit: 'ตรวจสอบ Comment',
  Cargo_preportAuditStatus: 'ก่อน ที่จะตรวจสอบท่าเรือ',
  Cargo_TrunkLineAuditStatus: 'ตรวจสอบสถานะสายหลัก',
  Cargo_TailEndAuditStatus: 'ตรวจสอบระยะสุดท้าย',
  Cargo_NoReviewRequired: 'ไม่มีการตรวจสอบ',
  Cargo_HasBeenReviewed: 'ตรวจสอบแล้ว',
  Cargo_NoAuthorityReview: 'ไม่มีสิทธิ์ในการตรวจสอบ',
  Cargo_AddBasicAirFreightServiceProduct: 'เพิ่มผลิตภัณฑ์บริการขนส่งทางอากาศขั้นพื้นฐาน',
  Cargo_DeleteServiceProductWarning: 'คุณจะลบ 【{0}】 ข้อมูลผลิตภัณฑ์บริการโปรดดำเนินการด้วยความระมัดระวัง',
  Cargo_RouteProductName: 'ชื่อสินค้า เส้นทางบิน',
  Cargo_ServiceProduct: 'ผลิตภัณฑ์บริการ',
  Cargo_PurchaseMethod: 'วิธีการซื้อ',
  Cargo_Airline2: 'สายการบิน',
  Cargo_PurchaseSource: 'แหล่งจัดซื้อ',
  Cargo_OriginPort: 'ท่าเรือต้นทาง',
  Cargo_RouteOfficer: 'พนักงานเส้นทาง',
  Cargo_IsEffective: 'จะมีผลบังคับใช้หรือไม่',
  Cargo_BaseWeight: 'น้ำหนักพื้นฐาน',
  Cargo_LimitWeight: 'จำกัด น้ำหนัก',
  Cargo_SellableSpace: 'พื้นที่ขาย',
  Cargo_LengthLimit: 'จำกัด ความยาว',
  Cargo_HeightLimit: 'ขีด จำกัด ความสูง',
  Cargo_TheoreticalVolume: 'ปริมาณตามทฤษฎี',
  Cargo_SellableVolume: 'ปริมาณการขาย',
  Cargo_Box: 'กล่องบอร์ด',
  Cargo_PayingParty: 'วัตถุที่ต้องชำระเงิน',
  Cargo_UnitPrice_TotalPrice: 'ราคาต่อหน่วย / ราคารวม',
  Cargo_RouteProductCode: 'รหัสสินค้า',
  Cargo_BoardCount: 'จำนวนบอร์ด',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: 'วันที่มีผลบังคับต้องน้อยกว่าเท่ากับวันหมดอายุ',
  Cargo_AirlineProductCode: 'ผลิตภัณฑ์เส้นทาง',
  Cargo_NotInWarehouse: 'สินค้ายังไม่เข้าคลัง ออกคำสั่งเบิกสินค้าล่วงหน้า? กด "ยืนยัน" เพื่อดำเนินการ',
  Cargo_NotInWarehouse2: 'สินค้ายังไม่เข้าคลัง ยกเลิกคำสั่งเบิกสินค้าล่วงหน้า? กด "ยืนยัน" เพื่อยกเลิก',
  Cargo_OutboundInstructionIssued: 'ได้ออกคำสั่งเบิกสินค้าแล้ว',
  Cargo_AlreadyOutbound: 'สินค้าได้ออกจากคลังแล้ว ไม่สามารถยกเลิกคำสั่งได้',
  Cargo_EstimatedAmazonArrivalTime: 'เวลาที่คาดว่าจะถึงคลัง Amazon',
  Cargo_SelectCommonShipper: 'เลือกผู้ส่งสินค้าที่ใช้บ่อย',
  Cargo_SaveAsCommonShipper: 'บันทึกเป็นผู้ส่งสินค้าที่ใช้บ่อย',
  Cargo_SelectCommonConsignee: 'เลือกผู้รับสินค้าที่ใช้บ่อย',
  Cargo_SaveAsCommonConsignee: 'บันทึกเป็นผู้รับสินค้าที่ใช้บ่อย',
  Cargo_SelectCommonNotifier: 'เลือกผู้แจ้งเตือนที่ใช้บ่อย',
  Cargo_SaveAsCommonNotifier: 'บันทึกเป็นผู้แจ้งเตือนที่ใช้บ่อย',
  Cargo_BoxQuantity: 'จำนวนกล่อง',
  Cargo_OutboundMode: 'โหมดการนำออก',
  Cargo_PalletQuantity: 'จำนวนพาเลท',
  Cargo_InventoryAge: 'อายุสินค้าคงคลัง (วัน/สัปดาห์)',
  Cargo_OutboundOperator: 'ผู้ปฏิบัติงานนำออก',
  Cargo_RemainingBoxes: 'จำนวนกล่องที่เหลือในคลัง',
  Cargo_Goods: 'สินค้า',
  Cargo_InventoryInfo: 'ข้อมูลสินค้าคงคลัง',
  Cargo_OutboundByPallet: 'นำออกเป็นพาเลท',
  Cargo_OutboundByBox: 'นำออกเป็นกล่อง',
  Cargo_Outbound: 'นำออกแล้ว',
  Cargo_NotOutbound: 'ยังไม่นำออก',
  Cargo_OutboundBatch: 'ล็อตการนำออก',
  Cargo_BoxesInStock: 'จำนวนกล่องในคลัง',
  Cargo_PalletsInStock: 'จำนวนพาเลทในคลัง',
  Cargo_PromptWord: '##แนบไฟล์สรุป：\n' +
    'นี่คือใบแจ้งหนี้การบริโภค กรุณาพิจารณารูปแบบสกุลเงินตามภาษาของใบแจ้งหนี้ โปรดระบุข้อมูลในฟิลด์ต่อไปนี้: ผู้ให้บริการ (ผู้รับผิดชอบ), จำนวนเงินที่ใช้จ่าย, ภาษีการบริโภค (จำนวนภาษี), อัตราภาษี, และสกุลเงิน。\n' +
    '##ข้อกำหนดการส่งออก：\n' +
    '1、ส่งกลับในรูปแบบ JSON โดยชื่อฟิลด์ใน JSON ทั้งหมดจะต้องเป็นภาษาจีน。\n' +
    '2、ตัวอย่างรูปแบบ json：\n' +
    '      { \n' +
    '        "data": {\n' +
    '          "ผู้รับสินค้า": "",\n' +
    '          ……\n' +
    '        }\n' +
    '      }\n' +
    '##คำจำกัดความและกฎของแต่ละฟิลด์มีดังนี้：\n' +
    '#1、ผู้ให้บริการ (ผู้รับผิดชอบ）\n' +
    '#2、จำนวนเงินที่ใช้จ่าย\n' +
    '#3、ภาษีการบริโภค (จำนวนภาษี)\n' +
    '#4、อัตราภาษี\n' +
    '#5、สกุลเงิน',
  CargoMsg_AIAddressRecognition: 'การรู้จำที่อยู่ด้วย AI',
  Cargo_ContainerGroupHasOrder: 'มีคำสั่งซื้อในกลุ่มคอนเทนเนอร์ห้ามลบโปรดย้ายคำสั่งซื้อออกและลบออก',
  Cargo_HSCode: 'รหัส HS',
  Cargo_ShippingExchangeRateBatchConfig: 'การกำหนดค่าชุดราคาขนส่งทางทะเล',
  Cargo_DeclarationScope: 'ขอบเขตการประกาศ',
  Cargo_DeclarationBusiness: 'ธุรกิจที่ต้องประกาศ',
  Cargo_DeclarationFee: 'ค่าธรรมเนียมการประกาศ',
  Cargo_SetBranch: 'ตั้งค่าสาขา',
  Cargo_FollowHQ: 'ตาม HQ',
  Cargo_FreightRate: 'อัตราค่าขนส่ง',
  Cargo_ContainerLock: 'ค่าล็อคตู้คอนเทนเนอร์',
  Cargo_OtherAdditionalCharges: 'ค่าบริการเพิ่มเติมอื่นๆ',
  Cargo_UpperLimit: 'ขีดจำกัดบน',
  Cargo_LowerLimit: 'ขีดจำกัดล่าง',
  Cargo_AlertNotification: 'การแจ้งเตือน',
  Cargo_RPASettings: 'การตั้งค่า RPA',
  Cargo_UnregisteredShippingRate: 'เมื่ออัตราค่าขนส่งธุรกิจที่สร้างขึ้นไม่ได้ประกาศในตลาดการขนส่งทางทะเล',
  Cargo_ExceedMaintainedLimit: 'เมื่ออัตราค่าขนส่งธุรกิจที่สร้างขึ้นเกินขีดจำกัดที่กำหนดไว้',
  Cargo_RPAPaused: 'เมื่อ RPA ถูกหยุดชั่วคราว',
  Cargo_RPACompleted: 'เมื่อ RPA เสร็จสิ้น',
  Cargo_ProhibitSaving: 'ห้ามบันทึก',
  Cargo_RecordOnly: 'บันทึกเท่านั้นไม่แจ้งเตือน',
  Cargo_NoRecordNoAlert: 'ไม่บันทึกไม่แจ้งเตือน',
  Cargo_NotifyRoleByEmail: 'แจ้งเตือนทางอีเมลถึงบทบาทที่กำหนด',
  Cargo_NotifyPersonByEmail: 'แจ้งเตือนทางอีเมลถึงบุคคลที่กำหนด',
  Cargo_NotifyPositionByEmail: 'แจ้งเตือนทางอีเมลถึงตำแหน่งที่กำหนด',
  Cargo_RPAService: 'บริการ RPA',
  Cargo_EnableRPAService: 'เปิดใช้งานบริการ RPA',
  Cargo_ShippingExchangeAccount: 'บัญชีตลาดการขนส่งทางทะเล',
  Cargo_ShippingExchangePassword: 'รหัสผ่านตลาดการขนส่งทางทะเล',
  Cargo_RPASubmission: 'ให้ระบบอัตโนมัติส่งข้อมูลบน{0}',
  Cargo_WarningReason: 'เหตุผลการเตือน',
  Cargo_WarningMessage: 'ข้อความเตือน',
  Cargo_UnregisteredRateSaveError: 'บริษัทของเราได้เปิดใช้งานฟังก์ชันประกาศอัตราค่าขนส่งในตลาดการขนส่งทางทะเล อัตราค่าขนส่งธุรกิจปัจจุบันไม่ได้ประกาศในตลาดการขนส่งทางทะเล จึงไม่สามารถบันทึกได้ หากต้องการป้อนธุรกิจ โปรดติดต่อผู้รับผิดชอบการยื่น <br/>{0}',
  Cargo_UnregisteredRateWarning: 'บริษัทของเราได้เปิดใช้งานฟังก์ชันประกาศอัตราค่าขนส่งในตลาดการขนส่งทางทะเล อัตราค่าขนส่งธุรกิจปัจจุบันไม่ได้ประกาศในตลาดการขนส่งทางทะเล เพื่อหลีกเลี่ยงการดำเนินการที่ผิดกฎหมาย โปรดติดต่อผู้รับผิดชอบการvโดยเร็ว: <br/>{0}',
  Cargo_ExceedDeclaredLimitSaveError: 'บริษัทของเราได้เปิดใช้งานฟังก์ชันประกาศอัตราค่าขนส่งในตลาดการขนส่งทางทะเล อัตราค่าขนส่งธุรกิจปัจจุบันเกินขีดจำกัดที่ประกาศไว้ จึงไม่สามารถบันทึกได้ หากต้องการป้อนธุรกิจ โปรดติดต่อผู้รับผิดชอบการยื่น: <br/>{0}',
  Cargo_ExceedDeclaredLimitWarning: 'บริษัทของเราได้เปิดใช้งานฟังก์ชันประกาศอัตราค่าขนส่งในตลาดการขนส่งทางทะเล อัตราค่าขนส่งธุรกิจปัจจุบันเกินขีดจำกัดที่ประกาศไว้ เพื่อหลีกเลี่ยงการดำเนินการที่ผิดกฎหมาย โปรดติดต่อผู้รับผิดชอบการยื่นโดยเร็ว: <br/>{0}',
  Cargo_GoToProcess: 'ไปประมวลผล',
  Cargo_GoToDeclare: 'ไปประกาศ',
  Cargo_CheckWarningToProcess: 'โปรดเลือกระบุสารเตือนที่ต้องประมวลผล',
  Cargo_SelectedWarningMarkedProcessed: 'สารเตือนที่เลือกถูกทำเครื่องหมายว่า"ประมวลผลแล้ว"',
  Cargo_SelectInfoToDeclare: 'โปรดเลือกข้อมูลที่ต้องประกาศ',
  Cargo_SureSaveUnControlledProduct: 'ยืนยันจะบันทึกหรือไม่ ธุรกิจจะถูกล็อคหลังจากบันทึกไม่สามารถดำเนินการได้อีกต่อไปและไม่สามารถถอนได้! เมื่อส่งออกสินค้าควบคุมต้องได้รับอนุญาตก่อน สอบถามรายละเอียดได้ที่ห้องผลักดัน SCM',
  Cargo_SureAndSubmit: 'ยืนยันและยื่นอัตโนมัติ',
  Cargo_FilingBatchNo: 'การยื่นล็อต',
  Cargo_FilingState: 'สถานะล็อต',
  Cargo_SubmitDate: 'วันที่ส่ง',
  Cargo_DeclareFinal: 'จำนวนแถวประกาศ / จำนวนแถวสุดท้าย',
  Cargo_FiletotalRecordPass: 'บันทึกไฟล์ / เข้าห้องสมุด / ตรวจสอบผ่าน',
  Cargo_StartRPA: 'เริ่ม RPA',
  Cargo_SuspendRPA: 'หยุดชั่วคราว RPA',
  Cargo_SuspendRPA2: 'หยุดชั่วคราว',
  Cargo_RpaState: 'สถานะ RPA',
  Cargo_ImportFinalResult: 'นำเข้าผลลัพธ์สุดท้าย',
  Cargo_ManuallyExportFile: 'ส่งออกไฟล์ด้วยตนเอง',
  Cargo_FilingBatchInfo: 'ข้อมูลชุด',
  Cargo_FilingDate: 'วันที่ยื่น',
  Cargo_OpenPriceInfo: 'ประกาศราคาค่าขนส่ง',
  Cargo_Past6MonthPort: 'รับท่าเรือ ทำธุรกิจมาเกือบ 6 เดือน',
  Cargo_Past1MonthPrice: 'รับราคาค่าขนส่งที่เรือจะออกมาเกือบ 1 เดือน',
  Cargo_CompanyCode2: 'รหัสบริษัท',
  Cargo_Lane: 'ชื่อเส้นทาง',
  Cargo_DepartureDay: 'ชั้นเรียนรายสัปดาห์',
  Cargo_CargoType2: 'ประเภทของสินค้า',
  Cargo_EqSize: 'ขนาด',
  Cargo_Cost2: 'อัตราค่าจัดส่ง',
  Cargo_CostRange: 'ช่วงราคาค่าขนส่ง',
  Cargo_CostMin: 'ขีด จำกัด ล่างของราคาจัดส่ง',
  Cargo_CostMax: 'เพดานค่าจัดส่ง',
  Cargo_EqDeduct: 'หัวเข็มขัดกล่อง',
  Cargo_BatchReturnPreApproval: 'ส่งคืนการตรวจสอบล่วงหน้า/การจองระยะไกลเป็นชุด',
  Cargo_ReturnPreApprovalRemoteBooking: 'ส่งคืนการตรวจสอบล่วงหน้า/การจองระยะไกล',
  Cargo_ConfirmReturnResubmit: 'ยืนยันการส่งคืนการตรวจสอบล่วงหน้า/การจองระยะไกลเพื่อส่งใหม่?',
  Cargo_ReturnModuleSelection: 'เลือกโมดูลการส่งคืน',
  Cargo_ReturnModule: 'โมดูลการส่งคืน',
  Cargo_ReturnReason: 'เหตุผลในการส่งคืน',
  Cargo_MasterTicketRelationError: 'มีความสัมพันธ์ตั๋วหลักไม่允許ส่งคืน',
  Cargo_CostStatusReturnError: 'ค่าใช้จ่าย已{0}，不允許ส่งคืน',
  Cargo_RouteManagerEmptyError: 'เลขที่ธุรกิจ：{0} ผู้รับผิดชอบเส้นทางว่าง不允許ส่งคืน',
  Cargo_FOBReturnRestriction: 'ธุรกิจ FOB สามารถส่งคืนได้เฉพาะการจองระยะไกล',
  Cargo_SelectedBusiness: 'ธุรกิจที่เลือก',
  Cargo_RemoteBooking: 'การจองระยะไกล',
  Cargo_RemoteBookingExportOnly: 'การจองระยะไกลรองรับการส่งคืนเฉพาะธุรกิจส่งออก',
  Cargo_ReturnResult: 'ส่งคืนสำเร็จ {0} รายการ, ล้มเหลว {1} รายการ',
  Cargo_MasterTicketRelationAlert: '【{0}】มีความสัมพันธ์ตั๋วหลัก',
  Cargo_NotFromRemoteBookingError: '[{0}]ออเดอร์ไม่ได้มาจากการจองระยะไกล，ไม่允許ส่งคืน',
  Cargo_NotFromPreApprovalError: '[{0}]ออเดอร์ไม่ได้มาจากการตรวจสอบล่วงหน้า，ไม่允許ส่งคืน',
  Cargo_CostStatusAlert: '【{0}】ค่าใช้จ่าย已{1}',
  Cargo_ReturnCurrentOperationOnly: 'รองรับการส่งคืนเฉพาะธุรกิจที่กำลังดำเนินการ',
  Cargo_MixedBusinessTypeError: 'ธุรกิจที่เลือกมีทั้งประเภท FOB และไม่ใช่ FOB ไม่สามารถส่งคืนพร้อมกันได้',
  Cargo_CollabBatchRejectError: 'ประกอบด้วย {0} ซึ่งเป็นธุรกิจแบบร่วมมือ ไม่รองรับการปฏิเสธเป็นชุด',
  Cargo_OtherSurcharge: 'ค่าธรรมเนียมเพิ่มเติมอื่นๆ',
  Cargo_MoreDetails: 'รายละเอียดเพิ่มเติม',
  Cargo_SureToStartRPA: '[{0}] ระบบจะส่งข้อมูลไปยังเว็บไซต์ของตลาดหลักทรัพย์โดยอัตโนมัติหลังจากที่ RPA เริ่มใช้งาน โปรดตรวจสอบให้แน่ใจว่าได้กรอกข้อมูลให้ครบถ้วนก่อนเริ่มใช้งาน',
  Cargo_SureToSuspendRPA: '[{0}] หลังจากที่ RPA ถูกระงับชั่วคราวเช่นเริ่มต้นอีกครั้งระบบจะส่งสถานะข้อมูลในตลาดหลักทรัพย์เช่นการโหลดที่ไม่ได้รับการยืนยันระบบจะสร้างระยะเวลาการจัดเรียงและอัปโหลดใหม่หากไม่มีปัญหาร้ายแรงโปรดพยายามอย่าหยุดชั่วคราว RPA',
  Cargo_SureToDeleteOpenPrice: 'กรุณายืนยันว่าจะลบข้อมูลจาก [{0}] หรือไม่?',
  Cargo_SureToImportFinalResult: 'การนำเข้าผลลัพธ์สุดท้ายด้วยตนเองหมายความว่าคุณยืนยันว่าชุดนั้นเสร็จสมบูรณ์และ RPA จะไม่ดำเนินการอีกต่อไป',
  Cargo_SureToExportFile: 'กรุณายืนยันว่าจะส่งออกข้อมูลสำหรับชุด [{0}] หรือไม่?',
  FileBeLargerThan10MB: 'ขนาดไฟล์ต้องไม่เกิน 10MB',
  FileBeLargerThan5MB: 'ขนาดไฟล์ต้องไม่เกิน 5MB',
  Cargo_DeclareFile: 'เอกสารประกาศ',
  Cargo_ImportFinalFile: 'ผลการนำเข้าขั้นสุดท้าย',
  Cargo_FinalPriceInfo: 'ราคาส่งสุดท้าย',
  Cargo_DeclareNumLabel: 'ค่าจัดส่งทั้งหมด: {0} บาร์',
  Cargo_DeclareFinalLabel: 'จำนวนแถวประกาศ / จำนวนแถวสุดท้าย: {0}',
  Cargo_QuerySuccess: 'ได้รับข้อมูลความสำเร็จ',
  ChargeHasUpdate: 'ค่าใช้จ่ายถูกเปลี่ยนแปลงโดย {0} ใน {1} กรุณาตรวจสอบข้อมูลใหม่อีกครั้งก่อนดำเนินการ!',
  HasDeletedForDeleteJob: 'ธุรกิจที่ถูกเลือกได้รับการลบแล้ว！',
  HasSlaveJobForDeleteJob: '[{0}]กรุณาเอาใบเสร็จออกก่อน！',
  HasChargeForDeleteJob: '[{0}]ได้บันทึกค่าใช้จ่ายแล้ว！',
  HasMergeForDeleteJob: '[{0}]ได้รวมออร์เดอร์แล้ว！',
  Cargo_ArCustomerPaidOff: 'สถานะการชำระค่าธรรมเนียมหน่วยลงทุน',
  Cargo_ContainsAdvancePayment: 'มีค่าใช้จ่ายล่วงหน้าหรือไม่',
  Cargo_JdySendStatus: 'สถานะการส่ง JianDaoYun',
  Cargo_JdySendTime: 'เวลาส่ง JianDaoYun',
  Cargo_DetailsLockedStatus: 'สถานะล็อกรายละเอียดสินค้า',
  Cargo_InterestAmountCurrency: 'ดอกเบี้ยเกินกำหนด',
  Cargo_CheckRuleResult: 'ผลการตรวจสอบ',
  DataHasModified: 'ข้อมูลถูกแก้ไขโดย [{0}] เมื่อ {1} กรุณารีเฟรช!',
  Cargo_CheckNeedSynccloud: 'กรุณาเลือกบิลของแพลตฟอร์มคลาวด์ที่ต้องการซิงค์',
  Cargo_CheckJingdiesynccloud: 'มีเพียงบิลต่างประเทศ และ บิลที่เก็บเงินหรือจ่ายเงินแทนผู้อื่นเท่านั้น ที่สามารถส่งไปยัง Kingdee ได้',
  DisplayReceiptsOnly: 'แสดงใบเสร็จเท่านั้น',
  AssignedWorkResponsibleForNode: 'ตำแหน่งที่กำหนด (ตามผู้รับผิดชอบงานที่จุดตั้งตำแหน่ง)',
  Cargo_CheckZySave: 'โปรดตรวจสอบว่าสินค้าในคำสั่งซื้อนั้นเกี่ยวข้องกับกฎหมายควบคุมการส่งออกของสาธารณรัฐประชาชนจีนระเบียบควบคุมการส่งออกของสาธารณรัฐประชาชนจีนสำหรับรายการสำหรับการใช้งานสองทางและรายการควบคุมการส่งออกของสาธารณรัฐประชาชนจีนสำหรับรายการสำหรับการใช้งานสองทาง ในกรณีที่ลูกค้าต้องการให้ใบอนุญาตส่งออกสินค้าแบบ dual-use เป็นวัสดุประกอบในการประกาศศุลกากร สินค้าภายในใบสั่งซื้อสามารถเรียกดูได้จากชื่อสินค้าและ HSCODE ฐานข้อมูลเรียกดูได้จากหน้าเว็บต่อไปนี้:',
  Cargo_HasVerified: 'ตรวจสอบแล้ว',
  Cargo_ContainSensitiveWord: 'ไม่ว่าจะมีคำอ่อนไหว',
  Cargo_BusinessSingleMode: 'โหมดธุรกรรมเดี่ยวทางธุรกิจ',
  Cargo_BusinessBatchMode: 'โหมดการประมวลผลแบบกลุ่มทางธุรกิจ',
  Cargo_JobsSavedSuccessfully: 'บันทึก {0} งานสำเร็จ',
  Cargo_JobsFailedToSave: 'บันทึก {0} งานล้มเหลว',
  Cargo_BatchSaveFailed: 'การบันทึกแบบกลุ่มล้มเหลว',
  Cargo_PleaseAddGoods: '',
  confirmLock: '',
  confirmUnLock: '',
  Cargo_PleaseselectedGoods: '',
  Cargo_PleaseAddCheck: '',
  PriorityDisplay: 'การแสดงลำดับความสำคัญ',
  WhenTheNodeAllDisplayed: 'เมื่อไม่ได้ตั้งค่าความสำคัญสำหรับโหนด จะแสดงข้อมูลโหนดทั้งหมด!',
  DefaultDisplay: 'การแสดงค่าเริ่มต้น:',
  PrioritizationSettings: 'การตั้งค่าความสำคัญ',
  Cargo_OperationProvince: 'จังหวัดที่บริษัทดำเนินการ',
  Cargo_SalesProvince: 'จังหวัดที่บริษัทขายตั้งอยู่',
  Cargo_PushTime: 'เวลาผลักดัน',
  CargoMsg_CheckSecondCustomJobType: 'เมื่อประเภทธุรกิจที่กำหนดเองเป็นระดับที่สอง ประเภทธุรกิจที่กำหนดเองระดับสูงต้องไม่ว่างเปล่า!',
  Cargo_EnterpriseWechatApprovalPayCompany: 'บริษัทผู้ชำระเงิน (WeCom)',
  // ส่วนหัวตารางตำแหน่งที่กำหนดเองของรายการจองส่งออกทางทะเล (ตั้งชื่อตามบทบาททางธุรกิจ)
  Cargo_UserDefinedRoleHeader1: 'เจ้าหน้าที่จองเที่ยวเรือเส้นทางรอง',
  Cargo_UserDefinedRoleHeader2: 'เจ้าหน้าที่จองเที่ยวเรือเส้นทางหลัก',
  Cargo_UserDefinedRoleHeader3: 'เจ้าหน้าที่ประกันภัย',
  Cargo_UserDefinedRoleHeader4: 'เจ้าหน้าที่ติดตามงานต่างประเทศ',
  Cargo_UserDefinedRoleHeader5: 'ผู้ช่วยฝ่ายบริการลูกค้า'
}
